(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $4a3647cc29c100ad$exports = {};
$4a3647cc29c100ad$exports = ".mdc-banner__text{color:var(--mdc-theme-on-surface,#000)}.mdc-banner__graphic{color:var(--mdc-theme-surface,#fff);background-color:#6200ee;background-color:var(--mdc-theme-primary,#6200ee);border-radius:50%}.mdc-banner__content,.mdc-banner__fixed{min-width:344px}@media (width<=480px),(width<=344px){.mdc-banner__content,.mdc-banner__fixed{min-width:100%}}.mdc-banner__content{max-width:720px}.mdc-banner{background-color:#fff;background-color:var(--mdc-theme-surface,#fff);z-index:1;box-sizing:border-box;border-bottom:1px solid #0000001f;flex-shrink:0;width:100%;height:0;display:none;position:relative}.mdc-banner .mdc-banner__fixed{background-color:#fff;background-color:var(--mdc-theme-surface,#fff);border-bottom-color:#0000001f}@media (width<=480px){.mdc-banner .mdc-banner__fixed{left:0;right:0}.mdc-banner .mdc-banner__text{margin-left:16px;margin-right:36px}[dir=rtl] .mdc-banner .mdc-banner__text,.mdc-banner .mdc-banner__text[dir=rtl]{margin-left:36px;margin-right:16px}.mdc-banner.mdc-banner--mobile-stacked .mdc-banner__content{flex-wrap:wrap}.mdc-banner.mdc-banner--mobile-stacked .mdc-banner__graphic{margin-bottom:12px}.mdc-banner.mdc-banner--mobile-stacked .mdc-banner__text{margin-left:16px;margin-right:8px;padding-bottom:4px}[dir=rtl] .mdc-banner.mdc-banner--mobile-stacked .mdc-banner__text,.mdc-banner.mdc-banner--mobile-stacked .mdc-banner__text[dir=rtl]{margin-left:8px;margin-right:16px}.mdc-banner.mdc-banner--mobile-stacked .mdc-banner__actions{margin-left:auto}}.mdc-banner--opening,.mdc-banner--open,.mdc-banner--closing{display:flex}.mdc-banner--open{transition:height .3s}.mdc-banner--open .mdc-banner__content{transition:transform .3s;transform:translateY(0)}.mdc-banner--closing{transition:height .25s}.mdc-banner--closing .mdc-banner__content{transition:transform .25s}.mdc-banner--centered .mdc-banner__content{margin-left:auto;margin-right:auto;left:0;right:0}.mdc-banner__fixed{box-sizing:border-box;height:inherit;border-bottom-style:solid;border-bottom-width:1px;width:100%;position:fixed}.mdc-banner__content{width:100%;min-height:52px;display:flex;position:absolute;transform:translateY(-100%)}.mdc-banner__graphic-text-wrapper{width:100%;display:flex}.mdc-banner__graphic{text-align:center;flex-shrink:0;width:40px;height:40px;margin:16px 0 16px 16px}[dir=rtl] .mdc-banner__graphic,.mdc-banner__graphic[dir=rtl]{margin-left:0;margin-right:16px}.mdc-banner__icon{position:relative;top:50%;transform:translateY(-50%)}.mdc-banner__text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);flex-grow:1;align-self:center;margin-left:24px;margin-right:90px;padding-top:16px;padding-bottom:16px}[dir=rtl] .mdc-banner__text,.mdc-banner__text[dir=rtl]{margin-left:90px;margin-right:24px}.mdc-banner__actions{flex-shrink:0;align-self:flex-end;padding:8px 8px 8px 0;display:flex}[dir=rtl] .mdc-banner__actions,.mdc-banner__actions[dir=rtl]{padding-left:8px;padding-right:0}.mdc-banner__primary-action:not(:disabled){color:var(--mdc-theme-primary,#6200ee)}.mdc-banner__primary-action:before,.mdc-banner__primary-action:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-banner__primary-action:hover:before,.mdc-banner__primary-action.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-banner__primary-action.mdc-ripple-upgraded--background-focused:before,.mdc-banner__primary-action:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-banner__primary-action:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-banner__primary-action:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-banner__primary-action.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-banner__secondary-action{margin-left:0;margin-right:8px}.mdc-banner__secondary-action:not(:disabled){color:var(--mdc-theme-primary,#6200ee)}.mdc-banner__secondary-action:before,.mdc-banner__secondary-action:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-banner__secondary-action:hover:before,.mdc-banner__secondary-action.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-banner__secondary-action.mdc-ripple-upgraded--background-focused:before,.mdc-banner__secondary-action:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-banner__secondary-action:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-banner__secondary-action:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-banner__secondary-action.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}[dir=rtl] .mdc-banner__secondary-action,.mdc-banner__secondary-action[dir=rtl]{margin-left:8px;margin-right:0}.mdc-touch-target-wrapper{display:inline}.mdc-elevation-overlay{border-radius:inherit;pointer-events:none;opacity:0;opacity:var(--mdc-elevation-overlay-opacity,0);background-color:#fff;background-color:var(--mdc-elevation-overlay-color,#fff);transition:opacity .28s cubic-bezier(.4,0,.2,1);position:absolute}.mdc-button{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-button-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-button-font-size,.875rem);line-height:2.25rem;line-height:var(--mdc-typography-button-line-height,2.25rem);font-weight:500;font-weight:var(--mdc-typography-button-font-weight,500);letter-spacing:.0892857em;letter-spacing:var(--mdc-typography-button-letter-spacing,.0892857em);text-decoration:none;-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);text-decoration:var(--mdc-typography-button-text-decoration,none);text-transform:uppercase;text-transform:var(--mdc-typography-button-text-transform,uppercase);box-sizing:border-box;line-height:inherit;-webkit-user-select:none;user-select:none;-webkit-appearance:none;vertical-align:middle;border:none;outline:none;justify-content:center;align-items:center;min-width:64px;display:inline-flex;position:relative;overflow:visible}.mdc-button .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-button::-moz-focus-inner{border:0;padding:0}.mdc-button:active{outline:none}.mdc-button:hover{cursor:pointer}.mdc-button:disabled{cursor:default;pointer-events:none}.mdc-button .mdc-button__icon{vertical-align:top;width:1.125rem;height:1.125rem;margin-left:0;margin-right:8px;font-size:1.125rem;display:inline-block}[dir=rtl] .mdc-button .mdc-button__icon,.mdc-button .mdc-button__icon[dir=rtl]{margin-left:8px;margin-right:0}.mdc-button .mdc-button__touch{height:48px;position:absolute;top:50%;left:0;right:0;transform:translateY(-50%)}.mdc-button__label+.mdc-button__icon{margin-left:8px;margin-right:0}[dir=rtl] .mdc-button__label+.mdc-button__icon,.mdc-button__label+.mdc-button__icon[dir=rtl]{margin-left:0;margin-right:8px}svg.mdc-button__icon{fill:currentColor}.mdc-button--raised .mdc-button__icon,.mdc-button--unelevated .mdc-button__icon,.mdc-button--outlined .mdc-button__icon{margin-left:-4px;margin-right:8px}[dir=rtl] .mdc-button--raised .mdc-button__icon,.mdc-button--raised .mdc-button__icon[dir=rtl],[dir=rtl] .mdc-button--unelevated .mdc-button__icon,.mdc-button--unelevated .mdc-button__icon[dir=rtl],[dir=rtl] .mdc-button--outlined .mdc-button__icon,.mdc-button--outlined .mdc-button__icon[dir=rtl],.mdc-button--raised .mdc-button__label+.mdc-button__icon,.mdc-button--unelevated .mdc-button__label+.mdc-button__icon,.mdc-button--outlined .mdc-button__label+.mdc-button__icon{margin-left:8px;margin-right:-4px}[dir=rtl] .mdc-button--raised .mdc-button__label+.mdc-button__icon,.mdc-button--raised .mdc-button__label+.mdc-button__icon[dir=rtl],[dir=rtl] .mdc-button--unelevated .mdc-button__label+.mdc-button__icon,.mdc-button--unelevated .mdc-button__label+.mdc-button__icon[dir=rtl],[dir=rtl] .mdc-button--outlined .mdc-button__label+.mdc-button__icon,.mdc-button--outlined .mdc-button__label+.mdc-button__icon[dir=rtl]{margin-left:-4px;margin-right:8px}.mdc-button--touch{margin-top:6px;margin-bottom:6px}@keyframes mdc-ripple-fg-radius-in{0%{transform:translate(var(--mdc-ripple-fg-translate-start,0))scale(1);animation-timing-function:cubic-bezier(.4,0,.2,1)}to{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1))}}@keyframes mdc-ripple-fg-opacity-in{0%{opacity:0;animation-timing-function:linear}to{opacity:var(--mdc-ripple-fg-opacity,0)}}@keyframes mdc-ripple-fg-opacity-out{0%{opacity:var(--mdc-ripple-fg-opacity,0);animation-timing-function:linear}to{opacity:0}}.mdc-button{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-button .mdc-button__ripple:before,.mdc-button .mdc-button__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-button .mdc-button__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-button .mdc-button__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-button.mdc-ripple-upgraded .mdc-button__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-button.mdc-ripple-upgraded .mdc-button__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-button.mdc-ripple-upgraded--unbounded .mdc-button__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-button.mdc-ripple-upgraded--foreground-activation .mdc-button__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-button.mdc-ripple-upgraded--foreground-deactivation .mdc-button__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-button .mdc-button__ripple:before,.mdc-button .mdc-button__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-button.mdc-ripple-upgraded .mdc-button__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-button .mdc-button__ripple{box-sizing:content-box;width:100%;height:100%;position:absolute;overflow:hidden}.mdc-button:not(.mdc-button--outlined) .mdc-button__ripple{top:0;left:0}.mdc-button--raised{transition:box-shadow .28s cubic-bezier(.4,0,.2,1);box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mdc-button--raised:hover,.mdc-button--raised:focus{box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mdc-button--raised:active{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.mdc-button--raised:disabled{box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mdc-button--outlined{border-style:solid}.mdc-button{border-radius:4px;border-radius:var(--mdc-shape-small,4px);height:36px;padding:0 8px}.mdc-button:not(:disabled),.mdc-button:disabled{background-color:#0000}.mdc-button:not(:disabled){color:var(--mdc-theme-primary,#6200ee)}.mdc-button:disabled{color:#00000061}.mdc-button .mdc-button__ripple:before,.mdc-button .mdc-button__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-button:hover .mdc-button__ripple:before,.mdc-button.mdc-ripple-surface--hover .mdc-button__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-button.mdc-ripple-upgraded--background-focused .mdc-button__ripple:before,.mdc-button:not(.mdc-ripple-upgraded):focus .mdc-button__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-button:not(.mdc-ripple-upgraded) .mdc-button__ripple:after{transition:opacity .15s linear}.mdc-button:not(.mdc-ripple-upgraded):active .mdc-button__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-button .mdc-button__ripple{border-radius:4px;border-radius:var(--mdc-shape-small,4px)}.mdc-button--unelevated{border-radius:4px;border-radius:var(--mdc-shape-small,4px);height:36px;padding:0 16px}.mdc-button--unelevated:not(:disabled){background-color:#6200ee;background-color:var(--mdc-theme-primary,#6200ee)}.mdc-button--unelevated:disabled{background-color:#0000001f}.mdc-button--unelevated:not(:disabled){color:var(--mdc-theme-on-primary,#fff)}.mdc-button--unelevated:disabled{color:#00000061}.mdc-button--unelevated .mdc-button__ripple:before,.mdc-button--unelevated .mdc-button__ripple:after{background-color:#fff;background-color:var(--mdc-ripple-color,var(--mdc-theme-on-primary,#fff))}.mdc-button--unelevated:hover .mdc-button__ripple:before,.mdc-button--unelevated.mdc-ripple-surface--hover .mdc-button__ripple:before{opacity:.08;opacity:var(--mdc-ripple-hover-opacity,.08)}.mdc-button--unelevated.mdc-ripple-upgraded--background-focused .mdc-button__ripple:before,.mdc-button--unelevated:not(.mdc-ripple-upgraded):focus .mdc-button__ripple:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}.mdc-button--unelevated:not(.mdc-ripple-upgraded) .mdc-button__ripple:after{transition:opacity .15s linear}.mdc-button--unelevated:not(.mdc-ripple-upgraded):active .mdc-button__ripple:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}.mdc-button--unelevated.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.24)}.mdc-button--unelevated .mdc-button__ripple{border-radius:4px;border-radius:var(--mdc-shape-small,4px)}.mdc-button--raised{border-radius:4px;border-radius:var(--mdc-shape-small,4px);height:36px;padding:0 16px}.mdc-button--raised:not(:disabled){background-color:#6200ee;background-color:var(--mdc-theme-primary,#6200ee)}.mdc-button--raised:disabled{background-color:#0000001f}.mdc-button--raised:not(:disabled){color:var(--mdc-theme-on-primary,#fff)}.mdc-button--raised:disabled{color:#00000061}.mdc-button--raised .mdc-button__ripple:before,.mdc-button--raised .mdc-button__ripple:after{background-color:#fff;background-color:var(--mdc-ripple-color,var(--mdc-theme-on-primary,#fff))}.mdc-button--raised:hover .mdc-button__ripple:before,.mdc-button--raised.mdc-ripple-surface--hover .mdc-button__ripple:before{opacity:.08;opacity:var(--mdc-ripple-hover-opacity,.08)}.mdc-button--raised.mdc-ripple-upgraded--background-focused .mdc-button__ripple:before,.mdc-button--raised:not(.mdc-ripple-upgraded):focus .mdc-button__ripple:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}.mdc-button--raised:not(.mdc-ripple-upgraded) .mdc-button__ripple:after{transition:opacity .15s linear}.mdc-button--raised:not(.mdc-ripple-upgraded):active .mdc-button__ripple:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}.mdc-button--raised.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.24)}.mdc-button--raised .mdc-button__ripple{border-radius:4px;border-radius:var(--mdc-shape-small,4px)}.mdc-button--outlined{border-radius:4px;border-radius:var(--mdc-shape-small,4px);border-width:1px;height:36px;padding:0 15px}.mdc-button--outlined:not(:disabled),.mdc-button--outlined:disabled{background-color:#0000}.mdc-button--outlined:not(:disabled){color:var(--mdc-theme-primary,#6200ee)}.mdc-button--outlined:disabled{color:#00000061}.mdc-button--outlined .mdc-button__ripple:before,.mdc-button--outlined .mdc-button__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-button--outlined:hover .mdc-button__ripple:before,.mdc-button--outlined.mdc-ripple-surface--hover .mdc-button__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-button--outlined.mdc-ripple-upgraded--background-focused .mdc-button__ripple:before,.mdc-button--outlined:not(.mdc-ripple-upgraded):focus .mdc-button__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-button--outlined:not(.mdc-ripple-upgraded) .mdc-button__ripple:after{transition:opacity .15s linear}.mdc-button--outlined:not(.mdc-ripple-upgraded):active .mdc-button__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-button--outlined.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-button--outlined .mdc-button__ripple{border-radius:4px;border-radius:var(--mdc-shape-small,4px)}.mdc-button--outlined:not(:disabled),.mdc-button--outlined:disabled{border-color:#0000001f}.mdc-button--outlined .mdc-button__ripple{border:1px solid #0000;top:-1px;left:-1px}.mdc-button--outlined .mdc-button__touch{width:calc(100% + 2px);left:-1px}.mdc-card{border-radius:4px;border-radius:var(--mdc-shape-medium,4px);background-color:#fff;background-color:var(--mdc-theme-surface,#fff);box-sizing:border-box;flex-direction:column;display:flex;position:relative;box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.mdc-card .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-card:after{border-radius:4px;border-radius:var(--mdc-shape-medium,4px);box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;pointer-events:none;border:1px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-card--outlined{border:1px solid #e0e0e0;box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mdc-card--outlined:after{border:none}.mdc-card__content{border-radius:inherit;height:100%}.mdc-card__media{box-sizing:border-box;background-position:50%;background-repeat:no-repeat;background-size:cover;position:relative}.mdc-card__media:before{content:\"\";display:block}.mdc-card__media:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.mdc-card__media:last-child{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.mdc-card__media--square:before{margin-top:100%}.mdc-card__media--16-9:before{margin-top:56.25%}.mdc-card__media-content{box-sizing:border-box;position:absolute;inset:0}.mdc-card__primary-action{box-sizing:border-box;color:inherit;cursor:pointer;outline:none;flex-direction:column;text-decoration:none;display:flex;position:relative;overflow:hidden}.mdc-card__primary-action:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.mdc-card__primary-action:last-child{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.mdc-card__actions{box-sizing:border-box;flex-direction:row;align-items:center;min-height:52px;padding:8px;display:flex}.mdc-card__actions--full-bleed{padding:0}.mdc-card__action-buttons,.mdc-card__action-icons{box-sizing:border-box;flex-direction:row;align-items:center;display:flex}.mdc-card__action-icons{color:#0009;flex-grow:1;justify-content:flex-end}.mdc-card__action-buttons+.mdc-card__action-icons{margin-left:16px;margin-right:0}[dir=rtl] .mdc-card__action-buttons+.mdc-card__action-icons,.mdc-card__action-buttons+.mdc-card__action-icons[dir=rtl]{margin-left:0;margin-right:16px}.mdc-card__action{box-sizing:border-box;cursor:pointer;-webkit-user-select:none;user-select:none;flex-direction:row;justify-content:center;align-items:center;display:inline-flex}.mdc-card__action:focus{outline:none}.mdc-card__action--button{margin-left:0;margin-right:8px;padding:0 8px}[dir=rtl] .mdc-card__action--button,.mdc-card__action--button[dir=rtl]{margin-left:8px;margin-right:0}.mdc-card__action--button:last-child,[dir=rtl] .mdc-card__action--button:last-child,.mdc-card__action--button:last-child[dir=rtl]{margin-left:0;margin-right:0}.mdc-card__actions--full-bleed .mdc-card__action--button{text-align:left;justify-content:space-between;width:100%;height:auto;max-height:none;margin:0;padding:8px 16px}[dir=rtl] .mdc-card__actions--full-bleed .mdc-card__action--button,.mdc-card__actions--full-bleed .mdc-card__action--button[dir=rtl]{text-align:right}.mdc-card__action--icon{margin:-6px 0;padding:12px}.mdc-card__action--icon:not(:disabled){color:#0009}.mdc-card__primary-action{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-card__primary-action:before,.mdc-card__primary-action:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-card__primary-action:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-card__primary-action:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-card__primary-action.mdc-ripple-upgraded:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-card__primary-action.mdc-ripple-upgraded:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-card__primary-action.mdc-ripple-upgraded--unbounded:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-card__primary-action.mdc-ripple-upgraded--foreground-activation:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-card__primary-action.mdc-ripple-upgraded--foreground-deactivation:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-card__primary-action:before,.mdc-card__primary-action:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-card__primary-action.mdc-ripple-upgraded:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-card__primary-action:before,.mdc-card__primary-action:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}.mdc-card__primary-action:hover:before,.mdc-card__primary-action.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-card__primary-action.mdc-ripple-upgraded--background-focused:before,.mdc-card__primary-action:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-card__primary-action:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-card__primary-action:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-card__primary-action.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-checkbox{padding:11px;padding:calc((var(--mdc-checkbox-ripple-size,40px) - 18px)/2);margin:0;margin:calc((var(--mdc-checkbox-ripple-size,40px) - var(--mdc-checkbox-ripple-size,40px))/2)}.mdc-checkbox .mdc-checkbox__ripple:before,.mdc-checkbox .mdc-checkbox__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}.mdc-checkbox:hover .mdc-checkbox__ripple:before,.mdc-checkbox.mdc-ripple-surface--hover .mdc-checkbox__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-checkbox.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple:before,.mdc-checkbox:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-checkbox:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple:after{transition:opacity .15s linear}.mdc-checkbox:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-checkbox.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple:before,.mdc-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple:after{background-color:#018786;background-color:var(--mdc-ripple-color,var(--mdc-theme-secondary,#018786))}.mdc-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple:before,.mdc-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple:before,.mdc-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple:after{transition:opacity .15s linear}.mdc-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple:before,.mdc-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple:after{background-color:#018786;background-color:var(--mdc-ripple-color,var(--mdc-theme-secondary,#018786))}.mdc-checkbox .mdc-checkbox__background{top:11px;top:calc((var(--mdc-checkbox-ripple-size,40px) - 18px)/2);left:11px;left:calc((var(--mdc-checkbox-ripple-size,40px) - 18px)/2)}.mdc-checkbox .mdc-checkbox__native-control{top:0;top:calc((var(--mdc-checkbox-ripple-size,40px) - var(--mdc-checkbox-ripple-size,40px))/2);right:0;right:calc((var(--mdc-checkbox-ripple-size,40px) - var(--mdc-checkbox-ripple-size,40px))/2);left:0;left:calc((var(--mdc-checkbox-ripple-size,40px) - var(--mdc-checkbox-ripple-size,40px))/2);width:var(--mdc-checkbox-ripple-size,40px);height:var(--mdc-checkbox-ripple-size,40px);width:40px;height:40px}.mdc-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:#0000008a;border-color:var(--mdc-checkbox-unchecked-color,#0000008a);background-color:#0000}.mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background{border-color:#018786;border-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#018786));background-color:#018786;background-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#018786))}@keyframes mdc-checkbox-fade-in-background-8A000000FF01878600000000FF018786{0%{border-color:#0000008a;border-color:var(--mdc-checkbox-unchecked-color,#0000008a);background-color:#0000}50%{border-color:#018786;border-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#018786));background-color:#018786;background-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#018786))}}@keyframes mdc-checkbox-fade-out-background-8A000000FF01878600000000FF018786{0%,80%{border-color:#018786;border-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#018786));background-color:#018786;background-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#018786))}to{border-color:#0000008a;border-color:var(--mdc-checkbox-unchecked-color,#0000008a);background-color:#0000}}.mdc-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-in-background-8A000000FF01878600000000FF018786}.mdc-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-out-background-8A000000FF01878600000000FF018786}.mdc-checkbox .mdc-checkbox__native-control[disabled]:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:#00000061;border-color:var(--mdc-checkbox-disabled-color,#00000061);background-color:#0000}.mdc-checkbox .mdc-checkbox__native-control[disabled]:checked~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control[disabled]:indeterminate~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true][disabled]~.mdc-checkbox__background{background-color:#00000061;background-color:var(--mdc-checkbox-disabled-color,#00000061);border-color:#0000}.mdc-checkbox .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark{color:var(--mdc-checkbox-ink-color,#fff)}.mdc-checkbox .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__mixedmark{border-color:#fff;border-color:var(--mdc-checkbox-ink-color,#fff)}.mdc-checkbox .mdc-checkbox__native-control:disabled~.mdc-checkbox__background .mdc-checkbox__checkmark{color:var(--mdc-checkbox-ink-color,#fff)}.mdc-checkbox .mdc-checkbox__native-control:disabled~.mdc-checkbox__background .mdc-checkbox__mixedmark{border-color:#fff;border-color:var(--mdc-checkbox-ink-color,#fff)}@keyframes mdc-checkbox-unchecked-checked-checkmark-path{0%,50%{stroke-dashoffset:29.7833px}50%{animation-timing-function:cubic-bezier(0,0,.2,1)}to{stroke-dashoffset:0}}@keyframes mdc-checkbox-unchecked-indeterminate-mixedmark{0%,68.2%{transform:scaleX(0)}68.2%{animation-timing-function:cubic-bezier(0,0,0,1)}to{transform:scaleX(1)}}@keyframes mdc-checkbox-checked-unchecked-checkmark-path{0%{opacity:1;stroke-dashoffset:0;animation-timing-function:cubic-bezier(.4,0,1,1)}to{opacity:0;stroke-dashoffset:-29.7833px}}@keyframes mdc-checkbox-checked-indeterminate-checkmark{0%{opacity:1;animation-timing-function:cubic-bezier(0,0,.2,1);transform:rotate(0)}to{opacity:0;transform:rotate(45deg)}}@keyframes mdc-checkbox-indeterminate-checked-checkmark{0%{opacity:0;animation-timing-function:cubic-bezier(.14,0,0,1);transform:rotate(45deg)}to{opacity:1;transform:rotate(360deg)}}@keyframes mdc-checkbox-checked-indeterminate-mixedmark{0%{animation-timing-function:mdc-animation-deceleration-curve-timing-function;opacity:0;transform:rotate(-45deg)}to{opacity:1;transform:rotate(0)}}@keyframes mdc-checkbox-indeterminate-checked-mixedmark{0%{opacity:1;animation-timing-function:cubic-bezier(.14,0,0,1);transform:rotate(0)}to{opacity:0;transform:rotate(315deg)}}@keyframes mdc-checkbox-indeterminate-unchecked-mixedmark{0%{opacity:1;animation-timing-function:linear;transform:scaleX(1)}32.8%,to{opacity:0;transform:scaleX(0)}}.mdc-checkbox{box-sizing:content-box;white-space:nowrap;cursor:pointer;vertical-align:bottom;flex:0 0 18px;width:18px;height:18px;line-height:0;display:inline-block;position:relative}@media screen and (-ms-high-contrast:active){.mdc-checkbox__native-control[disabled]:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:graytext;border-color:var(--mdc-checkbox-disabled-color,GrayText);background-color:#0000}.mdc-checkbox__native-control[disabled]:checked~.mdc-checkbox__background,.mdc-checkbox__native-control[disabled]:indeterminate~.mdc-checkbox__background,.mdc-checkbox__native-control[data-indeterminate=true][disabled]~.mdc-checkbox__background{background-color:#0000;background-color:var(--mdc-checkbox-disabled-color,transparent);border-color:graytext}.mdc-checkbox__native-control:disabled~.mdc-checkbox__background .mdc-checkbox__checkmark{color:var(--mdc-checkbox-ink-color,GrayText)}.mdc-checkbox__native-control:disabled~.mdc-checkbox__background .mdc-checkbox__mixedmark{border-color:graytext;border-color:var(--mdc-checkbox-ink-color,GrayText)}.mdc-checkbox__mixedmark{margin:0 1px}}.mdc-checkbox--disabled{cursor:default;pointer-events:none}.mdc-checkbox__background{box-sizing:border-box;pointer-events:none;will-change:background-color,border-color;background-color:#0000;border:2px solid;border-radius:2px;justify-content:center;align-items:center;width:18px;height:18px;transition:background-color 90ms cubic-bezier(.4,0,.6,1),border-color 90ms cubic-bezier(.4,0,.6,1);display:inline-flex;position:absolute}.mdc-checkbox__checkmark{opacity:0;width:100%;transition:opacity .18s cubic-bezier(.4,0,.6,1);position:absolute;inset:0}.mdc-checkbox--upgraded .mdc-checkbox__checkmark{opacity:1}.mdc-checkbox__checkmark-path{stroke:currentColor;stroke-width:3.12px;stroke-dashoffset:29.7833px;stroke-dasharray:29.7833;transition:stroke-dashoffset .18s cubic-bezier(.4,0,.6,1)}.mdc-checkbox__mixedmark{opacity:0;border-style:solid;border-width:1px;width:100%;height:0;transition:opacity 90ms cubic-bezier(.4,0,.6,1),transform 90ms cubic-bezier(.4,0,.6,1);transform:scaleX(0)rotate(0)}.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__background,.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__background,.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__background,.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__background{animation-duration:.18s;animation-timing-function:linear}.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__checkmark-path{transition:none;animation:.18s linear mdc-checkbox-unchecked-checked-checkmark-path}.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__mixedmark{transition:none;animation:90ms linear mdc-checkbox-unchecked-indeterminate-mixedmark}.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__checkmark-path{transition:none;animation:90ms linear mdc-checkbox-checked-unchecked-checkmark-path}.mdc-checkbox--anim-checked-indeterminate .mdc-checkbox__checkmark{transition:none;animation:90ms linear mdc-checkbox-checked-indeterminate-checkmark}.mdc-checkbox--anim-checked-indeterminate .mdc-checkbox__mixedmark{transition:none;animation:90ms linear mdc-checkbox-checked-indeterminate-mixedmark}.mdc-checkbox--anim-indeterminate-checked .mdc-checkbox__checkmark{transition:none;animation:.5s linear mdc-checkbox-indeterminate-checked-checkmark}.mdc-checkbox--anim-indeterminate-checked .mdc-checkbox__mixedmark{transition:none;animation:.5s linear mdc-checkbox-indeterminate-checked-mixedmark}.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__mixedmark{transition:none;animation:.3s linear mdc-checkbox-indeterminate-unchecked-mixedmark}.mdc-checkbox__native-control:checked~.mdc-checkbox__background,.mdc-checkbox__native-control:indeterminate~.mdc-checkbox__background,.mdc-checkbox__native-control[data-indeterminate=true]~.mdc-checkbox__background{transition:border-color 90ms cubic-bezier(0,0,.2,1),background-color 90ms cubic-bezier(0,0,.2,1)}.mdc-checkbox__native-control:checked~.mdc-checkbox__background .mdc-checkbox__checkmark-path,.mdc-checkbox__native-control:indeterminate~.mdc-checkbox__background .mdc-checkbox__checkmark-path,.mdc-checkbox__native-control[data-indeterminate=true]~.mdc-checkbox__background .mdc-checkbox__checkmark-path{stroke-dashoffset:0}.mdc-checkbox__native-control{opacity:0;cursor:inherit;margin:0;padding:0;position:absolute}.mdc-checkbox__native-control:disabled{cursor:default;pointer-events:none}.mdc-checkbox--touch{margin:4px;margin:calc((var(--mdc-checkbox-touch-target-size,48px) - var(--mdc-checkbox-ripple-size,40px))/2)}.mdc-checkbox--touch .mdc-checkbox__native-control{top:-4px;top:calc((var(--mdc-checkbox-ripple-size,40px) - var(--mdc-checkbox-touch-target-size,48px))/2);right:-4px;right:calc((var(--mdc-checkbox-ripple-size,40px) - var(--mdc-checkbox-touch-target-size,48px))/2);left:-4px;left:calc((var(--mdc-checkbox-ripple-size,40px) - var(--mdc-checkbox-touch-target-size,48px))/2);width:var(--mdc-checkbox-touch-target-size,48px);height:var(--mdc-checkbox-touch-target-size,48px);width:48px;height:48px}.mdc-checkbox__native-control:checked~.mdc-checkbox__background .mdc-checkbox__checkmark{opacity:1;transition:opacity .18s cubic-bezier(0,0,.2,1),transform .18s cubic-bezier(0,0,.2,1)}.mdc-checkbox__native-control:checked~.mdc-checkbox__background .mdc-checkbox__mixedmark{transform:scaleX(1)rotate(-45deg)}.mdc-checkbox__native-control:indeterminate~.mdc-checkbox__background .mdc-checkbox__checkmark,.mdc-checkbox__native-control[data-indeterminate=true]~.mdc-checkbox__background .mdc-checkbox__checkmark{opacity:0;transition:opacity 90ms cubic-bezier(.4,0,.6,1),transform 90ms cubic-bezier(.4,0,.6,1);transform:rotate(45deg)}.mdc-checkbox__native-control:indeterminate~.mdc-checkbox__background .mdc-checkbox__mixedmark,.mdc-checkbox__native-control[data-indeterminate=true]~.mdc-checkbox__background .mdc-checkbox__mixedmark{opacity:1;transform:scaleX(1)rotate(0)}.mdc-checkbox.mdc-checkbox--upgraded .mdc-checkbox__background,.mdc-checkbox.mdc-checkbox--upgraded .mdc-checkbox__checkmark,.mdc-checkbox.mdc-checkbox--upgraded .mdc-checkbox__checkmark-path,.mdc-checkbox.mdc-checkbox--upgraded .mdc-checkbox__mixedmark{transition:none}.mdc-checkbox{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-checkbox .mdc-checkbox__ripple:before,.mdc-checkbox .mdc-checkbox__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-checkbox .mdc-checkbox__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-checkbox .mdc-checkbox__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-checkbox.mdc-ripple-upgraded .mdc-checkbox__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-checkbox.mdc-ripple-upgraded .mdc-checkbox__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-checkbox.mdc-ripple-upgraded--unbounded .mdc-checkbox__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-checkbox.mdc-ripple-upgraded--foreground-activation .mdc-checkbox__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-checkbox.mdc-ripple-upgraded--foreground-deactivation .mdc-checkbox__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-checkbox .mdc-checkbox__ripple:before,.mdc-checkbox .mdc-checkbox__ripple:after{width:100%;height:100%;top:0%;left:0%}.mdc-checkbox.mdc-ripple-upgraded .mdc-checkbox__ripple:before,.mdc-checkbox.mdc-ripple-upgraded .mdc-checkbox__ripple:after{top:var(--mdc-ripple-top,calc(50% - 50%));left:var(--mdc-ripple-left,calc(50% - 50%));width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-checkbox.mdc-ripple-upgraded .mdc-checkbox__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-checkbox{z-index:0}.mdc-checkbox .mdc-checkbox__ripple:before,.mdc-checkbox .mdc-checkbox__ripple:after{z-index:-1;z-index:var(--mdc-ripple-z-index,-1)}.mdc-checkbox__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-deprecated-chip-trailing-action__touch{width:48px;height:48px;position:absolute;top:50%;left:50%;right:0;transform:translate(-50%,-50%)}.mdc-deprecated-chip-trailing-action{box-sizing:border-box;cursor:pointer;-webkit-appearance:none;background:0 0;border:none;outline:none;justify-content:center;align-items:center;padding:0;display:inline-flex;position:relative}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__icon{width:18px;height:18px;font-size:18px}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action{color:var(--mdc-theme-on-surface,#000)}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__touch{width:26px}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__icon{fill:currentColor;color:inherit}.mdc-deprecated-chip-trailing-action{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple:before,.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded .mdc-deprecated-chip-trailing-action__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded .mdc-deprecated-chip-trailing-action__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded--unbounded .mdc-deprecated-chip-trailing-action__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded--foreground-activation .mdc-deprecated-chip-trailing-action__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded--foreground-deactivation .mdc-deprecated-chip-trailing-action__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple:before,.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple:after{width:100%;height:100%;top:0%;left:0%}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded .mdc-deprecated-chip-trailing-action__ripple:before,.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded .mdc-deprecated-chip-trailing-action__ripple:after{top:var(--mdc-ripple-top,calc(50% - 50%));left:var(--mdc-ripple-left,calc(50% - 50%));width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded .mdc-deprecated-chip-trailing-action__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple:before,.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,var(--mdc-theme-on-surface,#000))}.mdc-deprecated-chip-trailing-action:hover .mdc-deprecated-chip-trailing-action__ripple:before,.mdc-deprecated-chip-trailing-action.mdc-ripple-surface--hover .mdc-deprecated-chip-trailing-action__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded--background-focused .mdc-deprecated-chip-trailing-action__ripple:before,.mdc-deprecated-chip-trailing-action:not(.mdc-ripple-upgraded):focus .mdc-deprecated-chip-trailing-action__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-deprecated-chip-trailing-action:not(.mdc-ripple-upgraded) .mdc-deprecated-chip-trailing-action__ripple:after{transition:opacity .15s linear}.mdc-deprecated-chip-trailing-action:not(.mdc-ripple-upgraded):active .mdc-deprecated-chip-trailing-action__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple{box-sizing:content-box;width:100%;height:100%;position:absolute;overflow:hidden}.mdc-chip__icon--leading{color:#0000008a}.mdc-deprecated-chip-trailing-action{color:#000}.mdc-chip__icon--trailing{color:#0000008a}.mdc-chip__icon--trailing:hover{color:#0000009e}.mdc-chip__icon--trailing:focus{color:#000000de}.mdc-chip__icon.mdc-chip__icon--leading:not(.mdc-chip__icon--leading-hidden){width:20px;height:20px;font-size:20px}.mdc-deprecated-chip-trailing-action__icon,.mdc-chip__icon.mdc-chip__icon--trailing{width:18px;height:18px;font-size:18px}.mdc-deprecated-chip-trailing-action{margin-left:4px;margin-right:-4px}[dir=rtl] .mdc-deprecated-chip-trailing-action,.mdc-deprecated-chip-trailing-action[dir=rtl]{margin-left:-4px;margin-right:4px}.mdc-chip__icon--trailing{margin-left:4px;margin-right:-4px}[dir=rtl] .mdc-chip__icon--trailing,.mdc-chip__icon--trailing[dir=rtl]{margin-left:-4px;margin-right:4px}.mdc-chip{color:#000000de;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);box-sizing:border-box;cursor:pointer;-webkit-appearance:none;background-color:#e0e0e0;border-width:0;border-radius:16px;outline:none;align-items:center;height:32px;padding:0 12px;display:inline-flex;position:relative}.mdc-chip .mdc-chip__ripple{border-radius:16px}.mdc-chip.mdc-chip--selected .mdc-chip__checkmark,.mdc-chip .mdc-chip__icon--leading:not(.mdc-chip__icon--leading-hidden){margin-left:-4px;margin-right:4px}[dir=rtl] .mdc-chip.mdc-chip--selected .mdc-chip__checkmark,.mdc-chip.mdc-chip--selected .mdc-chip__checkmark[dir=rtl],[dir=rtl] .mdc-chip .mdc-chip__icon--leading:not(.mdc-chip__icon--leading-hidden),.mdc-chip .mdc-chip__icon--leading:not(.mdc-chip__icon--leading-hidden)[dir=rtl]{margin-left:4px;margin-right:-4px}.mdc-chip .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-chip::-moz-focus-inner{border:0;padding:0}.mdc-chip:hover{color:var(--mdc-theme-on-surface,#000)}.mdc-chip .mdc-chip__touch{height:48px;position:absolute;top:50%;left:0;right:0;transform:translateY(-50%)}.mdc-chip--exit{opacity:0;transition:opacity 75ms cubic-bezier(.4,0,.2,1),width .15s cubic-bezier(0,0,.2,1),padding .1s linear,margin .1s linear}.mdc-chip__overflow{text-overflow:ellipsis;overflow:hidden}.mdc-chip__text{white-space:nowrap}.mdc-chip__icon{vertical-align:middle;border-radius:50%;outline:none}.mdc-chip__checkmark{height:20px}.mdc-chip__checkmark-path{stroke-width:2px;stroke-dashoffset:29.7833px;stroke-dasharray:29.7833;transition:stroke-dashoffset .15s cubic-bezier(.4,0,.6,1) 50ms}.mdc-chip__primary-action:focus{outline:none}.mdc-chip--selected .mdc-chip__checkmark-path{stroke-dashoffset:0}.mdc-chip__icon--leading,.mdc-chip__icon--trailing{position:relative}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected{color:var(--mdc-theme-primary,#6200ee)}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected .mdc-chip__icon--leading{color:#6200ee8a}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected:hover{color:var(--mdc-theme-primary,#6200ee)}.mdc-chip-set--choice .mdc-chip .mdc-chip__checkmark-path{stroke:var(--mdc-theme-primary,#6200ee)}.mdc-chip-set--choice .mdc-chip--selected{background-color:#fff;background-color:var(--mdc-theme-surface,#fff)}.mdc-chip__checkmark-svg{width:0;height:20px;transition:width .15s cubic-bezier(.4,0,.2,1)}.mdc-chip--selected .mdc-chip__checkmark-svg{width:20px}.mdc-chip-set--filter .mdc-chip__icon--leading{opacity:1;transition:opacity 75ms linear -50ms}.mdc-chip-set--filter .mdc-chip__icon--leading+.mdc-chip__checkmark{opacity:0;transition:opacity 75ms linear 80ms}.mdc-chip-set--filter .mdc-chip__icon--leading+.mdc-chip__checkmark .mdc-chip__checkmark-svg{transition:width}.mdc-chip-set--filter .mdc-chip--selected .mdc-chip__icon--leading{opacity:0}.mdc-chip-set--filter .mdc-chip--selected .mdc-chip__icon--leading+.mdc-chip__checkmark{opacity:1;width:0}.mdc-chip-set--filter .mdc-chip__icon--leading-hidden.mdc-chip__icon--leading{opacity:0;width:0}.mdc-chip-set--filter .mdc-chip__icon--leading-hidden.mdc-chip__icon--leading+.mdc-chip__checkmark{width:20px}.mdc-chip{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-chip .mdc-chip__ripple:before,.mdc-chip .mdc-chip__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-chip .mdc-chip__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-chip .mdc-chip__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-chip.mdc-ripple-upgraded .mdc-chip__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-chip.mdc-ripple-upgraded .mdc-chip__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-chip.mdc-ripple-upgraded--unbounded .mdc-chip__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-chip.mdc-ripple-upgraded--foreground-activation .mdc-chip__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-chip.mdc-ripple-upgraded--foreground-deactivation .mdc-chip__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-chip .mdc-chip__ripple:before,.mdc-chip .mdc-chip__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-chip.mdc-ripple-upgraded .mdc-chip__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-chip .mdc-chip__ripple:before,.mdc-chip .mdc-chip__ripple:after{background-color:#000000de;background-color:var(--mdc-ripple-color,#000000de)}.mdc-chip:hover .mdc-chip__ripple:before,.mdc-chip.mdc-ripple-surface--hover .mdc-chip__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-chip.mdc-ripple-upgraded--background-focused .mdc-chip__ripple:before,.mdc-chip.mdc-ripple-upgraded:focus-within .mdc-chip__ripple:before,.mdc-chip:not(.mdc-ripple-upgraded):focus .mdc-chip__ripple:before,.mdc-chip:not(.mdc-ripple-upgraded):focus-within .mdc-chip__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-chip:not(.mdc-ripple-upgraded) .mdc-chip__ripple:after{transition:opacity .15s linear}.mdc-chip:not(.mdc-ripple-upgraded):active .mdc-chip__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-chip.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-chip .mdc-chip__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0;overflow:hidden}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected .mdc-chip__ripple:before{opacity:.08;opacity:var(--mdc-ripple-selected-opacity,.08)}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected .mdc-chip__ripple:before,.mdc-chip-set--choice .mdc-chip.mdc-chip--selected .mdc-chip__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected:hover .mdc-chip__ripple:before,.mdc-chip-set--choice .mdc-chip.mdc-chip--selected.mdc-ripple-surface--hover .mdc-chip__ripple:before{opacity:.12;opacity:var(--mdc-ripple-hover-opacity,.12)}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected.mdc-ripple-upgraded--background-focused .mdc-chip__ripple:before,.mdc-chip-set--choice .mdc-chip.mdc-chip--selected.mdc-ripple-upgraded:focus-within .mdc-chip__ripple:before,.mdc-chip-set--choice .mdc-chip.mdc-chip--selected:not(.mdc-ripple-upgraded):focus .mdc-chip__ripple:before,.mdc-chip-set--choice .mdc-chip.mdc-chip--selected:not(.mdc-ripple-upgraded):focus-within .mdc-chip__ripple:before{opacity:.2;opacity:var(--mdc-ripple-focus-opacity,.2);transition-duration:75ms}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected:not(.mdc-ripple-upgraded) .mdc-chip__ripple:after{transition:opacity .15s linear}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected:not(.mdc-ripple-upgraded):active .mdc-chip__ripple:after{opacity:.2;opacity:var(--mdc-ripple-press-opacity,.2);transition-duration:75ms}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.2)}@keyframes mdc-chip-entry{0%{opacity:.4;transform:scale(.8)}to{opacity:1;transform:scale(1)}}.mdc-chip-set{box-sizing:border-box;flex-wrap:wrap;padding:4px;display:flex}.mdc-chip-set .mdc-chip{margin:4px}.mdc-chip-set .mdc-chip--touch{margin-top:8px;margin-bottom:8px}.mdc-chip-set--input .mdc-chip{animation:.1s cubic-bezier(0,0,.2,1) mdc-chip-entry}.mdc-circular-progress__determinate-circle,.mdc-circular-progress__indeterminate-circle-graphic{stroke:var(--mdc-theme-primary,#6200ee)}.mdc-circular-progress__determinate-track{stroke:#0000}@keyframes mdc-circular-progress-container-rotate{to{transform:rotate(360deg)}}@keyframes mdc-circular-progress-spinner-layer-rotate{12.5%{transform:rotate(135deg)}25%{transform:rotate(270deg)}37.5%{transform:rotate(405deg)}50%{transform:rotate(540deg)}62.5%{transform:rotate(675deg)}75%{transform:rotate(810deg)}87.5%{transform:rotate(945deg)}to{transform:rotate(1080deg)}}@keyframes mdc-circular-progress-color-1-fade-in-out{0%{opacity:.99}25%{opacity:.99}26%{opacity:0}89%{opacity:0}90%{opacity:.99}to{opacity:.99}}@keyframes mdc-circular-progress-color-2-fade-in-out{0%{opacity:0}15%{opacity:0}25%{opacity:.99}50%{opacity:.99}51%{opacity:0}to{opacity:0}}@keyframes mdc-circular-progress-color-3-fade-in-out{0%{opacity:0}40%{opacity:0}50%{opacity:.99}75%{opacity:.99}76%{opacity:0}to{opacity:0}}@keyframes mdc-circular-progress-color-4-fade-in-out{0%{opacity:0}65%{opacity:0}75%{opacity:.99}90%{opacity:.99}to{opacity:0}}@keyframes mdc-circular-progress-left-spin{0%{transform:rotate(265deg)}50%{transform:rotate(130deg)}to{transform:rotate(265deg)}}@keyframes mdc-circular-progress-right-spin{0%{transform:rotate(-265deg)}50%{transform:rotate(-130deg)}to{transform:rotate(-265deg)}}.mdc-circular-progress{direction:ltr;transition:opacity .25s cubic-bezier(.4,0,.6,1);display:inline-flex;position:relative}.mdc-circular-progress__determinate-container,.mdc-circular-progress__indeterminate-circle-graphic,.mdc-circular-progress__indeterminate-container,.mdc-circular-progress__spinner-layer{width:100%;height:100%;position:absolute}.mdc-circular-progress__determinate-container{transform:rotate(-90deg)}.mdc-circular-progress__indeterminate-container{letter-spacing:0;white-space:nowrap;opacity:0;font-size:0}.mdc-circular-progress__determinate-circle-graphic,.mdc-circular-progress__indeterminate-circle-graphic{fill:#0000}.mdc-circular-progress__determinate-circle{transition:stroke-dashoffset .5s cubic-bezier(0,0,.2,1)}.mdc-circular-progress__gap-patch{box-sizing:border-box;width:5%;height:100%;position:absolute;top:0;left:47.5%;overflow:hidden}.mdc-circular-progress__gap-patch .mdc-circular-progress__indeterminate-circle-graphic{width:2000%;left:-900%;transform:rotate(180deg)}.mdc-circular-progress__circle-clipper{width:50%;height:100%;display:inline-flex;position:relative;overflow:hidden}.mdc-circular-progress__circle-clipper .mdc-circular-progress__indeterminate-circle-graphic{width:200%}.mdc-circular-progress__circle-right .mdc-circular-progress__indeterminate-circle-graphic{left:-100%}.mdc-circular-progress--indeterminate .mdc-circular-progress__determinate-container{opacity:0}.mdc-circular-progress--indeterminate .mdc-circular-progress__indeterminate-container{opacity:1;animation:1.56824s linear infinite mdc-circular-progress-container-rotate}.mdc-circular-progress--indeterminate .mdc-circular-progress__spinner-layer{animation:5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-spinner-layer-rotate}.mdc-circular-progress--indeterminate .mdc-circular-progress__color-1{animation:5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-spinner-layer-rotate,5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-color-1-fade-in-out}.mdc-circular-progress--indeterminate .mdc-circular-progress__color-2{animation:5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-spinner-layer-rotate,5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-color-2-fade-in-out}.mdc-circular-progress--indeterminate .mdc-circular-progress__color-3{animation:5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-spinner-layer-rotate,5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-color-3-fade-in-out}.mdc-circular-progress--indeterminate .mdc-circular-progress__color-4{animation:5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-spinner-layer-rotate,5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-color-4-fade-in-out}.mdc-circular-progress--indeterminate .mdc-circular-progress__circle-left .mdc-circular-progress__indeterminate-circle-graphic{animation:1.333s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-left-spin}.mdc-circular-progress--indeterminate .mdc-circular-progress__circle-right .mdc-circular-progress__indeterminate-circle-graphic{animation:1.333s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-right-spin}.mdc-circular-progress--closed{opacity:0}.mdc-floating-label{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);transform-origin:0 0;text-align:left;text-overflow:ellipsis;white-space:nowrap;cursor:text;will-change:transform;line-height:1.15rem;transition:transform .15s cubic-bezier(.4,0,.2,1),color .15s cubic-bezier(.4,0,.2,1);position:absolute;left:0;overflow:hidden}[dir=rtl] .mdc-floating-label,.mdc-floating-label[dir=rtl]{transform-origin:100% 0;text-align:right;left:auto;right:0}.mdc-floating-label--float-above{cursor:auto}.mdc-floating-label--required:after{content:\"*\";margin-left:1px;margin-right:0}[dir=rtl] .mdc-floating-label--required:after,.mdc-floating-label--required[dir=rtl]:after{margin-left:0;margin-right:1px}.mdc-floating-label--float-above{transform:translateY(-106%)scale(.75)}.mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-standard}@keyframes mdc-floating-label-shake-float-above-standard{0%{transform:translate(0)translateY(-106%)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(4%)translateY(-106%)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(-4%)translateY(-106%)scale(.75)}to{transform:translate(0)translateY(-106%)scale(.75)}}.mdc-line-ripple:before,.mdc-line-ripple:after{content:\"\";border-bottom-style:solid;width:100%;position:absolute;bottom:0;left:0}.mdc-line-ripple:before{z-index:1;border-bottom-width:1px}.mdc-line-ripple:after{opacity:0;z-index:2;border-bottom-width:2px;transition:transform .18s cubic-bezier(.4,0,.2,1),opacity .18s cubic-bezier(.4,0,.2,1);transform:scaleX(0)}.mdc-line-ripple--active:after{opacity:1;transform:scaleX(1)}.mdc-line-ripple--deactivating:after{opacity:0}.mdc-notched-outline{box-sizing:border-box;text-align:left;pointer-events:none;width:100%;max-width:100%;height:100%;display:flex;position:absolute;top:0;left:0;right:0}[dir=rtl] .mdc-notched-outline,.mdc-notched-outline[dir=rtl]{text-align:right}.mdc-notched-outline__leading,.mdc-notched-outline__notch,.mdc-notched-outline__trailing{box-sizing:border-box;pointer-events:none;border-top:1px solid;border-bottom:1px solid;height:100%}.mdc-notched-outline__leading{border-left:1px solid;border-right:none;width:12px}[dir=rtl] .mdc-notched-outline__leading,.mdc-notched-outline__leading[dir=rtl]{border-left:none;border-right:1px solid}.mdc-notched-outline__trailing{border-left:none;border-right:1px solid;flex-grow:1}[dir=rtl] .mdc-notched-outline__trailing,.mdc-notched-outline__trailing[dir=rtl]{border-left:1px solid;border-right:none}.mdc-notched-outline__notch{flex:none;width:auto;max-width:calc(100% - 24px)}.mdc-notched-outline .mdc-floating-label{max-width:100%;display:inline-block;position:relative}.mdc-notched-outline .mdc-floating-label--float-above{text-overflow:clip}.mdc-notched-outline--upgraded .mdc-floating-label--float-above{max-width:133.333%}.mdc-notched-outline--notched .mdc-notched-outline__notch{border-top:none;padding-left:0;padding-right:8px}[dir=rtl] .mdc-notched-outline--notched .mdc-notched-outline__notch,.mdc-notched-outline--notched .mdc-notched-outline__notch[dir=rtl]{padding-left:8px;padding-right:0}.mdc-notched-outline--no-label .mdc-notched-outline__notch{display:none}.mdc-select{display:inline-flex;position:relative}.mdc-select:not(.mdc-select--disabled) .mdc-select__selected-text{color:#000000de}.mdc-select.mdc-select--disabled .mdc-select__selected-text{color:#00000061}.mdc-select:not(.mdc-select--disabled) .mdc-floating-label{color:#0009}.mdc-select:not(.mdc-select--disabled).mdc-select--focused .mdc-floating-label{color:#6200eede}.mdc-select.mdc-select--disabled .mdc-floating-label{color:#00000061}.mdc-select:not(.mdc-select--disabled) .mdc-select__dropdown-icon{fill:#0000008a}.mdc-select:not(.mdc-select--disabled).mdc-select--focused .mdc-select__dropdown-icon{fill:var(--mdc-theme-primary,#6200ee)}.mdc-select.mdc-select--disabled .mdc-select__dropdown-icon{fill:#00000061}.mdc-select:not(.mdc-select--disabled)+.mdc-select-helper-text{color:#0009}.mdc-select.mdc-select--disabled+.mdc-select-helper-text{color:#00000061}.mdc-select:not(.mdc-select--disabled) .mdc-select__icon{color:#0000008a}.mdc-select.mdc-select--disabled .mdc-select__icon{color:#00000061}@media screen and (-ms-high-contrast:active){.mdc-select.mdc-select--disabled .mdc-select__selected-text{color:graytext}.mdc-select.mdc-select--disabled .mdc-select__dropdown-icon{fill:red}.mdc-select.mdc-select--disabled .mdc-floating-label{color:graytext}.mdc-select.mdc-select--disabled .mdc-line-ripple:before{border-bottom-color:graytext}.mdc-select.mdc-select--disabled .mdc-notched-outline__leading,.mdc-select.mdc-select--disabled .mdc-notched-outline__notch,.mdc-select.mdc-select--disabled .mdc-notched-outline__trailing{border-color:graytext}.mdc-select.mdc-select--disabled .mdc-select__icon,.mdc-select.mdc-select--disabled+.mdc-select-helper-text{color:graytext}}.mdc-select .mdc-floating-label{pointer-events:none;top:50%;transform:translateY(-50%)}.mdc-select .mdc-select__anchor{padding-left:16px;padding-right:0}[dir=rtl] .mdc-select .mdc-select__anchor,.mdc-select .mdc-select__anchor[dir=rtl]{padding-left:0;padding-right:16px}.mdc-select.mdc-select--with-leading-icon .mdc-select__anchor,[dir=rtl] .mdc-select.mdc-select--with-leading-icon .mdc-select__anchor,.mdc-select.mdc-select--with-leading-icon .mdc-select__anchor[dir=rtl]{padding-left:0;padding-right:0}.mdc-select .mdc-select__icon{width:24px;height:24px;font-size:24px}.mdc-select .mdc-select__dropdown-icon{width:24px;height:24px}.mdc-select .mdc-select__menu .mdc-deprecated-list-item,[dir=rtl] .mdc-select .mdc-select__menu .mdc-deprecated-list-item,.mdc-select .mdc-select__menu .mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:16px}.mdc-select .mdc-select__menu .mdc-deprecated-list-item__graphic{margin-left:0;margin-right:12px}[dir=rtl] .mdc-select .mdc-select__menu .mdc-deprecated-list-item__graphic,.mdc-select .mdc-select__menu .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:12px;margin-right:0}.mdc-select__dropdown-icon{pointer-events:none;flex-shrink:0;justify-content:center;align-self:center;align-items:center;margin-left:12px;margin-right:12px;display:inline-flex;position:relative}.mdc-select__dropdown-icon .mdc-select__dropdown-icon-active,.mdc-select__dropdown-icon .mdc-select__dropdown-icon-inactive{position:absolute;top:0;left:0}.mdc-select__dropdown-icon .mdc-select__dropdown-icon-graphic{width:41.6667%;height:20.8333%}.mdc-select__dropdown-icon .mdc-select__dropdown-icon-inactive{opacity:1;transition:opacity 75ms linear 75ms}.mdc-select__dropdown-icon .mdc-select__dropdown-icon-active{opacity:0;transition:opacity 75ms linear}[dir=rtl] .mdc-select__dropdown-icon,.mdc-select__dropdown-icon[dir=rtl]{margin-left:12px;margin-right:12px}.mdc-select--activated .mdc-select__dropdown-icon .mdc-select__dropdown-icon-inactive{opacity:0;transition:opacity 49.5ms linear}.mdc-select--activated .mdc-select__dropdown-icon .mdc-select__dropdown-icon-active{opacity:1;transition:opacity .1005s linear 49.5ms}.mdc-select__anchor{box-sizing:border-box;cursor:pointer;outline:none;flex:auto;width:200px;min-width:0;position:relative;overflow:hidden}.mdc-select__anchor .mdc-floating-label--float-above{transform:translateY(-106%)scale(.75)}.mdc-select__selected-text-container{appearance:none;pointer-events:none;box-sizing:border-box;color:inherit;background-color:#0000;border:none;outline:none;flex-grow:1;width:auto;min-width:0;height:28px;padding:0;display:flex}.mdc-select__selected-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);text-overflow:ellipsis;white-space:nowrap;text-align:left;width:100%;display:block;overflow:hidden}[dir=rtl] .mdc-select__selected-text,.mdc-select__selected-text[dir=rtl]{text-align:right}.mdc-select--invalid:not(.mdc-select--disabled) .mdc-floating-label,.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-floating-label,.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--invalid+.mdc-select-helper-text--validation-msg{color:var(--mdc-theme-error,#b00020)}.mdc-select--invalid:not(.mdc-select--disabled) .mdc-select__dropdown-icon,.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-select__dropdown-icon{fill:var(--mdc-theme-error,#b00020)}.mdc-select--disabled{cursor:default;pointer-events:none}.mdc-select--with-leading-icon .mdc-select__menu .mdc-deprecated-list-item,[dir=rtl] .mdc-select--with-leading-icon .mdc-select__menu .mdc-deprecated-list-item,.mdc-select--with-leading-icon .mdc-select__menu .mdc-deprecated-list-item[dir=rtl]{padding-left:12px;padding-right:12px}.mdc-select__menu .mdc-deprecated-list .mdc-select__icon,[dir=rtl] .mdc-select__menu .mdc-deprecated-list .mdc-select__icon,.mdc-select__menu .mdc-deprecated-list .mdc-select__icon[dir=rtl]{margin-left:0;margin-right:0}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--activated,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected .mdc-deprecated-list-item__graphic,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--activated .mdc-deprecated-list-item__graphic{color:var(--mdc-theme-on-surface,#000)}.mdc-select--filled .mdc-select__anchor{align-items:baseline;height:56px;display:flex}.mdc-select--filled .mdc-select__anchor:before{content:\"\";vertical-align:0;width:0;height:40px;display:inline-block}.mdc-select--filled.mdc-select--no-label .mdc-select__anchor .mdc-select__selected-text:before{content:\"​\"}.mdc-select--filled.mdc-select--no-label .mdc-select__anchor .mdc-select__selected-text-container{align-items:center;height:100%;display:inline-flex}.mdc-select--filled.mdc-select--no-label .mdc-select__anchor:before{display:none}.mdc-select--filled .mdc-select__anchor{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small,4px);border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small,4px);border-bottom-right-radius:0;border-bottom-left-radius:0}.mdc-select--filled:not(.mdc-select--disabled) .mdc-select__anchor{background-color:#f5f5f5}.mdc-select--filled.mdc-select--disabled .mdc-select__anchor{background-color:#fafafa}.mdc-select--filled:not(.mdc-select--disabled) .mdc-line-ripple:before{border-bottom-color:#0000006b}.mdc-select--filled:not(.mdc-select--disabled):hover .mdc-line-ripple:before{border-bottom-color:#000000de}.mdc-select--filled:not(.mdc-select--disabled) .mdc-line-ripple:after{border-bottom-color:#6200ee;border-bottom-color:var(--mdc-theme-primary,#6200ee)}.mdc-select--filled.mdc-select--disabled .mdc-line-ripple:before{border-bottom-color:#0000000f}.mdc-select--filled .mdc-floating-label{max-width:calc(100% - 64px)}.mdc-select--filled .mdc-floating-label--float-above{max-width:calc(133.333% - 85.3333px)}.mdc-select--filled .mdc-menu-surface--is-open-below{border-top-left-radius:0;border-top-right-radius:0}.mdc-select--filled.mdc-select--focused.mdc-line-ripple:after{opacity:1;transform:scaleY(2)}.mdc-select--filled .mdc-floating-label{left:16px;right:initial}[dir=rtl] .mdc-select--filled .mdc-floating-label,.mdc-select--filled .mdc-floating-label[dir=rtl]{left:initial;right:16px}.mdc-select--filled.mdc-select--with-leading-icon .mdc-floating-label{left:48px;right:initial}[dir=rtl] .mdc-select--filled.mdc-select--with-leading-icon .mdc-floating-label,.mdc-select--filled.mdc-select--with-leading-icon .mdc-floating-label[dir=rtl]{left:initial;right:48px}.mdc-select--filled.mdc-select--with-leading-icon .mdc-floating-label{max-width:calc(100% - 96px)}.mdc-select--filled.mdc-select--with-leading-icon .mdc-floating-label--float-above{max-width:calc(133.333% - 128px)}.mdc-select--invalid:not(.mdc-select--disabled) .mdc-line-ripple:before,.mdc-select--invalid:not(.mdc-select--disabled):hover .mdc-line-ripple:before,.mdc-select--invalid:not(.mdc-select--disabled) .mdc-line-ripple:after{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error,#b00020)}.mdc-select--outlined{border:none}.mdc-select--outlined .mdc-select__anchor{height:56px}@keyframes mdc-floating-label-shake-float-above-select-outlined-56px{0%{transform:translate(0)translateY(-34.75px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(4%)translateY(-34.75px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(-4%)translateY(-34.75px)scale(.75)}to{transform:translate(0)translateY(-34.75px)scale(.75)}}.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__leading{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small,4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small,4px)}[dir=rtl] .mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__leading[dir=rtl]{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small,4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small,4px);border-bottom-left-radius:0}@supports (top:max(0%)){.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__leading{width:max(12px,var(--mdc-shape-small,4px))}.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__notch{max-width:calc(100% - max(12px,var(--mdc-shape-small,4px))*2)}}.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__trailing{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small,4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small,4px);border-bottom-left-radius:0}[dir=rtl] .mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__trailing,.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__trailing[dir=rtl]{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small,4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small,4px)}@supports (top:max(0%)){.mdc-select--outlined .mdc-select__anchor{padding-left:max(16px,calc(var(--mdc-shape-small,4px) + 4px))}}[dir=rtl] .mdc-select--outlined .mdc-select__anchor,.mdc-select--outlined .mdc-select__anchor[dir=rtl]{padding-left:0}@supports (top:max(0%)){[dir=rtl] .mdc-select--outlined .mdc-select__anchor,.mdc-select--outlined .mdc-select__anchor[dir=rtl]{padding-right:max(16px,calc(var(--mdc-shape-small,4px) + 4px))}.mdc-select--outlined+.mdc-select-helper-text{margin-left:max(16px,calc(var(--mdc-shape-small,4px) + 4px))}}[dir=rtl] .mdc-select--outlined+.mdc-select-helper-text,.mdc-select--outlined+.mdc-select-helper-text[dir=rtl]{margin-left:0}@supports (top:max(0%)){[dir=rtl] .mdc-select--outlined+.mdc-select-helper-text,.mdc-select--outlined+.mdc-select-helper-text[dir=rtl]{margin-right:max(16px,calc(var(--mdc-shape-small,4px) + 4px))}}.mdc-select--outlined:not(.mdc-select--disabled) .mdc-select__anchor,.mdc-select--outlined.mdc-select--disabled .mdc-select__anchor{background-color:#0000}.mdc-select--outlined:not(.mdc-select--disabled) .mdc-notched-outline__leading,.mdc-select--outlined:not(.mdc-select--disabled) .mdc-notched-outline__notch,.mdc-select--outlined:not(.mdc-select--disabled) .mdc-notched-outline__trailing{border-color:#00000061}.mdc-select--outlined:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__notch,.mdc-select--outlined:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__trailing{border-color:#000000de}.mdc-select--outlined:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__notch,.mdc-select--outlined:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__trailing{border-width:2px;border-color:#6200ee;border-color:var(--mdc-theme-primary,#6200ee)}.mdc-select--outlined.mdc-select--disabled .mdc-notched-outline__leading,.mdc-select--outlined.mdc-select--disabled .mdc-notched-outline__notch,.mdc-select--outlined.mdc-select--disabled .mdc-notched-outline__trailing{border-color:#0000000f}.mdc-select--outlined .mdc-select__anchor :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 60px)}.mdc-select--outlined .mdc-select__anchor{align-items:baseline;display:flex;overflow:visible}.mdc-select--outlined .mdc-select__anchor .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-select-outlined}.mdc-select--outlined .mdc-select__anchor .mdc-floating-label--float-above{font-size:.75rem;transform:translateY(-37.25px)scale(1)}.mdc-select--outlined .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem;transform:translateY(-34.75px)scale(.75)}.mdc-select--outlined .mdc-select__anchor .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:1px}.mdc-select--outlined .mdc-select__anchor .mdc-select__selected-text:before{content:\"​\"}.mdc-select--outlined .mdc-select__anchor .mdc-select__selected-text-container{align-items:center;height:100%;display:inline-flex}.mdc-select--outlined .mdc-select__anchor:before{display:none}.mdc-select--outlined .mdc-select__selected-text-container{z-index:1;background-color:#0000;border:none;display:flex}.mdc-select--outlined .mdc-select__icon{z-index:2}.mdc-select--outlined .mdc-floating-label{left:4px;right:initial;line-height:1.15rem}[dir=rtl] .mdc-select--outlined .mdc-floating-label,.mdc-select--outlined .mdc-floating-label[dir=rtl]{left:initial;right:4px}.mdc-select--outlined.mdc-select--focused .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:2px}.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled) .mdc-notched-outline__leading,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled) .mdc-notched-outline__notch,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled) .mdc-notched-outline__trailing,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__notch,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__trailing{border-color:#b00020;border-color:var(--mdc-theme-error,#b00020)}.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__notch,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__trailing{border-width:2px;border-color:#b00020;border-color:var(--mdc-theme-error,#b00020)}.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label{left:36px;right:initial}[dir=rtl] .mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label,.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label[dir=rtl]{left:initial;right:36px}.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--float-above{transform:translateY(-37.25px)translate(-32px)scale(1)}[dir=rtl] .mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--float-above,.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--float-above[dir=rtl]{transform:translateY(-37.25px)translate(32px)scale(1)}.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--float-above{font-size:.75rem}.mdc-select--outlined.mdc-select--with-leading-icon.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined.mdc-select--with-leading-icon .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-34.75px)translate(-32px)scale(.75)}[dir=rtl] .mdc-select--outlined.mdc-select--with-leading-icon.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined.mdc-select--with-leading-icon.mdc-notched-outline--upgraded .mdc-floating-label--float-above[dir=rtl],[dir=rtl] .mdc-select--outlined.mdc-select--with-leading-icon .mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined.mdc-select--with-leading-icon .mdc-notched-outline--upgraded .mdc-floating-label--float-above[dir=rtl]{transform:translateY(-34.75px)translate(32px)scale(.75)}.mdc-select--outlined.mdc-select--with-leading-icon.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined.mdc-select--with-leading-icon .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-select-outlined-leading-icon-56px}@keyframes mdc-floating-label-shake-float-above-select-outlined-leading-icon-56px{0%{transform:translate(calc(0 - 32px))translateY(-34.75px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(calc(4% - 32px))translateY(-34.75px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(calc(-4% - 32px))translateY(-34.75px)scale(.75)}to{transform:translate(calc(0 - 32px))translateY(-34.75px)scale(.75)}}[dir=rtl] .mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--shake,.mdc-select--outlined.mdc-select--with-leading-icon[dir=rtl] .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-select-outlined-leading-icon-56px}@keyframes mdc-floating-label-shake-float-above-select-outlined-leading-icon-56px-rtl{0%{transform:translate(calc(0 + 32px))translateY(-34.75px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(calc(4% + 32px))translateY(-34.75px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(calc(32px - 4%))translateY(-34.75px)scale(.75)}to{transform:translate(calc(0 + 32px))translateY(-34.75px)scale(.75)}}.mdc-select--outlined.mdc-select--with-leading-icon .mdc-select__anchor :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 96px)}.mdc-select--outlined .mdc-menu-surface{margin-bottom:8px}.mdc-select--outlined.mdc-select--no-label .mdc-menu-surface,.mdc-select--outlined .mdc-menu-surface--is-open-below{margin-bottom:0}.mdc-select__anchor{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-select__anchor .mdc-select__ripple:before,.mdc-select__anchor .mdc-select__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-select__anchor .mdc-select__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-select__anchor .mdc-select__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-select__anchor.mdc-ripple-upgraded .mdc-select__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-select__anchor.mdc-ripple-upgraded .mdc-select__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-select__anchor.mdc-ripple-upgraded--unbounded .mdc-select__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-select__anchor.mdc-ripple-upgraded--foreground-activation .mdc-select__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-select__anchor.mdc-ripple-upgraded--foreground-deactivation .mdc-select__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-select__anchor .mdc-select__ripple:before,.mdc-select__anchor .mdc-select__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-select__anchor.mdc-ripple-upgraded .mdc-select__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-select__anchor .mdc-select__ripple:before,.mdc-select__anchor .mdc-select__ripple:after{background-color:#000000de;background-color:var(--mdc-ripple-color,#000000de)}.mdc-select__anchor:hover .mdc-select__ripple:before,.mdc-select__anchor.mdc-ripple-surface--hover .mdc-select__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-select__anchor.mdc-ripple-upgraded--background-focused .mdc-select__ripple:before,.mdc-select__anchor:not(.mdc-ripple-upgraded):focus .mdc-select__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-select__anchor .mdc-select__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected .mdc-deprecated-list-item__ripple:before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected .mdc-deprecated-list-item__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,var(--mdc-theme-on-surface,#000))}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:hover .mdc-deprecated-list-item__ripple:before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected.mdc-ripple-surface--hover .mdc-deprecated-list-item__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected.mdc-ripple-upgraded--background-focused .mdc-deprecated-list-item__ripple:before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):focus .mdc-deprecated-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded) .mdc-deprecated-list-item__ripple:after{transition:opacity .15s linear}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):active .mdc-deprecated-list-item__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected .mdc-list-item__ripple:before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected .mdc-list-item__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,var(--mdc-theme-on-surface,#000))}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:hover .mdc-list-item__ripple:before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected.mdc-ripple-surface--hover .mdc-list-item__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded) .mdc-list-item__ripple:after{transition:opacity .15s linear}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):active .mdc-list-item__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-select-helper-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-caption-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-caption-font-size,.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight,400);letter-spacing:.0333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing,.0333333em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform,inherit);margin:0 16px;line-height:normal;display:block}[dir=rtl] .mdc-select-helper-text,.mdc-select-helper-text[dir=rtl]{margin-left:16px;margin-right:16px}.mdc-select-helper-text:before{content:\"\";vertical-align:0;width:0;height:16px;display:inline-block}.mdc-select-helper-text--validation-msg{opacity:0;transition:opacity .18s cubic-bezier(.4,0,.2,1)}.mdc-select--invalid+.mdc-select-helper-text--validation-msg,.mdc-select-helper-text--validation-msg-persistent{opacity:1}.mdc-select--with-leading-icon .mdc-select__icon{box-sizing:border-box;cursor:pointer;-webkit-user-select:none;user-select:none;fill:currentColor;background-color:#0000;border:none;flex-shrink:0;align-self:center;margin-left:12px;margin-right:12px;text-decoration:none;display:inline-block}[dir=rtl] .mdc-select--with-leading-icon .mdc-select__icon,.mdc-select--with-leading-icon .mdc-select__icon[dir=rtl]{margin-left:12px;margin-right:12px}.mdc-select__icon:not([tabindex]),.mdc-select__icon[tabindex=\"-1\"]{cursor:default;pointer-events:none}.mdc-data-table__content{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit)}.mdc-data-table{background-color:#fff;background-color:var(--mdc-theme-surface,#fff);border-radius:4px;border-radius:var(--mdc-shape-medium,4px);-webkit-overflow-scrolling:touch;box-sizing:border-box;border:1px solid #0000001f;flex-direction:column;display:inline-flex;position:relative}.mdc-data-table .mdc-data-table__header-cell:first-child{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-medium,4px)}[dir=rtl] .mdc-data-table .mdc-data-table__header-cell:first-child,.mdc-data-table .mdc-data-table__header-cell:first-child[dir=rtl]{border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-medium,4px);border-top-left-radius:0}.mdc-data-table .mdc-data-table__header-cell:last-child{border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-medium,4px)}[dir=rtl] .mdc-data-table .mdc-data-table__header-cell:last-child,.mdc-data-table .mdc-data-table__header-cell:last-child[dir=rtl]{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-medium,4px);border-top-right-radius:0}.mdc-data-table__row{background-color:inherit}.mdc-data-table__header-cell{background-color:#fff;background-color:var(--mdc-theme-surface,#fff)}.mdc-data-table__row--selected{background-color:#6200ee0a}.mdc-data-table__header-cell:after{border-bottom-color:#0000001f}.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__leading,.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__notch,.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__trailing{border-color:#0000001f}.mdc-data-table__row,.mdc-data-table__pagination{border-top-color:#0000001f}.mdc-data-table__header-cell:after{border-bottom-style:solid;border-bottom-width:1px}.mdc-data-table__row,.mdc-data-table__pagination{border-top-style:solid;border-top-width:1px}.mdc-data-table__row:not(.mdc-data-table__row--selected):hover{background-color:#0000000a}.mdc-data-table__header-cell,.mdc-data-table__pagination-total,.mdc-data-table__pagination-rows-per-page-label,.mdc-data-table__cell{color:#000000de}.mdc-data-table__cell{height:52px}.mdc-data-table__pagination{min-height:52px}.mdc-data-table__header-cell{height:56px}.mdc-data-table__cell,.mdc-data-table__header-cell{padding-left:16px;padding-right:16px}.mdc-data-table__header-cell--checkbox,.mdc-data-table__cell--checkbox{padding-left:4px;padding-right:0}[dir=rtl] .mdc-data-table__header-cell--checkbox,.mdc-data-table__header-cell--checkbox[dir=rtl],[dir=rtl] .mdc-data-table__cell--checkbox,.mdc-data-table__cell--checkbox[dir=rtl]{padding-left:0;padding-right:4px}.mdc-data-table__sort-icon-button{color:#0009}.mdc-data-table__sort-icon-button:before,.mdc-data-table__sort-icon-button:after{background-color:#0009;background-color:var(--mdc-ripple-color,#0009)}.mdc-data-table__sort-icon-button:hover:before,.mdc-data-table__sort-icon-button.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused:before,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button{color:#000000de}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:after{background-color:#000000de;background-color:var(--mdc-ripple-color,#000000de)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:hover:before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused:before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-data-table__table-container{-webkit-overflow-scrolling:touch;width:100%;overflow-x:auto}.mdc-data-table__table{white-space:nowrap;border-collapse:collapse;table-layout:fixed;border:0;min-width:100%}.mdc-data-table__cell{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);box-sizing:border-box;text-align:left;text-overflow:ellipsis;overflow:hidden}[dir=rtl] .mdc-data-table__cell,.mdc-data-table__cell[dir=rtl],.mdc-data-table__cell--numeric{text-align:right}[dir=rtl] .mdc-data-table__cell--numeric,.mdc-data-table__cell--numeric[dir=rtl]{text-align:left}.mdc-data-table__cell--checkbox{width:1px}.mdc-data-table__header-cell{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-subtitle2-font-size,.875rem);line-height:1.375rem;line-height:var(--mdc-typography-subtitle2-line-height,1.375rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight,500);letter-spacing:.00714286em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing,.00714286em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform,inherit);box-sizing:border-box;text-overflow:ellipsis;text-align:left;outline:none;overflow:hidden}[dir=rtl] .mdc-data-table__header-cell,.mdc-data-table__header-cell[dir=rtl]{text-align:right}.mdc-data-table__header-cell--checkbox{width:1px}.mdc-data-table__header-cell--numeric{text-align:right}[dir=rtl] .mdc-data-table__header-cell--numeric,.mdc-data-table__header-cell--numeric[dir=rtl]{text-align:left}.mdc-data-table__sort-icon-button{opacity:0;width:28px;height:28px;margin-left:4px;margin-right:0;padding:2px;transition:transform .15s cubic-bezier(.4,0,.2,1);transform:rotate(.0001deg)}[dir=rtl] .mdc-data-table__sort-icon-button,.mdc-data-table__sort-icon-button[dir=rtl],.mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button{margin-left:0;margin-right:4px}[dir=rtl] .mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button,.mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button[dir=rtl]{margin-left:4px;margin-right:0}.mdc-data-table__header-cell--sorted-descending .mdc-data-table__sort-icon-button{transform:rotate(-180deg)}.mdc-data-table__sort-icon-button:focus,.mdc-data-table__header-cell:hover .mdc-data-table__sort-icon-button,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button{opacity:1}.mdc-data-table__header-cell-wrapper{vertical-align:middle;align-items:center;display:inline-flex}.mdc-data-table__header-cell--with-sort{cursor:pointer}.mdc-data-table__sort-status-label{clip:rect(1px,1px,1px,1px);white-space:nowrap;width:1px;height:1px;position:absolute;overflow:hidden}.mdc-data-table__progress-indicator{width:100%;display:none;position:absolute}.mdc-data-table--in-progress .mdc-data-table__progress-indicator{display:block}.mdc-data-table__scrim{background-color:#fff;background-color:var(--mdc-theme-surface,#fff);opacity:.32;width:100%;height:100%;position:absolute;top:0}.mdc-data-table--sticky-header .mdc-data-table__header-cell{z-index:1;position:sticky;top:0}.mdc-data-table--sticky-header .mdc-data-table__header-cell:after{content:\"\";width:100%;position:absolute;bottom:0;left:0}.mdc-data-table--sticky-header .mdc-data-table__row:first-child{border-top:0}.mdc-data-table__pagination{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);box-sizing:border-box;justify-content:flex-end;display:flex}.mdc-data-table__pagination-trailing{flex-wrap:wrap;justify-content:flex-end;align-items:center;margin-left:4px;margin-right:0;display:flex}[dir=rtl] .mdc-data-table__pagination-trailing,.mdc-data-table__pagination-trailing[dir=rtl]{margin-left:0;margin-right:4px}.mdc-data-table__pagination-navigation{align-items:center;display:flex}.mdc-data-table__pagination-button{margin-left:0;margin-right:4px}[dir=rtl] .mdc-data-table__pagination-button .mdc-button__icon,.mdc-data-table__pagination-button .mdc-button__icon[dir=rtl]{transform:rotate(180deg)}[dir=rtl] .mdc-data-table__pagination-button,.mdc-data-table__pagination-button[dir=rtl]{margin-left:4px;margin-right:0}.mdc-data-table__pagination-total{white-space:nowrap;margin-left:14px;margin-right:36px}[dir=rtl] .mdc-data-table__pagination-total,.mdc-data-table__pagination-total[dir=rtl]{margin-left:36px;margin-right:14px}.mdc-data-table__pagination-rows-per-page{align-items:center;margin-left:0;margin-right:22px;display:inline-flex}[dir=rtl] .mdc-data-table__pagination-rows-per-page,.mdc-data-table__pagination-rows-per-page[dir=rtl]{margin-left:22px;margin-right:0}.mdc-data-table__pagination-rows-per-page-label{white-space:nowrap;margin-left:0;margin-right:12px}[dir=rtl] .mdc-data-table__pagination-rows-per-page-label,.mdc-data-table__pagination-rows-per-page-label[dir=rtl]{margin-left:12px;margin-right:0}.mdc-data-table__pagination-rows-per-page-select{min-width:var(--mdc-menu-min-width,80px);min-width:80px;margin:8px 0}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor{width:100%;min-width:80px;height:36px}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--float-above{font-size:.75rem;transform:translateY(-27.25px)scale(1)}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem;transform:translateY(-24.75px)scale(.75)}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-select-outlined-36px}@keyframes mdc-floating-label-shake-float-above-select-outlined-36px{0%{transform:translate(0)translateY(-24.75px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(4%)translateY(-24.75px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(-4%)translateY(-24.75px)scale(.75)}to{transform:translate(0)translateY(-24.75px)scale(.75)}}.mdc-data-table__pagination-rows-per-page-select .mdc-select__dropdown-icon{width:20px;height:20px}.mdc-data-table__pagination-rows-per-page-select.mdc-select--outlined .mdc-select__anchor :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 56px)}.mdc-data-table__pagination-rows-per-page-select .mdc-deprecated-list-item{height:36px}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple:before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple:after,.mdc-data-table__row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple:before,.mdc-data-table__row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple:before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple:before,.mdc-data-table__row-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple:before,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple:before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple:before,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple:before,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple:after,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple:after{transition:opacity .15s linear}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple:after,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-data-table__header-row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple:before,.mdc-data-table__header-row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple:after,.mdc-data-table__row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple:before,.mdc-data-table__row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:#0000008a;border-color:var(--mdc-checkbox-unchecked-color,#0000008a);background-color:#0000}.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#6200ee))}@keyframes mdc-checkbox-fade-in-background-8A000000FF6200EE00000000FF6200EE{0%{border-color:#0000008a;border-color:var(--mdc-checkbox-unchecked-color,#0000008a);background-color:#0000}50%{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#6200ee))}}@keyframes mdc-checkbox-fade-out-background-8A000000FF6200EE00000000FF6200EE{0%,80%{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#6200ee))}to{border-color:#0000008a;border-color:var(--mdc-checkbox-unchecked-color,#0000008a);background-color:#0000}}.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-in-background-8A000000FF6200EE00000000FF6200EE}.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-out-background-8A000000FF6200EE00000000FF6200EE}.mdc-dialog,.mdc-dialog__scrim{box-sizing:border-box;justify-content:center;align-items:center;width:100%;height:100%;position:fixed;top:0;left:0}.mdc-dialog{z-index:7;z-index:var(--mdc-dialog-z-index,7);display:none}.mdc-dialog .mdc-dialog__surface{background-color:#fff;background-color:var(--mdc-theme-surface,#fff)}.mdc-dialog .mdc-dialog__scrim,.mdc-dialog .mdc-dialog__surface-scrim{background-color:#00000052}.mdc-dialog .mdc-dialog__title{color:#000000de}.mdc-dialog .mdc-dialog__content{color:#0009}.mdc-dialog .mdc-dialog__close{color:var(--mdc-theme-on-surface,#000)}.mdc-dialog .mdc-dialog__close:before,.mdc-dialog .mdc-dialog__close:after{background-color:#000;background-color:var(--mdc-ripple-color,var(--mdc-theme-on-surface,#000))}.mdc-dialog .mdc-dialog__close:hover:before,.mdc-dialog .mdc-dialog__close.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-dialog .mdc-dialog__close.mdc-ripple-upgraded--background-focused:before,.mdc-dialog .mdc-dialog__close:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-dialog .mdc-dialog__close:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-dialog .mdc-dialog__close:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-dialog .mdc-dialog__close.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-dialog.mdc-dialog--scrollable .mdc-dialog__title,.mdc-dialog.mdc-dialog--scrollable .mdc-dialog__actions,.mdc-dialog.mdc-dialog--scrollable.mdc-dialog-scroll-divider-footer .mdc-dialog__actions{border-color:#0000001f}.mdc-dialog.mdc-dialog--scrollable .mdc-dialog__title{border-bottom:1px solid #0000001f;margin-bottom:0}.mdc-dialog.mdc-dialog-scroll-divider-header.mdc-dialog--fullscreen .mdc-dialog__header{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mdc-dialog .mdc-dialog__content{padding:20px 24px}.mdc-dialog .mdc-dialog__surface{min-width:280px}@media (width<=592px){.mdc-dialog .mdc-dialog__surface{max-width:calc(100vw - 32px)}}@media (width>=592px){.mdc-dialog .mdc-dialog__surface{max-width:560px}}.mdc-dialog .mdc-dialog__surface{border-radius:4px;border-radius:var(--mdc-shape-medium,4px);max-height:calc(100% - 32px)}@media (width<=960px) and (height<=1440px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-width:560px;max-height:560px}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{right:-12px}}@media (width<=720px) and (height<=1023px) and (width<=672px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-width:calc(100vw - 112px)}}@media (width<=720px) and (height<=1023px) and (width>=672px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-width:560px}}@media (width<=720px) and (height<=1023px) and (height<=720px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-height:calc(100vh - 160px)}}@media (width<=720px) and (height<=1023px) and (height>=720px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-height:560px}}@media (width<=720px) and (height<=1023px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{right:-12px}}@media (width<=720px) and (height<=400px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{border-radius:0;width:100vw;max-width:100vw;height:100vh;max-height:100vh}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{order:-1;left:-12px}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__header{justify-content:flex-start;padding:0 16px 9px}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__title{margin-left:-8px}}@media (width<=600px) and (height<=960px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{border-radius:0;width:100vw;max-width:100vw;height:100vh;max-height:100vh}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{order:-1;left:-12px}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__header{justify-content:flex-start;padding:0 16px 9px}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__title{margin-left:-8px}}@media (width>=960px) and (height>=1440px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-width:calc(100vw - 400px)}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{right:-12px}}.mdc-dialog.mdc-dialog__scrim--hidden .mdc-dialog__scrim{opacity:0}.mdc-dialog__scrim{opacity:0;z-index:-1}.mdc-dialog__container{box-sizing:border-box;opacity:0;pointer-events:none;flex-direction:row;justify-content:space-around;align-items:center;height:100%;display:flex;transform:scale(.8)}.mdc-dialog__surface{box-sizing:border-box;pointer-events:auto;flex-direction:column;flex-grow:0;flex-shrink:0;max-width:100%;max-height:100%;display:flex;position:relative;overflow-y:auto;box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f}.mdc-dialog__surface .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}[dir=rtl] .mdc-dialog__surface,.mdc-dialog__surface[dir=rtl]{text-align:right}@media screen and (-ms-high-contrast:active){.mdc-dialog__surface{outline:2px solid windowtext}}.mdc-dialog__surface:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:2px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}@media screen and (-ms-high-contrast:active),screen and (-ms-high-contrast:none){.mdc-dialog__surface:before{content:none}}.mdc-dialog__title{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;line-height:normal;font-family:var(--mdc-typography-headline6-font-family,var(--mdc-typography-font-family,inherit));font-size:1.25rem;font-size:var(--mdc-typography-headline6-font-size,1.25rem);line-height:2rem;line-height:var(--mdc-typography-headline6-line-height,2rem);font-weight:500;font-weight:var(--mdc-typography-headline6-font-weight,500);letter-spacing:.0125em;letter-spacing:var(--mdc-typography-headline6-letter-spacing,.0125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline6-text-transform,inherit);box-sizing:border-box;flex-shrink:0;margin:0 0 1px;padding:0 24px 9px;display:block;position:relative}.mdc-dialog__title:before{content:\"\";vertical-align:0;width:0;height:40px;display:inline-block}[dir=rtl] .mdc-dialog__title,.mdc-dialog__title[dir=rtl]{text-align:right}.mdc-dialog--scrollable .mdc-dialog__title{margin-bottom:1px;padding-bottom:15px}.mdc-dialog--fullscreen .mdc-dialog__header{border-bottom:1px solid #0000;justify-content:space-between;align-items:baseline;padding:0 24px 9px;display:inline-flex}.mdc-dialog--fullscreen .mdc-dialog__header .mdc-dialog__close{right:-12px}.mdc-dialog--fullscreen .mdc-dialog__title{border-bottom:0;margin-bottom:0;padding:0}.mdc-dialog--fullscreen.mdc-dialog--scrollable .mdc-dialog__title{border-bottom:0;margin-bottom:0}.mdc-dialog--fullscreen .mdc-dialog__close{top:5px}.mdc-dialog--fullscreen.mdc-dialog--scrollable .mdc-dialog__actions{border-top:1px solid #0000}.mdc-dialog__content{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-body1-font-size,1rem);line-height:1.5rem;line-height:var(--mdc-typography-body1-line-height,1.5rem);font-weight:400;font-weight:var(--mdc-typography-body1-font-weight,400);letter-spacing:.03125em;letter-spacing:var(--mdc-typography-body1-letter-spacing,.03125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body1-text-transform,inherit);box-sizing:border-box;-webkit-overflow-scrolling:touch;flex-grow:1;margin:0;overflow:auto}.mdc-dialog__content>:first-child{margin-top:0}.mdc-dialog__content>:last-child{margin-bottom:0}.mdc-dialog__title+.mdc-dialog__content,.mdc-dialog__header+.mdc-dialog__content{padding-top:0}.mdc-dialog--scrollable .mdc-dialog__title+.mdc-dialog__content{padding-top:8px;padding-bottom:8px}.mdc-dialog__content .mdc-deprecated-list:first-child:last-child{padding:6px 0 0}.mdc-dialog--scrollable .mdc-dialog__content .mdc-deprecated-list:first-child:last-child{padding:0}.mdc-dialog__actions{box-sizing:border-box;border-top:1px solid #0000;flex-wrap:wrap;flex-shrink:0;justify-content:flex-end;align-items:center;min-height:52px;margin:0;padding:8px;display:flex;position:relative}.mdc-dialog--stacked .mdc-dialog__actions{flex-direction:column;align-items:flex-end}.mdc-dialog__button{text-align:right;max-width:100%;margin-left:8px;margin-right:0}[dir=rtl] .mdc-dialog__button,.mdc-dialog__button[dir=rtl]{margin-left:0;margin-right:8px}.mdc-dialog__button:first-child,[dir=rtl] .mdc-dialog__button:first-child,.mdc-dialog__button:first-child[dir=rtl]{margin-left:0;margin-right:0}[dir=rtl] .mdc-dialog__button,.mdc-dialog__button[dir=rtl]{text-align:left}.mdc-dialog--stacked .mdc-dialog__button:not(:first-child){margin-top:12px}.mdc-dialog--open,.mdc-dialog--opening,.mdc-dialog--closing{display:flex}.mdc-dialog--opening .mdc-dialog__scrim{transition:opacity .15s linear}.mdc-dialog--opening .mdc-dialog__container{transition:opacity 75ms linear,transform .15s cubic-bezier(0,0,.2,1)}.mdc-dialog--closing .mdc-dialog__scrim,.mdc-dialog--closing .mdc-dialog__container{transition:opacity 75ms linear}.mdc-dialog--closing .mdc-dialog__container{transform:none}.mdc-dialog--open .mdc-dialog__scrim{opacity:1}.mdc-dialog--open .mdc-dialog__container{opacity:1;transform:none}.mdc-dialog--open.mdc-dialog__surface-scrim--shown .mdc-dialog__surface-scrim{opacity:1;z-index:1}.mdc-dialog--open.mdc-dialog__surface-scrim--hiding .mdc-dialog__surface-scrim{transition:opacity 75ms linear}.mdc-dialog--open.mdc-dialog__surface-scrim--showing .mdc-dialog__surface-scrim{transition:opacity .15s linear}.mdc-dialog__surface-scrim{opacity:0;width:100%;height:100%;display:none;position:absolute}.mdc-dialog__surface-scrim--shown .mdc-dialog__surface-scrim,.mdc-dialog__surface-scrim--showing .mdc-dialog__surface-scrim,.mdc-dialog__surface-scrim--hiding .mdc-dialog__surface-scrim{display:block}.mdc-dialog-scroll-lock{overflow:hidden}.mdc-drawer{background-color:#fff;background-color:var(--mdc-theme-surface,#fff);border-top-left-radius:0;border-top-right-radius:0;border-top-right-radius:var(--mdc-shape-large,0);border-bottom-right-radius:0;border-bottom-right-radius:var(--mdc-shape-large,0);z-index:6;box-sizing:border-box;border-color:#0000001f;border-right-style:solid;border-right-width:1px;border-bottom-left-radius:0;flex-direction:column;flex-shrink:0;width:256px;height:100%;transition-property:transform;transition-timing-function:cubic-bezier(.4,0,.2,1);display:flex;overflow:hidden}.mdc-drawer .mdc-drawer__title{color:#000000de}.mdc-drawer .mdc-deprecated-list-group__subheader,.mdc-drawer .mdc-drawer__subtitle,.mdc-drawer .mdc-deprecated-list-item__graphic{color:#0009}.mdc-drawer .mdc-deprecated-list-item{color:#000000de}.mdc-drawer .mdc-deprecated-list-item--activated .mdc-deprecated-list-item__graphic{color:#6200ee}.mdc-drawer .mdc-deprecated-list-item--activated{color:#6200eede}[dir=rtl] .mdc-drawer,.mdc-drawer[dir=rtl]{border-top-left-radius:0;border-top-left-radius:var(--mdc-shape-large,0);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-bottom-left-radius:var(--mdc-shape-large,0)}.mdc-drawer .mdc-deprecated-list-item{border-radius:4px;border-radius:var(--mdc-shape-small,4px)}.mdc-drawer.mdc-drawer--open:not(.mdc-drawer--closing)+.mdc-drawer-app-content{margin-left:256px;margin-right:0}[dir=rtl] .mdc-drawer.mdc-drawer--open:not(.mdc-drawer--closing)+.mdc-drawer-app-content,.mdc-drawer.mdc-drawer--open:not(.mdc-drawer--closing)+.mdc-drawer-app-content[dir=rtl]{margin-left:0;margin-right:256px}[dir=rtl] .mdc-drawer,.mdc-drawer[dir=rtl]{border-left-style:solid;border-left-width:1px;border-right-style:none;border-right-width:0}.mdc-drawer .mdc-deprecated-list-item{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-subtitle2-font-size,.875rem);line-height:1.375rem;line-height:var(--mdc-typography-subtitle2-line-height,1.375rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight,500);letter-spacing:.00714286em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing,.00714286em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform,inherit);height:40px;margin:8px;padding:0 8px}.mdc-drawer .mdc-deprecated-list-item:first-child{margin-top:2px}.mdc-drawer .mdc-deprecated-list-item:last-child{margin-bottom:0}.mdc-drawer .mdc-deprecated-list-group__subheader{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);margin:0;padding:0 16px;line-height:normal;display:block}.mdc-drawer .mdc-deprecated-list-group__subheader:before{content:\"\";vertical-align:0;width:0;height:24px;display:inline-block}.mdc-drawer .mdc-deprecated-list-divider{margin:3px 0 4px}.mdc-drawer .mdc-deprecated-list-item__text,.mdc-drawer .mdc-deprecated-list-item__graphic{pointer-events:none}.mdc-drawer--animate{transform:translate(-100%)}[dir=rtl] .mdc-drawer--animate,.mdc-drawer--animate[dir=rtl]{transform:translate(100%)}.mdc-drawer--opening{transition-duration:.25s;transform:translate(0)}[dir=rtl] .mdc-drawer--opening,.mdc-drawer--opening[dir=rtl]{transform:translate(0)}.mdc-drawer--closing{transition-duration:.2s;transform:translate(-100%)}[dir=rtl] .mdc-drawer--closing,.mdc-drawer--closing[dir=rtl]{transform:translate(100%)}.mdc-drawer__header{box-sizing:border-box;flex-shrink:0;min-height:64px;padding:0 16px 4px}.mdc-drawer__title{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline6-font-family,var(--mdc-typography-font-family,inherit));font-size:1.25rem;font-size:var(--mdc-typography-headline6-font-size,1.25rem);line-height:2rem;line-height:var(--mdc-typography-headline6-line-height,2rem);font-weight:500;font-weight:var(--mdc-typography-headline6-font-weight,500);letter-spacing:.0125em;letter-spacing:var(--mdc-typography-headline6-letter-spacing,.0125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline6-text-transform,inherit);margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-drawer__title:before{content:\"\";vertical-align:0;width:0;height:36px;display:inline-block}.mdc-drawer__title:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-drawer__subtitle{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);margin-top:0;margin-bottom:0;line-height:normal;display:block}.mdc-drawer__subtitle:before{content:\"\";vertical-align:0;width:0;height:20px;display:inline-block}.mdc-drawer__content{-webkit-overflow-scrolling:touch;height:100%;overflow-y:auto}.mdc-drawer--dismissible{left:0;right:initial;display:none;position:absolute}[dir=rtl] .mdc-drawer--dismissible,.mdc-drawer--dismissible[dir=rtl]{left:initial;right:0}.mdc-drawer--dismissible.mdc-drawer--open{display:flex}.mdc-drawer-app-content{margin-left:0;margin-right:0;position:relative}[dir=rtl] .mdc-drawer-app-content,.mdc-drawer-app-content[dir=rtl]{margin-left:0;margin-right:0}.mdc-drawer--modal{left:0;right:initial;display:none;position:fixed;box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f}.mdc-drawer--modal+.mdc-drawer-scrim{background-color:#00000052}[dir=rtl] .mdc-drawer--modal,.mdc-drawer--modal[dir=rtl]{left:initial;right:0}.mdc-drawer--modal.mdc-drawer--open{display:flex}.mdc-drawer-scrim{z-index:5;width:100%;height:100%;transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1);display:none;position:fixed;top:0;left:0}.mdc-drawer--open+.mdc-drawer-scrim{display:block}.mdc-drawer--animate+.mdc-drawer-scrim{opacity:0}.mdc-drawer--opening+.mdc-drawer-scrim{opacity:1;transition-duration:.25s}.mdc-drawer--closing+.mdc-drawer-scrim{opacity:0;transition-duration:.2s}.mdc-elevation--z0{box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mdc-elevation--z1{box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.mdc-elevation--z2{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mdc-elevation--z3{box-shadow:0 3px 3px -2px #0003,0 3px 4px #00000024,0 1px 8px #0000001f}.mdc-elevation--z4{box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mdc-elevation--z5{box-shadow:0 3px 5px -1px #0003,0 5px 8px #00000024,0 1px 14px #0000001f}.mdc-elevation--z6{box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mdc-elevation--z7{box-shadow:0 4px 5px -2px #0003,0 7px 10px 1px #00000024,0 2px 16px 1px #0000001f}.mdc-elevation--z8{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.mdc-elevation--z9{box-shadow:0 5px 6px -3px #0003,0 9px 12px 1px #00000024,0 3px 16px 2px #0000001f}.mdc-elevation--z10{box-shadow:0 6px 6px -3px #0003,0 10px 14px 1px #00000024,0 4px 18px 3px #0000001f}.mdc-elevation--z11{box-shadow:0 6px 7px -4px #0003,0 11px 15px 1px #00000024,0 4px 20px 3px #0000001f}.mdc-elevation--z12{box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}.mdc-elevation--z13{box-shadow:0 7px 8px -4px #0003,0 13px 19px 2px #00000024,0 5px 24px 4px #0000001f}.mdc-elevation--z14{box-shadow:0 7px 9px -4px #0003,0 14px 21px 2px #00000024,0 5px 26px 4px #0000001f}.mdc-elevation--z15{box-shadow:0 8px 9px -5px #0003,0 15px 22px 2px #00000024,0 6px 28px 5px #0000001f}.mdc-elevation--z16{box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f}.mdc-elevation--z17{box-shadow:0 8px 11px -5px #0003,0 17px 26px 2px #00000024,0 6px 32px 5px #0000001f}.mdc-elevation--z18{box-shadow:0 9px 11px -5px #0003,0 18px 28px 2px #00000024,0 7px 34px 6px #0000001f}.mdc-elevation--z19{box-shadow:0 9px 12px -6px #0003,0 19px 29px 2px #00000024,0 7px 36px 6px #0000001f}.mdc-elevation--z20{box-shadow:0 10px 13px -6px #0003,0 20px 31px 3px #00000024,0 8px 38px 7px #0000001f}.mdc-elevation--z21{box-shadow:0 10px 13px -6px #0003,0 21px 33px 3px #00000024,0 8px 40px 7px #0000001f}.mdc-elevation--z22{box-shadow:0 10px 14px -6px #0003,0 22px 35px 3px #00000024,0 8px 42px 7px #0000001f}.mdc-elevation--z23{box-shadow:0 11px 14px -7px #0003,0 23px 36px 3px #00000024,0 9px 44px 8px #0000001f}.mdc-elevation--z24{box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f}.mdc-elevation-transition{will-change:box-shadow;transition:box-shadow .28s cubic-bezier(.4,0,.2,1)}.mdc-fab{box-sizing:border-box;fill:currentColor;cursor:pointer;-webkit-user-select:none;user-select:none;-webkit-appearance:none;-moz-appearance:none;background-color:#018786;background-color:var(--mdc-theme-secondary,#018786);border:none;justify-content:center;align-items:center;width:56px;height:56px;padding:0;text-decoration:none;transition:box-shadow .28s cubic-bezier(.4,0,.2,1),opacity 15ms linear 30ms,transform .27s cubic-bezier(0,0,.2,1);display:inline-flex;position:relative;overflow:visible;box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mdc-fab .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-fab::-moz-focus-inner{border:0;padding:0}.mdc-fab:hover,.mdc-fab.mdc-ripple-upgraded--background-focused,.mdc-fab:not(.mdc-ripple-upgraded):focus{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.mdc-fab:active,.mdc-fab:focus:active{box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}.mdc-fab:active,.mdc-fab:focus{outline:none}.mdc-fab:hover{cursor:pointer}.mdc-fab>svg{width:100%}.mdc-fab .mdc-fab__icon{width:24px;height:24px;font-size:24px}.mdc-fab,.mdc-fab:not(:disabled) .mdc-fab__icon,.mdc-fab:not(:disabled) .mdc-fab__label,.mdc-fab:disabled .mdc-fab__icon,.mdc-fab:disabled .mdc-fab__label{color:var(--mdc-theme-on-secondary,#fff)}.mdc-fab:not(.mdc-fab--extended),.mdc-fab:not(.mdc-fab--extended) .mdc-fab__ripple{border-radius:50%}.mdc-fab--mini{width:40px;height:40px}.mdc-fab--extended{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-button-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-button-font-size,.875rem);line-height:2.25rem;line-height:var(--mdc-typography-button-line-height,2.25rem);font-weight:500;font-weight:var(--mdc-typography-button-font-weight,500);letter-spacing:.0892857em;letter-spacing:var(--mdc-typography-button-letter-spacing,.0892857em);text-decoration:none;-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);text-decoration:var(--mdc-typography-button-text-decoration,none);text-transform:uppercase;text-transform:var(--mdc-typography-button-text-transform,uppercase);border-radius:24px;width:auto;max-width:100%;height:48px;padding-left:20px;padding-right:20px;line-height:normal}.mdc-fab--extended .mdc-fab__ripple{border-radius:24px}.mdc-fab--extended .mdc-fab__icon{margin-left:-8px;margin-right:12px}[dir=rtl] .mdc-fab--extended .mdc-fab__icon,.mdc-fab--extended .mdc-fab__icon[dir=rtl],.mdc-fab--extended .mdc-fab__label+.mdc-fab__icon{margin-left:12px;margin-right:-8px}[dir=rtl] .mdc-fab--extended .mdc-fab__label+.mdc-fab__icon,.mdc-fab--extended .mdc-fab__label+.mdc-fab__icon[dir=rtl]{margin-left:-8px;margin-right:12px}.mdc-fab--touch{margin:4px}.mdc-fab--touch .mdc-fab__touch{width:48px;height:48px;position:absolute;top:50%;left:50%;right:0;transform:translate(-50%,-50%)}.mdc-fab:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:1px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-fab__label{text-overflow:ellipsis;white-space:nowrap;justify-content:flex-start;overflow:hidden visible}.mdc-fab__icon{fill:currentColor;will-change:transform;transition:transform .18s cubic-bezier(0,0,.2,1) 90ms}.mdc-fab .mdc-fab__icon{justify-content:center;align-items:center;display:inline-flex}.mdc-fab--exited{opacity:0;transition:opacity 15ms linear .15s,transform .18s cubic-bezier(.4,0,1,1);transform:scale(0)}.mdc-fab--exited .mdc-fab__icon{transition:transform .135s cubic-bezier(.4,0,1,1);transform:scale(0)}.mdc-fab{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-fab .mdc-fab__ripple:before,.mdc-fab .mdc-fab__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-fab .mdc-fab__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-fab .mdc-fab__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-fab.mdc-ripple-upgraded .mdc-fab__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-fab.mdc-ripple-upgraded .mdc-fab__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-fab.mdc-ripple-upgraded--unbounded .mdc-fab__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-fab.mdc-ripple-upgraded--foreground-activation .mdc-fab__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-fab.mdc-ripple-upgraded--foreground-deactivation .mdc-fab__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-fab .mdc-fab__ripple:before,.mdc-fab .mdc-fab__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-fab.mdc-ripple-upgraded .mdc-fab__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-fab .mdc-fab__ripple:before,.mdc-fab .mdc-fab__ripple:after{background-color:#fff;background-color:var(--mdc-ripple-color,var(--mdc-theme-on-secondary,#fff))}.mdc-fab .mdc-fab__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0;overflow:hidden}.mdc-fab{z-index:0}.mdc-fab .mdc-fab__ripple:before,.mdc-fab .mdc-fab__ripple:after{z-index:-1;z-index:var(--mdc-ripple-z-index,-1)}.mdc-form-field{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);color:var(--mdc-theme-text-primary-on-background,#000000de);vertical-align:middle;align-items:center;display:inline-flex}.mdc-form-field>label{order:0;margin-left:0;margin-right:auto;padding-left:4px;padding-right:0}[dir=rtl] .mdc-form-field>label,.mdc-form-field>label[dir=rtl]{margin-left:auto;margin-right:0;padding-left:0;padding-right:4px}.mdc-form-field--nowrap>label{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.mdc-form-field--align-end>label{order:-1;margin-left:auto;margin-right:0;padding-left:0;padding-right:4px}[dir=rtl] .mdc-form-field--align-end>label,.mdc-form-field--align-end>label[dir=rtl]{margin-left:0;margin-right:auto;padding-left:4px;padding-right:0}.mdc-form-field--space-between{justify-content:space-between}.mdc-form-field--space-between>label,[dir=rtl] .mdc-form-field--space-between>label,.mdc-form-field--space-between>label[dir=rtl]{margin:0}.mdc-icon-button{box-sizing:border-box;fill:currentColor;color:inherit;cursor:pointer;-webkit-user-select:none;user-select:none;background-color:#0000;border:none;outline:none;width:48px;height:48px;padding:12px;font-size:24px;text-decoration:none;display:inline-block;position:relative}.mdc-icon-button svg,.mdc-icon-button img{width:24px;height:24px}.mdc-icon-button:disabled{color:var(--mdc-theme-text-disabled-on-light,#00000061);cursor:default;pointer-events:none}.mdc-icon-button__icon{display:inline-block}.mdc-icon-button__icon.mdc-icon-button__icon--on,.mdc-icon-button--on .mdc-icon-button__icon{display:none}.mdc-icon-button--on .mdc-icon-button__icon.mdc-icon-button__icon--on{display:inline-block}.mdc-icon-button{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-icon-button:before,.mdc-icon-button:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-icon-button:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-icon-button:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-icon-button.mdc-ripple-upgraded:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-icon-button.mdc-ripple-upgraded:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-icon-button.mdc-ripple-upgraded--unbounded:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-icon-button.mdc-ripple-upgraded--foreground-activation:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-icon-button.mdc-ripple-upgraded--foreground-deactivation:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-icon-button:before,.mdc-icon-button:after{width:100%;height:100%;top:0%;left:0%}.mdc-icon-button.mdc-ripple-upgraded:before,.mdc-icon-button.mdc-ripple-upgraded:after{top:var(--mdc-ripple-top,calc(50% - 50%));left:var(--mdc-ripple-left,calc(50% - 50%));width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-icon-button.mdc-ripple-upgraded:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-icon-button:before,.mdc-icon-button:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}.mdc-icon-button:hover:before,.mdc-icon-button.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-icon-button.mdc-ripple-upgraded--background-focused:before,.mdc-icon-button:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-icon-button:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-icon-button:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-icon-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-image-list{flex-wrap:wrap;margin:0 auto;padding:0;display:flex}.mdc-image-list__item,.mdc-image-list__image-aspect-container{box-sizing:border-box;position:relative}.mdc-image-list__item{list-style-type:none}.mdc-image-list__image{width:100%}.mdc-image-list__image-aspect-container .mdc-image-list__image{background-position:50%;background-repeat:no-repeat;background-size:cover;height:100%;position:absolute;inset:0}.mdc-image-list__image-aspect-container{padding-bottom:100%}.mdc-image-list__image,.mdc-image-list--with-text-protection .mdc-image-list__supporting{border-radius:0}.mdc-image-list__supporting{color:var(--mdc-theme-text-primary-on-background,#000000de);box-sizing:border-box;justify-content:space-between;align-items:center;padding:8px 0;line-height:24px;display:flex}.mdc-image-list__label{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.mdc-image-list--with-text-protection .mdc-image-list__supporting{color:#fff;background:#0009;width:100%;height:48px;padding:0 16px;position:absolute;bottom:0}.mdc-image-list--masonry{display:block}.mdc-image-list--masonry .mdc-image-list__item{break-inside:avoid-column}.mdc-image-list--masonry .mdc-image-list__image{height:auto;display:block}:root{--mdc-layout-grid-margin-desktop:24px;--mdc-layout-grid-gutter-desktop:24px;--mdc-layout-grid-column-width-desktop:72px;--mdc-layout-grid-margin-tablet:16px;--mdc-layout-grid-gutter-tablet:16px;--mdc-layout-grid-column-width-tablet:72px;--mdc-layout-grid-margin-phone:16px;--mdc-layout-grid-gutter-phone:16px;--mdc-layout-grid-column-width-phone:72px}@media (width>=840px){.mdc-layout-grid{box-sizing:border-box;padding:24px;padding:var(--mdc-layout-grid-margin-desktop,24px);margin:0 auto}}@media (width>=600px) and (width<=839px){.mdc-layout-grid{box-sizing:border-box;padding:16px;padding:var(--mdc-layout-grid-margin-tablet,16px);margin:0 auto}}@media (width<=599px){.mdc-layout-grid{box-sizing:border-box;padding:16px;padding:var(--mdc-layout-grid-margin-phone,16px);margin:0 auto}}@media (width>=840px){.mdc-layout-grid__inner{margin:-12px;margin:calc(var(--mdc-layout-grid-gutter-desktop,24px)/2*-1);flex-flow:wrap;align-items:stretch;display:flex}@supports (display:grid){.mdc-layout-grid__inner{grid-gap:24px;grid-gap:var(--mdc-layout-grid-gutter-desktop,24px);grid-template-columns:repeat(12,minmax(0,1fr));margin:0;display:grid}}}@media (width>=600px) and (width<=839px){.mdc-layout-grid__inner{margin:-8px;margin:calc(var(--mdc-layout-grid-gutter-tablet,16px)/2*-1);flex-flow:wrap;align-items:stretch;display:flex}@supports (display:grid){.mdc-layout-grid__inner{grid-gap:16px;grid-gap:var(--mdc-layout-grid-gutter-tablet,16px);grid-template-columns:repeat(8,minmax(0,1fr));margin:0;display:grid}}}@media (width<=599px){.mdc-layout-grid__inner{margin:-8px;margin:calc(var(--mdc-layout-grid-gutter-phone,16px)/2*-1);flex-flow:wrap;align-items:stretch;display:flex}@supports (display:grid){.mdc-layout-grid__inner{grid-gap:16px;grid-gap:var(--mdc-layout-grid-gutter-phone,16px);grid-template-columns:repeat(4,minmax(0,1fr));margin:0;display:grid}}}@media (width>=840px){.mdc-layout-grid__cell{width:calc(33.3333% - var(--mdc-layout-grid-gutter-desktop,24px));box-sizing:border-box;margin:12px;margin:calc(var(--mdc-layout-grid-gutter-desktop,24px)/2);width:calc(33.3333% - 24px)}@supports (display:grid){.mdc-layout-grid__cell{grid-column-end:span 4;width:auto;margin:0}}.mdc-layout-grid__cell--span-1,.mdc-layout-grid__cell--span-1-desktop{width:calc(8.33333% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(8.33333% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-1,.mdc-layout-grid__cell--span-1-desktop{grid-column-end:span 1;width:auto}}.mdc-layout-grid__cell--span-2,.mdc-layout-grid__cell--span-2-desktop{width:calc(16.6667% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(16.6667% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-2,.mdc-layout-grid__cell--span-2-desktop{grid-column-end:span 2;width:auto}}.mdc-layout-grid__cell--span-3,.mdc-layout-grid__cell--span-3-desktop{width:calc(25% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(25% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-3,.mdc-layout-grid__cell--span-3-desktop{grid-column-end:span 3;width:auto}}.mdc-layout-grid__cell--span-4,.mdc-layout-grid__cell--span-4-desktop{width:calc(33.3333% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(33.3333% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-4,.mdc-layout-grid__cell--span-4-desktop{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-5,.mdc-layout-grid__cell--span-5-desktop{width:calc(41.6667% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(41.6667% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-5,.mdc-layout-grid__cell--span-5-desktop{grid-column-end:span 5;width:auto}}.mdc-layout-grid__cell--span-6,.mdc-layout-grid__cell--span-6-desktop{width:calc(50% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(50% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-6,.mdc-layout-grid__cell--span-6-desktop{grid-column-end:span 6;width:auto}}.mdc-layout-grid__cell--span-7,.mdc-layout-grid__cell--span-7-desktop{width:calc(58.3333% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(58.3333% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-7,.mdc-layout-grid__cell--span-7-desktop{grid-column-end:span 7;width:auto}}.mdc-layout-grid__cell--span-8,.mdc-layout-grid__cell--span-8-desktop{width:calc(66.6667% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(66.6667% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-8,.mdc-layout-grid__cell--span-8-desktop{grid-column-end:span 8;width:auto}}.mdc-layout-grid__cell--span-9,.mdc-layout-grid__cell--span-9-desktop{width:calc(75% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(75% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-9,.mdc-layout-grid__cell--span-9-desktop{grid-column-end:span 9;width:auto}}.mdc-layout-grid__cell--span-10,.mdc-layout-grid__cell--span-10-desktop{width:calc(83.3333% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(83.3333% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-10,.mdc-layout-grid__cell--span-10-desktop{grid-column-end:span 10;width:auto}}.mdc-layout-grid__cell--span-11,.mdc-layout-grid__cell--span-11-desktop{width:calc(91.6667% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(91.6667% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-11,.mdc-layout-grid__cell--span-11-desktop{grid-column-end:span 11;width:auto}}.mdc-layout-grid__cell--span-12,.mdc-layout-grid__cell--span-12-desktop{width:calc(100% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(100% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-12,.mdc-layout-grid__cell--span-12-desktop{grid-column-end:span 12;width:auto}}}@media (width>=600px) and (width<=839px){.mdc-layout-grid__cell{width:calc(50% - var(--mdc-layout-grid-gutter-tablet,16px));box-sizing:border-box;margin:8px;margin:calc(var(--mdc-layout-grid-gutter-tablet,16px)/2);width:calc(50% - 16px)}@supports (display:grid){.mdc-layout-grid__cell{grid-column-end:span 4;width:auto;margin:0}}.mdc-layout-grid__cell--span-1,.mdc-layout-grid__cell--span-1-tablet{width:calc(12.5% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(12.5% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-1,.mdc-layout-grid__cell--span-1-tablet{grid-column-end:span 1;width:auto}}.mdc-layout-grid__cell--span-2,.mdc-layout-grid__cell--span-2-tablet{width:calc(25% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(25% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-2,.mdc-layout-grid__cell--span-2-tablet{grid-column-end:span 2;width:auto}}.mdc-layout-grid__cell--span-3,.mdc-layout-grid__cell--span-3-tablet{width:calc(37.5% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(37.5% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-3,.mdc-layout-grid__cell--span-3-tablet{grid-column-end:span 3;width:auto}}.mdc-layout-grid__cell--span-4,.mdc-layout-grid__cell--span-4-tablet{width:calc(50% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(50% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-4,.mdc-layout-grid__cell--span-4-tablet{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-5,.mdc-layout-grid__cell--span-5-tablet{width:calc(62.5% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(62.5% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-5,.mdc-layout-grid__cell--span-5-tablet{grid-column-end:span 5;width:auto}}.mdc-layout-grid__cell--span-6,.mdc-layout-grid__cell--span-6-tablet{width:calc(75% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(75% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-6,.mdc-layout-grid__cell--span-6-tablet{grid-column-end:span 6;width:auto}}.mdc-layout-grid__cell--span-7,.mdc-layout-grid__cell--span-7-tablet{width:calc(87.5% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(87.5% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-7,.mdc-layout-grid__cell--span-7-tablet{grid-column-end:span 7;width:auto}}.mdc-layout-grid__cell--span-8,.mdc-layout-grid__cell--span-8-tablet{width:calc(100% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-8,.mdc-layout-grid__cell--span-8-tablet{grid-column-end:span 8;width:auto}}.mdc-layout-grid__cell--span-9,.mdc-layout-grid__cell--span-9-tablet{width:calc(100% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-9,.mdc-layout-grid__cell--span-9-tablet{grid-column-end:span 8;width:auto}}.mdc-layout-grid__cell--span-10,.mdc-layout-grid__cell--span-10-tablet{width:calc(100% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-10,.mdc-layout-grid__cell--span-10-tablet{grid-column-end:span 8;width:auto}}.mdc-layout-grid__cell--span-11,.mdc-layout-grid__cell--span-11-tablet{width:calc(100% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-11,.mdc-layout-grid__cell--span-11-tablet{grid-column-end:span 8;width:auto}}.mdc-layout-grid__cell--span-12,.mdc-layout-grid__cell--span-12-tablet{width:calc(100% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-12,.mdc-layout-grid__cell--span-12-tablet{grid-column-end:span 8;width:auto}}}@media (width<=599px){.mdc-layout-grid__cell{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));box-sizing:border-box;margin:8px;margin:calc(var(--mdc-layout-grid-gutter-phone,16px)/2);width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell{grid-column-end:span 4;width:auto;margin:0}}.mdc-layout-grid__cell--span-1,.mdc-layout-grid__cell--span-1-phone{width:calc(25% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(25% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-1,.mdc-layout-grid__cell--span-1-phone{grid-column-end:span 1;width:auto}}.mdc-layout-grid__cell--span-2,.mdc-layout-grid__cell--span-2-phone{width:calc(50% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(50% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-2,.mdc-layout-grid__cell--span-2-phone{grid-column-end:span 2;width:auto}}.mdc-layout-grid__cell--span-3,.mdc-layout-grid__cell--span-3-phone{width:calc(75% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(75% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-3,.mdc-layout-grid__cell--span-3-phone{grid-column-end:span 3;width:auto}}.mdc-layout-grid__cell--span-4,.mdc-layout-grid__cell--span-4-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-4,.mdc-layout-grid__cell--span-4-phone{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-5,.mdc-layout-grid__cell--span-5-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-5,.mdc-layout-grid__cell--span-5-phone{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-6,.mdc-layout-grid__cell--span-6-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-6,.mdc-layout-grid__cell--span-6-phone{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-7,.mdc-layout-grid__cell--span-7-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-7,.mdc-layout-grid__cell--span-7-phone{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-8,.mdc-layout-grid__cell--span-8-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-8,.mdc-layout-grid__cell--span-8-phone{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-9,.mdc-layout-grid__cell--span-9-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-9,.mdc-layout-grid__cell--span-9-phone{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-10,.mdc-layout-grid__cell--span-10-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-10,.mdc-layout-grid__cell--span-10-phone{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-11,.mdc-layout-grid__cell--span-11-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-11,.mdc-layout-grid__cell--span-11-phone{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-12,.mdc-layout-grid__cell--span-12-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-12,.mdc-layout-grid__cell--span-12-phone{grid-column-end:span 4;width:auto}}}.mdc-layout-grid__cell--order-1{order:1}.mdc-layout-grid__cell--order-2{order:2}.mdc-layout-grid__cell--order-3{order:3}.mdc-layout-grid__cell--order-4{order:4}.mdc-layout-grid__cell--order-5{order:5}.mdc-layout-grid__cell--order-6{order:6}.mdc-layout-grid__cell--order-7{order:7}.mdc-layout-grid__cell--order-8{order:8}.mdc-layout-grid__cell--order-9{order:9}.mdc-layout-grid__cell--order-10{order:10}.mdc-layout-grid__cell--order-11{order:11}.mdc-layout-grid__cell--order-12{order:12}.mdc-layout-grid__cell--align-top{align-self:flex-start}@supports (display:grid){.mdc-layout-grid__cell--align-top{align-self:start}}.mdc-layout-grid__cell--align-middle{align-self:center}.mdc-layout-grid__cell--align-bottom{align-self:flex-end}@supports (display:grid){.mdc-layout-grid__cell--align-bottom{align-self:end}}@media (width>=840px){.mdc-layout-grid--fixed-column-width{width:calc(var(--mdc-layout-grid-column-width-desktop,72px)*12 + var(--mdc-layout-grid-gutter-desktop,24px)*11 + var(--mdc-layout-grid-margin-desktop,24px)*2);width:1176px}}@media (width>=600px) and (width<=839px){.mdc-layout-grid--fixed-column-width{width:calc(var(--mdc-layout-grid-column-width-tablet,72px)*8 + var(--mdc-layout-grid-gutter-tablet,16px)*7 + var(--mdc-layout-grid-margin-tablet,16px)*2);width:720px}}@media (width<=599px){.mdc-layout-grid--fixed-column-width{width:calc(var(--mdc-layout-grid-column-width-phone,72px)*4 + var(--mdc-layout-grid-gutter-phone,16px)*3 + var(--mdc-layout-grid-margin-phone,16px)*2);width:368px}}.mdc-layout-grid--align-left{margin-left:0;margin-right:auto}.mdc-layout-grid--align-right{margin-left:auto;margin-right:0}@keyframes mdc-linear-progress-primary-indeterminate-translate{0%{transform:translate(0)}20%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(0)}59.15%{transform:translate(83.6714%);transform:translateX(var(--mdc-linear-progress-primary-half,83.6714%));animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352)}to{transform:translate(200.611%);transform:translateX(var(--mdc-linear-progress-primary-full,200.611%))}}@keyframes mdc-linear-progress-primary-indeterminate-scale{0%{transform:scaleX(.08)}36.65%{animation-timing-function:cubic-bezier(.334731,.12482,.785844,1);transform:scaleX(.08)}69.15%{animation-timing-function:cubic-bezier(.06,.11,.6,1);transform:scaleX(.661479)}to{transform:scaleX(.08)}}@keyframes mdc-linear-progress-secondary-indeterminate-translate{0%{animation-timing-function:cubic-bezier(.15,0,.515058,.409685);transform:translate(0)}25%{transform:translate(37.6519%);transform:translateX(var(--mdc-linear-progress-secondary-quarter,37.6519%));animation-timing-function:cubic-bezier(.31033,.284058,.8,.733712)}48.35%{transform:translate(84.3862%);transform:translateX(var(--mdc-linear-progress-secondary-half,84.3862%));animation-timing-function:cubic-bezier(.4,.627035,.6,.902026)}to{transform:translate(160.278%);transform:translateX(var(--mdc-linear-progress-secondary-full,160.278%))}}@keyframes mdc-linear-progress-secondary-indeterminate-scale{0%{animation-timing-function:cubic-bezier(.205028,.057051,.57661,.453971);transform:scaleX(.08)}19.15%{animation-timing-function:cubic-bezier(.152313,.196432,.648374,1.00432);transform:scaleX(.457104)}44.15%{animation-timing-function:cubic-bezier(.257759,-.003163,.211762,1.38179);transform:scaleX(.72796)}to{transform:scaleX(.08)}}@keyframes mdc-linear-progress-buffering{0%{transform:rotate(180deg)translate(-10px)}}@keyframes mdc-linear-progress-primary-indeterminate-translate-reverse{0%{transform:translate(0)}20%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(0)}59.15%{transform:translate(-83.6714%);transform:translateX(var(--mdc-linear-progress-primary-half-neg,-83.6714%));animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352)}to{transform:translate(-200.611%);transform:translateX(var(--mdc-linear-progress-primary-full-neg,-200.611%))}}@keyframes mdc-linear-progress-secondary-indeterminate-translate-reverse{0%{animation-timing-function:cubic-bezier(.15,0,.515058,.409685);transform:translate(0)}25%{transform:translate(-37.6519%);transform:translateX(var(--mdc-linear-progress-secondary-quarter-neg,-37.6519%));animation-timing-function:cubic-bezier(.31033,.284058,.8,.733712)}48.35%{transform:translate(-84.3862%);transform:translateX(var(--mdc-linear-progress-secondary-half-neg,-84.3862%));animation-timing-function:cubic-bezier(.4,.627035,.6,.902026)}to{transform:translate(-160.278%);transform:translateX(var(--mdc-linear-progress-secondary-full-neg,-160.278%))}}@keyframes mdc-linear-progress-buffering-reverse{0%{transform:translate(-10px)}}.mdc-linear-progress{outline:1px solid #0000;width:100%;height:4px;transition:opacity .25s cubic-bezier(.4,0,.6,1);position:relative;overflow:hidden;transform:translateZ(0)}.mdc-linear-progress__bar{transform-origin:0 0;width:100%;height:100%;transition:transform .25s cubic-bezier(.4,0,.6,1);animation:none;position:absolute}.mdc-linear-progress__bar-inner{border-top:4px solid;width:100%;animation:none;display:inline-block;position:absolute}.mdc-linear-progress__buffer{width:100%;height:100%;display:flex;position:absolute}.mdc-linear-progress__buffer-dots{background-repeat:repeat-x;background-size:10px 4px;flex:auto;animation:.25s linear infinite mdc-linear-progress-buffering;transform:rotate(180deg)}.mdc-linear-progress__buffer-bar{flex:0 100%;transition:flex-basis .25s cubic-bezier(.4,0,.6,1)}.mdc-linear-progress__primary-bar{transform:scaleX(0)}.mdc-linear-progress__secondary-bar{visibility:hidden}.mdc-linear-progress--indeterminate .mdc-linear-progress__bar{transition:none}.mdc-linear-progress--indeterminate .mdc-linear-progress__primary-bar{left:-145.167%}.mdc-linear-progress--indeterminate .mdc-linear-progress__secondary-bar{visibility:visible;left:-54.8889%}.mdc-linear-progress--indeterminate.mdc-linear-progress--animation-ready .mdc-linear-progress__primary-bar{animation:2s linear infinite mdc-linear-progress-primary-indeterminate-translate}.mdc-linear-progress--indeterminate.mdc-linear-progress--animation-ready .mdc-linear-progress__primary-bar>.mdc-linear-progress__bar-inner{animation:2s linear infinite mdc-linear-progress-primary-indeterminate-scale}.mdc-linear-progress--indeterminate.mdc-linear-progress--animation-ready .mdc-linear-progress__secondary-bar{animation:2s linear infinite mdc-linear-progress-secondary-indeterminate-translate}.mdc-linear-progress--indeterminate.mdc-linear-progress--animation-ready .mdc-linear-progress__secondary-bar>.mdc-linear-progress__bar-inner{animation:2s linear infinite mdc-linear-progress-secondary-indeterminate-scale}[dir=rtl] .mdc-linear-progress:not([dir=ltr]) .mdc-linear-progress__bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]) .mdc-linear-progress__bar{transform-origin:100%;right:0}[dir=rtl] .mdc-linear-progress:not([dir=ltr]).mdc-linear-progress--animation-ready .mdc-linear-progress__primary-bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]).mdc-linear-progress--animation-ready .mdc-linear-progress__primary-bar{animation-name:mdc-linear-progress-primary-indeterminate-translate-reverse}[dir=rtl] .mdc-linear-progress:not([dir=ltr]).mdc-linear-progress--animation-ready .mdc-linear-progress__secondary-bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]).mdc-linear-progress--animation-ready .mdc-linear-progress__secondary-bar{animation-name:mdc-linear-progress-secondary-indeterminate-translate-reverse}[dir=rtl] .mdc-linear-progress:not([dir=ltr]) .mdc-linear-progress__buffer-dots,.mdc-linear-progress[dir=rtl]:not([dir=ltr]) .mdc-linear-progress__buffer-dots{animation:.25s linear infinite mdc-linear-progress-buffering-reverse;transform:rotate(0)}[dir=rtl] .mdc-linear-progress:not([dir=ltr]).mdc-linear-progress--indeterminate .mdc-linear-progress__primary-bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]).mdc-linear-progress--indeterminate .mdc-linear-progress__primary-bar{left:auto;right:-145.167%}[dir=rtl] .mdc-linear-progress:not([dir=ltr]).mdc-linear-progress--indeterminate .mdc-linear-progress__secondary-bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]).mdc-linear-progress--indeterminate .mdc-linear-progress__secondary-bar{left:auto;right:-54.8889%}.mdc-linear-progress--closed{opacity:0}.mdc-linear-progress--closed-animation-off .mdc-linear-progress__buffer-dots,.mdc-linear-progress--closed-animation-off.mdc-linear-progress--indeterminate .mdc-linear-progress__bar,.mdc-linear-progress--closed-animation-off.mdc-linear-progress--indeterminate .mdc-linear-progress__bar .mdc-linear-progress__bar-inner{animation:none}.mdc-linear-progress__bar-inner{border-color:#6200ee;border-color:var(--mdc-theme-primary,#6200ee)}.mdc-linear-progress__buffer-dots{background-image:url(\"data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' enable-background='new 0 0 5 2' xml:space='preserve' viewBox='0 0 5 2' preserveAspectRatio='none slice'%3E%3Ccircle cx='1' cy='1' r='1' fill='%23e6e6e6'/%3E%3C/svg%3E\")}.mdc-linear-progress__buffer-bar{background-color:#e6e6e6}.mdc-deprecated-list{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);color:var(--mdc-theme-text-primary-on-background,#000000de);margin:0;padding:8px 0;line-height:1.5rem;list-style-type:none}.mdc-deprecated-list:focus{outline:none}.mdc-deprecated-list-item{height:48px}.mdc-deprecated-list-item__secondary-text{color:var(--mdc-theme-text-secondary-on-background,#0000008a)}.mdc-deprecated-list-item__graphic{color:var(--mdc-theme-text-icon-on-background,#00000061);background-color:#0000}.mdc-deprecated-list-item__meta{color:var(--mdc-theme-text-hint-on-background,#00000061)}.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__text{opacity:.38}.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__text,.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__primary-text,.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__secondary-text{color:var(--mdc-theme-on-surface,#000)}.mdc-deprecated-list-item--selected,.mdc-deprecated-list-item--activated,.mdc-deprecated-list-item--selected .mdc-deprecated-list-item__graphic,.mdc-deprecated-list-item--activated .mdc-deprecated-list-item__graphic{color:var(--mdc-theme-primary,#6200ee)}.mdc-deprecated-list--dense{padding-top:4px;padding-bottom:4px;font-size:.812rem}.mdc-deprecated-list-item{justify-content:flex-start;align-items:center;height:48px;padding:0 16px;display:flex;position:relative;overflow:hidden}.mdc-deprecated-list-item:focus{outline:none}.mdc-deprecated-list-item:not(.mdc-deprecated-list-item--selected):focus:before,.mdc-deprecated-list-item.mdc-ripple-upgraded--background-focused:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:1px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-deprecated-list-item.mdc-deprecated-list-item--selected:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:3px double #0000;width:100%;height:100%;position:absolute;top:0;left:0}[dir=rtl] .mdc-deprecated-list-item,.mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:16px}.mdc-deprecated-list--icon-list .mdc-deprecated-list-item{height:56px;padding-left:16px;padding-right:16px}[dir=rtl] .mdc-deprecated-list--icon-list .mdc-deprecated-list-item,.mdc-deprecated-list--icon-list .mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:16px}.mdc-deprecated-list--avatar-list .mdc-deprecated-list-item{height:56px;padding-left:16px;padding-right:16px}[dir=rtl] .mdc-deprecated-list--avatar-list .mdc-deprecated-list-item,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:16px}.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item{height:56px;padding-left:16px;padding-right:16px}[dir=rtl] .mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:16px}.mdc-deprecated-list--image-list .mdc-deprecated-list-item{height:72px;padding-left:16px;padding-right:16px}[dir=rtl] .mdc-deprecated-list--image-list .mdc-deprecated-list-item,.mdc-deprecated-list--image-list .mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:16px}.mdc-deprecated-list--video-list .mdc-deprecated-list-item{height:72px;padding-left:0;padding-right:16px}[dir=rtl] .mdc-deprecated-list--video-list .mdc-deprecated-list-item,.mdc-deprecated-list--video-list .mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:0}.mdc-deprecated-list--dense .mdc-deprecated-list-item__graphic{width:20px;height:20px;margin-left:0;margin-right:16px}[dir=rtl] .mdc-deprecated-list--dense .mdc-deprecated-list-item__graphic,.mdc-deprecated-list--dense .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:16px;margin-right:0}.mdc-deprecated-list-item__graphic{fill:currentColor;object-fit:cover;flex-shrink:0;justify-content:center;align-items:center;width:24px;height:24px;margin-left:0;margin-right:32px}[dir=rtl] .mdc-deprecated-list-item__graphic,.mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:32px;margin-right:0}.mdc-deprecated-list--icon-list .mdc-deprecated-list-item__graphic{width:24px;height:24px;margin-left:0;margin-right:32px}[dir=rtl] .mdc-deprecated-list--icon-list .mdc-deprecated-list-item__graphic,.mdc-deprecated-list--icon-list .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:32px;margin-right:0}.mdc-deprecated-list--avatar-list .mdc-deprecated-list-item__graphic{border-radius:50%;width:40px;height:40px;margin-left:0;margin-right:16px}[dir=rtl] .mdc-deprecated-list--avatar-list .mdc-deprecated-list-item__graphic,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:16px;margin-right:0}.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item__graphic{width:40px;height:40px;margin-left:0;margin-right:16px}[dir=rtl] .mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item__graphic,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:16px;margin-right:0}.mdc-deprecated-list--image-list .mdc-deprecated-list-item__graphic{width:56px;height:56px;margin-left:0;margin-right:16px}[dir=rtl] .mdc-deprecated-list--image-list .mdc-deprecated-list-item__graphic,.mdc-deprecated-list--image-list .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:16px;margin-right:0}.mdc-deprecated-list--video-list .mdc-deprecated-list-item__graphic{width:100px;height:56px;margin-left:0;margin-right:16px}[dir=rtl] .mdc-deprecated-list--video-list .mdc-deprecated-list-item__graphic,.mdc-deprecated-list--video-list .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:16px;margin-right:0}.mdc-deprecated-list .mdc-deprecated-list-item__graphic{display:inline-flex}.mdc-deprecated-list-item__meta{margin-left:auto;margin-right:0}.mdc-deprecated-list-item__meta:not(.material-icons){-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-caption-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-caption-font-size,.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight,400);letter-spacing:.0333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing,.0333333em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform,inherit)}.mdc-deprecated-list-item[dir=rtl] .mdc-deprecated-list-item__meta,[dir=rtl] .mdc-deprecated-list-item .mdc-deprecated-list-item__meta{margin-left:0;margin-right:auto}.mdc-deprecated-list-item__text{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.mdc-deprecated-list-item__text[for]{pointer-events:none}.mdc-deprecated-list-item__primary-text{text-overflow:ellipsis;white-space:nowrap;margin-top:0;margin-bottom:-20px;line-height:normal;display:block;overflow:hidden}.mdc-deprecated-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:28px;display:inline-block}.mdc-deprecated-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-deprecated-list--video-list .mdc-deprecated-list-item__primary-text,.mdc-deprecated-list--image-list .mdc-deprecated-list-item__primary-text,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item__primary-text,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-item__primary-text,.mdc-deprecated-list--icon-list .mdc-deprecated-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-deprecated-list--video-list .mdc-deprecated-list-item__primary-text:before,.mdc-deprecated-list--image-list .mdc-deprecated-list-item__primary-text:before,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item__primary-text:before,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-item__primary-text:before,.mdc-deprecated-list--icon-list .mdc-deprecated-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-deprecated-list--video-list .mdc-deprecated-list-item__primary-text:after,.mdc-deprecated-list--image-list .mdc-deprecated-list-item__primary-text:after,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item__primary-text:after,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-item__primary-text:after,.mdc-deprecated-list--icon-list .mdc-deprecated-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-deprecated-list--dense .mdc-deprecated-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-deprecated-list--dense .mdc-deprecated-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:24px;display:inline-block}.mdc-deprecated-list--dense .mdc-deprecated-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-deprecated-list-item__secondary-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);text-overflow:ellipsis;white-space:nowrap;margin-top:0;line-height:normal;display:block;overflow:hidden}.mdc-deprecated-list-item__secondary-text:before{content:\"\";vertical-align:0;width:0;height:20px;display:inline-block}.mdc-deprecated-list--dense .mdc-deprecated-list-item__secondary-text{font-size:inherit}.mdc-deprecated-list--dense .mdc-deprecated-list-item{height:40px}.mdc-deprecated-list--two-line .mdc-deprecated-list-item__text{align-self:flex-start}.mdc-deprecated-list--two-line .mdc-deprecated-list-item{height:64px}.mdc-deprecated-list--two-line.mdc-deprecated-list--video-list .mdc-deprecated-list-item,.mdc-deprecated-list--two-line.mdc-deprecated-list--image-list .mdc-deprecated-list-item,.mdc-deprecated-list--two-line.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item,.mdc-deprecated-list--two-line.mdc-deprecated-list--avatar-list .mdc-deprecated-list-item,.mdc-deprecated-list--two-line.mdc-deprecated-list--icon-list .mdc-deprecated-list-item{height:72px}.mdc-deprecated-list--two-line.mdc-deprecated-list--icon-list .mdc-deprecated-list-item__graphic{align-self:flex-start;margin-top:16px}.mdc-deprecated-list--two-line.mdc-deprecated-list--dense .mdc-deprecated-list-item,.mdc-deprecated-list--avatar-list.mdc-deprecated-list--dense .mdc-deprecated-list-item{height:60px}.mdc-deprecated-list--avatar-list.mdc-deprecated-list--dense .mdc-deprecated-list-item__graphic{width:36px;height:36px;margin-left:0;margin-right:16px}[dir=rtl] .mdc-deprecated-list--avatar-list.mdc-deprecated-list--dense .mdc-deprecated-list-item__graphic,.mdc-deprecated-list--avatar-list.mdc-deprecated-list--dense .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:16px;margin-right:0}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item{cursor:pointer}a.mdc-deprecated-list-item{color:inherit;text-decoration:none}.mdc-deprecated-list-divider{border:none;border-bottom:1px solid #0000001f;height:0;margin:0}.mdc-deprecated-list-divider--padded{width:calc(100% - 32px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list-divider--padded,.mdc-deprecated-list-divider--padded[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list-divider--inset{width:calc(100% - 72px);margin-left:72px;margin-right:0}[dir=rtl] .mdc-deprecated-list-divider--inset,.mdc-deprecated-list-divider--inset[dir=rtl]{margin-left:0;margin-right:72px}.mdc-deprecated-list-divider--inset.mdc-deprecated-list-divider--padded{width:calc(100% - 88px);margin-left:72px;margin-right:0}[dir=rtl] .mdc-deprecated-list-divider--inset.mdc-deprecated-list-divider--padded,.mdc-deprecated-list-divider--inset.mdc-deprecated-list-divider--padded[dir=rtl]{margin-left:0;margin-right:72px}.mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading{width:calc(100% - 16px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading,.mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list .mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 16px)}.mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 32px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing,.mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding{width:calc(100% - 16px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding,.mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding{width:calc(100% - 32px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding,.mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading{width:calc(100% - 72px);margin-left:72px;margin-right:0}[dir=rtl] .mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading,.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading[dir=rtl]{margin-left:0;margin-right:72px}.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 16px)}.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 88px);margin-left:72px;margin-right:0}[dir=rtl] .mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing,.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing[dir=rtl]{margin-left:0;margin-right:72px}.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding{width:calc(100% - 16px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding,.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding{width:calc(100% - 32px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding,.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading{width:calc(100% - 72px);margin-left:72px;margin-right:0}[dir=rtl] .mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading[dir=rtl]{margin-left:0;margin-right:72px}.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 16px)}.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 88px);margin-left:72px;margin-right:0}[dir=rtl] .mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing[dir=rtl]{margin-left:0;margin-right:72px}.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding{width:calc(100% - 16px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding{width:calc(100% - 32px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading{width:calc(100% - 72px);margin-left:72px;margin-right:0}[dir=rtl] .mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading[dir=rtl]{margin-left:0;margin-right:72px}.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 16px)}.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 88px);margin-left:72px;margin-right:0}[dir=rtl] .mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing[dir=rtl]{margin-left:0;margin-right:72px}.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding{width:calc(100% - 16px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding{width:calc(100% - 32px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading{width:calc(100% - 88px);margin-left:88px;margin-right:0}[dir=rtl] .mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading,.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading[dir=rtl]{margin-left:0;margin-right:88px}.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 16px)}.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 104px);margin-left:88px;margin-right:0}[dir=rtl] .mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing,.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing[dir=rtl]{margin-left:0;margin-right:88px}.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding{width:calc(100% - 16px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding,.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding{width:calc(100% - 32px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding,.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading{width:calc(100% - 116px);margin-left:116px;margin-right:0}[dir=rtl] .mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading,.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading[dir=rtl]{margin-left:0;margin-right:116px}.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 16px)}.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 132px);margin-left:116px;margin-right:0}[dir=rtl] .mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing,.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing[dir=rtl]{margin-left:0;margin-right:116px}.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding{width:100%;margin-left:0;margin-right:0}[dir=rtl] .mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding,.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding[dir=rtl]{margin-left:0;margin-right:0}.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding{width:calc(100% - 16px);margin-left:0;margin-right:0}[dir=rtl] .mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding,.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding[dir=rtl]{margin-left:0;margin-right:0}.mdc-deprecated-list-group .mdc-deprecated-list{padding:0}.mdc-deprecated-list-group__subheader{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);margin:.75rem 16px}.mdc-list-item__primary-text{color:var(--mdc-theme-text-primary-on-background,#000000de)}.mdc-list-item__secondary-text{color:var(--mdc-theme-text-secondary-on-background,#0000008a)}.mdc-list-item--with-leading-icon .mdc-list-item__start,.mdc-list-item--with-trailing-icon .mdc-list-item__end{color:var(--mdc-theme-text-icon-on-background,#00000061);background-color:#0000}.mdc-list-item--with-trailing-meta .mdc-list-item__end{color:var(--mdc-theme-text-hint-on-background,#00000061)}.mdc-list-item--disabled .mdc-list-item__start,.mdc-list-item--disabled .mdc-list-item__content,.mdc-list-item--disabled .mdc-list-item__end{opacity:.38}.mdc-list-item--disabled .mdc-list-item__primary-text,.mdc-list-item--disabled .mdc-list-item__secondary-text,.mdc-list-item--disabled.mdc-list-item--with-leading-icon .mdc-list-item__start,.mdc-list-item--disabled.mdc-list-item--with-trailing-icon .mdc-list-item__end,.mdc-list-item--disabled.mdc-list-item--with-trailing-meta .mdc-list-item__end{color:var(--mdc-theme-on-surface,#000)}.mdc-list-item--selected .mdc-list-item__primary-text,.mdc-list-item--activated .mdc-list-item__primary-text,.mdc-list-item--selected.mdc-list-item--with-leading-icon .mdc-list-item__start,.mdc-list-item--activated.mdc-list-item--with-leading-icon .mdc-list-item__start{color:var(--mdc-theme-primary,#6200ee)}.mdc-deprecated-list-group__subheader{color:var(--mdc-theme-text-primary-on-background,#000000de)}@media screen and (-ms-high-contrast:active){.mdc-list-divider:after{content:\"\";border-bottom:1px solid #fff;display:block}}.mdc-list{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);margin:0;padding:8px 0;line-height:1.5rem;list-style-type:none}.mdc-list:focus{outline:none}.mdc-list-item{cursor:pointer;justify-content:flex-start;align-items:stretch;padding:0 16px;display:flex;position:relative;overflow:hidden}.mdc-list-item:focus{outline:none}[dir=rtl] .mdc-list-item,.mdc-list-item[dir=rtl]{padding-left:16px;padding-right:16px}.mdc-list-item.mdc-list-item--with-one-line{height:48px}.mdc-list-item.mdc-list-item--with-two-lines{height:64px}.mdc-list-item.mdc-list-item--with-three-lines{height:88px}.mdc-list-item.mdc-list-item--with-one-line .mdc-list-item__start{align-self:center;margin-top:0}.mdc-list-item.mdc-list-item--with-two-lines .mdc-list-item__start,.mdc-list-item.mdc-list-item--with-three-lines .mdc-list-item__start{align-self:flex-start;margin-top:16px}.mdc-list-item.mdc-list-item--with-one-line .mdc-list-item__end,.mdc-list-item.mdc-list-item--with-two-lines .mdc-list-item__end{align-self:center;margin-top:0}.mdc-list-item.mdc-list-item--with-three-lines .mdc-list-item__end{align-self:flex-start;margin-top:16px}.mdc-list-item.mdc-list-item--disabled,.mdc-list-item.mdc-list-item--non-interactive{cursor:auto}.mdc-list-item:not(.mdc-list-item--selected):focus:before,.mdc-list-item.mdc-ripple-upgraded--background-focused:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:1px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-list-item.mdc-list-item--selected:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:3px double #0000;width:100%;height:100%;position:absolute;top:0;left:0}a.mdc-list-item{color:inherit;text-decoration:none}.mdc-list-item__start{fill:currentColor;pointer-events:none;flex-shrink:0}.mdc-list-item__end{pointer-events:none;flex-shrink:0}.mdc-list-item__content{text-overflow:ellipsis;white-space:nowrap;pointer-events:none;flex:1;align-self:center;overflow:hidden}.mdc-list-item--with-two-lines .mdc-list-item__content,.mdc-list-item--with-three-lines .mdc-list-item__content{align-self:stretch}.mdc-list-item__content[for]{pointer-events:none}.mdc-list-item__primary-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.mdc-list-item--with-two-lines .mdc-list-item__primary-text,.mdc-list-item--with-three-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before,.mdc-list-item--with-three-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:28px;display:inline-block}.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after,.mdc-list-item--with-three-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item__secondary-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);text-overflow:ellipsis;white-space:nowrap;margin-top:0;line-height:normal;display:block;overflow:hidden}.mdc-list-item__secondary-text:before{content:\"\";vertical-align:0;width:0;height:20px;display:inline-block}.mdc-list-item__overline-text{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.mdc-list-item--with-two-lines .mdc-list-item__overline-text,.mdc-list-item--with-three-lines .mdc-list-item__overline-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-two-lines .mdc-list-item__overline-text:before,.mdc-list-item--with-three-lines .mdc-list-item__overline-text:before{content:\"\";vertical-align:0;width:0;height:24px;display:inline-block}.mdc-list-item--with-two-lines .mdc-list-item__overline-text:after,.mdc-list-item--with-three-lines .mdc-list-item__overline-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-avatar.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-item--with-leading-avatar.mdc-list-item,.mdc-list-item--with-leading-avatar.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-list-item--with-leading-avatar .mdc-list-item__start,[dir=rtl] .mdc-list-item--with-leading-avatar .mdc-list-item__start,.mdc-list-item--with-leading-avatar .mdc-list-item__start[dir=rtl]{margin-left:16px;margin-right:16px}.mdc-list-item--with-leading-avatar .mdc-list-item__start{width:40px;height:40px}.mdc-list-item--with-leading-avatar.mdc-list-item--with-two-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-leading-avatar.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-avatar.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-avatar.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-leading-avatar.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-avatar.mdc-list-item--with-one-line{height:56px}.mdc-list-item--with-leading-avatar.mdc-list-item--with-two-lines{height:72px}.mdc-list-item--with-leading-avatar .mdc-list-item__start{border-radius:50%}.mdc-list-item--with-leading-icon .mdc-list-item__start{width:24px;height:24px}.mdc-list-item--with-leading-icon.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-item--with-leading-icon.mdc-list-item,.mdc-list-item--with-leading-icon.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-list-item--with-leading-icon .mdc-list-item__start{margin-left:16px;margin-right:32px}[dir=rtl] .mdc-list-item--with-leading-icon .mdc-list-item__start,.mdc-list-item--with-leading-icon .mdc-list-item__start[dir=rtl]{margin-left:32px;margin-right:16px}.mdc-list-item--with-leading-icon.mdc-list-item--with-two-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-leading-icon.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-icon.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-icon.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-leading-icon.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-icon.mdc-list-item--with-one-line{height:56px}.mdc-list-item--with-leading-icon.mdc-list-item--with-two-lines{height:72px}.mdc-list-item--with-leading-thumbnail.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-item--with-leading-thumbnail.mdc-list-item,.mdc-list-item--with-leading-thumbnail.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-list-item--with-leading-thumbnail .mdc-list-item__start,[dir=rtl] .mdc-list-item--with-leading-thumbnail .mdc-list-item__start,.mdc-list-item--with-leading-thumbnail .mdc-list-item__start[dir=rtl]{margin-left:16px;margin-right:16px}.mdc-list-item--with-leading-thumbnail .mdc-list-item__start{width:40px;height:40px}.mdc-list-item--with-leading-thumbnail.mdc-list-item--with-two-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-leading-thumbnail.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-thumbnail.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-thumbnail.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-leading-thumbnail.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-thumbnail.mdc-list-item--with-one-line{height:56px}.mdc-list-item--with-leading-thumbnail.mdc-list-item--with-two-lines{height:72px}.mdc-list-item--with-leading-image.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-item--with-leading-image.mdc-list-item,.mdc-list-item--with-leading-image.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-list-item--with-leading-image .mdc-list-item__start,[dir=rtl] .mdc-list-item--with-leading-image .mdc-list-item__start,.mdc-list-item--with-leading-image .mdc-list-item__start[dir=rtl]{margin-left:16px;margin-right:16px}.mdc-list-item--with-leading-image .mdc-list-item__start{width:56px;height:56px}.mdc-list-item--with-leading-image.mdc-list-item--with-two-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-leading-image.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-image.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-image.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-leading-image.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-image.mdc-list-item--with-one-line,.mdc-list-item--with-leading-image.mdc-list-item--with-two-lines{height:72px}.mdc-list-item--with-leading-video.mdc-list-item--with-two-lines .mdc-list-item__start{align-self:flex-start;margin-top:8px}.mdc-list-item--with-leading-video.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-item--with-leading-video.mdc-list-item,.mdc-list-item--with-leading-video.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-list-item--with-leading-video .mdc-list-item__start{margin-left:0;margin-right:16px}[dir=rtl] .mdc-list-item--with-leading-video .mdc-list-item__start,.mdc-list-item--with-leading-video .mdc-list-item__start[dir=rtl]{margin-left:16px;margin-right:0}.mdc-list-item--with-leading-video .mdc-list-item__start{width:100px;height:56px}.mdc-list-item--with-leading-video.mdc-list-item--with-two-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-leading-video.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-video.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-video.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-leading-video.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-video.mdc-list-item--with-one-line,.mdc-list-item--with-leading-video.mdc-list-item--with-two-lines{height:72px}.mdc-list-item--with-leading-checkbox.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-item--with-leading-checkbox.mdc-list-item,.mdc-list-item--with-leading-checkbox.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-list-item--with-leading-checkbox .mdc-list-item__start{margin-left:8px;margin-right:24px}[dir=rtl] .mdc-list-item--with-leading-checkbox .mdc-list-item__start,.mdc-list-item--with-leading-checkbox .mdc-list-item__start[dir=rtl]{margin-left:24px;margin-right:8px}.mdc-list-item--with-leading-checkbox .mdc-list-item__start{width:40px;height:40px}.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines .mdc-list-item__start{align-self:flex-start;margin-top:8px}.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-checkbox.mdc-list-item--with-one-line{height:56px}.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines{height:72px}.mdc-list-item--with-leading-radio.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-item--with-leading-radio.mdc-list-item,.mdc-list-item--with-leading-radio.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-list-item--with-leading-radio .mdc-list-item__start{margin-left:8px;margin-right:24px}[dir=rtl] .mdc-list-item--with-leading-radio .mdc-list-item__start,.mdc-list-item--with-leading-radio .mdc-list-item__start[dir=rtl]{margin-left:24px;margin-right:8px}.mdc-list-item--with-leading-radio .mdc-list-item__start{width:40px;height:40px}.mdc-list-item--with-leading-radio.mdc-list-item--with-two-lines .mdc-list-item__start{align-self:flex-start;margin-top:8px}.mdc-list-item--with-leading-radio.mdc-list-item--with-two-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-leading-radio.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-radio.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-radio.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-leading-radio.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-radio.mdc-list-item--with-one-line{height:56px}.mdc-list-item--with-leading-radio.mdc-list-item--with-two-lines{height:72px}.mdc-list-item--with-leading-switch.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-item--with-leading-switch.mdc-list-item,.mdc-list-item--with-leading-switch.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-list-item--with-leading-switch .mdc-list-item__start,[dir=rtl] .mdc-list-item--with-leading-switch .mdc-list-item__start,.mdc-list-item--with-leading-switch .mdc-list-item__start[dir=rtl]{margin-left:16px;margin-right:16px}.mdc-list-item--with-leading-switch .mdc-list-item__start{width:36px;height:20px}.mdc-list-item--with-leading-switch.mdc-list-item--with-two-lines .mdc-list-item__start{align-self:flex-start;margin-top:16px}.mdc-list-item--with-leading-switch.mdc-list-item--with-two-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-leading-switch.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-switch.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-switch.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-leading-switch.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-switch.mdc-list-item--with-one-line{height:56px}.mdc-list-item--with-leading-switch.mdc-list-item--with-two-lines{height:72px}.mdc-list-item--with-trailing-icon.mdc-list-item{padding-left:auto;padding-right:0}[dir=rtl] .mdc-list-item--with-trailing-icon.mdc-list-item,.mdc-list-item--with-trailing-icon.mdc-list-item[dir=rtl]{padding-left:0;padding-right:auto}.mdc-list-item--with-trailing-icon .mdc-list-item__end,[dir=rtl] .mdc-list-item--with-trailing-icon .mdc-list-item__end,.mdc-list-item--with-trailing-icon .mdc-list-item__end[dir=rtl]{margin-left:16px;margin-right:16px}.mdc-list-item--with-trailing-icon .mdc-list-item__end{width:24px;height:24px}.mdc-list-item--with-trailing-meta.mdc-list-item--with-two-lines .mdc-list-item__end,.mdc-list-item--with-trailing-meta.mdc-list-item--with-three-lines .mdc-list-item__end{align-self:flex-start;margin-top:0}.mdc-list-item--with-trailing-meta.mdc-list-item{padding-left:auto;padding-right:0}[dir=rtl] .mdc-list-item--with-trailing-meta.mdc-list-item,.mdc-list-item--with-trailing-meta.mdc-list-item[dir=rtl]{padding-left:0;padding-right:auto}.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-left:28px;margin-right:16px}[dir=rtl] .mdc-list-item--with-trailing-meta .mdc-list-item__end,.mdc-list-item--with-trailing-meta .mdc-list-item__end[dir=rtl]{margin-left:16px;margin-right:28px}.mdc-list-item--with-trailing-meta.mdc-list-item--with-two-lines .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-trailing-meta.mdc-list-item--with-two-lines .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:28px;display:inline-block}.mdc-list-item--with-trailing-meta.mdc-list-item--with-three-lines .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-trailing-meta.mdc-list-item--with-three-lines .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:28px;display:inline-block}.mdc-list-item--with-trailing-meta .mdc-list-item__end{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-caption-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-caption-font-size,.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight,400);letter-spacing:.0333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing,.0333333em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform,inherit)}.mdc-list-item--with-trailing-checkbox.mdc-list-item{padding-left:auto;padding-right:0}[dir=rtl] .mdc-list-item--with-trailing-checkbox.mdc-list-item,.mdc-list-item--with-trailing-checkbox.mdc-list-item[dir=rtl]{padding-left:0;padding-right:auto}.mdc-list-item--with-trailing-checkbox .mdc-list-item__end{margin-left:24px;margin-right:8px}[dir=rtl] .mdc-list-item--with-trailing-checkbox .mdc-list-item__end,.mdc-list-item--with-trailing-checkbox .mdc-list-item__end[dir=rtl]{margin-left:8px;margin-right:24px}.mdc-list-item--with-trailing-checkbox .mdc-list-item__end{width:40px;height:40px}.mdc-list-item--with-trailing-checkbox.mdc-list-item--with-three-lines .mdc-list-item__end{align-self:flex-start;margin-top:8px}.mdc-list-item--with-trailing-radio.mdc-list-item{padding-left:auto;padding-right:0}[dir=rtl] .mdc-list-item--with-trailing-radio.mdc-list-item,.mdc-list-item--with-trailing-radio.mdc-list-item[dir=rtl]{padding-left:0;padding-right:auto}.mdc-list-item--with-trailing-radio .mdc-list-item__end{margin-left:24px;margin-right:8px}[dir=rtl] .mdc-list-item--with-trailing-radio .mdc-list-item__end,.mdc-list-item--with-trailing-radio .mdc-list-item__end[dir=rtl]{margin-left:8px;margin-right:24px}.mdc-list-item--with-trailing-radio .mdc-list-item__end{width:40px;height:40px}.mdc-list-item--with-trailing-radio.mdc-list-item--with-three-lines .mdc-list-item__end{align-self:flex-start;margin-top:8px}.mdc-list-item--with-trailing-switch.mdc-list-item{padding-left:auto;padding-right:0}[dir=rtl] .mdc-list-item--with-trailing-switch.mdc-list-item,.mdc-list-item--with-trailing-switch.mdc-list-item[dir=rtl]{padding-left:0;padding-right:auto}.mdc-list-item--with-trailing-switch .mdc-list-item__end,[dir=rtl] .mdc-list-item--with-trailing-switch .mdc-list-item__end,.mdc-list-item--with-trailing-switch .mdc-list-item__end[dir=rtl]{margin-left:16px;margin-right:16px}.mdc-list-item--with-trailing-switch .mdc-list-item__end{width:36px;height:20px}.mdc-list-item--with-trailing-switch.mdc-list-item--with-three-lines .mdc-list-item__end{align-self:flex-start;margin-top:16px}.mdc-list-group .mdc-deprecated-list{padding:0}.mdc-list-group__subheader{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);margin:.75rem 16px}.mdc-list-divider{background-color:#0000001f;background-clip:content-box;height:1px;padding:0}.mdc-list-divider.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-text.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-icon.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-image.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-thumbnail.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-avatar.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-checkbox.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-switch.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-radio.mdc-list-divider--with-leading-inset{padding-left:16px;padding-right:auto}[dir=rtl] .mdc-list-divider.mdc-list-divider--with-leading-inset,.mdc-list-divider.mdc-list-divider--with-leading-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-text.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-text.mdc-list-divider--with-leading-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-icon.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-icon.mdc-list-divider--with-leading-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-image.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-image.mdc-list-divider--with-leading-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-thumbnail.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-thumbnail.mdc-list-divider--with-leading-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-avatar.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-avatar.mdc-list-divider--with-leading-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-checkbox.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-checkbox.mdc-list-divider--with-leading-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-switch.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-switch.mdc-list-divider--with-leading-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-radio.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-radio.mdc-list-divider--with-leading-inset[dir=rtl],.mdc-list-divider.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-text.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-icon.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-image.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-thumbnail.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-avatar.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-checkbox.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-switch.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-radio.mdc-list-divider--with-trailing-inset{padding-left:auto;padding-right:16px}[dir=rtl] .mdc-list-divider.mdc-list-divider--with-trailing-inset,.mdc-list-divider.mdc-list-divider--with-trailing-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-text.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-text.mdc-list-divider--with-trailing-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-icon.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-icon.mdc-list-divider--with-trailing-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-image.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-image.mdc-list-divider--with-trailing-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-thumbnail.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-thumbnail.mdc-list-divider--with-trailing-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-avatar.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-avatar.mdc-list-divider--with-trailing-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-checkbox.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-checkbox.mdc-list-divider--with-trailing-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-switch.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-switch.mdc-list-divider--with-trailing-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-radio.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-radio.mdc-list-divider--with-trailing-inset[dir=rtl]{padding-left:16px;padding-right:auto}.mdc-list-divider--with-leading-video.mdc-list-divider--with-leading-inset{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-divider--with-leading-video.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-video.mdc-list-divider--with-leading-inset[dir=rtl]{padding-left:auto;padding-right:0}[dir=rtl] .mdc-list-divider,.mdc-list-divider[dir=rtl]{padding:0}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded .mdc-deprecated-list-item__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded .mdc-deprecated-list-item__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded--unbounded .mdc-deprecated-list-item__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded--foreground-activation .mdc-deprecated-list-item__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded--foreground-deactivation .mdc-deprecated-list-item__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded .mdc-list-item__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded .mdc-list-item__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded--unbounded .mdc-list-item__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded--foreground-activation .mdc-list-item__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded--foreground-deactivation .mdc-list-item__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple:after{width:200%;height:200%;top:-50%;left:-50%}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded .mdc-deprecated-list-item__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple:after{width:200%;height:200%;top:-50%;left:-50%}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded .mdc-list-item__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item:hover .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-surface--hover .mdc-deprecated-list-item__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded--background-focused .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item:not(.mdc-ripple-upgraded):focus .mdc-deprecated-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item:not(.mdc-ripple-upgraded) .mdc-deprecated-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item:not(.mdc-ripple-upgraded):active .mdc-deprecated-list-item__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item:hover .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-surface--hover .mdc-list-item__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item:not(.mdc-ripple-upgraded) .mdc-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item:not(.mdc-ripple-upgraded):active .mdc-list-item__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated .mdc-deprecated-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-activated-opacity,.12)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated .mdc-deprecated-list-item__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated:hover .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated.mdc-ripple-surface--hover .mdc-deprecated-list-item__ripple:before{opacity:.16;opacity:var(--mdc-ripple-hover-opacity,.16)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated.mdc-ripple-upgraded--background-focused .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated:not(.mdc-ripple-upgraded):focus .mdc-deprecated-list-item__ripple:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated:not(.mdc-ripple-upgraded) .mdc-deprecated-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated:not(.mdc-ripple-upgraded):active .mdc-deprecated-list-item__ripple:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-activated-opacity,.12)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated .mdc-list-item__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated:hover .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated.mdc-ripple-surface--hover .mdc-list-item__ripple:before{opacity:.16;opacity:var(--mdc-ripple-hover-opacity,.16)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated:not(.mdc-ripple-upgraded) .mdc-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated:not(.mdc-ripple-upgraded):active .mdc-list-item__ripple:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.24)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected .mdc-deprecated-list-item__ripple:before{opacity:.08;opacity:var(--mdc-ripple-selected-opacity,.08)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected .mdc-deprecated-list-item__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected:hover .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected.mdc-ripple-surface--hover .mdc-deprecated-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-hover-opacity,.12)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected.mdc-ripple-upgraded--background-focused .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):focus .mdc-deprecated-list-item__ripple:before{opacity:.2;opacity:var(--mdc-ripple-focus-opacity,.2);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded) .mdc-deprecated-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):active .mdc-deprecated-list-item__ripple:after{opacity:.2;opacity:var(--mdc-ripple-press-opacity,.2);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected .mdc-list-item__ripple:before{opacity:.08;opacity:var(--mdc-ripple-selected-opacity,.08)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected .mdc-list-item__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected:hover .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected.mdc-ripple-surface--hover .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-hover-opacity,.12)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.2;opacity:var(--mdc-ripple-focus-opacity,.2);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded) .mdc-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):active .mdc-list-item__ripple:after{opacity:.2;opacity:var(--mdc-ripple-press-opacity,.2);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.2)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-deprecated-list-item--disabled{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple:before,.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded .mdc-deprecated-list-item__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded .mdc-deprecated-list-item__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded--unbounded .mdc-deprecated-list-item__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded--foreground-activation .mdc-deprecated-list-item__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded--foreground-deactivation .mdc-deprecated-list-item__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-deprecated-list-item--disabled .mdc-list-item__ripple:before,.mdc-deprecated-list-item--disabled .mdc-list-item__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-deprecated-list-item--disabled .mdc-list-item__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-deprecated-list-item--disabled .mdc-list-item__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded .mdc-list-item__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded .mdc-list-item__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded--unbounded .mdc-list-item__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded--foreground-activation .mdc-list-item__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded--foreground-deactivation .mdc-list-item__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple:before,.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded .mdc-deprecated-list-item__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-deprecated-list-item--disabled .mdc-list-item__ripple:before,.mdc-deprecated-list-item--disabled .mdc-list-item__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded .mdc-list-item__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple:before,.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple:after,.mdc-deprecated-list-item--disabled .mdc-list-item__ripple:before,.mdc-deprecated-list-item--disabled .mdc-list-item__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded--background-focused .mdc-deprecated-list-item__ripple:before,.mdc-deprecated-list-item--disabled:not(.mdc-ripple-upgraded):focus .mdc-deprecated-list-item__ripple:before,.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,.mdc-deprecated-list-item--disabled:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple,.mdc-deprecated-list-item--disabled .mdc-list-item__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}:not(.mdc-list-item--disabled).mdc-list-item{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-upgraded .mdc-list-item__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-upgraded .mdc-list-item__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-upgraded--unbounded .mdc-list-item__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-upgraded--foreground-activation .mdc-list-item__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-upgraded--foreground-deactivation .mdc-list-item__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple:after{width:200%;height:200%;top:-50%;left:-50%}:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-upgraded .mdc-list-item__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}:not(.mdc-list-item--disabled).mdc-list-item:hover .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-surface--hover .mdc-list-item__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}:not(.mdc-list-item--disabled).mdc-list-item:not(.mdc-ripple-upgraded) .mdc-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-list-item--disabled).mdc-list-item:not(.mdc-ripple-upgraded):active .mdc-list-item__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}:not(.mdc-list-item--disabled).mdc-list-item--activated .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-activated-opacity,.12)}:not(.mdc-list-item--disabled).mdc-list-item--activated .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item--activated .mdc-list-item__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}:not(.mdc-list-item--disabled).mdc-list-item--activated:hover .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item--activated.mdc-ripple-surface--hover .mdc-list-item__ripple:before{opacity:.16;opacity:var(--mdc-ripple-hover-opacity,.16)}:not(.mdc-list-item--disabled).mdc-list-item--activated.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item--activated:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}:not(.mdc-list-item--disabled).mdc-list-item--activated:not(.mdc-ripple-upgraded) .mdc-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-list-item--disabled).mdc-list-item--activated:not(.mdc-ripple-upgraded):active .mdc-list-item__ripple:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}:not(.mdc-list-item--disabled).mdc-list-item--activated.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.24)}:not(.mdc-list-item--disabled).mdc-list-item--selected .mdc-list-item__ripple:before{opacity:.08;opacity:var(--mdc-ripple-selected-opacity,.08)}:not(.mdc-list-item--disabled).mdc-list-item--selected .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item--selected .mdc-list-item__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}:not(.mdc-list-item--disabled).mdc-list-item--selected:hover .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item--selected.mdc-ripple-surface--hover .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-hover-opacity,.12)}:not(.mdc-list-item--disabled).mdc-list-item--selected.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item--selected:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.2;opacity:var(--mdc-ripple-focus-opacity,.2);transition-duration:75ms}:not(.mdc-list-item--disabled).mdc-list-item--selected:not(.mdc-ripple-upgraded) .mdc-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-list-item--disabled).mdc-list-item--selected:not(.mdc-ripple-upgraded):active .mdc-list-item__ripple:after{opacity:.2;opacity:var(--mdc-ripple-press-opacity,.2);transition-duration:75ms}:not(.mdc-list-item--disabled).mdc-list-item--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.2)}:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-list-item--disabled{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-list-item--disabled .mdc-list-item__ripple:before,.mdc-list-item--disabled .mdc-list-item__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-list-item--disabled .mdc-list-item__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-list-item--disabled .mdc-list-item__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-list-item--disabled.mdc-ripple-upgraded .mdc-list-item__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-list-item--disabled.mdc-ripple-upgraded .mdc-list-item__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-list-item--disabled.mdc-ripple-upgraded--unbounded .mdc-list-item__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-list-item--disabled.mdc-ripple-upgraded--foreground-activation .mdc-list-item__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-list-item--disabled.mdc-ripple-upgraded--foreground-deactivation .mdc-list-item__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-list-item--disabled .mdc-list-item__ripple:before,.mdc-list-item--disabled .mdc-list-item__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-list-item--disabled.mdc-ripple-upgraded .mdc-list-item__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-list-item--disabled .mdc-list-item__ripple:before,.mdc-list-item--disabled .mdc-list-item__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}.mdc-list-item--disabled.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,.mdc-list-item--disabled:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-list-item--disabled .mdc-list-item__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-menu{min-width:var(--mdc-menu-min-width,112px);min-width:112px}.mdc-menu .mdc-deprecated-list-item__meta,.mdc-menu .mdc-deprecated-list-item__graphic{color:#000000de}.mdc-menu .mdc-deprecated-list{color:#000000de;position:relative}.mdc-menu .mdc-deprecated-list .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-menu .mdc-deprecated-list-divider{margin:8px 0}.mdc-menu .mdc-deprecated-list-item{-webkit-user-select:none;user-select:none}.mdc-menu .mdc-deprecated-list-item--disabled{cursor:auto}.mdc-menu a.mdc-deprecated-list-item .mdc-deprecated-list-item__text,.mdc-menu a.mdc-deprecated-list-item .mdc-deprecated-list-item__graphic{pointer-events:none}.mdc-menu__selection-group{fill:currentColor;padding:0}.mdc-menu__selection-group .mdc-deprecated-list-item{padding-left:56px;padding-right:16px}[dir=rtl] .mdc-menu__selection-group .mdc-deprecated-list-item,.mdc-menu__selection-group .mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:56px}.mdc-menu__selection-group .mdc-menu__selection-group-icon{left:16px;right:initial;display:none;position:absolute;top:50%;transform:translateY(-50%)}[dir=rtl] .mdc-menu__selection-group .mdc-menu__selection-group-icon,.mdc-menu__selection-group .mdc-menu__selection-group-icon[dir=rtl]{left:initial;right:16px}.mdc-menu-item--selected .mdc-menu__selection-group-icon{display:inline}.mdc-menu-surface{box-sizing:border-box;max-width:var(--mdc-menu-max-width,calc(100vw - 32px));max-height:var(--mdc-menu-max-height,calc(100vh - 32px));transform-origin:0 0;opacity:0;will-change:transform,opacity;z-index:8;background-color:#fff;background-color:var(--mdc-theme-surface,#fff);color:var(--mdc-theme-on-surface,#000);border-radius:4px;border-radius:var(--mdc-shape-medium,4px);transform-origin-left:top left;transform-origin-right:top right;max-width:calc(100vw - 32px);max-height:calc(100vh - 32px);margin:0;padding:0;transition:opacity 30ms linear,transform .12s cubic-bezier(0,0,.2,1),height .25s cubic-bezier(0,0,.2,1);display:none;position:absolute;overflow:auto;transform:scale(1);box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.mdc-menu-surface:focus{outline:none}.mdc-menu-surface--open{opacity:1;display:inline-block;transform:scale(1)}.mdc-menu-surface--animating-open{opacity:0;display:inline-block;transform:scale(.8)}.mdc-menu-surface--animating-closed{opacity:0;transition:opacity 75ms linear;display:inline-block}[dir=rtl] .mdc-menu-surface,.mdc-menu-surface[dir=rtl]{transform-origin-left:top right;transform-origin-right:top left}.mdc-menu-surface--anchor{position:relative;overflow:visible}.mdc-menu-surface--fixed{position:fixed}.mdc-menu-surface--fullwidth{width:100%}.mdc-radio{box-sizing:content-box;cursor:pointer;will-change:opacity,transform,border-color,color;flex:none;width:20px;height:20px;padding:10px;display:inline-block;position:relative}.mdc-radio .mdc-radio__native-control:enabled:not(:checked)+.mdc-radio__background .mdc-radio__outer-circle{border-color:#0000008a}.mdc-radio .mdc-radio__native-control:enabled:checked+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio .mdc-radio__native-control:enabled+.mdc-radio__background .mdc-radio__inner-circle{border-color:#018786;border-color:var(--mdc-theme-secondary,#018786)}.mdc-radio [aria-disabled=true] .mdc-radio__native-control:not(:checked)+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio .mdc-radio__native-control:disabled:not(:checked)+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio [aria-disabled=true] .mdc-radio__native-control:checked+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio .mdc-radio__native-control:disabled:checked+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio [aria-disabled=true] .mdc-radio__native-control+.mdc-radio__background .mdc-radio__inner-circle,.mdc-radio .mdc-radio__native-control:disabled+.mdc-radio__background .mdc-radio__inner-circle{border-color:#00000061}.mdc-radio .mdc-radio__background:before{background-color:#018786;background-color:var(--mdc-theme-secondary,#018786);width:40px;height:40px;top:-10px;left:-10px}.mdc-radio .mdc-radio__native-control{width:40px;height:40px;top:0;left:0;right:0}@media screen and (-ms-high-contrast:active){.mdc-radio [aria-disabled=true] .mdc-radio__native-control:not(:checked)+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio .mdc-radio__native-control:disabled:not(:checked)+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio [aria-disabled=true] .mdc-radio__native-control:checked+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio .mdc-radio__native-control:disabled:checked+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio [aria-disabled=true] .mdc-radio__native-control+.mdc-radio__background .mdc-radio__inner-circle,.mdc-radio .mdc-radio__native-control:disabled+.mdc-radio__background .mdc-radio__inner-circle{border-color:graytext}}.mdc-radio__background{box-sizing:border-box;width:20px;height:20px;display:inline-block;position:relative}.mdc-radio__background:before{opacity:0;pointer-events:none;content:\"\";border-radius:50%;transition:opacity .12s cubic-bezier(.4,0,.6,1),transform .12s cubic-bezier(.4,0,.6,1);position:absolute;transform:scale(0)}.mdc-radio__outer-circle{box-sizing:border-box;border-style:solid;border-width:2px;border-radius:50%;width:100%;height:100%;transition:border-color .12s cubic-bezier(.4,0,.6,1);position:absolute;top:0;left:0}.mdc-radio__inner-circle{box-sizing:border-box;border-style:solid;border-width:10px;border-radius:50%;width:100%;height:100%;transition:transform .12s cubic-bezier(.4,0,.6,1),border-color .12s cubic-bezier(.4,0,.6,1);position:absolute;top:0;left:0;transform:scale(0)}.mdc-radio__native-control{opacity:0;cursor:inherit;z-index:1;margin:0;padding:0;position:absolute}.mdc-radio--touch{margin:4px}.mdc-radio--touch .mdc-radio__native-control{width:48px;height:48px;top:-4px;left:-4px;right:-4px}.mdc-radio__native-control:checked+.mdc-radio__background,.mdc-radio__native-control:disabled+.mdc-radio__background{transition:opacity .12s cubic-bezier(0,0,.2,1),transform .12s cubic-bezier(0,0,.2,1)}.mdc-radio__native-control:checked+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio__native-control:disabled+.mdc-radio__background .mdc-radio__outer-circle{transition:border-color .12s cubic-bezier(0,0,.2,1)}.mdc-radio__native-control:checked+.mdc-radio__background .mdc-radio__inner-circle,.mdc-radio__native-control:disabled+.mdc-radio__background .mdc-radio__inner-circle{transition:transform .12s cubic-bezier(0,0,.2,1),border-color .12s cubic-bezier(0,0,.2,1)}.mdc-radio--disabled{cursor:default;pointer-events:none}.mdc-radio__native-control:checked+.mdc-radio__background .mdc-radio__inner-circle{transition:transform .12s cubic-bezier(0,0,.2,1),border-color .12s cubic-bezier(0,0,.2,1);transform:scale(.5)}.mdc-radio__native-control:disabled+.mdc-radio__background,[aria-disabled=true] .mdc-radio__native-control+.mdc-radio__background{cursor:default}.mdc-radio__native-control:focus+.mdc-radio__background:before{opacity:.12;transition:opacity .12s cubic-bezier(0,0,.2,1),transform .12s cubic-bezier(0,0,.2,1);transform:scale(1)}.mdc-radio{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-radio .mdc-radio__ripple:before,.mdc-radio .mdc-radio__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-radio .mdc-radio__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-radio .mdc-radio__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-radio.mdc-ripple-upgraded .mdc-radio__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-radio.mdc-ripple-upgraded .mdc-radio__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-radio.mdc-ripple-upgraded--unbounded .mdc-radio__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-radio.mdc-ripple-upgraded--foreground-activation .mdc-radio__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-radio.mdc-ripple-upgraded--foreground-deactivation .mdc-radio__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-radio .mdc-radio__ripple:before,.mdc-radio .mdc-radio__ripple:after{width:100%;height:100%;top:0%;left:0%}.mdc-radio.mdc-ripple-upgraded .mdc-radio__ripple:before,.mdc-radio.mdc-ripple-upgraded .mdc-radio__ripple:after{top:var(--mdc-ripple-top,calc(50% - 50%));left:var(--mdc-ripple-left,calc(50% - 50%));width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-radio.mdc-ripple-upgraded .mdc-radio__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-radio .mdc-radio__ripple:before,.mdc-radio .mdc-radio__ripple:after{background-color:#018786;background-color:var(--mdc-ripple-color,var(--mdc-theme-secondary,#018786))}.mdc-radio:hover .mdc-radio__ripple:before,.mdc-radio.mdc-ripple-surface--hover .mdc-radio__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-radio.mdc-ripple-upgraded--background-focused .mdc-radio__ripple:before,.mdc-radio:not(.mdc-ripple-upgraded):focus .mdc-radio__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-radio:not(.mdc-ripple-upgraded) .mdc-radio__ripple:after{transition:opacity .15s linear}.mdc-radio:not(.mdc-ripple-upgraded):active .mdc-radio__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-radio.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-radio.mdc-ripple-upgraded .mdc-radio__background:before,.mdc-radio.mdc-ripple-upgraded--background-focused .mdc-radio__background:before{content:none}.mdc-radio__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-ripple-surface{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity;outline:none;position:relative;overflow:hidden}.mdc-ripple-surface:before,.mdc-ripple-surface:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-ripple-surface:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-ripple-surface:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-ripple-surface.mdc-ripple-upgraded:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-ripple-surface.mdc-ripple-upgraded:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-ripple-surface.mdc-ripple-upgraded--unbounded:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-ripple-surface.mdc-ripple-upgraded--foreground-activation:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-ripple-surface.mdc-ripple-upgraded--foreground-deactivation:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-ripple-surface:before,.mdc-ripple-surface:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}.mdc-ripple-surface:hover:before,.mdc-ripple-surface.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-ripple-surface.mdc-ripple-upgraded--background-focused:before,.mdc-ripple-surface:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-ripple-surface:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-ripple-surface:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-ripple-surface.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-ripple-surface:before,.mdc-ripple-surface:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-ripple-surface.mdc-ripple-upgraded:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-ripple-surface[data-mdc-ripple-is-unbounded],.mdc-ripple-upgraded--unbounded{overflow:visible}.mdc-ripple-surface[data-mdc-ripple-is-unbounded]:before,.mdc-ripple-surface[data-mdc-ripple-is-unbounded]:after,.mdc-ripple-upgraded--unbounded:before,.mdc-ripple-upgraded--unbounded:after{width:100%;height:100%;top:0%;left:0%}.mdc-ripple-surface[data-mdc-ripple-is-unbounded].mdc-ripple-upgraded:before,.mdc-ripple-surface[data-mdc-ripple-is-unbounded].mdc-ripple-upgraded:after,.mdc-ripple-upgraded--unbounded.mdc-ripple-upgraded:before,.mdc-ripple-upgraded--unbounded.mdc-ripple-upgraded:after{top:var(--mdc-ripple-top,calc(50% - 50%));left:var(--mdc-ripple-left,calc(50% - 50%));width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-ripple-surface[data-mdc-ripple-is-unbounded].mdc-ripple-upgraded:after,.mdc-ripple-upgraded--unbounded.mdc-ripple-upgraded:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-segmented-button{font-size:0;display:inline-block}.mdc-segmented-button__segment{border-color:#0000001f;border-color:var(--mdc-segmented-button-outline-color,#0000001f);color:var(--mdc-segmented-button-unselected-ink-color,#0009);background-color:#fff;background-color:var(--mdc-segmented-button-unselected-container-fill-color,white)}.mdc-segmented-button__segment--selected{color:var(--mdc-segmented-button-selected-ink-color,#6200ee);background-color:#6200ee14;background-color:var(--mdc-segmented-button-selected-container-fill-color,#6200ee14)}.mdc-segmented-button__segment{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-button-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-button-font-size,.875rem);line-height:2.25rem;line-height:var(--mdc-typography-button-line-height,2.25rem);font-weight:500;font-weight:var(--mdc-typography-button-font-weight,500);letter-spacing:.0892857em;letter-spacing:var(--mdc-typography-button-letter-spacing,.0892857em);text-decoration:none;-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);text-decoration:var(--mdc-typography-button-text-decoration,none);text-transform:uppercase;text-transform:var(--mdc-typography-button-text-transform,uppercase);vertical-align:top;border-width:1px 0 1px 1px;align-items:center;min-width:48px;height:36px;padding:0 12px;display:inline-flex;position:relative}.mdc-segmented-button__segment .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-segmented-button__segment:hover{cursor:pointer}.mdc-segmented-button__segment:focus{outline-width:0}.mdc-segmented-button__segment:first-child{border-radius:4px 0 0 4px}.mdc-segmented-button__segment:last-child{border-right-width:1px;border-radius:0 4px 4px 0}.mdc-segmented-button__segment .mdc-segmented-button__segment__touch{height:48px;position:absolute;top:50%;left:0;right:0;transform:translateY(-50%)}.mdc-segmented-button__segment .mdc-segmented-button__segment--touch{margin-top:0;margin-bottom:0}.mdc-touch-target-wrapper .mdc-segmented-button__segment{border-right-width:0;border-radius:0}.mdc-touch-target-wrapper:first-child .mdc-segmented-button__segment{border-radius:4px 0 0 4px}.mdc-touch-target-wrapper:last-child .mdc-segmented-button__segment{border-right-width:1px;border-radius:0 4px 4px 0}.mdc-segmented-button__icon{width:24px;font-size:18px}.mdc-segmented-button__icon+.mdc-segmented-button__label{padding-left:6px}.mdc-segmented-button__segment{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity;overflow:hidden}.mdc-segmented-button__segment .mdc-segmented-button__ripple:before,.mdc-segmented-button__segment .mdc-segmented-button__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-segmented-button__segment .mdc-segmented-button__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-segmented-button__segment .mdc-segmented-button__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-segmented-button__segment.mdc-ripple-upgraded .mdc-segmented-button__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-segmented-button__segment.mdc-ripple-upgraded .mdc-segmented-button__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-segmented-button__segment.mdc-ripple-upgraded--unbounded .mdc-segmented-button__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-segmented-button__segment.mdc-ripple-upgraded--foreground-activation .mdc-segmented-button__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-segmented-button__segment.mdc-ripple-upgraded--foreground-deactivation .mdc-segmented-button__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-segmented-button__segment .mdc-segmented-button__ripple:before,.mdc-segmented-button__segment .mdc-segmented-button__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-segmented-button__segment.mdc-ripple-upgraded .mdc-segmented-button__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-segmented-button__segment .mdc-segmented-button__ripple:before,.mdc-segmented-button__segment .mdc-segmented-button__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,#6200ee)}.mdc-segmented-button__segment:hover .mdc-segmented-button__ripple:before,.mdc-segmented-button__segment.mdc-ripple-surface--hover .mdc-segmented-button__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-segmented-button__segment.mdc-ripple-upgraded--background-focused .mdc-segmented-button__ripple:before,.mdc-segmented-button__segment.mdc-ripple-upgraded:focus-within .mdc-segmented-button__ripple:before,.mdc-segmented-button__segment:not(.mdc-ripple-upgraded):focus .mdc-segmented-button__ripple:before,.mdc-segmented-button__segment:not(.mdc-ripple-upgraded):focus-within .mdc-segmented-button__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-segmented-button__segment:not(.mdc-ripple-upgraded) .mdc-segmented-button__ripple:after{transition:opacity .15s linear}.mdc-segmented-button__segment:not(.mdc-ripple-upgraded):active .mdc-segmented-button__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-segmented-button__segment.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-segmented-button__segment .mdc-segmented-button__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-slider__thumb{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-slider__thumb:before,.mdc-slider__thumb:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-slider__thumb:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-slider__thumb:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-slider__thumb.mdc-ripple-upgraded:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-slider__thumb.mdc-ripple-upgraded:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-slider__thumb.mdc-ripple-upgraded--unbounded:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-slider__thumb.mdc-ripple-upgraded--foreground-activation:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-slider__thumb.mdc-ripple-upgraded--foreground-deactivation:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-slider__thumb:before,.mdc-slider__thumb:after{width:100%;height:100%;top:0%;left:0%}.mdc-slider__thumb.mdc-ripple-upgraded:before,.mdc-slider__thumb.mdc-ripple-upgraded:after{top:var(--mdc-ripple-top,calc(50% - 50%));left:var(--mdc-ripple-left,calc(50% - 50%));width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-slider__thumb.mdc-ripple-upgraded:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-slider__thumb:before,.mdc-slider__thumb:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-slider__thumb:hover:before,.mdc-slider__thumb.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-slider__thumb.mdc-ripple-upgraded--background-focused:before,.mdc-slider__thumb:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-slider__thumb:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-slider__thumb:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-slider__thumb.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-slider{cursor:pointer;touch-action:pan-y;height:48px;margin:0 24px;position:relative}.mdc-slider .mdc-slider__track{width:100%;height:4px;position:absolute;top:50%;transform:translateY(-50%)}.mdc-slider .mdc-slider__track--active,.mdc-slider .mdc-slider__track--inactive{width:100%;height:100%;display:flex;position:absolute}.mdc-slider .mdc-slider__track--active{border-radius:3px;height:6px;top:-1px;overflow:hidden}.mdc-slider .mdc-slider__track--active_fill{box-sizing:border-box;transform-origin:0;border-top:6px solid;width:100%;height:100%;position:relative}[dir=rtl] .mdc-slider .mdc-slider__track--active_fill,.mdc-slider .mdc-slider__track--active_fill[dir=rtl]{transform-origin:100%}.mdc-slider .mdc-slider__track--inactive{border-radius:2px;height:4px;top:0;left:0}.mdc-slider .mdc-slider__track--inactive:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:1px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-slider .mdc-slider__track--active_fill{border-color:#6200ee;border-color:var(--mdc-theme-primary,#6200ee)}.mdc-slider.mdc-slider--disabled .mdc-slider__track--active_fill{border-color:#000;border-color:var(--mdc-theme-on-surface,#000)}.mdc-slider .mdc-slider__track--inactive{background-color:#6200ee;background-color:var(--mdc-theme-primary,#6200ee);opacity:.24}.mdc-slider.mdc-slider--disabled .mdc-slider__track--inactive{background-color:#000;background-color:var(--mdc-theme-on-surface,#000);opacity:.24}.mdc-slider .mdc-slider__value-indicator-container{pointer-events:none;position:absolute;bottom:44px;left:50%;transform:translate(-50%)}.mdc-slider .mdc-slider__value-indicator{transform-origin:bottom;border-radius:4px;align-items:center;height:32px;padding:0 12px;transition:transform .1s cubic-bezier(.4,0,1,1);display:flex;transform:scale(0)}.mdc-slider .mdc-slider__value-indicator:before{content:\"\";border-top:6px solid;border-left:6px solid #0000;border-right:6px solid #0000;width:0;height:0;position:absolute;bottom:-5px;left:50%;transform:translate(-50%)}.mdc-slider .mdc-slider__value-indicator:after{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:1px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-slider .mdc-slider__thumb--with-indicator .mdc-slider__value-indicator-container{pointer-events:auto}.mdc-slider .mdc-slider__thumb--with-indicator .mdc-slider__value-indicator{transition:transform .1s cubic-bezier(0,0,.2,1);transform:scale(1)}@media (prefers-reduced-motion){.mdc-slider .mdc-slider__value-indicator,.mdc-slider .mdc-slider__thumb--with-indicator .mdc-slider__value-indicator{transition:none}}.mdc-slider .mdc-slider__value-indicator-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-subtitle2-font-size,.875rem);line-height:1.375rem;line-height:var(--mdc-typography-subtitle2-line-height,1.375rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight,500);letter-spacing:.00714286em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing,.00714286em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform,inherit)}.mdc-slider .mdc-slider__value-indicator{opacity:.6;background-color:#000}.mdc-slider .mdc-slider__value-indicator:before{border-top-color:#000}.mdc-slider .mdc-slider__value-indicator{color:var(--mdc-theme-on-primary,#fff)}.mdc-slider .mdc-slider__thumb{-webkit-user-select:none;user-select:none;outline:none;width:48px;height:48px;display:flex;position:absolute;left:-24px}.mdc-slider .mdc-slider__thumb--top{z-index:1}.mdc-slider .mdc-slider__thumb--top .mdc-slider__thumb-knob,.mdc-slider .mdc-slider__thumb--top.mdc-slider__thumb:hover .mdc-slider__thumb-knob,.mdc-slider .mdc-slider__thumb--top.mdc-slider__thumb--focused .mdc-slider__thumb-knob{box-sizing:content-box;border:1px solid #fff}.mdc-slider .mdc-slider__thumb-knob{box-sizing:border-box;background-color:#6200ee;background-color:var(--mdc-theme-primary,#6200ee);border:10px solid #6200ee;border-color:var(--mdc-theme-primary,#6200ee);border-radius:50%;width:20px;height:20px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.mdc-slider.mdc-slider--disabled .mdc-slider__thumb-knob{background-color:#000;background-color:var(--mdc-theme-on-surface,#000);border-color:#000;border-color:var(--mdc-theme-on-surface,#000)}.mdc-slider .mdc-slider__thumb:before,.mdc-slider .mdc-slider__thumb:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-slider .mdc-slider__thumb:hover:before,.mdc-slider .mdc-slider__thumb.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-slider .mdc-slider__thumb.mdc-ripple-upgraded--background-focused:before,.mdc-slider .mdc-slider__thumb:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-slider .mdc-slider__thumb:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-slider .mdc-slider__thumb:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-slider .mdc-slider__thumb.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-slider .mdc-slider__tick-marks{box-sizing:border-box;justify-content:space-between;align-items:center;width:100%;height:100%;padding:0 1px;display:flex;position:absolute}.mdc-slider .mdc-slider__tick-mark--active,.mdc-slider .mdc-slider__tick-mark--inactive{border-radius:50%;width:2px;height:2px}.mdc-slider .mdc-slider__tick-mark--active,.mdc-slider.mdc-slider--disabled .mdc-slider__tick-mark--active{background-color:#fff;background-color:var(--mdc-theme-on-primary,#fff);opacity:.6}.mdc-slider .mdc-slider__tick-mark--inactive{background-color:#6200ee;background-color:var(--mdc-theme-primary,#6200ee);opacity:.6}.mdc-slider.mdc-slider--disabled .mdc-slider__tick-mark--inactive{background-color:#000;background-color:var(--mdc-theme-on-surface,#000);opacity:.6}.mdc-slider.mdc-slider--disabled{opacity:.38;cursor:auto}.mdc-slider.mdc-slider--disabled .mdc-slider__thumb{pointer-events:none}.mdc-slider--discrete .mdc-slider__thumb,.mdc-slider--discrete .mdc-slider__track--active_fill{transition:transform 80ms}@media (prefers-reduced-motion){.mdc-slider--discrete .mdc-slider__thumb,.mdc-slider--discrete .mdc-slider__track--active_fill{transition:none}}.mdc-slider__input{cursor:pointer;opacity:0;pointer-events:none;width:100%;height:100%;margin:0;position:absolute;top:0;left:0}.mdc-snackbar{z-index:8;box-sizing:border-box;pointer-events:none;-webkit-tap-highlight-color:#0000;justify-content:center;align-items:center;margin:8px;display:none;position:fixed;bottom:0;left:0;right:0}.mdc-snackbar__surface{background-color:#333}.mdc-snackbar__label{color:#ffffffde}.mdc-snackbar__surface{min-width:344px}@media (width<=480px),(width<=344px){.mdc-snackbar__surface{min-width:100%}}.mdc-snackbar__surface{border-radius:4px;border-radius:var(--mdc-shape-small,4px);max-width:672px;box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mdc-snackbar--opening,.mdc-snackbar--open,.mdc-snackbar--closing{display:flex}.mdc-snackbar--open .mdc-snackbar__label,.mdc-snackbar--open .mdc-snackbar__actions{visibility:visible}.mdc-snackbar--leading{justify-content:flex-start}.mdc-snackbar--stacked .mdc-snackbar__label{padding-bottom:12px;padding-left:16px;padding-right:8px}[dir=rtl] .mdc-snackbar--stacked .mdc-snackbar__label,.mdc-snackbar--stacked .mdc-snackbar__label[dir=rtl]{padding-left:8px;padding-right:16px}.mdc-snackbar--stacked .mdc-snackbar__surface{flex-direction:column;align-items:flex-start}.mdc-snackbar--stacked .mdc-snackbar__actions{align-self:flex-end;margin-bottom:8px}.mdc-snackbar__surface{box-sizing:border-box;opacity:0;justify-content:flex-start;align-items:center;padding-left:0;padding-right:8px;display:flex;transform:scale(.8)}.mdc-snackbar__surface:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:1px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}[dir=rtl] .mdc-snackbar__surface,.mdc-snackbar__surface[dir=rtl]{padding-left:8px;padding-right:0}.mdc-snackbar--open .mdc-snackbar__surface{opacity:1;pointer-events:auto;transition:opacity .15s cubic-bezier(0,0,.2,1),transform .15s cubic-bezier(0,0,.2,1);transform:scale(1)}.mdc-snackbar--closing .mdc-snackbar__surface{transition:opacity 75ms cubic-bezier(.4,0,1,1);transform:scale(1)}.mdc-snackbar__label{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);box-sizing:border-box;visibility:hidden;flex-grow:1;width:100%;margin:0;padding:14px 8px 14px 16px}[dir=rtl] .mdc-snackbar__label,.mdc-snackbar__label[dir=rtl]{padding-left:8px;padding-right:16px}.mdc-snackbar__label:before{content:attr(data-mdc-snackbar-label-text);display:inline}.mdc-snackbar__actions{box-sizing:border-box;visibility:hidden;flex-shrink:0;align-items:center;display:flex}.mdc-snackbar__action:not(:disabled){color:#bb86fc}.mdc-snackbar__action:before,.mdc-snackbar__action:after{background-color:#bb86fc;background-color:var(--mdc-ripple-color,#bb86fc)}.mdc-snackbar__action:hover:before,.mdc-snackbar__action.mdc-ripple-surface--hover:before{opacity:.08;opacity:var(--mdc-ripple-hover-opacity,.08)}.mdc-snackbar__action.mdc-ripple-upgraded--background-focused:before,.mdc-snackbar__action:not(.mdc-ripple-upgraded):focus:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}.mdc-snackbar__action:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-snackbar__action:not(.mdc-ripple-upgraded):active:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}.mdc-snackbar__action.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.24)}.mdc-snackbar__dismiss{color:#ffffffde}.mdc-snackbar__dismiss:before,.mdc-snackbar__dismiss:after{background-color:#ffffffde;background-color:var(--mdc-ripple-color,#ffffffde)}.mdc-snackbar__dismiss:hover:before,.mdc-snackbar__dismiss.mdc-ripple-surface--hover:before{opacity:.08;opacity:var(--mdc-ripple-hover-opacity,.08)}.mdc-snackbar__dismiss.mdc-ripple-upgraded--background-focused:before,.mdc-snackbar__dismiss:not(.mdc-ripple-upgraded):focus:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}.mdc-snackbar__dismiss:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-snackbar__dismiss:not(.mdc-ripple-upgraded):active:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}.mdc-snackbar__dismiss.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.24)}.mdc-snackbar__dismiss.mdc-snackbar__dismiss{width:36px;height:36px;padding:9px;font-size:18px}.mdc-snackbar__dismiss.mdc-snackbar__dismiss svg,.mdc-snackbar__dismiss.mdc-snackbar__dismiss img{width:18px;height:18px}.mdc-snackbar__action+.mdc-snackbar__dismiss{margin-left:8px;margin-right:0}[dir=rtl] .mdc-snackbar__action+.mdc-snackbar__dismiss,.mdc-snackbar__action+.mdc-snackbar__dismiss[dir=rtl]{margin-left:0;margin-right:8px}.mdc-switch__thumb-underlay{left:-14px;right:initial;width:48px;height:48px;top:-17px}[dir=rtl] .mdc-switch__thumb-underlay,.mdc-switch__thumb-underlay[dir=rtl]{left:initial;right:-14px}.mdc-switch__native-control{width:64px;height:48px}.mdc-switch{-webkit-user-select:none;user-select:none;outline:none;display:inline-block;position:relative}.mdc-switch.mdc-switch--checked .mdc-switch__track{background-color:#018786;background-color:var(--mdc-theme-secondary,#018786)}.mdc-switch.mdc-switch--checked .mdc-switch__thumb{background-color:#018786;background-color:var(--mdc-theme-secondary,#018786);border-color:#018786;border-color:var(--mdc-theme-secondary,#018786)}.mdc-switch:not(.mdc-switch--checked) .mdc-switch__track{background-color:#000;background-color:var(--mdc-theme-on-surface,#000)}.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb{background-color:#fff;background-color:var(--mdc-theme-surface,#fff);border-color:#fff;border-color:var(--mdc-theme-surface,#fff)}.mdc-switch__native-control{left:0;right:initial;opacity:0;cursor:pointer;pointer-events:auto;margin:0;transition:transform 90ms cubic-bezier(.4,0,.2,1);position:absolute;top:0}[dir=rtl] .mdc-switch__native-control,.mdc-switch__native-control[dir=rtl]{left:initial;right:0}.mdc-switch__track{box-sizing:border-box;opacity:.38;border:1px solid #0000;border-radius:7px;width:36px;height:14px;transition:opacity 90ms cubic-bezier(.4,0,.2,1),background-color 90ms cubic-bezier(.4,0,.2,1),border-color 90ms cubic-bezier(.4,0,.2,1)}.mdc-switch__thumb-underlay{justify-content:center;align-items:center;transition:transform 90ms cubic-bezier(.4,0,.2,1),background-color 90ms cubic-bezier(.4,0,.2,1),border-color 90ms cubic-bezier(.4,0,.2,1);display:flex;position:absolute;transform:translate(0)}.mdc-switch__thumb{box-sizing:border-box;pointer-events:none;z-index:1;border:10px solid;border-radius:50%;width:20px;height:20px;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mdc-switch--checked .mdc-switch__track{opacity:.54}.mdc-switch--checked .mdc-switch__thumb-underlay{transform:translate(16px)}[dir=rtl] .mdc-switch--checked .mdc-switch__thumb-underlay,.mdc-switch--checked .mdc-switch__thumb-underlay[dir=rtl],.mdc-switch--checked .mdc-switch__native-control{transform:translate(-16px)}[dir=rtl] .mdc-switch--checked .mdc-switch__native-control,.mdc-switch--checked .mdc-switch__native-control[dir=rtl]{transform:translate(16px)}.mdc-switch--disabled{opacity:.38;pointer-events:none}.mdc-switch--disabled .mdc-switch__thumb{border-width:1px}.mdc-switch--disabled .mdc-switch__native-control{cursor:default;pointer-events:none}.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay:before,.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay:after{background-color:#9e9e9e;background-color:var(--mdc-ripple-color,#9e9e9e)}.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay:hover:before,.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay.mdc-ripple-surface--hover:before{opacity:.08;opacity:var(--mdc-ripple-hover-opacity,.08)}.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay.mdc-ripple-upgraded--background-focused:before,.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay:not(.mdc-ripple-upgraded):focus:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay:not(.mdc-ripple-upgraded):active:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.24)}.mdc-switch__thumb-underlay{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-switch__thumb-underlay:before,.mdc-switch__thumb-underlay:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-switch__thumb-underlay:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-switch__thumb-underlay:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-switch__thumb-underlay.mdc-ripple-upgraded:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-switch__thumb-underlay.mdc-ripple-upgraded:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-switch__thumb-underlay.mdc-ripple-upgraded--unbounded:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-switch__thumb-underlay.mdc-ripple-upgraded--foreground-activation:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-switch__thumb-underlay.mdc-ripple-upgraded--foreground-deactivation:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-switch__thumb-underlay:before,.mdc-switch__thumb-underlay:after{width:100%;height:100%;top:0%;left:0%}.mdc-switch__thumb-underlay.mdc-ripple-upgraded:before,.mdc-switch__thumb-underlay.mdc-ripple-upgraded:after{top:var(--mdc-ripple-top,calc(50% - 50%));left:var(--mdc-ripple-left,calc(50% - 50%));width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-switch__thumb-underlay.mdc-ripple-upgraded:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-switch__thumb-underlay:before,.mdc-switch__thumb-underlay:after{background-color:#018786;background-color:var(--mdc-ripple-color,var(--mdc-theme-secondary,#018786))}.mdc-switch__thumb-underlay:hover:before,.mdc-switch__thumb-underlay.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-switch__thumb-underlay.mdc-ripple-upgraded--background-focused:before,.mdc-switch__thumb-underlay:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-switch__thumb-underlay:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-switch__thumb-underlay:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-switch__thumb-underlay.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-tab{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-button-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-button-font-size,.875rem);line-height:2.25rem;line-height:var(--mdc-typography-button-line-height,2.25rem);font-weight:500;font-weight:var(--mdc-typography-button-font-weight,500);letter-spacing:.0892857em;letter-spacing:var(--mdc-typography-button-letter-spacing,.0892857em);text-decoration:none;-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);text-decoration:var(--mdc-typography-button-text-decoration,none);text-transform:uppercase;text-transform:var(--mdc-typography-button-text-transform,uppercase);box-sizing:border-box;text-align:center;white-space:nowrap;cursor:pointer;-webkit-appearance:none;z-index:1;background:0 0;border:none;outline:none;flex:1 0 auto;justify-content:center;min-width:90px;margin:0;padding:0 24px;display:flex;position:relative}.mdc-tab .mdc-tab__text-label{color:#0009}.mdc-tab .mdc-tab__icon{color:#0000008a;fill:currentColor}.mdc-tab::-moz-focus-inner{border:0;padding:0}.mdc-tab--min-width{flex:0 auto}.mdc-tab__content{height:inherit;pointer-events:none;justify-content:center;align-items:center;display:flex;position:relative}.mdc-tab__text-label{z-index:2;line-height:1;transition:color .15s linear;display:inline-block}.mdc-tab__icon{z-index:2;width:24px;height:24px;font-size:24px;transition:color .15s linear}.mdc-tab--stacked .mdc-tab__content{flex-direction:column;justify-content:center;align-items:center}.mdc-tab--stacked .mdc-tab__text-label{padding-top:6px;padding-bottom:4px}.mdc-tab--active .mdc-tab__text-label{color:var(--mdc-theme-primary,#6200ee)}.mdc-tab--active .mdc-tab__icon{color:var(--mdc-theme-primary,#6200ee);fill:currentColor}.mdc-tab--active .mdc-tab__text-label,.mdc-tab--active .mdc-tab__icon{transition-delay:.1s}.mdc-tab:not(.mdc-tab--stacked) .mdc-tab__icon+.mdc-tab__text-label{padding-left:8px;padding-right:0}[dir=rtl] .mdc-tab:not(.mdc-tab--stacked) .mdc-tab__icon+.mdc-tab__text-label,.mdc-tab:not(.mdc-tab--stacked) .mdc-tab__icon+.mdc-tab__text-label[dir=rtl]{padding-left:0;padding-right:8px}.mdc-tab{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000}.mdc-tab .mdc-tab__ripple:before,.mdc-tab .mdc-tab__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-tab .mdc-tab__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-tab .mdc-tab__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-tab.mdc-ripple-upgraded .mdc-tab__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-tab.mdc-ripple-upgraded .mdc-tab__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-tab.mdc-ripple-upgraded--unbounded .mdc-tab__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-tab.mdc-ripple-upgraded--foreground-activation .mdc-tab__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-tab.mdc-ripple-upgraded--foreground-deactivation .mdc-tab__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-tab .mdc-tab__ripple:before,.mdc-tab .mdc-tab__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-tab.mdc-ripple-upgraded .mdc-tab__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-tab .mdc-tab__ripple:before,.mdc-tab .mdc-tab__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-tab:hover .mdc-tab__ripple:before,.mdc-tab.mdc-ripple-surface--hover .mdc-tab__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-tab.mdc-ripple-upgraded--background-focused .mdc-tab__ripple:before,.mdc-tab:not(.mdc-ripple-upgraded):focus .mdc-tab__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-tab:not(.mdc-ripple-upgraded) .mdc-tab__ripple:after{transition:opacity .15s linear}.mdc-tab:not(.mdc-ripple-upgraded):active .mdc-tab__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-tab.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-tab__ripple{will-change:transform,opacity;width:100%;height:100%;position:absolute;top:0;left:0;overflow:hidden}.mdc-tab-bar{width:100%}.mdc-tab{height:48px}.mdc-tab--stacked{height:72px}.mdc-tab-indicator{pointer-events:none;z-index:1;justify-content:center;width:100%;height:100%;display:flex;position:absolute;top:0;left:0}.mdc-tab-indicator .mdc-tab-indicator__content--underline{border-color:#6200ee;border-color:var(--mdc-theme-primary,#6200ee)}.mdc-tab-indicator .mdc-tab-indicator__content--icon{color:var(--mdc-theme-secondary,#018786)}.mdc-tab-indicator .mdc-tab-indicator__content--underline{border-top-width:2px}.mdc-tab-indicator .mdc-tab-indicator__content--icon{height:34px;font-size:34px}.mdc-tab-indicator__content{transform-origin:0;opacity:0}.mdc-tab-indicator__content--underline{box-sizing:border-box;border-top-style:solid;align-self:flex-end;width:100%}.mdc-tab-indicator__content--icon{align-self:center;margin:0 auto}.mdc-tab-indicator--active .mdc-tab-indicator__content{opacity:1}.mdc-tab-indicator .mdc-tab-indicator__content{transition:transform .25s cubic-bezier(.4,0,.2,1)}.mdc-tab-indicator--no-transition .mdc-tab-indicator__content{transition:none}.mdc-tab-indicator--fade .mdc-tab-indicator__content{transition:opacity .15s linear}.mdc-tab-indicator--active.mdc-tab-indicator--fade .mdc-tab-indicator__content{transition-delay:.1s}.mdc-tab-scroller{overflow-y:hidden}.mdc-tab-scroller.mdc-tab-scroller--animating .mdc-tab-scroller__scroll-content{transition:transform .25s cubic-bezier(.4,0,.2,1)}.mdc-tab-scroller__test{width:100px;height:100px;position:absolute;top:-9999px;overflow-x:scroll}.mdc-tab-scroller__scroll-area{-webkit-overflow-scrolling:touch;display:flex;overflow-x:hidden}.mdc-tab-scroller__scroll-area::-webkit-scrollbar{display:none}.mdc-tab-scroller__test::-webkit-scrollbar{display:none}.mdc-tab-scroller__scroll-area--scroll{overflow-x:scroll}.mdc-tab-scroller__scroll-content{will-change:transform;flex:1 0 auto;display:flex;position:relative;transform:none}.mdc-tab-scroller--align-start .mdc-tab-scroller__scroll-content{justify-content:flex-start}.mdc-tab-scroller--align-end .mdc-tab-scroller__scroll-content{justify-content:flex-end}.mdc-tab-scroller--align-center .mdc-tab-scroller__scroll-content{justify-content:center}.mdc-tab-scroller--animating .mdc-tab-scroller__scroll-area{-webkit-overflow-scrolling:auto}.mdc-text-field--filled{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-text-field--filled .mdc-text-field__ripple:before,.mdc-text-field--filled .mdc-text-field__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-text-field--filled .mdc-text-field__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-text-field--filled .mdc-text-field__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-text-field--filled.mdc-ripple-upgraded .mdc-text-field__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-text-field--filled.mdc-ripple-upgraded .mdc-text-field__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-text-field--filled.mdc-ripple-upgraded--unbounded .mdc-text-field__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-text-field--filled.mdc-ripple-upgraded--foreground-activation .mdc-text-field__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-text-field--filled.mdc-ripple-upgraded--foreground-deactivation .mdc-text-field__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-text-field--filled .mdc-text-field__ripple:before,.mdc-text-field--filled .mdc-text-field__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-text-field--filled.mdc-ripple-upgraded .mdc-text-field__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-text-field__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-text-field{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small,4px);border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small,4px);box-sizing:border-box;will-change:opacity,transform,color;border-bottom-right-radius:0;border-bottom-left-radius:0;align-items:baseline;padding:0 16px;display:inline-flex;position:relative;overflow:hidden}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-floating-label{color:#0009}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input{color:#000000de}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input::placeholder{color:#0000008a}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input:-ms-input-placeholder{color:#0000008a}.mdc-text-field .mdc-text-field__input{caret-color:var(--mdc-theme-primary,#6200ee)}.mdc-text-field:not(.mdc-text-field--disabled)+.mdc-text-field-helper-line .mdc-text-field-helper-text,.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field-character-counter,.mdc-text-field:not(.mdc-text-field--disabled)+.mdc-text-field-helper-line .mdc-text-field-character-counter{color:#0009}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__icon--leading,.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__icon--trailing{color:#0000008a}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__affix--prefix,.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__affix--suffix{color:#0009}.mdc-text-field .mdc-floating-label{pointer-events:none;top:50%;transform:translateY(-50%)}.mdc-text-field__input{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);appearance:none;background:0 0;border:none;border-radius:0;width:100%;min-width:0;height:28px;padding:0;transition:opacity .15s cubic-bezier(.4,0,.2,1)}.mdc-text-field__input::-ms-clear{display:none}.mdc-text-field__input::-webkit-calendar-picker-indicator{display:none}.mdc-text-field__input:focus{outline:none}.mdc-text-field__input:invalid{box-shadow:none}.mdc-text-field__input::placeholder{opacity:0;transition:opacity 67ms cubic-bezier(.4,0,.2,1)}.mdc-text-field__input:-ms-input-placeholder{opacity:0;transition:opacity 67ms cubic-bezier(.4,0,.2,1)}.mdc-text-field--no-label .mdc-text-field__input::placeholder,.mdc-text-field--focused .mdc-text-field__input::placeholder,:is(.mdc-text-field--no-label .mdc-text-field__input:-ms-input-placeholder,.mdc-text-field--focused .mdc-text-field__input:-ms-input-placeholder){opacity:1;transition-duration:.11s;transition-delay:40ms}.mdc-text-field__affix{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);opacity:0;white-space:nowrap;height:28px;transition:opacity .15s cubic-bezier(.4,0,.2,1)}.mdc-text-field--label-floating .mdc-text-field__affix,.mdc-text-field--no-label .mdc-text-field__affix{opacity:1}@supports ((-webkit-hyphens:none)){.mdc-text-field--outlined .mdc-text-field__affix{align-self:center;align-items:center;height:100%;display:inline-flex}}.mdc-text-field__affix--prefix{padding-left:0;padding-right:2px}[dir=rtl] .mdc-text-field__affix--prefix,.mdc-text-field__affix--prefix[dir=rtl]{padding-left:2px;padding-right:0}.mdc-text-field--end-aligned .mdc-text-field__affix--prefix{padding-left:0;padding-right:12px}[dir=rtl] .mdc-text-field--end-aligned .mdc-text-field__affix--prefix,.mdc-text-field--end-aligned .mdc-text-field__affix--prefix[dir=rtl],.mdc-text-field__affix--suffix{padding-left:12px;padding-right:0}[dir=rtl] .mdc-text-field__affix--suffix,.mdc-text-field__affix--suffix[dir=rtl]{padding-left:0;padding-right:12px}.mdc-text-field--end-aligned .mdc-text-field__affix--suffix{padding-left:2px;padding-right:0}[dir=rtl] .mdc-text-field--end-aligned .mdc-text-field__affix--suffix,.mdc-text-field--end-aligned .mdc-text-field__affix--suffix[dir=rtl]{padding-left:0;padding-right:2px}.mdc-text-field--filled{height:56px}.mdc-text-field--filled .mdc-text-field__ripple:before,.mdc-text-field--filled .mdc-text-field__ripple:after{background-color:#000000de;background-color:var(--mdc-ripple-color,#000000de)}.mdc-text-field--filled:hover .mdc-text-field__ripple:before,.mdc-text-field--filled.mdc-ripple-surface--hover .mdc-text-field__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-text-field--filled.mdc-ripple-upgraded--background-focused .mdc-text-field__ripple:before,.mdc-text-field--filled:not(.mdc-ripple-upgraded):focus .mdc-text-field__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-text-field--filled:before{content:\"\";vertical-align:0;width:0;height:40px;display:inline-block}.mdc-text-field--filled:not(.mdc-text-field--disabled){background-color:#f5f5f5}.mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple:before{border-bottom-color:#0000006b}.mdc-text-field--filled:not(.mdc-text-field--disabled):hover .mdc-line-ripple:before{border-bottom-color:#000000de}.mdc-text-field--filled .mdc-line-ripple:after{border-bottom-color:#6200ee;border-bottom-color:var(--mdc-theme-primary,#6200ee)}.mdc-text-field--filled .mdc-floating-label{left:16px;right:initial}[dir=rtl] .mdc-text-field--filled .mdc-floating-label,.mdc-text-field--filled .mdc-floating-label[dir=rtl]{left:initial;right:16px}.mdc-text-field--filled .mdc-floating-label--float-above{transform:translateY(-106%)scale(.75)}.mdc-text-field--filled.mdc-text-field--no-label .mdc-text-field__input{height:100%}.mdc-text-field--filled.mdc-text-field--no-label .mdc-floating-label,.mdc-text-field--filled.mdc-text-field--no-label:before{display:none}@supports ((-webkit-hyphens:none)){.mdc-text-field--filled.mdc-text-field--no-label .mdc-text-field__affix{align-self:center;align-items:center;height:100%;display:inline-flex}}.mdc-text-field--outlined{height:56px;overflow:visible}.mdc-text-field--outlined .mdc-floating-label--float-above{font-size:.75rem;transform:translateY(-37.25px)scale(1)}.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem;transform:translateY(-34.75px)scale(.75)}.mdc-text-field--outlined .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-text-field-outlined}@keyframes mdc-floating-label-shake-float-above-text-field-outlined{0%{transform:translate(0)translateY(-34.75px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(4%)translateY(-34.75px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(-4%)translateY(-34.75px)scale(.75)}to{transform:translate(0)translateY(-34.75px)scale(.75)}}.mdc-text-field--outlined .mdc-text-field__input{height:100%}.mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__leading,.mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__notch,.mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing{border-color:#00000061}.mdc-text-field--outlined:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__leading,.mdc-text-field--outlined:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__notch,.mdc-text-field--outlined:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__trailing{border-color:#000000de}.mdc-text-field--outlined:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__leading,.mdc-text-field--outlined:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__notch,.mdc-text-field--outlined:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__trailing{border-color:#6200ee;border-color:var(--mdc-theme-primary,#6200ee)}.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small,4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small,4px)}[dir=rtl] .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading,.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading[dir=rtl]{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small,4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small,4px);border-bottom-left-radius:0}@supports (top:max(0%)){.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading{width:max(12px,var(--mdc-shape-small,4px))}.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__notch{max-width:calc(100% - max(12px,var(--mdc-shape-small,4px))*2)}}.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__trailing{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small,4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small,4px);border-bottom-left-radius:0}[dir=rtl] .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__trailing,.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__trailing[dir=rtl]{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small,4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small,4px)}@supports (top:max(0%)){.mdc-text-field--outlined,.mdc-text-field--outlined+.mdc-text-field-helper-line{padding-left:max(16px,calc(var(--mdc-shape-small,4px) + 4px));padding-right:max(16px,var(--mdc-shape-small,4px))}}.mdc-text-field--outlined.mdc-text-field--with-leading-icon{padding-left:0}@supports (top:max(0%)){.mdc-text-field--outlined.mdc-text-field--with-leading-icon{padding-right:max(16px,var(--mdc-shape-small,4px))}}[dir=rtl] .mdc-text-field--outlined.mdc-text-field--with-leading-icon,.mdc-text-field--outlined.mdc-text-field--with-leading-icon[dir=rtl]{padding-right:0}@supports (top:max(0%)){[dir=rtl] .mdc-text-field--outlined.mdc-text-field--with-leading-icon,.mdc-text-field--outlined.mdc-text-field--with-leading-icon[dir=rtl]{padding-left:max(16px,var(--mdc-shape-small,4px))}}.mdc-text-field--outlined.mdc-text-field--with-trailing-icon{padding-right:0}@supports (top:max(0%)){.mdc-text-field--outlined.mdc-text-field--with-trailing-icon{padding-left:max(16px,calc(var(--mdc-shape-small,4px) + 4px))}}[dir=rtl] .mdc-text-field--outlined.mdc-text-field--with-trailing-icon,.mdc-text-field--outlined.mdc-text-field--with-trailing-icon[dir=rtl]{padding-left:0}@supports (top:max(0%)){[dir=rtl] .mdc-text-field--outlined.mdc-text-field--with-trailing-icon,.mdc-text-field--outlined.mdc-text-field--with-trailing-icon[dir=rtl]{padding-right:max(16px,calc(var(--mdc-shape-small,4px) + 4px))}}.mdc-text-field--outlined.mdc-text-field--with-leading-icon.mdc-text-field--with-trailing-icon{padding-left:0;padding-right:0}.mdc-text-field--outlined .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:1px}.mdc-text-field--outlined .mdc-text-field__ripple:before,.mdc-text-field--outlined .mdc-text-field__ripple:after{content:none}.mdc-text-field--outlined .mdc-floating-label{left:4px;right:initial}[dir=rtl] .mdc-text-field--outlined .mdc-floating-label,.mdc-text-field--outlined .mdc-floating-label[dir=rtl]{left:initial;right:4px}.mdc-text-field--outlined .mdc-text-field__input{background-color:#0000;display:flex;border:none!important}.mdc-text-field--outlined .mdc-notched-outline{z-index:1}.mdc-text-field--textarea{flex-direction:column;align-items:center;width:auto;height:auto;padding:0;transition:none}.mdc-text-field--textarea .mdc-floating-label{top:19px}.mdc-text-field--textarea .mdc-floating-label:not(.mdc-floating-label--float-above){transform:none}.mdc-text-field--textarea .mdc-text-field__input{box-sizing:border-box;resize:none;flex-grow:1;height:auto;min-height:1.5rem;padding:0 16px;line-height:1.5rem;overflow:hidden auto}.mdc-text-field--textarea.mdc-text-field--filled:before{display:none}.mdc-text-field--textarea.mdc-text-field--filled .mdc-floating-label--float-above{transform:translateY(-10.25px)scale(.75)}.mdc-text-field--textarea.mdc-text-field--filled .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-textarea-filled}@keyframes mdc-floating-label-shake-float-above-textarea-filled{0%{transform:translate(0)translateY(-10.25px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(4%)translateY(-10.25px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(-4%)translateY(-10.25px)scale(.75)}to{transform:translate(0)translateY(-10.25px)scale(.75)}}.mdc-text-field--textarea.mdc-text-field--filled .mdc-text-field__input{margin-top:23px;margin-bottom:9px}.mdc-text-field--textarea.mdc-text-field--filled.mdc-text-field--no-label .mdc-text-field__input{margin-top:16px;margin-bottom:16px}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:0}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-floating-label--float-above{font-size:.75rem;transform:translateY(-27.25px)scale(1)}.mdc-text-field--textarea.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--textarea.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem;transform:translateY(-24.75px)scale(.75)}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-textarea-outlined}@keyframes mdc-floating-label-shake-float-above-textarea-outlined{0%{transform:translate(0)translateY(-24.75px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(4%)translateY(-24.75px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(-4%)translateY(-24.75px)scale(.75)}to{transform:translate(0)translateY(-24.75px)scale(.75)}}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-text-field__input{margin-top:16px;margin-bottom:16px}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-floating-label{top:18px}.mdc-text-field--textarea.mdc-text-field--with-internal-counter .mdc-text-field__input{margin-bottom:2px}.mdc-text-field--textarea.mdc-text-field--with-internal-counter .mdc-text-field-character-counter{align-self:flex-end;padding:0 16px}.mdc-text-field--textarea.mdc-text-field--with-internal-counter .mdc-text-field-character-counter:after{content:\"\";vertical-align:-16px;width:0;height:16px;display:inline-block}.mdc-text-field--textarea.mdc-text-field--with-internal-counter .mdc-text-field-character-counter:before{display:none}.mdc-text-field__resizer{resize:both;flex-direction:column;flex-grow:1;align-self:stretch;min-width:-webkit-fill-available;max-width:100%;min-height:56px;max-height:100%;display:inline-flex;overflow:hidden}.mdc-text-field--filled .mdc-text-field__resizer{transform:translateY(-1px)}.mdc-text-field--filled .mdc-text-field__resizer .mdc-text-field__input,.mdc-text-field--filled .mdc-text-field__resizer .mdc-text-field-character-counter{transform:translateY(1px)}.mdc-text-field--outlined .mdc-text-field__resizer{transform:translate(-1px)translateY(-1px)}[dir=rtl] .mdc-text-field--outlined .mdc-text-field__resizer,.mdc-text-field--outlined .mdc-text-field__resizer[dir=rtl]{transform:translate(1px)translateY(-1px)}.mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field__input,.mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field-character-counter{transform:translate(1px)translateY(1px)}[dir=rtl] .mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field__input,.mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field__input[dir=rtl],[dir=rtl] .mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field-character-counter,.mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field-character-counter[dir=rtl]{transform:translate(-1px)translateY(1px)}.mdc-text-field--with-leading-icon{padding-left:0;padding-right:16px}[dir=rtl] .mdc-text-field--with-leading-icon,.mdc-text-field--with-leading-icon[dir=rtl]{padding-left:16px;padding-right:0}.mdc-text-field--with-leading-icon.mdc-text-field--filled .mdc-floating-label{left:48px;right:initial;max-width:calc(100% - 48px)}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--filled .mdc-floating-label,.mdc-text-field--with-leading-icon.mdc-text-field--filled .mdc-floating-label[dir=rtl]{left:initial;right:48px}.mdc-text-field--with-leading-icon.mdc-text-field--filled .mdc-floating-label--float-above{max-width:calc(133.333% - 85.3333px)}.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label{left:36px;right:initial}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label[dir=rtl]{left:initial;right:36px}.mdc-text-field--with-leading-icon.mdc-text-field--outlined :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 60px)}.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above{transform:translateY(-37.25px)translate(-32px)scale(1)}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above[dir=rtl]{transform:translateY(-37.25px)translate(32px)scale(1)}.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above{font-size:.75rem}.mdc-text-field--with-leading-icon.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-34.75px)translate(-32px)scale(.75)}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above[dir=rtl],[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above[dir=rtl]{transform:translateY(-34.75px)translate(32px)scale(.75)}.mdc-text-field--with-leading-icon.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-text-field-outlined-leading-icon}@keyframes mdc-floating-label-shake-float-above-text-field-outlined-leading-icon{0%{transform:translate(calc(0 - 32px))translateY(-34.75px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(calc(4% - 32px))translateY(-34.75px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(calc(-4% - 32px))translateY(-34.75px)scale(.75)}to{transform:translate(calc(0 - 32px))translateY(-34.75px)scale(.75)}}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--shake,.mdc-text-field--with-leading-icon.mdc-text-field--outlined[dir=rtl] .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-text-field-outlined-leading-icon}@keyframes mdc-floating-label-shake-float-above-text-field-outlined-leading-icon-rtl{0%{transform:translate(calc(0 + 32px))translateY(-34.75px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(calc(4% + 32px))translateY(-34.75px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(calc(32px - 4%))translateY(-34.75px)scale(.75)}to{transform:translate(calc(0 + 32px))translateY(-34.75px)scale(.75)}}.mdc-text-field--with-trailing-icon{padding-left:16px;padding-right:0}[dir=rtl] .mdc-text-field--with-trailing-icon,.mdc-text-field--with-trailing-icon[dir=rtl]{padding-left:0;padding-right:16px}.mdc-text-field--with-trailing-icon.mdc-text-field--filled .mdc-floating-label{max-width:calc(100% - 64px)}.mdc-text-field--with-trailing-icon.mdc-text-field--filled .mdc-floating-label--float-above{max-width:calc(133.333% - 85.3333px)}.mdc-text-field--with-trailing-icon.mdc-text-field--outlined :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 60px)}.mdc-text-field--with-leading-icon.mdc-text-field--with-trailing-icon{padding-left:0;padding-right:0}.mdc-text-field--with-leading-icon.mdc-text-field--with-trailing-icon.mdc-text-field--filled .mdc-floating-label{max-width:calc(100% - 96px)}.mdc-text-field--with-leading-icon.mdc-text-field--with-trailing-icon.mdc-text-field--filled .mdc-floating-label--float-above{max-width:calc(133.333% - 128px)}.mdc-text-field-helper-line{box-sizing:border-box;justify-content:space-between;display:flex}.mdc-text-field+.mdc-text-field-helper-line{padding-left:16px;padding-right:16px}.mdc-form-field>.mdc-text-field+label{align-self:flex-start}.mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label{color:#6200eede}.mdc-text-field--focused .mdc-notched-outline__leading,.mdc-text-field--focused .mdc-notched-outline__notch,.mdc-text-field--focused .mdc-notched-outline__trailing{border-width:2px}.mdc-text-field--focused+.mdc-text-field-helper-line .mdc-text-field-helper-text:not(.mdc-text-field-helper-text--validation-msg){opacity:1}.mdc-text-field--focused.mdc-text-field--outlined .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:2px}.mdc-text-field--focused.mdc-text-field--outlined.mdc-text-field--textarea .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:0}.mdc-text-field--invalid:not(.mdc-text-field--disabled):hover .mdc-line-ripple:before,.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple:after{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error,#b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-floating-label,.mdc-text-field--invalid:not(.mdc-text-field--disabled).mdc-text-field--invalid+.mdc-text-field-helper-line .mdc-text-field-helper-text--validation-msg{color:var(--mdc-theme-error,#b00020)}.mdc-text-field--invalid .mdc-text-field__input{caret-color:var(--mdc-theme-error,#b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-text-field__icon--trailing{color:var(--mdc-theme-error,#b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple:before{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error,#b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-notched-outline__leading,.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-notched-outline__notch,.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing,.mdc-text-field--invalid:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__leading,.mdc-text-field--invalid:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__notch,.mdc-text-field--invalid:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__trailing,.mdc-text-field--invalid:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__leading,.mdc-text-field--invalid:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__notch,.mdc-text-field--invalid:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__trailing{border-color:#b00020;border-color:var(--mdc-theme-error,#b00020)}.mdc-text-field--invalid+.mdc-text-field-helper-line .mdc-text-field-helper-text--validation-msg{opacity:1}.mdc-text-field--disabled{pointer-events:none}.mdc-text-field--disabled .mdc-text-field__input{color:#00000061}.mdc-text-field--disabled .mdc-text-field__input::placeholder{color:#00000061}.mdc-text-field--disabled .mdc-text-field__input:-ms-input-placeholder{color:#00000061}.mdc-text-field--disabled .mdc-floating-label,.mdc-text-field--disabled+.mdc-text-field-helper-line .mdc-text-field-helper-text,.mdc-text-field--disabled .mdc-text-field-character-counter,.mdc-text-field--disabled+.mdc-text-field-helper-line .mdc-text-field-character-counter{color:#00000061}.mdc-text-field--disabled .mdc-text-field__icon--leading,.mdc-text-field--disabled .mdc-text-field__icon--trailing{color:#0000004d}.mdc-text-field--disabled .mdc-text-field__affix--prefix,.mdc-text-field--disabled .mdc-text-field__affix--suffix{color:#00000061}.mdc-text-field--disabled .mdc-line-ripple:before{border-bottom-color:#0000000f}.mdc-text-field--disabled .mdc-notched-outline__leading,.mdc-text-field--disabled .mdc-notched-outline__notch,.mdc-text-field--disabled .mdc-notched-outline__trailing{border-color:#0000000f}@media screen and (-ms-high-contrast:active){.mdc-text-field--disabled .mdc-text-field__input::placeholder{color:graytext}.mdc-text-field--disabled .mdc-text-field__input:-ms-input-placeholder{color:graytext}.mdc-text-field--disabled .mdc-floating-label,.mdc-text-field--disabled+.mdc-text-field-helper-line .mdc-text-field-helper-text,.mdc-text-field--disabled .mdc-text-field-character-counter,.mdc-text-field--disabled+.mdc-text-field-helper-line .mdc-text-field-character-counter,.mdc-text-field--disabled .mdc-text-field__icon--leading,.mdc-text-field--disabled .mdc-text-field__icon--trailing,.mdc-text-field--disabled .mdc-text-field__affix--prefix,.mdc-text-field--disabled .mdc-text-field__affix--suffix{color:graytext}.mdc-text-field--disabled .mdc-line-ripple:before{border-bottom-color:graytext}.mdc-text-field--disabled .mdc-notched-outline__leading,.mdc-text-field--disabled .mdc-notched-outline__notch,.mdc-text-field--disabled .mdc-notched-outline__trailing{border-color:graytext}}.mdc-text-field--disabled .mdc-floating-label{cursor:default}.mdc-text-field--disabled.mdc-text-field--filled{background-color:#fafafa}.mdc-text-field--disabled.mdc-text-field--filled .mdc-text-field__ripple{display:none}.mdc-text-field--disabled .mdc-text-field__input{pointer-events:auto}.mdc-text-field--end-aligned .mdc-text-field__input{text-align:right}[dir=rtl] .mdc-text-field--end-aligned .mdc-text-field__input,.mdc-text-field--end-aligned .mdc-text-field__input[dir=rtl]{text-align:left}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__input,[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__input,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix{direction:ltr}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix--prefix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix--prefix{padding-left:0;padding-right:2px}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix--suffix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix--suffix{padding-left:12px;padding-right:0}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__icon--leading,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__icon--leading{order:1}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix--suffix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix--suffix{order:2}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__input,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__input{order:3}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix--prefix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix--prefix{order:4}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__icon--trailing,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__icon--trailing{order:5}[dir=rtl] .mdc-text-field--ltr-text.mdc-text-field--end-aligned .mdc-text-field__input,.mdc-text-field--ltr-text.mdc-text-field--end-aligned[dir=rtl] .mdc-text-field__input{text-align:right}[dir=rtl] .mdc-text-field--ltr-text.mdc-text-field--end-aligned .mdc-text-field__affix--prefix,.mdc-text-field--ltr-text.mdc-text-field--end-aligned[dir=rtl] .mdc-text-field__affix--prefix{padding-right:12px}[dir=rtl] .mdc-text-field--ltr-text.mdc-text-field--end-aligned .mdc-text-field__affix--suffix,.mdc-text-field--ltr-text.mdc-text-field--end-aligned[dir=rtl] .mdc-text-field__affix--suffix{padding-left:2px}.mdc-text-field-helper-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-caption-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-caption-font-size,.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight,400);letter-spacing:.0333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing,.0333333em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform,inherit);opacity:0;will-change:opacity;margin:0;line-height:normal;transition:opacity .15s cubic-bezier(.4,0,.2,1);display:block}.mdc-text-field-helper-text:before{content:\"\";vertical-align:0;width:0;height:16px;display:inline-block}.mdc-text-field-helper-text--persistent{opacity:1;will-change:initial;transition:none}.mdc-text-field-character-counter{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-caption-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-caption-font-size,.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight,400);letter-spacing:.0333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing,.0333333em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform,inherit);white-space:nowrap;margin-top:0;margin-left:auto;margin-right:0;padding-left:16px;padding-right:0;line-height:normal;display:block}.mdc-text-field-character-counter:before{content:\"\";vertical-align:0;width:0;height:16px;display:inline-block}[dir=rtl] .mdc-text-field-character-counter,.mdc-text-field-character-counter[dir=rtl]{margin-left:0;margin-right:auto;padding-left:0;padding-right:16px}.mdc-text-field__icon{cursor:pointer;align-self:center}.mdc-text-field__icon:not([tabindex]),.mdc-text-field__icon[tabindex=\"-1\"]{cursor:default;pointer-events:none}.mdc-text-field__icon svg{display:block}.mdc-text-field__icon--leading{margin-left:16px;margin-right:8px}[dir=rtl] .mdc-text-field__icon--leading,.mdc-text-field__icon--leading[dir=rtl]{margin-left:8px;margin-right:16px}.mdc-text-field__icon--trailing{margin-left:0;margin-right:0;padding:12px}[dir=rtl] .mdc-text-field__icon--trailing,.mdc-text-field__icon--trailing[dir=rtl]{margin-left:0;margin-right:0}:root{--mdc-theme-primary:#6200ee;--mdc-theme-secondary:#018786;--mdc-theme-background:#fff;--mdc-theme-surface:#fff;--mdc-theme-error:#b00020;--mdc-theme-on-primary:#fff;--mdc-theme-on-secondary:#fff;--mdc-theme-on-surface:#000;--mdc-theme-on-error:#fff;--mdc-theme-text-primary-on-background:#000000de;--mdc-theme-text-secondary-on-background:#0000008a;--mdc-theme-text-hint-on-background:#00000061;--mdc-theme-text-disabled-on-background:#00000061;--mdc-theme-text-icon-on-background:#00000061;--mdc-theme-text-primary-on-light:#000000de;--mdc-theme-text-secondary-on-light:#0000008a;--mdc-theme-text-hint-on-light:#00000061;--mdc-theme-text-disabled-on-light:#00000061;--mdc-theme-text-icon-on-light:#00000061;--mdc-theme-text-primary-on-dark:white;--mdc-theme-text-secondary-on-dark:#ffffffb3;--mdc-theme-text-hint-on-dark:#ffffff80;--mdc-theme-text-disabled-on-dark:#ffffff80;--mdc-theme-text-icon-on-dark:#ffffff80}.mdc-theme--primary{color:var(--mdc-theme-primary,#6200ee)!important}.mdc-theme--secondary{color:var(--mdc-theme-secondary,#018786)!important}.mdc-theme--background{background-color:#fff;background-color:var(--mdc-theme-background,#fff)}.mdc-theme--surface{background-color:#fff;background-color:var(--mdc-theme-surface,#fff)}.mdc-theme--error{color:var(--mdc-theme-error,#b00020)!important}.mdc-theme--on-primary{color:var(--mdc-theme-on-primary,#fff)!important}.mdc-theme--on-secondary{color:var(--mdc-theme-on-secondary,#fff)!important}.mdc-theme--on-surface{color:var(--mdc-theme-on-surface,#000)!important}.mdc-theme--on-error{color:var(--mdc-theme-on-error,#fff)!important}.mdc-theme--text-primary-on-background{color:var(--mdc-theme-text-primary-on-background,#000000de)!important}.mdc-theme--text-secondary-on-background{color:var(--mdc-theme-text-secondary-on-background,#0000008a)!important}.mdc-theme--text-hint-on-background{color:var(--mdc-theme-text-hint-on-background,#00000061)!important}.mdc-theme--text-disabled-on-background{color:var(--mdc-theme-text-disabled-on-background,#00000061)!important}.mdc-theme--text-icon-on-background{color:var(--mdc-theme-text-icon-on-background,#00000061)!important}.mdc-theme--text-primary-on-light{color:var(--mdc-theme-text-primary-on-light,#000000de)!important}.mdc-theme--text-secondary-on-light{color:var(--mdc-theme-text-secondary-on-light,#0000008a)!important}.mdc-theme--text-hint-on-light{color:var(--mdc-theme-text-hint-on-light,#00000061)!important}.mdc-theme--text-disabled-on-light{color:var(--mdc-theme-text-disabled-on-light,#00000061)!important}.mdc-theme--text-icon-on-light{color:var(--mdc-theme-text-icon-on-light,#00000061)!important}.mdc-theme--text-primary-on-dark{color:var(--mdc-theme-text-primary-on-dark,white)!important}.mdc-theme--text-secondary-on-dark{color:var(--mdc-theme-text-secondary-on-dark,#ffffffb3)!important}.mdc-theme--text-hint-on-dark{color:var(--mdc-theme-text-hint-on-dark,#ffffff80)!important}.mdc-theme--text-disabled-on-dark{color:var(--mdc-theme-text-disabled-on-dark,#ffffff80)!important}.mdc-theme--text-icon-on-dark{color:var(--mdc-theme-text-icon-on-dark,#ffffff80)!important}.mdc-theme--primary-bg{background-color:#6200ee!important;background-color:var(--mdc-theme-primary,#6200ee)!important}.mdc-theme--secondary-bg{background-color:#018786!important;background-color:var(--mdc-theme-secondary,#018786)!important}.mdc-tooltip__surface,.mdc-tooltip__caret-surface-top,.mdc-tooltip__caret-surface-bottom{border-radius:4px;border-radius:var(--mdc-shape-small,4px)}.mdc-tooltip__surface{color:var(--mdc-theme-text-primary-on-dark,white);word-break:break-all;word-break:var(--mdc-tooltip-word-break,normal);overflow-wrap:anywhere;background-color:#0009}.mdc-tooltip{z-index:2}.mdc-tooltip--showing-transition .mdc-tooltip__surface-animation{transition:opacity .15s cubic-bezier(0,0,.2,1),transform .15s cubic-bezier(0,0,.2,1)}.mdc-tooltip--hide-transition .mdc-tooltip__surface-animation{transition:opacity 75ms cubic-bezier(.4,0,1,1)}.mdc-tooltip__title{color:var(--mdc-theme-text-primary-on-light,#000000de)}.mdc-tooltip__content{color:#0009}.mdc-tooltip__content-link{color:var(--mdc-theme-primary,#6200ee)}.mdc-tooltip{display:none;position:fixed}.mdc-tooltip.mdc-tooltip--rich .mdc-tooltip__surface,.mdc-tooltip.mdc-tooltip--rich .mdc-tooltip__caret-surface-top,.mdc-tooltip.mdc-tooltip--rich .mdc-tooltip__caret-surface-bottom{background-color:#fff}.mdc-tooltip-wrapper--rich{position:relative}.mdc-tooltip--shown,.mdc-tooltip--showing,.mdc-tooltip--hide{display:inline-flex}.mdc-tooltip--shown.mdc-tooltip--rich,.mdc-tooltip--showing.mdc-tooltip--rich,.mdc-tooltip--hide.mdc-tooltip--rich{display:inline-block;position:absolute;left:-320px}.mdc-tooltip__surface{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-caption-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-caption-font-size,.75rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight,400);letter-spacing:.0333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing,.0333333em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform,inherit);box-sizing:border-box;text-align:center;min-width:40px;max-width:200px;min-height:24px;max-height:40vh;padding:4px 8px;line-height:16px;overflow:hidden}.mdc-tooltip__surface:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:1px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-tooltip--rich .mdc-tooltip__surface{border-radius:4px;flex-direction:column;align-items:flex-start;min-width:40px;max-width:320px;min-height:24px;line-height:20px;display:flex;position:relative;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mdc-tooltip--rich .mdc-tooltip__surface .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-tooltip--multiline .mdc-tooltip__surface{text-align:left}[dir=rtl] .mdc-tooltip--multiline .mdc-tooltip__surface,.mdc-tooltip--multiline .mdc-tooltip__surface[dir=rtl]{text-align:right}.mdc-tooltip__surface .mdc-tooltip__title{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;line-height:normal;font-family:var(--mdc-typography-subtitle2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-subtitle2-font-size,.875rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight,500);letter-spacing:.00714286em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing,.00714286em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform,inherit);margin:0 8px;display:block}.mdc-tooltip__surface .mdc-tooltip__title:before{content:\"\";vertical-align:0;width:0;height:28px;display:inline-block}.mdc-tooltip__surface .mdc-tooltip__content{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;line-height:normal;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);text-align:left;max-width:calc(100% - 16px);margin:0 8px 16px;display:block}.mdc-tooltip__surface .mdc-tooltip__content:before{content:\"\";vertical-align:0;width:0;height:24px;display:inline-block}[dir=rtl] .mdc-tooltip__surface .mdc-tooltip__content,.mdc-tooltip__surface .mdc-tooltip__content[dir=rtl]{text-align:right}.mdc-tooltip__surface .mdc-tooltip__content-link{text-decoration:none}.mdc-tooltip__surface-animation{opacity:0;will-change:transform,opacity;transform:scale(.8)}.mdc-tooltip--shown .mdc-tooltip__surface-animation{opacity:1;transform:scale(1)}.mdc-tooltip--hide .mdc-tooltip__surface-animation{transform:scale(1)}.mdc-tooltip__caret-surface-top,.mdc-tooltip__caret-surface-bottom{width:24px;height:24px;position:absolute}.mdc-tooltip__caret-surface-top .mdc-elevation-overlay,.mdc-tooltip__caret-surface-bottom .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-tooltip__caret-surface-bottom{z-index:-1;outline:1px solid #0000;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mdc-top-app-bar{background-color:#6200ee;background-color:var(--mdc-theme-primary,#6200ee);color:#fff;box-sizing:border-box;z-index:4;flex-direction:column;justify-content:space-between;width:100%;display:flex;position:fixed}.mdc-top-app-bar .mdc-top-app-bar__action-item,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon{color:var(--mdc-theme-on-primary,#fff)}.mdc-top-app-bar .mdc-top-app-bar__action-item:before,.mdc-top-app-bar .mdc-top-app-bar__action-item:after,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:after{background-color:#fff;background-color:var(--mdc-ripple-color,var(--mdc-theme-on-primary,#fff))}.mdc-top-app-bar .mdc-top-app-bar__action-item:hover:before,.mdc-top-app-bar .mdc-top-app-bar__action-item.mdc-ripple-surface--hover:before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:hover:before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon.mdc-ripple-surface--hover:before{opacity:.08;opacity:var(--mdc-ripple-hover-opacity,.08)}.mdc-top-app-bar .mdc-top-app-bar__action-item.mdc-ripple-upgraded--background-focused:before,.mdc-top-app-bar .mdc-top-app-bar__action-item:not(.mdc-ripple-upgraded):focus:before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon.mdc-ripple-upgraded--background-focused:before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:not(.mdc-ripple-upgraded):focus:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}.mdc-top-app-bar .mdc-top-app-bar__action-item:not(.mdc-ripple-upgraded):after,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-top-app-bar .mdc-top-app-bar__action-item:not(.mdc-ripple-upgraded):active:after,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:not(.mdc-ripple-upgraded):active:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}.mdc-top-app-bar .mdc-top-app-bar__action-item.mdc-ripple-upgraded,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.24)}.mdc-top-app-bar__row{box-sizing:border-box;width:100%;height:64px;display:flex;position:relative}.mdc-top-app-bar__section{z-index:1;flex:auto;align-items:center;min-width:0;padding:8px 12px;display:inline-flex}.mdc-top-app-bar__section--align-start{order:-1;justify-content:flex-start}.mdc-top-app-bar__section--align-end{order:1;justify-content:flex-end}.mdc-top-app-bar__title{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline6-font-family,var(--mdc-typography-font-family,inherit));font-size:1.25rem;font-size:var(--mdc-typography-headline6-font-size,1.25rem);line-height:2rem;line-height:var(--mdc-typography-headline6-line-height,2rem);font-weight:500;font-weight:var(--mdc-typography-headline6-font-weight,500);letter-spacing:.0125em;letter-spacing:var(--mdc-typography-headline6-letter-spacing,.0125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline6-text-transform,inherit);text-overflow:ellipsis;white-space:nowrap;z-index:1;padding-left:20px;padding-right:0;overflow:hidden}[dir=rtl] .mdc-top-app-bar__title,.mdc-top-app-bar__title[dir=rtl]{padding-left:0;padding-right:20px}.mdc-top-app-bar--short-collapsed{border-radius:0 0 24px}[dir=rtl] .mdc-top-app-bar--short-collapsed,.mdc-top-app-bar--short-collapsed[dir=rtl]{border-radius:0 0 0 24px}.mdc-top-app-bar--short{width:100%;transition:width .25s cubic-bezier(.4,0,.2,1);top:0;left:0;right:auto}[dir=rtl] .mdc-top-app-bar--short,.mdc-top-app-bar--short[dir=rtl]{left:auto;right:0}.mdc-top-app-bar--short .mdc-top-app-bar__row{height:56px}.mdc-top-app-bar--short .mdc-top-app-bar__section{padding:4px}.mdc-top-app-bar--short .mdc-top-app-bar__title{opacity:1;transition:opacity .2s cubic-bezier(.4,0,.2,1)}.mdc-top-app-bar--short-collapsed{width:56px;transition:width .3s cubic-bezier(.4,0,.2,1);box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mdc-top-app-bar--short-collapsed .mdc-top-app-bar__title{display:none}.mdc-top-app-bar--short-collapsed .mdc-top-app-bar__action-item{transition:padding .15s cubic-bezier(.4,0,.2,1)}.mdc-top-app-bar--short-collapsed.mdc-top-app-bar--short-has-action-item{width:112px}.mdc-top-app-bar--short-collapsed.mdc-top-app-bar--short-has-action-item .mdc-top-app-bar__section--align-end{padding-left:0;padding-right:12px}[dir=rtl] .mdc-top-app-bar--short-collapsed.mdc-top-app-bar--short-has-action-item .mdc-top-app-bar__section--align-end,.mdc-top-app-bar--short-collapsed.mdc-top-app-bar--short-has-action-item .mdc-top-app-bar__section--align-end[dir=rtl]{padding-left:12px;padding-right:0}.mdc-top-app-bar--dense .mdc-top-app-bar__row{height:48px}.mdc-top-app-bar--dense .mdc-top-app-bar__section{padding:0 4px}.mdc-top-app-bar--dense .mdc-top-app-bar__title{padding-left:12px;padding-right:0}[dir=rtl] .mdc-top-app-bar--dense .mdc-top-app-bar__title,.mdc-top-app-bar--dense .mdc-top-app-bar__title[dir=rtl]{padding-left:0;padding-right:12px}.mdc-top-app-bar--prominent .mdc-top-app-bar__row{height:128px}.mdc-top-app-bar--prominent .mdc-top-app-bar__title{align-self:flex-end;padding-bottom:2px}.mdc-top-app-bar--prominent .mdc-top-app-bar__action-item,.mdc-top-app-bar--prominent .mdc-top-app-bar__navigation-icon{align-self:flex-start}.mdc-top-app-bar--fixed{transition:box-shadow .2s linear}.mdc-top-app-bar--fixed-scrolled{transition:box-shadow .2s linear;box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__row{height:96px}.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__section{padding:0 12px}.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__title{padding-bottom:9px;padding-left:20px;padding-right:0}[dir=rtl] .mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__title,.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__title[dir=rtl]{padding-left:0;padding-right:20px}.mdc-top-app-bar--fixed-adjust{padding-top:64px}.mdc-top-app-bar--dense-fixed-adjust{padding-top:48px}.mdc-top-app-bar--short-fixed-adjust{padding-top:56px}.mdc-top-app-bar--prominent-fixed-adjust{padding-top:128px}.mdc-top-app-bar--dense-prominent-fixed-adjust{padding-top:96px}@media (width<=599px){.mdc-top-app-bar__row{height:56px}.mdc-top-app-bar__section{padding:4px}.mdc-top-app-bar--short{transition:width .2s cubic-bezier(.4,0,.2,1)}.mdc-top-app-bar--short-collapsed{transition:width .25s cubic-bezier(.4,0,.2,1)}.mdc-top-app-bar--short-collapsed .mdc-top-app-bar__section--align-end{padding-left:0;padding-right:12px}[dir=rtl] .mdc-top-app-bar--short-collapsed .mdc-top-app-bar__section--align-end,.mdc-top-app-bar--short-collapsed .mdc-top-app-bar__section--align-end[dir=rtl]{padding-left:12px;padding-right:0}.mdc-top-app-bar--prominent .mdc-top-app-bar__title{padding-bottom:6px}.mdc-top-app-bar--fixed-adjust{padding-top:56px}}.mdc-typography{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-font-family,inherit)}.mdc-typography--headline1{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline1-font-family,var(--mdc-typography-font-family,inherit));font-size:6rem;font-size:var(--mdc-typography-headline1-font-size,6rem);line-height:6rem;line-height:var(--mdc-typography-headline1-line-height,6rem);font-weight:300;font-weight:var(--mdc-typography-headline1-font-weight,300);letter-spacing:-.015625em;letter-spacing:var(--mdc-typography-headline1-letter-spacing,-.015625em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline1-text-decoration,inherit);text-decoration:var(--mdc-typography-headline1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline1-text-transform,inherit)}.mdc-typography--headline2{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline2-font-family,var(--mdc-typography-font-family,inherit));font-size:3.75rem;font-size:var(--mdc-typography-headline2-font-size,3.75rem);line-height:3.75rem;line-height:var(--mdc-typography-headline2-line-height,3.75rem);font-weight:300;font-weight:var(--mdc-typography-headline2-font-weight,300);letter-spacing:-.00833333em;letter-spacing:var(--mdc-typography-headline2-letter-spacing,-.00833333em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline2-text-decoration,inherit);text-decoration:var(--mdc-typography-headline2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline2-text-transform,inherit)}.mdc-typography--headline3{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline3-font-family,var(--mdc-typography-font-family,inherit));font-size:3rem;font-size:var(--mdc-typography-headline3-font-size,3rem);line-height:3.125rem;line-height:var(--mdc-typography-headline3-line-height,3.125rem);font-weight:400;font-weight:var(--mdc-typography-headline3-font-weight,400);letter-spacing:normal;letter-spacing:var(--mdc-typography-headline3-letter-spacing,normal);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline3-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline3-text-decoration,inherit);text-decoration:var(--mdc-typography-headline3-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline3-text-transform,inherit)}.mdc-typography--headline4{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline4-font-family,var(--mdc-typography-font-family,inherit));font-size:2.125rem;font-size:var(--mdc-typography-headline4-font-size,2.125rem);line-height:2.5rem;line-height:var(--mdc-typography-headline4-line-height,2.5rem);font-weight:400;font-weight:var(--mdc-typography-headline4-font-weight,400);letter-spacing:.00735294em;letter-spacing:var(--mdc-typography-headline4-letter-spacing,.00735294em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline4-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline4-text-decoration,inherit);text-decoration:var(--mdc-typography-headline4-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline4-text-transform,inherit)}.mdc-typography--headline5{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline5-font-family,var(--mdc-typography-font-family,inherit));font-size:1.5rem;font-size:var(--mdc-typography-headline5-font-size,1.5rem);line-height:2rem;line-height:var(--mdc-typography-headline5-line-height,2rem);font-weight:400;font-weight:var(--mdc-typography-headline5-font-weight,400);letter-spacing:normal;letter-spacing:var(--mdc-typography-headline5-letter-spacing,normal);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline5-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline5-text-decoration,inherit);text-decoration:var(--mdc-typography-headline5-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline5-text-transform,inherit)}.mdc-typography--headline6{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline6-font-family,var(--mdc-typography-font-family,inherit));font-size:1.25rem;font-size:var(--mdc-typography-headline6-font-size,1.25rem);line-height:2rem;line-height:var(--mdc-typography-headline6-line-height,2rem);font-weight:500;font-weight:var(--mdc-typography-headline6-font-weight,500);letter-spacing:.0125em;letter-spacing:var(--mdc-typography-headline6-letter-spacing,.0125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline6-text-transform,inherit)}.mdc-typography--subtitle1{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit)}.mdc-typography--subtitle2{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-subtitle2-font-size,.875rem);line-height:1.375rem;line-height:var(--mdc-typography-subtitle2-line-height,1.375rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight,500);letter-spacing:.00714286em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing,.00714286em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform,inherit)}.mdc-typography--body1{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-body1-font-size,1rem);line-height:1.5rem;line-height:var(--mdc-typography-body1-line-height,1.5rem);font-weight:400;font-weight:var(--mdc-typography-body1-font-weight,400);letter-spacing:.03125em;letter-spacing:var(--mdc-typography-body1-letter-spacing,.03125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body1-text-transform,inherit)}.mdc-typography--body2{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit)}.mdc-typography--caption{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-caption-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-caption-font-size,.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight,400);letter-spacing:.0333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing,.0333333em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform,inherit)}.mdc-typography--button{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-button-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-button-font-size,.875rem);line-height:2.25rem;line-height:var(--mdc-typography-button-line-height,2.25rem);font-weight:500;font-weight:var(--mdc-typography-button-font-weight,500);letter-spacing:.0892857em;letter-spacing:var(--mdc-typography-button-letter-spacing,.0892857em);text-decoration:none;-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);text-decoration:var(--mdc-typography-button-text-decoration,none);text-transform:uppercase;text-transform:var(--mdc-typography-button-text-transform,uppercase)}.mdc-typography--overline{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-overline-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-overline-font-size,.75rem);line-height:2rem;line-height:var(--mdc-typography-overline-line-height,2rem);font-weight:500;font-weight:var(--mdc-typography-overline-font-weight,500);letter-spacing:.166667em;letter-spacing:var(--mdc-typography-overline-letter-spacing,.166667em);text-decoration:none;-webkit-text-decoration:var(--mdc-typography-overline-text-decoration,none);-webkit-text-decoration:var(--mdc-typography-overline-text-decoration,none);text-decoration:var(--mdc-typography-overline-text-decoration,none);text-transform:uppercase;text-transform:var(--mdc-typography-overline-text-transform,uppercase)}.material-icons-outlined,.material-icons{text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;-webkit-font-smoothing:antialiased;text-rendering:optimizelegibility;-moz-osx-font-smoothing:grayscale;direction:ltr;font-family:Material Icons Outlined;font-size:24px;font-style:normal;font-weight:400;line-height:1;display:inline-block}@font-face{font-family:Material Icons Outlined;font-style:normal;font-display:swap;font-weight:400;src:url(material-icons-outlined-all-400-normal.d9672557.woff2)format(\"woff2\"),url(material-icons-outlined-all-400-normal.7ace03fd.woff)format(\"woff\")}:host{--mdc-typography-headline1-font-size:96px;--mdc-typography-headline1-line-height:96px;--mdc-typography-headline2-font-size:60px;--mdc-typography-headline2-line-height:60px;--mdc-typography-headline3-font-size:48px;--mdc-typography-headline3-line-height:50px;--mdc-typography-headline4-font-size:34px;--mdc-typography-headline4-line-height:40px;--mdc-typography-headline5-font-size:24px;--mdc-typography-headline5-line-height:32px;--mdc-typography-headline6-font-size:20px;--mdc-typography-headline6-line-height:32px;--mdc-typography-subtitle1-font-size:16px;--mdc-typography-subtitle1-line-height:28px;--mdc-typography-subtitle2-font-size:14px;--mdc-typography-subtitle2-line-height:22px;--mdc-typography-body1-font-size:16px;--mdc-typography-body1-line-height:24px;--mdc-typography-body2-font-size:14px;--mdc-typography-body2-line-height:20px;--mdc-typography-caption-font-size:12px;--mdc-typography-caption-line-height:20px;--mdc-typography-button-font-size:14px;--mdc-typography-button-line-height:36px;--mdc-typography-overline-font-size:12px;--mdc-typography-overline-line-height:32px;font-size:16px}.mdc-select--outlined .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:16px}.mdc-select--outlined .mdc-floating-label,.mdc-floating-label,.mdc-select--outlined .mdc-notched-outline,.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__notch{line-height:16px}h1{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline4-font-family,var(--mdc-typography-font-family,inherit));font-size:2.125rem;font-size:var(--mdc-typography-headline4-font-size,2.125rem);line-height:2.5rem;line-height:var(--mdc-typography-headline4-line-height,2.5rem);font-weight:400;font-weight:var(--mdc-typography-headline4-font-weight,400);letter-spacing:.00735294em;letter-spacing:var(--mdc-typography-headline4-letter-spacing,.00735294em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline4-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline4-text-decoration,inherit);text-decoration:var(--mdc-typography-headline4-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline4-text-transform,inherit)}h2{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline5-font-family,var(--mdc-typography-font-family,inherit));font-size:1.5rem;font-size:var(--mdc-typography-headline5-font-size,1.5rem);line-height:2rem;line-height:var(--mdc-typography-headline5-line-height,2rem);font-weight:400;font-weight:var(--mdc-typography-headline5-font-weight,400);letter-spacing:normal;letter-spacing:var(--mdc-typography-headline5-letter-spacing,normal);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline5-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline5-text-decoration,inherit);text-decoration:var(--mdc-typography-headline5-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline5-text-transform,inherit)}h3{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline6-font-family,var(--mdc-typography-font-family,inherit));font-size:1.25rem;font-size:var(--mdc-typography-headline6-font-size,1.25rem);line-height:2rem;line-height:var(--mdc-typography-headline6-line-height,2rem);font-weight:500;font-weight:var(--mdc-typography-headline6-font-weight,500);letter-spacing:.0125em;letter-spacing:var(--mdc-typography-headline6-letter-spacing,.0125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline6-text-transform,inherit)}h4{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit)}h5{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-subtitle2-font-size,.875rem);line-height:1.375rem;line-height:var(--mdc-typography-subtitle2-line-height,1.375rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight,500);letter-spacing:.00714286em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing,.00714286em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform,inherit)}h6{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-overline-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-overline-font-size,.75rem);line-height:2rem;line-height:var(--mdc-typography-overline-line-height,2rem);font-weight:500;font-weight:var(--mdc-typography-overline-font-weight,500);letter-spacing:.166667em;letter-spacing:var(--mdc-typography-overline-letter-spacing,.166667em);text-decoration:none;-webkit-text-decoration:var(--mdc-typography-overline-text-decoration,none);-webkit-text-decoration:var(--mdc-typography-overline-text-decoration,none);text-decoration:var(--mdc-typography-overline-text-decoration,none);text-transform:uppercase;text-transform:var(--mdc-typography-overline-text-transform,uppercase)}p{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-body1-font-size,1rem);line-height:1.5rem;line-height:var(--mdc-typography-body1-line-height,1.5rem);font-weight:400;font-weight:var(--mdc-typography-body1-font-weight,400);letter-spacing:.03125em;letter-spacing:var(--mdc-typography-body1-letter-spacing,.03125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body1-text-transform,inherit)}h1+h1,h1+h2,h1+h3,h1+h4,h1+h5,h1+h6,h1+p,h2+h1,h2+h2,h2+h3,h2+h4,h2+h5,h2+h6,h2+p,h3+h1,h3+h2,h3+h3,h3+h4,h3+h5,h3+h6,h3+p,h4+h1,h4+h2,h4+h3,h4+h4,h4+h5,h4+h6,h4+p,h5+h1,h5+h2,h5+h3,h5+h4,h5+h5,h5+h6,h5+p,h6+h1,h6+h2,h6+h3,h6+h4,h6+h5,h6+h6,h6+p,p+h1,p+h2,p+h3,p+h4,p+h5,p+h6,p+p{margin-top:0}h1,h2,h3,h4,h5,h6{align-items:center;display:flex}h1 .mdc-touch-target-wrapper,h2 .mdc-touch-target-wrapper,h3 .mdc-touch-target-wrapper,h4 .mdc-touch-target-wrapper,h5 .mdc-touch-target-wrapper,h6 .mdc-touch-target-wrapper{margin-left:auto}.form-wrapper{flex-flow:column;display:flex}.form-wrapper__inner{flex-flow:row;gap:24px;display:flex}.menu{background-color:#f5f5f5;border-right:1px solid #ccc;flex:none;width:-moz-fit-content;width:fit-content;max-width:300px}.menu-item__text,.menu .mdc-deprecated-list-group__subheader{text-overflow:ellipsis;white-space:collapse nowrap;display:block;overflow:hidden}.menu .mdc-deprecated-list-group__subheader{color:var(--mdc-theme-primary,#6200ee)}.menu .mdc-deprecated-list{margin-bottom:26px}.page__buttons{flex-flow:row-reverse wrap;margin-top:16px;display:flex}.page__buttons .page-button--prev{margin-right:auto}.ticket{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-body1-font-size,1rem);line-height:1.5rem;line-height:var(--mdc-typography-body1-line-height,1.5rem);font-weight:400;font-weight:var(--mdc-typography-body1-font-weight,400);letter-spacing:.03125em;letter-spacing:var(--mdc-typography-body1-letter-spacing,.03125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body1-text-transform,inherit);flex-flow:column;align-items:stretch;line-height:24px;display:flex}.ticket--summary.ticket{align-items:stretch}.ticket--disabled{color:var(--mdc-theme-text-hint-on-background,#00000061)}.ticket+.ticket{margin-top:16px}.ticket__label{cursor:pointer;flex-flow:row;font-weight:700;display:flex}.ticket--summary .ticket__label{cursor:default}.ticket--disabled .ticket__label{cursor:not-allowed}.ticket__native-control{flex:none;width:48px;height:24px;position:relative}.ticket__native-control .mdc-touch-target-wrapper{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.ticket__price{margin-left:auto;padding-left:8px}.ticket__description{color:var(--mdc-theme-text-hint-on-background,#00000061);margin-left:48px}.ticket__error{color:var(--mdc-theme-error,#b00020);margin-left:48px}.form-field-wrapper{flex-flow:wrap;margin-left:-16px;margin-right:-16px;display:flex}.form-field{flex:none;min-width:calc(50% - 32px);max-width:calc(100% - 32px);padding-left:16px;padding-right:16px}.form-field--full-width{min-width:calc(100% - 32px)}.form-field--checkbox,.form-field--radio-group{max-width:calc(100% - 116dppx);min-width:calc(50% - 16px);padding-left:0}.form-field--checkbox.form-field--full-width,.form-field--radio-group.form-field--full-width{min-width:calc(100% - 16px)}.form-field--radio-group{flex-flow:column;display:flex}.form-field--checkbox .mdc-form-field+.mdc-text-field-helper-line,.form-field--radio-group .mdc-form-field+.mdc-text-field-helper-line{padding-left:52px}.form-field mdc-text-field,.form-field mdc-select{width:100%}.form-field--summary{align-items:center;min-height:2rem;display:flex}.form-field label p:first-child{margin-top:0}.form-field label p:last-child{margin-bottom:0}.mdc-text-field-helper-line{flex:1 0 100%;min-height:1rem;line-height:1rem}.form-field--invalid .mdc-text-field-helper-line,.form-field--invalid+.mdc-text-field-helper-line{padding-left:16px;padding-right:16px}.form-field--invalid .mdc-text-field-helper-line .mdc-text-field-helper-text--validation-msg,.form-field--invalid+.mdc-text-field-helper-line .mdc-text-field-helper-text--validation-msg{opacity:1;color:var(--mdc-theme-error,#b00020)}.mdc-form-field+.mdc-text-field-helper-line{margin-top:-1rem;padding-left:32px;padding-right:32px}.form-field--global-validation .mdc-text-field-helper-text{font-weight:700}.validation-errors{margin:0;padding:0;list-style-type:none}.validation-errors a{cursor:pointer}.validation-errors .mdc-text-field-helper-text--validation-msg{opacity:1;color:var(--mdc-theme-error,#b00020)}.chosen-ticket{border:1px solid #ccc;width:calc(100% - 48px);margin:16px 16px 0;padding:12px 8px}.total{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-body1-font-size,1rem);line-height:1.5rem;line-height:var(--mdc-typography-body1-line-height,1.5rem);font-weight:400;font-weight:var(--mdc-typography-body1-font-weight,400);letter-spacing:.03125em;letter-spacing:var(--mdc-typography-body1-letter-spacing,.03125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body1-text-transform,inherit);border-top:1px solid #000;flex-flow:row;flex:1 0 calc(100% - 32px);padding:0 16px;font-weight:700;display:flex}.total span:last-child{white-space:nowrap;margin-left:auto}.total+.total{border-top:none}.login{color:var(--mdc-theme-primary,#6200ee);-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-body1-font-size,1rem);line-height:1.5rem;line-height:var(--mdc-typography-body1-line-height,1.5rem);font-weight:400;font-weight:var(--mdc-typography-body1-font-weight,400);letter-spacing:.03125em;letter-spacing:var(--mdc-typography-body1-letter-spacing,.03125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body1-text-transform,inherit);flex-flow:column;display:flex}.login__form{margin-top:16px}.login__after{color:var(--mdc-theme-text-hint-on-background,#00000061)}.error-view{padding:16px}.error-view h1{margin-top:0}.loading{justify-content:center;padding:16px;display:flex}.debug-banner{color:var(--mdc-theme-on-error,#fff);background-color:#b00020;background-color:var(--mdc-theme-error,#b00020);-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);text-align:center;margin-bottom:8px;padding:8px}hr{background-color:#00000061;background-color:var(--mdc-theme-text-hint-on-background,#00000061);border:none;width:calc(100% - 32px);height:1px}.current-person{color:var(--mdc-theme-primary,#6200ee)}";


var $ca3222cb63d04ad8$exports = {};
!function(n) {
    "use strict";
    function r(n, r, e) {
        return e.a = n, e.f = r, e;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(e) {
                return n(r, e);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(e) {
                return function(t) {
                    return n(r, e, t);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return n(r, e, t, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return function(c) {
                            return n(r, e, t, u, c);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return function(c) {
                            return function(a) {
                                return n(r, e, t, u, c, a);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return function(c) {
                            return function(a) {
                                return function(i) {
                                    return n(r, e, t, u, c, a, i);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F9(n) {
        return r(9, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(u) {
                        return function(c) {
                            return function(a) {
                                return function(i) {
                                    return function(o) {
                                        return function(f) {
                                            return n(r, e, t, u, c, a, i, o, f);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, e) {
        return 2 === n.a ? n.f(r, e) : n(r)(e);
    }
    function A3(n, r, e, t) {
        return 3 === n.a ? n.f(r, e, t) : n(r)(e)(t);
    }
    function A4(n, r, e, t, u) {
        return 4 === n.a ? n.f(r, e, t, u) : n(r)(e)(t)(u);
    }
    function A5(n, r, e, t, u, c) {
        return 5 === n.a ? n.f(r, e, t, u, c) : n(r)(e)(t)(u)(c);
    }
    function A6(n, r, e, t, u, c, a) {
        return 6 === n.a ? n.f(r, e, t, u, c, a) : n(r)(e)(t)(u)(c)(a);
    }
    function A7(n, r, e, t, u, c, a, i) {
        return 7 === n.a ? n.f(r, e, t, u, c, a, i) : n(r)(e)(t)(u)(c)(a)(i);
    }
    var e = F3(function(n, r, e) {
        for(var t = Array(n), u = 0; n > u; u++)t[u] = e(r + u);
        return t;
    }), t = F2(function(n, r) {
        for(var e = Array(n), t = 0; n > t && r.b; t++)e[t] = r.a, r = r.b;
        return e.length = t, g(e, r);
    });
    function u(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function c(n, r) {
        for(var e, t = [], u = a(n, r, 0, t); u && (e = t.pop()); u = a(e.a, e.b, 0, t));
        return u;
    }
    function a(n, r, e, t) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && u(5), !1;
        if (e > 100) return t.push(g(n, r)), !0;
        for(var c in 0 > n.$ && (n = be(n), r = be(r)), n)if (!a(n[c], r[c], e + 1, t)) return !1;
        return !0;
    }
    var i = F2(c), o = F2(function(n, r) {
        return !c(n, r);
    });
    function f(n, r, e) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (e = f(n.a, r.a)) || (e = f(n.b, r.b)) ? e : f(n.c, r.c);
        for(; n.b && r.b && !(e = f(n.a, r.a)); n = n.b, r = r.b);
        return e || (n.b ? 1 : r.b ? -1 : 0);
    }
    var s = F2(function(n, r) {
        return 0 > f(n, r);
    }), d = F2(function(n, r) {
        return f(n, r) > 0;
    }), b = F2(function(n, r) {
        return f(n, r) >= 0;
    }), l = F2(function(n, r) {
        var e = f(n, r);
        return 0 > e ? he : e ? ge : ve;
    }), v = 0;
    function g(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function h(n, r, e) {
        return {
            a: n,
            b: r,
            c: e
        };
    }
    function $(n, r) {
        var e = {};
        for(var t in n)e[t] = n[t];
        for(var t in r)e[t] = r[t];
        return e;
    }
    var m = F2(p);
    function p(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var e = y(n.a, r);
        n = n.b;
        for(var t = e; n.b; n = n.b)t = t.b = y(n.a, r);
        return e;
    }
    var w = {
        $: 0
    };
    function y(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var k = F2(y);
    function _(n) {
        for(var r = w, e = n.length; e--;)r = y(n[e], r);
        return r;
    }
    function I(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var x = F3(function(n, r, e) {
        for(var t = []; r.b && e.b; r = r.b, e = e.b)t.push(A2(n, r.a, e.a));
        return _(t);
    }), A = F4(function(n, r, e, t) {
        for(var u = []; r.b && e.b && t.b; r = r.b, e = e.b, t = t.b)u.push(A3(n, r.a, e.a, t.a));
        return _(u);
    }), B = F2(function(n, r) {
        return _(I(r).sort(function(r, e) {
            return f(n(r), n(e));
        }));
    }), C = F2(function(n, r) {
        return n + r;
    }), q = F2(function(n, r) {
        return n * r;
    }), z = F2(Math.pow), D = F2(function(n, r) {
        var e = r % n;
        return 0 === n ? u(11) : e > 0 && 0 > n || 0 > e && n > 0 ? e + n : e;
    }), P = Math.ceil, K = Math.floor, L = Math.round, T = Math.log, R = isNaN, F = F2(function(n, r) {
        return n + r;
    }), O = F2(function(n, r) {
        return n + r;
    }), W = F2(function(n, r) {
        for(var e = [], t = r.length, u = 0; t > u;){
            var c = r[u], a = r.charCodeAt(u);
            u++, 55296 > a || a > 56319 || (c += r[u], u++), n(c) && e.push(c);
        }
        return e.join("");
    }), E = F3(function(n, r, e) {
        for(var t = e.length, u = 0; t > u;){
            var c = e[u], a = e.charCodeAt(u);
            u++, 55296 > a || a > 56319 || (c += e[u], u++), r = A2(n, c, r);
        }
        return r;
    }), M = F3(function(n, r, e) {
        for(var t = e.length; t--;){
            var u = e[t], c = e.charCodeAt(t);
            56320 > c || c > 57343 || (u = e[--t] + u), r = A2(n, u, r);
        }
        return r;
    }), j = F2(function(n, r) {
        return r.split(n);
    }), S = F2(function(n, r) {
        return r.join(n);
    }), N = F3(function(n, r, e) {
        return e.slice(n, r);
    }), G = F2(function(n, r) {
        for(var e = r.length; e--;){
            var t = r[e], u = r.charCodeAt(e);
            if (56320 > u || u > 57343 || (t = r[--e] + t), !n(t)) return !1;
        }
        return !0;
    }), Q = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), U = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), H = F2(function(n, r) {
        return r.length >= n.length && r.lastIndexOf(n) === r.length - n.length;
    }), V = F2(function(n, r) {
        var e = n.length;
        if (1 > e) return w;
        for(var t = 0, u = []; (t = r.indexOf(n, t)) > -1;)u.push(t), t += e;
        return _(u);
    });
    function J(n) {
        return n + "";
    }
    function X(n) {
        return {
            $: 2,
            b: n
        };
    }
    var Z = X(function(n) {
        return "number" != typeof n ? pn("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? ye(n) : !isFinite(n) || n % 1 ? pn("an INT", n) : ye(n);
    }), Y = X(function(n) {
        return "boolean" == typeof n ? ye(n) : pn("a BOOL", n);
    }), nn = X(function(n) {
        return "number" == typeof n ? ye(n) : pn("a FLOAT", n);
    }), rn = X(function(n) {
        return ye(n);
    }), en = X(function(n) {
        return "string" == typeof n ? ye(n) : n instanceof String ? ye(n + "") : pn("a STRING", n);
    }), tn = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    }), un = F2(function(n, r) {
        return {
            $: 7,
            e: n,
            b: r
        };
    });
    function cn(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var an = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), on = F2(function(n, r) {
        return cn(n, [
            r
        ]);
    }), fn = F3(function(n, r, e) {
        return cn(n, [
            r,
            e
        ]);
    }), sn = F4(function(n, r, e, t) {
        return cn(n, [
            r,
            e,
            t
        ]);
    }), dn = F5(function(n, r, e, t, u) {
        return cn(n, [
            r,
            e,
            t,
            u
        ]);
    }), bn = F6(function(n, r, e, t, u, c) {
        return cn(n, [
            r,
            e,
            t,
            u,
            c
        ]);
    }), ln = F2(function(n, r) {
        try {
            return gn(n, JSON.parse(r));
        } catch (n) {
            return $e(A2(me, "This is not valid JSON! " + n.message, r));
        }
    }), vn = F2(function(n, r) {
        return gn(n, r);
    });
    function gn(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? ye(n.c) : pn("null", r);
            case 3:
                return $n(r) ? hn(n.b, r, _) : pn("a LIST", r);
            case 4:
                return $n(r) ? hn(n.b, r, mn) : pn("an ARRAY", r);
            case 6:
                var e = n.d;
                if ("object" != typeof r || null === r || !(e in r)) return pn("an OBJECT with a field named `" + e + "`", r);
                var t = gn(n.b, r[e]);
                return pt(t) ? t : $e(A2(pe, e, t.a));
            case 7:
                var u = n.e;
                return $n(r) ? r.length > u ? (t = gn(n.b, r[u]), pt(t) ? t : $e(A2(we, u, t.a))) : pn("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : pn("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || $n(r)) return pn("an OBJECT", r);
                var c = w;
                for(var a in r)if (r.hasOwnProperty(a)) {
                    if (t = gn(n.b, r[a]), !pt(t)) return $e(A2(pe, a, t.a));
                    c = y(g(a, t.a), c);
                }
                return ye(Se(c));
            case 9:
                for(var i = n.f, o = n.g, f = 0; o.length > f; f++){
                    if (t = gn(o[f], r), !pt(t)) return t;
                    i = i(t.a);
                }
                return ye(i);
            case 10:
                return t = gn(n.b, r), pt(t) ? gn(n.h(t.a), r) : t;
            case 11:
                for(var s = w, d = n.g; d.b; d = d.b){
                    if (t = gn(d.a, r), pt(t)) return t;
                    s = y(t.a, s);
                }
                return $e(ke(Se(s)));
            case 1:
                return $e(A2(me, n.a, r));
            case 0:
                return ye(n.a);
        }
    }
    function hn(n, r, e) {
        for(var t = r.length, u = Array(t), c = 0; t > c; c++){
            var a = gn(n, r[c]);
            if (!pt(a)) return $e(A2(we, c, a.a));
            u[c] = a.a;
        }
        return ye(e(u));
    }
    function $n(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function mn(n) {
        return A2(mt, n.length, function(r) {
            return n[r];
        });
    }
    function pn(n, r) {
        return $e(A2(me, "Expecting " + n, r));
    }
    function wn(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return wn(n.b, r.b);
            case 6:
                return n.d === r.d && wn(n.b, r.b);
            case 7:
                return n.e === r.e && wn(n.b, r.b);
            case 9:
                return n.f === r.f && yn(n.g, r.g);
            case 10:
                return n.h === r.h && wn(n.b, r.b);
            case 11:
                return yn(n.g, r.g);
        }
    }
    function yn(n, r) {
        var e = n.length;
        if (e !== r.length) return !1;
        for(var t = 0; e > t; t++)if (!wn(n[t], r[t])) return !1;
        return !0;
    }
    var kn = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function _n(n) {
        return n;
    }
    var In = F3(function(n, r, e) {
        return e[n] = r, e;
    });
    function xn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function An(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var Bn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), Cn = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), qn = 0;
    function zn(n) {
        var r = {
            $: 0,
            e: qn++,
            f: n,
            g: null,
            h: []
        };
        return Tn(r), r;
    }
    function Dn(n, r) {
        n.h.push(r), Tn(n);
    }
    var Pn = F2(function(n, r) {
        return An(function(e) {
            Dn(n, r), e(xn(v));
        });
    }), Kn = !1, Ln = [];
    function Tn(n) {
        if (Ln.push(n), !Kn) {
            for(Kn = !0; n = Ln.shift();)Rn(n);
            Kn = !1;
        }
    }
    function Rn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, Tn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var Fn = {};
    function On(n, r) {
        var e = {
            g: r,
            h: void 0
        }, t = n.c, u = n.d, c = n.e, a = n.f;
        function i(n) {
            return A2(Bn, i, {
                $: 5,
                b: function(r) {
                    var i = r.a;
                    return 0 === r.$ ? A3(u, e, i, n) : c && a ? A4(t, e, i.i, i.j, n) : A3(t, e, c ? i.i : i.j, n);
                }
            });
        }
        return e.h = zn(A2(Bn, i, n.b));
    }
    var Wn = F2(function(n, r) {
        return An(function(e) {
            n.g(r), e(xn(v));
        });
    }), En = F2(function(n, r) {
        return A2(Pn, n.h, {
            $: 0,
            a: r
        });
    });
    function Mn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function jn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Sn = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), Nn = [], Gn = !1;
    function Qn(n, r, e) {
        if (Nn.push({
            p: n,
            q: r,
            r: e
        }), !Gn) {
            Gn = !0;
            for(var t; t = Nn.shift();)Un(t.p, t.q, t.r);
            Gn = !1;
        }
    }
    function Un(n, r, e) {
        var t = {};
        for(var u in Hn(!0, r, t, null), Hn(!1, e, t, null), n)Dn(n[u], {
            $: "fx",
            a: t[u] || {
                i: w,
                j: w
            }
        });
    }
    function Hn(n, r, e, t) {
        switch(r.$){
            case 1:
                var u = r.k, c = function(n, r, e, t) {
                    function u(n) {
                        for(var r = e; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? Fn[r].e : Fn[r].f, u, t);
                }(n, u, t, r.l);
                return void (e[u] = function(n, r, e) {
                    return e = e || {
                        i: w,
                        j: w
                    }, n ? e.i = y(r, e.i) : e.j = y(r, e.j), e;
                }(n, c, e[u]));
            case 2:
                for(var a = r.m; a.b; a = a.b)Hn(n, a.a, e, t);
                return;
            case 3:
                return void Hn(n, r.o, e, {
                    s: r.n,
                    t: t
                });
        }
    }
    function Vn(n) {
        Fn[n] && u(3);
    }
    function Jn(n, r) {
        return Vn(n), Fn[n] = {
            e: Xn,
            u: r,
            a: Zn
        }, Mn(n);
    }
    var Xn = F2(function(n, r) {
        return r;
    });
    function Zn(n) {
        var r = [], e = Fn[n].u, t = An(function(n) {
            var r = setTimeout(function() {
                n(xn(v));
            }, 0);
            return function() {
                clearTimeout(r);
            };
        });
        return Fn[n].b = t, Fn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var c = r, a = e(u.a), i = 0; c.length > i; i++)c[i](a);
            return t;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var e = (r = r.slice()).indexOf(n);
                0 > e || r.splice(e, 1);
            }
        };
    }
    function Yn(n, r) {
        return Vn(n), Fn[n] = {
            f: rr,
            u: r,
            a: er
        }, Mn(n);
    }
    var nr, rr = F2(function(n, r) {
        return function(e) {
            return n(r(e));
        };
    });
    function er(n, r) {
        var e = w, t = Fn[n].u, c = xn(null);
        return Fn[n].b = c, Fn[n].c = F3(function(n, r) {
            return e = r, c;
        }), {
            send: function(n) {
                var c = A2(vn, t, n);
                pt(c) || u(4);
                for(var a = c.a, i = e; i.b; i = i.b)r(i.a(a));
            }
        };
    }
    var tr = "undefined" != typeof document ? document : {};
    function ur(n, r) {
        n.appendChild(r);
    }
    function cr(n) {
        return {
            $: 0,
            a: n
        };
    }
    var ar = F2(function(n, r) {
        return F2(function(e, t) {
            for(var u = [], c = 0; t.b; t = t.b){
                var a = t.a;
                c += a.b || 0, u.push(a);
            }
            return c += u.length, {
                $: 1,
                c: r,
                d: Ir(e),
                e: u,
                f: n,
                b: c
            };
        });
    }), ir = ar(void 0), or = F2(function(n, r) {
        return F2(function(e, t) {
            for(var u = [], c = 0; t.b; t = t.b){
                var a = t.a;
                c += a.b.b || 0, u.push(a);
            }
            return c += u.length, {
                $: 2,
                c: r,
                d: Ir(e),
                e: u,
                f: n,
                b: c
            };
        });
    })(void 0), fr = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    }), sr = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), dr = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), br = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), lr = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), vr = /^script$/i, gr = /^(on|formAction$)/i, hr = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i, $r = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function mr(n) {
        return vr.test(n) ? "p" : n;
    }
    function pr(n) {
        return $r.test(n) ? "" : n;
    }
    var wr, yr = F2(function(n, r) {
        return "a0" === r.$ ? A2(sr, r.n, function(n, r) {
            var e = xt(r);
            return {
                $: r.$,
                a: e ? A3(_t, 3 > e ? kr : _r, It(n), r.a) : A2(kt, n, r.a)
            };
        }(n, r.o)) : r;
    }), kr = F2(function(n, r) {
        return g(n(r.a), r.b);
    }), _r = F2(function(n, r) {
        return {
            az: n(r.az),
            dL: r.dL,
            dw: r.dw
        };
    });
    function Ir(n) {
        for(var r = {}; n.b; n = n.b){
            var e = n.a, t = e.$, u = e.n, c = e.o;
            if ("a2" !== t) {
                var a = r[t] || (r[t] = {});
                "a3" === t && "class" === u ? xr(a, u, c) : a[u] = c;
            } else "className" === u ? xr(r, u, c) : r[u] = c;
        }
        return r;
    }
    function xr(n, r, e) {
        var t = n[r];
        n[r] = t ? t + " " + e : e;
    }
    function Ar(n, r) {
        var e = n.$;
        if (5 === e) return Ar(n.k || (n.k = n.m()), r);
        if (0 === e) return tr.createTextNode(n.a);
        if (4 === e) {
            for(var t = n.k, u = n.j; 4 === t.$;)"object" != typeof u ? u = [
                u,
                t.j
            ] : u.push(t.j), t = t.k;
            var c = {
                j: u,
                p: r
            };
            return (a = Ar(t, c)).elm_event_node_ref = c, a;
        }
        if (3 === e) return Br(a = n.h(n.g), r, n.d), a;
        var a = n.f ? tr.createElementNS(n.f, n.c) : tr.createElement(n.c);
        nr && "a" == n.c && a.addEventListener("click", nr(a)), Br(a, r, n.d);
        for(var i = n.e, o = 0; i.length > o; o++)ur(a, Ar(1 === e ? i[o] : i[o].b, r));
        return a;
    }
    function Br(n, r, e) {
        for(var t in e){
            var u = e[t];
            "a1" === t ? Cr(n, u) : "a0" === t ? Dr(n, r, u) : "a3" === t ? qr(n, u) : "a4" === t ? zr(n, u) : ("value" !== t && "checked" !== t || n[t] !== u) && (n[t] = u);
        }
    }
    function Cr(n, r) {
        var e = n.style;
        for(var t in r)e[t] = r[t];
    }
    function qr(n, r) {
        for(var e in r){
            var t = r[e];
            void 0 !== t ? n.setAttribute(e, t) : n.removeAttribute(e);
        }
    }
    function zr(n, r) {
        for(var e in r){
            var t = r[e], u = t.f, c = t.o;
            void 0 !== c ? n.setAttributeNS(u, e, c) : n.removeAttributeNS(u, e);
        }
    }
    function Dr(n, r, e) {
        var t = n.elmFs || (n.elmFs = {});
        for(var u in e){
            var c = e[u], a = t[u];
            if (c) {
                if (a) {
                    if (a.q.$ === c.$) {
                        a.q = c;
                        continue;
                    }
                    n.removeEventListener(u, a);
                }
                a = Pr(r, c), n.addEventListener(u, a, wr && {
                    passive: 2 > xt(c)
                }), t[u] = a;
            } else n.removeEventListener(u, a), t[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                wr = !0;
            }
        }));
    } catch (n) {}
    function Pr(n, r) {
        function e(r) {
            var t = e.q, u = gn(t.a, r);
            if (pt(u)) {
                for(var c, a = xt(t), i = u.a, o = a ? 3 > a ? i.a : i.az : i, f = 1 == a ? i.b : 3 == a && i.dL, s = (f && r.stopPropagation(), (2 == a ? i.b : 3 == a && i.dw) && r.preventDefault(), n); c = s.j;){
                    if ("function" == typeof c) o = c(o);
                    else for(var d = c.length; d--;)o = c[d](o);
                    s = s.p;
                }
                s(o, f);
            }
        }
        return e.q = r, e;
    }
    function Kr(n, r) {
        return n.$ == r.$ && wn(n.a, r.a);
    }
    function Lr(n, r, e, t) {
        var u = {
            $: r,
            r: e,
            s: t,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Tr(n, r, e, t) {
        if (n !== r) {
            var u = n.$, c = r.$;
            if (u !== c) {
                if (1 !== u || 2 !== c) return void Lr(e, 0, t, r);
                r = function(n) {
                    for(var r = n.e, e = r.length, t = Array(e), u = 0; e > u; u++)t[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: t,
                        f: n.f,
                        b: n.b
                    };
                }(r), c = 1;
            }
            switch(c){
                case 5:
                    for(var a = n.l, i = r.l, o = a.length, f = o === i.length; f && o--;)f = a[o] === i[o];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Tr(n.k, r.k, s, 0), void (s.length > 0 && Lr(e, 1, t, s));
                case 4:
                    for(var d = n.j, b = r.j, l = !1, v = n.k; 4 === v.$;)l = !0, "object" != typeof d ? d = [
                        d,
                        v.j
                    ] : d.push(v.j), v = v.k;
                    for(var g = r.k; 4 === g.$;)l = !0, "object" != typeof b ? b = [
                        b,
                        g.j
                    ] : b.push(g.j), g = g.k;
                    return l && d.length !== b.length ? void Lr(e, 0, t, r) : ((l ? function(n, r) {
                        for(var e = 0; n.length > e; e++)if (n[e] !== r[e]) return !1;
                        return !0;
                    }(d, b) : d === b) || Lr(e, 2, t, b), void Tr(v, g, e, t + 1));
                case 0:
                    return void (n.a !== r.a && Lr(e, 3, t, r.a));
                case 1:
                    return void Rr(n, r, e, t, Or);
                case 2:
                    return void Rr(n, r, e, t, Wr);
                case 3:
                    if (n.h !== r.h) return void Lr(e, 0, t, r);
                    var h = Fr(n.d, r.d);
                    h && Lr(e, 4, t, h);
                    var $ = r.i(n.g, r.g);
                    return void ($ && Lr(e, 5, t, $));
            }
        }
    }
    function Rr(n, r, e, t, u) {
        if (n.c === r.c && n.f === r.f) {
            var c = Fr(n.d, r.d);
            c && Lr(e, 4, t, c), u(n, r, e, t);
        } else Lr(e, 0, t, r);
    }
    function Fr(n, r, e) {
        var t;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var c = n[u], a = r[u];
                c === a && "value" !== u && "checked" !== u || "a0" === e && Kr(c, a) || ((t = t || {})[u] = a);
            } else (t = t || {})[u] = e ? "a1" === e ? "" : "a0" === e || "a3" === e ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var i = Fr(n[u], r[u] || {}, u);
            i && ((t = t || {})[u] = i);
        }
        for(var o in r)o in n || ((t = t || {})[o] = r[o]);
        return t;
    }
    function Or(n, r, e, t) {
        var u = n.e, c = r.e, a = u.length, i = c.length;
        a > i ? Lr(e, 6, t, {
            v: i,
            i: a - i
        }) : i > a && Lr(e, 7, t, {
            v: a,
            e: c
        });
        for(var o = i > a ? a : i, f = 0; o > f; f++){
            var s = u[f];
            Tr(s, c[f], e, ++t), t += s.b || 0;
        }
    }
    function Wr(n, r, e, t) {
        for(var u = [], c = {}, a = [], i = n.e, o = r.e, f = i.length, s = o.length, d = 0, b = 0, l = t; f > d && s > b;){
            var v = (A = i[d]).a, g = (B = o[b]).a, h = A.b, $ = B.b, m = void 0, p = void 0;
            if (v !== g) {
                var w = i[d + 1], y = o[b + 1];
                if (w) {
                    var k = w.a, _ = w.b;
                    p = g === k;
                }
                if (y) {
                    var I = y.a, x = y.b;
                    m = v === I;
                }
                if (m && p) Tr(h, x, u, ++l), Mr(c, u, v, $, b, a), l += h.b || 0, jr(c, u, v, _, ++l), l += _.b || 0, d += 2, b += 2;
                else if (m) l++, Mr(c, u, g, $, b, a), Tr(h, x, u, l), l += h.b || 0, d += 1, b += 2;
                else if (p) jr(c, u, v, h, ++l), l += h.b || 0, Tr(_, $, u, ++l), l += _.b || 0, d += 2, b += 1;
                else {
                    if (!w || k !== I) break;
                    jr(c, u, v, h, ++l), Mr(c, u, g, $, b, a), l += h.b || 0, Tr(_, x, u, ++l), l += _.b || 0, d += 2, b += 2;
                }
            } else Tr(h, $, u, ++l), l += h.b || 0, d++, b++;
        }
        for(; f > d;){
            var A;
            l++, jr(c, u, (A = i[d]).a, h = A.b, l), l += h.b || 0, d++;
        }
        for(; s > b;){
            var B, C = C || [];
            Mr(c, u, (B = o[b]).a, B.b, void 0, C), b++;
        }
        (u.length > 0 || a.length > 0 || C) && Lr(e, 8, t, {
            w: u,
            x: a,
            y: C
        });
    }
    var Er = "_elmW6BL";
    function Mr(n, r, e, t, u, c) {
        var a = n[e];
        if (!a) return c.push({
            r: u,
            A: a = {
                c: 0,
                z: t,
                r: u,
                s: void 0
            }
        }), void (n[e] = a);
        if (1 === a.c) {
            c.push({
                r: u,
                A: a
            }), a.c = 2;
            var i = [];
            return Tr(a.z, t, i, a.r), a.r = u, void (a.s.s = {
                w: i,
                A: a
            });
        }
        Mr(n, r, e + Er, t, u, c);
    }
    function jr(n, r, e, t, u) {
        var c = n[e];
        if (c) {
            if (0 === c.c) {
                c.c = 2;
                var a = [];
                return Tr(t, c.z, a, u), void Lr(r, 9, u, {
                    w: a,
                    A: c
                });
            }
            jr(n, r, e + Er, t, u);
        } else {
            var i = Lr(r, 9, u, void 0);
            n[e] = {
                c: 1,
                z: t,
                r: u,
                s: i
            };
        }
    }
    function Sr(n, r, e, t) {
        Nr(n, r, e, 0, 0, r.b, t);
    }
    function Nr(n, r, e, t, u, c, a) {
        for(var i = e[t], o = i.r; o === u;){
            var f = i.$;
            if (1 === f) Sr(n, r.k, i.s, a);
            else if (8 === f) i.t = n, i.u = a, (s = i.s.w).length > 0 && Nr(n, r, s, 0, u, c, a);
            else if (9 === f) {
                i.t = n, i.u = a;
                var s, d = i.s;
                d && (d.A.s = n, (s = d.w).length > 0 && Nr(n, r, s, 0, u, c, a));
            } else i.t = n, i.u = a;
            if (!(i = e[++t]) || (o = i.r) > c) return t;
        }
        var b = r.$;
        if (4 === b) {
            for(var l = r.k; 4 === l.$;)l = l.k;
            return Nr(n, l, e, t, u + 1, c, n.elm_event_node_ref);
        }
        for(var v = r.e, g = n.childNodes, h = 0; v.length > h; h++){
            u++;
            var $ = 1 === b ? v[h] : v[h].b, m = u + ($.b || 0);
            if (!(u > o || o > m || (i = e[t = Nr(g[h], $, e, t, u, m, a)]) && (o = i.r) <= c)) return t;
            u = m;
        }
        return t;
    }
    function Gr(n, r) {
        for(var e = 0; r.length > e; e++){
            var t = r[e], u = t.t, c = Qr(u, t);
            u === n && (n = c);
        }
        return n;
    }
    function Qr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, e) {
                    var t = n.parentNode, u = Ar(r, e);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), t && u !== n && t.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Br(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Gr(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var e = r.s, t = 0; e.i > t; t++)n.removeChild(n.childNodes[e.v]);
                return n;
            case 7:
                for(var c = (e = r.s).e, a = n.childNodes[t = e.v]; c.length > t; t++)n.insertBefore(Ar(c[t], r.u), a);
                return n;
            case 9:
                if (!(e = r.s)) return n.parentNode.removeChild(n), n;
                var i = e.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = Gr(n, e.w), n;
            case 8:
                return function(n, r) {
                    var e = r.s, t = function(n, r) {
                        if (n) {
                            for(var e = tr.createDocumentFragment(), t = 0; n.length > t; t++){
                                var u = n[t].A;
                                ur(e, 2 === u.c ? u.s : Ar(u.z, r.u));
                            }
                            return e;
                        }
                    }(e.y, r);
                    n = Gr(n, e.w);
                    for(var u = e.x, c = 0; u.length > c; c++){
                        var a = u[c], i = a.A, o = 2 === i.c ? i.s : Ar(i.z, r.u);
                        n.insertBefore(o, n.childNodes[a.r]);
                    }
                    return t && ur(n, t), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                u(10);
        }
    }
    function Ur(n) {
        if (3 === n.nodeType) return cr(n.textContent);
        if (1 !== n.nodeType) return cr("");
        for(var r = w, e = n.attributes, t = e.length; t--;){
            var u = e[t];
            r = y(A2(lr, u.name, u.value), r);
        }
        var c = n.tagName.toLowerCase(), a = w, i = n.childNodes;
        for(t = i.length; t--;)a = y(Ur(i[t]), a);
        return A3(ir, c, r, a);
    }
    var Hr = F4(function(n, r, e, t) {
        return function(n, r, e, t, c, a) {
            var i = A2(vn, n, r ? r.flags : void 0);
            pt(i) || u(2);
            var o = {}, f = e(i.a), s = f.a, d = a(l, s), b = function(n, r) {
                var e;
                for(var t in Fn){
                    var u = Fn[t];
                    u.a && ((e = e || {})[t] = u.a(t, r)), n[t] = On(u, r);
                }
                return e;
            }(o, l);
            function l(n, r) {
                var e = A2(t, n, s);
                d(s = e.a, r), Qn(o, e.b, c(s));
            }
            return Qn(o, f.b, c(s)), b ? {
                ports: b
            } : {};
        }(r, t, n.hr, n.cw, n.im, function(r, e) {
            var u = n.iK, c = t.node, a = Ur(c);
            return function(n, r) {
                r(n);
                var e = 0;
                function t() {
                    e = 1 === e ? 0 : (Vr(t), r(n), 1);
                }
                return function(u, c) {
                    n = u, c ? (r(n), 2 === e && (e = 1)) : (0 === e && Vr(t), e = 2);
                };
            }(e, function(n) {
                var e = u(n), t = function(n, r) {
                    var e = [];
                    return Tr(n, r, e, 0), e;
                }(a, e);
                c = function(n, r, e, t) {
                    return 0 === e.length ? n : (Sr(n, r, e, t), Gr(n, e));
                }(c, a, t, r), a = e;
            });
        });
    }), Vr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    "undefined" != typeof document && document, "undefined" != typeof window && window;
    var Jr = F2(function(n, r) {
        var e = "g";
        n.hO && (e += "m"), n.go && (e += "i");
        try {
            return oe(RegExp(r, e));
        } catch (n) {
            return fe;
        }
    }), Xr = F2(function(n, r) {
        return null !== r.match(n);
    }), Zr = F3(function(n, r, e) {
        for(var t, u = [], c = 0, a = e, i = r.lastIndex, o = -1; c++ < n && (t = r.exec(a)) && o != r.lastIndex;){
            for(var f = t.length - 1, s = Array(f); f > 0;){
                var d = t[f];
                s[--f] = d ? oe(d) : fe;
            }
            u.push(A4(Wu, t[0], t.index, c, _(s))), o = r.lastIndex;
        }
        return r.lastIndex = i, _(u);
    }), Yr = F4(function(n, r, e, t) {
        var u = 0;
        return t.replace(r, function(r) {
            if (u++ >= n) return r;
            for(var t = arguments.length - 3, c = Array(t); t > 0;){
                var a = arguments[t];
                c[--t] = a ? oe(a) : fe;
            }
            return e(A4(Wu, r, arguments[arguments.length - 2], u, _(c)));
        });
    }), ne = 1 / 0, re = F5(function(n, r, e, t, u) {
        for(var c = n.length, a = u.length >= r + c, i = 0; a && c > i;){
            var o = u.charCodeAt(r);
            a = n[i++] === u[r++] && (10 === o ? (e++, t = 1) : (t++, 55296 == (63488 & o) ? n[i++] === u[r++] : 1));
        }
        return h(a ? r : -1, e, t);
    }), ee = F3(function(n, r, e) {
        return e.length > r ? 55296 == (63488 & e.charCodeAt(r)) ? n(e.substr(r, 2)) ? r + 2 : -1 : n(e[r]) ? "\n" === e[r] ? -2 : r + 1 : -1 : -1;
    }), te = F5(function(n, r, e, t, u) {
        for(var c = u.indexOf(n, r), a = 0 > c ? u.length : c + n.length; a > r;){
            var i = u.charCodeAt(r++);
            10 === i ? (t = 1, e++) : (t++, 55296 == (63488 & i) && r++);
        }
        return h(c, e, t);
    }), ue = F3(function(n, r, e) {
        return An(function(t) {
            function u(n) {
                t(r(e.b1.a(n)));
            }
            var c = new XMLHttpRequest;
            c.addEventListener("error", function() {
                u(Ii);
            }), c.addEventListener("timeout", function() {
                u(Bi);
            }), c.addEventListener("load", function() {
                u(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? _i : yi, function(n) {
                        return {
                            bh: n.responseURL,
                            fL: n.status,
                            ij: n.statusText,
                            a5: ce(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(e.b1.b, c));
            }), Ci(e.fT) && function(n, r, e) {
                r.upload.addEventListener("progress", function(t) {
                    r.c || zn(A2(qi, n, g(e, Ai({
                        ih: t.loaded,
                        dI: t.total
                    }))));
                }), r.addEventListener("progress", function(t) {
                    r.c || zn(A2(qi, n, g(e, xi({
                        h5: t.loaded,
                        dI: t.lengthComputable ? oe(t.total) : fe
                    }))));
                });
            }(n, c, e.fT.a);
            try {
                c.open(e.y, e.bh, !0);
            } catch (n) {
                return u(ki(e.bh));
            }
            return function(n, r) {
                for(var e = r.a5; e.b; e = e.b)n.setRequestHeader(e.a.a, e.a.b);
                n.timeout = r.bg.a || 0, n.responseType = r.b1.d, n.withCredentials = r.gg;
            }(c, e), e.o.a && c.setRequestHeader("Content-Type", e.o.a), c.send(e.o.b), function() {
                c.c = !0, c.abort();
            };
        });
    });
    function ce(n) {
        if (!n) return Na;
        for(var r = Na, e = n.split("\r\n"), t = e.length; t--;){
            var u = e[t], c = u.indexOf(": ");
            if (c > 0) {
                var a = u.substring(0, c), i = u.substring(c + 2);
                r = A3(Oi, a, function(n) {
                    return oe(Ci(n) ? i + ", " + n.a : i);
                }, r);
            }
        }
        return r;
    }
    var ae = F3(function(n, r, e) {
        return {
            $: 0,
            d: n,
            b: r,
            a: e
        };
    }), ie = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), oe = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fe = {
        $: 1
    }, se = k, de = F3(function(n, r, e) {
        for(;;){
            if (-2 === e.$) return r;
            var t = e.d, u = n, c = A3(n, e.b, e.c, A3(de, n, r, e.e));
            n = u, r = c, e = t;
        }
    }), be = function(n) {
        return A3(de, F3(function(n, r, e) {
            return A2(se, g(n, r), e);
        }), w, n);
    }, le = function(n) {
        var r;
        return r = n, A3(de, F3(function(n, r, e) {
            return A2(se, n, e);
        }), w, r);
    }, ve = 1, ge = 2, he = 0, $e = function(n) {
        return {
            $: 1,
            a: n
        };
    }, me = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), pe = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), we = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ye = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ke = function(n) {
        return {
            $: 2,
            a: n
        };
    }, _e = C, Ie = G, xe = m, Ae = kn, Be = J, Ce = F2(function(n, r) {
        return A2(S, n, I(r));
    }), qe = F2(function(n, r) {
        return _(A2(j, n, r));
    }), ze = function(n) {
        return A2(Ce, "\n    ", A2(qe, "\n", n));
    }, De = F3(function(n, r, e) {
        for(;;){
            if (!e.b) return r;
            var t = e.b, u = n, c = A2(n, e.a, r);
            n = u, r = c, e = t;
        }
    }), Pe = function(n) {
        return A3(De, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, Ke = x, Le = F3(function(n, r, e) {
        for(;;){
            if (f(n, r) >= 1) return e;
            var t = n, u = r - 1, c = A2(se, r, e);
            n = t, r = u, e = c;
        }
    }), Te = F2(function(n, r) {
        return A3(Le, n, r, w);
    }), Re = F2(function(n, r) {
        return A3(Ke, n, A2(Te, 0, Pe(r) - 1), r);
    }), Fe = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Oe = function(n) {
        var r = Fe(n);
        return r >= 97 && 122 >= r;
    }, We = function(n) {
        var r = Fe(n);
        return 90 >= r && r >= 65;
    }, Ee = function(n) {
        return Oe(n) || We(n);
    }, Me = function(n) {
        var r = Fe(n);
        return 57 >= r && r >= 48;
    }, je = function(n) {
        return Oe(n) || We(n) || Me(n);
    }, Se = function(n) {
        return A3(De, se, w, n);
    }, Ne = function(n) {
        var r = n.charCodeAt(0);
        return isNaN(r) ? fe : oe(55296 > r || r > 56319 ? g(n[0], n.slice(1)) : g(n[0] + n[1], n.slice(2)));
    }, Ge = F2(function(n, r) {
        return "\n\n(" + Be(n + 1) + ") " + ze(Qe(r));
    }), Qe = function(n) {
        return A2(Ue, n, w);
    }, Ue = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var e = n.a, t = n.b, u = function() {
                    var n = Ne(e);
                    if (1 === n.$) return !1;
                    var r = n.a, t = r.b;
                    return Ee(r.a) && A2(Ie, je, t);
                }();
                n = t, r = A2(se, u ? "." + e : "['" + e + "']", r);
                continue n;
            case 1:
                t = n.b;
                var c = "[" + Be(n.a) + "]";
                n = t, r = A2(se, c, r);
                continue n;
            case 2:
                var a = n.a;
                if (a.b) {
                    if (a.b.b) {
                        var i = (r.b ? "The Json.Decode.oneOf at json" + A2(Ce, "", Se(r)) : "Json.Decode.oneOf") + " failed in the following " + Be(Pe(a)) + " ways:";
                        return A2(Ce, "\n\n", A2(se, i, A2(Re, Ge, a)));
                    }
                    n = t = a.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (r.b ? " at json" + A2(Ce, "", Se(r)) : "!");
            default:
                var o = n.a, f = n.b;
                return (i = r.b ? "Problem with the value at json" + A2(Ce, "", Se(r)) + ":\n\n    " : "Problem with the given value:\n\n") + ze(A2(Ae, 4, f)) + "\n\n" + o;
        }
    }), He = 32, Ve = F4(function(n, r, e, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e,
            d: t
        };
    }), Je = [], Xe = P, Ze = F2(function(n, r) {
        return T(r) / T(n);
    }), Ye = function(n) {
        return n;
    }, nt = Xe(A2(Ze, 2, He)), rt = A4(Ve, 0, nt, Je, Je), et = e, tt = F2(function(n, r) {
        return n(r);
    }), ut = F2(function(n, r) {
        return r(n);
    }), ct = i, at = K, it = function(n) {
        return n.length;
    }, ot = d, ft = F2(function(n, r) {
        return f(n, r) > 0 ? n : r;
    }), st = q, dt = t, bt = F2(function(n, r) {
        for(;;){
            var e = A2(dt, He, n), t = e.b, u = A2(se, {
                $: 0,
                a: e.a
            }, r);
            if (!t.b) return Se(u);
            n = t, r = u;
        }
    }), lt = function(n) {
        return n.a;
    }, vt = F2(function(n, r) {
        for(;;){
            var e = Xe(r / He);
            if (1 === e) return A2(dt, He, n).a;
            n = A2(bt, n, w), r = e;
        }
    }), gt = F2(function(n, r) {
        if (r.p) {
            var e = r.p * He, t = at(A2(Ze, He, e - 1)), u = n ? Se(r.v) : r.v, c = A2(vt, u, r.p);
            return A4(Ve, it(r.s) + e, A2(ft, 5, t * nt), c, r.s);
        }
        return A4(Ve, it(r.s), nt, Je, r.s);
    }), ht = s, $t = F5(function(n, r, e, t, u) {
        for(;;){
            if (0 > r) return A2(gt, !1, {
                v: t,
                p: e / He | 0,
                s: u
            });
            var c = {
                $: 1,
                a: A3(et, He, r, n)
            };
            r -= He, t = A2(se, c, t);
        }
    }), mt = F2(function(n, r) {
        if (n > 0) {
            var e = n % He;
            return A5($t, r, n - e - He, n, w, A3(et, e, n - e, r));
        }
        return rt;
    }), pt = function(n) {
        return !n.$;
    }, wt = an, yt = Y, kt = on, _t = fn, It = function(n) {
        return {
            $: 0,
            a: n
        };
    }, xt = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, At = function(n) {
        return n;
    }, Bt = F6(function(n, r, e, t, u, c) {
        return {
            g6: c,
            aL: r,
            q: t,
            aP: e,
            aQ: n,
            h3: u
        };
    }), Ct = Q, qt = function(n) {
        return n.length;
    }, zt = N, Dt = F2(function(n, r) {
        return 1 > n ? r : A3(zt, n, qt(r), r);
    }), Pt = V, Kt = function(n) {
        return "" === n;
    }, Lt = F2(function(n, r) {
        return 1 > n ? "" : A3(zt, 0, n, r);
    }), Tt = function(n) {
        for(var r = 0, e = n.charCodeAt(0), t = 43 == e || 45 == e ? 1 : 0, u = t; n.length > u; ++u){
            var c = n.charCodeAt(u);
            if (48 > c || c > 57) return fe;
            r = 10 * r + c - 48;
        }
        return u == t ? fe : oe(45 == e ? -r : r);
    }, Rt = F5(function(n, r, e, t, u) {
        if (Kt(u) || A2(Ct, "@", u)) return fe;
        var c = A2(Pt, ":", u);
        if (c.b) {
            if (c.b.b) return fe;
            var a = c.a, i = Tt(A2(Dt, a + 1, u));
            if (1 === i.$) return fe;
            var o = i;
            return oe(A6(Bt, n, A2(Lt, a, u), o, r, e, t));
        }
        return oe(A6(Bt, n, u, fe, r, e, t));
    }), Ft = F4(function(n, r, e, t) {
        if (Kt(t)) return fe;
        var u = A2(Pt, "/", t);
        if (u.b) {
            var c = u.a;
            return A5(Rt, n, A2(Dt, c, t), r, e, A2(Lt, c, t));
        }
        return A5(Rt, n, "/", r, e, t);
    }), Ot = F3(function(n, r, e) {
        if (Kt(e)) return fe;
        var t = A2(Pt, "?", e);
        if (t.b) {
            var u = t.a;
            return A4(Ft, n, oe(A2(Dt, u + 1, e)), r, A2(Lt, u, e));
        }
        return A4(Ft, n, fe, r, e);
    }), Wt = F2(function(n, r) {
        if (Kt(r)) return fe;
        var e = A2(Pt, "#", r);
        if (e.b) {
            var t = e.a;
            return A3(Ot, n, oe(A2(Dt, t + 1, r)), A2(Lt, t, r));
        }
        return A3(Ot, n, fe, r);
    }), Et = U, Mt = function(n) {
        return A2(Et, "http://", n) ? A2(Wt, 0, A2(Dt, 7, n)) : A2(Et, "https://", n) ? A2(Wt, 1, A2(Dt, 8, n)) : fe;
    }, jt = function() {
        for(;;);
    }, St = xn, Nt = St(0), Gt = F4(function(n, r, e, t) {
        if (t.b) {
            var u = t.a, c = t.b;
            if (c.b) {
                var a = c.a, i = c.b;
                if (i.b) {
                    var o = i.a, f = i.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, a, A2(n, o, A2(n, f.a, e > 500 ? A3(De, n, r, Se(s)) : A4(Gt, n, r, e + 1, s)))));
                    }
                    return A2(n, u, A2(n, a, A2(n, o, r)));
                }
                return A2(n, u, A2(n, a, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), Qt = F3(function(n, r, e) {
        return A4(Gt, n, r, 0, e);
    }), Ut = F2(function(n, r) {
        return A3(Qt, F2(function(r, e) {
            return A2(se, n(r), e);
        }), w, r);
    }), Ht = Bn, Vt = F2(function(n, r) {
        return A2(Ht, function(r) {
            return St(n(r));
        }, r);
    }), Jt = F3(function(n, r, e) {
        return A2(Ht, function(r) {
            return A2(Ht, function(e) {
                return St(A2(n, r, e));
            }, e);
        }, r);
    }), Xt = Wn, Zt = F2(function(n, r) {
        var e = r;
        return function(n) {
            return An(function(r) {
                r(xn(zn(n)));
            });
        }(A2(Ht, Xt(n), e));
    });
    Fn.Task = {
        b: Nt,
        c: F3(function(n, r) {
            var e;
            return A2(Vt, function() {
                return 0;
            }, (e = A2(Ut, Zt(n), r), A3(Qt, Jt(se), St(w), e)));
        }),
        d: F3(function() {
            return St(0);
        }),
        e: F2(function(n, r) {
            return A2(Vt, n, r);
        }),
        f: undefined
    };
    var Yt, nu, ru = Mn("Task"), eu = F2(function(n, r) {
        return ru(A2(Vt, n, r));
    }), tu = Hr, uu = tn, cu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, au = function(n) {
        switch(n){
            case "de":
                return cu(0);
            case "en":
                return cu(1);
            case "es":
                return cu(2);
            case "fr":
                return cu(3);
            case "ru":
                return cu(4);
            default:
                return {
                    $: 1,
                    a: n
                };
        }
    }, iu = {
        $: 0
    }, ou = F3(function(n, r, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e
        };
    }), fu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, su = F3(function(n, r, e) {
        return n(r(e));
    }), du = Cn, bu = F2(function(n, r) {
        return ru(A2(du, A2(su, A2(su, St, n), $e), A2(Ht, A2(su, A2(su, St, n), ye), r)));
    }), lu = F3(function(n, r, e) {
        return {
            cT: e,
            dx: n,
            dF: r
        };
    }), vu = function(n) {
        return A3(De, F2(function(n, r) {
            return A3(In, n.a, n.b, r);
        }), {}, n);
    }, gu = function(n) {
        var r = n;
        return {
            a1: r.a1,
            cR: function(n) {
                return vu(Se(r.cR(n)));
            }
        };
    }, hu = F3(function(n, r, e) {
        return r(n(e));
    }), $u = function(n) {
        return n.a1;
    }, mu = function(n) {
        return n.cR;
    }, pu = F3(function(n, r, e) {
        return {
            a1: A2(wt, A2(hu, n, $u), $u(e)),
            cR: A2(su, mu(e), r)
        };
    }), wu = L, yu = F, ku = function(n) {
        return A2(yu, n, "");
    }, _u = F3(function(n, r, e) {
        return n > 0 ? A3(_u, n >> 1, p(r, r), 1 & n ? p(e, r) : e) : e;
    }), Iu = F2(function(n, r) {
        return A3(_u, n, r, "");
    }), xu = F3(function(n, r, e) {
        return p(A2(Iu, n - qt(e), ku(r)), e);
    }), Au = function(n) {
        return 0 > n || n > 1114111 ? "\uFFFD" : n > 65535 ? String.fromCharCode(Math.floor((n -= 65536) / 1024) + 55296, n % 1024 + 56320) : String.fromCharCode(n);
    }, Bu = D, Cu = function(n) {
        var r = function(n) {
            return 10 > n ? Be(n) : ku(Au(87 + n));
        };
        return 16 > n ? r(n) : p(Cu(n / 16 | 0), r(A2(Bu, 16, n)));
    }, qu = A2(hu, Cu, A2(xu, 2, "0")), zu = function(n) {
        var r = function(n) {
            return {
                a_: n.d,
                cH: n.c,
                c$: n.b,
                dB: n.a
            };
        }(n), e = r.cH, t = r.c$, u = r.dB;
        return A2(Ce, "", A2(se, "#", A2(Ut, A2(hu, wu, qu), _([
            255 * u,
            255 * t,
            255 * e
        ]))));
    }, Du = F2(function(n) {
        return n;
    }), Pu = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ku = null, Lu = function(n) {
        return {
            a1: Pu(n),
            cR: Du(Ku)
        };
    }, Tu = F2(function(n, r) {
        return r.$ ? fe : n(r.a);
    }), Ru = F2(function(n, r) {
        return r.$ ? $e(r.a) : n(r.a);
    }), Fu = F3(function(n, r, e) {
        var t = n(r);
        return t.$ ? e : A2(se, t.a, e);
    }), Ou = F2(function(n, r) {
        return A3(Qt, Fu(n), w, r);
    }), Wu = F4(function(n, r, e, t) {
        return {
            d: r,
            e3: n,
            hR: e,
            dM: t
        };
    }), Eu = Zr, Mu = F2(function(n, r) {
        return r.$ ? $e(n) : ye(r.a);
    }), ju = Jr, Su = function(n) {
        return A2(ju, {
            go: !1,
            hO: !1
        }, n);
    }, Nu = function(n) {
        return n.b ? oe(n.a) : fe;
    }, Gu = F2(function(n, r) {
        return r.$ ? fe : oe(n(r.a));
    }), Qu = F2(function(n, r) {
        return r.$ ? $e(r.a) : ye(n(r.a));
    }), Uu = F2(function(n, r) {
        return Fe(r) - Fe(n);
    }), Hu = F3(function(n, r, e) {
        var t = Fe(e);
        return 1 > f(Fe(n), t) && 1 > f(t, Fe(r));
    }), Vu = F2(function(n, r) {
        var e = function(e) {
            return 0 > f(e, n) ? ye(e) : $e({
                $: 1,
                a: r
            });
        }, t = A3(Hu, "0", "9", r) ? ye(A2(Uu, "0", r)) : A3(Hu, "a", "z", r) ? ye(10 + A2(Uu, "a", r)) : A3(Hu, "A", "Z", r) ? ye(10 + A2(Uu, "A", r)) : $e({
            $: 0,
            a: r
        });
        return A2(Ru, e, t);
    }), Ju = F2(function(n, r) {
        var e = Ne(r);
        if (1 === e.$) return ye(0);
        var t = e.a, u = t.b;
        return A2(Ru, function(r) {
            return A2(Ru, function(e) {
                return ye(r + e * n);
            }, A2(Ju, n, u));
        }, A2(Vu, n, t.a));
    }), Xu = function(n) {
        for(var r = n.length, e = Array(r), t = 0; r > t;){
            var u = n.charCodeAt(t);
            55296 > u || u > 56319 ? (e[r - t] = n[t], t++) : (e[r - t] = n[t + 1], e[r - ++t] = n[t - 1], t++);
        }
        return e.join("");
    }, Zu = F2(function(n, r) {
        return 2 > n || n > 36 ? $e({
            $: 2,
            a: n
        }) : A2(Ju, n, Xu(r));
    }), Yu = Zu(16), nc = F4(function(n, r, e, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e,
            d: t
        };
    }), rc = F3(function(n, r, e) {
        return A4(nc, n, r, e, 1);
    }), ec = F4(function(n, r, e, t) {
        return A4(nc, n, r, e, t);
    }), tc = z, uc = F2(function(n, r) {
        var e = A2(tc, 10, n);
        return wu(r * e) / e;
    }), cc = M, ac = function(n) {
        return A3(cc, se, w, n);
    }, ic = function(n) {
        return n.toLowerCase();
    }, oc = (Yt = function(n) {
        var r = ac(n);
        if (r.b && !r.b.b) {
            var e = r.a;
            return I(_([
                e,
                e
            ])).join("");
        }
        return n;
    }, A2(hu, ic, A2(hu, function(n) {
        return A2(Gu, function(r) {
            return A3(Eu, 1, r, n);
        }, Su("^#?(?:(?:([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2}))|(?:([a-f\\d])([a-f\\d])([a-f\\d]))|(?:([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2}))|(?:([a-f\\d])([a-f\\d])([a-f\\d])([a-f\\d])))$"));
    }, A2(hu, Tu(Nu), A2(hu, Gu(function(n) {
        return n.dM;
    }), A2(hu, Gu(Ou(At)), A2(hu, Mu("Parsing hex regex failed"), Ru(function(n) {
        var r = A2(Ut, A2(hu, Yt, A2(hu, Yu, Qu(Ye))), n);
        n: for(;;){
            if (r.b && !r.a.$ && r.b.b && !r.b.a.$ && r.b.b.b && !r.b.b.a.$) {
                if (r.b.b.b.b) {
                    if (r.b.b.b.a.$ || r.b.b.b.b.b) break n;
                    var e = r.b, t = e.b;
                    return ye(A4(ec, r.a.a / 255, e.a.a / 255, t.a.a / 255, A2(uc, 2, t.b.a.a / 255)));
                }
                var u = r.b;
                return ye(A3(rc, r.a.a / 255, u.a.a / 255, u.b.a.a / 255));
            }
            break n;
        }
        return $e("Parsing ints from hex failed");
    })))))))), fc = function(n) {
        return 7 === qt(n) ? oc(n) : $e("Parsing hex regex failed");
    }, sc = F2(function(n, r) {
        return {
            a1: r,
            cR: n
        };
    }), dc = en, bc = _n, lc = A2(sc, bc, dc), vc = function(n) {
        return {
            a1: It(n),
            cR: function() {
                return Ku;
            }
        };
    }, gc = F3(function(n, r, e) {
        return e.$ ? n(e.a) : r(e.a);
    }), hc = A3(pu, A2(su, A2(gc, Lu, vc), fc), zu, lc), $c = F4(function(n, r, e, t) {
        var u = t;
        return {
            a1: A3(_t, F2(function(n, r) {
                return n(r);
            }), u.a1, A2(uu, n, $u(e))),
            cR: function(t) {
                return A2(se, g(n, A2(mu, e, r(t))), u.cR(t));
            }
        };
    }), mc = function(n) {
        return {
            a1: It(n),
            cR: function() {
                return w;
            }
        };
    }, pc = gu(A4($c, "error", function(n) {
        return n.cT;
    }, hc, A4($c, "secondary", function(n) {
        return n.dF;
    }, hc, A4($c, "primary", function(n) {
        return n.dx;
    }, hc, mc(lu))))), wc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), yc = function(n) {
        return {
            $: 11,
            g: n
        };
    }, kc = function(n) {
        return A2(Ce, "", n);
    }, _c = function(n) {
        return function(n) {
            switch(n.$){
                case 0:
                    return "expecting '" + n.a + "'";
                case 1:
                    return "expecting int";
                case 2:
                    return "expecting hex";
                case 3:
                    return "expecting octal";
                case 4:
                    return "expecting binary";
                case 5:
                    return "expecting float";
                case 6:
                    return "expecting number";
                case 7:
                    return "expecting variable";
                case 8:
                    return "expecting symbol '" + n.a + "'";
                case 9:
                    return "expecting keyword '" + n.a + "'";
                case 10:
                    return "expecting end";
                case 11:
                    return "unexpected char";
                case 12:
                    return "problem " + n.a;
                default:
                    return "bad repeat";
            }
        }(n.h1) + " at row " + Be(n.ib) + ", col " + Be(n.ef);
    }, Ic = F2(function(n, r) {
        if (r.b) {
            var e = r.b;
            return A2(se, r.a, A3(Qt, F2(function(r, e) {
                return A2(se, n, A2(se, r, e));
            }), w, e));
        }
        return w;
    }), xc = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Ac = F3(function(n, r, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e
        };
    }), Bc = F2(function(n, r) {
        var e = r;
        return function(r) {
            var t = e(r);
            if (1 === t.$) return A2(xc, t.a, t.b);
            var u = t.a, c = t.c, a = n(t.b)(c);
            if (1 === a.$) {
                var i = a.a;
                return A2(xc, u || i, a.b);
            }
            return i = a.a, A3(Ac, u || i, a.b, a.c);
        };
    }), Cc = Bc, qc = {
        $: 10
    }, zc = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Dc = F4(function(n, r, e, t) {
        return {
            ef: r,
            gz: t,
            h1: e,
            ib: n
        };
    }), Pc = {
        $: 0
    }, Kc = F2(function(n, r) {
        return A2(zc, Pc, A4(Dc, n.ib, n.ef, r, n.gy));
    }), Lc = function(n) {
        return function(r) {
            return c(qt(r.dJ), r.f) ? A3(Ac, !1, 0, r) : A2(xc, !1, A2(Kc, r, n));
        };
    }, Tc = Lc(qc), Rc = ee, Fc = function(n) {
        return -n;
    }, Oc = F5(function(n, r, e, t, u) {
        for(;;){
            var a = A3(Rc, n, r, u.dJ);
            if (c(a, -1)) return A3(Ac, 0 > f(u.f, r), 0, {
                ef: t,
                gy: u.gy,
                j: u.j,
                f: r,
                ib: e,
                dJ: u.dJ
            });
            c(a, -2) ? (r += 1, e += 1, t = 1) : (r = a, t += 1);
        }
    }), Wc = function(n) {
        return function(r) {
            return A5(Oc, n, r.f, r.ib, r.ef, r);
        };
    }, Ec = Wc, Mc = F2(function(n, r) {
        var e = r;
        return function(r) {
            var t = e(r);
            if (1 === t.$) return A2(xc, t.a, t.b);
            var u = t.b, c = t.c;
            return A3(Ac, t.a, A2(n, A3(zt, r.f, c.f, r.dJ), u), c);
        };
    }), jc = function(n) {
        return A2(Mc, Du, n);
    }, Sc = jc, Nc = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Gc = function(n) {
        return function(r) {
            return A2(xc, !1, A2(Kc, r, n));
        };
    }, Qc = function(n) {
        return Gc(Nc(n));
    }, Uc = function(n) {
        return function(r) {
            return A3(Ac, !1, n, r);
        };
    }, Hc = Uc, Vc = A2(Cc, function(n) {
        if (qt(n) > 9) return Qc("Expected at most 9 digits, but got " + Be(qt(n)));
        var r = function(n) {
            if (0 === n.length || /[\sxbo]/.test(n)) return fe;
            var r = +n;
            return r == r ? oe(r) : fe;
        }("0." + n);
        return r.$ ? Qc('Invalid float: "' + n + '"') : Hc(wu(1e3 * r.a));
    }, Sc(Ec(Me))), Jc = At, Xc = F6(function(n, r, e, t, u, c) {
        return Jc(n + 60 * r * 60000 + 60 * (e - c) * 1e3 + 1e3 * t + u);
    }), Zc = F3(function(n, r, e) {
        var t = r, u = e;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(xc, e.a, e.b);
            var c = e.a, a = e.b, i = u(e.c);
            if (1 === i.$) {
                var o = i.a;
                return A2(xc, c || o, i.b);
            }
            o = i.a;
            var f = i.c;
            return A3(Ac, c || o, A2(n, a, i.b), f);
        };
    }), Yc = F2(function(n, r) {
        return A3(Zc, Du, n, r);
    }), na = Yc, ra = F2(function(n, r) {
        return A3(Zc, tt, n, r);
    }), ea = ra, ta = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), ua = F3(function(n, r, e) {
        n: for(;;){
            if (e.b) {
                var t = e.b, u = (0, e.a)(n);
                if (u.$) {
                    var c;
                    if ((c = u).a) return c;
                    r = A2(ta, r, c.b), e = t;
                    continue n;
                }
                return u;
            }
            return A2(xc, !1, r);
        }
    }), ca = function(n) {
        return function(r) {
            return A3(ua, r, Pc, n);
        };
    }, aa = ca, ia = function(n) {
        return {
            $: 1,
            a: n
        };
    }, oa = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fa = O, sa = {
        $: 11
    }, da = F2(function(n, r) {
        return function(e) {
            var t = A3(Rc, n, e.f, e.dJ);
            return c(t, -1) ? A2(xc, !1, A2(Kc, e, r)) : c(t, -2) ? A3(Ac, !0, 0, {
                ef: 1,
                gy: e.gy,
                j: e.j,
                f: e.f + 1,
                ib: e.ib + 1,
                dJ: e.dJ
            }) : A3(Ac, !0, 0, {
                ef: e.ef + 1,
                gy: e.gy,
                j: e.j,
                f: t,
                ib: e.ib,
                dJ: e.dJ
            });
        };
    }), ba = F4(function(n, r, e, t) {
        for(;;){
            var u = e(r)(t);
            if (u.$) return c = u.a, A2(xc, n || c, u.b);
            var c = u.a, a = u.b, i = u.c;
            if (a.$) return A3(Ac, n || c, a.a, i);
            n = n || c, r = a.a, t = i;
        }
    }), la = F2(function(n, r) {
        return function(e) {
            return A4(ba, !1, n, r, e);
        };
    }), va = F2(function(n, r) {
        var e = r;
        return function(r) {
            var t = e(r);
            if (t.$) return A2(xc, t.a, t.b);
            var u = t.c;
            return A3(Ac, t.a, n(t.b), u);
        };
    }), ga = va, ha = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $a = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ma = function(n) {
        return n.$ ? ha(n.a) : $a(n.a);
    }, pa = F2(function(n, r) {
        return A2(la, n, function(n) {
            return A2(ga, ma, r(n));
        });
    }), wa = function(n) {
        return A2(pa, "", function(r) {
            if (c(qt(r), n)) {
                var e = Tt(r);
                return e.$ ? Qc('Invalid integer: "' + r + '"') : A2(ga, ia, Hc(e.a));
            }
            return A2(ga, function(n) {
                return oa(A2(fa, r, n));
            }, Sc(A2(da, Me, sa)));
        });
    }, ya = function(n) {
        return {
            $: 8,
            a: n
        };
    }, ka = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), _a = re, Ia = function(n) {
        return !n;
    }, xa = function(n) {
        var r = n.a, e = n.b, t = !Kt(r);
        return function(n) {
            var u = A5(_a, r, n.f, n.ib, n.ef, n.dJ), a = u.a, i = u.b, o = u.c;
            return c(a, -1) ? A2(xc, !1, A2(Kc, n, e)) : A3(Ac, t, 0, {
                ef: o,
                gy: n.gy,
                j: n.j,
                f: a,
                ib: i,
                dJ: n.dJ
            });
        };
    }, Aa = xa, Ba = function(n) {
        return Aa(A2(ka, n, ya(n)));
    }, Ca = function(n) {
        return Qc("Invalid day: " + Be(n));
    }, qa = o, za = function(n) {
        return !(A2(Bu, 4, n) || !A2(Bu, 100, n) && A2(Bu, 400, n));
    }, Da = function(n) {
        var r = n - 1;
        return (r / 4 | 0) - (r / 100 | 0) + (r / 400 | 0);
    }, Pa = A2(Cc, function(n) {
        var r = n.a, e = n.b, t = n.c;
        if (0 > t) return Ca(t);
        var u = function(n) {
            var u = 31536e6 * (r - 1970), c = 864e5 * ((3 > e || !za(r) ? t - 1 : t) + (Da(r) - Da(1970)));
            return Hc(n + u + c);
        };
        switch(e){
            case 1:
                return t > 31 ? Ca(t) : u(0);
            case 2:
                return t > 29 || 29 === t && !za(r) ? Ca(t) : u(26784e5);
            case 3:
                return t > 31 ? Ca(t) : u(50976e5);
            case 4:
                return t > 30 ? Ca(t) : u(7776e6);
            case 5:
                return t > 31 ? Ca(t) : u(10368e6);
            case 6:
                return t > 30 ? Ca(t) : u(130464e5);
            case 7:
                return t > 31 ? Ca(t) : u(156384e5);
            case 8:
                return t > 31 ? Ca(t) : u(183168e5);
            case 9:
                return t > 30 ? Ca(t) : u(209952e5);
            case 10:
                return t > 31 ? Ca(t) : u(235872e5);
            case 11:
                return t > 30 ? Ca(t) : u(262656e5);
            case 12:
                return t > 31 ? Ca(t) : u(288576e5);
            default:
                return Qc('Invalid month: "' + Be(e) + '"');
        }
    }, A2(ea, A2(ea, A2(ea, Hc(F3(function(n, r, e) {
        return h(n, r, e);
    })), wa(4)), aa(_([
        A2(ea, A2(na, Hc(At), Ba("-")), wa(2)),
        wa(2)
    ]))), aa(_([
        A2(ea, A2(na, Hc(At), Ba("-")), wa(2)),
        wa(2)
    ])))), Ka = (nu = F3(function(n, r, e) {
        return n * (60 * r) + e;
    }), A2(ea, Hc(At), aa(_([
        A2(ga, function() {
            return 0;
        }, Ba("Z")),
        A2(ea, A2(ea, A2(ea, Hc(nu), aa(_([
            A2(ga, function() {
                return 1;
            }, Ba("+")),
            A2(ga, function() {
                return -1;
            }, Ba("-"))
        ]))), wa(2)), aa(_([
            A2(ea, A2(na, Hc(At), Ba(":")), wa(2)),
            wa(2),
            Hc(0)
        ]))),
        A2(na, Hc(0), Tc)
    ])))), La = A2(Cc, function(n) {
        return aa(_([
            A2(ea, A2(ea, A2(ea, A2(ea, A2(ea, A2(na, Hc(Xc(n)), Ba("T")), wa(2)), aa(_([
                A2(ea, A2(na, Hc(At), Ba(":")), wa(2)),
                wa(2)
            ]))), aa(_([
                A2(ea, A2(na, Hc(At), Ba(":")), wa(2)),
                wa(2),
                Hc(0)
            ]))), aa(_([
                A2(ea, A2(na, Hc(At), Ba(".")), Vc),
                Hc(0)
            ]))), A2(na, Ka, Tc)),
            A2(na, Hc(A6(Xc, n, 0, 0, 0, 0, 0)), Tc)
        ]));
    }, Pa), Ta = F3(function(n, r, e) {
        return {
            ef: r,
            h1: e,
            ib: n
        };
    }), Ra = function(n) {
        return A3(Ta, n.ib, n.ef, n.h1);
    }, Fa = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return r;
            case 1:
                var e = n.b;
                n = n.a, r = A2(se, e, r);
                continue n;
            default:
                var t = n.b;
                n = n.a, r = A2(Fa, t, r);
                continue n;
        }
    }), Oa = F2(function(n, r) {
        var e = n({
            ef: 1,
            gy: w,
            j: 1,
            f: 0,
            ib: 1,
            dJ: r
        });
        return e.$ ? $e(A2(Fa, e.b, w)) : ye(e.b);
    }), Wa = F2(function(n, r) {
        var e = A2(Oa, n, r);
        return e.$ ? $e(A2(Ut, Ra, e.a)) : ye(e.a);
    }), Ea = A2(wt, function(n) {
        var r = function(n) {
            return A2(Wa, La, n);
        }(n);
        return 1 === r.$ ? Pu(kc(A2(Ic, "; ", A2(Ut, _c, r.a)))) : It(r.a);
    }, dc), Ma = yc(_([
        A2(kt, function(n) {
            return A2(wc, n, {
                bN: !1
            });
        }, Ea),
        A3(_t, wc, A2(uu, "closedAfter", Ea), A2(kt, function(n) {
            return {
                bN: n
            };
        }, A2(uu, "allowCodes", yt)))
    ])), ja = A2(kt, au, dc), Sa = {
        $: -2
    }, Na = Sa, Ga = F5(function(n, r, e, t, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: e,
            d: t,
            e: u
        };
    }), Qa = F5(function(n, r, e, t, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== t.$ || t.a || -1 !== t.d.$ || t.d.a) return A5(Ga, n, r, e, t, u);
            var c = t.d;
            return a = t.e, A5(Ga, 0, t.b, t.c, A5(Ga, 1, c.b, c.c, c.d, c.e), A5(Ga, 1, r, e, a, u));
        }
        var a, i = u.b, o = u.c, f = u.d, s = u.e;
        return -1 !== t.$ || t.a ? A5(Ga, n, i, o, A5(Ga, 0, r, e, t, f), s) : A5(Ga, 0, r, e, A5(Ga, 1, t.b, t.c, t.d, a = t.e), A5(Ga, 1, i, o, f, s));
    }), Ua = l, Ha = F3(function(n, r, e) {
        if (-2 === e.$) return A5(Ga, 0, n, r, Sa, Sa);
        var t = e.a, u = e.b, c = e.c, a = e.d, i = e.e;
        switch(A2(Ua, n, u)){
            case 0:
                return A5(Qa, t, u, c, A3(Ha, n, r, a), i);
            case 1:
                return A5(Ga, t, u, r, a, i);
            default:
                return A5(Qa, t, u, c, a, A3(Ha, n, r, i));
        }
    }), Va = F3(function(n, r, e) {
        var t = A3(Ha, n, r, e);
        return -1 !== t.$ || t.a ? t : A5(Ga, 1, t.b, t.c, t.d, t.e);
    }), Ja = function(n) {
        return A3(De, F2(function(n, r) {
            return A3(Va, n.a, n.b, r);
        }), Na, n);
    }, Xa = function(n) {
        return {
            $: 8,
            b: n
        };
    }, Za = function(n) {
        return A2(kt, Ja, Xa(n));
    }, Ya = function(n) {
        return Za(n);
    }, ni = F2(function(n, r) {
        return A3(Qt, F2(function(r, e) {
            return n(r) ? A2(se, r, e) : e;
        }), w, r);
    }), ri = F3(function(n, r, e) {
        for(;;){
            if (!e.b) return fe;
            var t = e.b;
            if (r(e.a)) return oe(n);
            n += 1, e = t;
        }
    })(0), ei = function(n) {
        return {
            $: 3,
            b: n
        };
    }, ti = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var e = r.b;
            if (n(r.a)) return !0;
            r = e;
        }
    }), ui = F2(function(n, r) {
        return A2(ti, function(r) {
            return c(r, n);
        }, r);
    }), ci = function(n) {
        return n.b ? oe(g(n.a, n.b)) : fe;
    }, ai = function(n) {
        return A2(wt, function(n) {
            var r = ci(n);
            return 1 === r.$ ? Pu("expected non-empty list, but got []") : It(r.a);
        }, ei(n));
    }, ii = function(n) {
        return {
            $: 5,
            c: n
        };
    }, oi = function(n) {
        return yc(_([
            ii(fe),
            A2(kt, oe, n)
        ]));
    }, fi = _t(ut), si = F2(function(n, r) {
        return A3(Qt, uu, r, n);
    }), di = vn, bi = rn, li = F3(function(n, r, e) {
        var t = function(n) {
            return yc(_([
                n,
                ii(e)
            ]));
        };
        return A2(wt, function(u) {
            var c = A2(di, A2(si, n, bi), u);
            if (c.$) return It(e);
            var a = c.a, i = A2(di, t(r), a);
            return i.$ ? A2(si, n, t(r)) : It(i.a);
        }, bi);
    }), vi = F4(function(n, r, e, t) {
        return A2(fi, A3(li, _([
            n
        ]), r, e), t);
    }), gi = F3(function(n, r, e) {
        return A2(fi, A2(uu, n, r), e);
    }), hi = B, $i = F4(function(n, r, e, t) {
        for(;;){
            if (!e.b) return Se(t);
            var u = e.a, c = e.b, a = n(u);
            A2(ui, a, r) ? e = c : (r = A2(se, a, r), e = c, t = A2(se, u, t));
        }
    }), mi = F2(function(n, r) {
        return A4($i, n, w, r, w);
    }), pi = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), wi = A3(gi, "paymentMethods", ei(A3(_t, F2(function(n, r) {
        return {
            a9: n,
            bK: r
        };
    }), A2(uu, "label", Ya(dc)), A2(uu, "value", dc))), A3(gi, "live", yt, A3(gi, "colorScheme", $u(pc), A4(vi, "closedAfter", oi(Ma), fe, A3(gi, "closedText", Ya(dc), A3(gi, "confirmationText", Ya(dc), A3(gi, "locales", ai(ja), It(F7(function(n, r, e, t, u, c, a) {
        return {
            gt: t,
            bU: e,
            eh: u,
            ai: r,
            hD: c,
            hE: n,
            h_: function(n) {
                var r = n.ey;
                return A2(hi, function(n) {
                    return A2(pi, -1, A2(ri, ct(n.bK), _([
                        "invoice",
                        "creditcard",
                        "paypal",
                        "ec-terminal"
                    ])));
                }, A2(mi, function(n) {
                    return n.bK;
                }, A2(ni, function(n) {
                    return !A2(ui, n.bK, A2(Ut, function(n) {
                        return n.bK;
                    }, r));
                }, p(a, n.eU))));
            }
        };
    }))))))))), yi = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), ki = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _i = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Ii = {
        $: 2
    }, xi = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ai = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Bi = {
        $: 1
    }, Ci = function(n) {
        return !n.$;
    }, qi = En, zi = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return fe;
            var e = r.c, t = r.d, u = r.e;
            switch(A2(Ua, n, r.b)){
                case 0:
                    r = t;
                    continue n;
                case 1:
                    return oe(e);
                default:
                    r = u;
                    continue n;
            }
        }
    }), Di = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, e = n.e;
                return a = e.b, i = e.c, t = e.d, s = e.e, A5(Ga, 1, n.b, n.c, A5(Ga, 0, r.b, r.c, r.d, r.e), A5(Ga, 0, a, i, t, s));
            }
            var t, u = n.d, c = n.e, a = c.b, i = c.c, o = (t = c.d).d, f = t.e, s = c.e;
            return A5(Ga, 0, t.b, t.c, A5(Ga, 1, n.b, n.c, A5(Ga, 0, u.b, u.c, u.d, u.e), o), A5(Ga, 1, a, i, f, s));
        }
        return n;
    }, Pi = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, e = n.e;
                return f = e.b, s = e.c, d = e.d, b = e.e, A5(Ga, 1, t = n.b, u = n.c, A5(Ga, 0, r.b, r.c, r.d, i = r.e), A5(Ga, 0, f, s, d, b));
            }
            var t = n.b, u = n.c, c = n.d, a = c.d, i = c.e, o = n.e, f = o.b, s = o.c, d = o.d, b = o.e;
            return A5(Ga, 0, c.b, c.c, A5(Ga, 1, a.b, a.c, a.d, a.e), A5(Ga, 1, t, u, i, A5(Ga, 0, f, s, d, b)));
        }
        return n;
    }, Ki = F7(function(n, r, e, t, u, c, a) {
        if (-1 !== c.$ || c.a) {
            n: for(;;){
                if (-1 === a.$ && 1 === a.a) {
                    if (-1 === a.d.$) {
                        if (1 === a.d.a) return Pi(r);
                        break n;
                    }
                    return Pi(r);
                }
                break n;
            }
            return r;
        }
        return A5(Ga, e, c.b, c.c, c.d, A5(Ga, 0, t, u, c.e, a));
    }), Li = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, e = n.b, t = n.c, u = n.d, c = u.d, a = n.e;
            if (1 === u.a) {
                if (-1 !== c.$ || c.a) {
                    var i = Di(n);
                    if (-1 === i.$) {
                        var o = i.e;
                        return A5(Qa, i.a, i.b, i.c, Li(i.d), o);
                    }
                    return Sa;
                }
                return A5(Ga, r, e, t, Li(u), a);
            }
            return A5(Ga, r, e, t, Li(u), a);
        }
        return Sa;
    }, Ti = F2(function(n, r) {
        if (-2 === r.$) return Sa;
        var e = r.a, t = r.b, u = r.c, c = r.d, a = r.e;
        if (0 > f(n, t)) {
            if (-1 === c.$ && 1 === c.a) {
                var i = c.d;
                if (-1 !== i.$ || i.a) {
                    var o = Di(r);
                    if (-1 === o.$) {
                        var s = o.e;
                        return A5(Qa, o.a, o.b, o.c, A2(Ti, n, o.d), s);
                    }
                    return Sa;
                }
                return A5(Ga, e, t, u, A2(Ti, n, c), a);
            }
            return A5(Ga, e, t, u, A2(Ti, n, c), a);
        }
        return A2(Ri, n, A7(Ki, n, r, e, t, u, c, a));
    }), Ri = F2(function(n, r) {
        if (-1 === r.$) {
            var e = r.a, t = r.b, u = r.c, a = r.d, i = r.e;
            if (c(n, t)) {
                var o = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(i);
                return -1 === o.$ ? A5(Qa, e, o.b, o.c, a, Li(i)) : Sa;
            }
            return A5(Qa, e, t, u, a, A2(Ti, n, i));
        }
        return Sa;
    }), Fi = F2(function(n, r) {
        var e = A2(Ti, n, r);
        return -1 !== e.$ || e.a ? e : A5(Ga, 1, e.b, e.c, e.d, e.e);
    }), Oi = F3(function(n, r, e) {
        var t = r(A2(zi, n, e));
        return t.$ ? A2(Fi, n, e) : A3(Va, n, t.a, e);
    }), Wi = {
        $: 0
    }, Ei = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Mi = {
        $: 2
    }, ji = {
        $: 1
    }, Si = ln, Ni = F2(function(n, r) {
        return r.$ ? $e(n(r.a)) : ye(r.a);
    }), Gi = A2(ae, "", At), Qi = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Ui = Qi, Hi = function(n) {
        return A2(ie, "application/json", A2(Ae, 0, n));
    }, Vi = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ji = function(n) {
        return n.$ ? Vi(n.a) : St(n.a);
    }, Xi = F3(function(n, r, e) {
        return 1 === e.$ ? n : r(e.a);
    }), Zi = F2(function(n, r) {
        var e, t;
        return e = {
            o: A3(Xi, Wi, Hi, r.o),
            a5: A3(Xi, w, function(n) {
                return _([
                    A2(Ui, "X-Cookie", n.gA + "=" + n.gB)
                ]);
            }, n),
            y: r.y,
            be: (t = function() {
                return r.a1;
            }, Gi(function(n) {
                switch(n.$){
                    case 0:
                        return $e({
                            $: 0,
                            a: n.a
                        });
                    case 1:
                        return $e(ji);
                    case 2:
                        return $e(Mi);
                    case 3:
                        return $e(function(n) {
                            return {
                                $: 3,
                                a: n
                            };
                        }(n.a.fL));
                    default:
                        var r = n.b;
                        return A2(Ni, A2(su, Ei, Qe), A2(Si, t(), r));
                }
            })),
            bg: fe,
            bh: p("http://localhost:8080", r.q)
        }, A3(ue, 0, Ji, {
            gg: !0,
            o: e.o,
            b1: e.be,
            a5: e.a5,
            y: e.y,
            bg: e.bg,
            fT: fe,
            bh: e.bh
        });
    }), Yi = F2(function(n, r) {
        return A2(Zi, n, {
            o: fe,
            a1: r.a1,
            y: "GET",
            q: r.q
        });
    }), no = function(n) {
        return A2(Yi, n, {
            a1: wi,
            q: "/public/settings.json"
        });
    }, ro = yc(_([
        A3(gi, "updateText", Ya(dc), A3(gi, "afterLogin", Ya(dc), A3(gi, "beforeLogin", Ya(dc), It(F3(function(n, r, e) {
            return oe({
                ge: r,
                gk: n,
                iF: e
            });
        }))))),
        It(fe)
    ])), eo = fe, to = function(n) {
        return A2(du, function(n) {
            return 3 === n.$ && 404 === n.a ? St(eo) : Vi(n);
        }, A2(Yi, n, {
            a1: ro,
            q: "/public/userAccountSettings.json"
        }));
    }, uo = F3(function(n, r, e) {
        return A2(n, e, r);
    }), co = F2(function(n, r) {
        return g(n, r);
    }), ao = A3(_t, F2(function(n, r) {
        return {
            ak: r,
            eR: n
        };
    }), A2(uu, "_id", dc), A2(uu, "emailAddress", dc)), io = F2(function(n, r) {
        return A2(du, function(n) {
            return 3 === n.$ ? St(fe) : Vi(n);
        }, A2(Yi, n, {
            a1: A2(kt, oe, ao),
            q: r.$ ? "/public/user-account/whoami" : "/public/user-account/whoami?exhibitor=" + r.a
        }));
    }), oo = F3(function(n, r, e) {
        return g(A3(ou, n, r(e), iu), A2(bu, fu, A2(Ht, function(r) {
            if (1 === r.$) return St($e(fe));
            var e = r.a;
            return A2(Ht, function(r) {
                return r.$ ? A2(Vt, A2(su, $e, oe), A2(Vt, A2(uo, co, e), no(n.m))) : St(ye(r.a));
            }, A2(io, n.m, n.hI));
        }, to(n.m))));
    }), fo = function(n) {
        return {
            $: 0,
            a: n
        };
    }, so = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bo = function(n) {
        return {
            $: 1,
            a: n
        };
    }, lo = function(n) {
        return {
            $: 4,
            a: n
        };
    }, vo = function(n) {
        return {
            $: 2,
            a: n
        };
    }, go = function(n) {
        return {
            $: 7,
            a: n
        };
    }, ho = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $o = {
        $: 3
    }, mo = function(n) {
        return {
            $: 5,
            a: n
        };
    }, po = F5(function(n, r, e, t, u) {
        return {
            d5: n,
            ea: r,
            et: e,
            e: u,
            fI: t
        };
    }), wo = function(n) {
        if (n.$) return n.a;
        switch(n.a){
            case 0:
                return "de";
            case 1:
                return "en";
            case 2:
                return "es";
            case 3:
                return "fr";
            default:
                return "ru";
        }
    }, yo = A2(su, bc, wo), ko = A2(sc, yo, ja), _o = co, Io = F3(function(n, r, e) {
        var t = e;
        return {
            a1: r(t.a1),
            cR: n(t.cR)
        };
    }), xo = F2(function(n, r) {
        return A3(De, function(n) {
            return F2(function(r, e) {
                return e.push(n(r)), e;
            });
        }(n), [], r);
    }), Ao = A2(Io, xo, ei), Bo = function(n) {
        return A2(se, n.a, n.b);
    }, Co = function(n) {
        return A3(pu, function(n) {
            return n.b ? vc(A2(_o, n.a, n.b)) : Lu("expected non-empty list, but got `[]'");
        }, Bo, Ao(n));
    }, qo = F2(function(n, r) {
        return 1 === n.$ ? r : r + ":" + Be(n.a);
    }), zo = F3(function(n, r, e) {
        return 1 === r.$ ? e : p(e, p(n, r.a));
    }), Do = function(n) {
        return A3(zo, "#", n.g6, A3(zo, "?", n.h3, p(A2(qo, n.aP, p(n.aQ ? "https://" : "http://", n.aL)), n.q)));
    }, Po = A3(pu, function(n) {
        var r = Mt(n);
        return r.$ ? Lu("expected URL, but got `" + n + "'") : vc(r.a);
    }, Do, lc), Ko = gu(A4($c, "locale", function(n) {
        return n.e;
    }, ko, A4($c, "shopperResultUrl", function(n) {
        return n.fI;
    }, Po, A4($c, "endpoint", function(n) {
        return n.et;
    }, Po, A4($c, "checkoutId", function(n) {
        return n.ea;
    }, lc, A4($c, "brands", function(n) {
        return n.d5;
    }, Co(lc), mc(po))))))), Lo = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), To = {
        a4: Na,
        cq: Na
    }, Ro = function(n) {
        return !n.b;
    }, Fo = function(n) {
        return -2 === n.$;
    }, Oo = function(n) {
        return Fo(n);
    }, Wo = F2(function(n, r) {
        return !A2(zi, n, r).$;
    }), Eo = F2(function(n, r) {
        return A2(Wo, n, r);
    }), Mo = ui, jo = F2(function(n, r) {
        for(;;){
            if (!r.b) return fe;
            var e = r.a, t = r.b;
            if (n(e)) return oe(e);
            r = t;
        }
    }), So = F2(function(n, r) {
        return n(r);
    }), No = So(A2(Xi, w, be)), Go = F3(function(n, r, e) {
        for(;;){
            if (-2 === e.$) return r;
            var t = e.e, u = n, c = A3(n, e.b, e.c, A3(Go, n, r, e.d));
            n = u, r = c, e = t;
        }
    }), Qo = F2(function(n, r) {
        return A3(Go, Va, r, n);
    }), Uo = F2(function(n, r) {
        return A2(Qo, n, r);
    }), Ho = F2(function(n, r) {
        return r.b ? A3(Qt, se, r, n) : n;
    }), Vo = function(n) {
        return A3(Qt, Ho, w, n);
    }, Jo = F2(function(n, r) {
        return Vo(A2(Ut, n, r));
    }), Xo = function(n) {
        return A3(de, F3(function(n, r, e) {
            return A2(se, r, e);
        }), w, n);
    }, Zo = F2(function(n, r) {
        return A2(Jo, No, Xo(A2(Uo, n.g8, r.cq)));
    }), Yo = F4(function(n, r, e, t) {
        return A3(De, _e, 0, A2(Ut, function(r) {
            return r.a * n(r.b);
        }, A2(Ou, function(n) {
            var e = n.a;
            return A2(Gu, co(n.b), A2(jo, A2(su, ct(e), function(n) {
                return n.fP;
            }), r.cq));
        }, A2(Zo, e, t))));
    }), nf = F3(function(n, r, e) {
        return A3(De, _e, 0, A2(Ut, A3(Yo, n, r, e), Xo(e.dt)));
    }), rf = nf(A2(su, pi(0), function(n) {
        return n.fn;
    })), ef = F2(function(n, r) {
        return A2(ti, At, _([
            !Oo(r.e$) && A2(Eo, wo(n.e), r.e$),
            !Oo(r.ee) && A2(ti, function(r) {
                return c(oe(r), n.ec);
            }, le(r.ee)),
            !Oo(r.cq) && A2(ti, function(r) {
                return A2(ti, function(n) {
                    return A2(Mo, r, n);
                }, Xo(n.iz));
            }, le(r.cq)),
            !Ro(r.eC) && A2(ti, function(r) {
                var e = r.a, t = r.b, u = n.gF;
                if (u.$) return c(oe(t), A2(zi, e, n.cg.a4));
                var a = u.a;
                return c(oe(t), A2(zi, e, A2(pi, To, A2(zi, a, n.cg.dt)).a4)) || c(oe(t), A2(zi, e, n.cg.a4));
            }, r.eC),
            r.hn && !A2(rf, n, n.cg)
        ]));
    }), tf = F2(function(n, r) {
        return !A2(ti, A2(su, Ia, n), r);
    }), uf = F2(function(n, r) {
        return A2(tf, At, _([
            Oo(r.e$) || A2(Eo, wo(n.e), r.e$),
            Oo(r.ee) || A2(ti, function(r) {
                return c(oe(r), n.ec);
            }, le(r.ee)),
            Oo(r.cq) || A2(ti, function(r) {
                return A2(ti, Mo(r), Xo(n.iz));
            }, le(r.cq)),
            Ro(r.eC) || A2(ti, function(r) {
                var e = r.a, t = r.b, u = n.gF;
                if (u.$) return c(oe(t), A2(zi, e, n.cg.a4));
                var a = u.a;
                return c(oe(t), A2(zi, e, A2(pi, To, A2(zi, a, n.cg.dt)).a4)) || c(oe(t), A2(zi, e, n.cg.a4));
            }, r.eC),
            !r.hn || !A2(rf, n, n.cg)
        ]));
    }), cf = F5(function(n, r, e, t, u) {
        var c = u.a;
        return A2(uf, {
            ec: A2(Gu, function(n) {
                return n.ec;
            }, n.eb),
            gF: e,
            e: n.e,
            cg: r,
            iz: t,
            cq: n.cq
        }, c.hq) && !A2(ef, {
            ec: A2(Gu, function(n) {
                return n.ec;
            }, n.eb),
            gF: e,
            e: n.e,
            cg: r,
            iz: t,
            cq: n.cq
        }, c.gZ) ? _([
            u
        ]) : w;
    }), af = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), of = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), ff = function(n) {
        return {
            $: 7,
            a: n
        };
    }, sf = F2(function(n, r) {
        return A2(Jo, function(r) {
            var e = r.b;
            return _([
                A2(af, r.a, function() {
                    switch(e.$){
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 8:
                        default:
                            return e;
                        case 6:
                            return A2(of, e.a, A2(sf, n, e.b));
                        case 7:
                            var r = e.a;
                            return ff($(r, {
                                a4: A2(sf, n, r.a4)
                            }));
                    }
                }())
            ]);
        }, A2(Jo, n, r));
    }), df = function(n) {
        return _([
            n
        ]);
    }, bf = F4(function(n, r, e, t) {
        return A2(su, A2(su, Nu, sf(A4(cf, n, r, e, t))), df);
    }), lf = F5(function(n, r, e, t, u) {
        var c = u.b;
        return A2(Lo, u.a, A2(Ou, A4(bf, n, r, e, t), c));
    }), vf = F4(function(n, r, e, t) {
        var u = t.a, c = function() {
            if (1 === e.$) return Na;
            if (e.a.$) {
                var n = A2(zi, 0, e.a.a.dt);
                return 1 === n.$ ? Na : n.a.cq;
            }
            return e.a.a.cq;
        }(), a = A2(ef, {
            ec: A2(Gu, function(n) {
                return n.ec;
            }, n.eb),
            gF: fe,
            e: n.e,
            cg: r,
            iz: c,
            cq: n.cq
        }, u.gZ);
        return A2(uf, {
            ec: A2(Gu, function(n) {
                return n.ec;
            }, n.eb),
            gF: fe,
            e: n.e,
            cg: r,
            iz: c,
            cq: n.cq
        }, u.hq) && !a ? oe(t) : fe;
    }), gf = A, hf = function(n) {
        return n.b;
    }, $f = F2(function(n, r) {
        for(;;){
            if (-2 === r.$) return n;
            var e = r.d;
            n = A2($f, n + 1, r.e), r = e;
        }
    }), mf = function(n) {
        return A2($f, 0, n);
    }, pf = function(n) {
        return n.b ? oe(n.b) : fe;
    }, wf = F3(function(n, r, e) {
        var t = mf(r.dW.cg.dt) - 1, u = A2(Ut, function(n) {
            return {
                bl: n.bl,
                hx: n.hx,
                hX: n.hX
            };
        }, A2(hi, function(n) {
            var r = n.bl;
            return h(n.bc, r.gF, r.gE);
        }, Vo(A2(Re, F2(function(n, r) {
            var e = r.a, u = r.b, c = r.c;
            return c.a.bc ? A2(Ut, function(r) {
                return {
                    bl: {
                        gE: n,
                        gF: r
                    },
                    hx: e,
                    hX: c,
                    bc: u
                };
            }, A2(Te, 0, t)) : _([
                {
                    bl: {
                        gE: n,
                        gF: 0
                    },
                    hx: e,
                    hX: c,
                    bc: u
                }
            ]);
        }), A3(De, F2(function(n, r) {
            var e = r.a, t = e.a, u = e.b, c = r.b;
            return n.a.bc ? g(g(!0, u), p(c, _([
                h(!t, u + 1, n)
            ]))) : g(g(!1, u + 2), p(c, _([
                h(!1, u + 2, n)
            ])));
        }), g(g(!1, 0), w), A2(Ou, A3(vf, r.gy, r.dW.cg, r.ct), e)).b))));
        return A4(gf, F3(function(n, e, t) {
            var u, c;
            return {
                gI: {
                    gD: e.bl,
                    hP: A2(Gu, function(n) {
                        return n.bl;
                    }, t),
                    h0: A2(Gu, function(n) {
                        return n.bl;
                    }, n)
                },
                hx: e.hx,
                hX: (u = e.bl.gF, c = function() {
                    var n = r.ct;
                    if (1 === n.$) return Na;
                    if (n.a.$) {
                        var e = A2(zi, u, n.a.a.dt);
                        return 1 === e.$ ? Na : e.a.cq;
                    }
                    return n.a.a.cq;
                }(), A5(lf, r.gy, r.dW.cg, e.hX.a.bc ? oe(e.bl.gF) : fe, c, e.hX))
            };
        }), A2(se, fe, A2(Ut, oe, u)), u, p(A2(Ut, oe, A2(su, pi(w), pf)(u)), _([
            fe
        ])));
    }), yf = F5(function(n, r, e, t, u) {
        return {
            gS: n,
            a9: r,
            ft: e,
            dR: u,
            fV: t
        };
    }), kf = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _f = function(n) {
        return {
            $: 1,
            a: n
        };
    }, If = nn, xf = Z, Af = yc(_([
        A2(kt, kf, A2(uu, "flat-price", xf)),
        A2(kt, _f, A2(uu, "percentage", If))
    ])), Bf = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Cf = A2(uu, "if-num-persons", A3(_t, Bf, A2(uu, "numPersons", xf), A2(kt, function(n) {
        return {
            gf: n
        };
    }, A2(uu, "allPersons", yt)))), qf = Na, zf = bn, Df = F2(function(n, r) {
        return A3(Va, n, 0, r);
    }), Pf = function(n) {
        return A3(De, Df, qf, n);
    }, Kf = A2(su, kt(Pf), ei), Lf = A6(zf, yf, A2(uu, "discountId", dc), A2(uu, "label", Ya(dc)), A2(uu, "rate", Af), A2(uu, "trigger", Cf), yc(_([
        A2(uu, "ticketIds", Kf(dc)),
        It(qf)
    ]))), Tf = F2(function(n, r) {
        return {
            gZ: r,
            hq: n
        };
    }), Rf = F5(function(n, r, e, t, u) {
        return {
            ee: r,
            eC: t,
            hn: u,
            e$: n,
            cq: e
        };
    }), Ff = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Of = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Wf = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ef = {
        $: 3
    }, Mf = function(n) {
        return {
            $: 4,
            a: n
        };
    }, jf = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Sf = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Nf = function(n) {
        return A2(wt, n, It(0));
    };
    function Gf() {
        var n = A2(kt, jf, A2(wt, A2(hu, Se, It), Xa(Nf(function() {
            return Gf();
        })))), r = A2(kt, Of, ei(Nf(function() {
            return Gf();
        })));
        return yc(_([
            n,
            r,
            ii(Ef),
            A2(kt, Sf, dc),
            A2(kt, Mf, If),
            A2(kt, Wf, yt)
        ]));
    }
    var Qf = Gf();
    Gf = function() {
        return Qf;
    };
    var Uf = A3(_t, Ff, A2(uu, "field", dc), A2(uu, "value", Qf)), Hf = A6(zf, Rf, A2(uu, "language", Kf(dc)), A2(uu, "codes", Kf(dc)), A2(uu, "tickets", Kf(dc)), A2(uu, "fieldValues", ei(Uf)), A2(uu, "ifFree", yt)), Vf = Hf, Jf = A3(_t, Tf, A2(uu, "include", Hf), A2(uu, "exclude", Vf)), Xf = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Zf = {
        $: 1
    }, Yf = {
        $: 2
    }, ns = {
        $: 3
    }, rs = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), es = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ts = {
        $: 8
    }, us = function(n) {
        return {
            $: 9,
            a: n
        };
    }, cs = F5(function(n, r, e, t, u) {
        return {
            g7: u,
            hu: n,
            a9: r,
            fz: e,
            iI: t
        };
    }), as = {
        $: 0
    }, is = function(n) {
        return {
            $: 1,
            a: n
        };
    }, os = {
        $: 2
    }, fs = {
        $: 4
    }, ss = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ds = A2(wt, At, A3(_t, F2(function(n, r) {
        return A3(Xi, Pu("expected regular expression, but got `" + n + "'"), function(e) {
            return It({
                cU: r,
                fg: e,
                dr: n
            });
        }, Su(n));
    }), A2(uu, "pattern", dc), A2(uu, "errorMessage", Ya(dc)))), bs = A2(wt, function(n) {
        switch(n){
            case "bool":
                return It(as);
            case "choice":
                return A2(kt, is, A2(uu, "values", Ya(ai(A2(kt, function(n) {
                    return {
                        bK: n
                    };
                }, dc)))));
            case "email":
                return It(os);
            case "string":
                return A2(kt, ss, yc(_([
                    A2(uu, "customValidation", A2(kt, oe, ds)),
                    It(fe)
                ])));
            case "file":
                return It(fs);
            default:
                return Pu("expected validator, but got `" + n + "'");
        }
    }, A2(uu, "type", dc)), ls = A6(zf, cs, A2(uu, "inputField", dc), A2(uu, "label", Ya(dc)), A2(uu, "required", yt), A2(uu, "validator", bs), yc(_([
        A2(uu, "fullwidth", yt),
        It(!1)
    ]))), vs = un, gs = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hs = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), $s = {
        $: 2
    }, ms = A2(wt, function(n) {
        switch(n){
            case "bool":
                return A2(kt, gs, A2(uu, "description", Ya(dc)));
            case "choice":
                return A3(_t, hs, A2(kt, function(n) {
                    return {
                        fs: n
                    };
                }, yc(_([
                    A2(uu, "radio", yt),
                    It(!1)
                ]))), A2(uu, "variants", Ya(ai(yc(_([
                    A2(kt, function(n) {
                        return {
                            a9: n,
                            bK: n
                        };
                    }, dc),
                    A3(_t, F2(function(n, r) {
                        return {
                            a9: n,
                            bK: r
                        };
                    }), A2(uu, "label", dc), A2(uu, "value", dc))
                ]))))));
            case "string":
                return It($s);
            case "paymentMethod":
                var r = ei(A3(_t, F2(function(n, r) {
                    return {
                        a9: n,
                        bK: r
                    };
                }), A2(uu, "label", Ya(dc)), A2(uu, "value", dc)));
                return A3(_t, F2(function(n, r) {
                    return {
                        $: 3,
                        a: {
                            ey: r,
                            eU: n
                        }
                    };
                }), yc(_([
                    A2(uu, "includePaymentMethods", r),
                    It(w)
                ])), yc(_([
                    A2(uu, "excludePaymentMethods", r),
                    It(w)
                ])));
            case "fileUpload":
                return A3(_t, F2(function(n, r) {
                    return {
                        $: 4,
                        a: {
                            d$: n,
                            hH: r
                        }
                    };
                }), A2(uu, "accept", dc), A2(uu, "maxSize", xf));
            default:
                return Pu("expected input type, but got `" + n + "'");
        }
    }, A2(uu, "type", dc)), ps = ms, ws = function(n) {
        return yc(_([
            A2(kt, oe, n),
            It(fe)
        ]));
    };
    function ys() {
        var n;
        return A3(_t, af, A2(uu, "fieldConfig", Jf), A2(uu, "fieldType", (n = Nf(function() {
            return ys();
        }), yc(_([
            A2(uu, "chosenTicket", A2(kt, Xf, A2(uu, "ticketFields", ei(dc)))),
            A2(uu, "currentPerson", It(Zf)),
            A2(uu, "currentPrice", It(Yf)),
            A2(uu, "guestCodes", It(ns)),
            A2(uu, "input", A3(_t, rs, A2(uu, "inputConfig", ls), A2(uu, "inputType", ps))),
            A2(uu, "markdown", A2(kt, es, A2(uu, "content", Ya(dc)))),
            A2(uu, "persons", A3(_t, of, yc(_([
                A2(uu, "personsConfig", A2(kt, function(n) {
                    return {
                        bu: n
                    };
                }, A2(uu, "limit", A3(_t, co, A2(vs, 0, ws(xf)), A2(vs, 1, ws(xf)))))),
                It({
                    bu: g(fe, fe)
                })
            ])), A2(uu, "fields", ei(n)))),
            A2(uu, "section", A3(_t, F2(function(n, r) {
                return ff({
                    bn: n,
                    a4: r
                });
            }), A2(uu, "fieldMap", oi(ai(dc))), A2(uu, "fields", ei(n)))),
            A2(uu, "summary", It(ts)),
            A2(uu, "ticketSelection", A2(kt, us, A6(zf, F5(function(n, r, e, t, u) {
                return {
                    cc: n,
                    fd: u,
                    fz: r,
                    bD: e,
                    dR: t
                };
            }), A2(uu, "multiple", yt), A2(uu, "required", yt), A2(uu, "ticketField", dc), A2(uu, "ticketIds", ei(dc)), A2(uu, "optionalText", Ya(dc)))))
        ])))));
    }
    var ks = ys();
    ys = function() {
        return ks;
    };
    var _s, Is, xs, As, Bs, Cs, qs, zs, Ds, Ps, Ks = F3(function(n, r, e) {
        return {
            gZ: e,
            hq: r,
            bc: n
        };
    }), Ls = sn, Ts = A4(Ls, Ks, A2(uu, "perPerson", yt), A2(uu, "include", Hf), A2(uu, "exclude", Vf)), Rs = A3(_t, Lo, A2(uu, "pageConfig", Ts), A2(uu, "fields", ei(ks))), Fs = F9(function(n, r, e, t, u, c, a, i, o) {
        return {
            ec: u,
            er: e,
            eG: i,
            eV: a,
            a8: o,
            a9: r,
            fn: c,
            dA: t,
            fP: n
        };
    }), Os = function(n) {
        return {
            dC: n
        };
    }, Ws = A2(kt, Os, A2(uu, "remaining", xf)), Es = (_s = F2(function(n, r) {
        return A2(wt, function(n) {
            return A2(kt, ut(n), r);
        }, n);
    }), A2(_s, A2(uu, "invalid", yt), A2(_s, yc(_([
        A2(uu, "freeOfCharge", yt),
        It(!1)
    ])), A2(_s, A2(uu, "includedVat", oi(xf)), A2(_s, A2(uu, "price", oi(xf)), A2(_s, A2(uu, "codeId", oi(dc)), A2(_s, A2(uu, "quota", oi(Ws)), A2(_s, A2(uu, "description", oi(Ya(dc))), A2(_s, A2(uu, "label", Ya(dc)), A2(_s, A2(uu, "ticketId", dc), It(Fs))))))))))), Ms = Na, js = F2(function(n, r) {
        return {
            gE: n,
            gF: r
        };
    }), Ss = _n, Ns = A2(sc, Ss, xf), Gs = gu(A4($c, "currentPerson", function(n) {
        return n.gF;
    }, Ns, A4($c, "currentPage", function(n) {
        return n.gE;
    }, Ns, mc(js)))), Qs = mu(Gs), Us = F3(function(n, r, e) {
        return A3(Go, F3(function(e, t, u) {
            return A3(In, n(e), r(t), u);
        }), {}, e);
    }), Hs = So(A2(Xi, Ku, A2(Us, At, Ss))), Vs = _n, Js = _n, Xs = function(n) {
        switch(n.$){
            case 0:
                return vu(A2(Ut, function(n) {
                    return g(n.a, Xs(n.b));
                }, n.a));
            case 1:
                return A2(xo, Xs, n.a);
            case 5:
                return bc(n.a);
            case 2:
                return Vs(n.a);
            case 3:
                return Ku;
            default:
                return Js(n.a);
        }
    }, Zs = function(n) {
        return vu(_([
            g("tickets", A3(Us, At, Hs, n.cq)),
            g("fields", A3(Us, At, Xs, n.a4))
        ]));
    }, Ys = function(n) {
        var r, e, t;
        return vu(_([
            g("cursor", Qs(n.bl)),
            g("orderInput", (e = n.cg, vu(_([
                g("fields", A3(Us, At, Xs, e.a4)),
                g("persons", A3(Us, Be, Zs, e.dt)),
                g("tickets", A3(Us, At, Hs, e.cq)),
                g("globalTickets", (t = e.g8, A3(Us, At, Hs, t)))
            ])))),
            g("showErrors", (r = n.cm, vu(_(r.$ ? [
                g("allPages", vu(w))
            ] : [
                g("selectPages", vu(_([
                    g("cursors", A2(xo, Qs, r.a))
                ])))
            ]))))
        ]));
    }, nd = function(n) {
        return {
            $: 1,
            a: n
        };
    }, rd = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ed = ei(dc), td = A3(_t, F2(function(n, r) {
        return {
            a4: r,
            cq: n
        };
    }), yc(_([
        A2(uu, "tickets", Za(ed)),
        It(Na)
    ])), A2(uu, "fields", Za(Qf))), ud = F3(function(n, r, e) {
        if (1 === r.$) return $e(r.a);
        var t = r.a;
        return 1 === e.$ ? $e(e.a) : ye(A2(n, t, e.a));
    }), cd = A2(Qt, ud(se), ye(w)), ad = function(n) {
        return A2(wt, function(n) {
            return A3(gc, Pu, It, A2(Qu, Ja, cd(A2(Ut, function(n) {
                var r = n.a, e = n.b;
                return A2(Mu, "expected int key, but got `" + r + "'", A2(Gu, function(n) {
                    return g(n, e);
                }, Tt(r)));
            }, be(n)))));
        }, Za(n));
    }, id = (Is = yc(_([
        A2(uu, "tickets", Za(ed)),
        It(Na)
    ])), xs = A2(uu, "persons", ad(td)), As = A2(uu, "locale", ja), Bs = A2(uu, "fields", Za(Qf)), Cs = yc(_([
        It(fe),
        A2(uu, "discount", oi(dc))
    ])), qs = yc(_([
        A2(uu, "code", oi(dc)),
        It(fe)
    ])), yc(_([
        A6(zf, F5(function(n, r, e, t, u) {
            return nd({
                eb: e,
                aj: u,
                a4: n,
                e: t,
                dt: r
            });
        }), Bs, xs, qs, As, Cs),
        A6(zf, F5(function(n, r, e, t, u) {
            return rd({
                eb: e,
                aj: u,
                a4: n,
                e: t,
                cq: r
            });
        }), Bs, Is, qs, As, Cs)
    ]))), od = F2(function(n) {
        return A2(du, function(n) {
            return 3 === n.$ && 404 === n.a ? St(fe) : Vi(n);
        }, A2(Yi, n, {
            a1: A2(kt, oe, id),
            q: "/public/registration.json"
        }));
    }), fd = F2(function(n, r) {
        var e = r.eR;
        return A2(Yi, n, {
            a1: It(0),
            q: "/public/payment/status?id=" + e
        });
    }), sd = F2(function(n, r) {
        var e;
        return A2(du, function(n) {
            return 3 === n.$ && 404 === n.a ? St(w) : Vi(n);
        }, A2(Yi, n, {
            a1: ei(Es),
            q: "/public/tickets.json" + (e = r.eb, e.$ ? "" : "?code=" + e.a)
        }));
    }), dd = F2(function(n, r) {
        switch(r.$){
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 8:
            default:
                return w;
            case 6:
                return A2(Jo, n, r.b);
            case 7:
                return A2(Jo, n, r.a.a4);
        }
    }), bd = function(n) {
        return A2(se, n, A2(dd, bd, n.b));
    }, ld = function(n) {
        return A2(Jo, bd, n.b);
    }, vd = function(n) {
        return {
            eb: n.eb,
            gQ: n.gQ,
            as: n.as,
            am: n.am,
            e: n.e,
            ba: n.ba,
            aS: n.aS,
            cq: n.cq,
            aE: n.aE
        };
    }, gd = At, hd = function(n) {
        return oe(A3(De, function(n) {
            return A2(Oi, n, A2(su, A2(su, oe, _e(1)), pi(0)));
        }, Na, n));
    }, $d = F2(function(n, r) {
        if (-2 === r.$) return Sa;
        var e = r.b, t = r.d, u = r.e;
        return A5(Ga, r.a, e, A2(n, e, r.c), A2($d, n, t), A2($d, n, u));
    }), md = F2(function(n, r) {
        return A3(Go, F3(function(r, e, t) {
            var u = t.a, c = t.b;
            return A2(n, r, e) ? g(A3(Va, r, e, u), c) : g(u, A3(Va, r, e, c));
        }), g(Na, Na), r);
    }), pd = F2(function(n, r) {
        return g({
            a4: r.a4,
            cq: A2($d, function() {
                return hd;
            }, r.cq)
        }, gd(A2(md, F2(function(r) {
            return A2(ui, r, n);
        }), A2($d, function() {
            return hd;
        }, r.cq)).a));
    }), wd = F2(function(n, r) {
        return g(r.a, n(r.b));
    }), yd = F2(function(n, r) {
        return A2(Qo, n, r);
    }), kd = Na, _d = A2(De, yd, kd), Id = F2(function(n, r) {
        return A5(Ga, 1, n, r, Sa, Sa);
    }), xd = F2(function(n, r) {
        var e, t = A2(wd, A2(su, _d, Xo), g(A2($d, function() {
            return lt;
        }, e = A2($d, function() {
            return pd(n);
        }, r.$ ? r.a.dt : A2(Id, 0, {
            a4: Na,
            cq: r.a.cq
        }))), A2($d, function() {
            return hf;
        }, e)));
        return {
            a4: r.a.a4,
            g8: t.b,
            dt: t.a,
            cq: Na
        };
    }), Ad = {
        $: 1
    }, Bd = {
        gE: 0,
        gF: 0
    }, Cd = ti(function(n) {
        return A2(ti, function(n) {
            return 6 === n.b.$;
        }, ld(n));
    }), qd = function(n) {
        var r = Cd(n);
        return A2(Jo, function(n) {
            var e = n.a;
            return A2(Ou, function(n) {
                var t = n.b;
                return 9 === t.$ && r && !e.bc ? oe(t.a.bD) : fe;
            }, ld(n));
        }, n);
    }, zd = function(n) {
        return n.a;
    }, Dd = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Pd = F4(function(n, r, e, t) {
        return {
            gy: n,
            gD: {
                gE: 0,
                gF: 0
            },
            eR: 1,
            bc: !1,
            cm: Dd(w),
            bC: t,
            iC: fe,
            ct: fe,
            dW: r,
            iL: e
        };
    }), Kd = {
        a4: Na,
        g8: kd,
        dt: Na,
        cq: Na
    }, Ld = {
        bl: Bd,
        cg: Kd,
        cm: Dd(w)
    }, Td = Jn("inspect", At), Rd = b, Fd = function(n) {
        return 1 === n.$;
    }, Od = F3(function(n, r, e) {
        var t = e.b.bN;
        return f(r, e.a) > -1 && (!t || Fd(n));
    }), Wd = function(n) {
        return 1 !== n.$;
    }, Ed = F4(function(n, r, e, t) {
        return A2(Ht, function(r) {
            return A2(Ht, function(e) {
                return A2(Ht, function(t) {
                    return St(A3(n, r, e, t));
                }, t);
            }, e);
        }, r);
    }), Md = F2(function(n, r) {
        return A2(du, A2(su, Vi, n), r);
    }), jd = Jn("mountCheckout", At), Sd = jn, Nd = Sd(w), Gd = (zs = Jc, An(function(n) {
        n(xn(zs(Date.now())));
    })), Qd = F2(function(n, r) {
        return 1 === r.$ ? n : r;
    }), Ud = F4(function(n, r, e, t) {
        return {
            eb: r,
            ec: n,
            ez: t,
            eH: e
        };
    }), Hd = F3(function(n, r, e) {
        return {
            eH: e,
            eR: n,
            a9: r
        };
    }), Vd = A4(Ls, Hd, A2(uu, "_id", dc), A2(uu, "label", Ya(dc)), A2(uu, "freeTickets", xf)), Jd = dn, Xd = A5(Jd, Ud, A2(uu, "codeId", dc), A2(uu, "code", dc), ws(A2(uu, "freeTickets", Za(ai(dc)))), ws(A2(uu, "exhibitor", Vd))), Zd = F2(function(n, r) {
        var e = r.eb;
        return A2(du, function(n) {
            return 3 === n.$ && 409 === n.a ? St($e(e)) : Vi(n);
        }, A2(Yi, n, {
            a1: yc(_([
                A2(kt, ye, Xd),
                A2(kt, $e, It(e))
            ])),
            q: "/public/redeem-code?code=" + e
        }));
    }), Yd = function(n) {
        return {
            $: 1,
            a: n
        };
    }, nb = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), rb = {
        $: 0
    }, eb = F3(function(n, r, e) {
        return {
            $: 3,
            a: n,
            b: r,
            c: e
        };
    }), tb = F2(function(n, r) {
        var e = A2(Ut, function(n) {
            return n.eV;
        }, r), t = A2(Ut, function(n) {
            return n.fn;
        }, r), u = n.ft;
        if (u.$) {
            var c = u.a;
            return {
                eV: at(A3(De, _e, 0, A2(Ut, A2(su, st(c), Ye), e))),
                fn: at(A3(De, _e, 0, A2(Ut, A2(su, st(c), Ye), t)))
            };
        }
        var a = u.a;
        return {
            eV: at(A3(De, _e, 0, e) * (a / A3(De, _e, 0, t))),
            fn: a
        };
    }), ub = F2(function(n, r) {
        return A3(Go, F3(function(r, e, t) {
            return A2(n, r, e) ? A3(Va, r, e, t) : t;
        }), Na, r);
    }), cb = F2(function(n, r) {
        return A2(ub, F2(function(n) {
            return A2(Wo, n, r);
        }), n);
    }), ab = F2(function(n, r) {
        return A2(cb, n, r);
    }), ib = F2(function(n, r) {
        return A2(Qo, n, r);
    }), ob = F2(function(n, r) {
        return !!Oo(r.dR) || A2(su, Ia, Oo)(A2(ab, r.dR, A3(De, ib, qf, A2(Ut, function(r) {
            return Pf(A2(Ou, function(n) {
                return n.b > 0 ? oe(n.a) : fe;
            }, A2(Jo, No, Xo(A2(Uo, n.g8, r.cq)))));
        }, Xo(n.dt)))));
    }), fb = F4(function(n, r, e, t) {
        return A2(Ut, function(r) {
            var e = r.a, t = n(r.b);
            return {
                eV: e * t.eV,
                fn: e * t.fn
            };
        }, A2(Ou, function(n) {
            var e = n.a;
            return A2(Gu, co(n.b), A2(jo, A2(su, ct(e), function(n) {
                return n.fP;
            }), r.cq));
        }, A2(Zo, e, t)));
    }), sb = fb(function(n) {
        return {
            eV: A2(pi, 0, n.eV),
            fn: A2(pi, 0, n.fn)
        };
    }), db = F3(function(n, r, e) {
        if (A2(ob, r, e)) {
            var t = e.fV, u = t.a, c = t.b.gf;
            return f(mf(r.dt), u) > -1 ? oe(A2(Jo, A2(sb, n, r), A2(Ut, hf, A2(ni, function(n) {
                return f(n.a + 1, u) > -1 || c;
            }, A2(Re, co, Xo(r.dt)))))) : fe;
        }
        return fe;
    }), bb = F3(function(n, r, e) {
        return A2(Tu, function(n) {
            return n.fn > 0 ? oe(n) : fe;
        }, A2(Gu, tb(e), A3(db, n, r, e)));
    }), lb = F3(function(n, r, e) {
        return Nu(Se(A2(hi, A2(su, function(n) {
            return n.fn;
        }, hf), A2(Ou, function(e) {
            return A2(Gu, co(e), A3(bb, n, r, e));
        }, e))));
    }), vb = F2(function(n, r) {
        return A2(lr, function(n) {
            return gr.test(n) ? "data-" + n : n;
        }(n), pr(r));
    }), gb = vb, hb = ir("b"), $b = F2(function(n, r) {
        return A2(br, n, bc(r));
    }), mb = $b("className"), pb = lr("class"), wb = lr("d"), yb = ir("div"), kb = lr("fill"), _b = ar("http://www.w3.org/2000/svg"), Ib = _b("path"), xb = _b("svg"), Ab = lr("viewBox"), Bb = A2(yb, _([
        mb("mdc-checkbox__background")
    ]), _([
        A2(xb, _([
            pb("mdc-checkbox__checkmark"),
            Ab("0 0 24 24")
        ]), _([
            A2(Ib, _([
                pb("mdc-checkbox__checkmark-path"),
                kb("none"),
                wb("M1.73,12.91 8.1,19.28 22.79,4.59")
            ]), w)
        ])),
        A2(yb, _([
            mb("mdc-checkbox__mixedmark")
        ]), w)
    ])), Cb = F2(function(n, r) {
        return A2(br, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), function(n) {
            return "string" == typeof n && $r.test(n) ? "" : n;
        }(r));
    }), qb = Cb, zb = function(n) {
        return oe(A2(qb, "checked", Vs(c(n.cn, oe(1)))));
    }, Db = function(n) {
        return oe(A2(qb, "disabled", Vs(n.I)));
    }, Pb = function(n) {
        return oe(A2(qb, "indeterminate", Vs(c(n.cn, oe(2)))));
    }, Kb = sr, Lb = F2(function(n, r) {
        return A2(Kb, n, {
            $: 0,
            a: r
        });
    }), Tb = ir("input"), Rb = $b("type"), Fb = function(n) {
        var r;
        return A2(Tb, A2(Ou, At, _([
            oe(Rb("checkbox")),
            oe(mb("mdc-checkbox__native-control")),
            zb(n),
            Pb(n),
            (r = n, A2(Gu, function(n) {
                return A2(Lb, "change", It(n));
            }, r.dj))
        ])), w);
    }, Ob = function(n) {
        return ir(mr(n));
    }, Wb = A2(yb, _([
        mb("mdc-checkbox__ripple")
    ]), w), Eb = oe(mb("mdc-checkbox")), Mb = function(n) {
        var r, e, t = n.cz, u = n.bG;
        return r = A3(Ob, "mdc-checkbox", p(A2(Ou, At, _([
            Eb,
            (e = n, e.bG ? oe(mb("mdc-checkbox--touch")) : fe),
            zb(n),
            Pb(n),
            Db(n)
        ])), t), _([
            Fb(n),
            Bb,
            Wb
        ])), u ? A2(yb, _([
            mb("mdc-touch-target-wrapper")
        ]), _([
            r
        ])) : r;
    }, jb = function(n) {
        return mb(A2(Ce, " ", A2(Ut, lt, A2(ni, hf, n))));
    }, Sb = {
        cz: w,
        cP: !1,
        I: !1,
        bp: fe,
        c1: fe,
        hK: fe,
        dk: fe,
        dQ: fe,
        bG: !0,
        cu: !1
    }, Nb = {
        cz: w,
        I: !1,
        dj: fe,
        cn: fe,
        bG: !0
    }, Gb = {
        cz: w,
        cI: !1,
        c_: !1,
        a9: fe,
        dI: 0
    }, Qb = {
        cz: w,
        cA: !1,
        cY: fe,
        a9: fe,
        dk: fe
    }, Ub = {
        cz: w,
        aG: !1,
        I: !1,
        dj: fe,
        bG: !0
    }, Hb = {
        cz: w,
        I: !1,
        a9: fe,
        bt: fe,
        dj: fe,
        fz: !1,
        dG: fe,
        dU: !0
    }, Vb = function(n) {
        return {
            cz: w,
            I: !1,
            bK: n.bK
        };
    }, Jb = {
        cz: w,
        I: !1,
        cS: !1,
        g7: !1,
        a9: fe,
        bt: fe,
        c9: fe,
        b8: fe,
        dc: fe,
        b9: fe,
        di: fe,
        dj: fe,
        dm: fe,
        fg: fe,
        du: fe,
        dv: fe,
        fz: !1,
        dK: fe,
        dN: fe,
        cu: fe,
        cv: fe,
        dU: !0,
        bK: fe
    }, Xb = F3(function(n, r, e) {
        return {
            $: 0,
            a: {
                bO: r,
                I: !1,
                cd: n,
                ce: e,
                fc: fe
            }
        };
    }), Zb = F5(function(n, r, e, t, u) {
        return {
            cM: u,
            c5: t,
            de: n,
            dI: r,
            cv: e
        };
    }), Yb = A3(gi, "dataURL", dc, A3(gi, "lastModified", A2(kt, Jc, xf), A3(gi, "type", dc, A3(gi, "size", xf, A3(gi, "name", dc, It(Zb)))))), nl = ir("a"), rl = function(n) {
        var r;
        return A2($b, "href", hr.test(r = n) ? "" : r);
    }, el = F2(function(n, r) {
        return 1 === n.$ ? r.$ ? $e(A2(se, n.a, r.a)) : ye(r.a) : ye(n.a);
    }), tl = F2(function(n, r) {
        return Ro(r) ? "<" + n + ">" : "<" + n + " " + function(n) {
            return A2(Ce, " ", A2(Ut, function(n) {
                return n.de + '="' + n.bK + '"';
            }, n));
        }(r) + ">";
    }), ul = function(n) {
        var r, e = A2(Ut, function(n) {
            return n;
        }, n);
        return r = A3(De, F2(function(n, r) {
            return F3(function(e, t, u) {
                return A2(el, A3(n, e, t, u), A3(r, e, t, u));
            });
        }), F3(function() {
            return $e(w);
        }), e), F3(function(n, e, t) {
            return A2(Ni, function(r) {
                if (r.b) {
                    if (r.b.b) return "oneOf failed parsing this value:\n    " + A2(tl, n, e) + "\n\nParsing failed in the following 2 ways:\n\n\n" + A2(Ce, "\n\n", A2(Re, F2(function(n, r) {
                        return "(" + Be(n + 1) + ") " + r;
                    }), r)) + "\n";
                    var t = r.a;
                    return "Problem with the given value:\n\n" + A2(tl, n, e) + "\n\n" + t + "\n";
                }
                return "Ran into a oneOf with no possibilities!";
            }, A3(r, n, e, t));
        });
    }, cl = ir("span"), al = dr, il = al, ol = F2(function(n, r) {
        return F3(function(e) {
            return c(e, n) ? ye(r) : $e("Expected " + n + " but was " + e);
        });
    }), fl = ul(_([
        A2(ol, "center", function(n) {
            return A2(cl, _([
                A2(il, "text-align", "center")
            ]), n);
        })
    ])), sl = $b("target"), dl = $b("title"), bl = $b("align"), ll = $b("alt"), vl = ir("blockquote"), gl = ir("br"), hl = F2(function(n, r) {
        return A2(br, n, Vs(r));
    }), $l = hl("checked"), ml = ir("code"), pl = ir("del"), wl = hl("disabled"), yl = ir("em"), kl = ir("h1"), _l = ir("h2"), Il = ir("h3"), xl = ir("h4"), Al = ir("h5"), Bl = ir("h6"), Cl = ir("hr"), ql = ir("img"), zl = ir("li"), Dl = ir("ol"), Pl = ir("p"), Kl = ir("pre"), Ll = function(n) {
        return A2($b, "src", pr(n));
    }, Tl = ir("strong"), Rl = ir("table"), Fl = ir("tbody"), Ol = ir("td"), Wl = cr, El = Wl, Ml = ir("th"), jl = ir("thead"), Sl = ir("tr"), Nl = ir("ul"), Gl = function(n) {
        return _(n.trim().split(/\s+/g));
    }, Ql = {
        gl: vl(w),
        gu: function(n) {
            var r, e = n.o, t = !(r = A2(Gu, Gl, n.e$)).$ && r.a.b ? _([
                mb("language-" + r.a.a)
            ]) : w;
            return A2(Kl, w, _([
                A2(ml, t, _([
                    El(e)
                ]))
            ]));
        },
        gv: function(n) {
            return A2(ml, w, _([
                El(n)
            ]));
        },
        gW: function(n) {
            return A2(yl, w, n);
        },
        hd: A2(gl, w, w),
        hf: function(n) {
            var r = n.gq;
            switch(n.hA){
                case 0:
                    return A2(kl, w, r);
                case 1:
                    return A2(_l, w, r);
                case 2:
                    return A2(Il, w, r);
                case 3:
                    return A2(xl, w, r);
                case 4:
                    return A2(Al, w, r);
                default:
                    return A2(Bl, w, r);
            }
        },
        hl: ul(w),
        ho: function(n) {
            var r = n.iA;
            if (r.$) return A2(ql, _([
                Ll(n.dJ),
                ll(n.cB)
            ]), w);
            var e = r.a;
            return A2(ql, _([
                Ll(n.dJ),
                ll(n.cB),
                dl(e)
            ]), w);
        },
        hC: F2(function(n, r) {
            var e = n.iA;
            if (e.$) return A2(nl, _([
                rl(n.a2)
            ]), r);
            var t = e.a;
            return A2(nl, _([
                rl(n.a2),
                dl(t)
            ]), r);
        }),
        hW: F2(function(n, r) {
            var e;
            return A2(Dl, 1 === n ? _([
                (e = n, A2($b, "start", Be(e)))
            ]) : w, A2(Ut, function(n) {
                return A2(zl, w, n);
            }, r));
        }),
        hY: Pl(w),
        ik: function(n) {
            return A2(pl, w, n);
        },
        il: function(n) {
            return A2(Tl, w, n);
        },
        io: Rl(w),
        ip: Fl(w),
        iq: function(n) {
            return Ol(A2(pi, w, A2(Gu, df, A2(Gu, bl, A2(Gu, function(n) {
                switch(n){
                    case 0:
                        return "left";
                    case 2:
                        return "center";
                    default:
                        return "right";
                }
            }, n)))));
        },
        ir: jl(w),
        is: function(n) {
            return Ml(A2(pi, w, A2(Gu, df, A2(Gu, bl, A2(Gu, function(n) {
                switch(n){
                    case 0:
                        return "left";
                    case 2:
                        return "center";
                    default:
                        return "right";
                }
            }, n)))));
        },
        it: Sl(w),
        iu: El,
        iv: A2(Cl, w, w),
        iD: function(n) {
            return A2(Nl, w, A2(Ut, function(n) {
                var r = n.a, e = n.b, t = function() {
                    switch(r){
                        case 0:
                            return El("");
                        case 1:
                            return A2(Tb, _([
                                wl(!0),
                                $l(!1),
                                Rb("checkbox")
                            ]), w);
                        default:
                            return A2(Tb, _([
                                wl(!0),
                                $l(!0),
                                Rb("checkbox")
                            ]), w);
                    }
                }();
                return A2(zl, w, A2(se, t, e));
            }, n));
        }
    }, Ul = (Ds = Ql, $(Ds, {
        hl: fl,
        hC: F2(function(n, r) {
            if (A2(Et, "tel:", n.a2)) return A2(nl, _([
                rl(n.a2)
            ]), r);
            if (A2(Et, "mailto:", n.a2)) return A2(nl, _([
                rl(n.a2)
            ]), r);
            var e = n.iA;
            if (e.$) return A2(nl, _([
                rl(n.a2),
                sl("_blank")
            ]), r);
            var t = e.a;
            return A2(nl, _([
                rl(n.a2),
                dl(t),
                sl("_blank")
            ]), r);
        })
    })), Hl = {
        g2: At,
        h8: Ul
    }, Vl = F2(function(n, r) {
        return r.$ ? n(r.a) : r.a;
    }), Jl = A2(su, zi, wo), Xl = F2(function(n, r) {
        var e = n.e;
        return A2(Qd, A2(Jl, n.gQ, r), A2(Jl, e, r));
    }), Zl = F2(function(n, r) {
        return A2(su, pi(r), Xl(n));
    }), Yl = function(n) {
        return A2(su, A2(su, ci, ni(n)), Bo);
    }, nv = $b("htmlFor"), rv = function(n) {
        return A2(Lb, "click", It(n));
    }, ev = function(n) {
        return A2(Gu, rv, n.dk);
    }, tv = ir("label"), uv = function(n) {
        var r, e = n.a9;
        return A2(tv, A2(Ou, At, _([
            (r = n, A2(Gu, nv, r.cY)),
            ev(n)
        ])), _([
            El(A2(pi, "", e))
        ]));
    }, cv = oe(mb("mdc-form-field")), av = F2(function(n, r) {
        var e, t = n.cz;
        return A3(Ob, "mdc-form-field", p(A2(Ou, At, _([
            cv,
            (e = n, e.cA ? oe(mb("mdc-form-field--align-end")) : fe)
        ])), t), p(r, _([
            uv(n)
        ])));
    }), iv = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ov = {
        gN: ".",
        gO: {
            $: 0,
            a: 0
        },
        df: "\u2212",
        dg: "",
        fl: "",
        fm: "",
        cp: 0,
        iw: "",
        f9: "",
        ga: ""
    }, fv = $(ov, {
        gO: iv(2),
        iw: ","
    }), sv = (Ps = fv, $(Ps, {
        gN: ",",
        iw: "."
    })), dv = fv, bv = $(ov, {
        gN: ",",
        gO: iv(3),
        iw: "."
    }), lv = bv, vv = F5(function(n, r, e, t, u) {
        return {
            gO: e,
            eY: r,
            ff: n,
            dv: t,
            dN: u
        };
    }), gv = W, hv = function(n) {
        return 0 > n ? -n : n;
    }, $v = F2(function(n, r) {
        var e = qt(r), t = 0 > f(e, n) ? hv(n - e) : 0;
        return p(r, A2(Iu, t, "0"));
    }), mv = F2(function(n, r) {
        return 1 > n ? r : A3(zt, 0, -n, r);
    }), pv = F2(function(n, r) {
        return 1 > n ? "" : A3(zt, -n, qt(r), r);
    }), wv = function(n) {
        return "0" !== A2(pv, 1, n) ? n : wv(A2(mv, 1, n));
    }, yv = F2(function(n, r) {
        var e = n.gO;
        switch(e.$){
            case 1:
                return wv(r);
            case 2:
                return r;
            default:
                return A2($v, e.a, r);
        }
    }), kv = J, _v = F2(function(n, r) {
        var e = A2(ti, function(n) {
            return "0" !== n && "." !== n;
        }, ac(r));
        return p(n && e ? "-" : "", r);
    }), Iv = function(n) {
        var r = n.a, e = n.b;
        if ("9" === r) {
            var t = Ne(e);
            return 1 === t.$ ? "01" : A2(yu, "0", Iv(t.a));
        }
        var u = Fe(r);
        return u >= 48 && 57 > u ? A2(yu, Au(u + 1), e) : "0";
    }, xv = R, Av = F3(function(n, r, e) {
        return p(e, A2(Iu, n - qt(e), ku(r)));
    }), Bv = function(n) {
        var r = A2(qe, ".", n);
        return r.b ? g(r.a, r.b.b ? r.b.a : "0") : g("0", "0");
    }, Cv = F2(function(n, r) {
        var e = r.b;
        return g(n(r.a), e);
    }), qv = F3(function(n, r, e) {
        if ((t = e) === 1 / 0 || t === -1 / 0 || xv(e)) return kv(e);
        var t, u = 0 > e, c = Bv(function(n) {
            var r = A2(qe, "e", kv(hv(n)));
            if (r.b) {
                if (r.b.b) {
                    var e = r.a, t = r.b.a, u = A2(pi, 0, Tt(A2(Et, "+", t) ? A2(Dt, 1, t) : t)), c = Bv(e), a = p(c.a, c.b), i = 0 > u ? A2(pi, "0", A2(Gu, function(n) {
                        return n.a + "." + n.b;
                    }, A2(Gu, Cv(ku), Ne(p(A2(Iu, hv(u), "0"), a))))) : A3(Av, u + 1, "0", a);
                    return p(0 > n ? "-" : "", i);
                }
                return p(0 > n ? "-" : "", e = r.a);
            }
            return "";
        }(hv(e))), a = c.a, i = c.b, o = qt(a) + r, s = p(A2(Iu, 1 - o, "0"), A3(Av, o, "0", p(a, i))), d = qt(s), b = A2(ft, 1, o), l = A2(n, u, A3(zt, b, d, s)), v = A3(zt, 0, b, s), g = l ? Xu(A2(pi, "1", A2(Gu, Iv, Ne(Xu(v))))) : v, h = qt(g), $ = "0" === g ? g : r > 0 ? 0 > f(r, qt(i)) ? A3(zt, 0, h - r, g) + "." + A3(zt, h - r, h, g) : p(a + ".", A3(Av, r, "0", i)) : p(g, A2(Iu, hv(r), "0"));
        return A2(_v, u, $);
    }), zv = qv(F2(function(n, r) {
        var e, t = Ne(r);
        return 1 !== t.$ && ("5" === t.a.a ? "" !== t.a.b || !n : (e = Fe(t.a.a)) > 53 && n || e >= 53 && !n);
    })), Dv = F2(function(n, r) {
        var e, t = function() {
            var r = n.gO;
            switch(r.$){
                case 1:
                default:
                    return zv(r.a);
                case 0:
                    return kv;
            }
        }(), u = A2(qe, ".", t(r)), c = (e = pf(u)).$ ? "" : A2(pi, "", Nu(e.a));
        return g(A2(pi, "", Nu(u)), c);
    }), Pv = F2(function(n, r) {
        return n ? function(n) {
            var r = qt(n) > 3 ? A2(pv, 3, n) : n, e = function(n) {
                return qt(n) > 2 ? A2(se, A2(pv, 2, n), e(A2(mv, 2, n))) : qt(n) ? _([
                    n
                ]) : w;
            };
            return Se(A2(se, r, e(A2(mv, 3, n))));
        }(A2(gv, Me, r)) : function(n) {
            var r = function(n) {
                return qt(n) > 3 ? A2(se, A2(pv, 3, n), r(A2(mv, 3, n))) : _([
                    n
                ]);
            };
            return Se(r(n));
        }(A2(gv, Me, r));
    }), Kv = F2(function(n, r) {
        var e, t = A2(Dv, n, r), u = A5(vv, r, A2(Pv, n.cp, A2(gv, Me, t.a)), A2(yv, n, t.b), "", "");
        switch(A2(Ie, function(n) {
            return "0" === n;
        }, kc(A2(Ho, (e = u).eY, df(e.gO)))) ? 1 : 0 > e.ff ? 2 : 0){
            case 2:
                return $(u, {
                    dv: n.df,
                    dN: n.dg
                });
            case 0:
                return $(u, {
                    dv: n.fl,
                    dN: n.fm
                });
            default:
                return $(u, {
                    dv: n.f9,
                    dN: n.ga
                });
        }
    }), Lv = F2(function(n, r) {
        return "" === r ? "" : p(n.gN, r);
    }), Tv = F2(function(n, r) {
        var e = Lv(n), t = A2(Ce, n.iw, r.eY), u = e(r.gO);
        return kc(_([
            r.dv,
            t,
            u,
            r.dN
        ]));
    }), Rv = F2(function(n, r) {
        return A2(Tv, n, A2(Kv, n, r));
    }), Fv = $(ov, {
        gN: ",",
        gO: iv(3),
        iw: "\u202F"
    }), Ov = Fv, Wv = dv, Ev = F2(function(n, r) {
        var e = function() {
            if (n.$) return ov;
            switch(n.a){
                case 0:
                    return sv;
                case 1:
                    return dv;
                case 2:
                    return lv;
                case 3:
                    return Ov;
                default:
                    return Wv;
            }
        }();
        return A2(Rv, $(e, {
            gO: iv(2)
        }), r / 100) + "\xa0EUR";
    }), Mv = At, jv = A2(su, Mv, Ja), Sv = A2(su, Ja, Ut(Cv(wo))), Nv = _([
        0,
        1,
        2,
        3,
        4
    ]), Gv = function(n) {
        return Sv(A2(Ut, function(r) {
            return g(cu(r), n(r));
        }, Nv));
    }, Qv = function(n) {
        return 5 === n.$ ? oe(n.a) : fe;
    }, Uv = F2(function(n, r) {
        return n.$ ? r : A2(se, n.a, r);
    }), Hv = A2(Qt, Uv, w), Vv = F2(function(n, r) {
        return A2(zi, n, r);
    }), Jv = {
        cz: w,
        ds: !1,
        dV: !0
    }, Xv = oe(A2(gb, "aria-hidden", "true")), Zv = oe(mb("mdc-text-field-helper-text")), Yv = function(n) {
        return n.dV ? oe(mb("mdc-text-field-helper-text--validation-msg")) : fe;
    }, ng = F2(function(n, r) {
        var e, t = n.cz;
        return A2(yb, p(A2(Ou, At, _([
            Zv,
            (e = n, e.ds ? oe(mb("mdc-text-field-helper-text--persistent")) : fe),
            Yv(n),
            Xv
        ])), t), _([
            El(r)
        ]));
    }), rg = F2(function(n, r) {
        return $(r, {
            ds: n
        });
    }), eg = F2(function(n, r) {
        return $(r, {
            dV: n
        });
    }), tg = function(n) {
        var r = n.iH;
        return A2(yb, _([
            mb("mdc-text-field-helper-line")
        ]), _([
            A2(ng, A2(eg, !0, A2(rg, !0, Jv)), A3(Xi, "", function(n) {
                return n.cU;
            }, r))
        ]));
    }, ug = $b("id"), cg = oe(A2(gb, "aria-value-max", "1")), ag = oe(A2(gb, "aria-value-min", "0")), ig = function(n) {
        return A2(Gu, A2(su, A2(su, gb("aria-value-now"), kv), function(n) {
            return n.dy;
        }), n);
    }, og = function(n) {
        return oe(A2(qb, "closed", Vs(n.cI)));
    }, fg = function(n) {
        return pb(c(n, fe) ? "mdc-circular-progress__indeterminate-circle" : "mdc-circular-progress__determinate-circle");
    }, sg = _b("circle"), dg = lr("cx"), bg = function(n) {
        var r = n.dI;
        return dg(function() {
            switch(r){
                case 0:
                    return "24";
                case 1:
                    return "16";
                default:
                    return "12";
            }
        }());
    }, lg = lr("cy"), vg = function(n) {
        var r = n.dI;
        return lg(function() {
            switch(r){
                case 0:
                    return "24";
                case 1:
                    return "16";
                default:
                    return "12";
            }
        }());
    }, gg = lr("r"), hg = function(n) {
        var r = n.dI;
        return gg(function() {
            switch(r){
                case 0:
                    return "18";
                case 1:
                    return "12.5";
                default:
                    return "8.75";
            }
        }());
    }, $g = lr("stroke-dasharray"), mg = lr("stroke-dashoffset"), pg = F2(function(n, r) {
        var e = r.dI;
        return A3(su, mg, kv, function() {
            var r = g(n, e);
            if (r.a.$) switch(r.b){
                case 0:
                    return 56.549;
                case 1:
                    return 39.27;
                default:
                    return 27.489;
            }
            else switch(r.b){
                case 0:
                    return 113.097;
                case 1:
                    return 78.54;
                default:
                    return 54.978;
            }
        }());
    }), wg = F4(function(n, r, e, t) {
        var u, c;
        return A2(sg, p(_([
            bg(t),
            vg(t),
            hg(t),
            (u = t, c = u.dI, A3(su, $g, kv, function() {
                switch(c){
                    case 0:
                        return 113.097;
                    case 1:
                        return 78.54;
                    default:
                        return 54.978;
                }
            }())),
            A2(pg, e, t),
            n(t)
        ]), A2(Ou, At, _([
            A2(Gu, ut(e), r)
        ]))), w);
    }), yg = lr("stroke-width"), kg = function(n) {
        var r = n.dI;
        return A3(su, yg, kv, function() {
            switch(r){
                case 0:
                    return 4;
                case 1:
                    return 3;
                default:
                    return 2.5;
            }
        }());
    }, _g = pb("mdc-circular-progress__determinate-track"), Ig = function(n) {
        return A2(sg, _([
            _g,
            bg(n),
            vg(n),
            hg(n),
            kg(n)
        ]), w);
    }, xg = function(n) {
        var r = n.dI;
        return Ab(function() {
            switch(r){
                case 0:
                    return "0 0 48 48";
                case 1:
                    return "0 0 32 32";
                default:
                    return "0 0 24 24";
            }
        }());
    }, Ag = F2(function(n, r) {
        return A2(xb, _([
            pb("mdc-circular-progress__determinate-circle-graphic"),
            xg(Gb)
        ]), _([
            Ig(r),
            A4(wg, kg, oe(fg), n, r)
        ]));
    }), Bg = F2(function(n, r) {
        return A2(yb, _([
            mb("mdc-circular-progress__determinate-container")
        ]), _([
            A2(Ag, n, r)
        ]));
    }), Cg = function(n) {
        return oe(A2(qb, "determinate", Vs(!c(n, fe))));
    }, qg = F2(function(n, r) {
        return A2(xb, _([
            pb("mdc-circular-progress__indeterminate-circle-graphic"),
            xg(r)
        ]), _([
            A4(wg, n, fe, fe, r)
        ]));
    }), zg = function(n) {
        var r = n.dI;
        return A3(su, yg, kv, function() {
            switch(r){
                case 0:
                    return 3.2;
                case 1:
                    return 2.4;
                default:
                    return 2;
            }
        }());
    }, Dg = F2(function(n, r) {
        return A2(yb, A2(se, mb("mdc-circular-progress__spinner-layer"), r), _([
            A2(yb, _([
                mb("mdc-circular-progress__circle-clipper"),
                mb("mdc-circular-progress__circle-left")
            ]), _([
                A2(qg, kg, n)
            ])),
            A2(yb, _([
                mb("mdc-circular-progress__gap-patch")
            ]), _([
                A2(qg, zg, n)
            ])),
            A2(yb, _([
                mb("mdc-circular-progress__circle-clipper"),
                mb("mdc-circular-progress__circle-right")
            ]), _([
                A2(qg, kg, n)
            ]))
        ]));
    }), Pg = function(n) {
        var r = n.c_;
        return A2(yb, _([
            mb("mdc-circular-progress__indeterminate-container")
        ]), _(r ? [
            A2(Dg, n, _([
                mb("mdc-circular-progress__color-1")
            ])),
            A2(Dg, n, _([
                mb("mdc-circular-progress__color-2")
            ])),
            A2(Dg, n, _([
                mb("mdc-circular-progress__color-3")
            ])),
            A2(Dg, n, _([
                mb("mdc-circular-progress__color-4")
            ]))
        ] : [
            A2(Dg, n, w)
        ]));
    }, Kg = function(n) {
        return c(n, fe) ? oe(mb("mdc-circular-progress--indeterminate")) : fe;
    }, Lg = function(n) {
        return A2(Gu, A2(su, A2(su, qb("progress"), Js), function(n) {
            return n.dy;
        }), n);
    }, Tg = oe(A2(gb, "role", "progressbar")), Rg = oe(mb("mdc-circular-progress")), Fg = F2(function(n, r) {
        var e, t, u = r.cz;
        return A3(Ob, "mdc-circular-progress", p(A2(Ou, At, _([
            Rg,
            Kg(n),
            Tg,
            (e = r, t = e.a9, A2(Gu, gb("aria-label"), t)),
            ag,
            cg,
            ig(n),
            Cg(n),
            Lg(n),
            og(r)
        ])), p(function(n) {
            var r = n.dI, e = Be(function() {
                switch(r){
                    case 0:
                        return 48;
                    case 1:
                        return 36;
                    default:
                        return 24;
                }
            }()) + "px";
            return _([
                A2(il, "width", e),
                A2(il, "height", e)
            ]);
        }(r), u)), _([
            A2(Bg, A2(pi, oe({
                dy: 0
            }), A2(Gu, oe, n)), r),
            Pg(r)
        ]));
    }), Og = function(n) {
        return A2(Fg, fe, n);
    }, Wg = function(n) {
        return g(n.gE, n.gF);
    }, Eg = F2(function(n, r) {
        return r.$ ? Ad : Dd(A4($i, At, w, A2(hi, Wg, A2(se, n, r.a)), w));
    }), Mg = Ja(_([
        g("BLOCK A-C | kostenfrei", "BLOCK A-C"),
        g("BLOCK 01-05 | kostenfrei", "BLOCK 01"),
        g("Mitglied | BLOCK A-C | Fr\xfchbucher", "BLOCK A-C"),
        g("Mitglied | BLOCK A-C", "BLOCK A-C"),
        g("Mitglied | BLOCK 01-05 | Fr\xfchbucher", "BLOCK 01"),
        g("Mitglied | BLOCK 01-05", "BLOCK 01"),
        g("Mitglied | Biogas Intensiv 01 | Fr\xfchbucher", "Biogas Intensiv 01"),
        g("Mitglied | Biogas Intensiv 02 | Fr\xfchbucher", "Biogas Intensiv 02"),
        g("Mitglied | Biogas Intensiv 03 | Fr\xfchbucher", "Biogas Intensiv 03"),
        g("Mitglied | Biogas Intensiv 04 | Fr\xfchbucher", "Biogas Intensiv 04"),
        g("Mitglied | Biogas Intensiv 05 | Fr\xfchbucher", "Biogas Intensiv 05"),
        g("Mitglied | Biogas Intensiv 01", "Biogas Intensiv 01"),
        g("Mitglied | Biogas Intensiv 02", "Biogas Intensiv 02"),
        g("Mitglied | Biogas Intensiv 03", "Biogas Intensiv 03"),
        g("Mitglied | Biogas Intensiv 04", "Biogas Intensiv 04"),
        g("Mitglied | Biogas Intensiv 05", "Biogas Intensiv 05"),
        g("Nichtmitglied | BLOCK A-C | Fr\xfchbucher", "BLOCK A-C"),
        g("Nichtmitglied | BLOCK A-C", "BLOCK A-C"),
        g("Nichtmitglied | BLOCK 01-05 | Fr\xfchbucher", "BLOCK 01"),
        g("Nichtmitglied | BLOCK 01-05", "BLOCK 01"),
        g("Nichtmitglied | Biogas Intensiv 01 | Fr\xfchbucher", "Biogas Intensiv 01"),
        g("Nichtmitglied | Biogas Intensiv 02 | Fr\xfchbucher", "Biogas Intensiv 02"),
        g("Nichtmitglied | Biogas Intensiv 03 | Fr\xfchbucher", "Biogas Intensiv 03"),
        g("Nichtmitglied | Biogas Intensiv 04 | Fr\xfchbucher", "Biogas Intensiv 04"),
        g("Nichtmitglied | Biogas Intensiv 05 | Fr\xfchbucher", "Biogas Intensiv 05"),
        g("Nichtmitglied | Biogas Intensiv 01", "Biogas Intensiv 01"),
        g("Nichtmitglied | Biogas Intensiv 02", "Biogas Intensiv 02"),
        g("Nichtmitglied | Biogas Intensiv 03", "Biogas Intensiv 03"),
        g("Nichtmitglied | Biogas Intensiv 04", "Biogas Intensiv 04"),
        g("Nichtmitglied | Biogas Intensiv 05", "Biogas Intensiv 05"),
        g("DAC-Liste | BLOCK A-C | Fr\xfchbucher", "BLOCK A-C"),
        g("DAC-Liste | BLOCK A-C", "BLOCK A-C"),
        g("DAC-Liste | BLOCK 01-05 | kostenfrei", "BLOCK 01"),
        g("Lehrfahrt | Fr\xfchbucher", ""),
        g("Lehrfahrt", ""),
        g("Lehrfahrt | DAC-Liste | Fr\xfchbucher", ""),
        g("Lehrfahrt | DAC-Liste", ""),
        g("Abendveranstaltung | Fr\xfchbucher", ""),
        g("Abendveranstaltung", ""),
        g("Ja, ich nehme an der Abendveranstaltung teil.", ""),
        g("Nein, ich nehme nicht an der Abendveranstaltung teil.", ""),
        g("Messe | Dienstag | Tageskasse", "Dienstag"),
        g("Messe | Mittwoch | Tageskasse", "Mittwoch"),
        g("Messe | Donnerstag | Tageskasse", "Donnerstag"),
        g("Messe | Dienstag", "Dienstag"),
        g("Messe | Mittwoch", "Mittwoch"),
        g("Messe | Donnerstag", "Donnerstag"),
        g("Messe | Dauerticket | Tageskasse", "Dauerticket"),
        g("Messe | Dauerticket", "Dauerticket"),
        g("Messe | Mitglied", ""),
        g("Aussteller-Gast", ""),
        g("Aussteller-Standpersonal (kostenfrei)", ""),
        g("Aussteller-Standpersonal", ""),
        g("Biogas Intensiv 01 | kostenfrei", "Biogas Intensiv 01"),
        g("Biogas Intensiv 02 | kostenfrei", "Biogas Intensiv 02"),
        g("Biogas Intensiv 03 | kostenfrei", "Biogas Intensiv 03"),
        g("Biogas Intensiv 04 | kostenfrei", "Biogas Intensiv 04"),
        g("Biogas Intensiv 05 | kostenfrei", "Biogas Intensiv 05"),
        g("Lehrfahrt | kostenfrei", ""),
        g("Messe | Dauerticket | kostenfrei", "Dauerticket"),
        g("Presse", "Presse"),
        g("Referierende", "Referierende"),
        g("Gast", "Gast"),
        g("Team", "Team"),
        g("Beh\xf6rde", "Beh\xf6rde"),
        g("European Biogas Association", "European Biogas Association"),
        g("BLOCK 02", "BLOCK 02"),
        g("BLOCK 03", "BLOCK 03"),
        g("BLOCK 04", "BLOCK 04"),
        g("BLOCK 05", "BLOCK 05"),
        g("Messe | Sch\xfcler / Student | Dienstag", "Dienstag"),
        g("Messe | Sch\xfcler / Student | Mittwoch", "Mittwoch"),
        g("Messe | Sch\xfcler / Student | Donnerstag", "Donnerstag"),
        g("Ich nehme nicht an der Messe teil.", ""),
        g("Beh\xf6rde | BLOCK 01-05 | Fr\xfchbucher", "BLOCK 01"),
        g("Beh\xf6rde | BLOCK 01-05", "BLOCK 01"),
        g("Beh\xf6rde | Biogas Intensiv 01 | Fr\xfchbucher", "Biogas Intensiv 01"),
        g("Beh\xf6rde | Biogas Intensiv 02 | Fr\xfchbucher", "Biogas Intensiv 02"),
        g("Beh\xf6rde | Biogas Intensiv 03 | Fr\xfchbucher", "Biogas Intensiv 03"),
        g("Beh\xf6rde | Biogas Intensiv 04 | Fr\xfchbucher", "Biogas Intensiv 04"),
        g("Beh\xf6rde | Biogas Intensiv 05 | Fr\xfchbucher", "Biogas Intensiv 05"),
        g("Beh\xf6rde | Biogas Intensiv 01", "Biogas Intensiv 01"),
        g("Beh\xf6rde | Biogas Intensiv 02", "Biogas Intensiv 02"),
        g("Beh\xf6rde | Biogas Intensiv 03", "Biogas Intensiv 03"),
        g("Beh\xf6rde | Biogas Intensiv 04", "Biogas Intensiv 04"),
        g("Beh\xf6rde | Biogas Intensiv 05", "Biogas Intensiv 05"),
        g("Ich nehme an keinem Programmpunkt von 09:00 - 12:00 Uhr teil.", ""),
        g("Ich nehme an keinem Programmpunkt von 13:00 - 16:00 Uhr teil.", ""),
        g("Beh\xf6rde | Ich nehme an keinem Programmpunkt von 09:00 - 12:00 Uhr teil.", ""),
        g("Beh\xf6rde | Ich nehme an keinem Programmpunkt von 13:00 - 16:00 Uhr teil.", ""),
        g("Storniert", ""),
        g("Indien (Block A-C)", "BLOCK A-C"),
        g('Mitglied | "BLOCK 01-05"', "BLOCK 01")
    ])), jg = /.^/, Sg = Yr(ne), Ng = F2(function(n, r) {
        switch(n){
            case 0:
            case 1:
                return r;
            default:
                return A3(Sg, A2(pi, jg, Su("&")), function() {
                    return "&amp;";
                }, r);
        }
    }), Gg = F2(function(n, r) {
        return A2(pi, "", A2(zi, n, r));
    }), Qg = A2(pi, jg, Su("{{[^}]*}}")), Ug = F2(function(n, r) {
        return A2(Sg, Qg, function(e) {
            var t, u = e.e3;
            return A2(Ng, n, (t = A2(su, mv(2), Dt(2))(u), function(n) {
                var r = A2(zi, n, Mg);
                return r.$ ? n : r.a;
            }(A2(Gg, t, r))));
        });
    }), Hg = F2(function(n, r) {
        var e = r.b;
        return g(n(r.a), A2(Ut, n, e));
    }), Vg = function(n) {
        return $d(A2(su, n, au));
    }, Jg = Mv(Na), Xg = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Zg = function(n) {
        return A2(mv, qt(".json"), A2(Ce, "-", A2(Xg, 1, A2(su, pi(w), pf)(A2(qe, "-", n)))));
    }, Yg = ir("button"), nh = function(n) {
        return A2(Gu, rv, n.dk);
    }, rh = function(n) {
        return oe(wl(n.I));
    }, eh = function(n) {
        return A2(Gu, rl, n.bp);
    }, th = function(n) {
        return oe(A2(cl, _([
            mb("mdc-button__label")
        ]), _([
            El(n)
        ])));
    }, uh = fr, ch = uh, ah = function(n) {
        var r = n;
        return A2(Gu, ch(jt), function() {
            var n = r.c1;
            if (n.$) return fe;
            if (n.a.$) return e = n.a.a.ce, t = n.a.a.bO, oe(A2(n.a.a.cd, A2(se, pb("mdc-button__icon"), A2(se, A2(gb, "aria-hidden", "true"), t)), e));
            var e = n.a.a.ce, t = n.a.a.bO;
            return oe(A2(n.a.a.cd, A2(se, mb("mdc-button__icon"), A2(se, A2(gb, "aria-hidden", "true"), t)), e));
        }());
    }, ih = function(n) {
        return n.cu ? fe : ah(n);
    }, oh = function(n) {
        var r = n.cf;
        return A2(Gu, A2(su, Lb("MDCMenuSurface:close"), It), r);
    }, fh = {
        cz: w,
        cD: !1,
        cP: !1,
        b5: !0,
        cl: !0,
        dT: !1,
        iJ: !1,
        d_: !1
    }, sh = function(n) {
        return n.cD ? oe(mb("mdc-deprecated-list--avatar-list")) : fe;
    }, dh = function(n) {
        var r = function(n) {
            return 0 === n.$ ? oe(n.b.dk) : fe;
        }, e = A2(wt, function(e) {
            var t = function(e) {
                return A2(Tu, At, Nu(A2(Xg, e, A2(Ou, At, A2(Ut, r, n)))));
            }(e);
            return t.$ ? Pu("") : It(t.a);
        }, A2(si, _([
            "detail",
            "index"
        ]), xf));
        return oe(A2(Lb, "MDCList:action", e));
    }, bh = function(n) {
        return oe(A2(qb, "interactive", Vs(n.b5)));
    }, lh = oe(mb("mdc-deprecated-list")), vh = function(n) {
        var r = A2(Ou, At, A2(Re, F2(function(n, r) {
            return 0 === r.$ ? c(r.b.ig, fe) ? fe : oe(n) : fe;
        }), A2(ni, function(n) {
            return 0 === n.$;
        }, n)));
        return oe(A2(qb, "selectedIndex", A2(xo, Ss, r)));
    }, gh = function(n) {
        return n.dT ? oe(mb("mdc-deprecated-list--two-line")) : fe;
    }, hh = function(n) {
        return oe(A2(qb, "wrapFocus", Vs(n.d_)));
    }, $h = F3(function(n, r, e) {
        var t, u = n.cz, c = n.b5, a = n.cl, i = A2(se, r, e);
        return A3(Ob, "mdc-list", p(A2(Ou, At, _([
            lh,
            (t = n, t.cP ? oe(mb("mdc-deprecated-list--dense")) : fe),
            sh(n),
            gh(n),
            hh(n),
            dh(i),
            vh(i),
            bh(n)
        ])), u), A2(Ut, function(n) {
            return 0 === n.$ ? (0, n.a)($(n.b, {
                cl: a && c
            })) : n.a;
        }, i));
    }), mh = function(n) {
        return oe(A2(qb, "quickOpen", Vs(n.dz)));
    }, ph = oe(mb("mdc-menu mdc-menu-surface")), wh = F2(function(n, r) {
        return $(r, {
            cl: n
        });
    }), yh = F2(function(n, r) {
        return $(r, {
            d_: n
        });
    }), kh = F3(function(n, r, e) {
        var t, u = n.cz;
        return A3(Ob, "mdc-menu", p(A2(Ou, At, _([
            ph,
            (t = n, oe(A2(qb, "open", Vs(t.dn)))),
            mh(n),
            oh(n)
        ])), u), _([
            A3($h, A2(yh, !0, A2(wh, !1, fh)), r, e)
        ]));
    }), _h = oe(A2(yb, _([
        mb("mdc-button__ripple")
    ]), w)), Ih = oe(mb("mdc-button")), xh = function(n) {
        return oe(A2(qb, "tabIndex", Ss(n.I ? -1 : 0)));
    }, Ah = function(n) {
        var r = n.dQ;
        return c(n.bp, fe) ? fe : A2(Gu, sl, r);
    }, Bh = function(n) {
        return n.bG ? oe(mb("mdc-button--touch")) : fe;
    }, Ch = function(n) {
        return n.bG ? oe(A2(yb, _([
            mb("mdc-button__touch")
        ]), w)) : fe;
    }, qh = function(n) {
        return n.cu ? ah(n) : fe;
    }, zh = function(n) {
        switch(n){
            case 0:
                return fe;
            case 1:
                return oe(mb("mdc-button--raised"));
            case 2:
                return oe(mb("mdc-button--unelevated"));
            default:
                return oe(mb("mdc-button--outlined"));
        }
    }, Dh = F3(function(n, r, e) {
        var t, u, a = r, i = a.I, o = a.bG, f = a.cz;
        return function(n) {
            var r = a.hK;
            if (1 === r.$) return n;
            var e = r.a, t = e.a, u = e.b, c = e.c;
            return A2(yb, _([
                mb("mdc-menu-surface--anchor")
            ]), _([
                n,
                A3(kh, t, u, c)
            ]));
        }((t = A3(Ob, "mdc-button", w, _([
            A2(c(a.bp, fe) || i ? Yg : nl, p(A2(Ou, At, _([
                Ih,
                zh(n),
                (u = r, u.cP ? oe(mb("mdc-button--dense")) : fe),
                Bh(r),
                rh(r),
                xh(r),
                eh(r),
                Ah(r),
                nh(r)
            ])), f), A2(Ou, At, _([
                _h,
                ih(r),
                th(e),
                qh(r),
                Ch(r)
            ])))
        ])), o ? A2(yb, _([
            mb("mdc-touch-target-wrapper")
        ]), _([
            t
        ])) : t));
    }), Ph = F2(function(n, r) {
        return A3(Dh, 3, n, r);
    }), Kh = mb("mdc-select__anchor"), Lh = function(n) {
        return A2(gb, "aria-expanded", n ? "true" : "false");
    }, Th = A2(gb, "role", "button"), Rh = F2(function(n, r) {
        return A2(yb, p(_([
            Kh,
            Th,
            A2(gb, "aria-haspopup", "listbox"),
            Lh(!1)
        ]), n), r);
    }), Fh = function(n) {
        return oe(A2(qb, "disabled", Vs(n.I)));
    }, Oh = lr("fill-rule"), Wh = ir("i"), Eh = lr("points"), Mh = _b("polygon"), jh = lr("stroke"), Sh = A2(Wh, _([
        mb("mdc-select__dropdown-icon")
    ]), _([
        A2(xb, _([
            pb("mdc-select__dropdown-icon-graphic"),
            Ab("7 10 10 5"),
            A2(vb, "focusable", "false")
        ]), _([
            A2(Mh, _([
                pb("mdc-select__dropdown-icon-inactive"),
                jh("none"),
                Oh("evenodd"),
                Eh("7 10 12 15 17 10")
            ]), w),
            A2(Mh, _([
                pb("mdc-select__dropdown-icon-active"),
                jh("none"),
                Oh("evenodd"),
                Eh("7 15 12 10 17 15")
            ]), w)
        ]))
    ])), Nh = function(n) {
        return n ? fe : oe(mb("mdc-select--filled"));
    }, Gh = function(n) {
        return A2(Gu, function(n) {
            return A2(yb, _([
                mb("mdc-floating-label")
            ]), _([
                El(n)
            ]));
        }, n.a9);
    }, Qh = function(n) {
        return A2(Gu, function() {
            return mb("mdc-select--with-leading-icon");
        }, n.bt);
    }, Uh = A2(uu, "keyCode", xf), Hh = function(n) {
        return A2(lr, "tabIndex", Be(n));
    }, Vh = function(n) {
        var r = n.bt;
        if (1 === r.$) return El("");
        if (r.a.$) return e = r.a.a.I, t = r.a.a.fc, u = r.a.a.ce, c = r.a.a.bO, A2(r.a.a.cd, A2(se, pb("mdc-select__icon"), function() {
            if (t.$) return c;
            var n = t.a;
            return e ? A2(se, Hh(-1), A2(se, A2(gb, "role", "button"), c)) : A2(se, Hh(0), A2(se, A2(gb, "role", "button"), A2(se, rv(n), A2(se, A2(Lb, "keydown", A2(wt, function(r) {
                return 13 === r ? It(n) : Pu("");
            }, Uh)), c))));
        }()), u);
        var e = r.a.a.I, t = r.a.a.fc, u = r.a.a.ce, c = r.a.a.bO;
        return A2(r.a.a.cd, A2(se, mb("mdc-select__icon"), function() {
            if (t.$) return c;
            var n = t.a;
            return e ? A2(se, Hh(-1), A2(se, A2(gb, "role", "button"), c)) : A2(se, Hh(0), A2(se, A2(gb, "role", "button"), A2(se, rv(n), A2(se, A2(Lb, "keydown", A2(wt, function(r) {
                return 13 === r ? It(n) : Pu("");
            }, Uh)), c))));
        }()), u);
    }, Jh = A2(tv, _([
        mb("mdc-line-ripple")
    ]), w), Xh = {
        cz: w,
        cf: fe,
        dn: !1,
        dz: !1
    }, Zh = F2(function(n, r) {
        return A2(yb, A2(se, mb("mdc-deprecated-list-item__graphic"), n), r);
    }), Yh = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), n$ = function(n) {
        return c(n.ig, oe(1)) ? oe(mb("mdc-deprecated-list-item--activated")) : fe;
    }, r$ = function(n) {
        return c(n.ig, fe) ? fe : oe(A2(gb, "aria-selected", "true"));
    }, e$ = function(n) {
        return n.I ? oe(mb("mdc-deprecated-list-item--disabled")) : fe;
    }, t$ = function(n) {
        return A2(qb, "interactive", Vs(n.b5));
    }, u$ = oe(mb("mdc-deprecated-list-item")), c$ = A2(cl, _([
        mb("mdc-deprecated-list-item__ripple")
    ]), w), a$ = function(n) {
        return c(n.ig, oe(0)) ? oe(mb("mdc-deprecated-list-item--selected")) : fe;
    }, i$ = function(n) {
        var r = n.dQ;
        return c(n.bp, fe) ? fe : A2(Gu, sl, r);
    }, o$ = F2(function(n, r) {
        var e, t = n.bp, u = n.cz;
        return A2(F2(function(r, e) {
            var u;
            return A3(Ob, "mdc-list-item", p(_([
                (u = n, A2(qb, "ripples", Vs(u.cl))),
                t$(n)
            ]), c(t, fe) ? r : w), c(t, fe) ? e : _([
                A2(nl, r, e)
            ]));
        }), p(A2(Ou, At, _([
            u$,
            (e = n, A2(Gu, rl, e.bp)),
            i$(n),
            e$(n),
            a$(n),
            n$(n),
            r$(n)
        ])), u), A2(se, c$, r));
    }), f$ = F2(function(n, r) {
        return A2(Yh, function(n) {
            return A2(o$, n, r);
        }, n);
    }), s$ = {
        cz: w,
        I: !1,
        bp: fe,
        b5: !1,
        dk: fe,
        cl: !1,
        ig: fe,
        dQ: fe
    }, d$ = F2(function(n, r) {
        return $(r, {
            cz: n
        });
    }), b$ = F2(function(n, r) {
        return $(r, {
            I: n
        });
    }), l$ = F2(function(n, r) {
        return $(r, {
            dk: oe(n)
        });
    }), v$ = F2(function(n, r) {
        return $(r, {
            ig: n
        });
    }), g$ = F3(function(n, r, e) {
        var t = e.cz, u = e.I, a = e.bK;
        return (r.$ ? At : l$((0, r.a)(a)))(A2(v$, c(n, oe(a)) ? oe(1) : fe, A2(d$, t, A2(b$, u, s$))));
    }), h$ = F4(function(n, r, e, t) {
        var u = t.b;
        return A2(f$, A3(g$, r, e, t.a), Vo(_([
            c(n, fe) ? w : _([
                A2(Zh, w, w)
            ]),
            _([
                A2(yb, _([
                    mb("mdc-deprecated-list-item__text")
                ]), _([
                    El(u)
                ]))
            ])
        ])));
    }), $$ = F2(function(n, r) {
        return $(r, {
            cz: n
        });
    }), m$ = F5(function(n, r, e, t, u) {
        return A3(kh, A2($$, _([
            mb("mdc-select__menu"),
            A2(il, "width", "100%")
        ]), Xh), A4(h$, n, r, e, t), A2(Ut, A3(h$, n, r, e), u));
    }), p$ = function(n) {
        return A2(cl, _([
            mb("mdc-notched-outline")
        ]), _([
            A2(cl, _([
                mb("mdc-notched-outline__leading")
            ]), w),
            A2(cl, _([
                mb("mdc-notched-outline__notch")
            ]), A2(Ou, At, _([
                Gh(n)
            ]))),
            A2(cl, _([
                mb("mdc-notched-outline__trailing")
            ]), w)
        ]));
    }, w$ = function(n) {
        return 1 === n ? oe(mb("mdc-select--outlined")) : fe;
    }, y$ = function(n) {
        return oe(A2(qb, "required", Vs(n.fz)));
    }, k$ = oe(A2(cl, _([
        mb("mdc-select__ripple")
    ]), w)), _$ = oe(mb("mdc-select")), I$ = function(n) {
        return oe(A2(qb, "selectedIndex", Ss(A2(pi, -1, n))));
    }, x$ = A2(cl, _([
        mb("mdc-select__selected-text")
    ]), w), A$ = A2(cl, _([
        mb("mdc-select__selected-text-container")
    ]), _([
        x$
    ])), B$ = function(n) {
        return oe(A2(qb, "valid", Vs(n.dU)));
    }, C$ = F4(function(n, r, e, t) {
        var u, a = r.dj, i = r.cz, o = r.dG, f = r.bt, s = Nu(A2(Ou, At, A2(Re, F2(function(n, r) {
            return c(oe(r.a.bK), o) ? oe(n) : fe;
        }), A2(se, e, t))));
        return A3(Ob, "mdc-select", p(A2(Ou, At, _([
            _$,
            (u = r, c(u.a9, fe) ? oe(mb("mdc-select--no-label")) : fe),
            Nh(n),
            w$(n),
            Qh(r),
            Fh(r),
            I$(s),
            B$(r),
            y$(r)
        ])), i), _([
            A2(Rh, w, Vo(_([
                n ? _([
                    p$(r)
                ]) : A2(Ou, At, _([
                    k$,
                    Gh(r)
                ])),
                _([
                    Vh(r),
                    A$,
                    Sh
                ]),
                n ? w : _([
                    Jh
                ])
            ]))),
            A5(m$, f, o, a, e, t)
        ]));
    }), q$ = F3(function(n, r, e) {
        return A4(C$, 1, n, r, e);
    }), z$ = function(n) {
        return n.I ? oe(mb("mdc-text-field--disabled")) : fe;
    }, D$ = function(n) {
        return oe(A2(qb, "disabled", Vs(n.I)));
    }, P$ = function(n) {
        return n.cS ? oe(mb("mdc-text-field--end-aligned")) : fe;
    }, K$ = function(n) {
        return n ? fe : oe(mb("mdc-text-field--filled"));
    }, L$ = oe(A2(qb, "foucClassNames", A2(xo, bc, _([
        "mdc-text-field--label-floating"
    ])))), T$ = function(n) {
        return n.g7 ? oe(mb("mdc-text-field--fullwidth")) : fe;
    }, R$ = function(n) {
        var r = n.a9;
        return n.g7 ? A2(Gu, gb("aria-label"), r) : fe;
    }, F$ = function(n) {
        return A2(Lb, "blur", It(n));
    }, O$ = function(n) {
        return A2(Gu, F$, n.di);
    }, W$ = A2(si, _([
        "target",
        "value"
    ]), dc), E$ = function(n) {
        return A2(Gu, function(n) {
            return A2(Lb, "change", A2(kt, n, W$));
        }, n.dj);
    }, M$ = oe(mb("mdc-text-field__input")), j$ = function(n) {
        return g(n, !0);
    }, S$ = F2(function(n, r) {
        return A2(Kb, n, function(n) {
            return {
                $: 1,
                a: n
            };
        }(r));
    }), N$ = function(n) {
        return A2(S$, "input", A2(kt, j$, A2(kt, n, W$)));
    }, G$ = function(n) {
        return A2(Gu, N$, n.dm);
    }, Q$ = function(n) {
        var r = n.b8;
        return A2(Gu, A2(su, gb("maxLength"), Be), r);
    }, U$ = function(n) {
        var r = n.b9;
        return A2(Gu, A2(su, gb("minLength"), Be), r);
    }, H$ = $b("placeholder"), V$ = function(n) {
        return A2(Gu, H$, n.du);
    }, J$ = function(n) {
        var r;
        return A2(Tb, A2(Ou, At, _([
            M$,
            (r = n, A2(Gu, Rb, r.cv)),
            R$(n),
            V$(n),
            G$(n),
            O$(n),
            E$(n),
            U$(n),
            Q$(n)
        ])), w);
    }, X$ = function(n) {
        var r = n.bK, e = "mdc-floating-label--float-above", t = "mdc-floating-label", u = g(n.g7, n.a9);
        if (u.a || u.b.$) return El("");
        var c = u.b.a;
        return A2(cl, _([
            mb("" !== A2(pi, "", r) ? t + " " + e : t),
            A2(qb, "foucClassNames", A2(xo, bc, _([
                e
            ])))
        ]), _([
            El(c)
        ]));
    }, Z$ = function(n) {
        var r = n.bK;
        return n.g7 || c(n.a9, fe) || "" === A2(pi, "", r) ? fe : oe(mb("mdc-text-field--label-floating"));
    }, Y$ = F2(function(n, r) {
        if (1 === r.$) return El("");
        if (r.a.$) return e = r.a.a.I, t = r.a.a.fc, u = r.a.a.ce, c = r.a.a.bO, A2(r.a.a.cd, A2(se, pb("mdc-text-field__icon"), A2(se, pb(n), function() {
            if (t.$) return c;
            var n = t.a;
            return e ? A2(se, Hh(-1), A2(se, A2(gb, "role", "button"), c)) : A2(se, Hh(0), A2(se, A2(gb, "role", "button"), A2(se, rv(n), A2(se, A2(Lb, "keydown", A2(wt, function(r) {
                return 13 === r ? It(n) : Pu("");
            }, Uh)), c))));
        }())), u);
        var e = r.a.a.I, t = r.a.a.fc, u = r.a.a.ce, c = r.a.a.bO;
        return A2(r.a.a.cd, A2(se, mb("mdc-text-field__icon"), A2(se, mb(n), function() {
            if (t.$) return c;
            var n = t.a;
            return e ? A2(se, Hh(-1), A2(se, A2(gb, "role", "button"), c)) : A2(se, Hh(0), A2(se, A2(gb, "role", "button"), A2(se, rv(n), A2(se, A2(Lb, "keydown", A2(wt, function(r) {
                return 13 === r ? It(n) : Pu("");
            }, Uh)), c))));
        }())), u);
    }), nm = function(n) {
        return A2(Y$, "mdc-text-field__icon--leading", n.bt);
    }, rm = A2(cl, _([
        mb("mdc-line-ripple")
    ]), w), em = function(n) {
        return oe(A2(qb, "maxLength", Ss(A2(pi, -1, n.b8))));
    }, tm = function(n) {
        return oe(A2(qb, "max", bc(A2(pi, "", A2(Gu, Be, n.c9)))));
    }, um = function(n) {
        return oe(A2(qb, "minLength", Ss(A2(pi, -1, n.b9))));
    }, cm = function(n) {
        return oe(A2(qb, "min", bc(A2(pi, "", A2(Gu, Be, n.dc)))));
    }, am = A2(cl, _([
        mb("mdc-notched-outline__leading")
    ]), w), im = function(n) {
        return A2(cl, _([
            mb("mdc-notched-outline__notch")
        ]), _([
            X$(n)
        ]));
    }, om = A2(cl, _([
        mb("mdc-notched-outline__trailing")
    ]), w), fm = function(n) {
        return A2(cl, _([
            mb("mdc-notched-outline")
        ]), _([
            am,
            im(n),
            om
        ]));
    }, sm = function(n) {
        return n ? oe(mb("mdc-text-field--outlined")) : fe;
    }, dm = function(n) {
        return oe(A2(qb, "pattern", A2(pi, Ku, A2(Gu, bc, n.fg))));
    }, bm = mb("mdc-text-field__affix mdc-text-field__affix--prefix"), lm = function(n) {
        var r = n.dv;
        if (r.$) return El("");
        var e = r.a;
        return A2(cl, _([
            bm
        ]), _([
            El(e)
        ]));
    }, vm = function(n) {
        return oe(A2(qb, "required", Vs(n.fz)));
    }, gm = A2(cl, _([
        mb("mdc-text-field__ripple")
    ]), w), hm = oe(mb("mdc-text-field")), $m = function(n) {
        return oe(A2(qb, "step", bc(A2(pi, "", A2(Gu, Be, n.dK)))));
    }, mm = mb("mdc-text-field__affix mdc-text-field__affix--suffix"), pm = function(n) {
        var r = n.dN;
        if (r.$) return El("");
        var e = r.a;
        return A2(cl, _([
            mm
        ]), _([
            El(e)
        ]));
    }, wm = function(n) {
        return A2(Y$, "mdc-text-field__icon--trailing", n.cu);
    }, ym = function(n) {
        return oe(A2(qb, "valid", Vs(n.dU)));
    }, km = function(n) {
        var r = n.bK;
        return A2(Gu, A2(su, qb("value"), bc), r);
    }, _m = function(n) {
        return c(n.bt, fe) ? fe : oe(mb("mdc-text-field--with-leading-icon"));
    }, Im = function(n) {
        return c(n.cu, fe) ? fe : oe(mb("mdc-text-field--with-trailing-icon"));
    }, xm = F2(function(n, r) {
        var e, t = r.cz;
        return A3(Ob, "mdc-text-field", p(A2(Ou, At, _([
            hm,
            (e = r, c(e.a9, fe) ? oe(mb("mdc-text-field--no-label")) : fe),
            K$(n),
            sm(n),
            T$(r),
            Z$(r),
            L$,
            z$(r),
            _m(r),
            Im(r),
            P$(r),
            km(r),
            D$(r),
            vm(r),
            ym(r),
            dm(r),
            um(r),
            em(r),
            cm(r),
            tm(r),
            $m(r)
        ])), t), _(n ? [
            nm(r),
            lm(r),
            J$(r),
            pm(r),
            fm(r),
            wm(r)
        ] : [
            gm,
            nm(r),
            lm(r),
            J$(r),
            pm(r),
            X$(r),
            rm,
            wm(r)
        ]));
    }), Am = function(n) {
        return A2(xm, !0, n);
    }, Bm = A2(yb, _([
        mb("mdc-radio__inner-circle")
    ]), w), Cm = A2(yb, _([
        mb("mdc-radio__outer-circle")
    ]), w), qm = A2(yb, _([
        mb("mdc-radio__background")
    ]), _([
        Cm,
        Bm
    ])), zm = function(n) {
        return oe(A2(qb, "checked", Vs(n.aG)));
    }, Dm = function(n) {
        return oe(A2(qb, "disabled", Vs(n.I)));
    }, Pm = oe(mb("mdc-radio__native-control")), Km = oe(Rb("radio")), Lm = function(n) {
        var r;
        return A2(Tb, A2(Ou, At, _([
            Pm,
            Km,
            zm(n),
            (r = n, A2(Gu, function(n) {
                return A2(Lb, "change", It(n));
            }, r.dj))
        ])), w);
    }, Tm = A2(yb, _([
        mb("mdc-radio__ripple")
    ]), w), Rm = oe(mb("mdc-radio")), Fm = function(n) {
        var r, e, t = n.cz, u = n.bG;
        return r = A3(Ob, "mdc-radio", p(A2(Ou, At, _([
            Rm,
            (e = n, e.bG ? oe(mb("mdc-radio--touch")) : fe),
            zm(n),
            Dm(n)
        ])), t), _([
            Lm(n),
            qm,
            Tm
        ])), u ? A2(yb, _([
            mb("mdc-touch-target-wrapper")
        ]), _([
            r
        ])) : r;
    }, Om = F2(function(n, r) {
        return A3(Dh, 1, n, r);
    }), Wm = ir("section"), Em = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Mm = Em, jm = F2(function(n, r) {
        return $(r, {
            cz: n
        });
    }), Sm = F2(function(n, r) {
        return $(r, {
            cz: n
        });
    }), Nm = F2(function(n, r) {
        return $(r, {
            cz: n
        });
    }), Gm = F2(function(n, r) {
        return $(r, {
            cz: n
        });
    }), Qm = F2(function(n, r) {
        return $(r, {
            aG: n
        });
    }), Um = F2(function(n, r) {
        return $(r, {
            cI: n
        });
    }), Hm = F2(function(n, r) {
        return $(r, {
            I: n
        });
    }), Vm = F2(function(n, r) {
        return $(r, {
            I: n
        });
    }), Jm = F2(function(n, r) {
        return $(r, {
            a9: n
        });
    }), Xm = F2(function(n, r) {
        return $(r, {
            a9: n
        });
    }), Zm = F2(function(n, r) {
        return $(r, {
            a9: n
        });
    }), Ym = F2(function(n, r) {
        return $(r, {
            dj: oe(n)
        });
    }), np = F2(function(n, r) {
        return $(r, {
            dj: oe(n)
        });
    }), rp = F2(function(n, r) {
        return $(r, {
            dj: oe(n)
        });
    }), ep = F2(function(n, r) {
        return $(r, {
            dk: oe(n)
        });
    }), tp = F2(function(n, r) {
        return $(r, {
            dk: oe(n)
        });
    }), up = F2(function(n, r) {
        return $(r, {
            dm: oe(n)
        });
    }), cp = F2(function(n, r) {
        return $(r, {
            dG: n
        });
    }), ap = F2(function(n, r) {
        return $(r, {
            dI: n
        });
    }), ip = F2(function(n, r) {
        return $(r, {
            cn: n
        });
    }), op = F2(function(n, r) {
        return $(r, {
            cu: n
        });
    }), fp = F2(function(n, r) {
        return $(r, {
            dU: n
        });
    }), sp = F2(function(n, r) {
        return $(r, {
            dU: n
        });
    }), dp = F2(function(n, r) {
        return $(r, {
            bK: n
        });
    }), bp = function(n) {
        return g(n, w);
    }, lp = A2(su, Id, wo), vp = function(n) {
        return $(n, {
            hf: function(n) {
                var r = n.gq;
                switch(n.hA){
                    case 0:
                        return A2(kl, _([
                            mb("form-field form-field--full-width")
                        ]), r);
                    case 1:
                        return A2(_l, _([
                            mb("form-field form-field--full-width")
                        ]), r);
                    case 2:
                        return A2(Il, _([
                            mb("form-field form-field--full-width")
                        ]), r);
                    case 3:
                        return A2(xl, _([
                            mb("form-field form-field--full-width")
                        ]), r);
                    case 4:
                        return A2(Al, _([
                            mb("form-field form-field--full-width")
                        ]), r);
                    default:
                        return A2(Bl, _([
                            mb("form-field form-field--full-width")
                        ]), r);
                }
            },
            hY: Pl(_([
                mb("form-field form-field--full-width")
            ]))
        });
    }(Ul), gp = F2(function(n, r) {
        return A3(Dh, 0, n, r);
    }), hp = function(n) {
        return 2 === n.$ ? oe(n.a) : fe;
    }, $p = F2(function(n, r) {
        var e = function() {
            switch(n){
                case 0:
                case 1:
                case 2:
                default:
                    return "B";
                case 3:
                    return "O";
            }
        }();
        return 1024 > r ? Be(r) + "\xa0" + e : 0 > f(r, 1048576) ? Be(r / 1024 | 0) + "\xa0KiB" : 0 > f(r, 1073741824) ? Be(r / 1048576 | 0) + "\xa0MiB" : Be(r / 1073741824 | 0) + "\xa0GiB";
    }), mp = nf(A2(su, pi(0), function(n) {
        return n.eV;
    })), pp = function(n) {
        return "Problem at row " + Be(n.ib) + "\n" + function(n) {
            switch(n.$){
                case 0:
                    return "Expecting " + n.a;
                case 1:
                    return "Expecting int";
                case 2:
                    return "Expecting hex";
                case 3:
                    return "Expecting octal";
                case 4:
                    return "Expecting binary";
                case 5:
                    return "Expecting float";
                case 6:
                    return "Expecting number";
                case 7:
                    return "Expecting variable";
                case 8:
                    return "Expecting symbol " + n.a;
                case 9:
                    return "Expecting keyword " + n.a;
                case 10:
                    return "Expecting keyword end";
                case 11:
                    return "Unexpected char";
                case 12:
                    return n.a;
                default:
                    return "Bad repeat";
            }
        }(n.h1);
    }, wp = {
        $: 10
    }, yp = function(n) {
        return {
            $: 11,
            a: n
        };
    }, kp = function(n) {
        return {
            $: 4,
            a: n
        };
    }, _p = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Ip = function(n) {
        return {
            $: 5,
            a: n
        };
    }, xp = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ap = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), Bp = {
        $: 0
    }, Cp = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qp = {
        $: 8
    }, zp = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Dp = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Pp = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Kp = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Lp = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Tp = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Rp = F3(function(n, r, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e
        };
    }), Fp = F3(function(n, r, e) {
        return {
            $: 2,
            a: n,
            b: r,
            c: e
        };
    }), Op = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Wp = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ep = F3(function(n, r, e) {
        return {
            $: 1,
            a: n,
            b: r,
            c: e
        };
    }), Mp = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), jp = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Sp = F3(function(n, r, e) {
        return {
            $: 2,
            a: n,
            b: r,
            c: e
        };
    }), Np = F6(function(n, r, e, t, u, c) {
        return {
            $: 4,
            a: n,
            b: r,
            c: e,
            d: t,
            e: u,
            f: c
        };
    }), Gp = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Qp = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Up = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Hp = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Vp = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Jp = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), Xp = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Zp = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Yp = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), nw = {
        $: 8
    }, rw = {
        $: 7
    }, ew = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), tw = F4(function(n, r, e, t) {
        return {
            $: 3,
            a: n,
            b: r,
            c: e,
            d: t
        };
    }), uw = F2(function(n, r) {
        return {
            b: A2(se, r, n.b),
            c: n.c
        };
    }), cw = function(n) {
        var r = n;
        return function(n) {
            var e = r(n);
            return 1 === e.$ ? A2(xc, !1, e.b) : A3(Ac, !1, e.b, e.c);
        };
    }, aw = function(n) {
        switch(n){
            case " ":
            case "	":
                return !0;
            default:
                return !1;
        }
    }, iw = A2(ka, "\r", Cp("a carriage return")), ow = A2(ka, "\n", Cp("a newline")), fw = ca(_([
        xa(ow),
        A2(Yc, xa(iw), ca(_([
            xa(ow),
            Uc(0)
        ])))
    ])), sw = A2(va, function() {
        return wp;
    }, A2(Yc, cw(Wc(aw)), fw)), dw = A2(ka, " ", Cp("a space")), bw = _([
        Aa(A2(ka, ">", Cp(">"))),
        A2(Yc, cw(Aa(dw)), ca(_([
            Aa(A2(ka, ">", Cp(" >"))),
            Aa(A2(ka, " >", Cp("  >"))),
            Aa(A2(ka, "  >", Cp("   >")))
        ])))
    ]), lw = function(n) {
        switch(n){
            case "\n":
            case "\r":
                return !0;
            default:
                return !1;
        }
    }, vw = Wc(A2(su, Ia, lw)), gw = Lc(Cp("the end of the input")), hw = ca(_([
        fw,
        gw
    ])), $w = A2(ra, A2(Yc, A2(Yc, Uc(yp), ca(bw)), ca(_([
        Aa(dw),
        Uc(0)
    ]))), A2(Yc, jc(vw), hw)), mw = function(n) {
        return A2(Ce, "\n", A2(Ut, pp, n));
    }, pw = H, ww = function(n) {
        n: for(;;)switch(n.$){
            case 1:
                return !A2(pw, n.a, "\n");
            case 12:
                if ((e = n.a).b) {
                    n = e.a;
                    continue n;
                }
                return !1;
            case 4:
                var r = n.e;
                if (r.b) {
                    var e;
                    if ((e = r.a).b) {
                        n = e.a;
                        continue n;
                    }
                    return !1;
                }
                return !1;
            case 0:
                return !0;
            default:
                return !1;
        }
    }, yw = function(n) {
        return {
            $: 3,
            a: n
        };
    }, kw = F3(function(n, r, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e
        };
    }), _w = Cp("at least 1 tag name character"), Iw = function(n) {
        switch(n){
            case " ":
            case "\r":
            case "\n":
            case "	":
            case "/":
            case "<":
            case ">":
            case '"':
            case "'":
            case "=":
                return !1;
            default:
                return !0;
        }
    }, xw = A2(Mc, F2(function(n) {
        return ic(n);
    }), A2(Yc, A2(da, Iw, _w), Wc(Iw))), Aw = xw, Bw = function(n) {
        return xa(A2(ka, n, ya(n)));
    }, Cw = Ja(_([
        g("amp", "&"),
        g("lt", "<"),
        g("gt", ">"),
        g("apos", "'"),
        g("quot", '"')
    ])), qw = F3(function(n, r, e) {
        n: for(;;){
            if (!r.b) return ye(e);
            var t = r.a, u = r.b;
            switch(t){
                case "0":
                    n = c = n - 1, r = a = u, e = i = e;
                    continue n;
                case "1":
                    var c = n - 1, a = u, i = e + A2(tc, 16, n);
                    n = c, r = a, e = i;
                    continue n;
                case "2":
                    c = n - 1, a = u, i = e + 2 * A2(tc, 16, n), n = c, r = a, e = i;
                    continue n;
                case "3":
                    c = n - 1, a = u, i = e + 3 * A2(tc, 16, n), n = c, r = a, e = i;
                    continue n;
                case "4":
                    c = n - 1, a = u, i = e + 4 * A2(tc, 16, n), n = c, r = a, e = i;
                    continue n;
                case "5":
                    c = n - 1, a = u, i = e + 5 * A2(tc, 16, n), n = c, r = a, e = i;
                    continue n;
                case "6":
                    c = n - 1, a = u, i = e + 6 * A2(tc, 16, n), n = c, r = a, e = i;
                    continue n;
                case "7":
                    c = n - 1, a = u, i = e + 7 * A2(tc, 16, n), n = c, r = a, e = i;
                    continue n;
                case "8":
                    c = n - 1, a = u, i = e + 8 * A2(tc, 16, n), n = c, r = a, e = i;
                    continue n;
                case "9":
                    c = n - 1, a = u, i = e + 9 * A2(tc, 16, n), n = c, r = a, e = i;
                    continue n;
                case "a":
                    c = n - 1, a = u, i = e + 10 * A2(tc, 16, n), n = c, r = a, e = i;
                    continue n;
                case "b":
                    c = n - 1, a = u, i = e + 11 * A2(tc, 16, n), n = c, r = a, e = i;
                    continue n;
                case "c":
                    c = n - 1, a = u, i = e + 12 * A2(tc, 16, n), n = c, r = a, e = i;
                    continue n;
                case "d":
                    c = n - 1, a = u, i = e + 13 * A2(tc, 16, n), n = c, r = a, e = i;
                    continue n;
                case "e":
                    c = n - 1, a = u, i = e + 14 * A2(tc, 16, n), n = c, r = a, e = i;
                    continue n;
                case "f":
                    c = n - 1, a = u, i = e + 15 * A2(tc, 16, n), n = c, r = a, e = i;
                    continue n;
                default:
                    return $e(ku(t) + " is not a valid hexadecimal character.");
            }
        }
    }), zw = function(n) {
        var r = function(n) {
            var r, e = A2(Et, "#x", r = n) ? A2(Ni, Nc, A2(Qu, Au, function(n) {
                if (Kt(n)) return $e("Empty strings are not valid hexadecimal strings.");
                var r = function() {
                    if (A2(Et, "-", n)) {
                        var r = A2(pi, w, pf(ac(n)));
                        return A2(Qu, Fc, A3(qw, Pe(r) - 1, r, 0));
                    }
                    return A3(qw, qt(n) - 1, ac(n), 0);
                }();
                return A2(Ni, function(r) {
                    return A2(Ce, " ", _([
                        '"' + n + '"',
                        "is not a valid hexadecimal string because",
                        r
                    ]));
                }, r);
            }(A2(Dt, 2, r)))) : A2(Et, "#", r) ? A2(Mu, Nc("Invalid escaped character: " + r), A2(Gu, Au, Tt(A2(Dt, 1, r)))) : A2(Mu, Nc('No entity named "&' + r + ';" found.'), A2(zi, r, Cw));
            return e.$ ? Gc(e.a) : Uc(e.a);
        }, e = function(r) {
            return !c(r, n) && ";" !== r;
        };
        return A2(ra, A2(Yc, Uc(At), Bw("&")), A2(Yc, A2(Bc, r, jc(A2(Yc, A2(da, e, Cp("an entity character")), Wc(e)))), Bw(";")));
    }, Dw = F3(function(n, r, e) {
        return A2(Bc, function(r) {
            return ca(_([
                A2(va, function(n) {
                    return $a(p(e, p(r, ku(n))));
                }, zw(n)),
                Uc(ha(p(e, r)))
            ]));
        }, jc(Wc(r)));
    }), Pw = function(n) {
        return A2(la, "", A2(Dw, n, function(r) {
            return !c(r, n) && "&" !== r;
        }));
    }, Kw = ca(_([
        A2(ra, A2(Yc, Uc(At), Bw('"')), A2(Yc, Pw('"'), Bw('"'))),
        A2(ra, A2(Yc, Uc(At), Bw("'")), A2(Yc, Pw("'"), Bw("'")))
    ])), Lw = F2(function(n, r) {
        return oe(r.$ ? n : r.a);
    }), Tw = function(n) {
        switch(n){
            case " ":
            case "\r":
            case "\n":
            case "	":
                return !0;
            default:
                return !1;
        }
    }, Rw = Wc(Tw), Fw = function(n) {
        var r = F2(function(r, e) {
            return $a(A3(Oi, ic(r), Lw(e), n));
        });
        return ca(_([
            A2(ra, A2(ra, Uc(r), A2(Yc, A2(Yc, A2(Yc, Aw, Rw), Bw("=")), Rw)), A2(Yc, Kw, Rw)),
            Uc(ha(n))
        ]));
    }, Ow = A2(va, A2(Go, F3(function(n, r, e) {
        return A2(se, {
            de: n,
            bK: r
        }, e);
    }), w), A2(la, Na, Fw)), Ww = function(n) {
        return function(r) {
            var e = A5(te, n, r.f, r.ib, r.ef, r.dJ), t = e.a, u = e.b, c = e.c, a = 0 > t ? qt(r.dJ) : t;
            return A3(Ac, 0 > f(r.f, a), 0, {
                ef: c,
                gy: r.gy,
                j: r.j,
                f: a,
                ib: u,
                dJ: r.dJ
            });
        };
    }, Ew = A2(ra, A2(Yc, Uc(At), Bw("<![CDATA[")), A2(Yc, jc(Ww("]]>")), Bw("]]>"))), Mw = F2(function(n, r) {
        return A2(va, function(n) {
            return n(r);
        }, ca(n));
    }), jw = function(n) {
        var r = A2(Bc, function(r) {
            return c(n, r) ? Uc(0) : Gc(Nc("tag name mismatch: " + n + " and " + r));
        }, xw);
        return A2(Yc, A2(Yc, A2(Yc, A2(Yc, Bw("</"), Rw), r), Rw), Bw(">"));
    }, Sw = function(n) {
        return A2(ka, n, Cp(n));
    }, Nw = A2(ra, A2(Yc, Uc(function(n) {
        return {
            $: 2,
            a: n
        };
    }), xa(Sw("<!--"))), A2(Yc, jc(Ww("-->")), xa(Sw("-->")))), Gw = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), Qw = Cp("at least 1 uppercase character"), Uw = jc(A2(Yc, A2(da, We, Qw), Wc(We))), Hw = A2(Yc, A2(da, Tw, Cp("at least one whitespace")), Wc(Tw)), Vw = A2(ra, A2(ra, A2(Yc, Uc(Gw), Bw("<!")), A2(Yc, Uw, Hw)), A2(Yc, jc(Ww(">")), Bw(">"))), Jw = A2(ra, A2(Yc, Uc(function(n) {
        return {
            $: 4,
            a: n
        };
    }), Bw("<?")), A2(Yc, jc(Ww("?>")), Bw("?>"))), Xw = function(n) {
        switch(n){
            case "<":
            case "&":
                return !1;
            default:
                return !0;
        }
    }, Zw = _([
        A2(va, function() {
            return $a(0);
        }, A2(Yc, A2(da, Xw, Cp("is not & or <")), Wc(Xw))),
        A2(va, function() {
            return $a(0);
        }, zw("<")),
        Uc(ha(0))
    ]), Yw = jc(A2(la, 0, function() {
        return ca(Zw);
    })), ny = function(n) {
        return A2(la, w, Mw(ry(n)));
    }, ry = function(n) {
        return _([
            A2(va, F2(function(n, r) {
                return ha(Se(r));
            }), jw(n)),
            A2(Bc, function(r) {
                return Kt(r) ? A2(va, F2(function(n, r) {
                    return ha(Se(r));
                }), jw(n)) : Uc(function(n) {
                    return $a(A2(se, function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(r), n));
                });
            }, Yw),
            A2(va, F2(function(n, r) {
                return $a(A2(se, n, r));
            }), ty())
        ]);
    }, ey = function(n) {
        return A2(ra, A2(ra, A2(Yc, Uc(kw(n)), Rw), A2(Yc, Ow, Rw)), ca(_([
            A2(va, function() {
                return w;
            }, Bw("/>")),
            A2(ra, A2(Yc, Uc(At), Bw(">")), ny(n))
        ])));
    };
    function ty() {
        return ca(_([
            A2(va, yw, Ew),
            Jw,
            Nw,
            Vw,
            uy()
        ]));
    }
    function uy() {
        return A2(ra, A2(Yc, Uc(At), Bw("<")), A2(Bc, ey, xw));
    }
    var cy = ty();
    ty = function() {
        return cy;
    };
    var ay = uy();
    uy = function() {
        return ay;
    };
    var iy, oy, fy, sy = A2(ka, "	", Cp("a tab")), dy = ca(_([
        Aa(sy),
        A2(Yc, cw(Aa(dw)), ca(_([
            Aa(A2(ka, "   ", ya("Indentation"))),
            Aa(A2(ka, " 	", ya("Indentation"))),
            Aa(A2(ka, "  	", ya("Indentation")))
        ])))
    ])), by = A2(ra, A2(Yc, Uc(Op), dy), A2(Yc, jc(vw), hw)), ly = function(n) {
        return !A2(Bu, 2, n);
    }, vy = function(n) {
        return n ? 1 : 0;
    }, gy = F3(function(n, r, e) {
        var t = g(r, e);
        return "" === t.a ? e : "" === t.b ? r : p(r, p(n, e));
    }), hy = F2(function(n, r) {
        return n + "\n" + r;
    }), $y = A2(Mc, F2(function(n) {
        return jp(n);
    }), vw), my = A2(Yc, $y, hw), py = F4(function(n, r, e, t) {
        return {
            o: t,
            hw: r,
            hG: e,
            hV: n
        };
    }), wy = function(n) {
        return A3(Ac, !1, n.ef, n);
    }, yy = A2(ra, Uc(function(n) {
        return g(n, "");
    }), A2(Yc, wy, hw)), ky = function(n) {
        return A2(Yc, A2(da, n, Nc("Expected one or more character")), Wc(n));
    }, _y = A2(ra, A2(ra, A2(Yc, Uc(F2(function(n, r) {
        return g(n, r);
    })), ky(aw)), wy), A2(Yc, jc(vw), hw)), Iy = A2(ka, ")", Cp("a `)`")), xy = A2(ka, ".", Cp("a `.`")), Ay = ca(_([
        A2(Yc, Uc(0), Aa(xy)),
        A2(Yc, Uc(1), Aa(Iy))
    ])), By = A2(Mc, F2(function(n) {
        return A2(pi, 0, Tt(n));
    }), ky(Me)), Cy = A2(Bc, function(n) {
        return n > 999999999 ? Gc(Nc("Starting numbers must be nine digits or less.")) : Uc(n);
    }, By), qy = xa(dw), zy = F3(function(n, r, e) {
        for(;;){
            if (0 >= r) return n;
            n = A2(se, e, n), r -= 1;
        }
    }), Dy = F2(function(n, r) {
        return A3(zy, w, n, r);
    }), Py = F2(function(n, r) {
        var e = A2(Dy, n, r);
        if (e.b) {
            var t = e.a, u = e.b;
            return A3(De, F2(function(n, r) {
                return ca(_([
                    A2(Yc, n, r),
                    Uc(0)
                ]));
            }), ca(_([
                t,
                Uc(0)
            ])), u);
        }
        return Uc(0);
    }), Ky = function(n) {
        return 1 === n ? Uc(n) : Gc(Nc("Lists inside a paragraph or after a paragraph without a blank line must start with 1"));
    }, Ly = function(n) {
        return A2(va, function(n) {
            return A6(Np, !0, n.hw, n.hG, n.hV, w, n.o);
        }, function(n) {
            return A2(ra, A2(ra, A2(ra, A2(ra, A2(ra, Uc(F5(function(n, r, e, t, u) {
                var c = u.a, a = u.b;
                return c - t > 4 ? A4(py, r, t - n + 1, e, p(A2(Iu, c - t - 1, " "), a)) : A4(py, r, c - n, e, a);
            })), wy), cw(function(n) {
                return n ? A2(Bc, Ky, A2(ra, A2(Yc, Uc(At), A2(Py, 3, qy)), Cy)) : A2(ra, A2(Yc, Uc(At), A2(Py, 3, qy)), Cy);
            }(n))), cw(Ay)), wy), n ? _y : ca(_([
                yy,
                _y
            ])));
        }(n));
    }, Ty = {
        $: 1
    }, Ry = F3(function(n, r, e) {
        return {
            $: 4,
            a: n,
            b: r,
            c: e
        };
    }), Fy = F3(function(n, r, e) {
        return {
            $: 3,
            a: n,
            b: r,
            c: e
        };
    }), Oy = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Wy = function(n) {
        var r = n, e = r.cv;
        switch(e.$){
            case 0:
                return Oy(r.iu);
            case 1:
                return Ty;
            case 2:
                return function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(r.iu);
            case 3:
                var t = e.a;
                return A3(Fy, t.b, fe, _([
                    Oy(t.a)
                ]));
            case 4:
                var u = e.a;
                return A3(Fy, u.a, u.b, Ey(r.u));
            case 5:
                var c = e.a;
                return A3(Ry, c.a, c.b, Ey(r.u));
            case 6:
                return function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(e.a);
            case 7:
                return A2(Ap, e.a, Ey(r.u));
            default:
                return function(n) {
                    return {
                        $: 7,
                        a: n
                    };
                }(Ey(r.u));
        }
    }, Ey = function(n) {
        return A2(Ut, Wy, n);
    }, My = F2(function(n, r) {
        return {
            i: r.i - n.w,
            u: r.u,
            k: r.k - n.w,
            iu: r.iu,
            D: r.D - n.w,
            w: r.w - n.w,
            cv: r.cv
        };
    }), jy = F2(function(n, r) {
        return {
            i: n.i,
            u: A2(se, A2(My, n, r), n.u),
            k: n.k,
            iu: n.iu,
            D: n.D,
            w: n.w,
            cv: n.cv
        };
    }), Sy = function(n) {
        var r = n;
        return {
            i: r.i,
            u: Ny(r.u),
            k: r.k,
            iu: r.iu,
            D: r.D,
            w: r.w,
            cv: r.cv
        };
    }, Ny = function(n) {
        var r = A2(hi, function(n) {
            return n.k;
        }, n);
        return r.b ? A3(Gy, r.b, r.a, w) : w;
    }, Gy = F3(function(n, r, e) {
        for(;;){
            var t = r;
            if (!n.b) return A2(se, Sy(t), e);
            var u = n.a, c = n.b;
            1 > f(t.i, u.k) ? (n = c, r = u, e = A2(se, Sy(t), e)) : 0 > f(t.k, u.k) && f(t.i, u.i) > 0 ? (n = c, r = A2(jy, t, u)) : (n = c, r = t);
        }
    }), Qy = {
        $: 0
    }, Uy = A2(pi, jg, Su("&#([0-9]{1,8});")), Hy = function(n) {
        return function(n) {
            return 9 === n || 10 === n || 13 === n || 133 === n || n >= 32 && 126 >= n || n >= 160 && 55295 >= n || n >= 57344 && 64975 >= n || n >= 65008 && 65533 >= n || n >= 65536 && 1114109 >= n;
        }(n) && !function(n) {
            var r = A2(Bu, 16, n), e = A2(Bu, 131070, n);
            return !(131070 > n || (0 > e || e > 15) && (65536 > e || e > 65551) || 14 !== r && 15 !== r);
        }(n) ? ku(Au(n)) : ku(Au(65533));
    }, Vy = A2(Sg, Uy, function(n) {
        var r = n.dM;
        if (r.b && !r.a.$) {
            var e = Tt(r.a.a);
            return e.$ ? n.e3 : Hy(e.a);
        }
        return n.e3;
    }), Jy = A2(pi, jg, Su("&([0-9a-zA-Z]+);")), Xy = Ja(_([
        g("quot", 34),
        g("amp", 38),
        g("apos", 39),
        g("lt", 60),
        g("gt", 62),
        g("nbsp", 160),
        g("iexcl", 161),
        g("cent", 162),
        g("pound", 163),
        g("curren", 164),
        g("yen", 165),
        g("brvbar", 166),
        g("sect", 167),
        g("uml", 168),
        g("copy", 169),
        g("ordf", 170),
        g("laquo", 171),
        g("not", 172),
        g("shy", 173),
        g("reg", 174),
        g("macr", 175),
        g("deg", 176),
        g("plusmn", 177),
        g("sup2", 178),
        g("sup3", 179),
        g("acute", 180),
        g("micro", 181),
        g("para", 182),
        g("middot", 183),
        g("cedil", 184),
        g("sup1", 185),
        g("ordm", 186),
        g("raquo", 187),
        g("frac14", 188),
        g("frac12", 189),
        g("frac34", 190),
        g("iquest", 191),
        g("Agrave", 192),
        g("Aacute", 193),
        g("Acirc", 194),
        g("Atilde", 195),
        g("Auml", 196),
        g("Aring", 197),
        g("AElig", 198),
        g("Ccedil", 199),
        g("Egrave", 200),
        g("Eacute", 201),
        g("Ecirc", 202),
        g("Euml", 203),
        g("Igrave", 204),
        g("Iacute", 205),
        g("Icirc", 206),
        g("Iuml", 207),
        g("ETH", 208),
        g("Ntilde", 209),
        g("Ograve", 210),
        g("Oacute", 211),
        g("Ocirc", 212),
        g("Otilde", 213),
        g("Ouml", 214),
        g("times", 215),
        g("Oslash", 216),
        g("Ugrave", 217),
        g("Uacute", 218),
        g("Ucirc", 219),
        g("Uuml", 220),
        g("Yacute", 221),
        g("THORN", 222),
        g("szlig", 223),
        g("agrave", 224),
        g("aacute", 225),
        g("acirc", 226),
        g("atilde", 227),
        g("auml", 228),
        g("aring", 229),
        g("aelig", 230),
        g("ccedil", 231),
        g("egrave", 232),
        g("eacute", 233),
        g("ecirc", 234),
        g("euml", 235),
        g("igrave", 236),
        g("iacute", 237),
        g("icirc", 238),
        g("iuml", 239),
        g("eth", 240),
        g("ntilde", 241),
        g("ograve", 242),
        g("oacute", 243),
        g("ocirc", 244),
        g("otilde", 245),
        g("ouml", 246),
        g("divide", 247),
        g("oslash", 248),
        g("ugrave", 249),
        g("uacute", 250),
        g("ucirc", 251),
        g("uuml", 252),
        g("yacute", 253),
        g("thorn", 254),
        g("yuml", 255),
        g("OElig", 338),
        g("oelig", 339),
        g("Scaron", 352),
        g("scaron", 353),
        g("Yuml", 376),
        g("fnof", 402),
        g("circ", 710),
        g("tilde", 732),
        g("Alpha", 913),
        g("Beta", 914),
        g("Gamma", 915),
        g("Delta", 916),
        g("Epsilon", 917),
        g("Zeta", 918),
        g("Eta", 919),
        g("Theta", 920),
        g("Iota", 921),
        g("Kappa", 922),
        g("Lambda", 923),
        g("Mu", 924),
        g("Nu", 925),
        g("Xi", 926),
        g("Omicron", 927),
        g("Pi", 928),
        g("Rho", 929),
        g("Sigma", 931),
        g("Tau", 932),
        g("Upsilon", 933),
        g("Phi", 934),
        g("Chi", 935),
        g("Psi", 936),
        g("Omega", 937),
        g("alpha", 945),
        g("beta", 946),
        g("gamma", 947),
        g("delta", 948),
        g("epsilon", 949),
        g("zeta", 950),
        g("eta", 951),
        g("theta", 952),
        g("iota", 953),
        g("kappa", 954),
        g("lambda", 955),
        g("mu", 956),
        g("nu", 957),
        g("xi", 958),
        g("omicron", 959),
        g("pi", 960),
        g("rho", 961),
        g("sigmaf", 962),
        g("sigma", 963),
        g("tau", 964),
        g("upsilon", 965),
        g("phi", 966),
        g("chi", 967),
        g("psi", 968),
        g("omega", 969),
        g("thetasym", 977),
        g("upsih", 978),
        g("piv", 982),
        g("ensp", 8194),
        g("emsp", 8195),
        g("thinsp", 8201),
        g("zwnj", 8204),
        g("zwj", 8205),
        g("lrm", 8206),
        g("rlm", 8207),
        g("ndash", 8211),
        g("mdash", 8212),
        g("lsquo", 8216),
        g("rsquo", 8217),
        g("sbquo", 8218),
        g("ldquo", 8220),
        g("rdquo", 8221),
        g("bdquo", 8222),
        g("dagger", 8224),
        g("Dagger", 8225),
        g("bull", 8226),
        g("hellip", 8230),
        g("permil", 8240),
        g("prime", 8242),
        g("Prime", 8243),
        g("lsaquo", 8249),
        g("rsaquo", 8250),
        g("oline", 8254),
        g("frasl", 8260),
        g("euro", 8364),
        g("image", 8465),
        g("weierp", 8472),
        g("real", 8476),
        g("trade", 8482),
        g("alefsym", 8501),
        g("larr", 8592),
        g("uarr", 8593),
        g("rarr", 8594),
        g("darr", 8595),
        g("harr", 8596),
        g("crarr", 8629),
        g("lArr", 8656),
        g("uArr", 8657),
        g("rArr", 8658),
        g("dArr", 8659),
        g("hArr", 8660),
        g("forall", 8704),
        g("part", 8706),
        g("exist", 8707),
        g("empty", 8709),
        g("nabla", 8711),
        g("isin", 8712),
        g("notin", 8713),
        g("ni", 8715),
        g("prod", 8719),
        g("sum", 8721),
        g("minus", 8722),
        g("lowast", 8727),
        g("radic", 8730),
        g("prop", 8733),
        g("infin", 8734),
        g("ang", 8736),
        g("and", 8743),
        g("or", 8744),
        g("cap", 8745),
        g("cup", 8746),
        g("int", 8747),
        g("there4", 8756),
        g("sim", 8764),
        g("cong", 8773),
        g("asymp", 8776),
        g("ne", 8800),
        g("equiv", 8801),
        g("le", 8804),
        g("ge", 8805),
        g("sub", 8834),
        g("sup", 8835),
        g("nsub", 8836),
        g("sube", 8838),
        g("supe", 8839),
        g("oplus", 8853),
        g("otimes", 8855),
        g("perp", 8869),
        g("sdot", 8901),
        g("lceil", 8968),
        g("rceil", 8969),
        g("lfloor", 8970),
        g("rfloor", 8971),
        g("lang", 9001),
        g("rang", 9002),
        g("loz", 9674),
        g("spades", 9824),
        g("clubs", 9827),
        g("hearts", 9829),
        g("diams", 9830)
    ])), Zy = A2(Sg, Jy, function(n) {
        var r = n.dM;
        if (r.b && !r.a.$) {
            var e = A2(zi, r.a.a, Xy);
            return e.$ ? n.e3 : ku(Au(e.a));
        }
        return n.e3;
    }), Yy = A2(pi, jg, Su("(\\\\+)([!\"#$%&\\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-])")), nk = A2(Sg, Yy, function(n) {
        var r = n.dM;
        if (r.b && !r.a.$ && r.b.b && !r.b.a.$) {
            var e = r.b.a.a;
            return p(A2(Iu, qt(r.a.a) / 2 | 0, "\\"), e);
        }
        return n.e3;
    }), rk = A2(pi, jg, Su("&#[Xx]([0-9a-fA-F]{1,8});")), ek = E, tk = A2(Sg, rk, function(n) {
        var r, e = n.dM;
        return e.b && !e.a.$ ? Hy((r = e.a.a, A3(ek, F2(function(n, r) {
            return 16 * r + A2(Bu, 39, Fe(n)) - 9;
        }), 0, ic(r)))) : n.e3;
    }), uk = function(n) {
        var r = nk(n);
        return A2(Ct, "&", r) ? tk(Vy(Zy(r))) : r;
    }, ck = function(n) {
        return {
            i: 0,
            u: w,
            k: 0,
            iu: uk(n),
            D: 0,
            w: 0,
            cv: Qy
        };
    }, ak = F3(function(n, r, e) {
        var t = r, u = {
            i: t.i,
            u: A3(ik, t.iu, w, t.u),
            k: t.k,
            iu: t.iu,
            D: t.D,
            w: t.w,
            cv: t.cv
        };
        if (e.b) {
            var a = e.a;
            return a.cv.$ ? c(t.i, a.k) ? A2(se, u, e) : 0 > f(t.i, a.k) ? A2(se, u, A2(se, ck(A3(zt, t.i, a.k, n)), e)) : e : A2(se, u, e);
        }
        var i = A2(Dt, t.i, n);
        return Kt(i) ? _([
            u
        ]) : _([
            u,
            ck(i)
        ]);
    }), ik = F3(function(n, r, e) {
        for(;;){
            if (!e.b) {
                if (r.b) {
                    var t = r.a;
                    return t.k > 0 ? A2(se, ck(A2(Lt, t.k, n)), r) : r;
                }
                return Kt(n) ? w : _([
                    ck(n)
                ]);
            }
            var u = e.b, c = n, a = A3(ak, n, e.a, r);
            n = c, r = a, e = u;
        }
    }), ok = F3(function(n, r, e) {
        n: for(;;){
            if (!r.b) return w;
            var t = r.a, u = r.b;
            if (n.b) {
                var c = n.a, a = n.b;
                if (0 > f(c.d, t.d)) {
                    if (e) {
                        n = a, e += 1;
                        continue n;
                    }
                    return A2(se, c, A3(ok, a, r, e + 1));
                }
                if (e > 1) {
                    r = u, e -= 1;
                    continue n;
                }
                if (1 === e) return A2(se, t, A3(ok, n, u, e - 1));
                r = u, e = 0;
            } else if (e > 1) r = u, e -= 1;
            else {
                if (1 === e) return A2(se, t, A3(ok, n, u, e - 1));
                r = u, e = 0;
            }
        }
    }), fk = A2(pi, jg, Su("(\\\\*)(\\<)")), sk = Zr(ne), dk = {
        $: 4
    }, bk = function(n) {
        var r = n.dM;
        if (r.b && r.b.b && !r.b.a.$) {
            var e = A2(pi, 0, A2(Gu, qt, r.a));
            return ly(e) ? oe({
                d: n.d + e,
                c6: 1,
                h: dk
            }) : fe;
        }
        return fe;
    }, lk = A2(pi, jg, Su("(\\\\*)(\\>)")), vk = function(n) {
        return {
            $: 5,
            a: n
        };
    }, gk = function(n) {
        var r = n.dM;
        if (r.b && r.b.b && !r.b.a.$) {
            var e = A2(pi, 0, A2(Gu, qt, r.a));
            return oe({
                d: n.d + e,
                c6: 1,
                h: ly(e) ? vk(1) : vk(0)
            });
        }
        return fe;
    }, hk = A2(pi, jg, Su("(\\\\*)([^*])?(\\*+)([^*])?")), $k = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), mk = A2(ek, F2(function(n, r) {
        return r || function(n) {
            switch(n){
                case "!":
                case '"':
                case "#":
                case "%":
                case "&":
                case "'":
                case "(":
                case ")":
                case "*":
                case ",":
                case "-":
                case ".":
                case "/":
                case ":":
                case ";":
                case "?":
                case "@":
                case "[":
                case "]":
                case "_":
                case "{":
                case "}":
                case "~":
                    return !0;
                default:
                    return !1;
            }
        }(n);
    }), !1), pk = A2(ek, F2(function(n, r) {
        return r || function(n) {
            switch(n){
                case " ":
                case "\f":
                case "\n":
                case "\r":
                case "	":
                case "\v":
                case "\xa0":
                case "\u2028":
                case "\u2029":
                    return !0;
                default:
                    return !1;
            }
        }(n);
    }), !1), wk = function(n) {
        if (n.$) return 0;
        var r = n.a;
        return Kt(r) || pk(r) ? 0 : mk(r) ? 1 : 2;
    }, yk = F3(function(n, r, e) {
        var t = e.dM;
        if (t.b && t.b.b && t.b.b.b && !t.b.b.a.$ && t.b.b.b.b) {
            var u = t.a, c = t.b, a = c.a, i = c.b, o = i.a.a, f = wk(i.b.a), s = a.$ ? 0 : qt(a.a), d = e.d && !s ? oe(A3(zt, e.d - 1, e.d, r)) : a, b = u.$ ? 0 : qt(u.a), l = !ly(b) && !s || !d.$ && "\\" === d.a, v = l ? qt(o) - 1 : qt(o), g = l ? 1 : wk(d);
            return 0 >= v || "_" === n && 2 === g && 2 === f ? fe : oe({
                d: e.d + b + s + (l ? 1 : 0),
                c6: v,
                h: A2($k, n, {
                    b7: g,
                    ck: f
                })
            });
        }
        return fe;
    }), kk = A2(pi, jg, Su("(\\\\*)(\\`+)")), _k = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ik = function(n) {
        var r = n.dM;
        if (r.b && r.b.b && !r.b.a.$) {
            var e = r.b.a.a, t = A2(pi, 0, A2(Gu, qt, r.a));
            return oe({
                d: n.d + t,
                c6: qt(e),
                h: ly(t) ? _k(1) : _k(0)
            });
        }
        return fe;
    }, xk = A2(pi, jg, Su("(?:(\\\\+)|( {2,}))\\n")), Ak = {
        $: 8
    }, Bk = function(n) {
        var r = n.dM;
        n: for(;;){
            if (r.b) {
                if (r.a.$) {
                    if (r.b.b && !r.b.a.$) return oe({
                        d: n.d,
                        c6: qt(n.e3),
                        h: Ak
                    });
                    break n;
                }
                var e = qt(r.a.a);
                return ly(e) ? fe : oe({
                    d: n.d + e - 1,
                    c6: 2,
                    h: Ak
                });
            }
            break n;
        }
        return fe;
    }, Ck = (Su("(?:(\\\\+)|( *))\\n"), A2(pi, jg, Su("(\\\\*)(\\])"))), qk = {
        $: 3
    }, zk = function(n) {
        var r = n.dM;
        if (r.b && r.b.b && !r.b.a.$) {
            var e = A2(pi, 0, A2(Gu, qt, r.a));
            return ly(e) ? oe({
                d: n.d + e,
                c6: 1,
                h: qk
            }) : fe;
        }
        return fe;
    }, Dk = A2(pi, jg, Su("(\\\\*)(\\!)?(\\[)")), Pk = {
        $: 2
    }, Kk = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Lk = function(n) {
        var r = n.dM;
        if (r.b && r.b.b && r.b.b.b && !r.b.b.a.$) {
            var e = r.b.a, t = A2(pi, 0, A2(Gu, qt, r.a)), u = !ly(t), c = u ? n.d + t + 1 : n.d + t;
            return u ? e.$ ? fe : oe({
                d: c,
                c6: 1,
                h: Kk(0)
            }) : oe(e.$ ? {
                d: c,
                c6: 1,
                h: Kk(0)
            } : {
                d: c,
                c6: 2,
                h: Pk
            });
        }
        return fe;
    }, Tk = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Rk = function(n) {
        var r = n.dM;
        if (r.b && r.b.b && !r.b.a.$) {
            var e = r.b.a.a, t = A2(pi, 0, A2(Gu, qt, r.a)), u = ly(t) ? g(qt(e), Tk(1)) : g(qt(e), Tk(0));
            return oe({
                d: n.d + t,
                c6: u.a,
                h: u.b
            });
        }
        return fe;
    }, Fk = A2(pi, jg, Su("(\\\\*)(~{2,})([^~])?")), Ok = A2(pi, jg, Su("(\\\\*)([^_])?(\\_+)([^_])?")), Wk = F2(function(n, r) {
        if (n.b) {
            var e = n.a, t = n.b;
            if (r.b) {
                var u = r.a, c = r.b;
                return 0 > f(e.d, u.d) ? A2(se, e, A2(Wk, t, r)) : A2(se, u, A2(Wk, n, c));
            }
            return n;
        }
        return r;
    }), Ek = {
        $: 2
    }, Mk = function(n) {
        return {
            $: 6,
            a: n
        };
    }, jk = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Sk = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Nk = {
        $: 8
    }, Gk = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Qk = Xr, Uk = A2(pi, jg, Su("%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)")), Hk = function(n) {
        return encodeURIComponent(n);
    }, Vk = A2(hu, Hk, A2(Sg, Uk, function(n) {
        return A2(pi, n.e3, function(n) {
            try {
                return oe(decodeURIComponent(n));
            } catch (n) {
                return fe;
            }
        }(n.e3));
    })), Jk = A2(pi, jg, Su("^([A-Za-z][A-Za-z0-9.+\\-]{1,31}:[^<>\\x00-\\x20]*)$")), Xk = A2(pi, jg, Su("^\\[\\s*([^\\[\\]\\\\]*(?:\\\\.[^\\[\\]\\\\]*)*)\\s*\\]")), Zk = function(n) {
        return n;
    }, Yk = A2(hu, Zk, ic), n_ = F2(function(n, r) {
        return g(Vk(uk(n)), A2(Gu, uk, r));
    }), r_ = F3(function(n, r, e) {
        var t, u = Kt(t = A2(pi, n.iu, A2(pi, fe, A2(Tu, A2(hu, function(n) {
            return n.dM;
        }, Nu), e)))) ? n.iu : t, c = A2(zi, Yk(u), r);
        if (1 === c.$) return fe;
        var a = c.a, i = a.a, o = a.b, f = 5 === n.cv.$ ? jk(A2(n_, i, o)) : Sk(A2(n_, i, o)), s = e.$ ? 0 : qt(e.a.e3);
        return oe($(n, {
            i: n.i + s,
            cv: f
        }));
    }), e_ = F3(function(n, r, e) {
        return A3(r_, r, e, Nu(A3(Eu, 1, Xk, n)));
    }), t_ = " \\t\\f\\v\\r\\n", u_ = A2(pi, jg, Su("^\\(\\s*(?:<([^<>\\f\\v\\r\\n]*)>|([^" + t_ + "\\(\\)\\\\]*(?:\\\\.[^" + t_ + "\\(\\)\\\\]*)*))(?:[" + t_ + "]+(?:'([^'\\\\]*(?:\\\\.[^'\\\\]*)*)'|\"([^\"\\\\]*(?:\\\\.[^\"\\\\]*)*)\"|\\(([^\\)\\\\]*(?:\\\\.[^\\)\\\\]*)*)\\)))?\\s*\\)")), c_ = function(n) {
        var r = F2(function(n, r) {
            return r.$ ? n : oe(r.a);
        });
        return A3(De, r, fe, n);
    }, a_ = F2(function(n, r) {
        var e, t = r.dM;
        if (t.b && t.b.b && t.b.b.b && t.b.b.b.b && t.b.b.b.b.b) {
            var u = t.a, c = t.b, a = c.a, i = c.b, o = i.b, f = c_(_([
                i.a,
                o.a,
                o.b.a
            ])), s = c_(_([
                u,
                a
            ]));
            return oe((e = A2(pi, "", s), $(n, {
                i: n.i + qt(r.e3),
                cv: (5 === n.cv.$ ? jk : Sk)(A2(n_, e, f))
            })));
        }
        return fe;
    }), i_ = F3(function(n, r, e) {
        var t = r, u = A3(Eu, 1, u_, n);
        if (u.b) {
            var c = A2(a_, t, u.a);
            return c.$ ? A3(e_, n, t, e) : oe(c.a);
        }
        return A3(e_, n, t, e);
    }), o_ = F2(function(n, r) {
        var e = n, t = ni(function(n) {
            var r = n;
            return f(e.i, r.k) > 0 && 0 > f(e.i, r.i);
        });
        return Ro(r) || Ro(t(r)) ? oe(A2(se, e, r)) : fe;
    }), f_ = A2(pi, jg, Su("^([a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~\\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)*)$")), s_ = function(n) {
        var r = n;
        return A2(Qk, f_, r.iu) ? ye($(r, {
            cv: Gk(g(r.iu, "mailto:" + Vk(r.iu)))
        })) : $e(r);
    }, d_ = F3(function(n, r, e) {
        for(;;){
            if (!e.b) return fe;
            var t = e.a, u = e.b;
            if (r(t)) return oe(h(t, Se(n), u));
            n = A2(se, t, n), e = u;
        }
    }), b_ = F2(function(n, r) {
        return A3(d_, w, n, r);
    }), l_ = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), v_ = function(n) {
        return A3(Ac, !1, n.f, n);
    }, g_ = F2(function(n, r) {
        var e = r, t = A2(ra, A2(ra, A2(ra, Uc(F3(function(n, r, e) {
            return {
                eP: r,
                c6: e - n
            };
        })), v_), cy), v_), u = A2(Oa, t, A2(Dt, e.k, n));
        return u.$ ? fe : oe({
            d: e.k,
            c6: u.a.c6,
            h: A2(l_, 0, u.a.eP)
        });
    }), h_ = F2(function(n, r) {
        return r.$ ? n(r.a) : r;
    }), $_ = F2(function(n, r) {
        var e = r.h;
        return !e.$ && c(e.a ? r.c6 : r.c6 - 1, n.c6);
    }), m_ = function(n) {
        switch(n.h.$){
            case 1:
            case 2:
                return !0;
            default:
                return !1;
        }
    }, p_ = F2(function(n, r) {
        var e = r.h;
        if (7 === e.$) {
            var t = e.b, u = n.h;
            if (7 === u.$) {
                var a = u.b;
                return !(!c(e.a, u.a) || (c(t.b7, t.ck) || c(a.b7, a.ck)) && !A2(Bu, 3, n.c6 + r.c6) && (A2(Bu, 3, n.c6) || A2(Bu, 3, r.c6)));
            }
            return !1;
        }
        return !1;
    }), w_ = F2(function(n, r) {
        var e, t, u = 9 === (t = r.h).$ ? g(!0, t.a ? r.c6 : r.c6 - 1) : g(!1, 0), a = u.a, i = u.b, o = 9 === (e = n.h).$ ? g(!0, e.a ? n.c6 : n.c6 - 1) : g(!1, 0);
        return o.a && a && c(o.b, i);
    }), y_ = {
        $: 1
    }, k_ = F2(function(n, r) {
        return {
            i: n.d + n.c6,
            u: w,
            k: n.d,
            iu: "",
            D: 0,
            w: 0,
            cv: r
        };
    }), __ = F2(function(n, r) {
        for(;;){
            if (!n.b) return r;
            var e = n.a, t = n.b;
            8 !== e.h.$ ? n = t : (n = t, r = A2(se, A2(k_, e, y_), r));
        }
    }), I_ = F2(function(n, r) {
        var e = n;
        return A2(ni, function(n) {
            return f(n.d, e.i) > -1;
        }, r);
    }), x_ = F6(function(n, r, e, t, u, c) {
        var a, i = c.c, o = A2(h_, s_, A2(Qk, Jk, (a = A7(T_, t, u, function(n) {
            return n;
        }, Ek, c.a, n, w)).iu) ? ye($(a, {
            cv: Gk(g(a.iu, Vk(a.iu)))
        })) : $e(a));
        if (1 === o.$) {
            if (1 === r) {
                var f = A2(g_, u, o.a);
                return f.$ ? fe : oe(g(A2(se, f.a, i), e));
            }
            return fe;
        }
        return oe(g(i, A2(se, o.a, e)));
    }), A_ = F5(function(n, r, e, t, u) {
        n: for(;;){
            if (!n.b) return A5(z_, Se(r), w, e, t, u);
            var c = n.a, a = n.b, i = c.h;
            switch(i.$){
                case 0:
                    var o = A2(b_, $_(c), r);
                    if (o.$) {
                        n = a, r = A2(se, c, r);
                        continue n;
                    }
                    var f = A5(B_, c, e, t, u, o.a);
                    n = a, r = g = f.a, e = h = f.b;
                    continue n;
                case 5:
                    var s = i.a, d = function(n) {
                        return 4 === n.h.$;
                    }, b = A2(b_, d, r);
                    if (b.$) {
                        n = a, r = A2(ni, A2(su, Ia, d), r);
                        continue n;
                    }
                    var l = A6(x_, c, s, e, t, u, b.a);
                    if (l.$) {
                        n = a, r = A2(ni, A2(su, Ia, d), r);
                        continue n;
                    }
                    var v = l.a, g = v.a, h = v.b;
                    n = a, r = A2(ni, A2(su, Ia, d), g), e = h;
                    continue n;
                default:
                    n = a, r = A2(se, c, r);
                    continue n;
            }
        }
    }), B_ = F5(function(n, r, e, t, u) {
        var c, a = u.a, i = u.c, o = (c = a.h).$ || c.a ? a : $(a, {
            d: a.d + 1,
            c6: a.c6 - 1
        });
        return g(i, A2(se, A7(T_, e, t, Zk, Ek, o, n, w), r));
    }), C_ = F5(function(n, r, e, t, u) {
        n: for(;;){
            if (!n.b) return A5(K_, Se(r), w, e, t, u);
            var a = n.a, i = n.b, o = a.h;
            if (7 !== o.$) n = i, r = A2(se, a, r);
            else {
                var s = o.a, d = o.b.ck, b = o.b.b7;
                if (c(b, d)) {
                    if (!d || "_" === s && 1 !== d) {
                        n = i;
                        continue n;
                    }
                    var l = A2(b_, p_(a), r);
                    if (l.$) {
                        n = i, r = A2(se, a, r);
                        continue n;
                    }
                    var v = A5(q_, t, u, a, i, l.a);
                    n = v.a, r = v.c, e = A2(se, v.b, e);
                    continue n;
                }
                if (0 > f(b, d)) {
                    n = i, r = A2(se, a, r);
                    continue n;
                }
                var g = A2(b_, p_(a), r);
                if (g.$) {
                    n = i;
                    continue n;
                }
                var h = A5(q_, t, u, a, i, g.a);
                n = h.a, r = h.c, e = A2(se, h.b, e);
            }
        }
    }), q_ = F5(function(n, r, e, t, u) {
        var c = u.a, a = u.b, i = u.c, o = c.c6 - e.c6, f = o ? o > 0 ? {
            bT: e,
            bA: $(c, {
                d: c.d + o,
                c6: e.c6
            }),
            cj: A2(se, $(c, {
                c6: o
            }), i),
            cs: t
        } : {
            bT: $(e, {
                c6: c.c6
            }),
            bA: c,
            cj: i,
            cs: A2(se, $(e, {
                d: e.d + c.c6,
                c6: -o
            }), t)
        } : {
            bT: e,
            bA: c,
            cj: i,
            cs: t
        }, s = A7(T_, n, r, function(n) {
            return n;
        }, function(n) {
            return {
                $: 7,
                a: n
            };
        }(f.bA.c6), f.bA, f.bT, Se(a));
        return h(f.cs, s, f.cj);
    }), z_ = F5(function(n, r, e, t, u) {
        for(;;){
            if (!n.b) return A5(D_, Se(r), w, e, t, u);
            var c = n.a, a = n.b, i = c.h;
            6 !== i.$ ? (n = a, r = A2(se, c, r)) : (n = a, e = A2(se, A2(k_, c, Mk(i.b)), e));
        }
    }), D_ = F5(function(n, r, e, t, u) {
        n: for(;;){
            if (!n.b) return A5(C_, Se(r), w, e, t, u);
            var c = n.a, a = n.b;
            if (3 !== c.h.$) n = a, r = A2(se, c, r);
            else {
                var i = A2(b_, m_, r);
                if (i.$) {
                    n = a;
                    continue n;
                }
                var o = A6(P_, c, a, e, t, u, i.a);
                if (o.$) {
                    n = a;
                    continue n;
                }
                var f = o.a;
                n = f.a, r = f.c, e = f.b;
            }
        }
    }), P_ = F6(function(n, r, e, t, u, c) {
        var a = c.a, i = c.b, o = c.c, f = h(r, e, p(i, o)), s = A2(Dt, n.d + 1, u), d = function(n) {
            return 1 === n.h.$ ? $(n, {
                h: Kk(1)
            }) : n;
        }, b = function(r) {
            return A7(T_, t, u, function(n) {
                return n;
            }, r ? Sk(g("", fe)) : jk(g("", fe)), a, n, Se(i));
        }, l = a.h;
        switch(l.$){
            case 2:
                var v = b(!1), m = A3(i_, s, v, t);
                if (1 === m.$) return oe(f);
                var w = A2(o_, _ = m.a, e);
                if (w.$) return oe(f);
                var y = w.a;
                return oe(h(A2(I_, _, r), y, o));
            case 1:
                if (l.a) return oe(f);
                v = b(!0);
                var k = A3(i_, s, v, t);
                if (1 === k.$) return oe(f);
                var _, I = A2(o_, _ = k.a, e);
                return I.$ ? oe(f) : (y = I.a, oe(h(A2(I_, _, r), y, A2(Ut, d, o))));
            default:
                return fe;
        }
    }), K_ = F5(function(n, r, e, t, u) {
        n: for(;;){
            if (!n.b) return A2(__, Se(r), e);
            var c = n.a, a = n.b;
            if (9 !== c.h.$) n = a, r = A2(se, c, r);
            else {
                var i = A2(b_, w_(c), r);
                if (i.$) {
                    n = a, r = A2(se, c, r);
                    continue n;
                }
                var o = A5(L_, c, e, t, u, i.a);
                n = a, r = o.a, e = o.b;
            }
        }
    }), L_ = F5(function(n, r, e, t, u) {
        var c, a = u.a, i = u.c, o = 9 !== (c = a.h).$ || c.a ? a : $(a, {
            d: a.d + 1,
            c6: a.c6 - 1
        });
        return g(i, A2(se, A7(T_, e, t, Zk, Nk, o, n, w), r));
    }), T_ = F7(function(n, r, e, t, u, c, a) {
        var i = u.d + u.c6, o = c.d, f = e(A3(zt, i, o, r)), s = u.d, d = c.d + c.c6, b = {
            i: d,
            u: w,
            k: s,
            iu: f,
            D: o,
            w: i,
            cv: t
        };
        return {
            i: d,
            u: A2(Ut, function(n) {
                return A2(My, b, n);
            }, A4(R_, a, w, n, r)),
            k: s,
            iu: f,
            D: o,
            w: i,
            cv: t
        };
    }), R_ = F4(function(n, r, e, t) {
        return A5(A_, n, w, r, e, t);
    }), F_ = function(n) {
        return n.trim();
    }, O_ = F2(function(n, r) {
        var e = F_(r), t = function(n) {
            var r;
            return A2(Wk, A3(ok, A2(hi, function(n) {
                return n.d;
            }, A2(Ou, bk, A2(sk, fk, n))), A2(hi, function(n) {
                return n.d;
            }, A2(Ou, gk, A2(sk, lk, n))), 0), A2(Wk, (r = n, A2(Ou, Bk, A2(sk, xk, r))), A2(Wk, function(n) {
                return A2(Ou, zk, A2(sk, Ck, n));
            }(n), A2(Wk, function(n) {
                return A2(Ou, Lk, A2(sk, Dk, n));
            }(n), A2(Wk, function(n) {
                return A2(Ou, Rk, A2(sk, Fk, n));
            }(n), A2(Wk, function(n) {
                return A2(Ou, A2(yk, "_", n), A2(sk, Ok, n));
            }(n), A2(Wk, function(n) {
                return A2(Ou, A2(yk, "*", n), A2(sk, hk, n));
            }(n), function(n) {
                return A2(Ou, Ik, A2(sk, kk, n));
            }(n))))))));
        }(e);
        return Ey(A3(ik, e, w, Ny(A4(R_, t, w, n, e))));
    }), W_ = ca(_([
        xa(A2(ka, " ", Cp(" "))),
        xa(A2(ka, ">", Cp(">"))),
        A2(Yc, A2(Yc, A2(da, Ee, Cp("Alpha")), Wc(function(n) {
            return je(n) || "-" === n;
        })), ca(_([
            xa(A2(ka, ":", Cp(":"))),
            xa(A2(ka, "@", Cp("@"))),
            xa(A2(ka, "\\", Cp("\\"))),
            xa(A2(ka, "+", Cp("+"))),
            xa(A2(ka, ".", Cp(".")))
        ])))
    ])), E_ = cw(A2(Mc, F2(function(n) {
        return jp(n);
    }), A2(Yc, A2(Yc, A2(Yc, xa(A2(ka, "<", Cp("<"))), W_), vw), hw))), M_ = function(n) {
        return xa(A2(ka, n, Cp(n)));
    }, j_ = function(n) {
        var r = n.a, e = n.b, t = A2(pi, ha(e), A2(Gu, function(n) {
            return ha(A2(se, n, e));
        }, r)), u = A2(pi, $a(g(fe, e)), A2(Gu, function(n) {
            return $a(g(fe, A2(se, n, e)));
        }, r)), c = function(n) {
            return $a(g(oe(function(n) {
                return p(A2(pi, "", r), n);
            }(n)), e));
        };
        return ca(_([
            A2(va, function() {
                return t;
            }, M_("|\n")),
            A2(va, function() {
                return t;
            }, M_("\n")),
            A2(va, function() {
                return t;
            }, Lc(Cp("end"))),
            A2(Yc, cw(Uc(c("|"))), M_("\\\\|")),
            A2(Yc, cw(Uc(c("\\"))), M_("\\\\")),
            A2(Yc, cw(Uc(c("|"))), M_("\\|")),
            A2(Yc, cw(Uc(u)), M_("|")),
            A2(Mc, F2(function(n) {
                return c(n);
            }), A2(da, Du(!0), Nc("No character found")))
        ]));
    }, S_ = A2(va, A2(De, F2(function(n, r) {
        return A2(se, F_(n), r);
    }), w), A2(la, g(fe, w), j_)), N_ = A2(ra, A2(Yc, Uc(At), ca(_([
        M_("|"),
        Uc(0)
    ]))), S_), G_ = F2(function(n, r) {
        var e, t = n.b, u = A2(Oa, N_, r);
        return u.$ ? $e("Unable to parse previous line as a table header") : c(Pe(e = u.a), Pe(t)) ? ye(function(n) {
            return A3(Ke, F2(function(n, r) {
                return {
                    bM: r,
                    a9: n
                };
            }), n, t);
        }(e)) : $e("Tables must have the same number of header columns (" + Be(Pe(e)) + ") as delimiter columns (" + Be(Pe(t)) + ")");
    }), Q_ = F2(function(n, r) {
        return {
            o: r,
            e$: n
        };
    }), U_ = {
        bR: "`",
        b6: 0,
        cr: A2(ka, "`", Cp("a '`'"))
    }, H_ = function(n) {
        switch(n){
            case 1:
                return Uc(0);
            case 2:
                return Uc(1);
            case 3:
                return Uc(2);
            case 4:
                return Uc(3);
            default:
                return Gc(Cp("Fenced code blocks should be indented no more than 3 spaces"));
        }
    }, V_ = F2(function(n, r) {
        var e = A3(De, F2(function(n, r) {
            return A2(Yc, r, n);
        }), Uc(0), A2(Dy, n, xa(r.cr)));
        return A2(Mc, F2(function(n) {
            return g(r, qt(n));
        }), A2(Yc, e, Wc(ct(r.bR))));
    }), J_ = {
        bR: "~",
        b6: 1,
        cr: A2(ka, "~", Cp("a `~`"))
    }, X_ = ca(_([
        A2(Yc, A2(Yc, qy, ca(_([
            qy,
            Uc(0)
        ]))), ca(_([
            qy,
            Uc(0)
        ]))),
        Uc(0)
    ])), Z_ = A2(ra, A2(ra, A2(Yc, Uc(F2(function(n, r) {
        return {
            bS: r.a,
            c2: n,
            c6: r.b
        };
    })), X_), A2(Bc, H_, wy)), ca(_([
        A2(V_, 3, U_),
        A2(V_, 3, J_)
    ]))), Y_ = ct(" "), nI = F2(function(n, r) {
        return A2(Yc, A2(Yc, A2(Yc, A2(Yc, Uc(0), X_), A2(V_, n, r)), Wc(Y_)), hw);
    }), rI = function(n) {
        return A3(Ac, !1, n.dJ, n);
    }, eI = function(n) {
        var r, e = n.a, t = n.b;
        return ca(_([
            A2(Yc, Uc(ha(t)), Lc(qc)),
            A2(Mc, F2(function(n) {
                return $a(g(e, p(t, n)));
            }), fw),
            cw(A2(Yc, Uc(ha(t)), A2(nI, e.c6, e.bS))),
            A2(ra, A2(ra, A2(ra, Uc(F3(function(n, r, u) {
                return $a(g(e, p(t, A3(zt, n, r, u))));
            })), (r = e.c2, A2(ra, A2(Yc, Uc(At), A2(Py, r, qy)), A2(Yc, A2(Yc, v_, vw), hw)))), v_), rI)
        ]));
    }, tI = A2(Bc, function(n) {
        var r;
        return A2(ra, A2(ra, Uc(Q_), A2(Yc, (r = n.bS, A2(Mc, F2(function(n) {
            var r = F_(n);
            return "" === r ? fe : oe(r);
        }), Wc(r.b6 ? A2(su, Ia, lw) : function(n) {
            return "`" !== n && !lw(n);
        }))), hw)), function(n) {
            return A2(la, g(n, ""), eI);
        }(n));
    }, Z_), uI = A2(ka, "#", Cp("a `#`")), cI = Wc(function(n) {
        return " " === n || "\n" === n || "\r" === n;
    }), aI = A2(ra, A2(ra, A2(Yc, A2(Yc, Uc(Dp), A2(Bc, function(n) {
        var r = qt(n);
        return 4 > r ? Uc(r) : Gc(Cp("heading with < 4 spaces in front"));
    }, jc(cI))), Aa(uI)), A2(Bc, function(n) {
        var r = qt(n) + 1;
        return 7 > r ? Uc(r) : Gc(Cp("heading with < 7 #'s"));
    }, jc(Wc(function(n) {
        return "#" === n;
    })))), ca(_([
        A2(Yc, Uc(""), Aa(ow)),
        A2(ra, A2(Yc, Uc(At), ca(_([
            Aa(dw),
            Aa(sy)
        ]))), A2(Mc, F2(function(n) {
            var r, e;
            return r = F_(n), e = function(n) {
                for(;;){
                    if (!A2(pw, "#", n)) return n;
                    n = A2(mv, 1, n);
                }
            }(r), A2(pw, " ", e) || Kt(e) ? e.replace(/\s+$/, "") : r;
        }), vw))
    ]))), iI = te, oI = F4(function(n, r, e, t) {
        return A2(zc, Pc, A4(Dc, n, r, e, t));
    }), fI = function(n) {
        var r = n.a, e = n.b;
        return function(n) {
            var t = A5(iI, r, n.f, n.ib, n.ef, n.dJ), u = t.a, a = t.b, i = t.c;
            return c(u, -1) ? A2(xc, !1, A4(oI, a, i, e, n.gy)) : A3(Ac, 0 > f(n.f, u), 0, {
                ef: i,
                gy: n.gy,
                j: n.j,
                f: u,
                ib: a,
                dJ: n.dJ
            });
        };
    }, sI = A2(ka, ">", Cp("a `>`")), dI = F3(function(n, r, e) {
        return {
            ef: r,
            gy: e,
            ib: n
        };
    }), bI = F2(function(n, r) {
        return {
            ef: r.ef,
            gy: n,
            j: r.j,
            f: r.f,
            ib: r.ib,
            dJ: r.dJ
        };
    }), lI = F2(function(n, r) {
        var e = r;
        return function(r) {
            var t = e(A2(bI, A2(se, A3(dI, r.ib, r.ef, n), r.gy), r));
            return t.$ ? t : A3(Ac, t.a, t.b, A2(bI, r.gy, t.c));
        };
    }), vI = function(n) {
        switch(n){
            case " ":
            case "\n":
            case "	":
            case "\v":
            case "\f":
            case "\r":
                return !0;
            default:
                return !1;
        }
    }, gI = A2(ka, "<", Cp("a `<`")), hI = A2(lI, "link destination", ca(_([
        A2(ra, A2(Yc, Uc(Hk), Aa(gI)), A2(Yc, jc(fI(sI)), Aa(sI))),
        jc(ky(A2(su, Ia, vI)))
    ]))), $I = A2(ka, "]", Cp("a `]`")), mI = A2(ka, "[", Cp("a `[`")), pI = A2(ra, A2(Yc, Uc(Yk), Aa(mI)), A2(Yc, jc(fI($I)), Aa(A2(ka, "]:", Cp("]:"))))), wI = A2(ka, '"', Cp("a double quote")), yI = function(n) {
        return A2(Ct, "\n\n", n) ? Gc(Cp("no blank line")) : Uc(n);
    }, kI = A2(Yc, Wc(function(n) {
        return !lw(n) && vI(n);
    }), hw), _I = A2(Yc, A2(da, vI, Cp("Required whitespace")), Wc(vI)), II = A2(ka, "'", Cp("a single quote")), xI = (iy = A2(ra, A2(Yc, Uc(oe), Aa(II)), A2(Yc, A2(Yc, A2(Bc, yI, jc(fI(II))), Aa(II)), kI)), oy = A2(ra, A2(Yc, Uc(oe), Aa(wI)), A2(Yc, A2(Yc, A2(Bc, yI, jc(fI(wI))), Aa(wI)), kI)), A2(lI, "title", ca(_([
        cw(A2(ra, A2(Yc, Uc(At), _I), ca(_([
            oy,
            iy,
            Uc(fe)
        ])))),
        A2(Yc, Uc(fe), kI)
    ])))), AI = A2(lI, "link reference definition", A2(ra, A2(ra, A2(ra, A2(Yc, Uc(F3(function(n, r, e) {
        return g(n, {
            a2: r,
            iA: e
        });
    })), X_), A2(Yc, A2(Yc, A2(Yc, pI, Wc(aw)), ca(_([
        fw,
        Uc(0)
    ]))), Wc(aw))), hI), xI)), BI = Wc(aw), CI = function(n) {
        var r = M_(ku(n));
        return A2(Yc, A2(Yc, A2(Yc, A2(Yc, A2(Yc, A2(Yc, A2(Yc, Uc(0), r), BI), r), BI), r), Wc(function(r) {
            return c(r, n) || aw(r);
        })), hw);
    }, qI = ca(_([
        CI("-"),
        CI("*"),
        CI("_")
    ])), zI = ca(_([
        A2(ra, A2(Yc, A2(Yc, A2(Yc, Uc(At), qy), ca(_([
            qy,
            Uc(0)
        ]))), ca(_([
            qy,
            Uc(0)
        ]))), qI),
        qI
    ])), DI = F2(function(n, r) {
        return {
            $: 13,
            a: n,
            b: r
        };
    }), PI = A2(ka, "=", Cp("a `=`")), KI = A2(ka, "-", Cp("a `-`")), LI = (fy = F3(function(n, r, e) {
        return A2(Yc, A2(Yc, Uc(n), xa(r)), Wc(ct(e)));
    }), A2(Mc, F2(function(n, r) {
        return A2(DI, r, n);
    }), A2(ra, A2(Yc, Uc(At), X_), A2(Yc, A2(Yc, ca(_([
        A3(fy, 0, PI, "="),
        A3(fy, 1, KI, "-")
    ])), Wc(aw)), hw)))), TI = function(n) {
        return {
            $: 9,
            a: n
        };
    }, RI = Wc(aw), FI = function(n) {
        return ca(_([
            A2(da, n, Nc("Character not found")),
            Uc(0)
        ]));
    }, OI = function(n) {
        var r;
        return ca(_([
            cw(A2(va, function() {
                return ha(n);
            }, M_("|\n"))),
            A2(va, function() {
                return ha(n);
            }, M_("\n")),
            A2(va, function() {
                return ha(n);
            }, Lc(Cp("end"))),
            cw(A2(Yc, A2(Yc, Uc(ha(n)), M_("|")), Lc(Cp("end")))),
            A2(ra, A2(Yc, A2(Yc, Uc(function(r) {
                return $a(A2(se, r, n));
            }), (r = n, Ro(r) ? ca(_([
                M_("|"),
                Uc(0)
            ])) : M_("|"))), RI), A2(Yc, jc(A2(Yc, A2(Yc, A2(Yc, Uc(0), FI(function(n) {
                return ":" === n;
            })), ky(function(n) {
                return "-" === n;
            })), FI(function(n) {
                return ":" === n;
            }))), RI))
        ]));
    }, WI = function(n) {
        var r = g(A2(Et, ":", n), A2(pw, ":", n));
        return r.a ? oe(r.b ? 2 : 0) : r.b ? oe(1) : fe;
    }, EI = A2(va, TI, A2(Bc, function(n) {
        var r = n.a.fW, e = n.b;
        return Ro(e) ? Gc(Cp("Must have at least one column in delimiter row.")) : 1 !== Pe(e) || A2(Et, "|", r) && A2(pw, "|", r) ? Uc(n) : Gc(Nc("Tables with a single column must have pipes at the start and end of the delimiter row to avoid ambiguity."));
    }, A2(Mc, F2(function(n, r) {
        return A2(Yp, {
            fu: n,
            fW: F_(n)
        }, A2(Ut, WI, Se(r)));
    }), A2(la, w, OI)))), MI = F3(function(n, r, e) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var t = r.a;
                    n -= 1, r = r.b, e = A2(se, t, e);
                    continue n;
                }
                return e;
            }
            return e;
        }
    }), jI = F2(function(n, r) {
        return Se(A3(MI, n, r, w));
    }), SI = F3(function(n, r, e) {
        if (r > 0) {
            var t = g(r, e);
            n: for(;;){
                r: for(;;){
                    if (!t.b.b) return e;
                    if (!t.b.b.b) {
                        if (1 === t.a) break n;
                        break r;
                    }
                    switch(t.a){
                        case 1:
                            break n;
                        case 2:
                            var u = t.b;
                            return _([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (t.b.b.b.b) {
                                var c = t.b, a = c.b;
                                return _([
                                    c.a,
                                    a.a,
                                    a.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (t.b.b.b.b && t.b.b.b.b.b) {
                                var i = t.b, o = i.b, f = o.b, s = f.b, d = s.b;
                                return A2(se, i.a, A2(se, o.a, A2(se, f.a, A2(se, s.a, n > 1e3 ? A2(jI, r - 4, d) : A3(SI, n + 1, r - 4, d)))));
                            }
                            break r;
                    }
                }
                return e;
            }
            return _([
                t.b.a
            ]);
        }
        return w;
    }), NI = F2(function(n, r) {
        return A3(SI, 0, n, r);
    }), GI = F2(function(n, r) {
        var e = Pe(r);
        switch(A2(Ua, n, e)){
            case 0:
                return A2(NI, n, r);
            case 1:
                return r;
            default:
                return p(r, A2(Dy, n - e, ""));
        }
    }), QI = function(n) {
        var r, e = n.a, t = n.b;
        return A2(va, function(n) {
            return Xp(A2(Zp, e, p(t, _([
                n
            ]))));
        }, (r = Pe(e), A2(Bc, function(n) {
            return Ro(n) || A2(tf, Kt, n) ? Gc(Nc("A line must have at least one column")) : Uc(A2(GI, r, n));
        }, N_)));
    }, UI = {
        $: 2
    }, HI = function(n) {
        return {
            $: 1,
            a: n
        };
    }, VI = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), JI = F4(function(n, r, e, t) {
        var u = t.a, c = t.b, a = u - e;
        return a > 4 ? h(r, e - n + 1, function() {
            switch(c.$){
                case 0:
                    var n = c.b;
                    return A2(VI, c.a, p(A2(Iu, a - 1, " "), n));
                case 1:
                    return n = c.a, HI(p(A2(Iu, a - 1, " "), n));
                default:
                    return UI;
            }
        }()) : h(r, u - n, c);
    }), XI = A2(ra, Uc(function(n) {
        return g(n, UI);
    }), A2(Yc, wy, hw)), ZI = ca(_([
        A2(Yc, Uc(1), Aa(A2(ka, "[x] ", ya("[x] ")))),
        A2(Yc, Uc(1), Aa(A2(ka, "[X] ", ya("[X] ")))),
        A2(Yc, Uc(0), Aa(A2(ka, "[ ] ", ya("[ ] "))))
    ])), YI = A2(ra, ca(_([
        A2(ra, Uc(VI), A2(Yc, ZI, Wc(aw))),
        Uc(HI)
    ])), A2(Yc, jc(vw), hw)), nx = A2(ra, A2(ra, A2(Yc, Uc(F2(function(n, r) {
        return g(n, r);
    })), ky(aw)), wy), YI), rx = ca(_([
        A2(Yc, A2(Yc, Uc(0), A2(Py, 3, qy)), Aa(A2(ka, "-", ya("-")))),
        A2(Yc, Uc(1), Aa(A2(ka, "+", ya("+")))),
        A2(Yc, Uc(2), Aa(A2(ka, "*", ya("*"))))
    ])), ex = function(n) {
        var r = F2(function(n, r) {
            switch(r.$){
                case 0:
                    return {
                        o: r.b,
                        hG: n,
                        l: oe(1 === r.a)
                    };
                case 1:
                    return {
                        o: r.a,
                        hG: n,
                        l: fe
                    };
                default:
                    return {
                        o: "",
                        hG: n,
                        l: fe
                    };
            }
        });
        return A2(va, function(n) {
            return A4(tw, !0, n.b, w, A2(r, n.a, n.c));
        }, function(n) {
            return A2(ra, A2(ra, A2(ra, A2(ra, Uc(JI), wy), cw(rx)), wy), n ? nx : ca(_([
                XI,
                nx
            ])));
        }(n));
    }, tx = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), ux = F2(function(n, r) {
        switch(n.$){
            case 0:
                var e = n.a, t = n.b, u = sx(n.c);
                if (u.$) return $e(u.a);
                var c = Kp(A3(Rp, e, t, u.a));
                return ye(A2(se, c, r));
            case 1:
                var a = bx(n.a);
                return a.$ ? $e(Cp(A2(Ce, "\n", A2(Ut, pp, a.a)))) : ye(p(Se(a.a), r));
            case 2:
                return ye(A2(se, Kp(Lp(n.a)), r));
            case 3:
                return ye(A2(se, Kp(kp(n.a)), r));
            case 4:
                return ye(A2(se, Kp(Hp(n.a)), r));
            default:
                return ye(A2(se, Kp(A2(Tp, n.a, n.b)), r));
        }
    }), cx = function(n) {
        var r = n.c;
        n: for(; r.b;)switch(r.a.$){
            case 11:
                var e = r.a.a, t = r.b, u = A2(Oa, kx(), e);
                return u.$ ? Gc(Nc(mw(u.a))) : Uc({
                    b: p(n.b, (w = u.a).b),
                    c: A2(se, Up(w.c), t)
                });
            case 3:
                var c = r.a, a = c.a, i = c.b, o = c.c, f = c.d, s = (t = r.b, A2(Oa, kx(), f.o));
                if (s.$) return Gc(Nc(mw(s.a)));
                var d = !A2(ui, wp, (w = s.a).c) && a;
                return Uc({
                    b: p(n.b, w.b),
                    c: A2(se, A4(tw, d, i, A2(se, {
                        o: w.c,
                        l: f.l
                    }, o), f), t)
                });
            case 4:
                var b = r.a, l = (a = b.a, i = b.b, b.c), v = b.d, g = (o = b.e, f = b.f, t = r.b, A2(Oa, kx(), f));
                return g.$ ? Gc(Nc(mw(g.a))) : (d = !A2(ui, wp, (w = g.a).c) && a, Uc({
                    b: p(n.b, w.b),
                    c: A2(se, A6(Np, d, i, l, v, A2(se, w.c, o), f), t)
                }));
            case 10:
                if (!r.b.b) break n;
                switch(r.b.a.$){
                    case 3:
                        var h = r.b, $ = h.a, m = (a = $.a, i = $.b, o = $.c, f = $.d, t = h.b, A2(Oa, kx(), f.o));
                        return m.$ ? Gc(Nc(mw(m.a))) : (d = !A2(ui, wp, (w = m.a).c) && a, Uc({
                            b: p(n.b, w.b),
                            c: A2(se, A4(tw, d, i, A2(se, {
                                o: w.c,
                                l: f.l
                            }, o), f), t)
                        }));
                    case 4:
                        var w, y = r.b, k = y.a, _ = (a = k.a, i = k.b, l = k.c, v = k.d, o = k.e, f = k.f, t = y.b, A2(Oa, kx(), f));
                        return _.$ ? Gc(Nc(mw(_.a))) : (d = !A2(ui, wp, (w = _.a).c) && a, Uc({
                            b: p(n.b, w.b),
                            c: A2(se, A6(Np, d, i, l, v, A2(se, w.c, o), f), t)
                        }));
                    default:
                        break n;
                }
            default:
                break n;
        }
        return Uc(n);
    }, ax = F2(function(n, r) {
        var e = g(r, n.c);
        n: for(; e.b.b;)switch(e.b.a.$){
            case 5:
                if (5 === e.a.$) {
                    var t = e.b, u = t.b;
                    return Uc({
                        b: n.b,
                        c: A2(se, Ip({
                            o: A2(hy, t.a.a.o, e.a.a.o),
                            e$: fe
                        }), u)
                    });
                }
                break n;
            case 6:
                switch(e.a.$){
                    case 6:
                        var a = e.b;
                        return u = a.b, Uc({
                            b: n.b,
                            c: A2(se, Op(A2(hy, a.a.a, e.a.a)), u)
                        });
                    case 10:
                        var i = e.b;
                        return u = i.b, Uc({
                            b: n.b,
                            c: A2(se, Op(A2(hy, i.a.a, "\n")), u)
                        });
                    default:
                        break n;
                }
            case 11:
                var o = e.b, f = o.a.a;
                switch(u = o.b, r.$){
                    case 11:
                        return Uc({
                            b: n.b,
                            c: A2(se, yp(A2(hy, f, s = r.a)), u)
                        });
                    case 1:
                        var s = r.a, d = A2(Oa, kx(), f);
                        if (d.$) return Gc(Nc(mw(d.a)));
                        var b = (nn = d.a).c;
                        if (b.b) {
                            if (ww(b.a) && !A2(pw, "\n", f)) return Uc({
                                b: n.b,
                                c: A2(se, yp(A2(hy, f, s)), u)
                            });
                            var l = A2(Oa, kx(), f);
                            if (l.$) return Gc(Nc(mw(l.a)));
                            var v = l.a;
                            return Uc({
                                b: p(n.b, nn.b),
                                c: A2(se, r, A2(se, Up(v.c), u))
                            });
                        }
                        var h = A2(Oa, kx(), f);
                        return h.$ ? Gc(Nc(mw(h.a))) : (v = h.a, Uc({
                            b: p(n.b, nn.b),
                            c: A2(se, r, A2(se, Up(v.c), u))
                        }));
                    case 6:
                        s = r.a;
                        var m = A2(Oa, kx(), f);
                        if (m.$) return Gc(Nc(mw(m.a)));
                        var y = (nn = m.a).c;
                        if (y.b && 1 === y.a.$) return Uc({
                            b: n.b,
                            c: A2(se, yp(A3(gy, " ", f, s)), u)
                        });
                        var k = A2(Oa, kx(), f);
                        return k.$ ? Gc(Nc(mw(k.a))) : (v = k.a, Uc({
                            b: p(n.b, nn.b),
                            c: A2(se, r, A2(se, Up(v.c), u))
                        }));
                    default:
                        var _ = A2(Oa, kx(), f);
                        return _.$ ? Gc(Nc(mw(_.a))) : Uc({
                            b: p(n.b, (nn = _.a).b),
                            c: A2(se, r, A2(se, Up(nn.c), u))
                        });
                }
            case 3:
                var I = e.b, x = I.a, A = x.a, B = x.b, C = x.c, q = x.d;
                switch(u = I.b, r.$){
                    case 3:
                        var z = r.b;
                        if (c(q.hG, (W = r.d).hG)) {
                            var D = A2(Oa, kx(), q.o);
                            return D.$ ? Gc(Nc(mw(D.a))) : Uc(A2(ui, wp, (nn = D.a).c) ? {
                                b: p(n.b, nn.b),
                                c: A2(se, A4(tw, !1, z, A2(se, {
                                    o: nn.c,
                                    l: q.l
                                }, C), W), u)
                            } : {
                                b: p(n.b, nn.b),
                                c: A2(se, A4(tw, A, z, A2(se, {
                                    o: nn.c,
                                    l: q.l
                                }, C), W), u)
                            });
                        }
                        var P = A2(Oa, kx(), q.o);
                        if (P.$) return Gc(Nc(mw(P.a)));
                        var K = !A2(ui, wp, (nn = P.a).c) && A;
                        return Uc({
                            b: p(n.b, nn.b),
                            c: A2(se, r, A2(se, A4(tw, K, B, A2(se, {
                                o: nn.c,
                                l: q.l
                            }, C), W), u))
                        });
                    case 1:
                        return Uc({
                            b: n.b,
                            c: A2(se, A4(tw, A, B, C, $(q, {
                                o: A3(gy, "\n", q.o, s = r.a)
                            })), u)
                        });
                    default:
                        var L = A2(Oa, kx(), q.o);
                        return L.$ ? Gc(Nc(mw(L.a))) : (K = !A2(ui, wp, (nn = L.a).c) && A, Uc({
                            b: p(n.b, nn.b),
                            c: A2(se, r, A2(se, A4(tw, K, B, A2(se, {
                                o: nn.c,
                                l: q.l
                            }, C), q), u))
                        }));
                }
            case 4:
                var T = e.b, R = T.a, F = (A = R.a, B = R.b, R.c), O = R.d;
                switch(C = R.e, q = R.f, u = T.b, r.$){
                    case 4:
                        z = r.b;
                        var W = r.f;
                        if (c(F, r.c)) {
                            var E = A2(Oa, kx(), q);
                            return E.$ ? Gc(Nc(mw(E.a))) : (K = !A2(ui, wp, (nn = E.a).c) && A, Uc({
                                b: p(n.b, nn.b),
                                c: A2(se, A6(Np, K, z, F, O, A2(se, nn.c, C), W), u)
                            }));
                        }
                        var M = A2(Oa, kx(), q);
                        return M.$ ? Gc(Nc(mw(M.a))) : (K = !A2(ui, wp, (nn = M.a).c) && A, Uc({
                            b: p(n.b, nn.b),
                            c: A2(se, r, A2(se, A6(Np, K, B, F, O, A2(se, nn.c, C), q), u))
                        }));
                    case 1:
                        return Uc({
                            b: n.b,
                            c: A2(se, A6(Np, A, B, F, O, C, q + "\n" + (s = r.a)), u)
                        });
                    default:
                        var j = A2(Oa, kx(), q);
                        return j.$ ? Gc(Nc(mw(j.a))) : (K = !A2(ui, wp, (nn = j.a).c) && A, Uc({
                            b: p(n.b, nn.b),
                            c: A2(se, r, A2(se, A6(Np, K, B, F, O, A2(se, nn.c, C), q), u))
                        }));
                }
            case 1:
                switch(e.a.$){
                    case 1:
                        var S = e.b;
                        return u = S.b, Uc({
                            b: n.b,
                            c: A2(se, jp(A3(gy, "\n", f = S.a.a, s = e.a.a)), u)
                        });
                    case 13:
                        if (e.a.a) {
                            var N = e.b;
                            return u = N.b, Uc({
                                b: n.b,
                                c: A2(se, A2(Dp, 2, N.a.a), u)
                            });
                        }
                        var G = e.b;
                        u = G.b;
                        return Uc({
                            b: n.b,
                            c: A2(se, A2(Dp, 1, G.a.a), u)
                        });
                    case 9:
                        var Q = e.a.a, U = Q.a, H = e.b, V = H.a.a, J = (u = H.b, A2(G_, A2(Yp, U, Q.b), V));
                        return Uc(J.$ ? {
                            b: n.b,
                            c: A2(se, jp(A3(gy, "\n", V, U.fu)), u)
                        } : {
                            b: n.b,
                            c: A2(se, Xp(A2(Zp, J.a, w)), u)
                        });
                    default:
                        break n;
                }
            case 8:
                if (8 === e.a.$) return u = e.b.b, Uc({
                    b: n.b,
                    c: A2(se, Xp(e.a.a), u)
                });
                break n;
            case 10:
                if (!e.b.b.b) break n;
                switch(e.b.b.a.$){
                    case 4:
                        var X = e.b.b, Z = X.a, Y = (A = Z.a, B = Z.b, F = Z.c, O = Z.d, C = Z.e, q = Z.f, u = X.b, A2(Oa, kx(), q));
                        if (Y.$) return Gc(Nc(mw(Y.a)));
                        var nn = Y.a;
                        if (4 === r.$) {
                            z = r.b;
                            var rn = r.f;
                            return Uc({
                                b: p(n.b, nn.b),
                                c: A2(se, A6(Np, !1, z, F, O, A2(se, nn.c, C), rn), u)
                            });
                        }
                        return Uc({
                            b: p(n.b, nn.b),
                            c: A2(se, r, A2(se, wp, A2(se, A6(Np, A, B, F, O, A2(se, nn.c, C), q), u)))
                        });
                    case 3:
                        var en = e.b.b, tn = en.a, un = (A = tn.a, B = tn.b, C = tn.c, q = tn.d, u = en.b, A2(Oa, kx(), q.o));
                        return un.$ ? Gc(Nc(mw(un.a))) : (nn = un.a, 3 === r.$ ? (rn = r.d, Uc({
                            b: p(n.b, nn.b),
                            c: A2(se, A4(tw, !1, B, A2(se, {
                                o: nn.c,
                                l: q.l
                            }, C), rn), u)
                        })) : Uc({
                            b: p(n.b, nn.b),
                            c: A2(se, r, A2(se, wp, A2(se, A4(tw, A, B, A2(se, {
                                o: nn.c,
                                l: q.l
                            }, C), q), u)))
                        }));
                    default:
                        break n;
                }
            default:
                break n;
        }
        return Uc({
            b: n.b,
            c: A2(se, r, n.c)
        });
    }), ix = F2(function(n, r) {
        var e = r, t = Ja(A2(Ut, wd(function(n) {
            return g(n.a2, n.iA);
        }), n));
        return A2(Ut, ox, A2(O_, t, e));
    }), ox = function(n) {
        switch(n.$){
            case 0:
                return function(n) {
                    return {
                        $: 7,
                        a: n
                    };
                }(n.a);
            case 1:
                return qp;
            case 2:
                return function(n) {
                    return {
                        $: 6,
                        a: n
                    };
                }(n.a);
            case 3:
                return A3(Ep, n.a, n.b, A2(Ut, ox, e = n.c));
            case 4:
                return A3(Fp, n.a, n.b, A2(Ut, ox, e = n.c));
            case 5:
                return function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(fx(n.a));
            case 6:
                var r = n.a, e = n.b;
                switch(r){
                    case 1:
                        return xp(A2(Ut, ox, e));
                    case 2:
                        return Vp(A2(Ut, ox, e));
                    default:
                        return ly(r) ? Vp(_([
                            ox(A2(Ap, r - 2, e))
                        ])) : xp(_([
                            ox(A2(Ap, r - 1, e))
                        ]));
                }
            default:
                return function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(A2(Ut, ox, e = n.a));
        }
    }, fx = function(n) {
        switch(n.$){
            case 1:
                return Lp("TODO this never happens, but use types to drop this case.");
            case 0:
                return A3(Rp, n.a, n.b, A2(Jo, function(n) {
                    return 1 === n.$ ? wx(n.a) : _([
                        Kp(fx(n))
                    ]);
                }, n.c));
            case 2:
                return Lp(n.a);
            case 3:
                return kp(n.a);
            case 4:
                return Hp(n.a);
            default:
                return A2(Tp, n.a, n.b);
        }
    }, sx = function(n) {
        return A2(dx, n, w);
    }, dx = F2(function(n, r) {
        for(;;){
            if (!n.b) return ye(Se(r));
            var e = n.b, t = A2(ux, n.a, r);
            if (t.$) return $e(t.a);
            n = e, r = t.a;
        }
    }), bx = function(n) {
        var r = A2(Oa, A2(Yc, kx(), gw), n);
        if (1 === r.$) return $e(r.a);
        var e = lx(r.a);
        return 1 === e.$ ? A2(Oa, Gc(e.a), "") : ye(A2(ni, function(n) {
            return !(5 === n.$ && !n.a.b);
        }, e.a));
    }, lx = function(n) {
        return A3(vx, n, n.c, w);
    }, vx = F3(function(n, r, e) {
        n: for(;;){
            if (!r.b) return ye(e);
            var t = r.b, u = A2(hx, n.b, r.a);
            switch(u.$){
                case 1:
                    r = t, e = A2(se, u.a, e);
                    continue n;
                case 0:
                    r = t;
                    continue n;
                default:
                    return $e(u.a);
            }
        }
    }), gx = F2(function(n, r) {
        return A2(Ut, function(r) {
            var e = r.bM;
            return A3($x, n, function(n) {
                return {
                    bM: e,
                    a9: n
                };
            }, r.a9);
        }, r);
    }), hx = F2(function(n, r) {
        switch(r.$){
            case 0:
                var e = r.b, t = function(n) {
                    switch(n){
                        case 1:
                            return ye(0);
                        case 2:
                            return ye(1);
                        case 3:
                            return ye(2);
                        case 4:
                            return ye(3);
                        case 5:
                            return ye(4);
                        case 6:
                            return ye(5);
                        default:
                            return $e(Cp("A heading with 1 to 6 #'s, but found " + Be(n)));
                    }
                }(r.a);
                return t.$ ? Wp(t.a) : Qp(A2(zp, t.a, A2(ix, n, e)));
            case 1:
                return Qp(Gp(A2(ix, n, e = r.a)));
            case 2:
                return Qp(Kp(r.a));
            case 3:
                var u = r.a, c = r.c, a = F2(function(r, e) {
                    var t, u = r.$ ? 0 : r.a ? 2 : 1, c = (t = lx({
                        b: n,
                        c: e
                    })).$ ? w : t.a;
                    return A2(Mp, u, c);
                });
                return Qp(A2(ew, vy(u), Se(A2(Ut, function(n) {
                    return A2(a, n.l, n.o);
                }, c))));
            case 4:
                var i = r.d;
                return c = r.e, a = function(r) {
                    var e = lx({
                        b: n,
                        c: r
                    });
                    return e.$ ? w : e.a;
                }, Qp(A3(Sp, vy(u = r.a), i, Se(A2(Ut, a, c))));
            case 5:
                return Qp(_p(r.a));
            case 7:
                return Qp(nw);
            case 10:
            case 11:
                return Bp;
            case 12:
                var o = lx({
                    b: n,
                    c: r.a
                });
                return o.$ ? Wp(o.a) : Qp(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(o.a));
            case 6:
                return Qp(_p({
                    o: r.a,
                    e$: fe
                }));
            case 8:
                var f = r.a, s = f.b;
                return Qp(A2(Jp, A2(gx, n, f.a), A2(mx, n, s)));
            case 9:
                return Qp(Gp(A2(ix, n, r.a.a.fu)));
            default:
                return Qp(Gp(A2(ix, n, r.b)));
        }
    }), $x = F3(function(n, r, e) {
        return r(A2(ix, n, e));
    }), mx = F2(function(n, r) {
        return A2(Ut, function(r) {
            return A2(Ut, function(r) {
                return A3($x, n, At, r);
            }, r);
        }, r);
    }), px = function(n) {
        return ca(_([
            A2(va, function() {
                return ha(n);
            }, gw),
            A2(va, function(r) {
                return $a(A2(uw, n, r));
            }, cw(AI)),
            function() {
                var r = n.c;
                n: for(; r.b;)switch(r.a.$){
                    case 1:
                        return A2(va, function(n) {
                            return $a(n);
                        }, A2(Bc, ax(n), Ix()));
                    case 8:
                        var e = r.a.a;
                        return A2(va, function(n) {
                            return $a(n);
                        }, A2(Bc, ax(n), ca(_([
                            _x(),
                            QI(e)
                        ]))));
                    case 3:
                        var t = r.a, u = t.a, c = t.b, a = t.c, i = t.d, o = r.b, f = F2(function(n, r) {
                            return $(n, {
                                c: A2(se, wp, A2(se, A4(tw, u, c, a, $(i, {
                                    o: A3(gy, "", i.o, r)
                                })), o))
                            });
                        }), s = F2(function(n, r) {
                            return $(n, {
                                c: A2(se, A4(tw, u, c, a, $(i, {
                                    o: A3(gy, "\n", i.o, r)
                                })), o)
                            });
                        });
                        return ca(_([
                            A2(va, function(n) {
                                return $a(n);
                            }, A2(va, function() {
                                return A2(f, n, "\n");
                            }, sw)),
                            A2(va, function(n) {
                                return $a(n);
                            }, A2(va, s(n), A2(ra, A2(Yc, Uc(At), Aa(A2(ka, A2(Iu, c, " "), ya("Indentation")))), A2(Yc, jc(vw), hw)))),
                            A2(va, function(n) {
                                return $a(n);
                            }, A2(Bc, ax(n), xx()))
                        ]));
                    case 4:
                        var d = r.a, b = (u = d.a, c = d.b, d.c), l = d.d;
                        return a = d.e, i = d.f, o = r.b, f = F2(function(n, r) {
                            return $(n, {
                                c: A2(se, wp, A2(se, A6(Np, u, c, b, l, a, i + "\n" + r), o))
                            });
                        }), s = F2(function(n, r) {
                            return $(n, {
                                c: A2(se, A6(Np, u, c, b, l, a, i + "\n" + r), o)
                            });
                        }), ca(_([
                            A2(va, function(n) {
                                return $a(n);
                            }, A2(va, function() {
                                return A2(f, n, "\n");
                            }, sw)),
                            A2(va, function(n) {
                                return $a(n);
                            }, A2(va, s(n), A2(ra, A2(Yc, Uc(At), Aa(A2(ka, A2(Iu, c, " "), ya("Indentation")))), A2(Yc, jc(vw), hw)))),
                            A2(va, function(n) {
                                return $a(n);
                            }, A2(Bc, ax(n), xx()))
                        ]));
                    case 10:
                        if (!r.b.b) break n;
                        switch(r.b.a.$){
                            case 3:
                                var v = r.b, g = v.a;
                                return u = g.a, c = g.b, a = g.c, i = g.d, o = v.b, f = F2(function(n, r) {
                                    return $(n, {
                                        c: A2(se, wp, A2(se, A4(tw, u, c, a, $(i, {
                                            o: A3(gy, "", i.o, r)
                                        })), o))
                                    });
                                }), s = F2(function(n, r) {
                                    return $(n, {
                                        c: A2(se, A4(tw, u, c, a, $(i, {
                                            o: A3(gy, "\n", i.o, r)
                                        })), o)
                                    });
                                }), "" === F_(i.o) ? A2(va, function(n) {
                                    return $a(n);
                                }, A2(Bc, ax(n), _x())) : ca(_([
                                    A2(va, function(n) {
                                        return $a(n);
                                    }, A2(va, function() {
                                        return A2(f, n, "\n");
                                    }, sw)),
                                    A2(va, function(n) {
                                        return $a(n);
                                    }, A2(va, s(n), A2(ra, A2(Yc, Uc(At), Aa(A2(ka, A2(Iu, c, " "), ya("Indentation")))), A2(Yc, jc(vw), hw)))),
                                    A2(va, function(n) {
                                        return $a(n);
                                    }, A2(Bc, ax(n), _x()))
                                ]));
                            case 4:
                                var h = r.b, m = h.a;
                                return u = m.a, c = m.b, b = m.c, l = m.d, a = m.e, i = m.f, o = h.b, f = F2(function(n, r) {
                                    return $(n, {
                                        c: A2(se, wp, A2(se, A6(Np, u, c, b, l, a, i + "\n" + r), o))
                                    });
                                }), s = F2(function(n, r) {
                                    return $(n, {
                                        c: A2(se, A6(Np, u, c, b, l, a, i + "\n" + r), o)
                                    });
                                }), "" === F_(i) ? A2(va, function(n) {
                                    return $a(n);
                                }, A2(Bc, ax(n), _x())) : ca(_([
                                    A2(va, function(n) {
                                        return $a(n);
                                    }, A2(va, function() {
                                        return A2(f, n, "\n");
                                    }, sw)),
                                    A2(va, function(n) {
                                        return $a(n);
                                    }, A2(va, s(n), A2(ra, A2(Yc, Uc(At), Aa(A2(ka, A2(Iu, c, " "), ya("Indentation")))), A2(Yc, jc(vw), hw)))),
                                    A2(va, function(n) {
                                        return $a(n);
                                    }, A2(Bc, ax(n), _x()))
                                ]));
                            default:
                                break n;
                        }
                    default:
                        break n;
                }
                return A2(va, function(n) {
                    return $a(n);
                }, A2(Bc, ax(n), _x()));
            }(),
            A2(va, function(n) {
                return $a(n);
            }, A2(Bc, ax(n), my))
        ]));
    }, wx = function(n) {
        return A2(tx, w, bx(n));
    }, yx = function(n) {
        switch(n.$){
            case 1:
                return Uc(jp(n.a));
            case 0:
                var r = n.a, e = n.b, t = sx(n.c);
                return t.$ ? Gc(t.a) : Uc(Pp(A3(Rp, r, e, t.a)));
            case 2:
                return Uc(Pp(Lp(n.a)));
            case 3:
                return Uc(Pp(kp(n.a)));
            case 4:
                return Uc(Pp(Hp(n.a)));
            default:
                return Uc(Pp(A2(Tp, n.a, n.b)));
        }
    };
    function kx() {
        return A2(Bc, cx, A2(la, {
            b: w,
            c: w
        }, px));
    }
    function _x() {
        return ca(_([
            E_,
            sw,
            $w,
            A2(va, Ip, cw(tI)),
            by,
            A2(va, function() {
                return rw;
            }, cw(zI)),
            ex(!1),
            Ly(!1),
            cw(aI),
            Ax()
        ]));
    }
    function Ix() {
        return ca(_([
            E_,
            sw,
            $w,
            A2(va, Ip, cw(tI)),
            cw(LI),
            A2(va, function() {
                return rw;
            }, cw(zI)),
            ex(!0),
            Ly(!0),
            cw(aI),
            Ax(),
            cw(EI)
        ]));
    }
    function xx() {
        return ca(_([
            E_,
            sw,
            $w,
            A2(va, Ip, cw(tI)),
            A2(va, function() {
                return rw;
            }, cw(zI)),
            ex(!1),
            Ly(!1),
            cw(aI),
            Ax()
        ]));
    }
    function Ax() {
        return A2(Bc, yx, cy);
    }
    var Bx = kx();
    kx = function() {
        return Bx;
    };
    var Cx = _x();
    _x = function() {
        return Cx;
    };
    var qx = Ix();
    Ix = function() {
        return qx;
    };
    var zx = xx();
    xx = function() {
        return zx;
    };
    var Dx = Ax();
    Ax = function() {
        return Dx;
    };
    var Px, Kx, Lx = A2(Qt, ud(se), ye(w)), Tx = F3(function(n, r, e) {
        n: for(;;){
            if (!e.b) return r;
            var t = e.a, u = e.b;
            switch(t.$){
                case 0:
                    var c = t.a;
                    if (c.$) {
                        i = n, o = A2(n, t, r), n = i, r = o, e = u;
                        continue n;
                    }
                    var a = c.c, i = n, o = A2(n, t, r);
                    n = i, r = o, e = p(a, u);
                    continue n;
                case 1:
                    var f = A2(Jo, function(n) {
                        return n.b;
                    }, s = t.b);
                    i = n, o = A2(n, t, r), n = i, r = o, e = p(f, u);
                    continue n;
                case 2:
                    var s = t.c;
                    i = n, o = A2(n, t, r), n = i, r = o, e = p(Vo(s), u);
                    continue n;
                case 3:
                    s = t.a, i = n, o = A2(n, t, r), n = i, r = o, e = p(s, u);
                    continue n;
                default:
                    i = n, o = A2(n, t, r), n = i, r = o, e = u;
                    continue n;
            }
        }
    }), Rx = function(n) {
        switch(n.$){
            case 5:
                return Fx(n.a);
            case 0:
                var r = n.a;
                if (r.$) return "";
                var e = r.c;
                return A3(Tx, F2(function(n, r) {
                    return p(r, Rx(n));
                }), "", e);
            case 1:
                return A2(Ce, "\n", A2(Ut, function(n) {
                    return A2(Ce, "\n", A2(Ut, Rx, n.b));
                }, n.b));
            case 2:
                return A2(Ce, "\n", A2(Ut, function(n) {
                    return A2(Ce, "\n", A2(Ut, Rx, n));
                }, n.c));
            case 3:
                return A2(Ce, "\n", A2(Ut, Rx, e = n.a));
            case 4:
                return Fx(n.b);
            case 6:
                var t = n.b;
                return A2(Ce, "\n", Vo(_([
                    A2(Ut, Fx, A2(Ut, function(n) {
                        return n.a9;
                    }, n.a)),
                    Vo(A2(Ut, Ut(Fx), t))
                ])));
            case 7:
                return n.a.o;
            default:
                return "";
        }
    }, Fx = function(n) {
        return A3(De, Ox, "", n);
    }, Ox = F2(function(n, r) {
        switch(n.$){
            case 7:
            case 6:
                return p(r, n.a);
            case 8:
                return r + " ";
            case 1:
            case 2:
                return p(r, Fx(n.c));
            case 0:
                var e = n.a;
                if (e.$) return r;
                var t = e.c;
                return A3(Tx, F2(function(n, r) {
                    return p(r, Rx(n));
                }), r, t);
            default:
                return p(r, Fx(n.a));
        }
    }), Wx = F5(function(n, r, e, t, u) {
        var c = t;
        return A2(Ru, function(t) {
            return A2(Qu, function(n) {
                return n(t);
            }, A3(c, n, r, e));
        }, Lx(u));
    }), Ex = F3(function(n, r, e) {
        var t = A2(Nx, n, r);
        return t.$ ? e : A2(se, t.a, e);
    }), Mx = F2(function(n, r) {
        return A2(Ou, jx(n), r);
    }), jx = function(n) {
        return function(r) {
            switch(r.$){
                case 4:
                    var e = r.a;
                    return oe(A2(Qu, function(r) {
                        return n.hf({
                            gq: r,
                            hA: e,
                            h4: Fx(t)
                        });
                    }, A2(Gx, n, t = r.b)));
                case 5:
                    var t;
                    return oe(A2(Qu, n.hY, A2(Gx, n, t = r.a)));
                case 0:
                    var u = r.a;
                    return u.$ ? fe : oe(A4(Sx, n, u.a, u.b, u.c));
                case 1:
                    var c = r.a;
                    return oe(A2(Qu, function(r) {
                        return n.iD(A2(Ut, function(n) {
                            return A2(Mp, n.a, Vo(n.b));
                        }, r));
                    }, Lx(A2(Ut, function(r) {
                        var e = r.b;
                        return A2(Qu, Mp(r.a), Lx(A2(Ou, function(r) {
                            var e = g(c, r);
                            return 1 === e.a && 5 === e.b.$ ? oe(A2(Gx, n, e.b.a)) : A2(Gu, Qu(df), A2(jx, n, r));
                        }, e)));
                    }, r.b))));
                case 2:
                    c = r.a;
                    var a = r.b;
                    return oe(A2(Qu, function(r) {
                        return A2(n.hW, a, A2(Ut, function(n) {
                            return Vo(n);
                        }, r));
                    }, Lx(A2(Ut, function(r) {
                        return Lx(A2(Ou, function(r) {
                            var e = g(c, r);
                            return 1 === e.a && 5 === e.b.$ ? oe(A2(Gx, n, e.b.a)) : A2(Gu, Qu(df), A2(jx, n, r));
                        }, r));
                    }, r.c))));
                case 7:
                    return oe(ye(n.gu(r.a)));
                case 8:
                    return oe(ye(n.iv));
                case 3:
                    return oe(A2(Qu, n.gl, Lx(A2(Mx, n, r.a))));
                default:
                    var i = r.a, o = r.b, f = Lx(A2(Ut, function(r) {
                        var e = r.a9;
                        return A2(Qu, co(r.bM), A2(Gx, n, e));
                    }, i)), s = A2(Qu, function(r) {
                        return n.ir(df(n.it(A2(Ut, function(r) {
                            return A2(n.is, r.a, r.b);
                        }, r))));
                    }, f), d = function(r) {
                        return A2(Qu, n.it, A2(Qu, Re(F2(function(r, e) {
                            return A2(n.iq, A2(Tu, function(n) {
                                return n.bM;
                            }, Nu(A2(Xg, r, i))), e);
                        })), Lx(A2(Ut, Gx(n), r))));
                    }, b = Lx(A2(Ut, d, o));
                    return oe(A3(ud, F2(function(r, e) {
                        return n.io(A2(se, r, function(r) {
                            return Ro(r) ? w : _([
                                n.ip(r)
                            ]);
                        }(e)));
                    }), s, b));
            }
        };
    }, Sx = F4(function(n, r, e, t) {
        return A5(Wx, r, e, t, n.hl, A2(Mx, n, t));
    }), Nx = F2(function(n, r) {
        switch(r.$){
            case 4:
                return oe(A2(Qu, n.il, A2(Gx, n, r.a)));
            case 3:
                return oe(A2(Qu, n.gW, A2(Gx, n, r.a)));
            case 5:
                return oe(A2(Qu, n.ik, A2(Gx, n, r.a)));
            case 2:
                var e = r.a, t = r.b;
                return oe(ye(n.ho({
                    cB: Fx(r.c),
                    dJ: e,
                    iA: t
                })));
            case 7:
                return oe(ye(n.iu(r.a)));
            case 6:
                return oe(ye(n.gv(r.a)));
            case 1:
                var u = r.a;
                return t = r.b, oe(A2(Ru, function(r) {
                    return ye(A2(n.hC, {
                        a2: u,
                        iA: t
                    }, r));
                }, A2(Gx, n, r.c)));
            case 8:
                return oe(ye(n.hd));
            default:
                var c = r.a;
                return c.$ ? fe : oe(A4(Sx, n, c.a, c.b, c.c));
        }
    }), Gx = F2(function(n, r) {
        return Lx(A3(Qt, Ex(n), w, r));
    }), Qx = F2(function(n, r) {
        return Lx(A2(Mx, n, r));
    }), Ux = F2(function(n, r) {
        return A2(Ru, A2(su, Qx(n.h8), n.g2), A2(Ni, A2(hu, Ut(pp), Ce("\n\n")), bx(r)));
    }), Hx = Ux(Hl), Vx = function(n) {
        return {
            gr: function(n) {
                var r = Xo(A2(ub, F2(function(r) {
                    return A2(ui, r, n.ix);
                }), n.dW)), e = ci(Hv(A2(Ut, function(r) {
                    return A2(jo, A2(su, ct(r), function(n) {
                        return n.fP;
                    }), n.gy.cq);
                }, A2(Ut, lt, A2(Jo, No, r)))));
                return _([
                    A2(yb, _([
                        mb("chosen-ticket")
                    ]), _([
                        El(A3(Zl, n.gy, "", Gv(function(n) {
                            switch(n){
                                case 0:
                                    return "Ihre Auswahl";
                                case 1:
                                case 3:
                                    return "Your selection";
                                case 2:
                                    return "Tu selecci\xf3n";
                                default:
                                    return "\u0412\u0430\u0448 \u0432\u044B\u0431\u043E\u0440";
                            }
                        })) + ": "),
                        A2(hb, w, _([
                            El(A3(Xi, "-", A2(su, Ce(", "), Bo), A2(Gu, Hg(A2(su, A2(Zl, n.gy, ""), function(n) {
                                return n.a9;
                            })), e)))
                        ]))
                    ]))
                ]);
            },
            gF: function(n) {
                var r;
                return _([
                    A2(Pl, _([
                        mb("current-person"),
                        mb("form-field"),
                        mb("form-field--full-width")
                    ]), _([
                        A2(hb, w, _([
                            El(A3(Zl, n.gy, "", Gv(function(n) {
                                switch(n){
                                    case 0:
                                        return "Teilnehmende Person:";
                                    case 1:
                                        return "Participant:";
                                    case 2:
                                        return "Persona participante:";
                                    case 3:
                                        return "Personne participante:";
                                    default:
                                        return "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A:";
                                }
                            }))),
                            El(" "),
                            El((r = n.dW, A2(Ce, " ", A2(Ou, Qv, A2(Ou, function(n) {
                                return Nu(Hv(A2(Ut, function(n) {
                                    return A2(zi, n, r.a4);
                                }, n)));
                            }, _([
                                _([
                                    "Titel",
                                    "Official title"
                                ]),
                                _([
                                    "Vorname",
                                    "First name"
                                ]),
                                _([
                                    "Nachname",
                                    "Last name"
                                ])
                            ]))))))
                        ]))
                    ]))
                ]);
            },
            gG: function(n) {
                var r = A2(rf, n.gy, n.dW.cg), e = A3(Xi, g(fe, {
                    eV: 0,
                    fn: 0
                }), Cv(oe), A3(lb, n.gy, n.dW.cg, n.gy.as)), t = e.a, u = e.b;
                return _([
                    A2(Pl, _([
                        mb("current-price"),
                        mb("form-field"),
                        mb("form-field--full-width")
                    ]), _([
                        El(A3(Zl, n.gy, "", Gv(function(n) {
                            switch(n){
                                case 0:
                                    return "Gesamtsumme";
                                case 1:
                                    return "Price (total)";
                                case 2:
                                    return "Importe (total)";
                                case 3:
                                    return "Montant total";
                                default:
                                    return "\u0426\u0435\u043D\u0430 (\u043E\u0431\u0449\u0430\u044F)";
                            }
                        }))),
                        El(": "),
                        A2(hb, w, r ? p(_([
                            El(A2(Ev, n.gy.e, r - u.fn))
                        ]), Wd(t) ? _([
                            El(" ("),
                            El(A2(Ev, n.gy.e, u.fn)),
                            El(")")
                        ]) : w) : _([
                            El(A3(Zl, n.gy, "", Gv(function(n) {
                                switch(n){
                                    case 0:
                                        return "kostenfrei";
                                    case 1:
                                        return "free of cost";
                                    case 2:
                                        return "gratis";
                                    case 3:
                                        return "gratuit";
                                    default:
                                        return "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E";
                                }
                            })))
                        ]))
                    ]))
                ]);
            },
            hb: function(n) {
                var r, e, t = n.eR, u = n.iH;
                return _([
                    A2(yb, _([
                        jb(_([
                            g("form-field", !0),
                            g("form-field--full-width", !0),
                            g("form-field--invalid", Wd(u))
                        ]))
                    ]), (r = A2(Ut, A2(su, function(n) {
                        return {
                            a9: n,
                            bK: n
                        };
                    }, Be), _([
                        50,
                        100,
                        200,
                        500
                    ])), e = F2(function(n, r) {
                        var e = r.a9;
                        return A2(Mm, A2(Vm, n.I, Vb({
                            bK: r.bK
                        })), e);
                    }), _([
                        A3(q$, A2(fp, Fd(u), A2(rp, A2(su, Yd, Sf), A2(cp, Qv(n.dW), A2(Xm, oe(A3(Zl, n.gy, "", Gv(function(n) {
                            return 1 === n ? "Guest codes*" : "G\xe4stecodes*";
                        }))), A2(Nm, _([
                            ug(Be(t))
                        ]), Hb))))), A2(e, {
                            I: !0
                        }, {
                            a9: "",
                            bK: ""
                        }), A2(Ut, e({
                            I: !1
                        }), r)),
                        tg({
                            ag: n,
                            iH: u
                        })
                    ])))
                ]);
            },
            hs: function(n) {
                var r = n.gy, e = n.hv, t = n.eR, u = n.ht, a = n.iH;
                return _([
                    A2(yb, _([
                        jb(_([
                            g("form-field", !0),
                            g("form-field--full-width", u.g7 || function() {
                                switch(e.$){
                                    case 0:
                                        return !0;
                                    case 1:
                                        return e.a.fs;
                                    default:
                                        return !1;
                                }
                            }()),
                            g("form-field--checkbox", !e.$),
                            g("form-field--radio-group", 1 === e.$ && e.a.fs),
                            g("form-field--invalid", Wd(a)),
                            g("form-field--file", 4 === e.$)
                        ]))
                    ]), function() {
                        switch(e.$){
                            case 0:
                                var i = e.a, o = A2(pi, !1, hp(n.dW));
                                return _([
                                    A2(av, Qb, _([
                                        Mb(A2(Ym, Yd(Wf(!o)), A2(ip, oe(o ? 1 : 0), A2(jm, _([
                                            ug(Be(t))
                                        ]), Nb)))),
                                        A2(tv, _([
                                            rv(Yd(Wf(!o))),
                                            nv(Be(t))
                                        ]), A2(Vl, A2(su, A2(su, A2(su, df, Kl(w)), df), El), Hx(p(A3(Zl, n.gy, "", i), u.fz ? "\\*" : ""))))
                                    ])),
                                    tg({
                                        ag: n,
                                        iH: a
                                    })
                                ]);
                            case 1:
                                var f = e.b;
                                if (e.a.fs) {
                                    var s = A3(Zl, n.gy, w, A2(Vg, function() {
                                        return Bo;
                                    }, f)), d = F2(function(r, e) {
                                        var a = e.bK, i = e.a9;
                                        return A2(av, A2(tp, Yd(Sf(a)), A2(Jm, oe(p(i, u.fz ? "*" : "")), Qb)), _([
                                            Fm((r ? At : Sm(_([
                                                ug(Be(t))
                                            ])))(A2(Qm, c(Qv(n.dW), oe(a)), A2(np, Yd(Sf(a)), Ub))))
                                        ]));
                                    });
                                    return p(A2(Re, d, s), _([
                                        tg({
                                            ag: n,
                                            iH: a
                                        })
                                    ]));
                                }
                                s = A3(Zl, n.gy, w, A2(Vg, function() {
                                    return Bo;
                                }, f));
                                var b = F2(function(n, r) {
                                    var e = r.a9;
                                    return A2(Mm, A2(Vm, n.I, Vb({
                                        bK: r.bK
                                    })), e);
                                });
                                return _([
                                    A3(q$, A2(fp, Fd(a), A2(rp, A2(su, Yd, Sf), A2(cp, Qv(n.dW), A2(Xm, oe(p(A3(Zl, n.gy, "", "$guestCodes" === A3(Zl, n.gy, "", u.a9) ? Gv(function(n) {
                                        return 1 === n ? "Number of guest codes" : "Anzahl G\xe4stecodes";
                                    }) : u.a9), u.fz ? "*" : "")), A2(Nm, _([
                                        ug(Be(t))
                                    ]), Hb))))), A2(b, u.fz ? {
                                        I: !0
                                    } : {
                                        I: !1
                                    }, {
                                        a9: "",
                                        bK: ""
                                    }), A2(Ut, b({
                                        I: !1
                                    }), s)),
                                    tg({
                                        ag: n,
                                        iH: a
                                    })
                                ]);
                            case 2:
                                return o = Qv(n.dW), _([
                                    Am(A2(sp, Fd(a), A2(up, A2(su, Yd, Sf), A2(dp, o, A2(Zm, oe(p(A3(Zl, n.gy, "", u.a9), u.fz ? "*" : "")), A2(Gm, _([
                                        ug(Be(t))
                                    ]), Jb)))))),
                                    tg({
                                        ag: n,
                                        iH: a
                                    })
                                ]);
                            case 3:
                                return s = r.aS.h_({
                                    ey: e.a.ey,
                                    eU: e.a.eU
                                }), b = F2(function(n, e) {
                                    var t = e.a9;
                                    return A2(Mm, A2(Vm, n.I, Vb({
                                        bK: e.bK
                                    })), A3(Zl, r, "", t));
                                }), _([
                                    A3(q$, A2(fp, Fd(a), A2(rp, A2(su, Yd, Sf), A2(cp, Qv(n.dW), A2(Xm, oe(p(A3(Zl, n.gy, "", u.a9), u.fz ? "*" : "")), A2(Nm, _([
                                        ug(Be(t))
                                    ]), Hb))))), A2(b, u.fz ? {
                                        I: !0
                                    } : {
                                        I: !1
                                    }, {
                                        a9: A2(lp, r.gQ, ""),
                                        bK: ""
                                    }), A2(Ut, b({
                                        I: !1
                                    }), s)),
                                    tg({
                                        ag: n,
                                        iH: a
                                    })
                                ]);
                            default:
                                var l = e.a.hH, v = e.a.d$, h = 1 === (I = n.fj).$ ? bp(u.hu) : A2(_o, "persons", _([
                                    Be(I.a),
                                    u.hu
                                ])), $ = (y = g(A2(Vv, h, n.gy.am), Qv(n.dW)), o = y.a.$ ? y.b.$ ? fe : oe(ye(y.b.a)) : oe($e(y.a.a)), function() {
                                    if (1 === o.$) return !1;
                                    if (!o.a.$) return !1;
                                    switch(o.a.a.$){
                                        case 0:
                                        case 1:
                                            return !0;
                                        default:
                                            return !1;
                                    }
                                }()), m = 1 === o.$ ? "" : o.a.$ ? o.a.a.a.de : Zg(o.a.a);
                                return _([
                                    A3(Ob, "x-user-upload", _([
                                        A2(Lb, "filereplaced", A2(kt, A2(eb, {
                                            hH: l
                                        }, h), A2(uu, "detail", Yb))),
                                        A2(qb, "accept", bc(v))
                                    ]), _([
                                        A2(yb, _([
                                            A2(gb, "slot", "root")
                                        ]), _([
                                            Am(A2(sp, Fd(a), A2(up, function() {
                                                return Yd(n.dW);
                                            }, A2(dp, oe(m), A2(Zm, oe(p(A3(Zl, n.gy, "", u.a9), u.fz ? "*" : "")), A2(op, oe(A3(Xb, cl, w, _([
                                                Og(A2(Um, !$, A2(ap, 2, Gb)))
                                            ]))), A2(Gm, _([
                                                ug(Be(t))
                                            ]), Jb)))))))
                                        ]))
                                    ])),
                                    tg({
                                        ag: n,
                                        iH: (k = A2(Tu, function(r) {
                                            if (!r.$) return fe;
                                            switch(r.a.$){
                                                case 0:
                                                case 1:
                                                    return oe({
                                                        cU: A3(Zl, n.gy, "", Gv(function(n) {
                                                            switch(n){
                                                                case 0:
                                                                    return "Die Datei wird noch hochgeladen.";
                                                                case 1:
                                                                    return "The file is still uploading.";
                                                                case 2:
                                                                    return "El archivo a\xfan se est\xe1 cargando.";
                                                                case 3:
                                                                    return "Le fichier est en cours de t\xe9l\xe9chargement.";
                                                                default:
                                                                    return "\u0424\u0430\u0439\u043B \u0432\u0441\u0435 \u0435\u0449\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u0442\u0441\u044F.";
                                                            }
                                                        })),
                                                        eR: Be(t),
                                                        e2: n.gD
                                                    });
                                                case 2:
                                                    return oe({
                                                        cU: A3(Zl, n.gy, "", Gv(function(n) {
                                                            switch(n){
                                                                case 0:
                                                                    return "Die Datei konnte nicht hochgeladen werden.";
                                                                case 1:
                                                                    return "The file failed to upload.";
                                                                case 2:
                                                                    return "No se ha podido cargar el archivo.";
                                                                case 3:
                                                                    return "Le fichier n'a pas pu \xeatre t\xe9l\xe9charg\xe9.";
                                                                default:
                                                                    return "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0444\u0430\u0439\u043B.";
                                                            }
                                                        })),
                                                        eR: Be(t),
                                                        e2: n.gD
                                                    });
                                                default:
                                                    return oe({
                                                        cU: A3(Zl, n.gy, "", Gv(function(n) {
                                                            switch(n){
                                                                case 0:
                                                                    return "Die Datei ist zu gro\xdf (max. " + A2($p, n, l) + ").";
                                                                case 1:
                                                                    return "The file is too large (max. " + A2($p, n, l) + ").";
                                                                case 2:
                                                                    return "El fichero es demasiado grande (m\xe1x. " + A2($p, n, l) + ").";
                                                                case 3:
                                                                    return "Le fichier est trop important (max. " + A2($p, n, l) + ").";
                                                                default:
                                                                    return "\u0424\u0430\u0439\u043B \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u0432\u0435\u043B\u0438\u043A (\u043C\u0430\u043A\u0441. " + A2($p, n, l) + ").";
                                                            }
                                                        })),
                                                        eR: Be(t),
                                                        e2: n.gD
                                                    });
                                            }
                                        }, o), A2(Tu, function() {
                                            return A2(Qd, a, k);
                                        }, a))
                                    })
                                ]);
                        }
                        var y, k, I;
                    }())
                ]);
            },
            hF: function(n) {
                var r = n.ic;
                return A2(Vl, A2(su, A2(su, A2(su, df, Kl(w)), df), El), A2(Ux, $(Hl, {
                    h8: vp
                }), A3(Ug, 2, A2(pi, Jg, A2(Gu, function(r) {
                    return jv(_([
                        g("Aussteller.Firma", A3(Zl, n.gy, "", r.a9)),
                        g("Aussteller.Kostenfreie Tickets", Be(r.eH))
                    ]));
                }, A2(Tu, function(n) {
                    return n.ez;
                }, n.gy.eb))), A3(Zl, n.gy, "", r))));
            },
            hK: function() {
                return w;
            },
            hX: function(n) {
                var r, e, t = n.iC, u = n.g0, a = n.iG, i = n.hP, o = n.h0;
                if (c(n.dW.bl, n.gD)) {
                    var f = function(r) {
                        var e;
                        return A2(yb, _([
                            mb("page-button--prev")
                        ]), _([
                            A2(gp, A2(ep, Yd((e = n.dW, $(e, {
                                bl: r
                            }))), Sb), A3(Zl, n.gy, "", Gv(function(n) {
                                switch(n){
                                    case 0:
                                        return "Zur\xfcck";
                                    case 1:
                                        return "Back";
                                    case 2:
                                        return "Atr\xe1s";
                                    case 3:
                                        return "Retour";
                                    default:
                                        return "\u041D\u0430\u0437\u0430\u0434";
                                }
                            })))
                        ]));
                    }, s = Fd(i);
                    return _([
                        A2(Wm, _([
                            mb("page"),
                            ug(Be(n.eR))
                        ]), _([
                            A2(yb, _([
                                mb("page__form form-field-wrapper")
                            ]), u),
                            s ? A3(Xi, El(""), A2(su, function(r) {
                                return A2(yb, _([
                                    mb("form-field--global-validation form-field-wrapper form-field--invalid")
                                ]), _([
                                    tg({
                                        ag: n,
                                        iH: oe($(r, {
                                            cU: A3(Zl, n.gy, "", Gv(function(n) {
                                                return 1 === n ? "Your order is incomplete. Please complete the pages marked in red." : "Ihre Bestellung ist unvollst\xe4ndig. Bitte erg\xe4nzen Sie die im Men\xfc rot hervorgehobenen Seiten.";
                                            }))
                                        }))
                                    })
                                ]));
                            }, zd), c(n.dW.cm, Ad) ? A2(Tu, Yl(A2(su, qa(n.gD), function(n) {
                                return n.e2;
                            })), t) : fe) : El(""),
                            A2(yb, _([
                                mb("page__buttons")
                            ]), A2(se, (r = i, A2(yb, _([
                                mb("page-button--next")
                            ]), _([
                                A2(Om, A2(ep, (e = n.dW, r.$ ? a && c(t, fe) ? rb : Yd($(e, {
                                    cm: Ad
                                })) : Yd($(e, a ? {
                                    bl: r.a
                                } : {
                                    cm: A2(Eg, n.gD, e.cm)
                                }))), Sb), A3(Zl, n.gy, "", i.$ ? Wd(n.gy.ba) ? Gv(A2(rf, n.gy, n.dW.cg) ? function(n) {
                                    return 1 === n ? "Update registration incl. payment" : "Kostenpflichtige \xc4nderung vornehmen";
                                } : function(n) {
                                    return 1 === n ? "Update registration" : "\xc4nderung vornehmen";
                                }) : Gv(A2(rf, n.gy, n.dW.cg) ? function(n) {
                                    switch(n){
                                        case 0:
                                            return "Kostenpflichtige Registrierung abschlie\xdfen";
                                        case 1:
                                            return "Complete registration incl. payment";
                                        case 2:
                                            return "Completar la inscripci\xf3n de pago";
                                        case 3:
                                            return "Finaliser l'inscription payante";
                                        default:
                                            return "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u043E\u043F\u043B\u0430\u0442\u0443";
                                    }
                                } : function(n) {
                                    switch(n){
                                        case 0:
                                            return "Registrierung abschlie\xdfen";
                                        case 1:
                                            return "Complete registration";
                                        case 2:
                                            return "Completar la inscripci\xf3n";
                                        case 3:
                                            return "Finaliser l'inscription";
                                        default:
                                            return "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E";
                                    }
                                }) : Gv(function(n) {
                                    switch(n){
                                        case 0:
                                            return "Weiter";
                                        case 1:
                                            return "Next";
                                        case 2:
                                            return "Continuar";
                                        case 3:
                                            return "Prochain";
                                        default:
                                            return "\u0414\u0430\u043B\u0435\u0435";
                                    }
                                })))
                            ]))), Hv(_([
                                A2(Gu, f, o)
                            ]))))
                        ]))
                    ]);
                }
                return w;
            },
            dt: function(n) {
                var r = n.bu, e = n.g1, t = n.iH, u = A2(su, A2(su, A2(su, A2(su, Ja, Re(co)), Ut(hf)), hi(lt)), be);
                return p(Vo(A2(Re, function(r) {
                    return se(A2(Il, _([
                        mb("form-field form-field--full-width")
                    ]), A2(se, El(p(A3(Zl, n.gy, "", Gv(function(n) {
                        switch(n){
                            case 0:
                                return "Teilnehmende Person ";
                            case 1:
                                return "Participant ";
                            case 2:
                                return "Persona participante ";
                            case 3:
                                return "Personne participante ";
                            default:
                                return "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A ";
                        }
                    })), Be(r + 1))), mf(n.dW) > 1 ? _([
                        A2(Ph, A2(ep, A2(nb, r, u(A2(Fi, r, n.dW))), Sb), A3(Zl, n.gy, "", Gv(function(n) {
                            switch(n){
                                case 0:
                                    return "entfernen";
                                case 1:
                                    return "remove";
                                case 2:
                                    return "eliminar";
                                case 3:
                                    return "supprimer";
                                default:
                                    return "\u0443\u0434\u0430\u043B\u0438\u0442\u044C";
                            }
                        })))
                    ]) : w)));
                }, e)), A3(Xi, !1, function(n) {
                    return 1 >= n;
                }, r.b) ? w : _([
                    A2(yb, _([
                        mb("form-field form-field--full-width"),
                        jb(_([
                            g("form-field--invalid", Wd(t))
                        ]))
                    ]), _([
                        A2(Ph, A2(Hm, A3(Xi, !1, Rd(mf(n.dW)), r.b), A2(ep, Yd(Fo(n.dW) ? Ja(_([
                            g(0, To),
                            g(1, To)
                        ])) : A3(Va, mf(n.dW), To, n.dW)), Sb)), A3(Zl, n.gy, "", Gv(function(n) {
                            switch(n){
                                case 0:
                                    return "Neue Person hinzuf\xfcgen";
                                case 1:
                                    return "Add participant";
                                case 2:
                                    return "A\xf1adir nuevo participante";
                                case 3:
                                    return "Ajouter une nouvelle personne";
                                default:
                                    return "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430";
                            }
                        })))
                    ])),
                    tg({
                        ag: n,
                        iH: t
                    })
                ]));
            },
            $9: function(n) {
                var r = !A2(tf, function(n) {
                    return !A2(pi, 0, n.fn);
                }, n.gy.cq), e = n.bC({
                    iE: n.eR
                });
                return A2(se, A2(_l, _([
                    mb("form-field form-field--full-width")
                ]), _([
                    El(A3(Zl, n.gy, "", Gv(function(n) {
                        switch(n){
                            case 0:
                                return "Zusammenfassung";
                            case 1:
                                return "Summary";
                            case 2:
                                return "Resumen";
                            case 3:
                                return "R\xe9capitulatif";
                            default:
                                return "\u041A\u0440\u0430\u0442\u043A\u043E\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435";
                        }
                    })))
                ])), p(e, function() {
                    if (r) {
                        var e = A2(mp, n.gy, n.dW.cg), t = A2(rf, n.gy, n.dW.cg), u = A3(Xi, g(fe, {
                            eV: 0,
                            fn: 0
                        }), Cv(oe), A3(lb, n.gy, n.dW.cg, n.gy.as)), c = u.a, a = u.b;
                        return _([
                            A3(Xi, El(""), function() {
                                return A2(yb, _([
                                    mb("total")
                                ]), _([
                                    A2(cl, w, _([
                                        El(A3(Zl, n.gy, "", Gv(function(n) {
                                            switch(n){
                                                case 0:
                                                    return "enthaltene MwSt. (vor Rabatt)";
                                                case 1:
                                                    return "tax (included before discount)";
                                                case 2:
                                                    return "IVA incluido (antes del descuento)";
                                                case 3:
                                                    return "TVA incluse (avant remise)";
                                                default:
                                                    return "\u0432\u043A\u043B\u044E\u0447\u0430\u044F \u041D\u0414\u0421 (\u0431\u0435\u0437 \u0443\u0447\u0435\u0442\u0430 \u0441\u043A\u0438\u0434\u043A\u0438)";
                                            }
                                        })))
                                    ])),
                                    A2(cl, w, _([
                                        El(e ? A2(Ev, n.gy.e, e) : A3(Zl, n.gy, "", Gv(function(n) {
                                            switch(n){
                                                case 0:
                                                    return "steuerfrei";
                                                case 1:
                                                    return "free of tax";
                                                case 2:
                                                    return "Libre de impuestos";
                                                case 3:
                                                    return "exon\xe9r\xe9 d'imp\xf4t";
                                                default:
                                                    return "\u043D\u0435 \u043E\u0431\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C";
                                            }
                                        })))
                                    ]))
                                ]));
                            }, c),
                            A3(Xi, El(""), function() {
                                return A2(yb, _([
                                    mb("total")
                                ]), _([
                                    A2(cl, w, _([
                                        El(A3(Zl, n.gy, "", Gv(function(n) {
                                            switch(n){
                                                case 0:
                                                    return "Gesamtsumme (vor Rabatt)";
                                                case 1:
                                                    return "Price (total before discount)";
                                                case 2:
                                                    return "Importe (total antes del descuento)";
                                                case 3:
                                                    return "Montant total (avant remise)";
                                                default:
                                                    return "\u0426\u0435\u043D\u0430 (\u043E\u0431\u0449\u0430\u044F \u0431\u0435\u0437 \u0443\u0447\u0435\u0442\u0430 \u0441\u043A\u0438\u0434\u043A\u0438)";
                                            }
                                        })))
                                    ])),
                                    A2(cl, w, _([
                                        El(t ? A2(Ev, n.gy.e, t) : A3(Zl, n.gy, "", Gv(function(n) {
                                            switch(n){
                                                case 0:
                                                    return "kostenfrei";
                                                case 1:
                                                    return "free of cost";
                                                case 2:
                                                    return "gratis";
                                                case 3:
                                                    return "gratuit";
                                                default:
                                                    return "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E";
                                            }
                                        })))
                                    ]))
                                ]));
                            }, c),
                            A3(Xi, El(""), function(r) {
                                return A2(yb, _([
                                    mb("total")
                                ]), _([
                                    A2(cl, w, _([
                                        El(A3(Zl, n.gy, "", Gv(function(n) {
                                            switch(n){
                                                case 0:
                                                    return "Rabatt";
                                                case 1:
                                                    return "Discount";
                                                case 2:
                                                    return "Descuento";
                                                case 3:
                                                    return "Remise";
                                                default:
                                                    return "\u0421\u043A\u0438\u0434\u043A\u0430";
                                            }
                                        }))),
                                        El(" ("),
                                        El(A3(Zl, n.gy, "", r.a9)),
                                        El(")")
                                    ])),
                                    A2(cl, w, _([
                                        El(A2(Ev, n.gy.e, -a.fn))
                                    ]))
                                ]));
                            }, c),
                            A2(yb, _([
                                mb("total")
                            ]), _([
                                A2(cl, w, _([
                                    El(A3(Zl, n.gy, "", Gv(function(n) {
                                        switch(n){
                                            case 0:
                                                return "enthaltene MwSt.";
                                            case 1:
                                                return "tax (included)";
                                            case 2:
                                                return "IVA incluido";
                                            case 3:
                                                return "TVA incluse";
                                            default:
                                                return "\u0432\u043A\u043B\u044E\u0447\u0430\u044F \u041D\u0414\u0421";
                                        }
                                    })))
                                ])),
                                A2(cl, w, _([
                                    El(e ? A2(Ev, n.gy.e, e - a.eV) : A3(Zl, n.gy, "", Gv(function(n) {
                                        switch(n){
                                            case 0:
                                                return "steuerfrei";
                                            case 1:
                                                return "free of tax";
                                            case 2:
                                                return "libre de impuestos";
                                            case 3:
                                                return "exon\xe9r\xe9 d'imp\xf4t";
                                            default:
                                                return "\u043D\u0435 \u043E\u0431\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C";
                                        }
                                    })))
                                ]))
                            ])),
                            A2(yb, _([
                                mb("total")
                            ]), _([
                                A2(cl, w, _([
                                    El(A3(Zl, n.gy, "", Gv(function(n) {
                                        switch(n){
                                            case 0:
                                                return "Gesamtsumme";
                                            case 1:
                                                return "Price (total)";
                                            case 2:
                                                return "Importe (total)";
                                            case 3:
                                                return "Montant total";
                                            default:
                                                return "\u0426\u0435\u043D\u0430 (\u043E\u0431\u0449\u0430\u044F)";
                                        }
                                    })))
                                ])),
                                A2(cl, w, _([
                                    El(t ? A2(Ev, n.gy.e, t - a.fn) : A3(Zl, n.gy, "", Gv(function(n) {
                                        switch(n){
                                            case 0:
                                                return "kostenfrei";
                                            case 1:
                                                return "free of cost";
                                            case 2:
                                                return "gratis";
                                            case 3:
                                                return "gratuit";
                                            default:
                                                return "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E";
                                        }
                                    })))
                                ]))
                            ]))
                        ]);
                    }
                    return w;
                }()));
            },
            iy: n
        };
    }, Jx = So(Wd), Xx = function(n) {
        return Pe(n.b) + 1;
    }, Zx = oe(Na), Yx = F3(function(n, r, e) {
        var t = Be(n.eR) + "-" + Be(e);
        return A2(yb, _([
            jb(_([
                g("form-field--checkbox", !0),
                g("form-field--full-width", !0),
                g("form-field--invalid", r.a8),
                g("form-field", !0),
                g("ticket", !0)
            ])),
            rv(Zx)
        ]), _([
            A2(yb, _([
                mb("ticket__title")
            ]), _([
                A2(av, A2(tp, Zx, A2(Jm, oe(p(A3(Zl, n.gy, "", r.fd), r.fz ? "*" : "")), Qb)), _([
                    r.cc ? Mb(A2(Ym, Zx, A2(ip, oe(r.aG ? 1 : 0), A2(jm, _([
                        ug(t)
                    ]), Nb)))) : Fm(A2(np, Zx, A2(Qm, r.aG, A2(Sm, _([
                        ug(t)
                    ]), Ub))))
                ]))
            ]))
        ]));
    }), nA = function(n) {
        return So(A2(Xi, !1, function(r) {
            return A3(Xi, !1, function(n) {
                return n > 0;
            }, A2(zi, n, r));
        }));
    }, rA = F2(function(n, r) {
        return $(r, {
            I: n
        });
    }), eA = F2(function(n, r) {
        return $(r, {
            I: n
        });
    }), tA = function(n) {
        return A2(su, A2(su, At, oe), So(A2(Xi, Na, Fi(n))));
    }, uA = function(n) {
        return A2(su, A2(su, At, oe), So(A2(Xi, A2(Id, n, 1), A2(Va, n, 1))));
    }, cA = F2(function(n, r) {
        return A2(A2(nA, n, r) ? tA : uA, n, r);
    }), aA = F4(function(n, r, e, t) {
        var u, c = t.fP, a = A2(ui, t.fP, A2(pi, w, A2(Gu, Bo, A2(Tu, zi(n.bD), A2(Tu, function(n) {
            return n.eH;
        }, n.gy.eb))))), i = r.aG, o = Be(n.eR) + "-" + Be(e), f = t.a8, s = Pe(A2(ni, ct(c), 1 === (u = n.ct).$ ? w : u.a.$ ? A2(Jo, function(n) {
            return Vo(Xo(n.cq));
        }, Xo(u.a.a.dt)) : Vo(Xo(u.a.a.cq)))), d = A3(Xi, !1, function(n) {
            return 0 >= n.dC - s;
        }, t.dA), b = !i && (d || f), l = !i && a ? A2(pi, !1, A2(Gu, function(n) {
            return 0 >= n - s;
        }, A2(Gu, function(n) {
            return n.dC;
        }, t.dA))) ? oe("Das Kontingent f\xfcr Ihre kostenfreien Tickets ist ersch\xf6pft.") : fe : !i && d ? oe(A3(Zl, n.gy, "", Gv(function(n) {
            switch(n){
                case 0:
                    return "ausgebucht";
                case 1:
                    return "sold out";
                case 2:
                    return "completo";
                case 3:
                    return "complet";
                default:
                    return "\u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0445 \u043C\u0435\u0441\u0442 \u043D\u0435\u0442";
            }
        }))) : fe;
        return A2(ch, function() {
            return A2(cA, c, r.cc ? n.dW : Zx);
        }, A2(tv, _([
            jb(_([
                g("form-field--checkbox", !0),
                g("form-field--full-width", !0),
                g("form-field--invalid", r.a8),
                g("form-field", !0),
                g("ticket", !0),
                g("ticket--disabled", b)
            ]))
        ]), _([
            A2(yb, _([
                mb("ticket__label")
            ]), _([
                A2(yb, _([
                    mb("ticket__native-control")
                ]), _([
                    r.cc ? Mb(A2(rA, b, A2(Ym, 0, A2(ip, oe(r.aG ? 1 : 0), A2(jm, _([
                        ug(o)
                    ]), Nb))))) : Fm(A2(eA, b, A2(np, 0, A2(Qm, r.aG, A2(Sm, _([
                        ug(o)
                    ]), Ub)))))
                ])),
                A2(yb, _([
                    mb("ticket__title")
                ]), _([
                    El(p(A3(Zl, n.gy, "", t.a9), r.fz ? "*" : ""))
                ])),
                A3(Xi, El(""), function(r) {
                    return A2(yb, _([
                        mb("ticket__price")
                    ]), _([
                        A2(cl, w, _([
                            El(!r && t.eG ? "kostenfrei" : A2(Ev, n.gy.e, r))
                        ]))
                    ]));
                }, t.fn)
            ])),
            A2(yb, _([
                mb("ticket__description")
            ]), _([
                El(A2(pi, "", A2(Tu, Xl(n.gy), t.er)))
            ])),
            function() {
                if (l.$) return El("");
                var n = l.a;
                return A2(yb, _([
                    mb("ticket__error")
                ]), _([
                    El(n)
                ]));
            }()
        ])));
    }), iA = function(n) {
        var r = n.fz, e = n.cc, t = n.iH, u = function(r) {
            var e = A2(Gu, Xx, A2(Tu, ci, A2(Gu, ni(ct(r.fP)), A2(Tu, zi(n.bD), A2(Gu, $d(function() {
                return Bo;
            }), A2(Tu, function(n) {
                return n.eH;
            }, n.gy.eb))))));
            return e.$ ? r : $(r, {
                dA: oe({
                    dC: e.a
                })
            });
        }, c = function(r) {
            return A2(nA, r, n.dW);
        }, a = Wd(t), i = A2(Ut, u, A2(ni, function(n) {
            return !n.a8 || c(n.fP);
        }, n.gj));
        return p(A2(Re, F2(function(t, u) {
            return A2(ch, Yd, A4(aA, n, {
                aG: c(u.fP),
                a8: a,
                cc: e,
                fz: r
            }, t, u));
        }), i), p(r ? w : _([
            A2(ch, Yd, A3(Yx, n, {
                aG: Jx(n.dW) && Ro(No(n.dW)),
                a8: a,
                cc: e,
                fd: n.fd,
                fz: r
            }, Pe(i)))
        ]), _([
            tg({
                ag: n,
                iH: t
            })
        ])));
    }, oA = function(n) {
        return n.$ ? Vi(n.a) : St(n.a);
    }, fA = $u(Gs), sA = yc(_([
        A2(uu, "selectPages", A2(kt, Dd, A2(uu, "cursors", ei(fA)))),
        A2(uu, "allPages", It(Ad))
    ])), dA = A2(kt, At, oi(Za(xf))), bA = A2(kt, At, Za(dA)), lA = A3(_t, F2(function(n, r) {
        return {
            a4: r,
            cq: n
        };
    }), A2(uu, "tickets", Za(dA)), A2(uu, "fields", Za(Qf))), vA = function() {
        var n = A2(uu, "tickets", Za(dA)), r = A2(uu, "persons", ad(lA)), e = yc(_([
            A2(uu, "globalTickets", bA),
            It(kd)
        ])), t = A2(uu, "fields", Za(Qf));
        return yc(_([
            A5(Jd, F4(function(n, r, e, t) {
                return {
                    a4: n,
                    g8: t,
                    dt: r,
                    cq: e
                };
            }), t, r, n, e),
            A4(Ls, F3(function(n, r, e) {
                return {
                    a4: n,
                    g8: e,
                    dt: r,
                    cq: Na
                };
            }), t, r, e),
            A4(Ls, F3(function(n, r, e) {
                return {
                    a4: n,
                    g8: e,
                    dt: Na,
                    cq: r
                };
            }), t, n, e)
        ]));
    }(), gA = A4(Ls, F3(function(n, r, e) {
        return {
            bl: n,
            cg: r,
            cm: e
        };
    }), A2(uu, "cursor", fA), A2(uu, "orderInput", vA), A2(uu, "showErrors", sA)), hA = F2(function(n, r) {
        var e = A3(Xi, A2(Md, vo, A2(sd, n.m, {
            eb: n.eb
        })), function(n) {
            return A2(Md, bo, oA(A2(di, ei(Es), n)));
        }, n.cq), t = A3(Xi, A2(Md, vo, A2(du, function(n) {
            return 3 === n.$ && 404 === n.a ? St(w) : Vi(n);
        }, A2(Yi, n.m, {
            a1: A2(uu, "values", ei(Rs)),
            q: "/public/pages.json"
        }))), function(n) {
            return A2(Md, bo, oA(A2(di, ei(Rs), n)));
        }, n.C), u = F2(function(r, e) {
            return A2(Md, vo, A2(od, n.m, e));
        }), c = F2(function(r, e) {
            return A3(Xi, function() {
                if (r.$) return St(fe);
                var n, t = r.a;
                return St(oe((n = A2(xd, qd(e), t), {
                    bl: Bd,
                    cg: n,
                    cm: Ad
                })));
            }(), function(n) {
                return A2(Md, bo, A2(Vt, oe, oA(A2(di, A2(kt, pi(Ld), oi(gA)), n))));
            }, n.dW);
        }), a = A3(Xi, A2(Md, vo, A2(du, function(n) {
            return 3 === n.$ && 404 === n.a ? St(w) : Vi(n);
        }, A2(Yi, n.m, {
            a1: ei(Lf),
            q: "/public/discounts.json"
        }))), function(n) {
            return A2(Md, bo, oA(A2(di, ei(Lf), n)));
        }, n.as), i = F2(function(r, e) {
            return A3(Xi, St(ye(fe)), function(r) {
                return A2(Vt, Qu(oe), A2(Md, vo, A2(Zd, n.m, {
                    eb: r
                })));
            }, r.$ ? e.$ ? n.eb : oe(e.a) : r.a.a.eb);
        });
        return g($o, A2(eu, go, A2(du, function(n) {
            return St(g(fo({
                gQ: cu(0),
                cT: n,
                e: cu(0)
            }), Nd));
        }, A2(Ht, function(t) {
            var u = t.ba, o = t.C, f = t.aE;
            return A2(Vt, function(t) {
                var i, s = t.ed, d = t.aS, b = t.fa, l = zd(d.hE), v = u.$ ? A3(Xi, l, au, n.e) : u.a.a.e;
                return A2(pi, g($o, A2(eu, go, A2(du, function(n) {
                    return St(g(fo({
                        gQ: l,
                        cT: n,
                        e: v
                    }), Nd));
                }, A4(Ed, F3(function(e, t, c) {
                    if (1 === s.$) return g(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }({
                        eb: a = s.a,
                        gQ: l,
                        e: v
                    }), Nd);
                    var a = s.a, i = {
                        m: A2(Qd, n.m, A2(Tu, hf, r)),
                        eb: a,
                        ai: 1 === u.$ ? d.ai : A3(Xi, d.ai, function(n) {
                            return n.iF;
                        }, f),
                        gQ: l,
                        ar: fe,
                        as: t,
                        am: Ms,
                        cW: n,
                        t: A2(pi, Ld, c),
                        an: n.an,
                        e: v,
                        ba: u,
                        by: !1,
                        aN: Mt(n.aN),
                        C: o,
                        aS: d,
                        cq: e,
                        cw: Wd(c),
                        fX: A2(Gu, lt, r),
                        aE: f,
                        aF: n.aF
                    };
                    return g(ho($(i, {
                        t: (Wd(u) ? function(n) {
                            var r = A3(wf, Cd(o), A4(Pd, vd(i), n, Vx(iA), function() {
                                return w;
                            }), o), e = Nu(A2(Ou, function(n) {
                                var r = n.gI;
                                return A2(ti, function(n) {
                                    return 8 === n.b.$;
                                }, ld(n.hX)) ? oe(r.gD) : fe;
                            }, r));
                            return e.$ ? n : $(n, {
                                bl: e.a
                            });
                        } : At)(i.t)
                    })), Td(Ys(i.t)));
                }), e, a, A2(c, u, o))))), Nu(Hv(_([
                    (i = n.c7, !i.$ && i.a ? oe(g($o, Nd)) : fe),
                    A2(Gu, function(n) {
                        return g(fo({
                            gQ: l,
                            cT: so(n),
                            e: v
                        }), Nd);
                    }, n.cJ),
                    A2(Gu, function(n) {
                        var r = A2(di, $u(Ko), n);
                        if (r.$) return g(fo({
                            gQ: l,
                            cT: bo(r.a),
                            e: v
                        }), Nd);
                        var e = r.a;
                        return g(mo({
                            aH: e,
                            gQ: l,
                            e: v
                        }), jd(A2(mu, Ko, e)));
                    }, n.aH),
                    A2(Gu, function(r) {
                        return g($o, A2(eu, go, A2(du, function(n) {
                            return St(g(fo({
                                gQ: l,
                                cT: n,
                                e: v
                            }), Nd));
                        }, A2(Md, vo, A2(Vt, function() {
                            return g(lo({
                                ai: d.ai,
                                gQ: l,
                                an: r,
                                e: v
                            }), Nd);
                        }, A2(fd, n.m, {
                            eR: r
                        }))))));
                    }, n.eR),
                    A2(Tu, function(n) {
                        return A3(Od, 1 === s.$ ? oe(0) : 1 === s.a.$ ? fe : oe(0), b, n) ? oe(g(function(n) {
                            return {
                                $: 6,
                                a: n
                            };
                        }({
                            bU: d.bU,
                            gQ: l,
                            e: v
                        }), Nd)) : fe;
                    }, d.gt)
                ]))));
            }, A4(Ed, F3(function(n, r, e) {
                return {
                    ed: e,
                    fa: n,
                    aS: r
                };
            }), Gd, A2(Md, vo, no(n.m)), A2(i, u, n.ez)));
        }, A2(Ht, function(n) {
            var e, t = n.a, c = n.b;
            return A2(Vt, function(n) {
                return {
                    ba: n,
                    C: t,
                    aE: c
                };
            }, (e = g(c, A2(Gu, lt, r))).a.$ || e.b.$ ? St(fe) : A2(u, t, e.b.a));
        }, A3(Jt, co, t, A2(Md, vo, to(n.m))))))));
    }), $A = function(n) {
        return A3(oo, {
            m: n.m,
            e: A2(Gu, au, n.e),
            hI: n.ez,
            h7: n.aN
        }, hA, n);
    }, mA = function(n) {
        return {
            $: 4,
            a: n
        };
    }, pA = Sn, wA = jn, yA = wA(w), kA = F2(function(n, r) {
        var e = r.c;
        return 4 === e.$ ? A2(pA, mA, n(e.a)) : yA;
    }), _A = function(n) {
        return {
            $: 5,
            a: n
        };
    }, IA = function(n) {
        return {
            $: 2,
            a: n
        };
    }, xA = function(n) {
        return {
            $: 0,
            a: n
        };
    }, AA = function(n) {
        return {
            $: 4,
            a: n
        };
    }, BA = function(n) {
        return {
            $: 6,
            a: n
        };
    }, CA = Yn("setDiscounts", bi), qA = Yn("setLocale", dc), zA = Yn("setPages", bi), DA = Yn("setTickets", bi), PA = Yn("setWidth", yc(_([
        ii(fe),
        A2(kt, oe, xf)
    ]))), KA = kA(function() {
        return wA(_([
            zA(A2(su, xA, di(ei(Rs)))),
            qA(A2(su, A2(su, IA, ye), au)),
            DA(A2(su, AA, di(ei(Es)))),
            CA(A2(su, _A, di(ei(Lf)))),
            PA(BA)
        ]));
    }), LA = function(n) {
        return {
            $: 2,
            a: n
        };
    }, TA = function(n) {
        return {
            $: 4,
            a: n
        };
    }, RA = function(n) {
        return {
            $: 1,
            a: n
        };
    }, FA = function(n) {
        return {
            $: 3,
            a: n
        };
    }, OA = F2(function(n, r) {
        return {
            gA: n,
            gB: r
        };
    }), WA = F2(function(n, r) {
        var e = r.q, t = r.a1;
        return A2(Zi, n, {
            o: oe(r.o),
            a1: t,
            y: "POST",
            q: e
        });
    }), EA = F4(function(n, r, e, t) {
        return A2(WA, n, {
            o: vu(_([
                g("emailAddress", bc(t)),
                g("exhibitor", A3(Xi, Ku, bc, e)),
                g("referringUrl", bc(r))
            ])),
            a1: yc(_([
                A2(kt, oe, A3(_t, co, A2(uu, "user", ao), A2(uu, "maybeCookie", yc(_([
                    A2(kt, oe, A3(_t, OA, A2(uu, "cookieName", dc), A2(uu, "cookieValue", dc))),
                    It(fe)
                ]))))),
                It(fe)
            ])),
            q: "/public/user-account/login"
        });
    }), MA = Sn, jA = F3(function(n, r, e) {
        var t = e.a, u = e.b, c = g(r, e.c);
        n: for(;;){
            r: for(;;)switch(c.a.$){
                case 1:
                    return g(1 === c.b.$ ? A3(ou, t, u, RA($(o = c.b.a, {
                        ak: c.a.a
                    }))) : e, Nd);
                case 2:
                    if (1 === c.b.$) {
                        var a = F_((o = c.b.a).ak);
                        return g(A3(ou, t, u, RA($(o, {
                            c7: !0
                        }))), A2(bu, FA, A4(EA, fe, t.h7, t.hI, a)));
                    }
                    return g(e, Nd);
                case 3:
                    if (c.a.a.$) {
                        if (1 === c.b.$) return g(A3(ou, t, u, RA($(o = c.b.a, {
                            cT: oe(c.a.a.a)
                        }))), Nd);
                        break n;
                    }
                    if (c.a.a.a.$) {
                        if (1 === c.b.$) return g(A3(ou, t, u, LA({
                            ak: (o = c.b.a).ak,
                            aS: o.aS
                        })), Nd);
                        break n;
                    }
                    if (1 === c.b.$) {
                        var i = c.a.a.a.a, o = c.b.a;
                        return A2(su, wd(MA(mA)), Cv(A2(su, A2(ou, t, u), TA)))(u(oe(i)));
                    }
                    break n;
                case 4:
                    if (4 === c.b.$) {
                        var f = c.a.a, s = c.b.a;
                        return A2(su, wd(MA(mA)), Cv(A2(su, A2(ou, t, u), TA)))(A2(n, f, s));
                    }
                    return f = c.a.a, g(e, Nd);
                default:
                    if (c.a.a.$) {
                        if (c.b.$) break r;
                        return g(e, Nd);
                    }
                    if (c.a.a.a.$) {
                        if (1 === c.a.a.a.a.$) {
                            if (c.b.$) break r;
                            return A2(su, wd(MA(mA)), Cv(A2(su, A2(ou, t, u), TA)))(u(fe));
                        }
                        if (c.b.$) break r;
                        var d = c.a.a.a.a.a;
                        return g(A3(ou, t, u, RA({
                            ak: "",
                            cT: fe,
                            c7: !1,
                            aS: d.a,
                            aE: d.b
                        })), Nd);
                    }
                    if (c.b.$) break r;
                    var b = c.a.a.a.a;
                    return A2(su, wd(MA(mA)), Cv(A2(su, A2(ou, t, u), TA)))(u(oe(g(b, fe))));
            }
            return g(e, Nd);
        }
        return g(e, Nd);
    }), SA = function(n) {
        return {
            $: 0,
            a: n
        };
    }, NA = function(n) {
        return {
            $: 9,
            a: n
        };
    }, GA = function(n) {
        return {
            $: 3,
            a: n
        };
    }, QA = F3(function(n, r, e) {
        return {
            $: 8,
            a: n,
            b: r,
            c: e
        };
    }), UA = function(n) {
        return n.$ ? n : function(n) {
            return {
                $: 1,
                a: n
            };
        }(n.a);
    }, HA = xo(bc), VA = function(n) {
        return vu(_([
            g("tickets", A3(Us, At, HA, n.cq)),
            g("fields", A3(Us, At, Xs, n.a4))
        ]));
    }, JA = function(n) {
        var r;
        return vu(_(n.$ ? [
            g("persons", A3(Us, Be, VA, (r = n.a).dt)),
            g("fields", A3(Us, At, Xs, r.a4)),
            g("code", A3(Xi, Ku, bc, r.eb)),
            g("locale", yo(r.e)),
            g("discount", A3(Xi, Ku, bc, r.aj))
        ] : [
            g("fields", A3(Us, At, Xs, (r = n.a).a4)),
            g("tickets", A3(Us, At, HA, r.cq)),
            g("code", A3(Xi, Ku, bc, r.eb)),
            g("locale", yo(r.e)),
            g("discount", A3(Xi, Ku, bc, r.aj))
        ]));
    }, XA = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ZA = function(n) {
        return {
            $: 1,
            a: n
        };
    }, YA = function(n) {
        return {
            $: 2,
            a: n
        };
    }, nB = F5(function(n, r, e, t, u) {
        return {
            d5: n,
            ea: r,
            et: e,
            e: u,
            fI: t
        };
    }), rB = gu(A4($c, "locale", function(n) {
        return n.e;
    }, ko, A4($c, "shopperResultUrl", function(n) {
        return n.fI;
    }, Po, A4($c, "endpoint", function(n) {
        return n.et;
    }, Po, A4($c, "checkoutId", function(n) {
        return n.ea;
    }, lc, A4($c, "brands", function(n) {
        return n.d5;
    }, Co(lc), mc(nB))))))), eB = A2(kt, function(n) {
        return {
            cT: n
        };
    }, yc(_([
        A2(uu, "error", dc),
        A2(uu, "error", A2(uu, "message", dc))
    ]))), tB = gu(A4($c, "transactionId", function(n) {
        return n.eR;
    }, lc, mc(function(n) {
        return {
            eR: n
        };
    }))), uB = yc(_([
        A2(kt, XA, $u(rB)),
        A2(kt, ZA, eB),
        A2(kt, YA, $u(tB))
    ])), cB = F5(function(n, r, e, t, u) {
        return A2(WA, n, {
            o: JA(r),
            a1: uB,
            q: "/public/payment/prepare?id=" + e + "&frontendPrice=" + (Be(t) + A3(Xi, "", A2(su, A2(su, xe("&referringUrl="), Hk), Do), u))
        });
    }), aB = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), iB = F3(function(n, r, e) {
        if (n.b.b) {
            if ("persons" === n.a && n.b.b.b && !n.b.b.b.b) {
                var t = n.b, u = t.b.a, c = Tt(t.a);
                return 1 === c.$ ? e : $(e, {
                    dt: A3(Oi, c.a, A2(su, A2(su, oe, function(n) {
                        return $(n, {
                            a4: A2(r, u, n.a4)
                        });
                    }), pi(To)), e.dt)
                });
            }
            return e;
        }
        return $(e, {
            a4: A2(r, u = n.a, e.a4)
        });
    }), oB = F5(function(n, r, e, t, u) {
        var a = t;
        return c(A2(Gu, function(n) {
            return n.a;
        }, A2(zi, n, a)), oe(r)) ? g(A3(Va, n, A2(aB, r, e), a), $(u, {
            cg: A3(iB, n, Fi, u.cg)
        })) : g(a, u);
    }), fB = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), sB = F5(function(n, r, e, t, u) {
        var c = n.hH, a = t;
        return g(f(e.dI, c) > 0 ? A3(Va, r, A2(fB, e, c), a) : A3(Va, r, function(n) {
            return {
                $: 0,
                a: n
            };
        }(e), a), $(u, {
            cg: A3(iB, r, Fi, u.cg)
        }));
    }), dB = F5(function(n, r, e, t, u) {
        var a = t;
        return c(A2(Gu, function(n) {
            return n.a;
        }, A2(zi, n, a)), oe(r)) ? g(A2(Fi, n, a), $(u, {
            cg: A3(iB, n, F2(function(n, r) {
                return A3(Va, n, Sf(e), r);
            }), u.cg)
        })) : g(a, u);
    }), bB = Jn("navigated", function() {
        return Ku;
    }), lB = Jn("submit", At), vB = F2(function(n, r) {
        return n(r);
    }), gB = function(n) {
        return n.$ ? oe(n.a) : fe;
    }, hB = F3(function(n, r, e) {
        for(;;){
            var t = $(e, {
                iC: A2(Tu, A2(su, gB, function(n) {
                    return n.bo;
                }), n),
                ct: A2(Gu, function(n) {
                    return n.ct;
                }, n)
            }), u = A2(vB, r, t), a = {
                bo: u.bo,
                ct: u.ct
            };
            if (c(oe(a), n)) return g(u, t);
            n = oe(a), e = t;
        }
    }), $B = F2(function(n, r) {
        return A3(hB, fe, n, r);
    }), mB = function(n) {
        return A2(Ce, " ", A2(Ou, Qv, A2(Ou, function(r) {
            return Nu(Hv(A2(Ut, function(r) {
                return A2(zi, r, n.a4);
            }, r)));
        }, _([
            _([
                "Anrede",
                "Title"
            ]),
            _([
                "Titel",
                "Official title"
            ]),
            _([
                "Vorname",
                "First name"
            ]),
            _([
                "Nachname",
                "Last name"
            ])
        ]))));
    }, pB = F4(function(n, r, e, t) {
        var u, a, i, o = A4(Pd, r, e, (u = n, {
            gr: function() {
                return w;
            },
            gF: function() {
                return w;
            },
            gG: function() {
                return w;
            },
            hb: function() {
                return w;
            },
            hs: function(n) {
                var r = n.gy, e = n.ht, t = n.hv;
                return _([
                    A2(Pl, w, _([
                        A2(yb, w, function() {
                            switch(t.$){
                                case 0:
                                    var u = t.a, c = A3(Zl, n.gy, "", A2(pi, !1, hp(n.dW)) ? Gv(function(n) {
                                        switch(n){
                                            case 0:
                                                return "ja";
                                            case 1:
                                                return "yes";
                                            case 2:
                                                return "s\xed";
                                            case 3:
                                                return "oui";
                                            default:
                                                return "\u0434\u0430";
                                        }
                                    }) : Gv(function(n) {
                                        switch(n){
                                            case 0:
                                                return "nein";
                                            case 1:
                                            case 2:
                                                return "no";
                                            case 3:
                                                return "non";
                                            default:
                                                return "\u043D\u0435\u0442";
                                        }
                                    }));
                                    return Vo(_([
                                        A2(Vl, A2(su, A2(su, A2(su, df, Kl(w)), df), El), Hx(A3(Zl, n.gy, "", u) + ":\xa0" + c))
                                    ]));
                                case 1:
                                    var a = t.b, i = (c = Qv(n.dW), A2(Gu, function(r) {
                                        return A3(Xi, r, function(n) {
                                            return n.a9;
                                        }, A2(jo, A2(su, ct(r), function(n) {
                                            return n.bK;
                                        }), A3(Zl, n.gy, w, A2(Vg, function() {
                                            return Bo;
                                        }, a))));
                                    }, c));
                                    return _([
                                        El(A3(Zl, n.gy, "", "$guestCodes" === A3(Zl, n.gy, "", e.a9) ? Gv(function(n) {
                                            return 1 === n ? "Number of guest codes" : "Anzahl G\xe4stecodes";
                                        }) : e.a9)),
                                        El(":\xa0"),
                                        El(A2(pi, "-", i))
                                    ]);
                                case 2:
                                    c = Qv(n.dW);
                                    var o = A2(Tu, function(n) {
                                        return Kt(n) ? fe : oe(n);
                                    }, A2(Gu, F_, c));
                                    return _([
                                        El(A3(Zl, n.gy, "", e.a9)),
                                        El(":\xa0"),
                                        El(A2(pi, "-", o))
                                    ]);
                                case 3:
                                    return c = Qv(n.dW), a = r.aS.h_({
                                        ey: w,
                                        eU: w
                                    }), i = A2(Gu, function(n) {
                                        return A3(Xi, n, A2(su, A2(Zl, r, ""), function(n) {
                                            return n.a9;
                                        }), A2(jo, A2(su, ct(n), function(n) {
                                            return n.bK;
                                        }), a));
                                    }, c), _([
                                        El(A3(Zl, n.gy, "", e.a9)),
                                        El(":\xa0"),
                                        El(A2(pi, "-", i))
                                    ]);
                                default:
                                    return i = A2(Gu, Zg, Qv(n.dW)), _([
                                        El(A3(Zl, n.gy, "", e.a9)),
                                        El(":\xa0"),
                                        El(A2(pi, "-", i))
                                    ]);
                            }
                        }())
                    ]))
                ]);
            },
            hF: (a = function(n) {
                return A2(Tx, F2(function(r, e) {
                    n: for(; 4 === r.$;)switch(r.a){
                        case 1:
                            var t = r.b;
                            return p(e, _([
                                Gp(_(n ? [
                                    xp(t)
                                ] : [
                                    Vp(t)
                                ]))
                            ]));
                        case 2:
                            return t = r.b, p(e, _([
                                Gp(n ? w : _([
                                    xp(t)
                                ]))
                            ]));
                        default:
                            break n;
                    }
                    return e;
                }), w);
            }, i = F2(function(n, r) {
                return $(r, {
                    g2: a(n)
                });
            }), function(n) {
                var r = n.ic;
                return A2(Vl, A2(su, A2(su, A2(su, df, Kl(w)), df), El), A2(Ux, A2(i, n.bc, Hl), A3(Zl, n.gy, "", r)));
            }),
            hK: function() {
                return w;
            },
            hX: function(n) {
                var r = n.g0;
                return n.bc && c(n.gD.gF, u) ? r : w;
            },
            dt: function(n) {
                return Vo(A2(Re, function(r) {
                    return se(A2(Pl, w, _([
                        A2(yl, w, _([
                            El(p(A3(Zl, n.gy, "", Gv(function(n) {
                                switch(n){
                                    case 0:
                                        return "Teilnehmende Person ";
                                    case 1:
                                        return "Participant ";
                                    case 2:
                                        return "Persona participante ";
                                    case 3:
                                        return "Personne participante ";
                                    default:
                                        return "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A ";
                                }
                            })), Be(r + 1)))
                        ]))
                    ])));
                }, n.g1));
            },
            $9: function(n) {
                if (!A2(tf, function(n) {
                    return !A2(pi, 0, n.fn);
                }, n.gy.cq)) {
                    var r = A2(mp, n.gy, n.dW.cg), e = A2(rf, n.gy, n.dW.cg), t = A3(Xi, g(fe, {
                        eV: 0,
                        fn: 0
                    }), Cv(oe), A3(lb, n.gy, n.dW.cg, n.gy.as)), u = t.a, c = t.b;
                    return _([
                        A3(Xi, El(""), function() {
                            return A2(yb, w, _([
                                El(A3(Zl, n.gy, "", Gv(function(n) {
                                    switch(n){
                                        case 0:
                                            return "enthaltene MwSt. (vor Rabatt)";
                                        case 1:
                                            return "tax (included before discount)";
                                        case 2:
                                            return "IVA incluido (antes del descuento)";
                                        case 3:
                                            return "TVA incluse (avant remise)";
                                        default:
                                            return "\u0432\u043A\u043B\u044E\u0447\u0430\u044F \u041D\u0414\u0421 (\u0431\u0435\u0437 \u0443\u0447\u0435\u0442\u0430 \u0441\u043A\u0438\u0434\u043A\u0438)";
                                    }
                                }))),
                                El(": "),
                                El(r ? A2(Ev, n.gy.e, r) : A3(Zl, n.gy, "", Gv(function(n) {
                                    switch(n){
                                        case 0:
                                            return "steuerfrei";
                                        case 1:
                                            return "free of tax";
                                        case 2:
                                            return "libre de impuestos";
                                        case 3:
                                            return "exon\xe9r\xe9 d'imp\xf4t";
                                        default:
                                            return "\u043D\u0435 \u043E\u0431\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C";
                                    }
                                })))
                            ]));
                        }, u),
                        A3(Xi, El(""), function() {
                            return A2(yb, w, _([
                                El(A3(Zl, n.gy, "", Gv(function(n) {
                                    switch(n){
                                        case 0:
                                            return "Gesamtsumme (vor Rabatt)";
                                        case 1:
                                            return "Price (total before discount)";
                                        case 2:
                                            return "Importe (total antes del descuento)";
                                        case 3:
                                            return "Montant total (avant remise)";
                                        default:
                                            return "\u0426\u0435\u043D\u0430 (\u043E\u0431\u0449\u0430\u044F \u0431\u0435\u0437 \u0443\u0447\u0435\u0442\u0430 \u0441\u043A\u0438\u0434\u043A\u0438)";
                                    }
                                }))),
                                El(": "),
                                El(e ? A2(Ev, n.gy.e, e) : A3(Zl, n.gy, "", Gv(function(n) {
                                    switch(n){
                                        case 0:
                                            return "kostenfrei";
                                        case 1:
                                            return "free of cost";
                                        case 2:
                                            return "gratis";
                                        case 3:
                                            return "gratuit";
                                        default:
                                            return "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E";
                                    }
                                })))
                            ]));
                        }, u),
                        A3(Xi, El(""), function(r) {
                            return A2(yb, w, _([
                                El(A3(Zl, n.gy, "", Gv(function(n) {
                                    switch(n){
                                        case 0:
                                            return "Rabatt";
                                        case 1:
                                            return "Discount";
                                        case 2:
                                            return "Descuento";
                                        case 3:
                                            return "Remise";
                                        default:
                                            return "\u0421\u043A\u0438\u0434\u043A\u0430";
                                    }
                                }))),
                                El(" ("),
                                El(A3(Zl, n.gy, "", r.a9)),
                                El("): "),
                                El(A2(Ev, n.gy.e, -c.fn))
                            ]));
                        }, u),
                        A2(yb, w, _([
                            El(A3(Zl, n.gy, "", Gv(function(n) {
                                switch(n){
                                    case 0:
                                        return "enthaltene MwSt.";
                                    case 1:
                                        return "tax (included)";
                                    case 2:
                                        return "IVA incluido";
                                    case 3:
                                        return "TVA incluse";
                                    default:
                                        return "\u0432\u043A\u043B\u044E\u0447\u0430\u044F \u041D\u0414\u0421";
                                }
                            }))),
                            El(": "),
                            El(r ? A2(Ev, n.gy.e, r - c.eV) : A3(Zl, n.gy, "", Gv(function(n) {
                                switch(n){
                                    case 0:
                                        return "steuerfrei";
                                    case 1:
                                        return "free of tax";
                                    case 2:
                                        return "libre de impuestos";
                                    case 3:
                                        return "exon\xe9r\xe9 d'imp\xf4t";
                                    default:
                                        return "\u043D\u0435 \u043E\u0431\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C";
                                }
                            })))
                        ])),
                        A2(yb, w, _([
                            El(A3(Zl, n.gy, "", Gv(function(n) {
                                switch(n){
                                    case 0:
                                        return "Gesamtsumme";
                                    case 1:
                                        return "Price (total)";
                                    case 2:
                                        return "Importe (total)";
                                    case 3:
                                        return "Montant total";
                                    default:
                                        return "\u0426\u0435\u043D\u0430 (\u043E\u0431\u0449\u0430\u044F)";
                                }
                            }))),
                            El(": "),
                            El(e ? A2(Ev, n.gy.e, e - c.fn) : A3(Zl, n.gy, "", Gv(function(n) {
                                switch(n){
                                    case 0:
                                        return "kostenfrei";
                                    case 1:
                                        return "free of cost";
                                    case 2:
                                        return "gratis";
                                    case 3:
                                        return "gratuit";
                                    default:
                                        return "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E";
                                }
                            })))
                        ]))
                    ]);
                }
                return w;
            },
            iy: function(n) {
                var r = n.$8, e = A2(Ou, function(n) {
                    return A2(Gu, function(r) {
                        return g(r.b, n);
                    }, A2(jo, A2(su, ct(n.fP), lt), r));
                }, n.gy.cq);
                return e.b ? A2(Ut, function(r) {
                    var e = r.a, t = r.b;
                    return A2(yb, w, _([
                        El(Be(e) + "x\xa0" + A3(Zl, n.gy, "", t.a9)),
                        El("\xa0"),
                        A3(Xi, El(""), function(r) {
                            return El(!r && t.eG ? "kostenfrei" : (e > 1 ? xe("\xe1\xa0") : At)(A2(Ev, n.gy.e, r)));
                        }, t.fn)
                    ]));
                }, e) : _([
                    El(A3(Zl, n.gy, "", n.fd))
                ]);
            }
        }), function() {
            return w;
        }), f = A2($B, t, o).a;
        return p(_([
            A2(Pl, _([
                A2(il, "color", zu(r.aS.eh.dx))
            ]), _([
                A2(hb, w, _([
                    El(A3(Xi, "", mB, A2(zi, n, e.cg.dt)))
                ]))
            ]))
        ]), A2(Ut, ch(function() {
            return 0;
        }), f.iK));
    }), wB = function(n) {
        return nd({
            eb: n.eb,
            aj: n.aj,
            a4: Na,
            e: n.e,
            dt: Na
        });
    }, yB = function(n) {
        return rd({
            eb: n.eb,
            aj: n.aj,
            a4: Na,
            e: n.e,
            cq: Na
        });
    }, kB = F3(function(n, r, e) {
        return function(t) {
            var u = A2(Gu, lt, A3(lb, r, e.cg, r.as));
            return t((n ? wB : yB)({
                eb: A2(Gu, function(n) {
                    return n.eb;
                }, r.eb),
                aj: A2(Gu, function(n) {
                    return n.gS;
                }, u),
                e: r.e
            }));
        };
    }), _B = function(n) {
        return A2($d, function() {
            return Jo(function(n) {
                return A2(Dy, n.b, n.a);
            });
        }, A2($d, function() {
            return No;
        }, n));
    }, IB = F2(function(n, r) {
        var e = n.cg.g8;
        if (r.$) {
            var t = r.a;
            return nd($(t, {
                dt: A2($d, F2(function(n, r) {
                    return $(r, {
                        cq: A2(Qo, _B(e), r.cq)
                    });
                }), t.dt)
            }));
        }
        var u = r.a;
        return rd($(u, {
            cq: A2(Qo, _B(e), u.cq)
        }));
    }), xB = F2(function(n, r) {
        return g(n, A2(se, r.a, r.b));
    }), AB = F2(function(n, r) {
        return A2(su, A2(Qt, n, r), Bo);
    }), BB = F2(function(n, r) {
        return Bo(r).b ? A3(AB, xB, r, n) : n;
    }), CB = F2(function(n, r) {
        return function(e) {
            var t, u = 2 * e.eR, c = $(e, {
                eR: 2 * e.eR + 1
            }), a = A2(vB, r, c), i = $(e, {
                eR: u
            }), o = A2(vB, n, i);
            return {
                bo: (t = g(o.bo, a.bo), 1 === t.a.$ ? $e(1 === t.b.$ ? A2(BB, t.a.a, t.b.a) : t.a.a) : 1 === t.b.$ ? $e(t.b.a) : ye((0, t.b.a)(t.a.a))),
                ct: a.ct(o.ct),
                iK: p(o.iK, a.iK)
            };
        };
    }), qB = F2(function(n, r) {
        return function(e) {
            var t = A2(vB, r, e);
            return {
                bo: A2(Qu, n, t.bo),
                ct: n(t.ct),
                iK: t.iK
            };
        };
    }), zB = function(n) {
        return function() {
            return {
                bo: ye(n),
                ct: n,
                iK: w
            };
        };
    }, DB = function(n) {
        if (n.b) {
            var r = n.a, e = n.b;
            return A3(De, F2(function(n, r) {
                return A2(CB, r, A2(CB, n, zB(se)));
            }), A2(qB, df, r), e);
        }
        return zB(w);
    }, PB = function(n) {
        return jf(_([
            g("name", Sf(n.de)),
            g("size", Mf(n.dI)),
            g("type", Sf(n.cv)),
            g("lastModified", Mf(n.c5)),
            g("dataURL", Sf(n.cM))
        ]));
    }, KB = A2(Cc, function(n) {
        return 1 > qt(n) ? Qc("Domain has to be atleast 1 character long.") : Hc(n);
    }, Sc(A2(na, Hc(0), Ec(function(n) {
        return (je(n) || "-" === n) && "@" !== n && "." !== n;
    })))), LB = A2(Cc, function(n) {
        return A2(Et, ".", n) || A2(pw, ".", n) || !c(A2(Pt, "..", n), w) ? Qc("localPart can't start or end with a dot, nor can there be double dots") : c(F_(n), n) ? Hc(n) : Qc("localPart can't be wrapped with whitespace");
    }, Sc(A2(na, Hc(0), Ec(function(n) {
        return "+" !== n && "@" !== n && "\\" !== n && '"' !== n;
    })))), TB = A2(Cc, function(n) {
        return 2 > qt(n) ? Qc("Tld needs to be at least 2 character long.") : Hc(n);
    }, Sc(A2(na, Hc(0), Ec(function(n) {
        return We(n) || Oe(n) || "-" === n;
    })))), RB = (Px = F2(function(n, r) {
        return A2(pa, w, function(e) {
            return aa(_([
                A2(ea, A2(na, Hc(function(n) {
                    return oa(A2(se, n, e));
                }), Ba(ku(n))), r),
                A2(ga, function() {
                    return ia(Se(e));
                }, Hc(0))
            ]));
        });
    }), A2(ea, A2(ea, A2(ea, A2(ea, Hc(F4(function(n, r, e, t) {
        var u = A2(Ce, "", _([
            n,
            r.b ? "+" + A2(Ce, "+", r) : ""
        ]));
        return qt(u) > 64 || 1 > Pe(t) ? fe : oe({
            cQ: e,
            c8: n,
            dP: r,
            dS: t
        });
    })), LB), A2(na, A2(Px, "+", LB), Ba("@"))), KB), A2(na, A2(Px, ".", TB), Tc))), FB = F6(function(n, r, e, t, u, c) {
        return 1 === r.$ || 1 === e.$ || 1 === t.$ || 1 === u.$ || 1 === c.$ ? fe : oe(A5(n, r.a, e.a, t.a, u.a, c.a));
    }), OB = function(n) {
        if (4 === n.$) {
            var r = n.a, e = at(r);
            return r - e ? fe : oe(e);
        }
        return fe;
    }, WB = function(n) {
        if (n.$) return fe;
        var r = n.a;
        return A6(FB, Zb, A2(Tu, A2(su, Qv, hf), A2(jo, A2(su, ct("name"), lt), r)), A2(Tu, A2(su, OB, hf), A2(jo, A2(su, ct("size"), lt), r)), A2(Tu, A2(su, Qv, hf), A2(jo, A2(su, ct("type"), lt), r)), A2(Tu, A2(su, A2(su, Gu(Jc), OB), hf), A2(jo, A2(su, ct("lastModified"), lt), r)), A2(Tu, A2(su, Qv, hf), A2(jo, A2(su, ct("dataURL"), lt), r)));
    }, EB = F4(function(n, r, e, t) {
        var u = e.fz;
        switch(r.$){
            case 0:
                var c = A2(pi, !1, A2(Tu, hp, t));
                return u && !c ? $e(Gv(function(n) {
                    switch(n){
                        case 0:
                            return "Diese Angabe ist verpflichtend.";
                        case 1:
                            return "Please indicate your agreement.";
                        case 2:
                            return "Esta informaci\xf3n es obligatoria.";
                        case 3:
                            return "Cette mention est obligatoire.";
                        default:
                            return "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0441\u0432\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435.";
                    }
                })) : ye(Wf(c));
            case 1:
                var a = r.a, i = A3(Xi, "", F_, A2(Tu, Qv, t));
                return u && Kt(i) ? $e(Gv(function(n) {
                    switch(n){
                        case 0:
                            return "Bitte treffen Sie eine Auswahl.";
                        case 1:
                            return "Please select an option.";
                        case 2:
                            return "Por favor, selecciona una opci\xf3n.";
                        case 3:
                            return "Veuillez s\xe9lectionner une option.";
                        default:
                            return "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0430\u0440\u0438\u0430\u043D\u0442.";
                    }
                })) : !u && Kt(i) || A2(ui, i, A2(Ut, function(n) {
                    return n.bK;
                }, A3(Zl, n, w, A2(Vg, function() {
                    return Bo;
                }, a)))) ? ye(Sf(i)) : $e(Gv(function(n) {
                    switch(n){
                        case 0:
                            return "Bitte f\xfcllen Sie dieses Pflichtfeld.";
                        case 1:
                            return "Please fill this mandatory field.";
                        case 2:
                            return "Por favor, rellena este campo obligatorio.";
                        case 3:
                            return "Veuillez remplir ce champ obligatoire.";
                        default:
                            return "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u044D\u0442\u043E \u043F\u043E\u043B\u0435.";
                    }
                }));
            case 2:
                return i = A3(Xi, "", F_, A2(Tu, Qv, t)), u && Kt(i) ? $e(Gv(function(n) {
                    switch(n){
                        case 0:
                            return "Bitte f\xfcllen Sie dieses Pflichtfeld.";
                        case 1:
                            return "Please fill this mandatory field.";
                        case 2:
                            return "Por favor, rellena este campo obligatorio.";
                        case 3:
                            return "Veuillez remplir ce champ obligatoire.";
                        default:
                            return "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u044D\u0442\u043E \u043F\u043E\u043B\u0435.";
                    }
                })) : !u && Kt(i) || Wd(function(n) {
                    var r = A2(Wa, RB, n);
                    return r.$ ? fe : r.a;
                }(i)) ? ye(Sf(i)) : $e(Gv(function(n) {
                    switch(n){
                        case 0:
                            return "Diese E-Mail-Adresse ist ung\xfcltig.";
                        case 1:
                            return "This email address is not valid.";
                        case 2:
                            return "Esta direcci\xf3n de correo no es v\xe1lida.";
                        case 3:
                            return "Cette adresse e-mail n'est pas valide.";
                        default:
                            return "\u042D\u0442\u043E\u0442 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u0435\u043D.";
                    }
                }));
            case 3:
                var o = r.a;
                return i = A3(Xi, "", F_, A2(Tu, Qv, t)), u && Kt(i) ? $e(Gv(function(n) {
                    switch(n){
                        case 0:
                            return "Bitte f\xfcllen Sie dieses Pflichtfeld.";
                        case 1:
                            return "Please fill this mandatory field.";
                        case 2:
                            return "Por favor, rellena este campo obligatorio.";
                        case 3:
                            return "Veuillez remplir ce champ obligatoire.";
                        default:
                            return "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u044D\u0442\u043E \u043F\u043E\u043B\u0435.";
                    }
                })) : A2(Qu, function() {
                    return Sf(i);
                }, A3(Xi, ye(0), function(n) {
                    var r = n.cU;
                    return A2(Qk, n.fg, i) ? ye(0) : $e(r);
                }, o));
            default:
                var f = A2(Tu, WB, t);
                return u && Fd(f) ? $e(Gv(function(n) {
                    switch(n){
                        case 0:
                            return "Bitte f\xfcllen Sie dieses Pflichtfeld.";
                        case 1:
                            return "Please fill this mandatory field.";
                        case 2:
                            return "Por favor, rellena este campo obligatorio.";
                        case 3:
                            return "Veuillez remplir ce champ obligatoire.";
                        default:
                            return "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u044D\u0442\u043E \u043F\u043E\u043B\u0435.";
                    }
                })) : ye(A3(Xi, Ef, PB, f));
        }
    }), MB = F3(function(n, r, e) {
        return function(t) {
            return {
                bo: ye(n),
                ct: n,
                iK: A2(Ut, ch(jt), t.iL.gr({
                    gy: t.gy,
                    eR: t.eR,
                    ix: e,
                    dW: r
                }))
            };
        };
    }), jB = F2(function(n, r) {
        var e = n, t = r;
        return {
            eI: function(n) {
                return t.eI(e.eI(n));
            },
            cw: F2(function(n, r) {
                return A2(e.cw, t.cw(n), r);
            })
        };
    }), SB = F2(function(n, r) {
        return {
            eI: n,
            cw: r
        };
    }), NB = F2(function(n, r) {
        return A2(SB, A2(su, pi(n), zi(r)), function(e) {
            return A2(Oi, r, A2(su, A2(su, oe, e), pi(n)));
        });
    }), GB = A2(SB, function(n) {
        return n.a4;
    }, F2(function(n, r) {
        return $(r, {
            a4: n(r.a4)
        });
    })), QB = function(n) {
        return A2(jB, GB, A2(NB, Sf(""), n));
    }, UB = A2(SB, function(n) {
        return n.a4;
    }, F2(function(n, r) {
        return $(r, {
            a4: n(r.a4)
        });
    })), HB = F2(function(n, r) {
        return n.eI(r);
    }), VB = F3(function(n, r, e) {
        return A2(n.cw, Du(r), e);
    }), JB = function(n) {
        return {
            eI: HB(n),
            fH: VB(n)
        };
    }, XB = F2(function(n, r) {
        return !!r.$ || A2(ui, n, r.a);
    }), ZB = F3(function(n, r, e) {
        return {
            cU: e,
            eR: r,
            e2: n
        };
    }), YB = F3(function(n, r, e) {
        var t = n.fj;
        return function(n) {
            var u = n.dW, c = A2(Ni, A2(su, A2(su, bp, A2(ZB, n.gD, Be(n.eR))), A2(Zl, n.gy, "")), A2(r.iI, {
                fz: r.fz
            }, oe(u))), a = A2(XB, n.gD, n.cm) && 1 === c.$ ? oe(zd(c.a)) : fe;
            return {
                bo: c,
                ct: u,
                iK: n.iL.hs({
                    gy: n.gy,
                    gD: n.gD,
                    eR: n.eR,
                    ht: r,
                    hv: e,
                    fj: t,
                    iH: a,
                    dW: n.dW
                })
            };
        };
    }), nC = qB, rC = F2(function(n, r) {
        switch(r.$){
            case 0:
                return rb;
            case 1:
                return Yd(n(r.a));
            case 2:
                return A2(nb, r.a, n(r.b));
            default:
                return A3(eb, r.a, r.b, r.c);
        }
    }), eC = F2(function(n, r) {
        var e = n.fH, t = n.eI;
        return function(n) {
            var u = A2(vB, r, {
                gy: n.gy,
                gD: n.gD,
                eR: n.eR,
                bc: n.bc,
                cm: n.cm,
                bC: n.bC,
                iC: n.iC,
                ct: n.ct,
                dW: t(n.dW),
                iL: n.iL
            });
            return {
                bo: u.bo,
                ct: u.ct,
                iK: A2(Ut, ch(rC(A2(uo, e, n.dW))), u.iK)
            };
        };
    }), tC = eC, uC = F2(function(n, r) {
        return function(e) {
            return {
                bo: ye(n),
                ct: n,
                iK: A2(Ut, ch(Yd), e.iL.hF({
                    gy: e.gy,
                    gD: e.gD,
                    eR: e.eR,
                    bc: e.bc,
                    ic: r
                }))
            };
        };
    }), cC = function(n) {
        return function(r) {
            return A2(vB, n(r), r);
        };
    }, aC = F2(function(n, r) {
        var e, t = r.b;
        switch(t.$){
            case 0:
            case 1:
            case 2:
            case 3:
            case 6:
            case 8:
            default:
                return fe;
            case 4:
                var u = t.a, c = t.b;
                return oe(A2(nC, F2(function(n, r) {
                    return $(r, {
                        a4: A3(Va, u.hu, n, r.a4)
                    });
                }), A2(tC, JB((e = u.hu, A2(jB, UB, A2(NB, Sf(""), e)))), cC(function(r) {
                    return A3(YB, {
                        fj: n.eZ ? oe(r.gD.gF) : fe
                    }, {
                        g7: u.g7,
                        hu: u.hu,
                        a9: u.a9,
                        fz: u.fz,
                        iI: A2(EB, r.gy, u.iI)
                    }, c);
                }))));
            case 5:
                var a = t.a;
                return oe(A2(tC, {
                    eI: function() {
                        return {
                            gE: 0,
                            gF: 0
                        };
                    },
                    fH: F2(function(n, r) {
                        return r;
                    })
                }, A2(uC, At, a)));
            case 7:
                var i = t.a;
                return oe(A2(nC, A2(De, su, At), DB(A2(Ou, aC(n), i.a4))));
        }
    }), iC = A2(SB, function(n) {
        return n.g8;
    }, F2(function(n, r) {
        return $(r, {
            g8: n(r.g8)
        });
    })), oC = fe, fC = function(n) {
        var r = n.dW, e = A2(Ni, function() {
            return bp(A3(ZB, n.gD, Be(n.eR), A3(Zl, n.gy, "", Gv(function(n) {
                switch(n){
                    case 0:
                        return "Bitte treffen Sie eine Auswahl.";
                    case 1:
                        return "Please select an option.";
                    case 2:
                        return "Por favor, selecciona una opci\xf3n.";
                    case 3:
                        return "Veuillez s\xe9lectionner une option.";
                    default:
                        return "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0430\u0440\u0438\u0430\u043D\u0442.";
                }
            }))));
        }, function() {
            var r = n.dW;
            if (5 === r.$) {
                var e = Tt(r.a);
                return e.$ ? $e(0) : ye(Mf(e.a));
            }
            return $e(0);
        }()), t = A2(XB, n.gD, n.cm) && 1 === e.$ ? oe(zd(e.a)) : fe;
        return {
            bo: e,
            ct: r,
            iK: n.iL.hb({
                gy: n.gy,
                eR: n.eR,
                iH: t,
                dW: n.dW
            })
        };
    }, sC = {
        a4: Na,
        cq: Na
    }, dC = F2(function(n, r) {
        var e;
        return r.$ ? nd($(e = r.a, {
            a4: n(e.a4)
        })) : rd($(e = r.a, {
            a4: n(e.a4)
        }));
    }), bC = F2(function(n, r) {
        if (r.$) {
            var e = r.a;
            return nd($(e, {
                dt: n(e.dt)
            }));
        }
        return r;
    }), lC = F6(function(n, r, e, t, u, c) {
        var a = A3(Go, F3(function(t, u, c) {
            n: for(;;){
                var a = c.a, i = c.b;
                if (a.b) {
                    var o = a.a, s = o.a, d = o.b, b = a.b;
                    if (0 > f(s, t)) {
                        c = g(b, A3(n, s, d, i));
                        continue n;
                    }
                    return f(s, t) > 0 ? g(a, A3(e, t, u, i)) : g(b, A4(r, s, d, u, i));
                }
                return g(a, A3(e, t, u, i));
            }
        }), g(be(t), c), u), i = a.a, o = a.b;
        return A3(De, F2(function(r, e) {
            return A3(n, r.a, r.b, e);
        }), o, i);
    }), vC = A2(SB, function(n) {
        return n.dt;
    }, F2(function(n, r) {
        return $(r, {
            dt: n(r.dt)
        });
    })), gC = function(n) {
        return A2(jB, vC, A2(NB, To, n));
    }, hC = A2(De, F2(function(n, r) {
        var e = g(n, r);
        return e.a.$ ? $e(1 === e.b.$ ? A2(BB, e.a.a, e.b.a) : e.a.a) : e.b.$ ? $e(e.b.a) : ye(A2(se, e.a.a, e.b.a));
    }), ye(w)), $C = F2(function(n, r) {
        return function(e) {
            var t = Fo(e.dW) ? A2(Id, 0, To) : e.dW, u = A2(Ut, function(n) {
                var t, u = n.a, c = n.b;
                return A2(vB, A2(qB, Gu(Id(u)), A2(eC, {
                    eI: function() {
                        return oe(c);
                    },
                    fH: F2(function(n, r) {
                        return A3(Xi, A2(Fi, u, r), function(n) {
                            return A3(Va, u, n, r);
                        }, n);
                    })
                }, A2(qB, oe, A2(eC, {
                    eI: function() {
                        return c;
                    },
                    fH: F2(function(n) {
                        return oe(n);
                    })
                }, r)))), $(e, {
                    gD: (t = e.gD, $(t, {
                        gF: u
                    }))
                }));
            }, be(t)), c = A2(su, A2(De, Qo, Na), Hv)(A2(Ut, function(n) {
                return n.ct;
            }, u)), a = A3(Xi, !1, ht(mf(t)), n.bu.a) ? $e(bp(A3(ZB, e.gD, Be(e.eR), A3(Zl, e.gy, "", Gv(function() {
                return "Bitte geben Sie mindestens " + Be(A2(pi, 0, n.bu.a)) + " Personen an.";
            }))))) : A3(Xi, !1, ot(mf(t)), n.bu.b) ? $e(bp(A3(ZB, e.gD, Be(e.eR), A3(Zl, e.gy, "", Gv(function() {
                return "Bitte geben Sie h\xf6chstens " + Be(A2(pi, 0, n.bu.b)) + " Personen an.";
            }))))) : A2(Qu, A2(su, A2(De, Qo, Na), Hv), hC(A2(Ut, function(n) {
                return n.bo;
            }, u))), i = A2(XB, e.gD, e.cm) && 1 === a.$ ? oe(zd(a.a)) : fe;
            return {
                bo: a,
                ct: c,
                iK: e.iL.dt({
                    gy: e.gy,
                    g1: A2(Ut, function(n) {
                        return n.iK;
                    }, u),
                    eR: e.eR,
                    bu: n.bu,
                    iH: i,
                    dW: t
                })
            };
        };
    }), mC = A2(SB, function(n) {
        return n.cq;
    }, F2(function(n, r) {
        return $(r, {
            cq: n(r.cq)
        });
    })), pC = F2(function(n, r) {
        var e = n.hQ, t = n.hy, u = r.fz, c = r.cc;
        return function(n) {
            var a, i = A2(Jo, function(n) {
                return A2(Dy, n.b, n.a);
            }, No(n.dW)), o = A2(pi, w, A2(Gu, Bo, A2(Tu, zi(r.bD), A2(Tu, function(n) {
                return n.eH;
            }, n.gy.eb)))), f = (t ? Ut(function(n) {
                return g(n.a, e);
            }) : At)(No(n.dW)), s = function(r) {
                return Be(n.eR) + "-" + Be(r);
            }, d = u && Ro(f) ? $e(bp(A3(ZB, n.gD, s(0), A3(Zl, n.gy, "Bitte w\xe4hlen Sie ein Ticket.", Gv(function(n) {
                return 1 === n ? "Please select a ticket." : "Bitte w\xe4hlen Sie ein Ticket.";
            }))))) : Jx(n.dW) ? ye(i) : $e(bp(A3(ZB, n.gD, s(0), A3(Zl, n.gy, "Bitte treffen Sie eine Auswahl.", Gv(function(n) {
                switch(n){
                    case 0:
                        return "Bitte treffen Sie eine Auswahl.";
                    case 1:
                        return "Please select an option.";
                    case 2:
                        return "Por favor, selecciona una opci\xf3n.";
                    case 3:
                        return "Veuillez s\xe9lectionner une option.";
                    default:
                        return "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0430\u0440\u0438\u0430\u043D\u0442.";
                }
            }))))), b = A2(XB, n.gD, n.cm) && 1 === d.$ ? oe(zd(d.a)) : fe, l = (!A2(XB, n.gD, n.cm) || Fd(b), p(r.dR, o)), v = (a = ni(A2(su, A2(uo, ui, l), function(n) {
                return n.fP;
            }))(n.gy.cq), A2(ti, A2(su, Wd, function(n) {
                return n.ec;
            }), a) ? A2(ni, A2(su, Wd, function(n) {
                return n.ec;
            }), a) : a);
            return {
                bo: d,
                ct: i,
                iK: n.iL.iy({
                    gj: v,
                    gy: n.gy,
                    eR: n.eR,
                    cc: c,
                    fd: r.fd,
                    fz: u,
                    $8: f,
                    bD: r.bD,
                    ct: n.ct,
                    iH: b,
                    dW: n.dW
                })
            };
        };
    }), wC = pC, yC = F2(function(n, r) {
        var e, t = n.bc, u = n.hy, c = n.bn, a = n.gF, i = r.b, o = A2(SB, function(n) {
            return n.cg;
        }, F2(function(n, r) {
            return $(r, {
                cg: n(r.cg)
            });
        })), f = tC(JB(o));
        switch(i.$){
            case 0:
                var s = i.a;
                return cC(function(n) {
                    var r = n.dW;
                    return A3(MB, At, A2(Uo, A2(HB, A2(jB, o, iC), r), A2(HB, A2(jB, A2(jB, o, gC(a)), mC), r)), s);
                });
            case 1:
                return f(A2(tC, JB(gC(a)), (e = At, function(n) {
                    return {
                        bo: ye(e),
                        ct: e,
                        iK: A2(Ut, ch(jt), n.iL.gF({
                            gy: n.gy,
                            eR: n.eR,
                            dW: n.dW
                        }))
                    };
                })));
            case 2:
                return function(n) {
                    return function(r) {
                        return {
                            bo: ye(n),
                            ct: n,
                            iK: A2(Ut, ch(jt), r.iL.gG({
                                gy: r.gy,
                                eR: r.eR,
                                dW: r.dW
                            }))
                        };
                    };
                }(At);
            case 3:
                return cC(function(n) {
                    var r, e = (r = n.gy.e).$ || 1 !== r.a ? "G\xe4stecodes" : "Guest codes", t = 1 === c.$ ? e : A2(Ce, ".", p(Bo(c.a), _([
                        e
                    ])));
                    return f(A2(nC, F2(function(n, r) {
                        return A2(dC, A2(Va, t, n), r);
                    }), A2(tC, JB(QB(t)), fC)));
                });
            case 4:
                var d = i.a, b = i.b;
                return f(A2(nC, F2(function(n, r) {
                    return t ? A2(bC, function(r) {
                        var e = A2(pi, sC, A2(zi, a, r));
                        return A3(Va, a, $(e, {
                            a4: A3(Va, d.hu, n, e.a4)
                        }), r);
                    }, r) : A2(dC, A2(Va, d.hu, n), r);
                }), A2(tC, JB(t ? A2(jB, gC(a), QB(d.hu)) : QB(d.hu)), cC(function(n) {
                    return A3(YB, {
                        fj: oe(a)
                    }, {
                        g7: d.g7,
                        hu: d.hu,
                        a9: d.a9,
                        fz: d.fz,
                        iI: A2(EB, n.gy, d.iI)
                    }, b);
                }))));
            case 5:
                var l = i.a;
                return A2(tC, {
                    eI: function(n) {
                        return n.bl;
                    },
                    fH: F2(function(n, r) {
                        return $(r, {
                            bl: n
                        });
                    })
                }, A2(uC, At, l));
            case 6:
                var v = i.a, g = i.b;
                return cC(function(n) {
                    return f(A2(nC, F2(function(n, r) {
                        return A2(bC, function(r) {
                            return A6(lC, F3(function(n, r, e) {
                                return A3(Va, n, r(sC), e);
                            }), F4(function(n, r, e, t) {
                                return A3(Va, n, r(e), t);
                            }), F3(function(n, r, e) {
                                return A3(Va, n, r, e);
                            }), n, r, Na);
                        }, r);
                    }), A2(tC, JB(vC), A2($C, v, A2(nC, A2(De, su, At), DB(A2(Ou, aC({
                        eZ: !0,
                        cg: n.dW.cg
                    }), g)))))));
                });
            case 7:
                var h = i.a;
                return A2(nC, A2(De, su, At), DB(A2(Ut, yC({
                    gF: a,
                    bn: h.bn,
                    hy: u,
                    bc: t
                }), h.a4)));
            case 8:
                return function(n) {
                    return function(r) {
                        return {
                            bo: ye(n),
                            ct: n,
                            iK: r.iL.$9({
                                gy: r.gy,
                                eR: r.eR,
                                cm: r.cm,
                                bC: r.bC,
                                dW: r.dW
                            })
                        };
                    };
                }(At);
            default:
                if (h = i.a, u) return cC(function(n) {
                    var r = n.dW;
                    return A2(nC, function() {
                        return At;
                    }, A2(tC, JB(A2(jB, o, A2(jB, iC, function(n) {
                        return A2(jB, A2(SB, function(n) {
                            return n;
                        }, F2(function(n, r) {
                            return n(r);
                        })), A2(NB, oC, n));
                    }(h.bD)))), A2(wC, {
                        gF: a,
                        hy: u,
                        hQ: mf(r.cg.dt)
                    }, h)));
                });
                var m = JB(A2(jB, gC(a), A2(jB, mC, A2(NB, oC, h.bD)))), w = F2(function(n, r) {
                    var e;
                    return r.$ ? nd($(e = r.a, {
                        dt: A3(Oi, a, A2(su, A2(su, oe, function(r) {
                            return $(r, {
                                cq: A3(Va, h.bD, n, r.cq)
                            });
                        }), pi(sC)), e.dt)
                    })) : rd($(e = r.a, {
                        cq: A3(Va, h.bD, n, e.cq)
                    }));
                });
                return cC(function(r) {
                    return f(A2(nC, w, A2(tC, m, A2(wC, {
                        gF: a,
                        hy: n.hy,
                        hQ: mf(r.dW.cg.dt)
                    }, h))));
                });
        }
    }), kC = F3(function(n, r, e) {
        return e.$ ? n : r(e.a);
    }), _C = F3(function(n, r, e) {
        var t = n.h0, u = n.hP, c = n.gD, a = r.bc, i = r.hx, o = e;
        return function(n) {
            var r = o($(n, {
                gD: c,
                bc: a,
                cm: n.dW.cm
            })), e = A3(kC, !1, Du(!0), r.bo);
            return {
                bo: r.bo,
                ct: r.ct,
                iK: n.iL.hX({
                    gy: n.gy,
                    gD: c,
                    g0: r.iK,
                    eR: n.eR,
                    hx: i,
                    hP: u,
                    bc: a,
                    h0: t,
                    iC: n.iC,
                    iG: e,
                    dW: n.dW
                })
            };
        };
    }), IC = function(n) {
        var r = Cd(n);
        return cC(function(e) {
            var t = e.dW, u = e.gy;
            return A3(su, A2(su, A2(su, nC(IB(t)), nC(A3(kB, r, u, t))), nC(A2(De, su, At))), DB, A2(Ut, function(n) {
                var e = n.hX, t = n.gI, u = e.a, c = e.b;
                return A3(_C, t, {
                    hx: n.hx,
                    bc: u.bc
                }, A2(nC, A2(De, su, At), DB(A2(Ut, yC({
                    gF: t.gD.gF,
                    bn: fe,
                    hy: r && !u.bc,
                    bc: u.bc
                }), c))));
            }, A3(wf, r, e, n)));
        });
    }, xC = F2(function(n, r) {
        var e = r.q, t = r.a1;
        return A2(Zi, n, {
            o: oe(r.o),
            a1: t,
            y: "PUT",
            q: e
        });
    }), AC = F3(function(n, r, e) {
        return A2(xC, n, {
            o: JA(r),
            a1: uB,
            q: "/public/registration.json?frontendPrice=" + Be(e)
        });
    }), BC = function(n) {
        return vu(_([
            g("name", bc(n.de)),
            g("size", Ss(n.dI)),
            g("type", bc(n.cv)),
            g("lastModified", Ss(n.c5)),
            g("dataURL", bc(n.cM))
        ]));
    }, CC = F2(function(n, r) {
        return A2(WA, n, {
            o: BC(r),
            a1: dc,
            q: "/public/upload"
        });
    }), qC = F2(function(n, r) {
        var e = g(r, Nd), t = g(n, r);
        n: for(;;){
            r: for(;;){
                e: for(;;){
                    t: for(;;){
                        u: for(;;){
                            c: for(;;){
                                a: for(;;){
                                    i: for(;;){
                                        o: for(;;){
                                            f: for(;;){
                                                s: for(;;)switch(t.b.$){
                                                    case 3:
                                                        if (7 === t.a.$) return t.a.a;
                                                        break r;
                                                    case 0:
                                                        if (7 === t.a.$) break n;
                                                        break e;
                                                    case 1:
                                                        if (7 === t.a.$) break n;
                                                        break t;
                                                    case 2:
                                                        switch(t.a.$){
                                                            case 7:
                                                                break n;
                                                            case 11:
                                                                var u = !c((l = t.a.a).bl, (D = t.b.a).t.bl);
                                                                return g(ho($(D, {
                                                                    ar: A2(Gu, UA, D.ar),
                                                                    t: l
                                                                })), Sd(_([
                                                                    Td(Ys(l)),
                                                                    u ? bB(0) : Nd
                                                                ])));
                                                            case 1:
                                                                switch(t.a.a.$){
                                                                    case 0:
                                                                        var a = t.a.a.a, i = A2(xd, qd((D = t.b.a).C), a), o = A3(Xi, 0, A2(su, function(n) {
                                                                            return n.fn;
                                                                        }, hf), A3(lb, D, i, D.as)), s = A2(rf, D, i) - o;
                                                                        return g(ho(D), Sd(_([
                                                                            lB(JA(a)),
                                                                            A2(bu, GA, D.cw ? A3(AC, D.m, a, s) : A5(cB, D.m, a, D.an, s, D.aN))
                                                                        ])));
                                                                    case 1:
                                                                        return u = !c((l = t.a.a.a).bl, (D = t.b.a).t.bl), g(ho($(D, {
                                                                            t: l
                                                                        })), Sd(_([
                                                                            Td(Ys(l)),
                                                                            u ? bB(0) : Nd
                                                                        ])));
                                                                    case 2:
                                                                        var d = t.a.a, b = d.a, l = d.b, v = (D = t.b.a).t, h = IC(D.C), m = vd(D);
                                                                        return g(ho($(D, {
                                                                            ar: oe(SA({
                                                                                bX: A4(pB, b, m, v, h),
                                                                                dl: l
                                                                            }))
                                                                        })), Nd);
                                                                    case 3:
                                                                        var p = t.a.a, y = p.a, k = A5(sB, y, A = p.b, B = p.c, (D = t.b.a).am, D.t);
                                                                        return g(ho($(D, {
                                                                            am: k.a,
                                                                            t: l = k.b
                                                                        })), Sd(_([
                                                                            Td(Ys(l)),
                                                                            1 > f(B.dI, y.hH) ? A2(bu, A2(QA, A, B), A2(CC, D.m, B)) : Nd
                                                                        ])));
                                                                    case 4:
                                                                        return g(ho($(D = t.b.a, {
                                                                            by: t.a.a.a
                                                                        })), Nd);
                                                                    default:
                                                                        return g(ho(D = t.b.a), A2(bu, NA, A2(WA, D.m, {
                                                                            o: vu(w),
                                                                            a1: It(0),
                                                                            q: "/public/user-account/logout"
                                                                        })));
                                                                }
                                                            case 9:
                                                                break u;
                                                            case 8:
                                                                if (t.a.c.$) {
                                                                    var I = t.a, x = A5(oB, A = I.a, B = I.b, I.c.a, (D = t.b.a).am, D.t);
                                                                    return g(ho($(D, {
                                                                        am: x.a,
                                                                        t: l = x.b
                                                                    })), Td(Ys(l)));
                                                                }
                                                                var A, B, C = t.a, q = A5(dB, A = C.a, B = C.b, C.c.a, (D = t.b.a).am, D.t);
                                                                return g(ho($(D, {
                                                                    am: q.a,
                                                                    t: l = q.b
                                                                })), Td(Ys(l)));
                                                            case 0:
                                                                return g(1 === t.a.a.$ ? fo({
                                                                    gQ: (D = t.b.a).gQ,
                                                                    cT: bo(t.a.a.a),
                                                                    e: D.e
                                                                }) : ho($(D = t.b.a, {
                                                                    C: t.a.a.a
                                                                })), Nd);
                                                            case 2:
                                                                return g(1 === t.a.a.$ ? fo({
                                                                    gQ: (D = t.b.a).gQ,
                                                                    cT: bo(t.a.a.a),
                                                                    e: D.e
                                                                }) : ho($(D = t.b.a, {
                                                                    e: t.a.a.a
                                                                })), Nd);
                                                            case 3:
                                                                if (1 === t.a.a.$) return g(fo({
                                                                    gQ: (D = t.b.a).gQ,
                                                                    cT: so("internal error"),
                                                                    e: D.e
                                                                }), Nd);
                                                                switch(t.a.a.a.$){
                                                                    case 2:
                                                                        return g(lo({
                                                                            ai: (D = t.b.a).ai,
                                                                            gQ: D.gQ,
                                                                            an: D.an,
                                                                            e: D.e
                                                                        }), Nd);
                                                                    case 0:
                                                                        var z = t.a.a.a.a;
                                                                        return g(mo({
                                                                            aH: z,
                                                                            gQ: (D = t.b.a).gQ,
                                                                            e: D.e
                                                                        }), jd(A2(mu, Ko, z)));
                                                                    default:
                                                                        return g(fo({
                                                                            gQ: (D = t.b.a).gQ,
                                                                            cT: so(t.a.a.a.a.cT),
                                                                            e: D.e
                                                                        }), Nd);
                                                                }
                                                            case 4:
                                                                return g(1 === t.a.a.$ ? fo({
                                                                    gQ: (D = t.b.a).gQ,
                                                                    cT: bo(t.a.a.a),
                                                                    e: D.e
                                                                }) : ho($(D = t.b.a, {
                                                                    cq: t.a.a.a
                                                                })), Nd);
                                                            case 5:
                                                                return g(1 === t.a.a.$ ? fo({
                                                                    gQ: (D = t.b.a).gQ,
                                                                    cT: bo(t.a.a.a),
                                                                    e: D.e
                                                                }) : ho($(D = t.b.a, {
                                                                    as: t.a.a.a
                                                                })), Nd);
                                                            case 6:
                                                                return g(ho($(D = t.b.a, {
                                                                    aF: t.a.a
                                                                })), Nd);
                                                            case 10:
                                                                var D;
                                                                return g(ho($(D = t.b.a, {
                                                                    ar: fe
                                                                })), Nd);
                                                            default:
                                                                return e;
                                                        }
                                                    case 4:
                                                        switch(t.a.$){
                                                            case 7:
                                                                break n;
                                                            case 9:
                                                                break u;
                                                            case 8:
                                                                break c;
                                                            case 3:
                                                                if (1 === t.a.a.$) break a;
                                                                if (1 === t.a.a.a.$) break i;
                                                                break o;
                                                            default:
                                                                break o;
                                                        }
                                                    case 6:
                                                        switch(t.a.$){
                                                            case 7:
                                                                break n;
                                                            case 9:
                                                                break u;
                                                            case 8:
                                                                break c;
                                                            case 3:
                                                                if (1 === t.a.a.$) break a;
                                                                if (1 === t.a.a.a.$) break i;
                                                                break f;
                                                            default:
                                                                break f;
                                                        }
                                                    default:
                                                        switch(t.a.$){
                                                            case 7:
                                                                break n;
                                                            case 9:
                                                                break u;
                                                            case 8:
                                                                break c;
                                                            case 3:
                                                                if (1 === t.a.a.$) break a;
                                                                if (1 === t.a.a.a.$) break i;
                                                                break s;
                                                            default:
                                                                break s;
                                                        }
                                                }
                                                return e;
                                            }
                                            return e;
                                        }
                                        return e;
                                    }
                                    return e;
                                }
                                return g(r, Nd);
                            }
                            return e;
                        }
                        return g(r, Nd);
                    }
                    return e;
                }
                return e;
            }
            return e;
        }
        return e;
    }), zC = F2(function(n, r) {
        var e = g(n, r);
        n: for(;;){
            if (4 === e.a.$ && 9 === e.a.a.$) {
                if (e.a.a.a.$) {
                    if (4 === e.b.c.$ && 2 === e.b.c.a.$) return g(r, Nd);
                    break n;
                }
                if (4 === e.b.c.$ && 2 === e.b.c.a.$) return $A(e.b.c.a.a.cW);
                break n;
            }
            break n;
        }
        return A3(jA, qC, n, r);
    }), DC = function(n) {
        return {
            $: 1,
            a: n
        };
    }, PC = {
        $: 2
    }, KC = function(n) {
        return A2(Ce, " ", A2(Ut, function(n) {
            return n.a + ": " + zu(n.b) + ";";
        }, _([
            g("--mdc-theme-primary", n.dx),
            g("--mdc-theme-secondary", n.dF),
            g("--mdc-theme-error", n.cT)
        ])));
    }, LC = {
        cz: w,
        cI: !1
    }, TC = {
        $: 0
    }, RC = A2(yb, _([
        mb("mdc-linear-progress__buffer-bar")
    ]), w), FC = A2(yb, _([
        mb("mdc-linear-progress__buffer-dots")
    ]), w), OC = A2(yb, _([
        mb("mdc-linear-progress__buffer")
    ]), _([
        RC,
        FC
    ])), WC = function(n) {
        return oe(A2(qb, "buffer", Js(2 === n.$ ? n.b : 1)));
    }, EC = function(n) {
        return oe(A2(qb, "determinate", Vs(!c(n, TC))));
    }, MC = oe(A2(il, "display", "block")), jC = A2(yb, _([
        mb("mdc-linear-progress__bar-inner")
    ]), w), SC = A2(yb, _([
        mb("mdc-linear-progress__bar mdc-linear-progress__primary-bar")
    ]), _([
        jC
    ])), NC = function(n) {
        return oe(A2(qb, "progress", Js(function() {
            switch(n.$){
                case 1:
                case 2:
                    return n.a;
                default:
                    return 0;
            }
        }())));
    }, GC = oe(A2(gb, "role", "progressbar")), QC = oe(mb("mdc-linear-progress")), UC = A2(yb, _([
        mb("mdc-linear-progress__bar mdc-linear-progress__secondary-bar")
    ]), _([
        jC
    ])), HC = function(n) {
        return n.$ ? fe : oe(mb("mdc-linear-progress--indeterminate"));
    }, VC = F2(function(n, r) {
        var e, t = r.cz;
        return A3(Ob, "mdc-linear-progress", p(A2(Ou, At, _([
            QC,
            MC,
            GC,
            HC(n),
            EC(n),
            NC(n),
            WC(n),
            (e = r, oe(A2(qb, "closed", Vs(e.cI))))
        ])), t), _([
            OC,
            SC,
            UC
        ]));
    }), JC = function(n) {
        return A2(VC, TC, n);
    }, XC = F2(function(n, r) {
        return $(r, {
            cP: n
        });
    }), ZC = F2(function(n, r) {
        return $(r, {
            bG: n
        });
    }), YC = F2(function(n, r) {
        return A3(Dh, 2, n, r);
    }), nq = A2(su, A2(gc, function(n) {
        return _([
            A2(Kl, w, _([
                El(n)
            ]))
        ]);
    }, At), Hx), rq = F2(function(n, r) {
        var e, t = F2(function(n, r) {
            var e = n.aS;
            return yb(p(_([
                mb("login"),
                A2(gb, "style", KC(e.eh))
            ]), r));
        });
        switch(r.c.$){
            case 1:
                var u = r.a, c = r.c.a, a = "" === F_(c.ak) || c.c7, i = zd(c.aS.hE);
                return A3(t, c, w, _([
                    A2(yb, _([
                        mb("login__before")
                    ]), nq(A3(Zl, {
                        gQ: i,
                        e: A2(pi, i, u.e)
                    }, "", c.aE.gk))),
                    A2(yb, _([
                        mb("login__form")
                    ]), _([
                        (e = A2(sp, Fd(c.cT), A2(up, DC, A2(dp, oe(c.ak), A2(Zm, oe("E-Mail-Adresse"), Jb)))), A2(xm, !1, e)),
                        A2(yb, _([
                            mb("mdc-text-field-helper-line")
                        ]), _([
                            A2(ng, A2(rg, !0, A2(eg, !0, Jv)), A3(Xi, "", function() {
                                return "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es sp\xe4ter erneut.";
                            }, c.cT))
                        ])),
                        A2(YC, A2(ep, PC, A2(Hm, a, A2(ZC, !0, A2(XC, !0, Sb)))), "Anmelden")
                    ])),
                    A2(yb, _([
                        mb("login__after")
                    ]), nq(A3(Zl, {
                        gQ: i,
                        e: A2(pi, i, u.e)
                    }, "", c.aE.ge)))
                ]));
            case 2:
                u = r.a;
                var o = r.c.a;
                return i = zd(o.aS.hE), A3(t, o, w, _([
                    A2(Pl, w, _([
                        El(A3(Zl, {
                            gQ: i,
                            e: A2(pi, i, u.e)
                        }, "", Gv(function(n) {
                            return 1 === n ? "Please follow the link in the email to complete your authentication." : "Bitte folge dem Link in der E-Mail um die Authentifizierung abzuschlie\xdfen.";
                        })))
                    ])),
                    A2(Pl, w, _([
                        El(A3(Zl, {
                            gQ: i,
                            e: A2(pi, i, u.e)
                        }, "", Gv(function(n) {
                            return 1 === n ? "An email has been sent to" : "Es wurde eine E-Mail an ";
                        }))),
                        A2(Tl, w, _([
                            El(o.ak)
                        ])),
                        El(A3(Zl, {
                            gQ: i,
                            e: A2(pi, i, u.e)
                        }, "", Gv(function(n) {
                            return 1 === n ? ". You can close this window." : " versendet. Dieses Fenster kann geschlossen werden.";
                        })))
                    ]))
                ]));
            case 3:
                u = r.a;
                var f = r.c.a;
                return i = zd(f.aS.hE), A3(t, f, _([
                    mb("login--form")
                ]), _([
                    A2(Pl, w, _([
                        El(A3(Zl, {
                            gQ: i,
                            e: A2(pi, i, u.e)
                        }, "", Gv(function(n) {
                            return 1 === n ? "Logging in.." : "Sie werden angemeldet..";
                        })))
                    ])),
                    JC(LC)
                ]));
            case 4:
                return u = r.a, A2(ch, mA, n(r.c.a));
            default:
                return u = r.a, El("");
        }
    }), eq = function(n) {
        return {
            $: 3,
            a: n
        };
    }, tq = ir("details"), uq = function(n) {
        switch(n.$){
            case 1:
                return "decode error: " + Qe(n.a);
            case 2:
                return "http error: " + function(n) {
                    switch(n.$){
                        case 0:
                            return "bad url: " + n.a;
                        case 1:
                            return "timeout";
                        case 2:
                            return "network error";
                        case 3:
                            return "bad status: " + Be(n.a);
                        default:
                            return "bad body: " + n.a;
                    }
                }(n.a);
            case 3:
                return "markdown error: " + n.a;
            default:
                return n.a;
        }
    }, cq = ir("summary"), aq = function(n) {
        return A2(yb, _([
            mb("error-view")
        ]), _([
            A3(gc, function(n) {
                return A2(Kl, w, _([
                    El(n)
                ]));
            }, yb(w), Hx(A3(Zl, n, "", Gv(function(n) {
                switch(n){
                    case 0:
                        return "\n# Technischer Fehler\n\nLeider ist ein unerwarteter Fehler aufgetreten.\n";
                    case 1:
                        return "\n# Technical error\n\nUnfortunately, we have encountered an unexpected error.\n";
                    case 2:
                        return '\n# Error t\xe9cnico\n\nDesafortunadamente, se ha producido un error inesperado."\n';
                    case 3:
                        return "\nErreur technique\n\nUne erreur inattendue est malheureusement survenue.\n";
                    default:
                        return "\n\u0421\u0431\u043E\u0439 \u0432 \u0440\u0430\u0431\u043E\u0442\u0435 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044F\n\n\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u043C\u044B \u0441\u0442\u043E\u043B\u043A\u043D\u0443\u043B\u0438\u0441\u044C \u0441 \u043D\u0435\u043F\u0440\u0435\u0434\u0432\u0438\u0434\u0435\u043D\u043D\u043E\u0439 \u043E\u0448\u0438\u0431\u043A\u043E\u0439.\n";
                }
            })))),
            A2(tq, w, _([
                A2(cq, w, _([
                    El(A3(Zl, n, "", Gv(function(n) {
                        switch(n){
                            case 0:
                                return "Technische Details";
                            case 1:
                                return "Technical details";
                            case 2:
                                return "Detalles t\xe9cnicos";
                            case 3:
                                return "D\xe9tails techniques";
                            default:
                                return "\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F, \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u043E\u0441\u0442\u0438";
                        }
                    })))
                ])),
                A2(Kl, w, _([
                    El(uq(n.cT))
                ]))
            ])),
            A3(gc, function(n) {
                return A2(Kl, w, _([
                    El(n)
                ]));
            }, yb(w), Hx(A3(Zl, n, "", Gv(function(n) {
                switch(n){
                    case 0:
                        return "\nBei Fragen zur Registrierung stehen wir Ihnen gern unter den folgenden Kontaktdaten zur Verf\xfcgung:\n\nTelefon: [+49(0)511 898813-0](tel:+49511898813-0) - E-Mail: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                    case 1:
                        return "\nPlease do not hesitate to contact us in case of any further questions regarding your registration.\n\nPhone: [+49(0)511 898813-0](tel:+49511898813-0) - E-Mail: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                    case 2:
                        return "\nSi tiene alguna pregunta sobre la inscripci\xf3n, no dude en ponerse en contacto con nosotros utilizando los siguientes datos de contacto:\n\nTel\xe9fono: [+49(0)511 898813-0](tel:+49511898813-0) - Correo electr\xf3nico: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                    case 3:
                        return "\nSi vous avez des questions concernant l'enregistrement, n'h\xe9sitez pas \xe0 nous contacter aux coordonn\xe9es suivantes:\n\nT\xe9l.: [+49(0)511 898813-0](tel:+49511898813-0) - E-mail: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                    default:
                        return "\n\u0415\u0441\u043B\u0438 \u0443 \u0432\u0430\u0441 \u0432\u043E\u0437\u043D\u0438\u043A\u043D\u0443\u0442 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0432\u0430\u0448\u0435\u0439 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438, \u043E\u0431\u0440\u0430\u0449\u0430\u0439\u0442\u0435\u0441\u044C \u043A \u043D\u0430\u043C:\n\n\u0413-\u0436\u0430 \u0421\u0430\u043D\u0434\u0440\u0438\u043D\u0435 \u0427\u0435\u0445, \u0442\u0435\u043B\u0435\u0444\u043E\u043D: [+49(0)511 898813-0](tel:+49511 898813-0) - \u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                }
            }))))
        ]));
    }, iq = function(n) {
        return {
            $: 11,
            a: n
        };
    }, oq = {
        $: 10
    }, fq = function(n) {
        return {
            $: 1,
            a: n
        };
    }, sq = {
        $: 12
    }, dq = {
        cz: w,
        gY: !0,
        b2: !1,
        cf: fe,
        dn: !1,
        dE: !0
    }, bq = function(n) {
        var r = n.cf;
        return A2(Gu, A2(su, Lb("MDCDialog:close"), It), r);
    }, lq = A2(gb, "role", "alertdialog"), vq = A2(gb, "aria-modal", "true"), gq = function(n) {
        var r = n.bX;
        return oe(A2(yb, _([
            mb("mdc-dialog__content")
        ]), r));
    }, hq = mb("mdc-dialog__surface"), $q = {
        cz: w,
        I: !1,
        bp: fe,
        a9: fe,
        hK: fe,
        dk: fe,
        dQ: fe
    }, mq = F3(function(n, r, e) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }({
            bO: r,
            cd: n,
            ce: e
        });
    }), pq = function(n) {
        return A2(Gu, rv, n.dk);
    }, wq = function(n) {
        return oe(wl(n.I));
    }, yq = oe(mb("mdc-icon-button")), kq = mb("mdc-menu-surface--anchor"), _q = function(n) {
        var r = n.dQ;
        return c(n.bp, fe) ? fe : A2(Gu, sl, r);
    }, Iq = F2(function(n, r) {
        var e, t = n, u = t.I, a = t.cz;
        return function(n) {
            var r = t.hK;
            if (1 === r.$) return n;
            var e = r.a, u = e.a, c = e.b, a = e.c;
            return A2(yb, _([
                kq
            ]), _([
                n,
                A3(kh, u, c, a)
            ]));
        }(A3(Ob, "mdc-icon-button", w, _([
            A2(c(t.bp, fe) || u ? Yg : nl, p(A2(Ou, At, _([
                yq,
                (e = n, A2(Gu, rl, e.bp)),
                _q(n),
                wq(n),
                pq(n)
            ])), a), _([
                A2(ch, jt, function() {
                    if (r.$) return n = r.a.ce, e = r.a.bO, A2(r.a.cd, A2(se, pb("mdc-icon-button__icon"), e), n);
                    var n = r.a.ce, e = r.a.bO;
                    return A2(r.a.cd, A2(se, mb("mdc-icon-button__icon"), e), n);
                }())
            ]))
        ])));
    }), xq = F2(function(n, r) {
        return $(r, {
            dk: oe(n)
        });
    }), Aq = function(n) {
        var r = n.iA;
        if (r.$) return fe;
        var e = r.a;
        return oe(A2(yb, _([
            mb("mdc-dialog__title")
        ]), _([
            El(e)
        ])));
    }, Bq = F2(function(n, r) {
        var e = n.cf;
        return oe(A2(yb, _([
            mb("mdc-dialog__header")
        ]), A2(Ou, At, _([
            Aq(r),
            oe(A2(yb, _([
                mb("mdc-dialog__close"),
                A2(il, "position", "relative")
            ]), _([
                A2(Iq, (e.$ ? At : xq(e.a))($q), A3(mq, Wh, _([
                    mb("material-icons")
                ]), _([
                    El("close")
                ])))
            ])))
        ]))));
    }), Cq = F2(function(n, r) {
        var e, t, u = n;
        return A2(yb, _([
            hq,
            lq,
            vq
        ]), A2(Ou, At, _([
            u.b2 ? A2(Bq, n, r) : Aq(r),
            gq(r),
            (e = r, t = e.gc, Ro(t) ? fe : oe(A2(yb, _([
                mb("mdc-dialog__actions")
            ]), t)))
        ])));
    }), qq = F2(function(n, r) {
        return A2(yb, _([
            mb("mdc-dialog__container")
        ]), _([
            A2(Cq, n, r)
        ]));
    }), zq = function(n) {
        return oe(A2(qb, "open", Vs(n.dn)));
    }, Dq = oe(mb("mdc-dialog")), Pq = function(n) {
        return oe(A2(qb, "scrimClickAction", bc(n.dE ? "close" : "")));
    }, Kq = A2(yb, _([
        mb("mdc-dialog__scrim")
    ]), w), Lq = F2(function(n, r) {
        var e, t = n.cz;
        return A3(Ob, "mdc-dialog", p(A2(Ou, At, _([
            Dq,
            (e = n, e.b2 ? oe(mb("mdc-dialog--fullscreen")) : fe),
            zq(n),
            Pq(n),
            bq(n)
        ])), t), _([
            A2(qq, n, r),
            Kq
        ]));
    }), Tq = F2(function(n, r) {
        return A2(Lq, n, {
            gc: r.gc,
            bX: r.bX,
            iA: oe(r.iA)
        });
    }), Rq = A2(gb, "data-mdc-dialog-button-default", ""), Fq = function(n) {
        return n.a;
    }, Oq = A2(Xi, 0, function(n) {
        return 964 > n ? 1 : 0;
    }), Wq = function(n) {
        return !n.$;
    }, Eq = mb("mdc-theme--error"), Mq = mb("mdc-deprecated-list-group"), jq = F2(function(n, r) {
        return A2(yb, A2(se, Mq, n), r);
    }), Sq = F2(function(n, r) {
        return A3(Qt, F2(function(r, e) {
            if (e.b) {
                var t = e.a, u = t.a, c = t.b, a = e.b;
                return A2(n, r, u) ? A2(se, g(r, A2(se, u, c)), a) : A2(se, g(r, w), e);
            }
            return _([
                g(r, w)
            ]);
        }), w, r);
    }), Nq = F2(function(n, r) {
        var e = r.b;
        return c(n, r.a) || A2(ui, n, e);
    }), Gq = ir("nav"), Qq = mb("mdc-deprecated-list-group__subheader"), Uq = F2(function(n, r) {
        return A2(cl, A2(se, Qq, n), r);
    }), Hq = Gv(function(n) {
        switch(n){
            case 0:
                return "Zusammenfassung";
            case 1:
                return "Summary";
            case 2:
                return "Resumen";
            case 3:
                return "R\xe9capitulatif";
            default:
                return "\u041A\u0440\u0430\u0442\u043A\u043E\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435";
        }
    }), Vq = function(n) {
        var r = n.b;
        switch(r.$){
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            default:
                return w;
            case 5:
                return _([
                    r.a
                ]);
            case 6:
                return A2(Jo, Vq, r.b);
            case 7:
                return A2(Jo, Vq, r.a.a4);
            case 8:
                return _([
                    A2(Vg, function() {
                        return xe("## ");
                    }, Hq)
                ]);
        }
    }, Jq = F2(function(n, r) {
        var e = r.a.bc, t = A2(Ux, {
            g2: A2(Tx, F2(function(n, r) {
                if (4 !== n.$) return r;
                switch(n.a){
                    case 1:
                        return p(r, _([
                            A2(zp, e ? 3 : 2, n.b)
                        ]));
                    case 2:
                        return p(r, _([
                            A2(zp, e ? 4 : 3, n.b)
                        ]));
                    default:
                        return r;
                }
            }), w),
            h8: {
                gl: function() {
                    return "";
                },
                gu: function() {
                    return "";
                },
                gv: function() {
                    return "";
                },
                gW: function() {
                    return "";
                },
                hd: "",
                hf: function(n) {
                    return n.h4;
                },
                hl: ul(w),
                ho: function() {
                    return "";
                },
                hC: F2(function() {
                    return "";
                }),
                hW: F2(function() {
                    return "";
                }),
                hY: function() {
                    return "";
                },
                ik: function() {
                    return "";
                },
                il: function() {
                    return "";
                },
                io: function() {
                    return "";
                },
                ip: function() {
                    return "";
                },
                iq: F2(function() {
                    return "";
                }),
                ir: function() {
                    return "";
                },
                is: F2(function() {
                    return "";
                }),
                it: function() {
                    return "";
                },
                iu: function(n) {
                    return n;
                },
                iv: "",
                iD: function() {
                    return "";
                }
            }
        }, kc(A2(Ic, "\n\n", A2(Ou, Xl(n), A2(Jo, Vq, r.b)))));
        return t.$ ? t.a : kc(t.a);
    }), Xq = F2(function(n, r) {
        return A2(n, r.a, r.b);
    }), Zq = F7(function(n, r, e, t, u, a, i) {
        var o = A3($h, fh, A2(f$, A2(l$, fe, s$), _([
            A2(yb, _([
                mb("menu-item__text")
            ]), _([
                El(A3(Zl, n, "", Gv(function(n) {
                    return 1 === n ? "Log out" : "Abmelden";
                })))
            ]))
        ])), w), f = function(r) {
            var e = r.hX, t = r.gI.gD, u = A2(XB, t, i.dW.cm) && A3(Xi, !1, A2(su, Nq(t), Hg(function(n) {
                return n.e2;
            })), a);
            return A2(f$, A2(l$, oe(t), A2(v$, c(t, i.dW.bl) ? oe(1) : fe, s$)), _([
                A2(yb, _([
                    mb("menu-item__text")
                ]), (u ? A2(su, df, cl(_([
                    Eq
                ]))) : At)(_([
                    El(A2(Jq, n, e))
                ])))
            ]));
        }, s = Cd(r);
        return A2(Gq, _([
            mb("menu")
        ]), _([
            A2(jq, w, p(A2(Jo, function(n) {
                var r = n.a, e = n.b;
                return (r.hX.a.bc ? se(A2(Uq, w, _([
                    El(A3(Xi, "", mB, A2(zi, r.gI.gD.gF, i.dW.cg.dt)))
                ]))) : At)(_([
                    A2(Xq, $h(fh), A2(_o, f(r), A2(Ut, f, e)))
                ]));
            }, A2(Sq, F2(function(n, r) {
                var e = function(n) {
                    return n.hX.a.bc;
                }, t = F4(function(n, r, e, t) {
                    return A2(t, n(r), n(e));
                }), u = function(n) {
                    return n.gI.gD.gF;
                };
                return A4(t, e, n, r, ct) && A4(t, u, n, r, ct);
            }), A3(wf, s, i, r))), _([
                o
            ])))
        ]));
    }), Yq = F3(function(n, r, e) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }({
            bO: r,
            cd: n,
            ce: e
        });
    }), nz = F2(function(n, r) {
        return $(r, {
            c1: n
        });
    }), rz = F2(function(n, r) {
        return $(r, {
            cf: oe(n)
        });
    }), ez = F2(function(n, r) {
        return $(r, {
            dn: n
        });
    }), tz = F6(function(n, r, e, t, u, a) {
        var i = n.by, o = function(r) {
            var e = r.hX, t = r.gI.gD, i = A2(XB, t, a.dW.cm) && A3(Xi, !1, A2(su, Nq(t), Hg(function(n) {
                return n.e2;
            })), u);
            return A2(f$, A2(l$, ye(t), A2(v$, c(t, a.dW.bl) ? oe(1) : fe, s$)), _([
                A2(yb, _([
                    mb("menu-item__text")
                ]), (i ? A2(su, df, cl(_([
                    Eq
                ]))) : At)(_([
                    El(A2(Jq, n, e))
                ])))
            ]));
        }, f = Cd(r), s = A3(wf, f, a, r), d = A2(Gu, function(n) {
            return n.hX;
        }, A2(jo, function(n) {
            return c(n.gI.gD, a.dW.bl);
        }, s));
        return A3(Xi, El(""), function(r) {
            return A2(yb, _([
                mb("mobile-menu"),
                kq
            ]), _([
                A2(YC, A2(XC, !0, A2(nz, oe(A3(Yq, Wh, _([
                    mb("material-icons")
                ]), _([
                    El("menu")
                ]))), A2(ep, $e(!0), Sb))), A3(Xi, "Navigation", A2(su, xe("Navigation: "), Jq(n)), d)),
                A2(Xq, kh(A2(rz, $e(!1), A2(ez, i, Xh))), r)
            ]));
        }, ci(A2(Jo, function(n) {
            var r, e, t, i, f = n.a, s = n.b;
            return (f.hX.a.bc ? se((e = A2(zi, (r = f.gI.gD).gF, a.dW.cg.dt), i = !!A2(XB, t = r, a.dW.cm) && !u.$ && 1 !== A2(Yl, function(n) {
                return c(n.e2, t);
            }, u.a).$, A2(f$, A2(l$, ye(t), A2(v$, c(t, a.dW.bl) ? oe(1) : fe, s$)), _([
                A2(yb, _([
                    mb("menu-item__text")
                ]), (i ? A2(su, df, cl(_([
                    Eq
                ]))) : At)(_([
                    El(A3(Xi, "", mB, e))
                ])))
            ])))) : At)(A2(se, o(f), A2(Ut, o, s)));
        }, A2(Sq, F2(function(n, r) {
            var e = function(n) {
                return n.hX.a.bc;
            }, t = F4(function(n, r, e, t) {
                return A2(t, n(r), n(e));
            }), u = function(n) {
                return n.gI.gD.gF;
            };
            return A4(t, e, n, r, ct) && A4(t, u, n, r, ct);
        }), s))));
    }), uz = F2(function(n, r) {
        return $(r, {
            cz: n
        });
    }), cz = F2(function(n, r) {
        return $(r, {
            cf: oe(n)
        });
    }), az = F2(function(n, r) {
        return $(r, {
            dn: n
        });
    }), iz = function(n) {
        return {
            $: 1,
            a: n
        };
    }, oz = {
        $: 5
    }, fz = function(n) {
        return {
            $: 4,
            a: n
        };
    }, sz = yr, dz = function(n) {
        return or(mr(n));
    }, bz = mb("mdc-theme--primary"), lz = function(n) {
        return n ? p(lz(n / 2 | 0), A2(Bu, 2, n) ? "1" : "0") : "";
    }, vz = F2(function(n, r) {
        var e = r.iE, t = F2(function(r, t) {
            return 0 > f(lz(t.eR), lz(e)) ? A2(r, function(n) {
                var r, e, t;
                return {
                    gr: function() {
                        return w;
                    },
                    gF: function() {
                        return w;
                    },
                    gG: function() {
                        return w;
                    },
                    hb: function() {
                        return w;
                    },
                    hs: function(n) {
                        var r = n.ht, e = n.hv;
                        return _([
                            A2(yb, _([
                                mb("form-field form-field--full-width form-field--summary")
                            ]), function() {
                                switch(e.$){
                                    case 0:
                                        var t = e.a, u = A3(Zl, n.gy, "", A2(pi, !1, hp(n.dW)) ? Gv(function(n) {
                                            switch(n){
                                                case 0:
                                                    return "ja";
                                                case 1:
                                                    return "yes";
                                                case 2:
                                                    return "s\xed";
                                                case 3:
                                                    return "oui";
                                                default:
                                                    return "\u0434\u0430";
                                            }
                                        }) : Gv(function(n) {
                                            switch(n){
                                                case 0:
                                                    return "nein";
                                                case 1:
                                                case 2:
                                                    return "no";
                                                case 3:
                                                    return "non";
                                                default:
                                                    return "\u043D\u0435\u0442";
                                            }
                                        }));
                                        return Vo(_([
                                            A2(Vl, A2(su, A2(su, A2(su, df, Kl(w)), df), El), Hx(A3(Zl, n.gy, "", t) + ":\xa0" + u))
                                        ]));
                                    case 1:
                                        var c = e.b, a = (u = Qv(n.dW), A2(Gu, function(r) {
                                            return A3(Xi, r, function(n) {
                                                return n.a9;
                                            }, A2(jo, A2(su, ct(r), function(n) {
                                                return n.bK;
                                            }), A3(Zl, n.gy, w, A2(Vg, function() {
                                                return Bo;
                                            }, c))));
                                        }, u));
                                        return _([
                                            El(A3(Zl, n.gy, "", "$guestCodes" === A3(Zl, n.gy, "", r.a9) ? Gv(function(n) {
                                                return 1 === n ? "Number of guest codes" : "Anzahl G\xe4stecodes";
                                            }) : r.a9)),
                                            El(":\xa0"),
                                            El(A2(pi, "-", a))
                                        ]);
                                    case 2:
                                        return u = Qv(n.dW), _([
                                            El(A3(Zl, n.gy, "", r.a9)),
                                            El(":\xa0"),
                                            El(A2(pi, "-", u))
                                        ]);
                                    case 3:
                                        var i = e.a.ey, o = e.a.eU;
                                        return u = Qv(n.dW), c = n.gy.aS.h_({
                                            ey: i,
                                            eU: o
                                        }), a = A2(Gu, function(r) {
                                            return A3(Xi, r, A2(su, A2(Zl, n.gy, ""), function(n) {
                                                return n.a9;
                                            }), A2(jo, A2(su, ct(r), function(n) {
                                                return n.bK;
                                            }), c));
                                        }, u), _([
                                            El(A3(Zl, n.gy, "", r.a9)),
                                            El(":\xa0"),
                                            El(A2(pi, "-", a))
                                        ]);
                                    default:
                                        return a = A2(Gu, Zg, Qv(n.dW)), _([
                                            El(A3(Zl, n.gy, "", r.a9)),
                                            El(":\xa0"),
                                            El(A2(pi, "-", a))
                                        ]);
                                }
                            }())
                        ]);
                    },
                    hF: (r = function(n) {
                        return A2(Tx, F2(function(r, e) {
                            if (4 !== r.$) return e;
                            switch(r.a){
                                case 1:
                                    return p(e, _([
                                        A2(zp, n ? 3 : 2, r.b)
                                    ]));
                                case 2:
                                    return p(e, _([
                                        A2(zp, n ? 4 : 3, r.b)
                                    ]));
                                default:
                                    return e;
                            }
                        }), w);
                    }, e = F2(function(n, r) {
                        return A2(gp, A2(ep, r, A2(XC, !0, Sb)), A3(Zl, n, "", Gv(function(n) {
                            switch(n){
                                case 0:
                                    return "Bearbeiten";
                                case 1:
                                    return "Edit";
                                case 2:
                                    return "Editar";
                                case 3:
                                    return "Modifier";
                                default:
                                    return "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C";
                            }
                        })));
                    }), t = F4(function(t, u, a, i) {
                        return $(i, {
                            g2: r(u),
                            h8: $(n, {
                                hf: function(r) {
                                    var i = r.gq;
                                    return c(r.hA, u ? 3 : 2) ? n.hf($(r, {
                                        gq: p(i, _([
                                            A2(e, t, a)
                                        ]))
                                    })) : n.hf(r);
                                }
                            })
                        });
                    }), function(n) {
                        var r = n.ic;
                        return A2(Vl, A2(su, A2(su, A2(su, df, Kl(w)), df), El), A2(Ux, A4(t, n.gy, n.bc, n.gD, Hl), A3(Zl, n.gy, "", r)));
                    }),
                    hK: function() {
                        return w;
                    },
                    hX: function(n) {
                        var r = n.g0;
                        return n.hx ? Vo(_([
                            n.gD.gF ? w : _([
                                A2(Cl, w, w)
                            ]),
                            _([
                                A2(Il, _([
                                    mb("form-field form-field--full-width"),
                                    bz
                                ]), _([
                                    El(A3(Xi, "", mB, A2(zi, n.gD.gF, n.dW.cg.dt)))
                                ]))
                            ]),
                            r,
                            _([
                                A2(Cl, w, w)
                            ])
                        ])) : r;
                    },
                    dt: function(n) {
                        return Vo(A2(Re, function(r) {
                            return xe(_([
                                r > 0 ? A2(Pl, w, _([
                                    El("\xa0")
                                ])) : El(""),
                                A2(xl, _([
                                    mb("form-field form-field--full-width")
                                ]), _([
                                    El(p(A3(Zl, n.gy, "", Gv(function(n) {
                                        switch(n){
                                            case 0:
                                                return "Teilnehmende Person ";
                                            case 1:
                                                return "Participant ";
                                            case 2:
                                                return "Persona participante ";
                                            case 3:
                                                return "Personne participante ";
                                            default:
                                                return "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A ";
                                        }
                                    })), Be(r + 1)))
                                ]))
                            ]));
                        }, n.g1));
                    },
                    $9: function() {
                        return w;
                    },
                    iy: function(n) {
                        var r = n.$8;
                        return A2(Ou, function(n) {
                            return A2(Gu, function(r) {
                                return g(r.b, n);
                            }, A2(jo, A2(su, ct(n.fP), lt), r));
                        }, n.gy.cq).b ? A2(Ut, function(r) {
                            var e = r.a, t = r.b;
                            return A2(yb, _([
                                mb("ticket ticket--summary"),
                                mb("form-field form-field--summary form-field--full-width")
                            ]), _([
                                A2(yb, _([
                                    mb("ticket__label")
                                ]), _([
                                    A2(cl, _([
                                        mb("ticket__title")
                                    ]), _([
                                        El(Be(e) + "x\xa0" + A3(Zl, n.gy, "", t.a9))
                                    ])),
                                    A3(Xi, El(""), function(r) {
                                        return A2(cl, _([
                                            mb("ticket__price")
                                        ]), _([
                                            A2(cl, w, _([
                                                El(!r && t.eG ? "kostenfrei" : (e > 1 ? xe("\xe1\xa0") : At)(A2(Ev, n.gy.e, r)))
                                            ]))
                                        ]));
                                    }, t.fn)
                                ]))
                            ]));
                        }, A2(Ou, function(n) {
                            return A2(Gu, function(r) {
                                return g(r.b, n);
                            }, A2(jo, A2(su, ct(n.fP), lt), r));
                        }, n.gy.cq)) : _([
                            A2(yb, _([
                                mb("form-field form-field--summary form-field--full-width")
                            ]), _([
                                El(A3(Zl, n.gy, "", n.fd))
                            ]))
                        ]);
                    }
                };
            }(n), t) : w;
        });
        return {
            gr: t(function(n) {
                return n.gr;
            }),
            gF: t(function(n) {
                return n.gF;
            }),
            gG: t(function(n) {
                return n.gG;
            }),
            hb: t(function(n) {
                return n.hb;
            }),
            hs: t(function(n) {
                return n.hs;
            }),
            hF: t(function(n) {
                return n.hF;
            }),
            hK: t(function(n) {
                return n.hK;
            }),
            hX: t(function(n) {
                return n.hX;
            }),
            dt: t(function(n) {
                return n.dt;
            }),
            $9: t(function(n) {
                return n.$9;
            }),
            iy: t(function(n) {
                return n.iy;
            })
        };
    }), gz = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), hz = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $z = F3(function(n, r, e) {
        return {
            $: 3,
            a: n,
            b: r,
            c: e
        };
    }), mz = F3(function(n, r, e) {
        switch(e.$){
            case 0:
                return A3(gc, function() {
                    return iz(n.dW);
                }, hz, r.bo);
            case 1:
                return iz(e.a);
            case 2:
                return A2(gz, e.a, e.b);
            default:
                return A3($z, e.a, e.b, e.c);
        }
    }), pz = F6(function(n, r, e, t, u, c) {
        var a = function(r) {
            return A2($B, c, A4(Pd, n, u, A2(vz, vp, r), function() {
                return w;
            })).a.iK;
        }, i = A4(Pd, n, u, Vx(iA), a), o = A2($B, c, i), f = o.a, s = o.b, d = gB(f.bo);
        return A2(yb, _([
            mb("form-wrapper__inner"),
            A2(gb, "style", KC(s.gy.aS.eh))
        ]), _([
            A3(Xi, El(""), ch(A2(Xi, oz, function(n) {
                return iz($(u, {
                    bl: n
                }));
            })), A2(Gu, function(r) {
                return A4(r, u.bl, n.ba, d, s);
            }, r)),
            A2(yb, _([
                mb("form-wrapper__wrapper")
            ]), _([
                A3(Xi, El(""), ch(A2(gc, fz, function(n) {
                    return iz($(u, {
                        bl: n
                    }));
                })), A2(Gu, function(r) {
                    return A3(r, n.ba, d, s);
                }, e)),
                A2(ch, A2(mz, s, f), A3(dz, "div", A2(se, mb("form"), A2(Ut, sz(jt), t)), A2(Re, A2(su, co, F2(function(n, r) {
                    return Be(n.gE) + ":" + Be(n.gF) + ":" + Be(r);
                })(u.bl)), f.iK)))
            ]))
        ]));
    }), wz = A2(yb, _([
        mb("loading")
    ]), _([
        Og(Gb)
    ])), yz = rq(function(n) {
        switch(n.$){
            case 0:
                return aq(n.a);
            case 1:
                return r = n.a, A2(yb, _([
                    mb("error-view")
                ]), _([
                    A3(gc, function(n) {
                        return A2(Kl, w, _([
                            El(n)
                        ]));
                    }, yb(w), Hx(A3(Zl, r, "", Gv(function(n) {
                        switch(n){
                            case 0:
                                return "\n# Kontingent ersch\xf6pft\n\nDas Kontingent f\xfcr den Code **" + r.eb + "** ist ersch\xf6pft. Haben Sie sich verschrieben oder sind Sie bereits angemeldet?\n";
                            case 1:
                                return "\n# Quota Exceeded\n\nThe quota for the code **" + r.eb + "** is exceeded. Did you spell the code incorrectly, or have you registered already?\n";
                            case 2:
                                return "\n# Contingente agotado\n\nSe ha superado la cuota para el c\xf3digo **" + r.eb + "** . \xbfHa escrito mal el c\xf3digo o ya se has registrado anteriormente?\n";
                            case 3:
                                return "\nContingent d\xe9pass\xe9\n\nLe contingent pour le code **" + r.eb + "** est d\xe9pass\xe9. Avez-vous fait une erreur ou \xeates-vous d\xe9j\xe0 inscrit ?\n";
                            default:
                                return "\n\u041A\u0432\u043E\u0442\u0430 \u0438\u0441\u0447\u0435\u0440\u043F\u0430\u043D\u0430\n\n\u041A\u0432\u043E\u0442\u0430 \u0434\u043B\u044F \u043A\u043E\u0434\u0430 **" + r.eb + "** \u0438\u0441\u0447\u0435\u0440\u043F\u0430\u043D\u0430. \u0412\u044B \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043B\u0438 \u043E\u043F\u0435\u0447\u0430\u0442\u043A\u0443 \u0438\u043B\u0438 \u0443\u0436\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043B\u0438\u0441\u044C?\n";
                        }
                    })))),
                    A3(gc, function(n) {
                        return A2(Kl, w, _([
                            El(n)
                        ]));
                    }, yb(w), Hx(A3(Zl, r, "", Gv(function(n) {
                        switch(n){
                            case 0:
                                return "\nBei Fragen zur Registrierung stehen wir Ihnen gern unter den folgenden Kontaktdaten zur Verf\xfcgung:\n\nTelefon: [+49(0)511 898813-0](tel:+49511898813-0) - E-Mail: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                            case 1:
                                return "\nPlease do not hesitate to contact us in case of any further questions regarding your registration.\n\nPhone: [+49(0)511 898813-0](tel:+49511898813-0) - E-Mail: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                            case 2:
                                return "\nSi tiene alguna pregunta sobre la inscripci\xf3n, no dude en ponerse en contacto con nosotros utilizando los siguientes datos de contacto:\n\nTel\xe9fono: [+49(0)511 898813-0](tel:+49511898813-0) - Correo electr\xf3nico: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                            case 3:
                                return "\nSi vous avez des questions concernant l'enregistrement, n'h\xe9sitez pas \xe0 nous contacter aux coordonn\xe9es suivantes:\n\nT\xe9l.: [+49(0)511 898813-0](tel:+49511898813-0) - E-mail: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                            default:
                                return "\n\u0415\u0441\u043B\u0438 \u0443 \u0432\u0430\u0441 \u0432\u043E\u0437\u043D\u0438\u043A\u043D\u0443\u0442 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0432\u0430\u0448\u0435\u0439 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438, \u043E\u0431\u0440\u0430\u0449\u0430\u0439\u0442\u0435\u0441\u044C \u043A \u043D\u0430\u043C:\n\n\u0413-\u0436\u0430 \u0421\u0430\u043D\u0434\u0440\u0438\u043D\u0435 \u0427\u0435\u0445, \u0442\u0435\u043B\u0435\u0444\u043E\u043D: [+49(0)511 898813-0](tel:+49511 898813-0) - \u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                        }
                    }))))
                ]));
            case 2:
                return function(n) {
                    var r, e = n.t, t = IC(n.C), u = vd(n);
                    return A2(yb, _([
                        mb("form-wrapper")
                    ]), _([
                        (r = n, r.aS.hD ? El("") : A2(yb, _([
                            mb("debug-banner")
                        ]), _([
                            El(A3(Zl, r, "", Gv(function(n) {
                                switch(n){
                                    case 0:
                                        return "Die Registrierung befindet sich in der Entwicklung. Zahlung ist NICHT live.";
                                    case 1:
                                        return "This registration is being developed. Payment is NOT live.";
                                    case 2:
                                        return "La inscripci\xf3n est\xe1 en desarrollo. El pago NO est\xe1 activo.";
                                    case 3:
                                        return "L'inscription est en cours de r\xe9alisation. Le paiement n'est PAS en direct.";
                                    default:
                                        return "\u042D\u0442\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0430\u0434\u0438\u0438 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0438. \u0424\u0443\u043D\u043A\u0446\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u041D\u0415 \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \xab\u043B\u0430\u0439\u0444\xbb.";
                                }
                            })))
                        ]))),
                        A2(ch, fq, A6(pz, u, Wd(n.aE) ? Oq(n.aF) ? fe : oe(A3(Zq, {
                            gQ: n.gQ,
                            e: n.e
                        }, n.C, t)) : fe, Wd(n.aE) && 1 === Oq(n.aF) ? oe(A3(tz, {
                            gQ: n.gQ,
                            e: n.e,
                            by: n.by
                        }, n.C, t)) : fe, w, e, t)),
                        A2(Tq, A2(cz, oq, A2(az, A3(Xi, !1, Wq, n.ar), dq)), {
                            gc: _([
                                A2(gp, A2(ep, oq, Sb), "Abbrechen"),
                                A2(gp, A2(uz, _([
                                    Rq
                                ]), A2(ep, A3(Xi, oq, A2(su, A2(su, iq, function(n) {
                                    return n.dl;
                                }), Fq), n.ar), Sb)), "Enternen")
                            ]),
                            bX: p(_([
                                A2(Pl, w, _([
                                    El("Durch das Entfernen des Teilnehmenden werden die folgenden assoziierten Buchungsdaten entfernt.")
                                ]))
                            ]), A3(Xi, w, A2(su, A2(su, A2(su, A2(su, df, ch(function() {
                                return sq;
                            })), yb(_([
                                A2(il, "opacity", "0.5")
                            ]))), function(n) {
                                return n.bX;
                            }), Fq), n.ar)),
                            iA: "Teilnehmenden entfernen"
                        })
                    ]));
                }(n.a);
            case 3:
                return wz;
            case 4:
                return function(n) {
                    return A3(gc, function(r) {
                        return aq({
                            gQ: n.gQ,
                            cT: eq(r),
                            e: n.e
                        });
                    }, yb(w), Hx(A3(Zl, n, "", n.ai)));
                }(n.a);
            case 5:
                return function(n) {
                    return A2(yb, _([
                        mb("error-view")
                    ]), _([
                        A3(gc, function(n) {
                            return A2(Kl, w, _([
                                El(n)
                            ]));
                        }, yb(w), Hx(A3(Zl, n, "", Gv(function(n) {
                            switch(n){
                                case 0:
                                    return "\n# Zahlung\n\nBitte schlie\xdfen Sie die Zahlung bei unserem externen Zahlungsprovider ab.\n";
                                case 1:
                                    return "\n# Checkout\n\nPlease complete the payment with our external payment provider.\n";
                                case 2:
                                    return "\n# Pago\n\nPor favor, completa el pago con nuestro proveedor de pago externo.\n";
                                case 3:
                                    return "\n# R\xe8glement\n\nVeuillez finaliser le r\xe8glement aupr\xe8s de notre prestataire de paiement externe.\n";
                                default:
                                    return "\n# \u0427\u0435\u043A-\u0430\u0443\u0442\n\n\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0435 \u043F\u043B\u0430\u0442\u0435\u0436 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043D\u0430\u0448\u0435\u0433\u043E \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 \u043F\u043B\u0430\u0442\u0451\u0436\u043D\u044B\u0445 \u0443\u0441\u043B\u0443\u0433\n";
                            }
                        })))),
                        A3(Ob, "slot", _([
                            A2(gb, "name", "checkout")
                        ]), w)
                    ]));
                }(n.a);
            default:
                return function(n) {
                    return A3(gc, function(r) {
                        return aq({
                            gQ: n.gQ,
                            cT: eq(r),
                            e: n.e
                        });
                    }, yb(w), Hx(A3(Zl, n, "", n.bU)));
                }(n.a);
        }
        var r;
    });
    Kx = {
        Frontend: {
            init: tu({
                hr: $A,
                im: KA,
                cw: zC,
                iK: yz
            })(A2(wt, function(n) {
                return A2(wt, function(r) {
                    return A2(wt, function(e) {
                        return A2(wt, function(t) {
                            return A2(wt, function(u) {
                                return A2(wt, function(c) {
                                    return A2(wt, function(a) {
                                        return A2(wt, function(i) {
                                            return A2(wt, function(o) {
                                                return A2(wt, function(f) {
                                                    return A2(wt, function(s) {
                                                        return A2(wt, function(d) {
                                                            return A2(wt, function(b) {
                                                                return A2(wt, function(l) {
                                                                    return A2(wt, function(v) {
                                                                        return It({
                                                                            m: v,
                                                                            aH: l,
                                                                            eb: b,
                                                                            cJ: d,
                                                                            as: s,
                                                                            ez: f,
                                                                            eR: o,
                                                                            an: i,
                                                                            c7: a,
                                                                            e: c,
                                                                            aN: u,
                                                                            C: t,
                                                                            cq: e,
                                                                            dW: r,
                                                                            aF: n
                                                                        });
                                                                    }, A2(uu, "auth", yc(_([
                                                                        ii(fe),
                                                                        A2(kt, oe, A2(wt, function(n) {
                                                                            return A2(wt, function(r) {
                                                                                return It({
                                                                                    gA: r,
                                                                                    gB: n
                                                                                });
                                                                            }, A2(uu, "cookieName", dc));
                                                                        }, A2(uu, "cookieValue", dc)))
                                                                    ]))));
                                                                }, A2(uu, "checkout", yc(_([
                                                                    ii(fe),
                                                                    A2(kt, oe, bi)
                                                                ]))));
                                                            }, A2(uu, "code", yc(_([
                                                                ii(fe),
                                                                A2(kt, oe, dc)
                                                            ]))));
                                                        }, A2(uu, "crashed", yc(_([
                                                            ii(fe),
                                                            A2(kt, oe, dc)
                                                        ]))));
                                                    }, A2(uu, "discounts", yc(_([
                                                        ii(fe),
                                                        A2(kt, oe, bi)
                                                    ]))));
                                                }, A2(uu, "exhibitor", yc(_([
                                                    ii(fe),
                                                    A2(kt, oe, dc)
                                                ]))));
                                            }, A2(uu, "id", yc(_([
                                                ii(fe),
                                                A2(kt, oe, dc)
                                            ]))));
                                        }, A2(uu, "idempotencyToken", dc));
                                    }, A2(uu, "loading", yc(_([
                                        ii(fe),
                                        A2(kt, oe, yt)
                                    ]))));
                                }, A2(uu, "locale", yc(_([
                                    ii(fe),
                                    A2(kt, oe, dc)
                                ]))));
                            }, A2(uu, "origin", dc));
                        }, A2(uu, "pages", yc(_([
                            ii(fe),
                            A2(kt, oe, bi)
                        ]))));
                    }, A2(uu, "tickets", yc(_([
                        ii(fe),
                        A2(kt, oe, bi)
                    ]))));
                }, A2(uu, "values", yc(_([
                    ii(fe),
                    A2(kt, oe, bi)
                ]))));
            }, A2(uu, "width", yc(_([
                ii(fe),
                A2(kt, oe, xf)
            ])))))(0)
        }
    }, n.Elm ? function n(r, e) {
        for(var t in e)t in r ? "init" == t ? u(6) : n(r[t], e[t]) : r[t] = e[t];
    }(n.Elm, Kx) : n.Elm = Kx;
}($ca3222cb63d04ad8$exports);


var $179193dbefa94847$exports = {};
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/material-components/material-components-web/blob/master/LICENSE
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $179193dbefa94847$exports = factory();
})($179193dbefa94847$exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = "./packages/material-components-web/index.ts");
    /******/ }({
        /***/ "./node_modules/@webcomponents/custom-elements/custom-elements.min.js": /*!****************************************************************************!*\
  !*** ./node_modules/@webcomponents/custom-elements/custom-elements.min.js ***!
  \****************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            (function() {
                /*

 Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 This code may only be used under the BSD style license found at
 http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 Google as part of the polymer project is also subject to an additional IP
 rights grant found at http://polymer.github.io/PATENTS.txt
*/ "use strict";
                var n = window.Document.prototype.createElement, p = window.Document.prototype.createElementNS, aa = window.Document.prototype.importNode, ba = window.Document.prototype.prepend, ca = window.Document.prototype.append, da = window.DocumentFragment.prototype.prepend, ea = window.DocumentFragment.prototype.append, q = window.Node.prototype.cloneNode, r = window.Node.prototype.appendChild, t = window.Node.prototype.insertBefore, u = window.Node.prototype.removeChild, v = window.Node.prototype.replaceChild, w = Object.getOwnPropertyDescriptor(window.Node.prototype, "textContent"), y = window.Element.prototype.attachShadow, z = Object.getOwnPropertyDescriptor(window.Element.prototype, "innerHTML"), A = window.Element.prototype.getAttribute, B = window.Element.prototype.setAttribute, C = window.Element.prototype.removeAttribute, D = window.Element.prototype.toggleAttribute, E = window.Element.prototype.getAttributeNS, F = window.Element.prototype.setAttributeNS, G = window.Element.prototype.removeAttributeNS, H = window.Element.prototype.insertAdjacentElement, fa = window.Element.prototype.insertAdjacentHTML, ha = window.Element.prototype.prepend, ia = window.Element.prototype.append, ja = window.Element.prototype.before, ka = window.Element.prototype.after, la = window.Element.prototype.replaceWith, ma = window.Element.prototype.remove, na = window.HTMLElement, I = Object.getOwnPropertyDescriptor(window.HTMLElement.prototype, "innerHTML"), oa = window.HTMLElement.prototype.insertAdjacentElement, pa = window.HTMLElement.prototype.insertAdjacentHTML;
                var qa = new Set;
                "annotation-xml color-profile font-face font-face-src font-face-uri font-face-format font-face-name missing-glyph".split(" ").forEach(function(a) {
                    return qa.add(a);
                });
                function ra(a) {
                    var b = qa.has(a);
                    a = /^[a-z][.0-9_a-z]*-[-.0-9_a-z]*$/.test(a);
                    return !b && a;
                }
                var sa = document.contains ? document.contains.bind(document) : document.documentElement.contains.bind(document.documentElement);
                function J(a) {
                    var b = a.isConnected;
                    if (void 0 !== b) return b;
                    if (sa(a)) return !0;
                    for(; a && !(a.__CE_isImportDocument || a instanceof Document);)a = a.parentNode || (window.ShadowRoot && a instanceof ShadowRoot ? a.host : void 0);
                    return !(!a || !(a.__CE_isImportDocument || a instanceof Document));
                }
                function K(a) {
                    var b = a.children;
                    if (b) return Array.prototype.slice.call(b);
                    b = [];
                    for(a = a.firstChild; a; a = a.nextSibling)a.nodeType === Node.ELEMENT_NODE && b.push(a);
                    return b;
                }
                function L(a, b) {
                    for(; b && b !== a && !b.nextSibling;)b = b.parentNode;
                    return b && b !== a ? b.nextSibling : null;
                }
                function M(a, b, d) {
                    for(var f = a; f;){
                        if (f.nodeType === Node.ELEMENT_NODE) {
                            var c = f;
                            b(c);
                            var e = c.localName;
                            if ("link" === e && "import" === c.getAttribute("rel")) {
                                f = c.import;
                                void 0 === d && (d = new Set);
                                if (f instanceof Node && !d.has(f)) for(d.add(f), f = f.firstChild; f; f = f.nextSibling)M(f, b, d);
                                f = L(a, c);
                                continue;
                            } else if ("template" === e) {
                                f = L(a, c);
                                continue;
                            }
                            if (c = c.__CE_shadowRoot) for(c = c.firstChild; c; c = c.nextSibling)M(c, b, d);
                        }
                        f = f.firstChild ? f.firstChild : L(a, f);
                    }
                }
                function N() {
                    var a = !(null === O || void 0 === O || !O.noDocumentConstructionObserver), b = !(null === O || void 0 === O || !O.shadyDomFastWalk);
                    this.m = [];
                    this.g = [];
                    this.j = !1;
                    this.shadyDomFastWalk = b;
                    this.I = !a;
                }
                function P(a, b, d, f) {
                    var c = window.ShadyDOM;
                    if (a.shadyDomFastWalk && c && c.inUse) {
                        if (b.nodeType === Node.ELEMENT_NODE && d(b), b.querySelectorAll) for(a = c.nativeMethods.querySelectorAll.call(b, "*"), b = 0; b < a.length; b++)d(a[b]);
                    } else M(b, d, f);
                }
                function ta(a, b) {
                    a.j = !0;
                    a.m.push(b);
                }
                function ua(a, b) {
                    a.j = !0;
                    a.g.push(b);
                }
                function Q(a, b) {
                    a.j && P(a, b, function(d) {
                        return R(a, d);
                    });
                }
                function R(a, b) {
                    if (a.j && !b.__CE_patched) {
                        b.__CE_patched = !0;
                        for(var d = 0; d < a.m.length; d++)a.m[d](b);
                        for(d = 0; d < a.g.length; d++)a.g[d](b);
                    }
                }
                function S(a, b) {
                    var d = [];
                    P(a, b, function(c) {
                        return d.push(c);
                    });
                    for(b = 0; b < d.length; b++){
                        var f = d[b];
                        1 === f.__CE_state ? a.connectedCallback(f) : T(a, f);
                    }
                }
                function U(a, b) {
                    var d = [];
                    P(a, b, function(c) {
                        return d.push(c);
                    });
                    for(b = 0; b < d.length; b++){
                        var f = d[b];
                        1 === f.__CE_state && a.disconnectedCallback(f);
                    }
                }
                function V(a, b, d) {
                    d = void 0 === d ? {} : d;
                    var f = d.J, c = d.upgrade || function(g) {
                        return T(a, g);
                    }, e = [];
                    P(a, b, function(g) {
                        a.j && R(a, g);
                        if ("link" === g.localName && "import" === g.getAttribute("rel")) {
                            var h = g.import;
                            h instanceof Node && (h.__CE_isImportDocument = !0, h.__CE_registry = document.__CE_registry);
                            h && "complete" === h.readyState ? h.__CE_documentLoadHandled = !0 : g.addEventListener("load", function() {
                                var k = g.import;
                                if (!k.__CE_documentLoadHandled) {
                                    k.__CE_documentLoadHandled = !0;
                                    var l = new Set;
                                    f && (f.forEach(function(m) {
                                        return l.add(m);
                                    }), l.delete(k));
                                    V(a, k, {
                                        J: l,
                                        upgrade: c
                                    });
                                }
                            });
                        } else e.push(g);
                    }, f);
                    for(b = 0; b < e.length; b++)c(e[b]);
                }
                function T(a, b) {
                    try {
                        var d = b.ownerDocument, f = d.__CE_registry;
                        var c = f && (d.defaultView || d.__CE_isImportDocument) ? W(f, b.localName) : void 0;
                        if (c && void 0 === b.__CE_state) {
                            c.constructionStack.push(b);
                            try {
                                try {
                                    if (new c.constructorFunction !== b) throw Error("The custom element constructor did not produce the element being upgraded.");
                                } finally{
                                    c.constructionStack.pop();
                                }
                            } catch (k) {
                                throw b.__CE_state = 2, k;
                            }
                            b.__CE_state = 1;
                            b.__CE_definition = c;
                            if (c.attributeChangedCallback && b.hasAttributes()) {
                                var e = c.observedAttributes;
                                for(c = 0; c < e.length; c++){
                                    var g = e[c], h = b.getAttribute(g);
                                    null !== h && a.attributeChangedCallback(b, g, null, h, null);
                                }
                            }
                            J(b) && a.connectedCallback(b);
                        }
                    } catch (k) {
                        X(k);
                    }
                }
                N.prototype.connectedCallback = function(a) {
                    var b = a.__CE_definition;
                    if (b.connectedCallback) try {
                        b.connectedCallback.call(a);
                    } catch (d) {
                        X(d);
                    }
                };
                N.prototype.disconnectedCallback = function(a) {
                    var b = a.__CE_definition;
                    if (b.disconnectedCallback) try {
                        b.disconnectedCallback.call(a);
                    } catch (d) {
                        X(d);
                    }
                };
                N.prototype.attributeChangedCallback = function(a, b, d, f, c) {
                    var e = a.__CE_definition;
                    if (e.attributeChangedCallback && -1 < e.observedAttributes.indexOf(b)) try {
                        e.attributeChangedCallback.call(a, b, d, f, c);
                    } catch (g) {
                        X(g);
                    }
                };
                function va(a, b, d, f) {
                    var c = b.__CE_registry;
                    if (c && (null === f || "http://www.w3.org/1999/xhtml" === f) && (c = W(c, d))) try {
                        var e = new c.constructorFunction;
                        if (void 0 === e.__CE_state || void 0 === e.__CE_definition) throw Error("Failed to construct '" + d + "': The returned value was not constructed with the HTMLElement constructor.");
                        if ("http://www.w3.org/1999/xhtml" !== e.namespaceURI) throw Error("Failed to construct '" + d + "': The constructed element's namespace must be the HTML namespace.");
                        if (e.hasAttributes()) throw Error("Failed to construct '" + d + "': The constructed element must not have any attributes.");
                        if (null !== e.firstChild) throw Error("Failed to construct '" + d + "': The constructed element must not have any children.");
                        if (null !== e.parentNode) throw Error("Failed to construct '" + d + "': The constructed element must not have a parent node.");
                        if (e.ownerDocument !== b) throw Error("Failed to construct '" + d + "': The constructed element's owner document is incorrect.");
                        if (e.localName !== d) throw Error("Failed to construct '" + d + "': The constructed element's local name is incorrect.");
                        return e;
                    } catch (g) {
                        return X(g), b = null === f ? n.call(b, d) : p.call(b, f, d), Object.setPrototypeOf(b, HTMLUnknownElement.prototype), b.__CE_state = 2, b.__CE_definition = void 0, R(a, b), b;
                    }
                    b = null === f ? n.call(b, d) : p.call(b, f, d);
                    R(a, b);
                    return b;
                }
                function X(a) {
                    var b = "", d = "", f = 0, c = 0;
                    a instanceof Error ? (b = a.message, d = a.sourceURL || a.fileName || "", f = a.line || a.lineNumber || 0, c = a.column || a.columnNumber || 0) : b = "Uncaught " + String(a);
                    var e = void 0;
                    void 0 === ErrorEvent.prototype.initErrorEvent ? e = new ErrorEvent("error", {
                        cancelable: !0,
                        message: b,
                        filename: d,
                        lineno: f,
                        colno: c,
                        error: a
                    }) : (e = document.createEvent("ErrorEvent"), e.initErrorEvent("error", !1, !0, b, d, f), e.preventDefault = function() {
                        Object.defineProperty(this, "defaultPrevented", {
                            configurable: !0,
                            get: function() {
                                return !0;
                            }
                        });
                    });
                    void 0 === e.error && Object.defineProperty(e, "error", {
                        configurable: !0,
                        enumerable: !0,
                        get: function() {
                            return a;
                        }
                    });
                    window.dispatchEvent(e);
                    e.defaultPrevented || console.error(a);
                }
                function wa() {
                    var a = this;
                    this.g = void 0;
                    this.F = new Promise(function(b) {
                        a.l = b;
                    });
                }
                wa.prototype.resolve = function(a) {
                    if (this.g) throw Error("Already resolved.");
                    this.g = a;
                    this.l(a);
                };
                function xa(a) {
                    var b = document;
                    this.l = void 0;
                    this.h = a;
                    this.g = b;
                    V(this.h, this.g);
                    "loading" === this.g.readyState && (this.l = new MutationObserver(this.G.bind(this)), this.l.observe(this.g, {
                        childList: !0,
                        subtree: !0
                    }));
                }
                function ya(a) {
                    a.l && a.l.disconnect();
                }
                xa.prototype.G = function(a) {
                    var b = this.g.readyState;
                    "interactive" !== b && "complete" !== b || ya(this);
                    for(b = 0; b < a.length; b++)for(var d = a[b].addedNodes, f = 0; f < d.length; f++)V(this.h, d[f]);
                };
                function Y(a) {
                    this.s = new Map;
                    this.u = new Map;
                    this.C = new Map;
                    this.A = !1;
                    this.B = new Map;
                    this.o = function(b) {
                        return b();
                    };
                    this.i = !1;
                    this.v = [];
                    this.h = a;
                    this.D = a.I ? new xa(a) : void 0;
                }
                Y.prototype.H = function(a, b) {
                    var d = this;
                    if (!(b instanceof Function)) throw new TypeError("Custom element constructor getters must be functions.");
                    za(this, a);
                    this.s.set(a, b);
                    this.v.push(a);
                    this.i || (this.i = !0, this.o(function() {
                        return Aa(d);
                    }));
                };
                Y.prototype.define = function(a, b) {
                    var d = this;
                    if (!(b instanceof Function)) throw new TypeError("Custom element constructors must be functions.");
                    za(this, a);
                    Ba(this, a, b);
                    this.v.push(a);
                    this.i || (this.i = !0, this.o(function() {
                        return Aa(d);
                    }));
                };
                function za(a, b) {
                    if (!ra(b)) throw new SyntaxError("The element name '" + b + "' is not valid.");
                    if (W(a, b)) throw Error("A custom element with name '" + (b + "' has already been defined."));
                    if (a.A) throw Error("A custom element is already being defined.");
                }
                function Ba(a, b, d) {
                    a.A = !0;
                    var f;
                    try {
                        var c = d.prototype;
                        if (!(c instanceof Object)) throw new TypeError("The custom element constructor's prototype is not an object.");
                        var e = function(m) {
                            var x = c[m];
                            if (void 0 !== x && !(x instanceof Function)) throw Error("The '" + m + "' callback must be a function.");
                            return x;
                        };
                        var g = e("connectedCallback");
                        var h = e("disconnectedCallback");
                        var k = e("adoptedCallback");
                        var l = (f = e("attributeChangedCallback")) && d.observedAttributes || [];
                    } catch (m) {
                        throw m;
                    } finally{
                        a.A = !1;
                    }
                    d = {
                        localName: b,
                        constructorFunction: d,
                        connectedCallback: g,
                        disconnectedCallback: h,
                        adoptedCallback: k,
                        attributeChangedCallback: f,
                        observedAttributes: l,
                        constructionStack: []
                    };
                    a.u.set(b, d);
                    a.C.set(d.constructorFunction, d);
                    return d;
                }
                Y.prototype.upgrade = function(a) {
                    V(this.h, a);
                };
                function Aa(a) {
                    if (!1 !== a.i) {
                        a.i = !1;
                        for(var b = [], d = a.v, f = new Map, c = 0; c < d.length; c++)f.set(d[c], []);
                        V(a.h, document, {
                            upgrade: function(k) {
                                if (void 0 === k.__CE_state) {
                                    var l = k.localName, m = f.get(l);
                                    m ? m.push(k) : a.u.has(l) && b.push(k);
                                }
                            }
                        });
                        for(c = 0; c < b.length; c++)T(a.h, b[c]);
                        for(c = 0; c < d.length; c++){
                            for(var e = d[c], g = f.get(e), h = 0; h < g.length; h++)T(a.h, g[h]);
                            (e = a.B.get(e)) && e.resolve(void 0);
                        }
                        d.length = 0;
                    }
                }
                Y.prototype.get = function(a) {
                    if (a = W(this, a)) return a.constructorFunction;
                };
                Y.prototype.whenDefined = function(a) {
                    if (!ra(a)) return Promise.reject(new SyntaxError("'" + a + "' is not a valid custom element name."));
                    var b = this.B.get(a);
                    if (b) return b.F;
                    b = new wa;
                    this.B.set(a, b);
                    var d = this.u.has(a) || this.s.has(a);
                    a = -1 === this.v.indexOf(a);
                    d && a && b.resolve(void 0);
                    return b.F;
                };
                Y.prototype.polyfillWrapFlushCallback = function(a) {
                    this.D && ya(this.D);
                    var b = this.o;
                    this.o = function(d) {
                        return a(function() {
                            return b(d);
                        });
                    };
                };
                function W(a, b) {
                    var d = a.u.get(b);
                    if (d) return d;
                    if (d = a.s.get(b)) {
                        a.s.delete(b);
                        try {
                            return Ba(a, b, d());
                        } catch (f) {
                            X(f);
                        }
                    }
                }
                Y.prototype.define = Y.prototype.define;
                Y.prototype.upgrade = Y.prototype.upgrade;
                Y.prototype.get = Y.prototype.get;
                Y.prototype.whenDefined = Y.prototype.whenDefined;
                Y.prototype.polyfillDefineLazy = Y.prototype.H;
                Y.prototype.polyfillWrapFlushCallback = Y.prototype.polyfillWrapFlushCallback;
                function Z(a, b, d) {
                    function f(c) {
                        return function(e) {
                            for(var g = [], h = 0; h < arguments.length; ++h)g[h] = arguments[h];
                            h = [];
                            for(var k = [], l = 0; l < g.length; l++){
                                var m = g[l];
                                m instanceof Element && J(m) && k.push(m);
                                if (m instanceof DocumentFragment) for(m = m.firstChild; m; m = m.nextSibling)h.push(m);
                                else h.push(m);
                            }
                            c.apply(this, g);
                            for(g = 0; g < k.length; g++)U(a, k[g]);
                            if (J(this)) for(g = 0; g < h.length; g++)k = h[g], k instanceof Element && S(a, k);
                        };
                    }
                    void 0 !== d.prepend && (b.prepend = f(d.prepend));
                    void 0 !== d.append && (b.append = f(d.append));
                }
                function Ca(a) {
                    Document.prototype.createElement = function(b) {
                        return va(a, this, b, null);
                    };
                    Document.prototype.importNode = function(b, d) {
                        b = aa.call(this, b, !!d);
                        this.__CE_registry ? V(a, b) : Q(a, b);
                        return b;
                    };
                    Document.prototype.createElementNS = function(b, d) {
                        return va(a, this, d, b);
                    };
                    Z(a, Document.prototype, {
                        prepend: ba,
                        append: ca
                    });
                }
                function Da(a) {
                    function b(f) {
                        return function(c) {
                            for(var e = [], g = 0; g < arguments.length; ++g)e[g] = arguments[g];
                            g = [];
                            for(var h = [], k = 0; k < e.length; k++){
                                var l = e[k];
                                l instanceof Element && J(l) && h.push(l);
                                if (l instanceof DocumentFragment) for(l = l.firstChild; l; l = l.nextSibling)g.push(l);
                                else g.push(l);
                            }
                            f.apply(this, e);
                            for(e = 0; e < h.length; e++)U(a, h[e]);
                            if (J(this)) for(e = 0; e < g.length; e++)h = g[e], h instanceof Element && S(a, h);
                        };
                    }
                    var d = Element.prototype;
                    void 0 !== ja && (d.before = b(ja));
                    void 0 !== ka && (d.after = b(ka));
                    void 0 !== la && (d.replaceWith = function(f) {
                        for(var c = [], e = 0; e < arguments.length; ++e)c[e] = arguments[e];
                        e = [];
                        for(var g = [], h = 0; h < c.length; h++){
                            var k = c[h];
                            k instanceof Element && J(k) && g.push(k);
                            if (k instanceof DocumentFragment) for(k = k.firstChild; k; k = k.nextSibling)e.push(k);
                            else e.push(k);
                        }
                        h = J(this);
                        la.apply(this, c);
                        for(c = 0; c < g.length; c++)U(a, g[c]);
                        if (h) for(U(a, this), c = 0; c < e.length; c++)g = e[c], g instanceof Element && S(a, g);
                    });
                    void 0 !== ma && (d.remove = function() {
                        var f = J(this);
                        ma.call(this);
                        f && U(a, this);
                    });
                }
                function Ea(a) {
                    function b(c, e) {
                        Object.defineProperty(c, "innerHTML", {
                            enumerable: e.enumerable,
                            configurable: !0,
                            get: e.get,
                            set: function(g) {
                                var h = this, k = void 0;
                                J(this) && (k = [], P(a, this, function(x) {
                                    x !== h && k.push(x);
                                }));
                                e.set.call(this, g);
                                if (k) for(var l = 0; l < k.length; l++){
                                    var m = k[l];
                                    1 === m.__CE_state && a.disconnectedCallback(m);
                                }
                                this.ownerDocument.__CE_registry ? V(a, this) : Q(a, this);
                                return g;
                            }
                        });
                    }
                    function d(c, e) {
                        c.insertAdjacentElement = function(g, h) {
                            var k = J(h);
                            g = e.call(this, g, h);
                            k && U(a, h);
                            J(g) && S(a, h);
                            return g;
                        };
                    }
                    function f(c, e) {
                        function g(h, k) {
                            for(var l = []; h !== k; h = h.nextSibling)l.push(h);
                            for(k = 0; k < l.length; k++)V(a, l[k]);
                        }
                        c.insertAdjacentHTML = function(h, k) {
                            h = h.toLowerCase();
                            if ("beforebegin" === h) {
                                var l = this.previousSibling;
                                e.call(this, h, k);
                                g(l || this.parentNode.firstChild, this);
                            } else if ("afterbegin" === h) l = this.firstChild, e.call(this, h, k), g(this.firstChild, l);
                            else if ("beforeend" === h) l = this.lastChild, e.call(this, h, k), g(l || this.firstChild, null);
                            else if ("afterend" === h) l = this.nextSibling, e.call(this, h, k), g(this.nextSibling, l);
                            else throw new SyntaxError("The value provided (" + String(h) + ") is not one of 'beforebegin', 'afterbegin', 'beforeend', or 'afterend'.");
                        };
                    }
                    y && (Element.prototype.attachShadow = function(c) {
                        c = y.call(this, c);
                        if (a.j && !c.__CE_patched) {
                            c.__CE_patched = !0;
                            for(var e = 0; e < a.m.length; e++)a.m[e](c);
                        }
                        return this.__CE_shadowRoot = c;
                    });
                    z && z.get ? b(Element.prototype, z) : I && I.get ? b(HTMLElement.prototype, I) : ua(a, function(c) {
                        b(c, {
                            enumerable: !0,
                            configurable: !0,
                            get: function() {
                                return q.call(this, !0).innerHTML;
                            },
                            set: function(e) {
                                var g = "template" === this.localName, h = g ? this.content : this, k = p.call(document, this.namespaceURI, this.localName);
                                for(k.innerHTML = e; 0 < h.childNodes.length;)u.call(h, h.childNodes[0]);
                                for(e = g ? k.content : k; 0 < e.childNodes.length;)r.call(h, e.childNodes[0]);
                            }
                        });
                    });
                    Element.prototype.setAttribute = function(c, e) {
                        if (1 !== this.__CE_state) return B.call(this, c, e);
                        var g = A.call(this, c);
                        B.call(this, c, e);
                        e = A.call(this, c);
                        a.attributeChangedCallback(this, c, g, e, null);
                    };
                    Element.prototype.setAttributeNS = function(c, e, g) {
                        if (1 !== this.__CE_state) return F.call(this, c, e, g);
                        var h = E.call(this, c, e);
                        F.call(this, c, e, g);
                        g = E.call(this, c, e);
                        a.attributeChangedCallback(this, e, h, g, c);
                    };
                    Element.prototype.removeAttribute = function(c) {
                        if (1 !== this.__CE_state) return C.call(this, c);
                        var e = A.call(this, c);
                        C.call(this, c);
                        null !== e && a.attributeChangedCallback(this, c, e, null, null);
                    };
                    D && (Element.prototype.toggleAttribute = function(c, e) {
                        if (1 !== this.__CE_state) return D.call(this, c, e);
                        var g = A.call(this, c), h = null !== g;
                        e = D.call(this, c, e);
                        h !== e && a.attributeChangedCallback(this, c, g, e ? "" : null, null);
                        return e;
                    });
                    Element.prototype.removeAttributeNS = function(c, e) {
                        if (1 !== this.__CE_state) return G.call(this, c, e);
                        var g = E.call(this, c, e);
                        G.call(this, c, e);
                        var h = E.call(this, c, e);
                        g !== h && a.attributeChangedCallback(this, e, g, h, c);
                    };
                    oa ? d(HTMLElement.prototype, oa) : H && d(Element.prototype, H);
                    pa ? f(HTMLElement.prototype, pa) : fa && f(Element.prototype, fa);
                    Z(a, Element.prototype, {
                        prepend: ha,
                        append: ia
                    });
                    Da(a);
                }
                var Fa = {};
                function Ga(a) {
                    function b() {
                        var d = this.constructor;
                        var f = document.__CE_registry.C.get(d);
                        if (!f) throw Error("Failed to construct a custom element: The constructor was not registered with `customElements`.");
                        var c = f.constructionStack;
                        if (0 === c.length) return c = n.call(document, f.localName), Object.setPrototypeOf(c, d.prototype), c.__CE_state = 1, c.__CE_definition = f, R(a, c), c;
                        var e = c.length - 1, g = c[e];
                        if (g === Fa) throw Error("Failed to construct '" + f.localName + "': This element was already constructed.");
                        c[e] = Fa;
                        Object.setPrototypeOf(g, d.prototype);
                        R(a, g);
                        return g;
                    }
                    b.prototype = na.prototype;
                    Object.defineProperty(HTMLElement.prototype, "constructor", {
                        writable: !0,
                        configurable: !0,
                        enumerable: !1,
                        value: b
                    });
                    window.HTMLElement = b;
                }
                function Ha(a) {
                    function b(d, f) {
                        Object.defineProperty(d, "textContent", {
                            enumerable: f.enumerable,
                            configurable: !0,
                            get: f.get,
                            set: function(c) {
                                if (this.nodeType === Node.TEXT_NODE) f.set.call(this, c);
                                else {
                                    var e = void 0;
                                    if (this.firstChild) {
                                        var g = this.childNodes, h = g.length;
                                        if (0 < h && J(this)) {
                                            e = Array(h);
                                            for(var k = 0; k < h; k++)e[k] = g[k];
                                        }
                                    }
                                    f.set.call(this, c);
                                    if (e) for(c = 0; c < e.length; c++)U(a, e[c]);
                                }
                            }
                        });
                    }
                    Node.prototype.insertBefore = function(d, f) {
                        if (d instanceof DocumentFragment) {
                            var c = K(d);
                            d = t.call(this, d, f);
                            if (J(this)) for(f = 0; f < c.length; f++)S(a, c[f]);
                            return d;
                        }
                        c = d instanceof Element && J(d);
                        f = t.call(this, d, f);
                        c && U(a, d);
                        J(this) && S(a, d);
                        return f;
                    };
                    Node.prototype.appendChild = function(d) {
                        if (d instanceof DocumentFragment) {
                            var f = K(d);
                            d = r.call(this, d);
                            if (J(this)) for(var c = 0; c < f.length; c++)S(a, f[c]);
                            return d;
                        }
                        f = d instanceof Element && J(d);
                        c = r.call(this, d);
                        f && U(a, d);
                        J(this) && S(a, d);
                        return c;
                    };
                    Node.prototype.cloneNode = function(d) {
                        d = q.call(this, !!d);
                        this.ownerDocument.__CE_registry ? V(a, d) : Q(a, d);
                        return d;
                    };
                    Node.prototype.removeChild = function(d) {
                        var f = d instanceof Element && J(d), c = u.call(this, d);
                        f && U(a, d);
                        return c;
                    };
                    Node.prototype.replaceChild = function(d, f) {
                        if (d instanceof DocumentFragment) {
                            var c = K(d);
                            d = v.call(this, d, f);
                            if (J(this)) for(U(a, f), f = 0; f < c.length; f++)S(a, c[f]);
                            return d;
                        }
                        c = d instanceof Element && J(d);
                        var e = v.call(this, d, f), g = J(this);
                        g && U(a, f);
                        c && U(a, d);
                        g && S(a, d);
                        return e;
                    };
                    w && w.get ? b(Node.prototype, w) : ta(a, function(d) {
                        b(d, {
                            enumerable: !0,
                            configurable: !0,
                            get: function() {
                                for(var f = [], c = this.firstChild; c; c = c.nextSibling)c.nodeType !== Node.COMMENT_NODE && f.push(c.textContent);
                                return f.join("");
                            },
                            set: function(f) {
                                for(; this.firstChild;)u.call(this, this.firstChild);
                                null != f && "" !== f && r.call(this, document.createTextNode(f));
                            }
                        });
                    });
                }
                var O = window.customElements;
                function Ia() {
                    var a = new N;
                    Ga(a);
                    Ca(a);
                    Z(a, DocumentFragment.prototype, {
                        prepend: da,
                        append: ea
                    });
                    Ha(a);
                    Ea(a);
                    window.CustomElementRegistry = Y;
                    a = new Y(a);
                    document.__CE_registry = a;
                    Object.defineProperty(window, "customElements", {
                        configurable: !0,
                        enumerable: !0,
                        value: a
                    });
                }
                O && !O.forcePolyfill && "function" == typeof O.define && "function" == typeof O.get || Ia();
                window.__CE_installPolyfill = Ia;
            }).call(self);
        //# sourceMappingURL=custom-elements.min.js.map
        /***/ },
        /***/ "./node_modules/focus-trap/dist/focus-trap.esm.js": /*!********************************************************!*\
  !*** ./node_modules/focus-trap/dist/focus-trap.esm.js ***!
  \********************************************************/ /*! exports provided: createFocusTrap */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFocusTrap", function() {
                return createFocusTrap;
            });
            /* harmony import */ var tabbable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tabbable */ "./node_modules/tabbable/dist/index.esm.js");
            /*!
* focus-trap 6.9.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    })), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread2(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                        _defineProperty(target, key, source[key]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    });
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            var activeFocusTraps = function() {
                var trapQueue = [];
                return {
                    activateTrap: function activateTrap(trap) {
                        if (trapQueue.length > 0) {
                            var activeTrap = trapQueue[trapQueue.length - 1];
                            if (activeTrap !== trap) activeTrap.pause();
                        }
                        var trapIndex = trapQueue.indexOf(trap);
                        if (trapIndex === -1) trapQueue.push(trap);
                        else {
                            // move this existing trap to the front of the queue
                            trapQueue.splice(trapIndex, 1);
                            trapQueue.push(trap);
                        }
                    },
                    deactivateTrap: function deactivateTrap(trap) {
                        var trapIndex = trapQueue.indexOf(trap);
                        if (trapIndex !== -1) trapQueue.splice(trapIndex, 1);
                        if (trapQueue.length > 0) trapQueue[trapQueue.length - 1].unpause();
                    }
                };
            }();
            var isSelectableInput = function isSelectableInput(node) {
                return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
            };
            var isEscapeEvent = function isEscapeEvent(e) {
                return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
            };
            var isTabEvent = function isTabEvent(e) {
                return e.key === "Tab" || e.keyCode === 9;
            };
            var delay = function delay(fn) {
                return setTimeout(fn, 0);
            }; // Array.find/findIndex() are not supported on IE; this replicates enough
            //  of Array.findIndex() for our needs
            var findIndex = function findIndex(arr, fn) {
                var idx = -1;
                arr.every(function(value, i) {
                    if (fn(value)) {
                        idx = i;
                        return false; // break
                    }
                    return true; // next
                });
                return idx;
            };
            /**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var valueOrHandler = function valueOrHandler(value) {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
                return typeof value === "function" ? value.apply(void 0, params) : value;
            };
            var getActualTarget = function getActualTarget(event) {
                // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
                //  shadow host. However, event.target.composedPath() will be an array of
                //  nodes "clicked" from inner-most (the actual element inside the shadow) to
                //  outer-most (the host HTML document). If we have access to composedPath(),
                //  then use its first element; otherwise, fall back to event.target (and
                //  this only works for an _open_ shadow DOM; otherwise,
                //  composedPath()[0] === event.target always).
                return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
            };
            var createFocusTrap = function createFocusTrap(elements, userOptions) {
                // SSR: a live trap shouldn't be created in this type of environment so this
                //  should be safe code to execute if the `document` option isn't specified
                var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
                var config = _objectSpread2({
                    returnFocusOnDeactivate: true,
                    escapeDeactivates: true,
                    delayInitialFocus: true
                }, userOptions);
                var state = {
                    // containers given to createFocusTrap()
                    // @type {Array<HTMLElement>}
                    containers: [],
                    // list of objects identifying tabbable nodes in `containers` in the trap
                    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
                    //  is active, but the trap should never get to a state where there isn't at least one group
                    //  with at least one tabbable node in it (that would lead to an error condition that would
                    //  result in an error being thrown)
                    // @type {Array<{
                    //   container: HTMLElement,
                    //   tabbableNodes: Array<HTMLElement>, // empty if none
                    //   focusableNodes: Array<HTMLElement>, // empty if none
                    //   firstTabbableNode: HTMLElement|null,
                    //   lastTabbableNode: HTMLElement|null,
                    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
                    // }>}
                    containerGroups: [],
                    // same order/length as `containers` list
                    // references to objects in `containerGroups`, but only those that actually have
                    //  tabbable nodes in them
                    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
                    //  the same length
                    tabbableGroups: [],
                    nodeFocusedBeforeActivation: null,
                    mostRecentlyFocusedNode: null,
                    active: false,
                    paused: false,
                    // timer ID for when delayInitialFocus is true and initial focus in this trap
                    //  has been delayed during activation
                    delayInitialFocusTimer: undefined
                };
                var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
                /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
                    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
                };
                /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element) {
                    // NOTE: search `containerGroups` because it's possible a group contains no tabbable
                    //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
                    //  and we still need to find the element in there
                    return state.containerGroups.findIndex(function(_ref) {
                        var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
                        return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
                        //  web components if the `tabbableOptions.getShadowRoot` option was used for
                        //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
                        //  look inside web components even if open)
                        tabbableNodes.find(function(node) {
                            return node === element;
                        });
                    });
                };
                /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */ var getNodeForOption = function getNodeForOption(optionName) {
                    var optionValue = config[optionName];
                    if (typeof optionValue === "function") {
                        for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
                        optionValue = optionValue.apply(void 0, params);
                    }
                    if (optionValue === true) optionValue = undefined; // use default value
                    if (!optionValue) {
                        if (optionValue === undefined || optionValue === false) return optionValue;
                         // else, empty string (invalid), null (invalid), 0 (invalid)
                        throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
                    }
                    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
                    if (typeof optionValue === "string") {
                        node = doc.querySelector(optionValue); // resolve to node, or null if fails
                        if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
                    }
                    return node;
                };
                var getInitialFocusNode = function getInitialFocusNode() {
                    var node = getNodeForOption("initialFocus"); // false explicitly indicates we want no initialFocus at all
                    if (node === false) return false;
                    if (node === undefined) {
                        // option not specified: use fallback options
                        if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
                        else {
                            var firstTabbableGroup = state.tabbableGroups[0];
                            var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                            node = firstTabbableNode || getNodeForOption("fallbackFocus");
                        }
                    }
                    if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
                    return node;
                };
                var updateTabbableNodes = function updateTabbableNodes() {
                    state.containerGroups = state.containers.map(function(container) {
                        var tabbableNodes = Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["tabbable"])(container, config.tabbableOptions); // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
                        //  are a superset of tabbable nodes
                        var focusableNodes = Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["focusable"])(container, config.tabbableOptions);
                        return {
                            container: container,
                            tabbableNodes: tabbableNodes,
                            focusableNodes: focusableNodes,
                            firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
                            lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
                            /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                                var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                                // NOTE: If tabindex is positive (in order to manipulate the tab order separate
                                //  from the DOM order), this __will not work__ because the list of focusableNodes,
                                //  while it contains tabbable nodes, does not sort its nodes in any order other
                                //  than DOM order, because it can't: Where would you place focusable (but not
                                //  tabbable) nodes in that order? They have no order, because they aren't tabbale...
                                // Support for positive tabindex is already broken and hard to manage (possibly
                                //  not supportable, TBD), so this isn't going to make things worse than they
                                //  already are, and at least makes things better for the majority of cases where
                                //  tabindex is either 0/unset or negative.
                                // FYI, positive tabindex issue: https://github.com/focus-trap/focus-trap/issues/375
                                var nodeIdx = focusableNodes.findIndex(function(n) {
                                    return n === node;
                                });
                                if (nodeIdx < 0) return undefined;
                                if (forward) return focusableNodes.slice(nodeIdx + 1).find(function(n) {
                                    return Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["isTabbable"])(n, config.tabbableOptions);
                                });
                                return focusableNodes.slice(0, nodeIdx).reverse().find(function(n) {
                                    return Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["isTabbable"])(n, config.tabbableOptions);
                                });
                            }
                        };
                    });
                    state.tabbableGroups = state.containerGroups.filter(function(group) {
                        return group.tabbableNodes.length > 0;
                    }); // throw if no groups have tabbable nodes and we don't have a fallback focus node either
                    if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus") // returning false not supported for this option
                    ) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
                };
                var tryFocus = function tryFocus(node) {
                    if (node === false) return;
                    if (node === doc.activeElement) return;
                    if (!node || !node.focus) {
                        tryFocus(getInitialFocusNode());
                        return;
                    }
                    node.focus({
                        preventScroll: !!config.preventScroll
                    });
                    state.mostRecentlyFocusedNode = node;
                    if (isSelectableInput(node)) node.select();
                };
                var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
                    var node = getNodeForOption("setReturnFocus", previousActiveElement);
                    return node ? node : node === false ? false : previousActiveElement;
                }; // This needs to be done on mousedown and touchstart instead of click
                // so that it precedes the focus event.
                var checkPointerDown = function checkPointerDown(e) {
                    var target = getActualTarget(e);
                    if (findContainerIndex(target) >= 0) // allow the click since it ocurred inside the trap
                    return;
                    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
                        // immediately deactivate the trap
                        trap.deactivate({
                            // if, on deactivation, we should return focus to the node originally-focused
                            //  when the trap was activated (or the configured `setReturnFocus` node),
                            //  then assume it's also OK to return focus to the outside node that was
                            //  just clicked, causing deactivation, as long as that node is focusable;
                            //  if it isn't focusable, then return focus to the original node focused
                            //  on activation (or the configured `setReturnFocus` node)
                            // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                            //  which will result in the outside click setting focus to the node
                            //  that was clicked, whether it's focusable or not; by setting
                            //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                            //  on activation (or the configured `setReturnFocus` node)
                            returnFocus: config.returnFocusOnDeactivate && !Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["isFocusable"])(target, config.tabbableOptions)
                        });
                        return;
                    } // This is needed for mobile devices.
                    // (If we'll only let `click` events through,
                    // then on mobile they will be blocked anyways if `touchstart` is blocked.)
                    if (valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
                    return;
                     // otherwise, prevent the click
                    e.preventDefault();
                }; // In case focus escapes the trap for some strange reason, pull it back in.
                var checkFocusIn = function checkFocusIn(e) {
                    var target = getActualTarget(e);
                    var targetContained = findContainerIndex(target) >= 0; // In Firefox when you Tab out of an iframe the Document is briefly focused.
                    if (targetContained || target instanceof Document) {
                        if (targetContained) state.mostRecentlyFocusedNode = target;
                    } else {
                        // escaped! pull it back in to where it just left
                        e.stopImmediatePropagation();
                        tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
                    }
                }; // Hijack Tab events on the first and last focusable nodes of the trap,
                // in order to prevent focus from escaping. If it escapes for even a
                // moment it can end up scrolling the page and causing confusion so we
                // kind of need to capture the action at the keydown phase.
                var checkTab = function checkTab(e) {
                    var target = getActualTarget(e);
                    updateTabbableNodes();
                    var destinationNode = null;
                    if (state.tabbableGroups.length > 0) {
                        // make sure the target is actually contained in a group
                        // NOTE: the target may also be the container itself if it's focusable
                        //  with tabIndex='-1' and was given initial focus
                        var containerIndex = findContainerIndex(target);
                        var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
                        if (containerIndex < 0) {
                            // target not found in any group: quite possible focus has escaped the trap,
                            //  so bring it back in to...
                            if (e.shiftKey) // ...the last node in the last group
                            destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                            else // ...the first node in the first group
                            destinationNode = state.tabbableGroups[0].firstTabbableNode;
                        } else if (e.shiftKey) {
                            // REVERSE
                            // is the target the first tabbable node in a group?
                            var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref2) {
                                var firstTabbableNode = _ref2.firstTabbableNode;
                                return target === firstTabbableNode;
                            });
                            if (startOfGroupIndex < 0 && (containerGroup.container === target || Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["isFocusable"])(target, config.tabbableOptions) && !Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["isTabbable"])(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                            //  a non-tabbable node that was given focus (i.e. tabindex is negative
                            //  and user clicked on it or node was programmatically given focus)
                            //  and is not followed by any other tabbable node, in which
                            //  case, we should handle shift+tab as if focus were on the container's
                            //  first tabbable node, and go to the last tabbable node of the LAST group
                            startOfGroupIndex = containerIndex;
                            if (startOfGroupIndex >= 0) {
                                // YES: then shift+tab should go to the last tabbable node in the
                                //  previous group (and wrap around to the last tabbable node of
                                //  the LAST group if it's the first tabbable node of the FIRST group)
                                var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                                var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                                destinationNode = destinationGroup.lastTabbableNode;
                            }
                        } else {
                            // FORWARD
                            // is the target the last tabbable node in a group?
                            var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
                                var lastTabbableNode = _ref3.lastTabbableNode;
                                return target === lastTabbableNode;
                            });
                            if (lastOfGroupIndex < 0 && (containerGroup.container === target || Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["isFocusable"])(target, config.tabbableOptions) && !Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["isTabbable"])(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                            //  a non-tabbable node that was given focus (i.e. tabindex is negative
                            //  and user clicked on it or node was programmatically given focus)
                            //  and is not followed by any other tabbable node, in which
                            //  case, we should handle tab as if focus were on the container's
                            //  last tabbable node, and go to the first tabbable node of the FIRST group
                            lastOfGroupIndex = containerIndex;
                            if (lastOfGroupIndex >= 0) {
                                // YES: then tab should go to the first tabbable node in the next
                                //  group (and wrap around to the first tabbable node of the FIRST
                                //  group if it's the last tabbable node of the LAST group)
                                var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                                var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                                destinationNode = _destinationGroup.firstTabbableNode;
                            }
                        }
                    } else // NOTE: the fallbackFocus option does not support returning false to opt-out
                    destinationNode = getNodeForOption("fallbackFocus");
                    if (destinationNode) {
                        e.preventDefault();
                        tryFocus(destinationNode);
                    } // else, let the browser take care of [shift+]tab and move the focus
                };
                var checkKey = function checkKey(e) {
                    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
                        e.preventDefault();
                        trap.deactivate();
                        return;
                    }
                    if (isTabEvent(e)) {
                        checkTab(e);
                        return;
                    }
                };
                var checkClick = function checkClick(e) {
                    var target = getActualTarget(e);
                    if (findContainerIndex(target) >= 0) return;
                    if (valueOrHandler(config.clickOutsideDeactivates, e)) return;
                    if (valueOrHandler(config.allowOutsideClick, e)) return;
                    e.preventDefault();
                    e.stopImmediatePropagation();
                }; //
                // EVENT LISTENERS
                //
                var addListeners = function addListeners() {
                    if (!state.active) return;
                     // There can be only one listening focus trap at a time
                    activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
                    // that caused the focus trap activation.
                    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
                        tryFocus(getInitialFocusNode());
                    }) : tryFocus(getInitialFocusNode());
                    doc.addEventListener("focusin", checkFocusIn, true);
                    doc.addEventListener("mousedown", checkPointerDown, {
                        capture: true,
                        passive: false
                    });
                    doc.addEventListener("touchstart", checkPointerDown, {
                        capture: true,
                        passive: false
                    });
                    doc.addEventListener("click", checkClick, {
                        capture: true,
                        passive: false
                    });
                    doc.addEventListener("keydown", checkKey, {
                        capture: true,
                        passive: false
                    });
                    return trap;
                };
                var removeListeners = function removeListeners() {
                    if (!state.active) return;
                    doc.removeEventListener("focusin", checkFocusIn, true);
                    doc.removeEventListener("mousedown", checkPointerDown, true);
                    doc.removeEventListener("touchstart", checkPointerDown, true);
                    doc.removeEventListener("click", checkClick, true);
                    doc.removeEventListener("keydown", checkKey, true);
                    return trap;
                }; //
                // TRAP DEFINITION
                //
                trap = {
                    get active () {
                        return state.active;
                    },
                    get paused () {
                        return state.paused;
                    },
                    activate: function activate(activateOptions) {
                        if (state.active) return this;
                        var onActivate = getOption(activateOptions, "onActivate");
                        var onPostActivate = getOption(activateOptions, "onPostActivate");
                        var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
                        if (!checkCanFocusTrap) updateTabbableNodes();
                        state.active = true;
                        state.paused = false;
                        state.nodeFocusedBeforeActivation = doc.activeElement;
                        if (onActivate) onActivate();
                        var finishActivation = function finishActivation() {
                            if (checkCanFocusTrap) updateTabbableNodes();
                            addListeners();
                            if (onPostActivate) onPostActivate();
                        };
                        if (checkCanFocusTrap) {
                            checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                            return this;
                        }
                        finishActivation();
                        return this;
                    },
                    deactivate: function deactivate(deactivateOptions) {
                        if (!state.active) return this;
                        var options = _objectSpread2({
                            onDeactivate: config.onDeactivate,
                            onPostDeactivate: config.onPostDeactivate,
                            checkCanReturnFocus: config.checkCanReturnFocus
                        }, deactivateOptions);
                        clearTimeout(state.delayInitialFocusTimer); // noop if undefined
                        state.delayInitialFocusTimer = undefined;
                        removeListeners();
                        state.active = false;
                        state.paused = false;
                        activeFocusTraps.deactivateTrap(trap);
                        var onDeactivate = getOption(options, "onDeactivate");
                        var onPostDeactivate = getOption(options, "onPostDeactivate");
                        var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
                        var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
                        if (onDeactivate) onDeactivate();
                        var finishDeactivation = function finishDeactivation() {
                            delay(function() {
                                if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                                if (onPostDeactivate) onPostDeactivate();
                            });
                        };
                        if (returnFocus && checkCanReturnFocus) {
                            checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                            return this;
                        }
                        finishDeactivation();
                        return this;
                    },
                    pause: function pause() {
                        if (state.paused || !state.active) return this;
                        state.paused = true;
                        removeListeners();
                        return this;
                    },
                    unpause: function unpause() {
                        if (!state.paused || !state.active) return this;
                        state.paused = false;
                        updateTabbableNodes();
                        addListeners();
                        return this;
                    },
                    updateContainerElements: function updateContainerElements(containerElements) {
                        var elementsAsArray = [].concat(containerElements).filter(Boolean);
                        state.containers = elementsAsArray.map(function(element) {
                            return typeof element === "string" ? doc.querySelector(element) : element;
                        });
                        if (state.active) updateTabbableNodes();
                        return this;
                    }
                }; // initialize container elements
                trap.updateContainerElements(elements);
                return trap;
            };
        //# sourceMappingURL=focus-trap.esm.js.map
        /***/ },
        /***/ "./node_modules/tabbable/dist/index.esm.js": /*!*************************************************!*\
  !*** ./node_modules/tabbable/dist/index.esm.js ***!
  \*************************************************/ /*! exports provided: focusable, isFocusable, isTabbable, tabbable */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "focusable", function() {
                return focusable;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFocusable", function() {
                return isFocusable;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTabbable", function() {
                return isTabbable;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tabbable", function() {
                return tabbable;
            });
            /*!
* tabbable 5.3.3
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ var candidateSelectors = [
                "input",
                "select",
                "textarea",
                "a[href]",
                "button",
                "[tabindex]:not(slot)",
                "audio[controls]",
                "video[controls]",
                '[contenteditable]:not([contenteditable="false"])',
                "details>summary:first-of-type",
                "details"
            ];
            var candidateSelector = /* #__PURE__ */ candidateSelectors.join(",");
            var NoElement = typeof Element === "undefined";
            var matches = NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
            var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
                return element.getRootNode();
            } : function(element) {
                return element.ownerDocument;
            };
            /**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var getCandidates = function getCandidates(el, includeContainer, filter) {
                var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
                if (includeContainer && matches.call(el, candidateSelector)) candidates.unshift(el);
                candidates = candidates.filter(filter);
                return candidates;
            };
            /**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidatesScope
 * @property {Element} scope contains inner candidates
 * @property {Element[]} candidates
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidatesScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidatesScope>}
 */ var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
                var candidates = [];
                var elementsToCheck = Array.from(elements);
                while(elementsToCheck.length){
                    var element = elementsToCheck.shift();
                    if (element.tagName === "SLOT") {
                        // add shadow dom slot scope (slot itself cannot be focusable)
                        var assigned = element.assignedElements();
                        var content = assigned.length ? assigned : element.children;
                        var nestedCandidates = getCandidatesIteratively(content, true, options);
                        if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
                        else candidates.push({
                            scope: element,
                            candidates: nestedCandidates
                        });
                    } else {
                        // check candidate element
                        var validCandidate = matches.call(element, candidateSelector);
                        if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
                         // iterate over shadow content if possible
                        var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
                        typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
                        var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);
                        if (shadowRoot && validShadowRoot) {
                            // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                            //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                            //  child candidates found because they're likely slotted elements (elements that are
                            //  children of the web component element (which has the shadow), in the light dom, but
                            //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                            //  _after_ we return from this recursive call
                            var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                            if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                            else candidates.push({
                                scope: element,
                                candidates: _nestedCandidates
                            });
                        } else // there's not shadow so just dig into the element's (light dom) children
                        //  __without__ giving the element special scope treatment
                        elementsToCheck.unshift.apply(elementsToCheck, element.children);
                    }
                }
                return candidates;
            };
            var getTabindex = function getTabindex(node, isScope) {
                if (node.tabIndex < 0) {
                    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
                    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
                    // yet they are still part of the regular tab order; in FF, they get a default
                    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
                    // order, consider their tab index to be 0.
                    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
                    // so if they don't have a tabindex attribute specifically set, assume it's 0.
                    //
                    // isScope is positive for custom element with shadow root or slot that by default
                    // have tabIndex -1, but need to be sorted by document order in order for their
                    // content to be inserted in the correct position
                    if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute("tabindex"), 10))) return 0;
                }
                return node.tabIndex;
            };
            var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
                return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
            };
            var isInput = function isInput(node) {
                return node.tagName === "INPUT";
            };
            var isHiddenInput = function isHiddenInput(node) {
                return isInput(node) && node.type === "hidden";
            };
            var isDetailsWithSummary = function isDetailsWithSummary(node) {
                var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
                    return child.tagName === "SUMMARY";
                });
                return r;
            };
            var getCheckedRadio = function getCheckedRadio(nodes, form) {
                for(var i = 0; i < nodes.length; i++){
                    if (nodes[i].checked && nodes[i].form === form) return nodes[i];
                }
            };
            var isTabbableRadio = function isTabbableRadio(node) {
                if (!node.name) return true;
                var radioScope = node.form || getRootNode(node);
                var queryRadios = function queryRadios(name) {
                    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
                };
                var radioSet;
                if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
                else try {
                    radioSet = queryRadios(node.name);
                } catch (err) {
                    // eslint-disable-next-line no-console
                    console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
                    return false;
                }
                var checked = getCheckedRadio(radioSet, node.form);
                return !checked || checked === node;
            };
            var isRadio = function isRadio(node) {
                return isInput(node) && node.type === "radio";
            };
            var isNonTabbableRadio = function isNonTabbableRadio(node) {
                return isRadio(node) && !isTabbableRadio(node);
            };
            var isZeroArea = function isZeroArea(node) {
                var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
                return width === 0 && height === 0;
            };
            var isHidden = function isHidden(node, _ref) {
                var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
                // NOTE: visibility will be `undefined` if node is detached from the document
                //  (see notes about this further down), which means we will consider it visible
                //  (this is legacy behavior from a very long way back)
                // NOTE: we check this regardless of `displayCheck="none"` because this is a
                //  _visibility_ check, not a _display_ check
                if (getComputedStyle(node).visibility === "hidden") return true;
                var isDirectSummary = matches.call(node, "details>summary:first-of-type");
                var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
                if (matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
                 // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
                //  (but NOT _the_ document; see second 'If' comment below for more).
                // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
                //  is attached, and the one we need to check if it's in the document or not (because the
                //  shadow, and all nodes it contains, is never considered in the document since shadows
                //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
                //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
                //  visibility, including all the nodes it contains). The host could be any normal node,
                //  or a custom element (i.e. web component). Either way, that's the one that is considered
                //  part of the document, not the shadow root, nor any of its children (i.e. the node being
                //  tested).
                // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
                //  document (per the docs) and while it's a Document-type object, that document does not
                //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
                //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
                //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
                //  node is actually detached.
                var nodeRootHost = getRootNode(node).host;
                var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);
                if (!displayCheck || displayCheck === "full") {
                    if (typeof getShadowRoot === "function") {
                        // figure out if we should consider the node to be in an undisclosed shadow and use the
                        //  'non-zero-area' fallback
                        var originalNode = node;
                        while(node){
                            var parentElement = node.parentElement;
                            var rootNode = getRootNode(node);
                            if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                            ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                            //  fall back to a non-zero-area test
                            return isZeroArea(node);
                            else if (node.assignedSlot) // iterate up slot
                            node = node.assignedSlot;
                            else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                            node = rootNode.host;
                            else // iterate up normal dom
                            node = parentElement;
                        }
                        node = originalNode;
                    } // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
                    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
                    //  it might be a falsy value, which means shadow DOM support is disabled
                    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
                    //  now we can just test to see if it would normally be visible or not, provided it's
                    //  attached to the main document.
                    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
                    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
                    if (nodeIsAttached) // this works wherever the node is: if there's at least one client rect, it's
                    //  somehow displayed; it also covers the CSS 'display: contents' case where the
                    //  node itself is hidden in place of its contents; and there's no need to search
                    //  up the hierarchy either
                    return !node.getClientRects().length;
                     // Else, the node isn't attached to the document, which means the `getClientRects()`
                //  API will __always__ return zero rects (this can happen, for example, if React
                //  is used to render nodes onto a detached tree, as confirmed in this thread:
                //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
                //
                // It also means that even window.getComputedStyle(node).display will return `undefined`
                //  because styles are only computed for nodes that are in the document.
                //
                // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
                //  somehow. Though it was never stated officially, anyone who has ever used tabbable
                //  APIs on nodes in detached containers has actually implicitly used tabbable in what
                //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
                //  considering __everything__ to be visible because of the innability to determine styles.
                } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
                //  whether it's displayed, and that a detached node will __always__ have a zero-area
                //  client rect, we don't special-case for whether the node is attached or not. In
                //  this mode, we do want to consider nodes that have a zero area to be hidden at all
                //  times, and that includes attached or not.
                return isZeroArea(node);
                 // visible, as far as we can tell, or per current `displayCheck` mode
                return false;
            }; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
            //  unless they are in the _first_ <legend> element of the top-most disabled
            //  fieldset
            var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
                if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
                    var parentNode = node.parentElement; // check if `node` is contained in a disabled <fieldset>
                    while(parentNode){
                        if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                            // look for the first <legend> among the children of the disabled <fieldset>
                            for(var i = 0; i < parentNode.children.length; i++){
                                var child = parentNode.children.item(i); // when the first <legend> (in document order) is found
                                if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                                // return whether `node` is a descendant of its first <legend>
                                return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                            } // the disabled <fieldset> containing `node` has no <legend>
                            return true;
                        }
                        parentNode = parentNode.parentElement;
                    }
                } // else, node's tabbable/focusable state should not be affected by a fieldset's
                //  enabled/disabled state
                return false;
            };
            var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
                if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
                isDetailsWithSummary(node) || isDisabledFromFieldset(node)) return false;
                return true;
            };
            var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
                if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) return false;
                return true;
            };
            var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
                var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
                if (isNaN(tabIndex) || tabIndex >= 0) return true;
                 // If a custom element has an explicit negative tabindex,
                // browsers will not allow tab targeting said element's children.
                return false;
            };
            /**
 * @param {Array.<Element|CandidatesScope>} candidates
 * @returns Element[]
 */ var sortByOrder = function sortByOrder(candidates) {
                var regularTabbables = [];
                var orderedTabbables = [];
                candidates.forEach(function(item, i) {
                    var isScope = !!item.scope;
                    var element = isScope ? item.scope : item;
                    var candidateTabindex = getTabindex(element, isScope);
                    var elements = isScope ? sortByOrder(item.candidates) : element;
                    if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
                    else orderedTabbables.push({
                        documentOrder: i,
                        tabIndex: candidateTabindex,
                        item: item,
                        isScope: isScope,
                        content: elements
                    });
                });
                return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
                    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
                    return acc;
                }, []).concat(regularTabbables);
            };
            var tabbable = function tabbable(el, options) {
                options = options || {};
                var candidates;
                if (options.getShadowRoot) candidates = getCandidatesIteratively([
                    el
                ], options.includeContainer, {
                    filter: isNodeMatchingSelectorTabbable.bind(null, options),
                    flatten: false,
                    getShadowRoot: options.getShadowRoot,
                    shadowRootFilter: isValidShadowRootTabbable
                });
                else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
                return sortByOrder(candidates);
            };
            var focusable = function focusable(el, options) {
                options = options || {};
                var candidates;
                if (options.getShadowRoot) candidates = getCandidatesIteratively([
                    el
                ], options.includeContainer, {
                    filter: isNodeMatchingSelectorFocusable.bind(null, options),
                    flatten: true,
                    getShadowRoot: options.getShadowRoot
                });
                else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
                return candidates;
            };
            var isTabbable = function isTabbable(node, options) {
                options = options || {};
                if (!node) throw new Error("No node provided");
                if (matches.call(node, candidateSelector) === false) return false;
                return isNodeMatchingSelectorTabbable(options, node);
            };
            var focusableCandidateSelector = /* #__PURE__ */ candidateSelectors.concat("iframe").join(",");
            var isFocusable = function isFocusable(node, options) {
                options = options || {};
                if (!node) throw new Error("No node provided");
                if (matches.call(node, focusableCandidateSelector) === false) return false;
                return isNodeMatchingSelectorFocusable(options, node);
            };
        //# sourceMappingURL=index.esm.js.map
        /***/ },
        /***/ "./packages/material-components-web/index.ts": /*!***************************************************!*\
  !*** ./packages/material-components-web/index.ts ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            __webpack_require__(/*! ./native-shim.es5.js */ "./packages/material-components-web/native-shim.es5.js");
            __webpack_require__(/*! @webcomponents/custom-elements */ "./node_modules/@webcomponents/custom-elements/custom-elements.min.js");
            __webpack_require__(/*! @material/button/custom-element */ "./packages/mdc-button/custom-element.js");
            __webpack_require__(/*! @material/card/custom-element */ "./packages/mdc-card/custom-element.js");
            __webpack_require__(/*! @material/checkbox/custom-element */ "./packages/mdc-checkbox/custom-element.js");
            __webpack_require__(/*! @material/chips/chip-set/custom-element */ "./packages/mdc-chips/chip-set/custom-element.js");
            __webpack_require__(/*! @material/chips/chip/custom-element */ "./packages/mdc-chips/chip/custom-element.js");
            __webpack_require__(/*! @material/circular-progress/custom-element */ "./packages/mdc-circular-progress/custom-element.js");
            __webpack_require__(/*! @material/data-table/custom-element */ "./packages/mdc-data-table/custom-element.js");
            __webpack_require__(/*! @material/dialog/custom-element */ "./packages/mdc-dialog/custom-element.js");
            __webpack_require__(/*! @material/drawer/custom-element */ "./packages/mdc-drawer/custom-element.js");
            __webpack_require__(/*! @material/fab/custom-element */ "./packages/mdc-fab/custom-element.js");
            __webpack_require__(/*! @material/form-field/custom-element */ "./packages/mdc-form-field/custom-element.js");
            __webpack_require__(/*! @material/icon-button/custom-element */ "./packages/mdc-icon-button/custom-element.js");
            __webpack_require__(/*! @material/image-list/custom-element */ "./packages/mdc-image-list/custom-element.js");
            __webpack_require__(/*! @material/layout-grid/custom-element */ "./packages/mdc-layout-grid/custom-element.js");
            __webpack_require__(/*! @material/linear-progress/custom-element */ "./packages/mdc-linear-progress/custom-element.js");
            __webpack_require__(/*! @material/list/custom-element */ "./packages/mdc-list/custom-element.js");
            __webpack_require__(/*! @material/menu/custom-element */ "./packages/mdc-menu/custom-element.js");
            __webpack_require__(/*! @material/radio/custom-element */ "./packages/mdc-radio/custom-element.js");
            __webpack_require__(/*! @material/ripple/custom-element */ "./packages/mdc-ripple/custom-element.js");
            __webpack_require__(/*! @material/select/custom-element */ "./packages/mdc-select/custom-element.js");
            __webpack_require__(/*! @material/slider/custom-element */ "./packages/mdc-slider/custom-element.js");
            __webpack_require__(/*! @material/snackbar/custom-element */ "./packages/mdc-snackbar/custom-element.js");
            __webpack_require__(/*! @material/switch/custom-element */ "./packages/mdc-switch/custom-element.js");
            __webpack_require__(/*! @material/tab-bar/custom-element */ "./packages/mdc-tab-bar/custom-element.js");
            __webpack_require__(/*! @material/tab/custom-element */ "./packages/mdc-tab/custom-element.js");
            __webpack_require__(/*! @material/textfield/custom-element */ "./packages/mdc-textfield/custom-element.js");
            __webpack_require__(/*! @material/top-app-bar/custom-element */ "./packages/mdc-top-app-bar/custom-element.js");
        /***/ },
        /***/ "./packages/material-components-web/native-shim.es5.js": /*!*************************************************************!*\
  !*** ./packages/material-components-web/native-shim.es5.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 * Google as part of the polymer project is also subject to an additional IP
 * rights grant found at http://polymer.github.io/PATENTS.txt
 */ /**
 * This shim allows elements written in, or compiled to, ES5 to work on native
 * implementations of Custom Elements v1. It sets new.target to the value of
 * this.constructor so that the native HTMLElement constructor can access the
 * current under-construction element's definition.
 */ (function() {
                if (// No Reflect, no classes, no need for shim because native custom elements
                // require ES2015 classes or Reflect.
                window.Reflect === undefined || window.customElements === undefined || // The webcomponentsjs custom elements polyfill doesn't require
                // ES2015-compatible construction (`super()` or `Reflect.construct`).
                window.customElements.polyfillWrapFlushCallback) return;
                var BuiltInHTMLElement = HTMLElement;
                /**
     * With jscompiler's RECOMMENDED_FLAGS the function name will be optimized away.
     * However, if we declare the function as a property on an object literal, and
     * use quotes for the property name, then closure will leave that much intact,
     * which is enough for the JS VM to correctly set Function.prototype.name.
     */ var wrapperForTheName = {
                    "HTMLElement": function HTMLElement1() {
                        return Reflect.construct(BuiltInHTMLElement, [], this.constructor);
                    }
                };
                window.HTMLElement = wrapperForTheName["HTMLElement"];
                HTMLElement.prototype = BuiltInHTMLElement.prototype;
                HTMLElement.prototype.constructor = HTMLElement;
                Object.setPrototypeOf(HTMLElement, BuiltInHTMLElement);
            })();
        // # sourceMappingURL=native-shim.js.map
        /***/ },
        /***/ "./packages/mdc-animation/animationframe.ts": /*!**************************************************!*\
  !*** ./packages/mdc-animation/animationframe.ts ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.AnimationFrame = void 0;
            /**
 * AnimationFrame provides a user-friendly abstraction around requesting
 * and canceling animation frames.
 */ var AnimationFrame = /** @class */ function() {
                function AnimationFrame() {
                    this.rafIDs = new Map();
                }
                /**
     * Requests an animation frame. Cancels any existing frame with the same key.
     * @param {string} key The key for this callback.
     * @param {FrameRequestCallback} callback The callback to be executed.
     */ AnimationFrame.prototype.request = function(key, callback) {
                    var _this = this;
                    this.cancel(key);
                    var frameID = requestAnimationFrame(function(frame) {
                        _this.rafIDs.delete(key);
                        // Callback must come *after* the key is deleted so that nested calls to
                        // request with the same key are not deleted.
                        callback(frame);
                    });
                    this.rafIDs.set(key, frameID);
                };
                /**
     * Cancels a queued callback with the given key.
     * @param {string} key The key for this callback.
     */ AnimationFrame.prototype.cancel = function(key) {
                    var rafID = this.rafIDs.get(key);
                    if (rafID) {
                        cancelAnimationFrame(rafID);
                        this.rafIDs.delete(key);
                    }
                };
                /**
     * Cancels all queued callback.
     */ AnimationFrame.prototype.cancelAll = function() {
                    var _this = this;
                    // Need to use forEach because it's the only iteration method supported
                    // by IE11. Suppress the underscore because we don't need it.
                    // tslint:disable-next-line:enforce-name-casing
                    this.rafIDs.forEach(function(_, key) {
                        _this.cancel(key);
                    });
                };
                /**
     * Returns the queue of unexecuted callback keys.
     */ AnimationFrame.prototype.getQueue = function() {
                    var queue = [];
                    // Need to use forEach because it's the only iteration method supported
                    // by IE11. Suppress the underscore because we don't need it.
                    // tslint:disable-next-line:enforce-name-casing
                    this.rafIDs.forEach(function(_, key) {
                        queue.push(key);
                    });
                    return queue;
                };
                return AnimationFrame;
            }();
            exports.AnimationFrame = AnimationFrame;
        /***/ },
        /***/ "./packages/mdc-animation/util.ts": /*!****************************************!*\
  !*** ./packages/mdc-animation/util.ts ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.getCorrectEventName = exports.getCorrectPropertyName = void 0;
            var cssPropertyNameMap = {
                animation: {
                    prefixed: "-webkit-animation",
                    standard: "animation"
                },
                transform: {
                    prefixed: "-webkit-transform",
                    standard: "transform"
                },
                transition: {
                    prefixed: "-webkit-transition",
                    standard: "transition"
                }
            };
            var jsEventTypeMap = {
                animationend: {
                    cssProperty: "animation",
                    prefixed: "webkitAnimationEnd",
                    standard: "animationend"
                },
                animationiteration: {
                    cssProperty: "animation",
                    prefixed: "webkitAnimationIteration",
                    standard: "animationiteration"
                },
                animationstart: {
                    cssProperty: "animation",
                    prefixed: "webkitAnimationStart",
                    standard: "animationstart"
                },
                transitionend: {
                    cssProperty: "transition",
                    prefixed: "webkitTransitionEnd",
                    standard: "transitionend"
                }
            };
            function isWindow(windowObj) {
                return Boolean(windowObj.document) && typeof windowObj.document.createElement === "function";
            }
            function getCorrectPropertyName(windowObj, cssProperty) {
                if (isWindow(windowObj) && cssProperty in cssPropertyNameMap) {
                    var el = windowObj.document.createElement("div");
                    var _a = cssPropertyNameMap[cssProperty], standard = _a.standard, prefixed = _a.prefixed;
                    var isStandard = standard in el.style;
                    return isStandard ? standard : prefixed;
                }
                return cssProperty;
            }
            exports.getCorrectPropertyName = getCorrectPropertyName;
            function getCorrectEventName(windowObj, eventType) {
                if (isWindow(windowObj) && eventType in jsEventTypeMap) {
                    var el = windowObj.document.createElement("div");
                    var _a = jsEventTypeMap[eventType], standard = _a.standard, prefixed = _a.prefixed, cssProperty = _a.cssProperty;
                    var isStandard = cssProperty in el.style;
                    return isStandard ? standard : prefixed;
                }
                return eventType;
            }
            exports.getCorrectEventName = getCorrectEventName;
        /***/ },
        /***/ "./packages/mdc-base/component.ts": /*!****************************************!*\
  !*** ./packages/mdc-base/component.ts ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __read = this && this.__read || function(o, n) {
                var m = typeof Symbol === "function" && o[Symbol.iterator];
                if (!m) return o;
                var i = m.call(o), r, ar = [], e;
                try {
                    while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
                } catch (error) {
                    e = {
                        error: error
                    };
                } finally{
                    try {
                        if (r && !r.done && (m = i["return"])) m.call(i);
                    } finally{
                        if (e) throw e.error;
                    }
                }
                return ar;
            };
            var __spreadArray = this && this.__spreadArray || function(to, from) {
                for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
                return to;
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCComponent = void 0;
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-base/foundation.ts");
            var MDCComponent = /** @class */ function() {
                function MDCComponent(root, foundation) {
                    var args = [];
                    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
                    this.root = root;
                    this.initialize.apply(this, __spreadArray([], __read(args)));
                    // Note that we initialize foundation here and not within the constructor's default param so that
                    // this.root_ is defined and can be used within the foundation class.
                    this.foundation = foundation === undefined ? this.getDefaultFoundation() : foundation;
                    this.foundation.init();
                    this.initialSyncWithDOM();
                }
                MDCComponent.attachTo = function(root) {
                    // Subclasses which extend MDCBase should provide an attachTo() method that takes a root element and
                    // returns an instantiated component with its root set to that element. Also note that in the cases of
                    // subclasses, an explicit foundation class will not have to be passed in; it will simply be initialized
                    // from getDefaultFoundation().
                    return new MDCComponent(root, new foundation_1.MDCFoundation({}));
                };
                /* istanbul ignore next: method param only exists for typing purposes; it does not need to be unit tested */ MDCComponent.prototype.initialize = function() {
                    var _args = [];
                    for(var _i = 0; _i < arguments.length; _i++)_args[_i] = arguments[_i];
                // Subclasses can override this to do any additional setup work that would be considered part of a
                // "constructor". Essentially, it is a hook into the parent constructor before the foundation is
                // initialized. Any additional arguments besides root and foundation will be passed in here.
                };
                MDCComponent.prototype.getDefaultFoundation = function() {
                    // Subclasses must override this method to return a properly configured foundation class for the
                    // component.
                    throw new Error("Subclasses must override getDefaultFoundation to return a properly configured foundation class");
                };
                MDCComponent.prototype.initialSyncWithDOM = function() {
                // Subclasses should override this method if they need to perform work to synchronize with a host DOM
                // object. An example of this would be a form control wrapper that needs to synchronize its internal state
                // to some property or attribute of the host DOM. Please note: this is *not* the place to perform DOM
                // reads/writes that would cause layout / paint, as this is called synchronously from within the constructor.
                };
                MDCComponent.prototype.destroy = function() {
                    // Subclasses may implement this method to release any resources / deregister any listeners they have
                    // attached. An example of this might be deregistering a resize event from the window object.
                    this.foundation.destroy();
                };
                MDCComponent.prototype.listen = function(evtType, handler, options) {
                    this.root.addEventListener(evtType, handler, options);
                };
                MDCComponent.prototype.unlisten = function(evtType, handler, options) {
                    this.root.removeEventListener(evtType, handler, options);
                };
                /**
     * Fires a cross-browser-compatible custom event from the component root of the given type, with the given data.
     */ MDCComponent.prototype.emit = function(evtType, evtData, shouldBubble) {
                    if (shouldBubble === void 0) shouldBubble = false;
                    var evt;
                    if (typeof CustomEvent === "function") evt = new CustomEvent(evtType, {
                        bubbles: shouldBubble,
                        detail: evtData
                    });
                    else {
                        evt = document.createEvent("CustomEvent");
                        evt.initCustomEvent(evtType, shouldBubble, false, evtData);
                    }
                    this.root.dispatchEvent(evt);
                };
                return MDCComponent;
            }();
            exports.MDCComponent = MDCComponent;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCComponent;
        /***/ },
        /***/ "./packages/mdc-base/foundation.ts": /*!*****************************************!*\
  !*** ./packages/mdc-base/foundation.ts ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCFoundation = void 0;
            var MDCFoundation = /** @class */ function() {
                function MDCFoundation(adapter) {
                    if (adapter === void 0) adapter = {};
                    this.adapter = adapter;
                }
                Object.defineProperty(MDCFoundation, "cssClasses", {
                    get: function get() {
                        // Classes extending MDCFoundation should implement this method to return an object which exports every
                        // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
                        return {};
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCFoundation, "strings", {
                    get: function get() {
                        // Classes extending MDCFoundation should implement this method to return an object which exports all
                        // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
                        return {};
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCFoundation, "numbers", {
                    get: function get() {
                        // Classes extending MDCFoundation should implement this method to return an object which exports all
                        // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
                        return {};
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCFoundation, "defaultAdapter", {
                    get: function get() {
                        // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
                        // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
                        // validation.
                        return {};
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCFoundation.prototype.init = function() {
                // Subclasses should override this method to perform initialization routines (registering events, etc.)
                };
                MDCFoundation.prototype.destroy = function() {
                // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
                };
                return MDCFoundation;
            }();
            exports.MDCFoundation = MDCFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCFoundation;
        /***/ },
        /***/ "./packages/mdc-button/custom-element.js": /*!***********************************************!*\
  !*** ./packages/mdc-button/custom-element.js ***!
  \***********************************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_material_ripple_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcButton = function(_HTMLElement) {
                _inherits(MdcButton, _HTMLElement);
                function MdcButton() {
                    _classCallCheck(this, MdcButton);
                    var _this = _possibleConstructorReturn(this, (MdcButton.__proto__ || Object.getPrototypeOf(MdcButton)).call(this));
                    _this.ripple_;
                    return _this;
                }
                _createClass(MdcButton, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.ripple_ = new _material_ripple_component__WEBPACK_IMPORTED_MODULE_0__["MDCRipple"](this.querySelector(".mdc-button"));
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.ripple_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcButton;
            }(HTMLElement);
            /* harmony default export */ __webpack_exports__["default"] = MdcButton;
            customElements.define("mdc-button", MdcButton);
        /***/ },
        /***/ "./packages/mdc-card/custom-element.js": /*!*********************************************!*\
  !*** ./packages/mdc-card/custom-element.js ***!
  \*********************************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_material_ripple_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcCard = function(_HTMLElement) {
                _inherits(MdcCard, _HTMLElement);
                _createClass(MdcCard, [
                    {
                        key: "focus",
                        value: function focus() {
                            if (!!this.primaryAction_) this.primaryAction_.focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            if (!!this.primaryAction_) this.primaryAction_.blur();
                        }
                    }
                ]);
                function MdcCard() {
                    _classCallCheck(this, MdcCard);
                    var _this = _possibleConstructorReturn(this, (MdcCard.__proto__ || Object.getPrototypeOf(MdcCard)).call(this));
                    _this.primaryAction_;
                    _this.ripple_;
                    return _this;
                }
                _createClass(MdcCard, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            var primaryActionElement = this.querySelector(".mdc-card__primary-action");
                            if (!!primaryActionElement) this.primaryAction_ = primaryActionElement;
                            if (!!this.primaryAction_) this.ripple_ = new _material_ripple_component__WEBPACK_IMPORTED_MODULE_0__["MDCRipple"](this.primaryAction_);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            if (this.ripple_) this.ripple_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcCard;
            }(HTMLElement);
            /* harmony default export */ __webpack_exports__["default"] = MdcCard;
            customElements.define("mdc-card", MdcCard);
        /***/ },
        /***/ "./packages/mdc-checkbox/component.ts": /*!********************************************!*\
  !*** ./packages/mdc-checkbox/component.ts ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCCheckbox = void 0;
            var util_1 = __webpack_require__(/*! @material/animation/util */ "./packages/mdc-animation/util.ts");
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var events_1 = __webpack_require__(/*! @material/dom/events */ "./packages/mdc-dom/events.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var component_2 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-checkbox/constants.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-checkbox/foundation.ts");
            var CB_PROTO_PROPS = [
                "checked",
                "indeterminate"
            ];
            var MDCCheckbox = /** @class */ function(_super) {
                __extends(MDCCheckbox, _super);
                function MDCCheckbox() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.ripple_ = _this.createRipple_();
                    return _this;
                }
                MDCCheckbox.attachTo = function(root) {
                    return new MDCCheckbox(root);
                };
                Object.defineProperty(MDCCheckbox.prototype, "ripple", {
                    get: function get() {
                        return this.ripple_;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCheckbox.prototype, "checked", {
                    get: function get() {
                        return this.nativeControl_.checked;
                    },
                    set: function set(checked) {
                        this.nativeControl_.checked = checked;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCheckbox.prototype, "indeterminate", {
                    get: function get() {
                        return this.nativeControl_.indeterminate;
                    },
                    set: function set(indeterminate) {
                        this.nativeControl_.indeterminate = indeterminate;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCheckbox.prototype, "disabled", {
                    get: function get() {
                        return this.nativeControl_.disabled;
                    },
                    set: function set(disabled) {
                        this.foundation.setDisabled(disabled);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCheckbox.prototype, "value", {
                    get: function get() {
                        return this.nativeControl_.value;
                    },
                    set: function set(value) {
                        this.nativeControl_.value = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCCheckbox.prototype.initialize = function() {
                    var DATA_INDETERMINATE_ATTR = constants_1.strings.DATA_INDETERMINATE_ATTR;
                    this.nativeControl_.indeterminate = this.nativeControl_.getAttribute(DATA_INDETERMINATE_ATTR) === "true";
                    this.nativeControl_.removeAttribute(DATA_INDETERMINATE_ATTR);
                };
                MDCCheckbox.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.handleAnimationEnd_ = function() {
                        return _this.foundation.handleAnimationEnd();
                    };
                    this.listen(util_1.getCorrectEventName(window, "animationend"), this.handleAnimationEnd_);
                    this.installPropertyChangeHooks_();
                };
                MDCCheckbox.prototype.destroy = function() {
                    this.ripple_.destroy();
                    this.unlisten(util_1.getCorrectEventName(window, "animationend"), this.handleAnimationEnd_);
                    this.uninstallPropertyChangeHooks_();
                    _super.prototype.destroy.call(this);
                };
                MDCCheckbox.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        forceLayout: function forceLayout() {
                            return _this.root.offsetWidth;
                        },
                        hasNativeControl: function hasNativeControl() {
                            return !!_this.nativeControl_;
                        },
                        isAttachedToDOM: function isAttachedToDOM() {
                            return Boolean(_this.root.parentNode);
                        },
                        isChecked: function isChecked() {
                            return _this.checked;
                        },
                        isIndeterminate: function isIndeterminate() {
                            return _this.indeterminate;
                        },
                        removeClass: function removeClass(className) {
                            _this.root.classList.remove(className);
                        },
                        removeNativeControlAttr: function removeNativeControlAttr(attr) {
                            _this.nativeControl_.removeAttribute(attr);
                        },
                        setNativeControlAttr: function setNativeControlAttr(attr, value) {
                            _this.nativeControl_.setAttribute(attr, value);
                        },
                        setNativeControlDisabled: function setNativeControlDisabled(disabled) {
                            _this.nativeControl_.disabled = disabled;
                        }
                    };
                    return new foundation_2.MDCCheckboxFoundation(adapter);
                };
                MDCCheckbox.prototype.createRipple_ = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = __assign(__assign({}, component_2.MDCRipple.createAdapter(this)), {
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            return _this.nativeControl_.removeEventListener(evtType, handler, events_1.applyPassive());
                        },
                        isSurfaceActive: function isSurfaceActive() {
                            return ponyfill_1.matches(_this.nativeControl_, ":active");
                        },
                        isUnbounded: function isUnbounded() {
                            return true;
                        },
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            return _this.nativeControl_.addEventListener(evtType, handler, events_1.applyPassive());
                        }
                    });
                    return new component_2.MDCRipple(this.root, new foundation_1.MDCRippleFoundation(adapter));
                };
                MDCCheckbox.prototype.installPropertyChangeHooks_ = function() {
                    var _this = this;
                    var nativeCb = this.nativeControl_;
                    var cbProto = Object.getPrototypeOf(nativeCb);
                    CB_PROTO_PROPS.forEach(function(controlState) {
                        var desc = Object.getOwnPropertyDescriptor(cbProto, controlState);
                        // We have to check for this descriptor, since some browsers (Safari) don't support its return.
                        // See: https://bugs.webkit.org/show_bug.cgi?id=49739
                        if (!validDescriptor(desc)) return;
                        // Type cast is needed for compatibility with Closure Compiler.
                        var nativeGetter = desc.get;
                        var nativeCbDesc = {
                            configurable: desc.configurable,
                            enumerable: desc.enumerable,
                            get: nativeGetter,
                            set: function set(state) {
                                desc.set.call(nativeCb, state);
                                _this.foundation.handleChange();
                            }
                        };
                        Object.defineProperty(nativeCb, controlState, nativeCbDesc);
                    });
                };
                MDCCheckbox.prototype.uninstallPropertyChangeHooks_ = function() {
                    var nativeCb = this.nativeControl_;
                    var cbProto = Object.getPrototypeOf(nativeCb);
                    CB_PROTO_PROPS.forEach(function(controlState) {
                        var desc = Object.getOwnPropertyDescriptor(cbProto, controlState);
                        if (!validDescriptor(desc)) return;
                        Object.defineProperty(nativeCb, controlState, desc);
                    });
                };
                Object.defineProperty(MDCCheckbox.prototype, "nativeControl_", {
                    get: function get() {
                        var NATIVE_CONTROL_SELECTOR = constants_1.strings.NATIVE_CONTROL_SELECTOR;
                        var el = this.root.querySelector(NATIVE_CONTROL_SELECTOR);
                        if (!el) throw new Error("Checkbox component requires a " + NATIVE_CONTROL_SELECTOR + " element");
                        return el;
                    },
                    enumerable: false,
                    configurable: true
                });
                return MDCCheckbox;
            }(component_1.MDCComponent);
            exports.MDCCheckbox = MDCCheckbox;
            function validDescriptor(inputPropDesc) {
                return !!inputPropDesc && typeof inputPropDesc.set === "function";
            }
        /***/ },
        /***/ "./packages/mdc-checkbox/constants.ts": /*!********************************************!*\
  !*** ./packages/mdc-checkbox/constants.ts ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.numbers = exports.strings = exports.cssClasses = void 0;
            exports.cssClasses = {
                ANIM_CHECKED_INDETERMINATE: "mdc-checkbox--anim-checked-indeterminate",
                ANIM_CHECKED_UNCHECKED: "mdc-checkbox--anim-checked-unchecked",
                ANIM_INDETERMINATE_CHECKED: "mdc-checkbox--anim-indeterminate-checked",
                ANIM_INDETERMINATE_UNCHECKED: "mdc-checkbox--anim-indeterminate-unchecked",
                ANIM_UNCHECKED_CHECKED: "mdc-checkbox--anim-unchecked-checked",
                ANIM_UNCHECKED_INDETERMINATE: "mdc-checkbox--anim-unchecked-indeterminate",
                BACKGROUND: "mdc-checkbox__background",
                CHECKED: "mdc-checkbox--checked",
                CHECKMARK: "mdc-checkbox__checkmark",
                CHECKMARK_PATH: "mdc-checkbox__checkmark-path",
                DISABLED: "mdc-checkbox--disabled",
                INDETERMINATE: "mdc-checkbox--indeterminate",
                MIXEDMARK: "mdc-checkbox__mixedmark",
                NATIVE_CONTROL: "mdc-checkbox__native-control",
                ROOT: "mdc-checkbox",
                SELECTED: "mdc-checkbox--selected",
                UPGRADED: "mdc-checkbox--upgraded"
            };
            exports.strings = {
                ARIA_CHECKED_ATTR: "aria-checked",
                ARIA_CHECKED_INDETERMINATE_VALUE: "mixed",
                DATA_INDETERMINATE_ATTR: "data-indeterminate",
                NATIVE_CONTROL_SELECTOR: ".mdc-checkbox__native-control",
                TRANSITION_STATE_CHECKED: "checked",
                TRANSITION_STATE_INDETERMINATE: "indeterminate",
                TRANSITION_STATE_INIT: "init",
                TRANSITION_STATE_UNCHECKED: "unchecked"
            };
            exports.numbers = {
                ANIM_END_LATCH_MS: 250
            };
        /***/ },
        /***/ "./packages/mdc-checkbox/custom-element.js": /*!*************************************************!*\
  !*** ./packages/mdc-checkbox/custom-element.js ***!
  \*************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-checkbox/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcCheckbox = function(_HTMLElement) {
                _inherits(MdcCheckbox, _HTMLElement);
                _createClass(MdcCheckbox, [
                    {
                        key: "focus",
                        value: function focus() {
                            this.checkbox_.nativeControl_.focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            this.checkbox_.nativeControl_.blur();
                        }
                    },
                    {
                        key: "checked",
                        get: function get() {
                            return this.checked_;
                        },
                        set: function set(checked) {
                            this.checked_ = checked;
                            if (!!this.checkbox_) this.checkbox_.checked = checked;
                        }
                    },
                    {
                        key: "indeterminate",
                        get: function get() {
                            return this.indeterminate_;
                        },
                        set: function set(indeterminate) {
                            this.indeterminate_ = indeterminate;
                            if (!!this.checkbox_) this.checkbox_.indeterminate = indeterminate;
                        }
                    },
                    {
                        key: "disabled",
                        get: function get() {
                            return this.disabled_;
                        },
                        set: function set(disabled) {
                            this.disabled_ = disabled;
                            if (!!this.checkbox_) this.checkbox_.disabled = disabled;
                        }
                    }
                ]);
                function MdcCheckbox() {
                    _classCallCheck(this, MdcCheckbox);
                    var _this = _possibleConstructorReturn(this, (MdcCheckbox.__proto__ || Object.getPrototypeOf(MdcCheckbox)).call(this));
                    _this.checked_ = false;
                    _this.indeterminate_ = false;
                    _this.disabled_ = false;
                    _this.checkbox_;
                    return _this;
                }
                _createClass(MdcCheckbox, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.checkbox_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCCheckbox"](this);
                            this.checkbox_.checked = this.checked_;
                            this.checkbox_.indeterminate = this.indeterminate_;
                            this.checkbox_.disabled = this.disabled_;
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            this.checkbox_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcCheckbox;
            }(HTMLElement);
            customElements.define("mdc-checkbox", MdcCheckbox);
        /***/ },
        /***/ "./packages/mdc-checkbox/foundation.ts": /*!*********************************************!*\
  !*** ./packages/mdc-checkbox/foundation.ts ***!
  \*********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCCheckboxFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-checkbox/constants.ts");
            var MDCCheckboxFoundation = /** @class */ function(_super) {
                __extends(MDCCheckboxFoundation, _super);
                function MDCCheckboxFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCCheckboxFoundation.defaultAdapter), adapter)) || this;
                    _this.currentCheckState_ = constants_1.strings.TRANSITION_STATE_INIT;
                    _this.currentAnimationClass_ = "";
                    _this.animEndLatchTimer_ = 0;
                    _this.enableAnimationEndHandler_ = false;
                    return _this;
                }
                Object.defineProperty(MDCCheckboxFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCheckboxFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCheckboxFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCheckboxFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            forceLayout: function forceLayout() {
                                return undefined;
                            },
                            hasNativeControl: function hasNativeControl() {
                                return false;
                            },
                            isAttachedToDOM: function isAttachedToDOM() {
                                return false;
                            },
                            isChecked: function isChecked() {
                                return false;
                            },
                            isIndeterminate: function isIndeterminate() {
                                return false;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            removeNativeControlAttr: function removeNativeControlAttr() {
                                return undefined;
                            },
                            setNativeControlAttr: function setNativeControlAttr() {
                                return undefined;
                            },
                            setNativeControlDisabled: function setNativeControlDisabled() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCCheckboxFoundation.prototype.init = function() {
                    this.currentCheckState_ = this.determineCheckState_();
                    this.updateAriaChecked_();
                    this.adapter.addClass(constants_1.cssClasses.UPGRADED);
                };
                MDCCheckboxFoundation.prototype.destroy = function() {
                    clearTimeout(this.animEndLatchTimer_);
                };
                MDCCheckboxFoundation.prototype.setDisabled = function(disabled) {
                    this.adapter.setNativeControlDisabled(disabled);
                    if (disabled) this.adapter.addClass(constants_1.cssClasses.DISABLED);
                    else this.adapter.removeClass(constants_1.cssClasses.DISABLED);
                };
                /**
     * Handles the animationend event for the checkbox
     */ MDCCheckboxFoundation.prototype.handleAnimationEnd = function() {
                    var _this = this;
                    if (!this.enableAnimationEndHandler_) return;
                    clearTimeout(this.animEndLatchTimer_);
                    this.animEndLatchTimer_ = setTimeout(function() {
                        _this.adapter.removeClass(_this.currentAnimationClass_);
                        _this.enableAnimationEndHandler_ = false;
                    }, constants_1.numbers.ANIM_END_LATCH_MS);
                };
                /**
     * Handles the change event for the checkbox
     */ MDCCheckboxFoundation.prototype.handleChange = function() {
                    this.transitionCheckState_();
                };
                MDCCheckboxFoundation.prototype.transitionCheckState_ = function() {
                    if (!this.adapter.hasNativeControl()) return;
                    var oldState = this.currentCheckState_;
                    var newState = this.determineCheckState_();
                    if (oldState === newState) return;
                    this.updateAriaChecked_();
                    var TRANSITION_STATE_UNCHECKED = constants_1.strings.TRANSITION_STATE_UNCHECKED;
                    var SELECTED = constants_1.cssClasses.SELECTED;
                    if (newState === TRANSITION_STATE_UNCHECKED) this.adapter.removeClass(SELECTED);
                    else this.adapter.addClass(SELECTED);
                    // Check to ensure that there isn't a previously existing animation class, in case for example
                    // the user interacted with the checkbox before the animation was finished.
                    if (this.currentAnimationClass_.length > 0) {
                        clearTimeout(this.animEndLatchTimer_);
                        this.adapter.forceLayout();
                        this.adapter.removeClass(this.currentAnimationClass_);
                    }
                    this.currentAnimationClass_ = this.getTransitionAnimationClass_(oldState, newState);
                    this.currentCheckState_ = newState;
                    // Check for parentNode so that animations are only run when the element is attached
                    // to the DOM.
                    if (this.adapter.isAttachedToDOM() && this.currentAnimationClass_.length > 0) {
                        this.adapter.addClass(this.currentAnimationClass_);
                        this.enableAnimationEndHandler_ = true;
                    }
                };
                MDCCheckboxFoundation.prototype.determineCheckState_ = function() {
                    var TRANSITION_STATE_INDETERMINATE = constants_1.strings.TRANSITION_STATE_INDETERMINATE, TRANSITION_STATE_CHECKED = constants_1.strings.TRANSITION_STATE_CHECKED, TRANSITION_STATE_UNCHECKED = constants_1.strings.TRANSITION_STATE_UNCHECKED;
                    if (this.adapter.isIndeterminate()) return TRANSITION_STATE_INDETERMINATE;
                    return this.adapter.isChecked() ? TRANSITION_STATE_CHECKED : TRANSITION_STATE_UNCHECKED;
                };
                MDCCheckboxFoundation.prototype.getTransitionAnimationClass_ = function(oldState, newState) {
                    var TRANSITION_STATE_INIT = constants_1.strings.TRANSITION_STATE_INIT, TRANSITION_STATE_CHECKED = constants_1.strings.TRANSITION_STATE_CHECKED, TRANSITION_STATE_UNCHECKED = constants_1.strings.TRANSITION_STATE_UNCHECKED;
                    var _a = MDCCheckboxFoundation.cssClasses, ANIM_UNCHECKED_CHECKED = _a.ANIM_UNCHECKED_CHECKED, ANIM_UNCHECKED_INDETERMINATE = _a.ANIM_UNCHECKED_INDETERMINATE, ANIM_CHECKED_UNCHECKED = _a.ANIM_CHECKED_UNCHECKED, ANIM_CHECKED_INDETERMINATE = _a.ANIM_CHECKED_INDETERMINATE, ANIM_INDETERMINATE_CHECKED = _a.ANIM_INDETERMINATE_CHECKED, ANIM_INDETERMINATE_UNCHECKED = _a.ANIM_INDETERMINATE_UNCHECKED;
                    switch(oldState){
                        case TRANSITION_STATE_INIT:
                            if (newState === TRANSITION_STATE_UNCHECKED) return "";
                            return newState === TRANSITION_STATE_CHECKED ? ANIM_INDETERMINATE_CHECKED : ANIM_INDETERMINATE_UNCHECKED;
                        case TRANSITION_STATE_UNCHECKED:
                            return newState === TRANSITION_STATE_CHECKED ? ANIM_UNCHECKED_CHECKED : ANIM_UNCHECKED_INDETERMINATE;
                        case TRANSITION_STATE_CHECKED:
                            return newState === TRANSITION_STATE_UNCHECKED ? ANIM_CHECKED_UNCHECKED : ANIM_CHECKED_INDETERMINATE;
                        default:
                            // TRANSITION_STATE_INDETERMINATE
                            return newState === TRANSITION_STATE_CHECKED ? ANIM_INDETERMINATE_CHECKED : ANIM_INDETERMINATE_UNCHECKED;
                    }
                };
                MDCCheckboxFoundation.prototype.updateAriaChecked_ = function() {
                    // Ensure aria-checked is set to mixed if checkbox is in indeterminate state.
                    if (this.adapter.isIndeterminate()) this.adapter.setNativeControlAttr(constants_1.strings.ARIA_CHECKED_ATTR, constants_1.strings.ARIA_CHECKED_INDETERMINATE_VALUE);
                    else // The on/off state does not need to keep track of aria-checked, since
                    // the screenreader uses the checked property on the checkbox element.
                    this.adapter.removeNativeControlAttr(constants_1.strings.ARIA_CHECKED_ATTR);
                };
                return MDCCheckboxFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCCheckboxFoundation = MDCCheckboxFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCCheckboxFoundation;
        /***/ },
        /***/ "./packages/mdc-chips/chip-set/custom-element.js": /*!*******************************************************!*\
  !*** ./packages/mdc-chips/chip-set/custom-element.js ***!
  \*******************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _deprecated_chip_set_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../deprecated/chip-set/component */ "./packages/mdc-chips/deprecated/chip-set/component.ts");
            /* harmony import */ var _deprecated_chip_set_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_deprecated_chip_set_component__WEBPACK_IMPORTED_MODULE_0__);
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcChipSet = function(_HTMLElement) {
                _inherits(MdcChipSet, _HTMLElement);
                _createClass(MdcChipSet, [
                    {
                        key: "focus",
                        value: function focus() {
                            var selectedChip = null;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = this.chipset_.chips[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var chip = _step.value;
                                    if (chip.selected) {
                                        selectedChip = chip;
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            if (!!selectedChip) selectedChip.focusPrimaryAction();
                            else if (this.chipset_.chips.length > 0) this.chipset_.chips[0].focusPrimaryAction();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            if (this.contains(document.activeElement)) document.activeElement.blur();
                        }
                    }
                ]);
                function MdcChipSet() {
                    _classCallCheck(this, MdcChipSet);
                    return _possibleConstructorReturn(this, (MdcChipSet.__proto__ || Object.getPrototypeOf(MdcChipSet)).call(this));
                }
                _createClass(MdcChipSet, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.chipset_ = new _deprecated_chip_set_component__WEBPACK_IMPORTED_MODULE_0__["MDCChipSet"](this);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.chipset_.destroy();
                        }
                    }
                ]);
                return MdcChipSet;
            }(HTMLElement);
            customElements.define("mdc-chip-set", MdcChipSet);
        /***/ },
        /***/ "./packages/mdc-chips/chip/custom-element.js": /*!***************************************************!*\
  !*** ./packages/mdc-chips/chip/custom-element.js ***!
  \***************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _deprecated_chip_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../deprecated/chip/component */ "./packages/mdc-chips/deprecated/chip/component.ts");
            /* harmony import */ var _deprecated_chip_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_deprecated_chip_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var idCounter = 0;
            var MdcChip = function(_HTMLElement) {
                _inherits(MdcChip, _HTMLElement);
                _createClass(MdcChip, [
                    {
                        key: "id",
                        get: function get() {
                            return this.id_;
                        },
                        set: function set(id) {
                            this.id_ = id;
                        }
                    },
                    {
                        key: "selected",
                        get: function get() {
                            return this.selected_;
                        },
                        set: function set(selected) {
                            this.selected_ = selected;
                            if (!!this.chip_) this.chip_.selected = selected;
                        }
                    }
                ]);
                function MdcChip() {
                    _classCallCheck(this, MdcChip);
                    var _this = _possibleConstructorReturn(this, (MdcChip.__proto__ || Object.getPrototypeOf(MdcChip)).call(this));
                    _this.selected_ = false;
                    _this.id_ = "mdc-chip-" + ++idCounter;
                    _this.chipset_ = null;
                    return _this;
                }
                _createClass(MdcChip, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.chip_ = new _deprecated_chip_component__WEBPACK_IMPORTED_MODULE_0__["MDCChip"](this);
                            this.chip_.selected = this.selected_;
                            this.chipset_ = this.parentElement.parentElement.chipset_;
                            this.chipset_.addChip(this);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.chip_.destroy();
                            this.chipset_.foundation.adapter.removeChipAtIndex(this.chipset_.findChipIndex_(this.id));
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcChip;
            }(HTMLElement);
            customElements.define("mdc-chip", MdcChip);
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/chip-set/component.ts": /*!*************************************************************!*\
  !*** ./packages/mdc-chips/deprecated/chip-set/component.ts ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCChipSet = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var announce_1 = __webpack_require__(/*! @material/dom/announce */ "./packages/mdc-dom/announce.ts");
            var foundation_1 = __webpack_require__(/*! ../chip/foundation */ "./packages/mdc-chips/deprecated/chip/foundation.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-chips/deprecated/chip-set/foundation.ts");
            var _a = foundation_1.MDCChipFoundation.strings, INTERACTION_EVENT = _a.INTERACTION_EVENT, SELECTION_EVENT = _a.SELECTION_EVENT, REMOVAL_EVENT = _a.REMOVAL_EVENT, NAVIGATION_EVENT = _a.NAVIGATION_EVENT;
            var MDCChipSet = /** @class */ function(_super) {
                __extends(MDCChipSet, _super);
                function MDCChipSet() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCChipSet.attachTo = function(root) {
                    return new MDCChipSet(root);
                };
                Object.defineProperty(MDCChipSet.prototype, "chips", {
                    get: function get() {
                        return this.chips_.slice();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChipSet.prototype, "selectedChipIds", {
                    /**
         * @return An array of the IDs of all selected chips.
         */ get: function get() {
                        return this.foundation.getSelectedChipIds();
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * @param chipFactory A function which creates a new MDCChip.
     */ MDCChipSet.prototype.initialize = function() {
                    this.chipFactory_ = function(el) {
                        return el.chip_;
                    };
                    this.chips_ = [];
                };
                MDCChipSet.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.chips_.forEach(function(chip) {
                        if (chip.id && chip.selected) _this.foundation.select(chip.id);
                    });
                    this.handleChipInteraction_ = function(evt) {
                        return _this.foundation.handleChipInteraction(evt.detail);
                    };
                    this.handleChipSelection_ = function(evt) {
                        return _this.foundation.handleChipSelection(evt.detail);
                    };
                    this.handleChipRemoval_ = function(evt) {
                        return _this.foundation.handleChipRemoval(evt.detail);
                    };
                    this.handleChipNavigation_ = function(evt) {
                        return _this.foundation.handleChipNavigation(evt.detail);
                    };
                    this.listen(INTERACTION_EVENT, this.handleChipInteraction_);
                    this.listen(SELECTION_EVENT, this.handleChipSelection_);
                    this.listen(NAVIGATION_EVENT, this.handleChipNavigation_);
                };
                MDCChipSet.prototype.destroy = function() {
                    this.chips_.forEach(function(chip) {
                        chip.destroy();
                    });
                    this.unlisten(INTERACTION_EVENT, this.handleChipInteraction_);
                    this.unlisten(SELECTION_EVENT, this.handleChipSelection_);
                    this.unlisten(REMOVAL_EVENT, this.handleChipRemoval_);
                    this.unlisten(NAVIGATION_EVENT, this.handleChipNavigation_);
                    _super.prototype.destroy.call(this);
                };
                /**
     * Adds a new chip object to the chip set from the given chip element.
     */ MDCChipSet.prototype.addChip = function(chipEl) {
                    this.chips_.push(this.chipFactory_(chipEl));
                    if (this.chips_.length === 1) this.chips_[0].makePrimaryActionFocusable();
                };
                MDCChipSet.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        announceMessage: function announceMessage(message) {
                            announce_1.announce(message);
                        },
                        focusChipPrimaryActionAtIndex: function focusChipPrimaryActionAtIndex(index) {
                            _this.chips_[index].focusPrimaryAction();
                        },
                        focusChipTrailingActionAtIndex: function focusChipTrailingActionAtIndex(index) {
                            _this.chips_[index].focusTrailingAction();
                        },
                        getChipListCount: function getChipListCount() {
                            return _this.chips_.length;
                        },
                        getIndexOfChipById: function getIndexOfChipById(chipId) {
                            return _this.findChipIndex_(chipId);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        isRTL: function isRTL() {
                            return window.getComputedStyle(_this.root).getPropertyValue("direction") === "rtl";
                        },
                        removeChipAtIndex: function removeChipAtIndex(index) {
                            if (index >= 0 && index < _this.chips_.length) {
                                _this.chips_.splice(index, 1);
                                if (_this.chips_.length > 0 && !_this.chips_.some(function(chip) {
                                    return chip.isPrimaryActionFocusable();
                                })) _this.chips_[Math.max(0, index - 1)].makePrimaryActionFocusable();
                            }
                        },
                        removeFocusFromChipAtIndex: function removeFocusFromChipAtIndex(index) {
                            _this.chips_[index].removeFocus();
                        },
                        selectChipAtIndex: function selectChipAtIndex(index, selected, shouldNotifyClients) {
                            if (index >= 0 && index < _this.chips_.length) _this.chips_[index].setSelectedFromChipSet(selected, shouldNotifyClients);
                        }
                    };
                    return new foundation_2.MDCChipSetFoundation(adapter);
                };
                /**
     * Returns the index of the chip with the given id, or -1 if the chip does not exist.
     */ MDCChipSet.prototype.findChipIndex_ = function(chipId) {
                    for(var i = 0; i < this.chips_.length; i++){
                        if (this.chips_[i].id === chipId) return i;
                    }
                    return -1;
                };
                return MDCChipSet;
            }(component_1.MDCComponent);
            exports.MDCChipSet = MDCChipSet;
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/chip-set/constants.ts": /*!*************************************************************!*\
  !*** ./packages/mdc-chips/deprecated/chip-set/constants.ts ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.cssClasses = exports.strings = void 0;
            exports.strings = {
                CHIP_SELECTOR: ".mdc-chip"
            };
            exports.cssClasses = {
                CHOICE: "mdc-chip-set--choice",
                FILTER: "mdc-chip-set--filter"
            };
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/chip-set/foundation.ts": /*!**************************************************************!*\
  !*** ./packages/mdc-chips/deprecated/chip-set/foundation.ts ***!
  \**************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCChipSetFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ../chip/constants */ "./packages/mdc-chips/deprecated/chip/constants.ts");
            var constants_2 = __webpack_require__(/*! ./constants */ "./packages/mdc-chips/deprecated/chip-set/constants.ts");
            var MDCChipSetFoundation = /** @class */ function(_super) {
                __extends(MDCChipSetFoundation, _super);
                function MDCChipSetFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCChipSetFoundation.defaultAdapter), adapter)) || this;
                    /**
         * The ids of the selected chips in the set. Only used for choice chip set or filter chip set.
         */ _this.selectedChipIds_ = [];
                    return _this;
                }
                Object.defineProperty(MDCChipSetFoundation, "strings", {
                    get: function get() {
                        return constants_2.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChipSetFoundation, "cssClasses", {
                    get: function get() {
                        return constants_2.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChipSetFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            announceMessage: function announceMessage() {
                                return undefined;
                            },
                            focusChipPrimaryActionAtIndex: function focusChipPrimaryActionAtIndex() {
                                return undefined;
                            },
                            focusChipTrailingActionAtIndex: function focusChipTrailingActionAtIndex() {
                                return undefined;
                            },
                            getChipListCount: function getChipListCount() {
                                return -1;
                            },
                            getIndexOfChipById: function getIndexOfChipById() {
                                return -1;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            isRTL: function isRTL() {
                                return false;
                            },
                            removeChipAtIndex: function removeChipAtIndex() {
                                return undefined;
                            },
                            removeFocusFromChipAtIndex: function removeFocusFromChipAtIndex() {
                                return undefined;
                            },
                            selectChipAtIndex: function selectChipAtIndex() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Returns an array of the IDs of all selected chips.
     */ MDCChipSetFoundation.prototype.getSelectedChipIds = function() {
                    return this.selectedChipIds_.slice();
                };
                /**
     * Selects the chip with the given id. Deselects all other chips if the chip set is of the choice variant.
     * Does not notify clients of the updated selection state.
     */ MDCChipSetFoundation.prototype.select = function(chipId) {
                    this.select_(chipId, false);
                };
                /**
     * Handles a chip interaction event
     */ MDCChipSetFoundation.prototype.handleChipInteraction = function(_a) {
                    var chipId = _a.chipId;
                    var index = this.adapter.getIndexOfChipById(chipId);
                    this.removeFocusFromChipsExcept_(index);
                };
                /**
     * Handles a chip selection event, used to handle discrepancy when selection state is set directly on the Chip.
     */ MDCChipSetFoundation.prototype.handleChipSelection = function(_a) {
                    var chipId = _a.chipId, selected = _a.selected, shouldIgnore = _a.shouldIgnore;
                    // Early exit if we should ignore the event
                    if (shouldIgnore) return;
                    var chipIsSelected = this.selectedChipIds_.indexOf(chipId) >= 0;
                    if (selected && !chipIsSelected) this.select(chipId);
                    else if (!selected && chipIsSelected) this.deselect_(chipId);
                };
                /**
     * Handles the event when a chip is removed.
     */ MDCChipSetFoundation.prototype.handleChipRemoval = function(_a) {
                    var chipId = _a.chipId, removedAnnouncement = _a.removedAnnouncement;
                    if (removedAnnouncement) this.adapter.announceMessage(removedAnnouncement);
                    var index = this.adapter.getIndexOfChipById(chipId);
                    this.deselectAndNotifyClients_(chipId);
                    this.adapter.removeChipAtIndex(index);
                    var maxIndex = this.adapter.getChipListCount() - 1;
                    if (maxIndex < 0) return;
                    var nextIndex = Math.min(index, maxIndex);
                    this.removeFocusFromChipsExcept_(nextIndex);
                    // After removing a chip, we should focus the trailing action for the next chip.
                    this.adapter.focusChipTrailingActionAtIndex(nextIndex);
                };
                /**
     * Handles a chip navigation event.
     */ MDCChipSetFoundation.prototype.handleChipNavigation = function(_a) {
                    var chipId = _a.chipId, key = _a.key, source = _a.source;
                    var maxIndex = this.adapter.getChipListCount() - 1;
                    var index = this.adapter.getIndexOfChipById(chipId);
                    // Early exit if the index is out of range or the key is unusable
                    if (index === -1 || !constants_1.navigationKeys.has(key)) return;
                    var isRTL = this.adapter.isRTL();
                    var isLeftKey = key === constants_1.strings.ARROW_LEFT_KEY || key === constants_1.strings.IE_ARROW_LEFT_KEY;
                    var isRightKey = key === constants_1.strings.ARROW_RIGHT_KEY || key === constants_1.strings.IE_ARROW_RIGHT_KEY;
                    var isDownKey = key === constants_1.strings.ARROW_DOWN_KEY || key === constants_1.strings.IE_ARROW_DOWN_KEY;
                    var shouldIncrement = !isRTL && isRightKey || isRTL && isLeftKey || isDownKey;
                    var isHome = key === constants_1.strings.HOME_KEY;
                    var isEnd = key === constants_1.strings.END_KEY;
                    if (shouldIncrement) index++;
                    else if (isHome) index = 0;
                    else if (isEnd) index = maxIndex;
                    else index--;
                    // Early exit if the index is out of bounds
                    if (index < 0 || index > maxIndex) return;
                    this.removeFocusFromChipsExcept_(index);
                    this.focusChipAction_(index, key, source);
                };
                MDCChipSetFoundation.prototype.focusChipAction_ = function(index, key, source) {
                    var shouldJumpChips = constants_1.jumpChipKeys.has(key);
                    if (shouldJumpChips && source === constants_1.EventSource.PRIMARY) return this.adapter.focusChipPrimaryActionAtIndex(index);
                    if (shouldJumpChips && source === constants_1.EventSource.TRAILING) return this.adapter.focusChipTrailingActionAtIndex(index);
                    var dir = this.getDirection_(key);
                    if (dir === constants_1.Direction.LEFT) return this.adapter.focusChipTrailingActionAtIndex(index);
                    if (dir === constants_1.Direction.RIGHT) return this.adapter.focusChipPrimaryActionAtIndex(index);
                };
                MDCChipSetFoundation.prototype.getDirection_ = function(key) {
                    var isRTL = this.adapter.isRTL();
                    var isLeftKey = key === constants_1.strings.ARROW_LEFT_KEY || key === constants_1.strings.IE_ARROW_LEFT_KEY;
                    var isRightKey = key === constants_1.strings.ARROW_RIGHT_KEY || key === constants_1.strings.IE_ARROW_RIGHT_KEY;
                    if (!isRTL && isLeftKey || isRTL && isRightKey) return constants_1.Direction.LEFT;
                    return constants_1.Direction.RIGHT;
                };
                /**
     * Deselects the chip with the given id and optionally notifies clients.
     */ MDCChipSetFoundation.prototype.deselect_ = function(chipId, shouldNotifyClients) {
                    if (shouldNotifyClients === void 0) shouldNotifyClients = false;
                    var index = this.selectedChipIds_.indexOf(chipId);
                    if (index >= 0) {
                        this.selectedChipIds_.splice(index, 1);
                        var chipIndex = this.adapter.getIndexOfChipById(chipId);
                        this.adapter.selectChipAtIndex(chipIndex, /** isSelected */ false, shouldNotifyClients);
                    }
                };
                /**
     * Deselects the chip with the given id and notifies clients.
     */ MDCChipSetFoundation.prototype.deselectAndNotifyClients_ = function(chipId) {
                    this.deselect_(chipId, true);
                };
                MDCChipSetFoundation.prototype.removeFocusFromChipsExcept_ = function(index) {
                    var chipCount = this.adapter.getChipListCount();
                    for(var i = 0; i < chipCount; i++)if (i !== index) this.adapter.removeFocusFromChipAtIndex(i);
                };
                MDCChipSetFoundation.prototype.select_ = function(chipId, shouldNotifyClients) {
                    if (this.selectedChipIds_.indexOf(chipId) >= 0) return;
                    if (this.adapter.hasClass(constants_2.cssClasses.CHOICE) && this.selectedChipIds_.length > 0) {
                        var previouslySelectedChip = this.selectedChipIds_[0];
                        var previouslySelectedIndex = this.adapter.getIndexOfChipById(previouslySelectedChip);
                        this.selectedChipIds_ = [];
                        this.adapter.selectChipAtIndex(previouslySelectedIndex, /** isSelected */ false, shouldNotifyClients);
                    }
                    this.selectedChipIds_.push(chipId);
                    var index = this.adapter.getIndexOfChipById(chipId);
                    this.adapter.selectChipAtIndex(index, /** isSelected */ true, shouldNotifyClients);
                };
                return MDCChipSetFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCChipSetFoundation = MDCChipSetFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCChipSetFoundation;
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/chip/component.ts": /*!*********************************************************!*\
  !*** ./packages/mdc-chips/deprecated/chip/component.ts ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCChip = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var component_2 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var component_3 = __webpack_require__(/*! ../trailingaction/component */ "./packages/mdc-chips/deprecated/trailingaction/component.ts");
            var constants_1 = __webpack_require__(/*! ../trailingaction/constants */ "./packages/mdc-chips/deprecated/trailingaction/constants.ts");
            var constants_2 = __webpack_require__(/*! ./constants */ "./packages/mdc-chips/deprecated/chip/constants.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-chips/deprecated/chip/foundation.ts");
            var MDCChip = /** @class */ function(_super) {
                __extends(MDCChip, _super);
                function MDCChip() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(MDCChip.prototype, "selected", {
                    /**
         * @return Whether the chip is selected.
         */ get: function get() {
                        return this.foundation.isSelected();
                    },
                    /**
         * Sets selected state on the chip.
         */ set: function set(selected) {
                        this.foundation.setSelected(selected);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChip.prototype, "shouldRemoveOnTrailingIconClick", {
                    /**
         * @return Whether a trailing icon click should trigger exit/removal of the chip.
         */ get: function get() {
                        return this.foundation.getShouldRemoveOnTrailingIconClick();
                    },
                    /**
         * Sets whether a trailing icon click should trigger exit/removal of the chip.
         */ set: function set(shouldRemove) {
                        this.foundation.setShouldRemoveOnTrailingIconClick(shouldRemove);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChip.prototype, "setShouldFocusPrimaryActionOnClick", {
                    /**
         * Sets whether a clicking on the chip should focus the primary action.
         */ set: function set(shouldFocus) {
                        this.foundation.setShouldFocusPrimaryActionOnClick(shouldFocus);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChip.prototype, "ripple", {
                    get: function get() {
                        return this.ripple_;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChip.prototype, "id", {
                    get: function get() {
                        return this.root.id;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCChip.attachTo = function(root) {
                    return new MDCChip(root);
                };
                MDCChip.prototype.initialize = function(rippleFactory, trailingActionFactory) {
                    var _this = this;
                    if (rippleFactory === void 0) rippleFactory = function rippleFactory(el, foundation) {
                        return new component_2.MDCRipple(el, foundation);
                    };
                    if (trailingActionFactory === void 0) trailingActionFactory = function trailingActionFactory(el) {
                        return new component_3.MDCChipTrailingAction(el);
                    };
                    this.leadingIcon_ = this.root.querySelector(constants_2.strings.LEADING_ICON_SELECTOR);
                    this.checkmark_ = this.root.querySelector(constants_2.strings.CHECKMARK_SELECTOR);
                    this.primaryAction_ = this.root.querySelector(constants_2.strings.PRIMARY_ACTION_SELECTOR);
                    var trailingActionEl = this.root.querySelector(constants_2.strings.TRAILING_ACTION_SELECTOR);
                    if (trailingActionEl) this.trailingAction_ = trailingActionFactory(trailingActionEl);
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var rippleAdapter = __assign(__assign({}, component_2.MDCRipple.createAdapter(this)), {
                        computeBoundingRect: function computeBoundingRect() {
                            return _this.foundation.getDimensions();
                        }
                    });
                    this.ripple_ = rippleFactory(this.root, new foundation_1.MDCRippleFoundation(rippleAdapter));
                };
                MDCChip.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    // Custom events
                    this.handleTrailingActionInteraction_ = function() {
                        _this.foundation.handleTrailingActionInteraction();
                    };
                    this.handleTrailingActionNavigation_ = function(evt) {
                        _this.foundation.handleTrailingActionNavigation(evt);
                    };
                    // Native events
                    this.handleClick_ = function() {
                        _this.foundation.handleClick();
                    };
                    this.handleKeydown_ = function(evt) {
                        _this.foundation.handleKeydown(evt);
                    };
                    this.handleTransitionEnd_ = function(evt) {
                        _this.foundation.handleTransitionEnd(evt);
                    };
                    this.handleFocusIn_ = function(evt) {
                        _this.foundation.handleFocusIn(evt);
                    };
                    this.handleFocusOut_ = function(evt) {
                        _this.foundation.handleFocusOut(evt);
                    };
                    this.listen("transitionend", this.handleTransitionEnd_);
                    this.listen("click", this.handleClick_);
                    this.listen("keydown", this.handleKeydown_);
                    this.listen("focusin", this.handleFocusIn_);
                    this.listen("focusout", this.handleFocusOut_);
                    if (this.trailingAction_) {
                        this.listen(constants_1.strings.INTERACTION_EVENT, this.handleTrailingActionInteraction_);
                        this.listen(constants_1.strings.NAVIGATION_EVENT, this.handleTrailingActionNavigation_);
                    }
                };
                MDCChip.prototype.destroy = function() {
                    this.ripple_.destroy();
                    this.unlisten("transitionend", this.handleTransitionEnd_);
                    this.unlisten("keydown", this.handleKeydown_);
                    this.unlisten("click", this.handleClick_);
                    this.unlisten("focusin", this.handleFocusIn_);
                    this.unlisten("focusout", this.handleFocusOut_);
                    if (this.trailingAction_) {
                        this.unlisten(constants_1.strings.INTERACTION_EVENT, this.handleTrailingActionInteraction_);
                        this.unlisten(constants_1.strings.NAVIGATION_EVENT, this.handleTrailingActionNavigation_);
                    }
                    _super.prototype.destroy.call(this);
                };
                /**
     * Begins the exit animation which leads to removal of the chip.
     */ MDCChip.prototype.beginExit = function() {
                    this.foundation.beginExit();
                };
                MDCChip.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        addClassToLeadingIcon: function addClassToLeadingIcon(className) {
                            if (_this.leadingIcon_) _this.leadingIcon_.classList.add(className);
                        },
                        eventTargetHasClass: function eventTargetHasClass(target, className) {
                            return target ? target.classList.contains(className) : false;
                        },
                        focusPrimaryAction: function focusPrimaryAction() {
                            if (_this.primaryAction_) _this.primaryAction_.focus();
                        },
                        focusTrailingAction: function focusTrailingAction() {
                            if (_this.trailingAction_) _this.trailingAction_.focus();
                        },
                        getAttribute: function getAttribute(attr) {
                            return _this.root.getAttribute(attr);
                        },
                        getCheckmarkBoundingClientRect: function getCheckmarkBoundingClientRect() {
                            return _this.checkmark_ ? _this.checkmark_.getBoundingClientRect() : null;
                        },
                        getComputedStyleValue: function getComputedStyleValue(propertyName) {
                            return window.getComputedStyle(_this.root).getPropertyValue(propertyName);
                        },
                        getRootBoundingClientRect: function getRootBoundingClientRect() {
                            return _this.root.getBoundingClientRect();
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        hasLeadingIcon: function hasLeadingIcon() {
                            return !!_this.leadingIcon_;
                        },
                        isRTL: function isRTL() {
                            return window.getComputedStyle(_this.root).getPropertyValue("direction") === "rtl";
                        },
                        isTrailingActionNavigable: function isTrailingActionNavigable() {
                            if (_this.trailingAction_) return _this.trailingAction_.isNavigable();
                            return false;
                        },
                        notifyInteraction: function notifyInteraction() {
                            return _this.emit(constants_2.strings.INTERACTION_EVENT, {
                                chipId: _this.id
                            }, true);
                        },
                        notifyNavigation: function notifyNavigation(key, source) {
                            return _this.emit(constants_2.strings.NAVIGATION_EVENT, {
                                chipId: _this.id,
                                key: key,
                                source: source
                            }, true);
                        },
                        notifyRemoval: function notifyRemoval(removedAnnouncement) {
                            _this.emit(constants_2.strings.REMOVAL_EVENT, {
                                chipId: _this.id,
                                removedAnnouncement: removedAnnouncement
                            }, true);
                        },
                        notifySelection: function notifySelection(selected, shouldIgnore) {
                            return _this.emit(constants_2.strings.SELECTION_EVENT, {
                                chipId: _this.id,
                                selected: selected,
                                shouldIgnore: shouldIgnore
                            }, true);
                        },
                        notifyTrailingIconInteraction: function notifyTrailingIconInteraction() {
                            return _this.emit(constants_2.strings.TRAILING_ICON_INTERACTION_EVENT, {
                                chipId: _this.id
                            }, true);
                        },
                        notifyEditStart: function notifyEditStart() {},
                        notifyEditFinish: function notifyEditFinish() {},
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        removeClassFromLeadingIcon: function removeClassFromLeadingIcon(className) {
                            if (_this.leadingIcon_) _this.leadingIcon_.classList.remove(className);
                        },
                        removeTrailingActionFocus: function removeTrailingActionFocus() {
                            if (_this.trailingAction_) _this.trailingAction_.removeFocus();
                        },
                        setPrimaryActionAttr: function setPrimaryActionAttr(attr, value) {
                            if (_this.primaryAction_) _this.primaryAction_.setAttribute(attr, value);
                        },
                        setStyleProperty: function setStyleProperty(propertyName, value) {
                            return _this.root.style.setProperty(propertyName, value);
                        }
                    };
                    return new foundation_2.MDCChipFoundation(adapter);
                };
                MDCChip.prototype.setSelectedFromChipSet = function(selected, shouldNotifyClients) {
                    this.foundation.setSelectedFromChipSet(selected, shouldNotifyClients);
                };
                MDCChip.prototype.focusPrimaryAction = function() {
                    this.foundation.focusPrimaryAction();
                };
                MDCChip.prototype.focusTrailingAction = function() {
                    this.foundation.focusTrailingAction();
                };
                MDCChip.prototype.removeFocus = function() {
                    this.foundation.removeFocus();
                };
                MDCChip.prototype.makePrimaryActionFocusable = function() {
                    if (!this.primaryAction_) return;
                    this.primaryAction_.setAttribute("tabindex", "0");
                };
                MDCChip.prototype.isPrimaryActionFocusable = function() {
                    if (!this.primaryAction_) return false;
                    return this.primaryAction_.getAttribute("tabindex") === "0";
                };
                return MDCChip;
            }(component_1.MDCComponent);
            exports.MDCChip = MDCChip;
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/chip/constants.ts": /*!*********************************************************!*\
  !*** ./packages/mdc-chips/deprecated/chip/constants.ts ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.jumpChipKeys = exports.navigationKeys = exports.cssClasses = exports.strings = exports.EventSource = exports.Direction = void 0;
            var Direction;
            (function(Direction) {
                Direction["LEFT"] = "left";
                Direction["RIGHT"] = "right";
            })(Direction = exports.Direction || (exports.Direction = {}));
            var EventSource;
            (function(EventSource) {
                EventSource["PRIMARY"] = "primary";
                EventSource["TRAILING"] = "trailing";
                EventSource["NONE"] = "none";
            })(EventSource = exports.EventSource || (exports.EventSource = {}));
            exports.strings = {
                ADDED_ANNOUNCEMENT_ATTRIBUTE: "data-mdc-chip-added-announcement",
                ARIA_CHECKED: "aria-checked",
                ARROW_DOWN_KEY: "ArrowDown",
                ARROW_LEFT_KEY: "ArrowLeft",
                ARROW_RIGHT_KEY: "ArrowRight",
                ARROW_UP_KEY: "ArrowUp",
                BACKSPACE_KEY: "Backspace",
                CHECKMARK_SELECTOR: ".mdc-chip__checkmark",
                DELETE_KEY: "Delete",
                END_KEY: "End",
                ENTER_KEY: "Enter",
                ENTRY_ANIMATION_NAME: "mdc-chip-entry",
                HOME_KEY: "Home",
                IE_ARROW_DOWN_KEY: "Down",
                IE_ARROW_LEFT_KEY: "Left",
                IE_ARROW_RIGHT_KEY: "Right",
                IE_ARROW_UP_KEY: "Up",
                IE_DELETE_KEY: "Del",
                INTERACTION_EVENT: "MDCChip:interaction",
                LEADING_ICON_SELECTOR: ".mdc-chip__icon--leading",
                NAVIGATION_EVENT: "MDCChip:navigation",
                PRIMARY_ACTION_SELECTOR: ".mdc-chip__primary-action",
                REMOVED_ANNOUNCEMENT_ATTRIBUTE: "data-mdc-chip-removed-announcement",
                REMOVAL_EVENT: "MDCChip:removal",
                SELECTION_EVENT: "MDCChip:selection",
                SPACEBAR_KEY: " ",
                TAB_INDEX: "tabindex",
                TRAILING_ACTION_SELECTOR: ".mdc-chip-trailing-action",
                TRAILING_ICON_INTERACTION_EVENT: "MDCChip:trailingIconInteraction",
                TRAILING_ICON_SELECTOR: ".mdc-chip__icon--trailing"
            };
            exports.cssClasses = {
                CHECKMARK: "mdc-chip__checkmark",
                CHIP_EXIT: "mdc-chip--exit",
                DELETABLE: "mdc-chip--deletable",
                EDITABLE: "mdc-chip--editable",
                EDITING: "mdc-chip--editing",
                HIDDEN_LEADING_ICON: "mdc-chip__icon--leading-hidden",
                LEADING_ICON: "mdc-chip__icon--leading",
                PRIMARY_ACTION: "mdc-chip__primary-action",
                PRIMARY_ACTION_FOCUSED: "mdc-chip--primary-action-focused",
                SELECTED: "mdc-chip--selected",
                TEXT: "mdc-chip__text",
                TRAILING_ACTION: "mdc-chip__trailing-action",
                TRAILING_ICON: "mdc-chip__icon--trailing"
            };
            exports.navigationKeys = new Set();
            // IE11 has no support for new Set with iterable so we need to initialize this by hand
            exports.navigationKeys.add(exports.strings.ARROW_LEFT_KEY);
            exports.navigationKeys.add(exports.strings.ARROW_RIGHT_KEY);
            exports.navigationKeys.add(exports.strings.ARROW_DOWN_KEY);
            exports.navigationKeys.add(exports.strings.ARROW_UP_KEY);
            exports.navigationKeys.add(exports.strings.END_KEY);
            exports.navigationKeys.add(exports.strings.HOME_KEY);
            exports.navigationKeys.add(exports.strings.IE_ARROW_LEFT_KEY);
            exports.navigationKeys.add(exports.strings.IE_ARROW_RIGHT_KEY);
            exports.navigationKeys.add(exports.strings.IE_ARROW_DOWN_KEY);
            exports.navigationKeys.add(exports.strings.IE_ARROW_UP_KEY);
            exports.jumpChipKeys = new Set();
            // IE11 has no support for new Set with iterable so we need to initialize this by hand
            exports.jumpChipKeys.add(exports.strings.ARROW_UP_KEY);
            exports.jumpChipKeys.add(exports.strings.ARROW_DOWN_KEY);
            exports.jumpChipKeys.add(exports.strings.HOME_KEY);
            exports.jumpChipKeys.add(exports.strings.END_KEY);
            exports.jumpChipKeys.add(exports.strings.IE_ARROW_UP_KEY);
            exports.jumpChipKeys.add(exports.strings.IE_ARROW_DOWN_KEY);
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/chip/foundation.ts": /*!**********************************************************!*\
  !*** ./packages/mdc-chips/deprecated/chip/foundation.ts ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCChipFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-chips/deprecated/chip/constants.ts");
            var emptyClientRect = {
                bottom: 0,
                height: 0,
                left: 0,
                right: 0,
                top: 0,
                width: 0
            };
            var FocusBehavior;
            (function(FocusBehavior) {
                FocusBehavior[FocusBehavior["SHOULD_FOCUS"] = 0] = "SHOULD_FOCUS";
                FocusBehavior[FocusBehavior["SHOULD_NOT_FOCUS"] = 1] = "SHOULD_NOT_FOCUS";
            })(FocusBehavior || (FocusBehavior = {}));
            var MDCChipFoundation = /** @class */ function(_super) {
                __extends(MDCChipFoundation, _super);
                function MDCChipFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCChipFoundation.defaultAdapter), adapter)) || this;
                    /** Whether a trailing icon click should immediately trigger exit/removal of the chip. */ _this.shouldRemoveOnTrailingIconClick_ = true;
                    /**
         * Whether the primary action should receive focus on click. Should only be
         * set to true for clients who programmatically give focus to a different
         * element on the page when a chip is clicked (like a menu).
         */ _this.shouldFocusPrimaryActionOnClick_ = true;
                    return _this;
                }
                Object.defineProperty(MDCChipFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChipFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChipFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            addClassToLeadingIcon: function addClassToLeadingIcon() {
                                return undefined;
                            },
                            eventTargetHasClass: function eventTargetHasClass() {
                                return false;
                            },
                            focusPrimaryAction: function focusPrimaryAction() {
                                return undefined;
                            },
                            focusTrailingAction: function focusTrailingAction() {
                                return undefined;
                            },
                            getAttribute: function getAttribute() {
                                return null;
                            },
                            getCheckmarkBoundingClientRect: function getCheckmarkBoundingClientRect() {
                                return emptyClientRect;
                            },
                            getComputedStyleValue: function getComputedStyleValue() {
                                return "";
                            },
                            getRootBoundingClientRect: function getRootBoundingClientRect() {
                                return emptyClientRect;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            hasLeadingIcon: function hasLeadingIcon() {
                                return false;
                            },
                            isRTL: function isRTL() {
                                return false;
                            },
                            isTrailingActionNavigable: function isTrailingActionNavigable() {
                                return false;
                            },
                            notifyEditFinish: function notifyEditFinish() {
                                return undefined;
                            },
                            notifyEditStart: function notifyEditStart() {
                                return undefined;
                            },
                            notifyInteraction: function notifyInteraction() {
                                return undefined;
                            },
                            notifyNavigation: function notifyNavigation() {
                                return undefined;
                            },
                            notifyRemoval: function notifyRemoval() {
                                return undefined;
                            },
                            notifySelection: function notifySelection() {
                                return undefined;
                            },
                            notifyTrailingIconInteraction: function notifyTrailingIconInteraction() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            removeClassFromLeadingIcon: function removeClassFromLeadingIcon() {
                                return undefined;
                            },
                            removeTrailingActionFocus: function removeTrailingActionFocus() {
                                return undefined;
                            },
                            setPrimaryActionAttr: function setPrimaryActionAttr() {
                                return undefined;
                            },
                            setStyleProperty: function setStyleProperty() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCChipFoundation.prototype.isSelected = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.SELECTED);
                };
                MDCChipFoundation.prototype.isEditable = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.EDITABLE);
                };
                MDCChipFoundation.prototype.isEditing = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.EDITING);
                };
                MDCChipFoundation.prototype.setSelected = function(selected) {
                    this.setSelected_(selected);
                    this.notifySelection_(selected);
                };
                MDCChipFoundation.prototype.setSelectedFromChipSet = function(selected, shouldNotifyClients) {
                    this.setSelected_(selected);
                    if (shouldNotifyClients) this.notifyIgnoredSelection_(selected);
                };
                MDCChipFoundation.prototype.getShouldRemoveOnTrailingIconClick = function() {
                    return this.shouldRemoveOnTrailingIconClick_;
                };
                MDCChipFoundation.prototype.setShouldRemoveOnTrailingIconClick = function(shouldRemove) {
                    this.shouldRemoveOnTrailingIconClick_ = shouldRemove;
                };
                MDCChipFoundation.prototype.setShouldFocusPrimaryActionOnClick = function(shouldFocus) {
                    this.shouldFocusPrimaryActionOnClick_ = shouldFocus;
                };
                MDCChipFoundation.prototype.getDimensions = function() {
                    var _this = this;
                    var getRootRect = function getRootRect() {
                        return _this.adapter.getRootBoundingClientRect();
                    };
                    var getCheckmarkRect = function getCheckmarkRect() {
                        return _this.adapter.getCheckmarkBoundingClientRect();
                    };
                    // When a chip has a checkmark and not a leading icon, the bounding rect changes in size depending on the current
                    // size of the checkmark.
                    if (!this.adapter.hasLeadingIcon()) {
                        var checkmarkRect = getCheckmarkRect();
                        if (checkmarkRect) {
                            var rootRect = getRootRect();
                            // Checkmark is a square, meaning the client rect's width and height are identical once the animation completes.
                            // However, the checkbox is initially hidden by setting the width to 0.
                            // To account for an initial width of 0, we use the checkbox's height instead (which equals the end-state width)
                            // when adding it to the root client rect's width.
                            return {
                                bottom: rootRect.bottom,
                                height: rootRect.height,
                                left: rootRect.left,
                                right: rootRect.right,
                                top: rootRect.top,
                                width: rootRect.width + checkmarkRect.height
                            };
                        }
                    }
                    return getRootRect();
                };
                /**
     * Begins the exit animation which leads to removal of the chip.
     */ MDCChipFoundation.prototype.beginExit = function() {
                    this.adapter.addClass(constants_1.cssClasses.CHIP_EXIT);
                };
                MDCChipFoundation.prototype.handleClick = function() {
                    this.adapter.notifyInteraction();
                    this.setPrimaryActionFocusable_(this.getFocusBehavior_());
                };
                MDCChipFoundation.prototype.handleDoubleClick = function() {
                    if (this.isEditable()) this.startEditing();
                };
                /**
     * Handles a transition end event on the root element.
     */ MDCChipFoundation.prototype.handleTransitionEnd = function(evt) {
                    var _this = this;
                    // Handle transition end event on the chip when it is about to be removed.
                    var shouldHandle = this.adapter.eventTargetHasClass(evt.target, constants_1.cssClasses.CHIP_EXIT);
                    var widthIsAnimating = evt.propertyName === "width";
                    var opacityIsAnimating = evt.propertyName === "opacity";
                    if (shouldHandle && opacityIsAnimating) {
                        // See: https://css-tricks.com/using-css-transitions-auto-dimensions/#article-header-id-5
                        var chipWidth_1 = this.adapter.getComputedStyleValue("width");
                        // On the next frame (once we get the computed width), explicitly set the chip's width
                        // to its current pixel width, so we aren't transitioning out of 'auto'.
                        requestAnimationFrame(function() {
                            _this.adapter.setStyleProperty("width", chipWidth_1);
                            // To mitigate jitter, start transitioning padding and margin before width.
                            _this.adapter.setStyleProperty("padding", "0");
                            _this.adapter.setStyleProperty("margin", "0");
                            // On the next frame (once width is explicitly set), transition width to 0.
                            requestAnimationFrame(function() {
                                _this.adapter.setStyleProperty("width", "0");
                            });
                        });
                        return;
                    }
                    if (shouldHandle && widthIsAnimating) {
                        this.removeFocus();
                        var removedAnnouncement = this.adapter.getAttribute(constants_1.strings.REMOVED_ANNOUNCEMENT_ATTRIBUTE);
                        this.adapter.notifyRemoval(removedAnnouncement);
                    }
                    // Handle a transition end event on the leading icon or checkmark, since the transition end event bubbles.
                    if (!opacityIsAnimating) return;
                    var shouldHideLeadingIcon = this.adapter.eventTargetHasClass(evt.target, constants_1.cssClasses.LEADING_ICON) && this.adapter.hasClass(constants_1.cssClasses.SELECTED);
                    var shouldShowLeadingIcon = this.adapter.eventTargetHasClass(evt.target, constants_1.cssClasses.CHECKMARK) && !this.adapter.hasClass(constants_1.cssClasses.SELECTED);
                    if (shouldHideLeadingIcon) {
                        this.adapter.addClassToLeadingIcon(constants_1.cssClasses.HIDDEN_LEADING_ICON);
                        return;
                    }
                    if (shouldShowLeadingIcon) {
                        this.adapter.removeClassFromLeadingIcon(constants_1.cssClasses.HIDDEN_LEADING_ICON);
                        return;
                    }
                };
                MDCChipFoundation.prototype.handleFocusIn = function(evt) {
                    // Early exit if the event doesn't come from the primary action
                    if (!this.eventFromPrimaryAction_(evt)) return;
                    this.adapter.addClass(constants_1.cssClasses.PRIMARY_ACTION_FOCUSED);
                };
                MDCChipFoundation.prototype.handleFocusOut = function(evt) {
                    // Early exit if the event doesn't come from the primary action
                    if (!this.eventFromPrimaryAction_(evt)) return;
                    if (this.isEditing()) this.finishEditing();
                    this.adapter.removeClass(constants_1.cssClasses.PRIMARY_ACTION_FOCUSED);
                };
                /**
     * Handles an interaction event on the trailing icon element. This is used to
     * prevent the ripple from activating on interaction with the trailing icon.
     */ MDCChipFoundation.prototype.handleTrailingActionInteraction = function() {
                    this.adapter.notifyTrailingIconInteraction();
                    this.removeChip_();
                };
                /**
     * Handles a keydown event from the root element.
     */ MDCChipFoundation.prototype.handleKeydown = function(evt) {
                    if (this.isEditing()) {
                        if (this.shouldFinishEditing(evt)) {
                            evt.preventDefault();
                            this.finishEditing();
                        }
                        // When editing, the foundation should only handle key events that finish
                        // the editing process.
                        return;
                    }
                    if (this.isEditable()) {
                        if (this.shouldStartEditing(evt)) {
                            evt.preventDefault();
                            this.startEditing();
                        }
                    }
                    if (this.shouldNotifyInteraction_(evt)) {
                        this.adapter.notifyInteraction();
                        this.setPrimaryActionFocusable_(this.getFocusBehavior_());
                        evt.preventDefault();
                        return;
                    }
                    if (this.isDeleteAction_(evt)) {
                        evt.preventDefault();
                        this.removeChip_();
                        return;
                    }
                    // Early exit if the key is not usable
                    if (!constants_1.navigationKeys.has(evt.key)) return;
                    // Prevent default behavior for movement keys which could include scrolling
                    evt.preventDefault();
                    this.focusNextAction_(evt.key, constants_1.EventSource.PRIMARY);
                };
                MDCChipFoundation.prototype.handleTrailingActionNavigation = function(evt) {
                    return this.focusNextAction_(evt.detail.key, constants_1.EventSource.TRAILING);
                };
                /**
     * Called by the chip set to remove focus from the chip actions.
     */ MDCChipFoundation.prototype.removeFocus = function() {
                    this.adapter.setPrimaryActionAttr(constants_1.strings.TAB_INDEX, "-1");
                    this.adapter.removeTrailingActionFocus();
                };
                /**
     * Called by the chip set to focus the primary action.
     *
     */ MDCChipFoundation.prototype.focusPrimaryAction = function() {
                    this.setPrimaryActionFocusable_(FocusBehavior.SHOULD_FOCUS);
                };
                /**
     * Called by the chip set to focus the trailing action (if present), otherwise
     * gives focus to the trailing action.
     */ MDCChipFoundation.prototype.focusTrailingAction = function() {
                    var trailingActionIsNavigable = this.adapter.isTrailingActionNavigable();
                    if (trailingActionIsNavigable) {
                        this.adapter.setPrimaryActionAttr(constants_1.strings.TAB_INDEX, "-1");
                        this.adapter.focusTrailingAction();
                        return;
                    }
                    this.focusPrimaryAction();
                };
                MDCChipFoundation.prototype.setPrimaryActionFocusable_ = function(focusBehavior) {
                    this.adapter.setPrimaryActionAttr(constants_1.strings.TAB_INDEX, "0");
                    if (focusBehavior === FocusBehavior.SHOULD_FOCUS) this.adapter.focusPrimaryAction();
                    this.adapter.removeTrailingActionFocus();
                };
                MDCChipFoundation.prototype.getFocusBehavior_ = function() {
                    if (this.shouldFocusPrimaryActionOnClick_) return FocusBehavior.SHOULD_FOCUS;
                    return FocusBehavior.SHOULD_NOT_FOCUS;
                };
                MDCChipFoundation.prototype.focusNextAction_ = function(key, source) {
                    var isTrailingActionNavigable = this.adapter.isTrailingActionNavigable();
                    var dir = this.getDirection_(key);
                    // Early exit if the key should jump chips
                    if (constants_1.jumpChipKeys.has(key) || !isTrailingActionNavigable) return this.adapter.notifyNavigation(key, source);
                    if (source === constants_1.EventSource.PRIMARY && dir === constants_1.Direction.RIGHT) return this.focusTrailingAction();
                    if (source === constants_1.EventSource.TRAILING && dir === constants_1.Direction.LEFT) return this.focusPrimaryAction();
                    this.adapter.notifyNavigation(key, constants_1.EventSource.NONE);
                };
                MDCChipFoundation.prototype.getDirection_ = function(key) {
                    var isRTL = this.adapter.isRTL();
                    var isLeftKey = key === constants_1.strings.ARROW_LEFT_KEY || key === constants_1.strings.IE_ARROW_LEFT_KEY;
                    var isRightKey = key === constants_1.strings.ARROW_RIGHT_KEY || key === constants_1.strings.IE_ARROW_RIGHT_KEY;
                    if (!isRTL && isLeftKey || isRTL && isRightKey) return constants_1.Direction.LEFT;
                    return constants_1.Direction.RIGHT;
                };
                MDCChipFoundation.prototype.removeChip_ = function() {
                    if (this.shouldRemoveOnTrailingIconClick_) this.beginExit();
                };
                MDCChipFoundation.prototype.shouldStartEditing = function(evt) {
                    return this.eventFromPrimaryAction_(evt) && evt.key === constants_1.strings.ENTER_KEY;
                };
                MDCChipFoundation.prototype.shouldFinishEditing = function(evt) {
                    return evt.key === constants_1.strings.ENTER_KEY;
                };
                MDCChipFoundation.prototype.shouldNotifyInteraction_ = function(evt) {
                    return evt.key === constants_1.strings.ENTER_KEY || evt.key === constants_1.strings.SPACEBAR_KEY;
                };
                MDCChipFoundation.prototype.isDeleteAction_ = function(evt) {
                    var isDeletable = this.adapter.hasClass(constants_1.cssClasses.DELETABLE);
                    return isDeletable && (evt.key === constants_1.strings.BACKSPACE_KEY || evt.key === constants_1.strings.DELETE_KEY || evt.key === constants_1.strings.IE_DELETE_KEY);
                };
                MDCChipFoundation.prototype.setSelected_ = function(selected) {
                    if (selected) {
                        this.adapter.addClass(constants_1.cssClasses.SELECTED);
                        this.adapter.setPrimaryActionAttr(constants_1.strings.ARIA_CHECKED, "true");
                    } else {
                        this.adapter.removeClass(constants_1.cssClasses.SELECTED);
                        this.adapter.setPrimaryActionAttr(constants_1.strings.ARIA_CHECKED, "false");
                    }
                };
                MDCChipFoundation.prototype.notifySelection_ = function(selected) {
                    this.adapter.notifySelection(selected, false);
                };
                MDCChipFoundation.prototype.notifyIgnoredSelection_ = function(selected) {
                    this.adapter.notifySelection(selected, true);
                };
                MDCChipFoundation.prototype.eventFromPrimaryAction_ = function(evt) {
                    return this.adapter.eventTargetHasClass(evt.target, constants_1.cssClasses.PRIMARY_ACTION);
                };
                MDCChipFoundation.prototype.startEditing = function() {
                    this.adapter.addClass(constants_1.cssClasses.EDITING);
                    this.adapter.notifyEditStart();
                };
                MDCChipFoundation.prototype.finishEditing = function() {
                    this.adapter.removeClass(constants_1.cssClasses.EDITING);
                    this.adapter.notifyEditFinish();
                };
                return MDCChipFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCChipFoundation = MDCChipFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCChipFoundation;
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/trailingaction/component.ts": /*!*******************************************************************!*\
  !*** ./packages/mdc-chips/deprecated/trailingaction/component.ts ***!
  \*******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCChipTrailingAction = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var component_2 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-chips/deprecated/trailingaction/constants.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-chips/deprecated/trailingaction/foundation.ts");
            var MDCChipTrailingAction = /** @class */ function(_super) {
                __extends(MDCChipTrailingAction, _super);
                function MDCChipTrailingAction() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(MDCChipTrailingAction.prototype, "ripple", {
                    get: function get() {
                        return this.ripple_;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCChipTrailingAction.attachTo = function(root) {
                    return new MDCChipTrailingAction(root);
                };
                MDCChipTrailingAction.prototype.initialize = function(rippleFactory) {
                    if (rippleFactory === void 0) rippleFactory = function rippleFactory(el, foundation) {
                        return new component_2.MDCRipple(el, foundation);
                    };
                    // DO NOT INLINE this variable. For backward compatibility, foundations take
                    // a Partial<MDCFooAdapter>. To ensure we don't accidentally omit any
                    // methods, we need a separate, strongly typed adapter variable.
                    var rippleAdapter = component_2.MDCRipple.createAdapter(this);
                    this.ripple_ = rippleFactory(this.root, new foundation_1.MDCRippleFoundation(rippleAdapter));
                };
                MDCChipTrailingAction.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.handleClick_ = function(evt) {
                        _this.foundation.handleClick(evt);
                    };
                    this.handleKeydown_ = function(evt) {
                        _this.foundation.handleKeydown(evt);
                    };
                    this.listen("click", this.handleClick_);
                    this.listen("keydown", this.handleKeydown_);
                };
                MDCChipTrailingAction.prototype.destroy = function() {
                    this.ripple_.destroy();
                    this.unlisten("click", this.handleClick_);
                    this.unlisten("keydown", this.handleKeydown_);
                    _super.prototype.destroy.call(this);
                };
                MDCChipTrailingAction.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take
                    // a Partial<MDCFooAdapter>. To ensure we don't accidentally omit any
                    // methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        focus: function focus() {
                            // TODO(b/157231863): Migate MDCComponent#root to HTMLElement
                            _this.root.focus();
                        },
                        getAttribute: function getAttribute(attr) {
                            return _this.root.getAttribute(attr);
                        },
                        notifyInteraction: function notifyInteraction(trigger) {
                            return _this.emit(constants_1.strings.INTERACTION_EVENT, {
                                trigger: trigger
                            }, true);
                        },
                        notifyNavigation: function notifyNavigation(key) {
                            _this.emit(constants_1.strings.NAVIGATION_EVENT, {
                                key: key
                            }, true);
                        },
                        setAttribute: function setAttribute(attr, value) {
                            _this.root.setAttribute(attr, value);
                        }
                    };
                    return new foundation_2.MDCChipTrailingActionFoundation(adapter);
                };
                MDCChipTrailingAction.prototype.isNavigable = function() {
                    return this.foundation.isNavigable();
                };
                MDCChipTrailingAction.prototype.focus = function() {
                    this.foundation.focus();
                };
                MDCChipTrailingAction.prototype.removeFocus = function() {
                    this.foundation.removeFocus();
                };
                return MDCChipTrailingAction;
            }(component_1.MDCComponent);
            exports.MDCChipTrailingAction = MDCChipTrailingAction;
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/trailingaction/constants.ts": /*!*******************************************************************!*\
  !*** ./packages/mdc-chips/deprecated/trailingaction/constants.ts ***!
  \*******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.InteractionTrigger = void 0;
            var InteractionTrigger;
            (function(InteractionTrigger) {
                InteractionTrigger[InteractionTrigger["UNSPECIFIED"] = 0] = "UNSPECIFIED";
                InteractionTrigger[InteractionTrigger["CLICK"] = 1] = "CLICK";
                InteractionTrigger[InteractionTrigger["BACKSPACE_KEY"] = 2] = "BACKSPACE_KEY";
                InteractionTrigger[InteractionTrigger["DELETE_KEY"] = 3] = "DELETE_KEY";
                InteractionTrigger[InteractionTrigger["SPACEBAR_KEY"] = 4] = "SPACEBAR_KEY";
                InteractionTrigger[InteractionTrigger["ENTER_KEY"] = 5] = "ENTER_KEY";
            })(InteractionTrigger = exports.InteractionTrigger || (exports.InteractionTrigger = {}));
            exports.strings = {
                ARIA_HIDDEN: "aria-hidden",
                INTERACTION_EVENT: "MDCChipTrailingAction:interaction",
                NAVIGATION_EVENT: "MDCChipTrailingAction:navigation",
                TAB_INDEX: "tabindex"
            };
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/trailingaction/foundation.ts": /*!********************************************************************!*\
  !*** ./packages/mdc-chips/deprecated/trailingaction/foundation.ts ***!
  \********************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCChipTrailingActionFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var keyboard_1 = __webpack_require__(/*! @material/dom/keyboard */ "./packages/mdc-dom/keyboard.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-chips/deprecated/trailingaction/constants.ts");
            var MDCChipTrailingActionFoundation = /** @class */ function(_super) {
                __extends(MDCChipTrailingActionFoundation, _super);
                function MDCChipTrailingActionFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCChipTrailingActionFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCChipTrailingActionFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChipTrailingActionFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            focus: function focus() {
                                return undefined;
                            },
                            getAttribute: function getAttribute() {
                                return null;
                            },
                            setAttribute: function setAttribute() {
                                return undefined;
                            },
                            notifyInteraction: function notifyInteraction() {
                                return undefined;
                            },
                            notifyNavigation: function notifyNavigation() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCChipTrailingActionFoundation.prototype.handleClick = function(evt) {
                    evt.stopPropagation();
                    this.adapter.notifyInteraction(constants_1.InteractionTrigger.CLICK);
                };
                MDCChipTrailingActionFoundation.prototype.handleKeydown = function(evt) {
                    evt.stopPropagation();
                    var key = keyboard_1.normalizeKey(evt);
                    if (this.shouldNotifyInteractionFromKey_(key)) {
                        var trigger = this.getTriggerFromKey_(key);
                        this.adapter.notifyInteraction(trigger);
                        return;
                    }
                    if (keyboard_1.isNavigationEvent(evt)) {
                        this.adapter.notifyNavigation(key);
                        return;
                    }
                };
                MDCChipTrailingActionFoundation.prototype.removeFocus = function() {
                    this.adapter.setAttribute(constants_1.strings.TAB_INDEX, "-1");
                };
                MDCChipTrailingActionFoundation.prototype.focus = function() {
                    this.adapter.setAttribute(constants_1.strings.TAB_INDEX, "0");
                    this.adapter.focus();
                };
                MDCChipTrailingActionFoundation.prototype.isNavigable = function() {
                    return this.adapter.getAttribute(constants_1.strings.ARIA_HIDDEN) !== "true";
                };
                MDCChipTrailingActionFoundation.prototype.shouldNotifyInteractionFromKey_ = function(key) {
                    var isFromActionKey = key === keyboard_1.KEY.ENTER || key === keyboard_1.KEY.SPACEBAR;
                    var isFromDeleteKey = key === keyboard_1.KEY.BACKSPACE || key === keyboard_1.KEY.DELETE;
                    return isFromActionKey || isFromDeleteKey;
                };
                MDCChipTrailingActionFoundation.prototype.getTriggerFromKey_ = function(key) {
                    if (key === keyboard_1.KEY.SPACEBAR) return constants_1.InteractionTrigger.SPACEBAR_KEY;
                    if (key === keyboard_1.KEY.ENTER) return constants_1.InteractionTrigger.ENTER_KEY;
                    if (key === keyboard_1.KEY.DELETE) return constants_1.InteractionTrigger.DELETE_KEY;
                    if (key === keyboard_1.KEY.BACKSPACE) return constants_1.InteractionTrigger.BACKSPACE_KEY;
                    // Default case, should never be returned
                    return constants_1.InteractionTrigger.UNSPECIFIED;
                };
                return MDCChipTrailingActionFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCChipTrailingActionFoundation = MDCChipTrailingActionFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCChipTrailingActionFoundation;
        /***/ },
        /***/ "./packages/mdc-circular-progress/component.ts": /*!*****************************************************!*\
  !*** ./packages/mdc-circular-progress/component.ts ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCCircularProgress = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-circular-progress/foundation.ts");
            var MDCCircularProgress = /** @class */ function(_super) {
                __extends(MDCCircularProgress, _super);
                function MDCCircularProgress() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCCircularProgress.prototype.initialize = function() {
                    this.determinateCircle_ = this.root.querySelector(foundation_1.MDCCircularProgressFoundation.strings.DETERMINATE_CIRCLE_SELECTOR);
                };
                MDCCircularProgress.attachTo = function(root) {
                    return new MDCCircularProgress(root);
                };
                Object.defineProperty(MDCCircularProgress.prototype, "determinate", {
                    /**
         * Sets whether the progress indicator is in determinate mode.
         * @param isDeterminate Whether the indicator should be determinate.
         */ set: function set(value) {
                        this.foundation.setDeterminate(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCircularProgress.prototype, "progress", {
                    /**
         * Sets the current progress value. In indeterminate mode, this has no
         * visual effect but will be reflected if the indicator is switched to
         * determinate mode.
         * @param value The current progress value, which must be between 0 and 1.
         */ set: function set(value) {
                        this.foundation.setProgress(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCircularProgress.prototype, "isClosed", {
                    /**
         * Whether the progress indicator is hidden.
         */ get: function get() {
                        return this.foundation.isClosed();
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Shows the progress indicator.
     */ MDCCircularProgress.prototype.open = function() {
                    this.foundation.open();
                };
                /**
     * Hides the progress indicator.
     */ MDCCircularProgress.prototype.close = function() {
                    this.foundation.close();
                };
                MDCCircularProgress.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take
                    // a Partial<MDCFooAdapter>. To ensure we don't accidentally omit any
                    // methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        getDeterminateCircleAttribute: function getDeterminateCircleAttribute(attributeName) {
                            return _this.determinateCircle_.getAttribute(attributeName);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        removeAttribute: function removeAttribute(attributeName) {
                            return _this.root.removeAttribute(attributeName);
                        },
                        setAttribute: function setAttribute(attributeName, value) {
                            return _this.root.setAttribute(attributeName, value);
                        },
                        setDeterminateCircleAttribute: function setDeterminateCircleAttribute(attributeName, value) {
                            return _this.determinateCircle_.setAttribute(attributeName, value);
                        }
                    };
                    return new foundation_1.MDCCircularProgressFoundation(adapter);
                };
                return MDCCircularProgress;
            }(component_1.MDCComponent);
            exports.MDCCircularProgress = MDCCircularProgress;
        /***/ },
        /***/ "./packages/mdc-circular-progress/constants.ts": /*!*****************************************************!*\
  !*** ./packages/mdc-circular-progress/constants.ts ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.cssClasses = void 0;
            /**
 * CSS class names used in component.
 */ exports.cssClasses = {
                INDETERMINATE_CLASS: "mdc-circular-progress--indeterminate",
                CLOSED_CLASS: "mdc-circular-progress--closed"
            };
            /**
 * Attributes and selectors used in component.
 */ exports.strings = {
                ARIA_HIDDEN: "aria-hidden",
                ARIA_VALUENOW: "aria-valuenow",
                DETERMINATE_CIRCLE_SELECTOR: ".mdc-circular-progress__determinate-circle",
                RADIUS: "r",
                STROKE_DASHOFFSET: "stroke-dashoffset"
            };
        /***/ },
        /***/ "./packages/mdc-circular-progress/custom-element.js": /*!**********************************************************!*\
  !*** ./packages/mdc-circular-progress/custom-element.js ***!
  \**********************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-circular-progress/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcCircularProgress = function(_HTMLElement) {
                _inherits(MdcCircularProgress, _HTMLElement);
                _createClass(MdcCircularProgress, [
                    {
                        key: "determinate",
                        get: function get() {
                            return this.determinate_;
                        },
                        set: function set(determinate) {
                            this.determinate_ = determinate;
                            if (!!this.circularProgress_) this.circularProgress_.determinate = determinate;
                        }
                    },
                    {
                        key: "progress",
                        get: function get() {
                            return this.progress_;
                        },
                        set: function set(progress) {
                            this.progress_ = progress;
                            if (!!this.circularProgress_) this.circularProgress_.progress = progress;
                        }
                    },
                    {
                        key: "closed",
                        get: function get() {
                            return this.closed_;
                        },
                        set: function set(closed) {
                            this.closed_ = closed;
                            if (!!this.circularProgress_) {
                                if (closed) this.circularProgress_.close();
                                else this.circularProgress_.open();
                            }
                        }
                    }
                ]);
                function MdcCircularProgress() {
                    _classCallCheck(this, MdcCircularProgress);
                    var _this = _possibleConstructorReturn(this, (MdcCircularProgress.__proto__ || Object.getPrototypeOf(MdcCircularProgress)).call(this));
                    _this.determinate_ = false;
                    _this.progress_ = 0;
                    _this.closed_ = false;
                    _this.circularProgress_;
                    return _this;
                }
                _createClass(MdcCircularProgress, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.circularProgress_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCCircularProgress"](this);
                            this.circularProgress_.determinate = this.determinate_;
                            this.circularProgress_.progress = this.progress_;
                            if (this.closed_) this.circularProgress_.close();
                            else this.circularProgress_.open();
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.circularProgress_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcCircularProgress;
            }(HTMLElement);
            customElements.define("mdc-circular-progress", MdcCircularProgress);
        /***/ },
        /***/ "./packages/mdc-circular-progress/foundation.ts": /*!******************************************************!*\
  !*** ./packages/mdc-circular-progress/foundation.ts ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCCircularProgressFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-circular-progress/constants.ts");
            var MDCCircularProgressFoundation = /** @class */ function(_super) {
                __extends(MDCCircularProgressFoundation, _super);
                function MDCCircularProgressFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCCircularProgressFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCCircularProgressFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCircularProgressFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCircularProgressFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            getDeterminateCircleAttribute: function getDeterminateCircleAttribute() {
                                return null;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            removeAttribute: function removeAttribute() {
                                return undefined;
                            },
                            setAttribute: function setAttribute() {
                                return undefined;
                            },
                            setDeterminateCircleAttribute: function setDeterminateCircleAttribute() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCCircularProgressFoundation.prototype.init = function() {
                    this.closed = this.adapter.hasClass(constants_1.cssClasses.CLOSED_CLASS);
                    this.determinate = !this.adapter.hasClass(constants_1.cssClasses.INDETERMINATE_CLASS);
                    this.progress = 0;
                    if (this.determinate) this.adapter.setAttribute(constants_1.strings.ARIA_VALUENOW, this.progress.toString());
                    this.radius = Number(this.adapter.getDeterminateCircleAttribute(constants_1.strings.RADIUS));
                };
                /**
     * Sets whether the progress indicator is in determinate mode.
     * @param determinate Whether the indicator should be determinate.
     */ MDCCircularProgressFoundation.prototype.setDeterminate = function(determinate) {
                    this.determinate = determinate;
                    if (this.determinate) {
                        this.adapter.removeClass(constants_1.cssClasses.INDETERMINATE_CLASS);
                        this.setProgress(this.progress);
                    } else {
                        this.adapter.addClass(constants_1.cssClasses.INDETERMINATE_CLASS);
                        this.adapter.removeAttribute(constants_1.strings.ARIA_VALUENOW);
                    }
                };
                MDCCircularProgressFoundation.prototype.isDeterminate = function() {
                    return this.determinate;
                };
                /**
     * Sets the current progress value. In indeterminate mode, this has no
     * visual effect but will be reflected if the indicator is switched to
     * determinate mode.
     * @param value The current progress value, which must be between 0 and 1.
     */ MDCCircularProgressFoundation.prototype.setProgress = function(value) {
                    this.progress = value;
                    if (this.determinate) {
                        var unfilledArcLength = (1 - this.progress) * (2 * Math.PI * this.radius);
                        this.adapter.setDeterminateCircleAttribute(constants_1.strings.STROKE_DASHOFFSET, "" + unfilledArcLength);
                        this.adapter.setAttribute(constants_1.strings.ARIA_VALUENOW, this.progress.toString());
                    }
                };
                MDCCircularProgressFoundation.prototype.getProgress = function() {
                    return this.progress;
                };
                /**
     * Shows the progress indicator.
     */ MDCCircularProgressFoundation.prototype.open = function() {
                    this.closed = false;
                    this.adapter.removeClass(constants_1.cssClasses.CLOSED_CLASS);
                    this.adapter.removeAttribute(constants_1.strings.ARIA_HIDDEN);
                };
                /**
     * Hides the progress indicator
     */ MDCCircularProgressFoundation.prototype.close = function() {
                    this.closed = true;
                    this.adapter.addClass(constants_1.cssClasses.CLOSED_CLASS);
                    this.adapter.setAttribute(constants_1.strings.ARIA_HIDDEN, "true");
                };
                /**
     * @return Returns whether the progress indicator is hidden.
     */ MDCCircularProgressFoundation.prototype.isClosed = function() {
                    return this.closed;
                };
                return MDCCircularProgressFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCCircularProgressFoundation = MDCCircularProgressFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCCircularProgressFoundation;
        /***/ },
        /***/ "./packages/mdc-data-table/custom-element.js": /*!***************************************************!*\
  !*** ./packages/mdc-data-table/custom-element.js ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcDataTable = function(_HTMLElement) {
                _inherits(MdcDataTable, _HTMLElement);
                function MdcDataTable() {
                    _classCallCheck(this, MdcDataTable);
                    return _possibleConstructorReturn(this, (MdcDataTable.__proto__ || Object.getPrototypeOf(MdcDataTable)).call(this));
                }
                _createClass(MdcDataTable, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {}
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {}
                    }
                ]);
                return MdcDataTable;
            }(HTMLElement);
            customElements.define("mdc-data-table", MdcDataTable);
        /***/ },
        /***/ "./packages/mdc-dialog/component.ts": /*!******************************************!*\
  !*** ./packages/mdc-dialog/component.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                Object.defineProperty(o, k2, {
                    enumerable: true,
                    get: function get() {
                        return m[k];
                    }
                });
            } : function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
            });
            var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                Object.defineProperty(o, "default", {
                    enumerable: true,
                    value: v
                });
            } : function(o, v) {
                o["default"] = v;
            });
            var __importStar = this && this.__importStar || function(mod) {
                if (mod && mod.__esModule) return mod;
                var result = {};
                if (mod != null) {
                    for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                }
                __setModuleDefault(result, mod);
                return result;
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCDialog = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-dialog/foundation.ts");
            var util = __importStar(__webpack_require__(/*! ./util */ "./packages/mdc-dialog/util.ts"));
            var strings = foundation_1.MDCDialogFoundation.strings;
            var MDCDialog = /** @class */ function(_super) {
                __extends(MDCDialog, _super);
                function MDCDialog() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(MDCDialog.prototype, "isOpen", {
                    get: function get() {
                        return this.foundation.isOpen();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDialog.prototype, "escapeKeyAction", {
                    get: function get() {
                        return this.foundation.getEscapeKeyAction();
                    },
                    set: function set(action) {
                        this.foundation.setEscapeKeyAction(action);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDialog.prototype, "scrimClickAction", {
                    get: function get() {
                        return this.foundation.getScrimClickAction();
                    },
                    set: function set(action) {
                        this.foundation.setScrimClickAction(action);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDialog.prototype, "autoStackButtons", {
                    get: function get() {
                        return this.foundation.getAutoStackButtons();
                    },
                    set: function set(autoStack) {
                        this.foundation.setAutoStackButtons(autoStack);
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCDialog.attachTo = function(root) {
                    return new MDCDialog(root);
                };
                MDCDialog.prototype.initialize = function(focusTrapFactory) {
                    var container = this.root.querySelector(strings.CONTAINER_SELECTOR);
                    if (!container) throw new Error("Dialog component requires a " + strings.CONTAINER_SELECTOR + " container element");
                    this.container = container;
                    this.content = this.root.querySelector(strings.CONTENT_SELECTOR);
                    this.buttons = [].slice.call(this.root.querySelectorAll(strings.BUTTON_SELECTOR));
                    this.defaultButton = this.root.querySelector("[" + strings.BUTTON_DEFAULT_ATTRIBUTE + "]");
                    this.focusTrapFactory = focusTrapFactory;
                };
                MDCDialog.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.focusTrap = util.createFocusTrapInstance(this.container, this.focusTrapFactory, this.getInitialFocusEl() || undefined);
                    this.handleClick = this.handleClick_.bind(this);
                    this.handleKeydown = this.foundation.handleKeydown.bind(this.foundation);
                    this.handleDocumentKeydown = this.handleDocumentKeydown_.bind(this);
                    // this.handleLayout = this.layout.bind(this);
                    this.handleOpening = function() {
                        document.addEventListener("keydown", _this.handleDocumentKeydown);
                    };
                    this.handleClosing = function() {
                        document.removeEventListener("keydown", _this.handleDocumentKeydown);
                    };
                    this.listen("click", this.handleClick);
                    this.listen("keydown", this.handleKeydown);
                    this.listen(strings.OPENING_EVENT, this.handleOpening);
                    this.listen(strings.CLOSING_EVENT, this.handleClosing);
                };
                MDCDialog.prototype.handleClick_ = function(evt) {
                    var isScrim = this.eventTargetMatches(evt.target, strings.SCRIM_SELECTOR);
                    // Check for scrim click first since it doesn't require querying ancestors.
                    if (isScrim && this.foundation.getScrimClickAction() !== "") {
                        this.close(this.scrimClickAction);
                        this.emit("MDCDialog:close", {});
                    }
                };
                MDCDialog.prototype.eventTargetMatches = function(target, selector) {
                    return target ? ponyfill_1.matches(target, selector) : false;
                };
                MDCDialog.prototype.handleDocumentKeydown_ = function(evt) {
                    var isEscape = evt.key === "Escape" || evt.keyCode === 27;
                    if (isEscape) this.emit("MDCDialog:close", {});
                };
                MDCDialog.prototype.destroy = function() {
                    this.unlisten("click", this.handleClick);
                    this.unlisten("keydown", this.handleKeydown);
                    this.unlisten(strings.OPENING_EVENT, this.handleOpening);
                    this.unlisten(strings.CLOSING_EVENT, this.handleClosing);
                    this.handleClosing();
                    _super.prototype.destroy.call(this);
                };
                MDCDialog.prototype.layout = function() {
                    this.foundation.layout();
                };
                MDCDialog.prototype.open = function() {
                    this.foundation.open();
                };
                MDCDialog.prototype.close = function(action) {
                    if (action === void 0) action = "";
                    this.foundation.close(action);
                };
                MDCDialog.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addBodyClass: function addBodyClass(className) {
                            return document.body.classList.add(className);
                        },
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        areButtonsStacked: function areButtonsStacked() {
                            return util.areTopsMisaligned(_this.buttons);
                        },
                        clickDefaultButton: function clickDefaultButton() {
                            if (_this.defaultButton) _this.defaultButton.click();
                        },
                        eventTargetMatches: function eventTargetMatches(target, selector) {
                            return target ? ponyfill_1.matches(target, selector) : false;
                        },
                        getActionFromEvent: function getActionFromEvent(evt) {
                            if (!evt.target) return "";
                            var element = ponyfill_1.closest(evt.target, "[" + strings.ACTION_ATTRIBUTE + "]");
                            return element && element.getAttribute(strings.ACTION_ATTRIBUTE);
                        },
                        getInitialFocusEl: function getInitialFocusEl() {
                            return _this.getInitialFocusEl();
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        isContentScrollable: function isContentScrollable() {
                            return util.isScrollable(_this.content);
                        },
                        notifyClosed: function notifyClosed(action) {
                            return _this.emit(strings.CLOSED_EVENT, action ? {
                                action: action
                            } : {});
                        },
                        notifyClosing: function notifyClosing(action) {
                            return _this.emit(strings.CLOSING_EVENT, action ? {
                                action: action
                            } : {});
                        },
                        notifyOpened: function notifyOpened() {
                            return _this.emit(strings.OPENED_EVENT, {});
                        },
                        notifyOpening: function notifyOpening() {
                            return _this.emit(strings.OPENING_EVENT, {});
                        },
                        releaseFocus: function releaseFocus() {
                            _this.focusTrap.deactivate();
                        },
                        removeBodyClass: function removeBodyClass(className) {
                            return document.body.classList.remove(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        reverseButtons: function reverseButtons() {
                            _this.buttons.reverse();
                            _this.buttons.forEach(function(button) {
                                button.parentElement.appendChild(button);
                            });
                        },
                        trapFocus: function trapFocus() {
                            _this.focusTrap.activate();
                        },
                        registerContentEventHandler: function registerContentEventHandler(evt, handler) {
                            if (_this.content instanceof HTMLElement) _this.content.addEventListener(evt, handler);
                        },
                        deregisterContentEventHandler: function deregisterContentEventHandler(evt, handler) {
                            if (_this.content instanceof HTMLElement) _this.content.removeEventListener(evt, handler);
                        },
                        isScrollableContentAtTop: function isScrollableContentAtTop() {
                            return util.isScrollAtTop(_this.content);
                        },
                        isScrollableContentAtBottom: function isScrollableContentAtBottom() {
                            return util.isScrollAtBottom(_this.content);
                        },
                        registerWindowEventHandler: function registerWindowEventHandler(evt, handler) {
                            window.addEventListener(evt, handler);
                        },
                        deregisterWindowEventHandler: function deregisterWindowEventHandler(evt, handler) {
                            window.removeEventListener(evt, handler);
                        }
                    };
                    return new foundation_1.MDCDialogFoundation(adapter);
                };
                MDCDialog.prototype.getInitialFocusEl = function() {
                    return this.root.querySelector("[" + strings.INITIAL_FOCUS_ATTRIBUTE + "]");
                };
                return MDCDialog;
            }(component_1.MDCComponent);
            exports.MDCDialog = MDCDialog;
        /***/ },
        /***/ "./packages/mdc-dialog/constants.ts": /*!******************************************!*\
  !*** ./packages/mdc-dialog/constants.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.numbers = exports.strings = exports.cssClasses = void 0;
            exports.cssClasses = {
                CLOSING: "mdc-dialog--closing",
                OPEN: "mdc-dialog--open",
                OPENING: "mdc-dialog--opening",
                SCROLLABLE: "mdc-dialog--scrollable",
                SCROLL_LOCK: "mdc-dialog-scroll-lock",
                STACKED: "mdc-dialog--stacked",
                FULLSCREEN: "mdc-dialog--fullscreen",
                // Class for showing a scroll divider on full-screen dialog header element.
                // Should only be displayed on scrollable content, when the dialog content is
                // scrolled "underneath" the header.
                SCROLL_DIVIDER_HEADER: "mdc-dialog-scroll-divider-header",
                // Class for showing a scroll divider on a full-screen dialog footer element.
                // Should only be displayed on scrolalble content, when the dialog content is
                // obscured "underneath" the footer.
                SCROLL_DIVIDER_FOOTER: "mdc-dialog-scroll-divider-footer",
                // The "surface scrim" is a scrim covering only the surface of a dialog. This
                // is used in situations where a confirmation dialog is shown over an already
                // opened full-screen dialog. On larger screen-sizes, the full-screen dialog
                // is sized as a modal and so in these situations we display a "surface scrim"
                // to prevent a "double scrim" (where the scrim from the secondary
                // confirmation dialog would overlap with the scrim from the full-screen
                // dialog).
                SURFACE_SCRIM_SHOWN: "mdc-dialog__surface-scrim--shown",
                // "Showing" animating class for the surface-scrim.
                SURFACE_SCRIM_SHOWING: "mdc-dialog__surface-scrim--showing",
                // "Hiding" animating class for the surface-scrim.
                SURFACE_SCRIM_HIDING: "mdc-dialog__surface-scrim--hiding",
                // Class to hide a dialog's scrim (used in conjunction with a surface-scrim).
                // Note that we only hide the original scrim rather than removing it entirely
                // to prevent interactions with the content behind this scrim, and to capture
                // scrim clicks.
                SCRIM_HIDDEN: "mdc-dialog__scrim--hidden"
            };
            exports.strings = {
                ACTION_ATTRIBUTE: "data-mdc-dialog-action",
                BUTTON_DEFAULT_ATTRIBUTE: "data-mdc-dialog-button-default",
                BUTTON_SELECTOR: ".mdc-dialog__button",
                CLOSED_EVENT: "MDCDialog:closed",
                CLOSE_ACTION: "close",
                CLOSING_EVENT: "MDCDialog:closing",
                CONTAINER_SELECTOR: ".mdc-dialog__container",
                CONTENT_SELECTOR: ".mdc-dialog__content",
                DESTROY_ACTION: "destroy",
                INITIAL_FOCUS_ATTRIBUTE: "data-mdc-dialog-initial-focus",
                OPENED_EVENT: "MDCDialog:opened",
                OPENING_EVENT: "MDCDialog:opening",
                SCRIM_SELECTOR: ".mdc-dialog__scrim",
                SUPPRESS_DEFAULT_PRESS_SELECTOR: [
                    "textarea",
                    ".mdc-menu .mdc-list-item",
                    ".mdc-menu .mdc-deprecated-list-item"
                ].join(", "),
                SURFACE_SELECTOR: ".mdc-dialog__surface"
            };
            exports.numbers = {
                DIALOG_ANIMATION_CLOSE_TIME_MS: 75,
                DIALOG_ANIMATION_OPEN_TIME_MS: 150
            };
        /***/ },
        /***/ "./packages/mdc-dialog/custom-element.js": /*!***********************************************!*\
  !*** ./packages/mdc-dialog/custom-element.js ***!
  \***********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-dialog/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcDialog = function(_HTMLElement) {
                _inherits(MdcDialog, _HTMLElement);
                _createClass(MdcDialog, [
                    {
                        key: "open",
                        get: function get() {
                            return this.open_;
                        },
                        set: function set(open) {
                            this.open_ = open;
                            if (!!this.dialog_) {
                                if (open) this.dialog_.open();
                                else this.dialog_.close();
                            }
                        }
                    },
                    {
                        key: "scrimClickAction",
                        get: function get() {
                            return this.scrimClickAction_;
                        },
                        set: function set(scrimClickAction) {
                            this.scrimClickAction_ = scrimClickAction;
                            if (!!this.dialog_) this.dialog_.scrimClickAction = scrimClickAction_;
                        }
                    },
                    {
                        key: "escapeKeyAction",
                        get: function get() {
                            return this.escapeKeyAction_;
                        },
                        set: function set(escapeKeyAction) {
                            this.escapeKeyAction_ = escapeKeyAction;
                            if (!!this.dialog_) this.dialog_.escapeKeyAction = escapeKeyAction_;
                        }
                    }
                ]);
                function MdcDialog() {
                    _classCallCheck(this, MdcDialog);
                    var _this = _possibleConstructorReturn(this, (MdcDialog.__proto__ || Object.getPrototypeOf(MdcDialog)).call(this));
                    _this.open_ = false;
                    _this.scrimClickAction_ = "close";
                    _this.escapeKeyAction_ = "close";
                    return _this;
                }
                _createClass(MdcDialog, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.dialog_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCDialog"](this);
                            this.dialog_.scrimClickAction = this.scrimClickAction_;
                            this.dialog_.escapeKeyAction = this.escapeKeyAction_;
                            if (this.open_) this.dialog_.open();
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.dialog_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcDialog;
            }(HTMLElement);
            customElements.define("mdc-dialog", MdcDialog);
        /***/ },
        /***/ "./packages/mdc-dialog/foundation.ts": /*!*******************************************!*\
  !*** ./packages/mdc-dialog/foundation.ts ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCDialogFoundation = void 0;
            var animationframe_1 = __webpack_require__(/*! @material/animation/animationframe */ "./packages/mdc-animation/animationframe.ts");
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-dialog/constants.ts");
            var AnimationKeys;
            (function(AnimationKeys) {
                AnimationKeys["POLL_SCROLL_POS"] = "poll_scroll_position";
                AnimationKeys["POLL_LAYOUT_CHANGE"] = "poll_layout_change";
            })(AnimationKeys || (AnimationKeys = {}));
            var MDCDialogFoundation = /** @class */ function(_super) {
                __extends(MDCDialogFoundation, _super);
                function MDCDialogFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCDialogFoundation.defaultAdapter), adapter)) || this;
                    _this.dialogOpen = false;
                    _this.isFullscreen = false;
                    _this.animationFrame = 0;
                    _this.animationTimer = 0;
                    _this.escapeKeyAction = constants_1.strings.CLOSE_ACTION;
                    _this.scrimClickAction = constants_1.strings.CLOSE_ACTION;
                    _this.autoStackButtons = true;
                    _this.areButtonsStacked = false;
                    _this.suppressDefaultPressSelector = constants_1.strings.SUPPRESS_DEFAULT_PRESS_SELECTOR;
                    _this.animFrame = new animationframe_1.AnimationFrame();
                    _this.contentScrollHandler = function() {
                        _this.handleScrollEvent();
                    };
                    _this.windowResizeHandler = function() {
                        _this.layout();
                    };
                    _this.windowOrientationChangeHandler = function() {
                        _this.layout();
                    };
                    return _this;
                }
                Object.defineProperty(MDCDialogFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDialogFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDialogFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDialogFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addBodyClass: function addBodyClass() {
                                return undefined;
                            },
                            addClass: function addClass() {
                                return undefined;
                            },
                            areButtonsStacked: function areButtonsStacked() {
                                return false;
                            },
                            clickDefaultButton: function clickDefaultButton() {
                                return undefined;
                            },
                            eventTargetMatches: function eventTargetMatches() {
                                return false;
                            },
                            getActionFromEvent: function getActionFromEvent() {
                                return "";
                            },
                            getInitialFocusEl: function getInitialFocusEl() {
                                return null;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            isContentScrollable: function isContentScrollable() {
                                return false;
                            },
                            notifyClosed: function notifyClosed() {
                                return undefined;
                            },
                            notifyClosing: function notifyClosing() {
                                return undefined;
                            },
                            notifyOpened: function notifyOpened() {
                                return undefined;
                            },
                            notifyOpening: function notifyOpening() {
                                return undefined;
                            },
                            releaseFocus: function releaseFocus() {
                                return undefined;
                            },
                            removeBodyClass: function removeBodyClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            reverseButtons: function reverseButtons() {
                                return undefined;
                            },
                            trapFocus: function trapFocus() {
                                return undefined;
                            },
                            registerContentEventHandler: function registerContentEventHandler() {
                                return undefined;
                            },
                            deregisterContentEventHandler: function deregisterContentEventHandler() {
                                return undefined;
                            },
                            isScrollableContentAtTop: function isScrollableContentAtTop() {
                                return false;
                            },
                            isScrollableContentAtBottom: function isScrollableContentAtBottom() {
                                return false;
                            },
                            registerWindowEventHandler: function registerWindowEventHandler() {
                                return undefined;
                            },
                            deregisterWindowEventHandler: function deregisterWindowEventHandler() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCDialogFoundation.prototype.init = function() {
                    if (this.adapter.hasClass(constants_1.cssClasses.STACKED)) this.setAutoStackButtons(false);
                    this.isFullscreen = this.adapter.hasClass(constants_1.cssClasses.FULLSCREEN);
                };
                MDCDialogFoundation.prototype.destroy = function() {
                    if (this.dialogOpen) this.close(constants_1.strings.DESTROY_ACTION);
                    if (this.animationTimer) {
                        clearTimeout(this.animationTimer);
                        this.handleAnimationTimerEnd();
                    }
                    if (this.isFullscreen) this.adapter.deregisterContentEventHandler("scroll", this.contentScrollHandler);
                    this.animFrame.cancelAll();
                    this.adapter.deregisterWindowEventHandler("resize", this.windowResizeHandler);
                    this.adapter.deregisterWindowEventHandler("orientationchange", this.windowOrientationChangeHandler);
                };
                MDCDialogFoundation.prototype.open = function(dialogOptions) {
                    var _this = this;
                    this.dialogOpen = true;
                    this.adapter.notifyOpening();
                    this.adapter.addClass(constants_1.cssClasses.OPENING);
                    if (this.isFullscreen) // A scroll event listener is registered even if the dialog is not
                    // scrollable on open, since the window resize event, or orientation
                    // change may make the dialog scrollable after it is opened.
                    this.adapter.registerContentEventHandler("scroll", this.contentScrollHandler);
                    if (dialogOptions && dialogOptions.isAboveFullscreenDialog) this.adapter.addClass(constants_1.cssClasses.SCRIM_HIDDEN);
                    this.adapter.registerWindowEventHandler("resize", this.windowResizeHandler);
                    this.adapter.registerWindowEventHandler("orientationchange", this.windowOrientationChangeHandler);
                    // Wait a frame once display is no longer "none", to establish basis for
                    // animation
                    this.runNextAnimationFrame(function() {
                        _this.adapter.addClass(constants_1.cssClasses.OPEN);
                        _this.adapter.addBodyClass(constants_1.cssClasses.SCROLL_LOCK);
                        _this.layout();
                        _this.animationTimer = setTimeout(function() {
                            _this.handleAnimationTimerEnd();
                            _this.adapter.trapFocus(_this.adapter.getInitialFocusEl());
                            _this.adapter.notifyOpened();
                        }, constants_1.numbers.DIALOG_ANIMATION_OPEN_TIME_MS);
                    });
                };
                MDCDialogFoundation.prototype.close = function(action) {
                    var _this = this;
                    if (action === void 0) action = "";
                    if (!this.dialogOpen) // Avoid redundant close calls (and events), e.g. from keydown on elements
                    // that inherently emit click
                    return;
                    this.dialogOpen = false;
                    this.adapter.notifyClosing(action);
                    this.adapter.addClass(constants_1.cssClasses.CLOSING);
                    this.adapter.removeClass(constants_1.cssClasses.OPEN);
                    this.adapter.removeBodyClass(constants_1.cssClasses.SCROLL_LOCK);
                    if (this.isFullscreen) this.adapter.deregisterContentEventHandler("scroll", this.contentScrollHandler);
                    this.adapter.deregisterWindowEventHandler("resize", this.windowResizeHandler);
                    this.adapter.deregisterWindowEventHandler("orientationchange", this.windowOrientationChangeHandler);
                    cancelAnimationFrame(this.animationFrame);
                    this.animationFrame = 0;
                    clearTimeout(this.animationTimer);
                    this.animationTimer = setTimeout(function() {
                        _this.adapter.releaseFocus();
                        _this.handleAnimationTimerEnd();
                        _this.adapter.notifyClosed(action);
                    }, constants_1.numbers.DIALOG_ANIMATION_CLOSE_TIME_MS);
                };
                /**
     * Used only in instances of showing a secondary dialog over a full-screen
     * dialog. Shows the "surface scrim" displayed over the full-screen dialog.
     */ MDCDialogFoundation.prototype.showSurfaceScrim = function() {
                    var _this = this;
                    this.adapter.addClass(constants_1.cssClasses.SURFACE_SCRIM_SHOWING);
                    this.runNextAnimationFrame(function() {
                        _this.adapter.addClass(constants_1.cssClasses.SURFACE_SCRIM_SHOWN);
                    });
                };
                /**
     * Used only in instances of showing a secondary dialog over a full-screen
     * dialog. Hides the "surface scrim" displayed over the full-screen dialog.
     */ MDCDialogFoundation.prototype.hideSurfaceScrim = function() {
                    this.adapter.removeClass(constants_1.cssClasses.SURFACE_SCRIM_SHOWN);
                    this.adapter.addClass(constants_1.cssClasses.SURFACE_SCRIM_HIDING);
                };
                /**
     * Handles `transitionend` event triggered when surface scrim animation is
     * finished.
     */ MDCDialogFoundation.prototype.handleSurfaceScrimTransitionEnd = function() {
                    this.adapter.removeClass(constants_1.cssClasses.SURFACE_SCRIM_HIDING);
                    this.adapter.removeClass(constants_1.cssClasses.SURFACE_SCRIM_SHOWING);
                };
                MDCDialogFoundation.prototype.isOpen = function() {
                    return this.dialogOpen;
                };
                MDCDialogFoundation.prototype.getEscapeKeyAction = function() {
                    return this.escapeKeyAction;
                };
                MDCDialogFoundation.prototype.setEscapeKeyAction = function(action) {
                    this.escapeKeyAction = action;
                };
                MDCDialogFoundation.prototype.getScrimClickAction = function() {
                    return this.scrimClickAction;
                };
                MDCDialogFoundation.prototype.setScrimClickAction = function(action) {
                    this.scrimClickAction = action;
                };
                MDCDialogFoundation.prototype.getAutoStackButtons = function() {
                    return this.autoStackButtons;
                };
                MDCDialogFoundation.prototype.setAutoStackButtons = function(autoStack) {
                    this.autoStackButtons = autoStack;
                };
                MDCDialogFoundation.prototype.getSuppressDefaultPressSelector = function() {
                    return this.suppressDefaultPressSelector;
                };
                MDCDialogFoundation.prototype.setSuppressDefaultPressSelector = function(selector) {
                    this.suppressDefaultPressSelector = selector;
                };
                MDCDialogFoundation.prototype.layout = function() {
                    var _this = this;
                    this.animFrame.request(AnimationKeys.POLL_LAYOUT_CHANGE, function() {
                        _this.layoutInternal();
                    });
                };
                /** Handles click on the dialog root element. */ MDCDialogFoundation.prototype.handleClick = function(evt) {
                    var isScrim = this.adapter.eventTargetMatches(evt.target, constants_1.strings.SCRIM_SELECTOR);
                    // Check for scrim click first since it doesn't require querying ancestors.
                    if (isScrim && this.scrimClickAction !== "") this.close(this.scrimClickAction);
                    else {
                        var action = this.adapter.getActionFromEvent(evt);
                        if (action) this.close(action);
                    }
                };
                /** Handles keydown on the dialog root element. */ MDCDialogFoundation.prototype.handleKeydown = function(evt) {
                    var isEnter = evt.key === "Enter" || evt.keyCode === 13;
                    if (!isEnter) return;
                    var action = this.adapter.getActionFromEvent(evt);
                    if (action) // Action button callback is handled in `handleClick`,
                    // since space/enter keydowns on buttons trigger click events.
                    return;
                    // `composedPath` is used here, when available, to account for use cases
                    // where a target meant to suppress the default press behaviour
                    // may exist in a shadow root.
                    // For example, a textarea inside a web component:
                    // <mwc-dialog>
                    //   <horizontal-layout>
                    //     #shadow-root (open)
                    //       <mwc-textarea>
                    //         #shadow-root (open)
                    //           <textarea></textarea>
                    //       </mwc-textarea>
                    //   </horizontal-layout>
                    // </mwc-dialog>
                    var target = evt.composedPath ? evt.composedPath()[0] : evt.target;
                    var isDefault = this.suppressDefaultPressSelector ? !this.adapter.eventTargetMatches(target, this.suppressDefaultPressSelector) : true;
                    if (isEnter && isDefault) this.adapter.clickDefaultButton();
                };
                /** Handles keydown on the document. */ MDCDialogFoundation.prototype.handleDocumentKeydown = function(evt) {
                    var isEscape = evt.key === "Escape" || evt.keyCode === 27;
                    if (isEscape && this.escapeKeyAction !== "") this.close(this.escapeKeyAction);
                };
                /**
     * Handles scroll event on the dialog's content element -- showing a scroll
     * divider on the header or footer based on the scroll position. This handler
     * should only be registered on full-screen dialogs with scrollable content.
     */ MDCDialogFoundation.prototype.handleScrollEvent = function() {
                    var _this = this;
                    // Since scroll events can fire at a high rate, we throttle these events by
                    // using requestAnimationFrame.
                    this.animFrame.request(AnimationKeys.POLL_SCROLL_POS, function() {
                        _this.toggleScrollDividerHeader();
                        _this.toggleScrollDividerFooter();
                    });
                };
                MDCDialogFoundation.prototype.layoutInternal = function() {
                    if (this.autoStackButtons) this.detectStackedButtons();
                    this.toggleScrollableClasses();
                };
                MDCDialogFoundation.prototype.handleAnimationTimerEnd = function() {
                    this.animationTimer = 0;
                    this.adapter.removeClass(constants_1.cssClasses.OPENING);
                    this.adapter.removeClass(constants_1.cssClasses.CLOSING);
                };
                /**
     * Runs the given logic on the next animation frame, using setTimeout to
     * factor in Firefox reflow behavior.
     */ MDCDialogFoundation.prototype.runNextAnimationFrame = function(callback) {
                    var _this = this;
                    cancelAnimationFrame(this.animationFrame);
                    this.animationFrame = requestAnimationFrame(function() {
                        _this.animationFrame = 0;
                        clearTimeout(_this.animationTimer);
                        _this.animationTimer = setTimeout(callback, 0);
                    });
                };
                MDCDialogFoundation.prototype.detectStackedButtons = function() {
                    // Remove the class first to let us measure the buttons' natural positions.
                    this.adapter.removeClass(constants_1.cssClasses.STACKED);
                    var areButtonsStacked = this.adapter.areButtonsStacked();
                    if (areButtonsStacked) this.adapter.addClass(constants_1.cssClasses.STACKED);
                    if (areButtonsStacked !== this.areButtonsStacked) {
                        this.adapter.reverseButtons();
                        this.areButtonsStacked = areButtonsStacked;
                    }
                };
                MDCDialogFoundation.prototype.toggleScrollableClasses = function() {
                    // Remove the class first to let us measure the natural height of the
                    // content.
                    this.adapter.removeClass(constants_1.cssClasses.SCROLLABLE);
                    if (this.adapter.isContentScrollable()) {
                        this.adapter.addClass(constants_1.cssClasses.SCROLLABLE);
                        if (this.isFullscreen) {
                            // If dialog is full-screen and scrollable, check if a scroll divider
                            // should be shown.
                            this.toggleScrollDividerHeader();
                            this.toggleScrollDividerFooter();
                        }
                    }
                };
                MDCDialogFoundation.prototype.toggleScrollDividerHeader = function() {
                    if (!this.adapter.isScrollableContentAtTop()) this.adapter.addClass(constants_1.cssClasses.SCROLL_DIVIDER_HEADER);
                    else if (this.adapter.hasClass(constants_1.cssClasses.SCROLL_DIVIDER_HEADER)) this.adapter.removeClass(constants_1.cssClasses.SCROLL_DIVIDER_HEADER);
                };
                MDCDialogFoundation.prototype.toggleScrollDividerFooter = function() {
                    if (!this.adapter.isScrollableContentAtBottom()) this.adapter.addClass(constants_1.cssClasses.SCROLL_DIVIDER_FOOTER);
                    else if (this.adapter.hasClass(constants_1.cssClasses.SCROLL_DIVIDER_FOOTER)) this.adapter.removeClass(constants_1.cssClasses.SCROLL_DIVIDER_FOOTER);
                };
                return MDCDialogFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCDialogFoundation = MDCDialogFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCDialogFoundation;
        /***/ },
        /***/ "./packages/mdc-dialog/util.ts": /*!*************************************!*\
  !*** ./packages/mdc-dialog/util.ts ***!
  \*************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.areTopsMisaligned = exports.isScrollAtBottom = exports.isScrollAtTop = exports.isScrollable = exports.createFocusTrapInstance = void 0;
            var focus_trap_1 = __webpack_require__(/*! focus-trap */ "./node_modules/focus-trap/dist/focus-trap.esm.js");
            function createFocusTrapInstance(surfaceEl, focusTrapFactory, initialFocusEl) {
                if (focusTrapFactory === void 0) focusTrapFactory = focus_trap_1.createFocusTrap;
                return focusTrapFactory(surfaceEl, {
                    allowOutsideClick: true,
                    clickOutsideDeactivates: false,
                    escapeDeactivates: true,
                    initialFocus: initialFocusEl
                });
            }
            exports.createFocusTrapInstance = createFocusTrapInstance;
            function isScrollable(el) {
                return el ? el.scrollHeight > el.offsetHeight : false;
            }
            exports.isScrollable = isScrollable;
            /**
 * For scrollable content, returns true if the content has not been scrolled
 * (that is, the scroll content is as the "top"). This is used in full-screen
 * dialogs, where the scroll divider is expected only to appear once the
 * content has been scrolled "underneath" the header bar.
 */ function isScrollAtTop(el) {
                return el ? el.scrollTop === 0 : false;
            }
            exports.isScrollAtTop = isScrollAtTop;
            /**
 * For scrollable content, returns true if the content has been scrolled all the
 * way to the bottom. This is used in full-screen dialogs, where the footer
 * scroll divider is expected only to appear when the content is "cut-off" by
 * the footer bar.
 */ function isScrollAtBottom(el) {
                return el ? Math.ceil(el.scrollHeight - el.scrollTop) === el.clientHeight : false;
            }
            exports.isScrollAtBottom = isScrollAtBottom;
            function areTopsMisaligned(els) {
                var tops = new Set();
                [].forEach.call(els, function(el) {
                    return tops.add(el.offsetTop);
                });
                return tops.size > 1;
            }
            exports.areTopsMisaligned = areTopsMisaligned;
        /***/ },
        /***/ "./packages/mdc-dom/announce.ts": /*!**************************************!*\
  !*** ./packages/mdc-dom/announce.ts ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.announce = exports.DATA_MDC_DOM_ANNOUNCE = exports.AnnouncerPriority = void 0;
            /**
 * Priorities for the announce function
 */ var AnnouncerPriority;
            (function(AnnouncerPriority) {
                AnnouncerPriority["POLITE"] = "polite";
                AnnouncerPriority["ASSERTIVE"] = "assertive";
            })(AnnouncerPriority = exports.AnnouncerPriority || (exports.AnnouncerPriority = {}));
            /**
 * Data attribute added to live region element.
 */ exports.DATA_MDC_DOM_ANNOUNCE = "data-mdc-dom-announce";
            /**
 * Announces the given message with optional priority, defaulting to "polite"
 */ function announce(message, priority) {
                Announcer.getInstance().say(message, priority);
            }
            exports.announce = announce;
            var Announcer = /** @class */ function() {
                // Constructor made private to ensure only the singleton is used
                function Announcer() {
                    this.liveRegions = new Map();
                }
                Announcer.getInstance = function() {
                    if (!Announcer.instance) Announcer.instance = new Announcer();
                    return Announcer.instance;
                };
                Announcer.prototype.say = function(message, priority) {
                    if (priority === void 0) priority = AnnouncerPriority.POLITE;
                    var liveRegion = this.getLiveRegion(priority);
                    // Reset the region to pick up the message, even if the message is the
                    // exact same as before.
                    liveRegion.textContent = "";
                    // Timeout is necessary for screen readers like NVDA and VoiceOver.
                    setTimeout(function() {
                        liveRegion.textContent = message;
                        document.addEventListener("click", clearLiveRegion);
                    }, 1);
                    function clearLiveRegion() {
                        liveRegion.textContent = "";
                        document.removeEventListener("click", clearLiveRegion);
                    }
                };
                Announcer.prototype.getLiveRegion = function(priority) {
                    var existingLiveRegion = this.liveRegions.get(priority);
                    if (existingLiveRegion && document.body.contains(existingLiveRegion)) return existingLiveRegion;
                    var liveRegion = this.createLiveRegion(priority);
                    this.liveRegions.set(priority, liveRegion);
                    return liveRegion;
                };
                Announcer.prototype.createLiveRegion = function(priority) {
                    var el = document.createElement("div");
                    el.style.position = "absolute";
                    el.style.top = "-9999px";
                    el.style.left = "-9999px";
                    el.style.height = "1px";
                    el.style.overflow = "hidden";
                    el.setAttribute("aria-atomic", "true");
                    el.setAttribute("aria-live", priority);
                    el.setAttribute(exports.DATA_MDC_DOM_ANNOUNCE, "true");
                    document.body.appendChild(el);
                    return el;
                };
                return Announcer;
            }();
        /***/ },
        /***/ "./packages/mdc-dom/events.ts": /*!************************************!*\
  !*** ./packages/mdc-dom/events.ts ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.applyPassive = void 0;
            /**
 * Determine whether the current browser supports passive event listeners, and
 * if so, use them.
 */ function applyPassive(globalObj) {
                if (globalObj === void 0) globalObj = window;
                return supportsPassiveOption(globalObj) ? {
                    passive: true
                } : false;
            }
            exports.applyPassive = applyPassive;
            function supportsPassiveOption(globalObj) {
                if (globalObj === void 0) globalObj = window;
                // See
                // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
                var passiveSupported = false;
                try {
                    var options = {
                        // This function will be called when the browser
                        // attempts to access the passive property.
                        get passive () {
                            passiveSupported = true;
                            return false;
                        }
                    };
                    var handler = function handler() {};
                    globalObj.document.addEventListener("test", handler, options);
                    globalObj.document.removeEventListener("test", handler, options);
                } catch (err) {
                    passiveSupported = false;
                }
                return passiveSupported;
            }
        /***/ },
        /***/ "./packages/mdc-dom/keyboard.ts": /*!**************************************!*\
  !*** ./packages/mdc-dom/keyboard.ts ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.isNavigationEvent = exports.normalizeKey = exports.KEY = void 0;
            /**
 * KEY provides normalized string values for keys.
 */ exports.KEY = {
                UNKNOWN: "Unknown",
                BACKSPACE: "Backspace",
                ENTER: "Enter",
                SPACEBAR: "Spacebar",
                PAGE_UP: "PageUp",
                PAGE_DOWN: "PageDown",
                END: "End",
                HOME: "Home",
                ARROW_LEFT: "ArrowLeft",
                ARROW_UP: "ArrowUp",
                ARROW_RIGHT: "ArrowRight",
                ARROW_DOWN: "ArrowDown",
                DELETE: "Delete",
                ESCAPE: "Escape",
                TAB: "Tab"
            };
            var normalizedKeys = new Set();
            // IE11 has no support for new Map with iterable so we need to initialize this
            // by hand.
            normalizedKeys.add(exports.KEY.BACKSPACE);
            normalizedKeys.add(exports.KEY.ENTER);
            normalizedKeys.add(exports.KEY.SPACEBAR);
            normalizedKeys.add(exports.KEY.PAGE_UP);
            normalizedKeys.add(exports.KEY.PAGE_DOWN);
            normalizedKeys.add(exports.KEY.END);
            normalizedKeys.add(exports.KEY.HOME);
            normalizedKeys.add(exports.KEY.ARROW_LEFT);
            normalizedKeys.add(exports.KEY.ARROW_UP);
            normalizedKeys.add(exports.KEY.ARROW_RIGHT);
            normalizedKeys.add(exports.KEY.ARROW_DOWN);
            normalizedKeys.add(exports.KEY.DELETE);
            normalizedKeys.add(exports.KEY.ESCAPE);
            normalizedKeys.add(exports.KEY.TAB);
            var KEY_CODE = {
                BACKSPACE: 8,
                ENTER: 13,
                SPACEBAR: 32,
                PAGE_UP: 33,
                PAGE_DOWN: 34,
                END: 35,
                HOME: 36,
                ARROW_LEFT: 37,
                ARROW_UP: 38,
                ARROW_RIGHT: 39,
                ARROW_DOWN: 40,
                DELETE: 46,
                ESCAPE: 27,
                TAB: 9
            };
            var mappedKeyCodes = new Map();
            // IE11 has no support for new Map with iterable so we need to initialize this
            // by hand.
            mappedKeyCodes.set(KEY_CODE.BACKSPACE, exports.KEY.BACKSPACE);
            mappedKeyCodes.set(KEY_CODE.ENTER, exports.KEY.ENTER);
            mappedKeyCodes.set(KEY_CODE.SPACEBAR, exports.KEY.SPACEBAR);
            mappedKeyCodes.set(KEY_CODE.PAGE_UP, exports.KEY.PAGE_UP);
            mappedKeyCodes.set(KEY_CODE.PAGE_DOWN, exports.KEY.PAGE_DOWN);
            mappedKeyCodes.set(KEY_CODE.END, exports.KEY.END);
            mappedKeyCodes.set(KEY_CODE.HOME, exports.KEY.HOME);
            mappedKeyCodes.set(KEY_CODE.ARROW_LEFT, exports.KEY.ARROW_LEFT);
            mappedKeyCodes.set(KEY_CODE.ARROW_UP, exports.KEY.ARROW_UP);
            mappedKeyCodes.set(KEY_CODE.ARROW_RIGHT, exports.KEY.ARROW_RIGHT);
            mappedKeyCodes.set(KEY_CODE.ARROW_DOWN, exports.KEY.ARROW_DOWN);
            mappedKeyCodes.set(KEY_CODE.DELETE, exports.KEY.DELETE);
            mappedKeyCodes.set(KEY_CODE.ESCAPE, exports.KEY.ESCAPE);
            mappedKeyCodes.set(KEY_CODE.TAB, exports.KEY.TAB);
            var navigationKeys = new Set();
            // IE11 has no support for new Set with iterable so we need to initialize this
            // by hand.
            navigationKeys.add(exports.KEY.PAGE_UP);
            navigationKeys.add(exports.KEY.PAGE_DOWN);
            navigationKeys.add(exports.KEY.END);
            navigationKeys.add(exports.KEY.HOME);
            navigationKeys.add(exports.KEY.ARROW_LEFT);
            navigationKeys.add(exports.KEY.ARROW_UP);
            navigationKeys.add(exports.KEY.ARROW_RIGHT);
            navigationKeys.add(exports.KEY.ARROW_DOWN);
            /**
 * normalizeKey returns the normalized string for a navigational action.
 */ function normalizeKey(evt) {
                var key = evt.key;
                // If the event already has a normalized key, return it
                if (normalizedKeys.has(key)) return key;
                // tslint:disable-next-line:deprecation
                var mappedKey = mappedKeyCodes.get(evt.keyCode);
                if (mappedKey) return mappedKey;
                return exports.KEY.UNKNOWN;
            }
            exports.normalizeKey = normalizeKey;
            /**
 * isNavigationEvent returns whether the event is a navigation event
 */ function isNavigationEvent(evt) {
                return navigationKeys.has(normalizeKey(evt));
            }
            exports.isNavigationEvent = isNavigationEvent;
        /***/ },
        /***/ "./packages/mdc-dom/ponyfill.ts": /*!**************************************!*\
  !*** ./packages/mdc-dom/ponyfill.ts ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.estimateScrollWidth = exports.matches = exports.closest = void 0;
            /**
 * @fileoverview A "ponyfill" is a polyfill that doesn't modify the global prototype chain.
 * This makes ponyfills safer than traditional polyfills, especially for libraries like MDC.
 */ function closest(element, selector) {
                if (element.closest) return element.closest(selector);
                var el = element;
                while(el){
                    if (matches(el, selector)) return el;
                    el = el.parentElement;
                }
                return null;
            }
            exports.closest = closest;
            function matches(element, selector) {
                var nativeMatches = element.matches || element.webkitMatchesSelector || element.msMatchesSelector;
                return nativeMatches.call(element, selector);
            }
            exports.matches = matches;
            /**
 * Used to compute the estimated scroll width of elements. When an element is
 * hidden due to display: none; being applied to a parent element, the width is
 * returned as 0. However, the element will have a true width once no longer
 * inside a display: none context. This method computes an estimated width when
 * the element is hidden or returns the true width when the element is visble.
 * @param {Element} element the element whose width to estimate
 */ function estimateScrollWidth(element) {
                // Check the offsetParent. If the element inherits display: none from any
                // parent, the offsetParent property will be null (see
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent).
                // This check ensures we only clone the node when necessary.
                var htmlEl = element;
                if (htmlEl.offsetParent !== null) return htmlEl.scrollWidth;
                var clone = htmlEl.cloneNode(true);
                clone.style.setProperty("position", "absolute");
                clone.style.setProperty("transform", "translate(-9999px, -9999px)");
                document.documentElement.appendChild(clone);
                var scrollWidth = clone.scrollWidth;
                document.documentElement.removeChild(clone);
                return scrollWidth;
            }
            exports.estimateScrollWidth = estimateScrollWidth;
        /***/ },
        /***/ "./packages/mdc-drawer/component.ts": /*!******************************************!*\
  !*** ./packages/mdc-drawer/component.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                Object.defineProperty(o, k2, {
                    enumerable: true,
                    get: function get() {
                        return m[k];
                    }
                });
            } : function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
            });
            var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                Object.defineProperty(o, "default", {
                    enumerable: true,
                    value: v
                });
            } : function(o, v) {
                o["default"] = v;
            });
            var __importStar = this && this.__importStar || function(mod) {
                if (mod && mod.__esModule) return mod;
                var result = {};
                if (mod != null) {
                    for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                }
                __setModuleDefault(result, mod);
                return result;
            };
            var __importDefault = this && this.__importDefault || function(mod) {
                return mod && mod.__esModule ? mod : {
                    "default": mod
                };
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCDrawer = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var focus_trap_1 = __importDefault(__webpack_require__(/*! focus-trap */ "./node_modules/focus-trap/dist/focus-trap.esm.js"));
            var foundation_1 = __webpack_require__(/*! ./dismissible/foundation */ "./packages/mdc-drawer/dismissible/foundation.ts");
            var foundation_2 = __webpack_require__(/*! ./modal/foundation */ "./packages/mdc-drawer/modal/foundation.ts");
            var util = __importStar(__webpack_require__(/*! ./util */ "./packages/mdc-drawer/util.ts"));
            var cssClasses = foundation_1.MDCDismissibleDrawerFoundation.cssClasses, strings = foundation_1.MDCDismissibleDrawerFoundation.strings;
            /**
 * @events `MDCDrawer:closed {}` Emits when the navigation drawer has closed.
 * @events `MDCDrawer:opened {}` Emits when the navigation drawer has opened.
 */ var MDCDrawer = /** @class */ function(_super) {
                __extends(MDCDrawer, _super);
                function MDCDrawer() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCDrawer.attachTo = function(root) {
                    return new MDCDrawer(root);
                };
                Object.defineProperty(MDCDrawer.prototype, "open", {
                    /**
         * @return boolean Proxies to the foundation's `open`/`close` methods.
         * Also returns true if drawer is in the open position.
         */ get: function get() {
                        return this.foundation.isOpen();
                    },
                    /**
         * Toggles the drawer open and closed.
         */ set: function set(isOpen) {
                        if (isOpen) this.foundation.open();
                        else this.foundation.close();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDrawer.prototype, "list", {
                    // initialSyncWithDOM()
                    get: function get() {
                        return this.list_;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCDrawer.prototype.initialize = function(focusTrapFactory) {
                    if (focusTrapFactory === void 0) focusTrapFactory = focus_trap_1.default;
                    /* TODO(revise): list setup */ /* TODO(drawer): list wrapFocus
        const listEl = this.root.querySelector(strings.LIST_SELECTOR);
        if (listEl) {
          listEl.wrapFocus = true;
        }
        */ this.focusTrapFactory_ = focusTrapFactory;
                };
                MDCDrawer.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    var MODAL = cssClasses.MODAL;
                    var SCRIM_SELECTOR = strings.SCRIM_SELECTOR;
                    this.scrim_ = this.root.parentNode.querySelector(SCRIM_SELECTOR);
                    if (this.scrim_ && this.root.classList.contains(MODAL)) {
                        this.handleScrimClick_ = function() {
                            return _this.handleScrimClick();
                        };
                        this.scrim_.addEventListener("click", this.handleScrimClick_);
                        this.focusTrap_ = util.createFocusTrapInstance(this.root, this.focusTrapFactory_);
                    }
                    this.handleKeydown_ = function(evt) {
                        return _this.handleKeydown(evt);
                    };
                    this.handleTransitionEnd_ = function(evt) {
                        return _this.foundation.handleTransitionEnd(evt);
                    };
                    this.listen("keydown", this.handleKeydown_);
                    this.listen("transitionend", this.handleTransitionEnd_);
                };
                MDCDrawer.prototype.handleScrimClick = function() {
                    this.emit("MDCDrawer:close", {}, true);
                };
                MDCDrawer.prototype.handleKeydown = function(evt) {
                    var keyCode = evt.keyCode, key = evt.key;
                    var isEscape = key === "Escape" || keyCode === 27;
                    if (isEscape) this.emit("MDCDrawer:close", {}, true);
                };
                MDCDrawer.prototype.destroy = function() {
                    this.unlisten("keydown", this.handleKeydown_);
                    this.unlisten("transitionend", this.handleTransitionEnd_);
                    var MODAL = cssClasses.MODAL;
                    if (this.scrim_ && this.handleScrimClick_ && this.root.classList.contains(MODAL)) {
                        this.scrim_.removeEventListener("click", this.handleScrimClick_);
                        // Ensure drawer is closed to hide scrim and release focus
                        this.open = false;
                    }
                };
                MDCDrawer.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take
                    // a Partial<MDCFooAdapter>. To ensure we don't accidentally omit any
                    // methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        elementHasClass: function elementHasClass(element, className) {
                            return element.classList.contains(className);
                        },
                        saveFocus: function saveFocus() {
                            return _this.previousFocus_ = document.activeElement;
                        },
                        restoreFocus: function restoreFocus() {
                            var previousFocus = _this.previousFocus_;
                            if (previousFocus && previousFocus.focus && _this.root.contains(document.activeElement)) previousFocus.focus();
                        },
                        focusActiveNavigationItem: function focusActiveNavigationItem() {
                            var activeNavItemEl = _this.root.querySelector(strings.LIST_ITEM_ACTIVATED_SELECTOR);
                            if (activeNavItemEl) activeNavItemEl.focus();
                        },
                        notifyClose: function notifyClose() {
                            return _this.emit(strings.CLOSE_EVENT, {}, true);
                        },
                        notifyOpen: function notifyOpen() {
                            return _this.emit(strings.OPEN_EVENT, {}, true);
                        },
                        trapFocus: function trapFocus() {
                            return _this.focusTrap_.activate();
                        },
                        releaseFocus: function releaseFocus() {
                            return _this.focusTrap_.deactivate();
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    var DISMISSIBLE = cssClasses.DISMISSIBLE, MODAL = cssClasses.MODAL;
                    if (this.root.classList.contains(DISMISSIBLE)) return new foundation_1.MDCDismissibleDrawerFoundation(adapter);
                    else if (this.root.classList.contains(MODAL)) return new foundation_2.MDCModalDrawerFoundation(adapter);
                    else throw new Error("MDCDrawer: Failed to instantiate component. Supported variants are " + DISMISSIBLE + " and " + MODAL + ".");
                };
                return MDCDrawer;
            }(component_1.MDCComponent);
            exports.MDCDrawer = MDCDrawer;
        /***/ },
        /***/ "./packages/mdc-drawer/constants.ts": /*!******************************************!*\
  !*** ./packages/mdc-drawer/constants.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.cssClasses = void 0;
            var cssClasses = {
                ANIMATE: "mdc-drawer--animate",
                CLOSING: "mdc-drawer--closing",
                DISMISSIBLE: "mdc-drawer--dismissible",
                MODAL: "mdc-drawer--modal",
                OPEN: "mdc-drawer--open",
                OPENING: "mdc-drawer--opening",
                ROOT: "mdc-drawer"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                APP_CONTENT_SELECTOR: ".mdc-drawer-app-content",
                CLOSE_EVENT: "MDCDrawer:closed",
                OPEN_EVENT: "MDCDrawer:opened",
                SCRIM_SELECTOR: ".mdc-drawer-scrim",
                LIST_SELECTOR: ".mdc-list,.mdc-deprecated-list",
                LIST_ITEM_ACTIVATED_SELECTOR: ".mdc-list-item--activated,.mdc-deprecated-list-item--activated"
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-drawer/custom-element.js": /*!***********************************************!*\
  !*** ./packages/mdc-drawer/custom-element.js ***!
  \***********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-drawer/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcDrawer = function(_HTMLElement) {
                _inherits(MdcDrawer, _HTMLElement);
                _createClass(MdcDrawer, [
                    {
                        key: "open",
                        get: function get() {
                            return this.open_;
                        },
                        set: function set(open) {
                            this.open_ = open;
                            if (!!this.drawer_) this.drawer_.open = open;
                        }
                    }
                ]);
                function MdcDrawer() {
                    _classCallCheck(this, MdcDrawer);
                    var _this = _possibleConstructorReturn(this, (MdcDrawer.__proto__ || Object.getPrototypeOf(MdcDrawer)).call(this));
                    _this.open_ = false;
                    _this.drawer_;
                    return _this;
                }
                _createClass(MdcDrawer, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.drawer_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCDrawer"](this);
                            this.drawer_.open = this.open_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.drawer_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcDrawer;
            }(HTMLElement);
            customElements.define("mdc-drawer", MdcDrawer);
        /***/ },
        /***/ "./packages/mdc-drawer/dismissible/foundation.ts": /*!*******************************************************!*\
  !*** ./packages/mdc-drawer/dismissible/foundation.ts ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCDismissibleDrawerFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ../constants */ "./packages/mdc-drawer/constants.ts");
            var MDCDismissibleDrawerFoundation = /** @class */ function(_super) {
                __extends(MDCDismissibleDrawerFoundation, _super);
                function MDCDismissibleDrawerFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCDismissibleDrawerFoundation.defaultAdapter), adapter)) || this;
                    _this.animationFrame_ = 0;
                    _this.animationTimer_ = 0;
                    return _this;
                }
                Object.defineProperty(MDCDismissibleDrawerFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDismissibleDrawerFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDismissibleDrawerFoundation, "defaultAdapter", {
                    get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            elementHasClass: function elementHasClass() {
                                return false;
                            },
                            notifyClose: function notifyClose() {
                                return undefined;
                            },
                            notifyOpen: function notifyOpen() {
                                return undefined;
                            },
                            saveFocus: function saveFocus() {
                                return undefined;
                            },
                            restoreFocus: function restoreFocus() {
                                return undefined;
                            },
                            focusActiveNavigationItem: function focusActiveNavigationItem() {
                                return undefined;
                            },
                            trapFocus: function trapFocus() {
                                return undefined;
                            },
                            releaseFocus: function releaseFocus() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCDismissibleDrawerFoundation.prototype.destroy = function() {
                    if (this.animationFrame_) cancelAnimationFrame(this.animationFrame_);
                    if (this.animationTimer_) clearTimeout(this.animationTimer_);
                };
                /**
     * Opens the drawer from the closed state.
     */ MDCDismissibleDrawerFoundation.prototype.open = function() {
                    var _this = this;
                    if (this.isOpen() || this.isOpening() || this.isClosing()) return;
                    this.adapter.addClass(constants_1.cssClasses.OPEN);
                    this.adapter.addClass(constants_1.cssClasses.ANIMATE);
                    // Wait a frame once display is no longer "none", to establish basis for animation
                    this.runNextAnimationFrame_(function() {
                        _this.adapter.addClass(constants_1.cssClasses.OPENING);
                    });
                    this.adapter.saveFocus();
                };
                /**
     * Closes the drawer from the open state.
     */ MDCDismissibleDrawerFoundation.prototype.close = function() {
                    if (!this.isOpen() || this.isOpening() || this.isClosing()) return;
                    this.adapter.addClass(constants_1.cssClasses.CLOSING);
                };
                /**
     * Returns true if the drawer is in the open position.
     * @return true if drawer is in open state.
     */ MDCDismissibleDrawerFoundation.prototype.isOpen = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.OPEN);
                };
                /**
     * Returns true if the drawer is animating open.
     * @return true if drawer is animating open.
     */ MDCDismissibleDrawerFoundation.prototype.isOpening = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.OPENING) || this.adapter.hasClass(constants_1.cssClasses.ANIMATE);
                };
                /**
     * Returns true if the drawer is animating closed.
     * @return true if drawer is animating closed.
     */ MDCDismissibleDrawerFoundation.prototype.isClosing = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.CLOSING);
                };
                /**
     * Keydown handler to close drawer when key is escape.
     */ MDCDismissibleDrawerFoundation.prototype.handleKeydown = function(evt) {
                    var keyCode = evt.keyCode, key = evt.key;
                    var isEscape = key === "Escape" || keyCode === 27;
                    if (isEscape) this.close();
                };
                /**
     * Handles the `transitionend` event when the drawer finishes opening/closing.
     */ MDCDismissibleDrawerFoundation.prototype.handleTransitionEnd = function(evt) {
                    var OPENING = constants_1.cssClasses.OPENING, CLOSING = constants_1.cssClasses.CLOSING, OPEN = constants_1.cssClasses.OPEN, ANIMATE = constants_1.cssClasses.ANIMATE, ROOT = constants_1.cssClasses.ROOT;
                    // In Edge, transitionend on ripple pseudo-elements yields a target without classList, so check for Element first.
                    var isRootElement = this.isElement_(evt.target) && this.adapter.elementHasClass(evt.target, ROOT);
                    if (!isRootElement) return;
                    if (this.isClosing()) {
                        this.adapter.removeClass(OPEN);
                        this.closed_();
                        this.adapter.restoreFocus();
                        this.adapter.notifyClose();
                    } else {
                        this.adapter.focusActiveNavigationItem();
                        this.opened_();
                        this.adapter.notifyOpen();
                    }
                    this.adapter.removeClass(ANIMATE);
                    this.adapter.removeClass(OPENING);
                    this.adapter.removeClass(CLOSING);
                };
                /**
     * Extension point for when drawer finishes open animation.
     */ MDCDismissibleDrawerFoundation.prototype.opened_ = function() {}; // tslint:disable-line:no-empty
                /**
     * Extension point for when drawer finishes close animation.
     */ MDCDismissibleDrawerFoundation.prototype.closed_ = function() {}; // tslint:disable-line:no-empty
                /**
     * Runs the given logic on the next animation frame, using setTimeout to factor in Firefox reflow behavior.
     */ MDCDismissibleDrawerFoundation.prototype.runNextAnimationFrame_ = function(callback) {
                    var _this = this;
                    cancelAnimationFrame(this.animationFrame_);
                    this.animationFrame_ = requestAnimationFrame(function() {
                        _this.animationFrame_ = 0;
                        clearTimeout(_this.animationTimer_);
                        _this.animationTimer_ = setTimeout(callback, 0);
                    });
                };
                MDCDismissibleDrawerFoundation.prototype.isElement_ = function(element) {
                    // In Edge, transitionend on ripple pseudo-elements yields a target without classList.
                    return Boolean(element.classList);
                };
                return MDCDismissibleDrawerFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCDismissibleDrawerFoundation = MDCDismissibleDrawerFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCDismissibleDrawerFoundation;
        /***/ },
        /***/ "./packages/mdc-drawer/modal/foundation.ts": /*!*************************************************!*\
  !*** ./packages/mdc-drawer/modal/foundation.ts ***!
  \*************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCModalDrawerFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! ../dismissible/foundation */ "./packages/mdc-drawer/dismissible/foundation.ts");
            /* istanbul ignore next: subclass is not a branch statement */ var MDCModalDrawerFoundation = /** @class */ function(_super) {
                __extends(MDCModalDrawerFoundation, _super);
                function MDCModalDrawerFoundation() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                /**
     * Handles click event on scrim.
     */ MDCModalDrawerFoundation.prototype.handleScrimClick = function() {
                    this.close();
                };
                /**
     * Called when drawer finishes open animation.
     */ MDCModalDrawerFoundation.prototype.opened_ = function() {
                    this.adapter.trapFocus();
                };
                /**
     * Called when drawer finishes close animation.
     */ MDCModalDrawerFoundation.prototype.closed_ = function() {
                    this.adapter.releaseFocus();
                };
                return MDCModalDrawerFoundation;
            }(foundation_1.MDCDismissibleDrawerFoundation);
            exports.MDCModalDrawerFoundation = MDCModalDrawerFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCModalDrawerFoundation;
        /***/ },
        /***/ "./packages/mdc-drawer/util.ts": /*!*************************************!*\
  !*** ./packages/mdc-drawer/util.ts ***!
  \*************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.createFocusTrapInstance = void 0;
            var focus_trap_1 = __webpack_require__(/*! focus-trap */ "./node_modules/focus-trap/dist/focus-trap.esm.js");
            function createFocusTrapInstance(surfaceEl, focusTrapFactory) {
                if (focusTrapFactory === void 0) focusTrapFactory = focus_trap_1.createFocusTrap;
                return focusTrapFactory(surfaceEl, {
                    clickOutsideDeactivates: true,
                    escapeDeactivates: false,
                    initialFocus: undefined,
                    returnFocusOnDeactivate: false
                });
            }
            exports.createFocusTrapInstance = createFocusTrapInstance;
        /***/ },
        /***/ "./packages/mdc-fab/custom-element.js": /*!********************************************!*\
  !*** ./packages/mdc-fab/custom-element.js ***!
  \********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_material_ripple_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcFab = function(_HTMLElement) {
                _inherits(MdcFab, _HTMLElement);
                function MdcFab() {
                    _classCallCheck(this, MdcFab);
                    var _this = _possibleConstructorReturn(this, (MdcFab.__proto__ || Object.getPrototypeOf(MdcFab)).call(this));
                    _this.handleKeydown_;
                    return _this;
                }
                _createClass(MdcFab, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.ripple_ = new _material_ripple_component__WEBPACK_IMPORTED_MODULE_0__["MDCRipple"](this);
                            this.handleKeydown_ = this.handleKeydown.bind(this);
                            this.addEventListener("keydown", this.handleKeydown_);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.ripple_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                            this.removeEventListener("keydown", this.handleKeydown_);
                        }
                    },
                    {
                        key: "handleKeydown",
                        value: function handleKeydown(event) {
                            var isSpace = event.key === "Space" || event.keyCode == 32;
                            var isEnter = event.key === "Enter" || event.keyCode == 12;
                            if (isSpace || isEnter) {
                                this.click();
                                event.preventDefault();
                            }
                        }
                    }
                ]);
                return MdcFab;
            }(HTMLElement);
            customElements.define("mdc-fab", MdcFab);
        /***/ },
        /***/ "./packages/mdc-floating-label/component.ts": /*!**************************************************!*\
  !*** ./packages/mdc-floating-label/component.ts ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCFloatingLabel = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-floating-label/foundation.ts");
            var MDCFloatingLabel = /** @class */ function(_super) {
                __extends(MDCFloatingLabel, _super);
                function MDCFloatingLabel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCFloatingLabel.attachTo = function(root) {
                    return new MDCFloatingLabel(root);
                };
                /**
     * Styles the label to produce the label shake for errors.
     * @param shouldShake If true, shakes the label by adding a CSS class; otherwise, stops shaking by removing the class.
     */ MDCFloatingLabel.prototype.shake = function(shouldShake) {
                    this.foundation.shake(shouldShake);
                };
                /**
     * Styles the label to float/dock.
     * @param shouldFloat If true, floats the label by adding a CSS class; otherwise, docks it by removing the class.
     */ MDCFloatingLabel.prototype.float = function(shouldFloat) {
                    this.foundation.float(shouldFloat);
                };
                /**
     * Styles the label as required.
     * @param isRequired If true, adds an asterisk to the label, indicating that it is required.
     */ MDCFloatingLabel.prototype.setRequired = function(isRequired) {
                    this.foundation.setRequired(isRequired);
                };
                MDCFloatingLabel.prototype.getWidth = function() {
                    return this.foundation.getWidth();
                };
                MDCFloatingLabel.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        getWidth: function getWidth() {
                            return ponyfill_1.estimateScrollWidth(_this.root);
                        },
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            return _this.listen(evtType, handler);
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            return _this.unlisten(evtType, handler);
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_1.MDCFloatingLabelFoundation(adapter);
                };
                return MDCFloatingLabel;
            }(component_1.MDCComponent);
            exports.MDCFloatingLabel = MDCFloatingLabel;
        /***/ },
        /***/ "./packages/mdc-floating-label/constants.ts": /*!**************************************************!*\
  !*** ./packages/mdc-floating-label/constants.ts ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.cssClasses = void 0;
            exports.cssClasses = {
                LABEL_FLOAT_ABOVE: "mdc-floating-label--float-above",
                LABEL_REQUIRED: "mdc-floating-label--required",
                LABEL_SHAKE: "mdc-floating-label--shake",
                ROOT: "mdc-floating-label"
            };
        /***/ },
        /***/ "./packages/mdc-floating-label/foundation.ts": /*!***************************************************!*\
  !*** ./packages/mdc-floating-label/foundation.ts ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCFloatingLabelFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-floating-label/constants.ts");
            var MDCFloatingLabelFoundation = /** @class */ function(_super) {
                __extends(MDCFloatingLabelFoundation, _super);
                function MDCFloatingLabelFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCFloatingLabelFoundation.defaultAdapter), adapter)) || this;
                    _this.shakeAnimationEndHandler_ = function() {
                        return _this.handleShakeAnimationEnd_();
                    };
                    return _this;
                }
                Object.defineProperty(MDCFloatingLabelFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCFloatingLabelFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCFloatingLabelAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            getWidth: function getWidth() {
                                return 0;
                            },
                            registerInteractionHandler: function registerInteractionHandler() {
                                return undefined;
                            },
                            deregisterInteractionHandler: function deregisterInteractionHandler() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCFloatingLabelFoundation.prototype.init = function() {
                    this.adapter.registerInteractionHandler("animationend", this.shakeAnimationEndHandler_);
                };
                MDCFloatingLabelFoundation.prototype.destroy = function() {
                    this.adapter.deregisterInteractionHandler("animationend", this.shakeAnimationEndHandler_);
                };
                /**
     * Returns the width of the label element.
     */ MDCFloatingLabelFoundation.prototype.getWidth = function() {
                    return this.adapter.getWidth();
                };
                /**
     * Styles the label to produce a shake animation to indicate an error.
     * @param shouldShake If true, adds the shake CSS class; otherwise, removes shake class.
     */ MDCFloatingLabelFoundation.prototype.shake = function(shouldShake) {
                    var LABEL_SHAKE = MDCFloatingLabelFoundation.cssClasses.LABEL_SHAKE;
                    if (shouldShake) this.adapter.addClass(LABEL_SHAKE);
                    else this.adapter.removeClass(LABEL_SHAKE);
                };
                /**
     * Styles the label to float or dock.
     * @param shouldFloat If true, adds the float CSS class; otherwise, removes float and shake classes to dock the label.
     */ MDCFloatingLabelFoundation.prototype.float = function(shouldFloat) {
                    var _a = MDCFloatingLabelFoundation.cssClasses, LABEL_FLOAT_ABOVE = _a.LABEL_FLOAT_ABOVE, LABEL_SHAKE = _a.LABEL_SHAKE;
                    if (shouldFloat) this.adapter.addClass(LABEL_FLOAT_ABOVE);
                    else {
                        this.adapter.removeClass(LABEL_FLOAT_ABOVE);
                        this.adapter.removeClass(LABEL_SHAKE);
                    }
                };
                /**
     * Styles the label as required.
     * @param isRequired If true, adds an asterisk to the label, indicating that it is required.
     */ MDCFloatingLabelFoundation.prototype.setRequired = function(isRequired) {
                    var LABEL_REQUIRED = MDCFloatingLabelFoundation.cssClasses.LABEL_REQUIRED;
                    if (isRequired) this.adapter.addClass(LABEL_REQUIRED);
                    else this.adapter.removeClass(LABEL_REQUIRED);
                };
                MDCFloatingLabelFoundation.prototype.handleShakeAnimationEnd_ = function() {
                    var LABEL_SHAKE = MDCFloatingLabelFoundation.cssClasses.LABEL_SHAKE;
                    this.adapter.removeClass(LABEL_SHAKE);
                };
                return MDCFloatingLabelFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCFloatingLabelFoundation = MDCFloatingLabelFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCFloatingLabelFoundation;
        /***/ },
        /***/ "./packages/mdc-form-field/component.ts": /*!**********************************************!*\
  !*** ./packages/mdc-form-field/component.ts ***!
  \**********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCFormField = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-form-field/foundation.ts");
            var MDCFormField = /** @class */ function(_super) {
                __extends(MDCFormField, _super);
                function MDCFormField() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCFormField.attachTo = function(root) {
                    return new MDCFormField(root);
                };
                MDCFormField.prototype.labelEl = function() {
                    var LABEL_SELECTOR = foundation_1.MDCFormFieldFoundation.strings.LABEL_SELECTOR;
                    return this.root.querySelector(LABEL_SELECTOR);
                };
                MDCFormField.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        activateInputRipple: function activateInputRipple() {
                            if (_this.input && _this.input.ripple) _this.input.ripple.activate();
                        },
                        deactivateInputRipple: function deactivateInputRipple() {
                            if (_this.input && _this.input.ripple) _this.input.ripple.deactivate();
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            var labelEl = _this.labelEl();
                            if (labelEl) labelEl.removeEventListener(evtType, handler);
                        },
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            var labelEl = _this.labelEl();
                            if (labelEl) labelEl.addEventListener(evtType, handler);
                        }
                    };
                    return new foundation_1.MDCFormFieldFoundation(adapter);
                };
                return MDCFormField;
            }(component_1.MDCComponent);
            exports.MDCFormField = MDCFormField;
        /***/ },
        /***/ "./packages/mdc-form-field/constants.ts": /*!**********************************************!*\
  !*** ./packages/mdc-form-field/constants.ts ***!
  \**********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.cssClasses = void 0;
            exports.cssClasses = {
                ROOT: "mdc-form-field"
            };
            exports.strings = {
                LABEL_SELECTOR: ".mdc-form-field > label"
            };
        /***/ },
        /***/ "./packages/mdc-form-field/custom-element.js": /*!***************************************************!*\
  !*** ./packages/mdc-form-field/custom-element.js ***!
  \***************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-form-field/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcFormField = function(_HTMLElement) {
                _inherits(MdcFormField, _HTMLElement);
                _createClass(MdcFormField, [
                    {
                        key: "focus",
                        value: function focus() {
                            if (!!this.formField_.input) this.formField_.input.focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            if (!!this.formField_.input) this.formField_.input.blur();
                        }
                    }
                ]);
                function MdcFormField() {
                    _classCallCheck(this, MdcFormField);
                    var _this = _possibleConstructorReturn(this, (MdcFormField.__proto__ || Object.getPrototypeOf(MdcFormField)).call(this));
                    _this.formField_;
                    return _this;
                }
                _createClass(MdcFormField, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.formField_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCFormField"](this);
                            var inputElement = this.querySelector("input");
                            if (inputElement) this.formField_.input = inputElement;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.formField_.destroy();
                        }
                    }
                ]);
                return MdcFormField;
            }(HTMLElement);
            customElements.define("mdc-form-field", MdcFormField);
        /***/ },
        /***/ "./packages/mdc-form-field/foundation.ts": /*!***********************************************!*\
  !*** ./packages/mdc-form-field/foundation.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCFormFieldFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-form-field/constants.ts");
            var MDCFormFieldFoundation = /** @class */ function(_super) {
                __extends(MDCFormFieldFoundation, _super);
                function MDCFormFieldFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCFormFieldFoundation.defaultAdapter), adapter)) || this;
                    _this.click = function() {
                        _this.handleClick();
                    };
                    return _this;
                }
                Object.defineProperty(MDCFormFieldFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCFormFieldFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCFormFieldFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            activateInputRipple: function activateInputRipple() {
                                return undefined;
                            },
                            deactivateInputRipple: function deactivateInputRipple() {
                                return undefined;
                            },
                            deregisterInteractionHandler: function deregisterInteractionHandler() {
                                return undefined;
                            },
                            registerInteractionHandler: function registerInteractionHandler() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCFormFieldFoundation.prototype.init = function() {
                    this.adapter.registerInteractionHandler("click", this.click);
                };
                MDCFormFieldFoundation.prototype.destroy = function() {
                    this.adapter.deregisterInteractionHandler("click", this.click);
                };
                MDCFormFieldFoundation.prototype.handleClick = function() {
                    var _this = this;
                    this.adapter.activateInputRipple();
                    requestAnimationFrame(function() {
                        _this.adapter.deactivateInputRipple();
                    });
                };
                return MDCFormFieldFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCFormFieldFoundation = MDCFormFieldFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCFormFieldFoundation;
        /***/ },
        /***/ "./packages/mdc-icon-button/component.ts": /*!***********************************************!*\
  !*** ./packages/mdc-icon-button/component.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCIconButtonToggle = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var component_2 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-icon-button/foundation.ts");
            var strings = foundation_1.MDCIconButtonToggleFoundation.strings;
            var MDCIconButtonToggle = /** @class */ function(_super) {
                __extends(MDCIconButtonToggle, _super);
                function MDCIconButtonToggle() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.rippleComponent = _this.createRipple();
                    return _this;
                }
                MDCIconButtonToggle.attachTo = function(root) {
                    return new MDCIconButtonToggle(root);
                };
                MDCIconButtonToggle.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.handleClick = function() {
                        _this.foundation.handleClick();
                    };
                    this.handleClick_ = this.handleClick_.bind(this);
                    this.listen("click", this.handleClick);
                };
                MDCIconButtonToggle.prototype.destroy = function() {
                    this.unlisten("click", this.handleClick);
                    this.ripple.destroy();
                    _super.prototype.destroy.call(this);
                };
                MDCIconButtonToggle.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        notifyChange: function notifyChange() {},
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        getAttr: function getAttr(attrName) {
                            return _this.root.getAttribute(attrName);
                        },
                        setAttr: function setAttr(attrName, attrValue) {
                            return _this.root.setAttribute(attrName, attrValue);
                        }
                    };
                    return new foundation_1.MDCIconButtonToggleFoundation(adapter);
                };
                MDCIconButtonToggle.prototype.handleClick_ = function() {
                    this.emit(strings.CHANGE_EVENT, {
                        isOn: !this.on
                    });
                };
                Object.defineProperty(MDCIconButtonToggle.prototype, "ripple", {
                    get: function get() {
                        return this.rippleComponent;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCIconButtonToggle.prototype, "on", {
                    get: function get() {
                        return this.foundation.isOn();
                    },
                    set: function set(isOn) {
                        this.foundation.toggle(isOn);
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCIconButtonToggle.prototype.createRipple = function() {
                    var ripple = new component_2.MDCRipple(this.root);
                    ripple.unbounded = true;
                    return ripple;
                };
                return MDCIconButtonToggle;
            }(component_1.MDCComponent);
            exports.MDCIconButtonToggle = MDCIconButtonToggle;
        /***/ },
        /***/ "./packages/mdc-icon-button/constants.ts": /*!***********************************************!*\
  !*** ./packages/mdc-icon-button/constants.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.cssClasses = void 0;
            exports.cssClasses = {
                ICON_BUTTON_ON: "mdc-icon-button--on",
                ROOT: "mdc-icon-button"
            };
            exports.strings = {
                ARIA_LABEL: "aria-label",
                ARIA_PRESSED: "aria-pressed",
                DATA_ARIA_LABEL_OFF: "data-aria-label-off",
                DATA_ARIA_LABEL_ON: "data-aria-label-on",
                CHANGE_EVENT: "MDCIconButtonToggle:change"
            };
        /***/ },
        /***/ "./packages/mdc-icon-button/custom-element.js": /*!****************************************************!*\
  !*** ./packages/mdc-icon-button/custom-element.js ***!
  \****************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _mdc_icon_button_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mdc-icon-button/component */ "./packages/mdc-icon-button/component.ts");
            /* harmony import */ var _mdc_icon_button_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_mdc_icon_button_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_material_ripple_component__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcIconButton = function(_HTMLElement) {
                _inherits(MdcIconButton, _HTMLElement);
                function MdcIconButton() {
                    _classCallCheck(this, MdcIconButton);
                    var _this = _possibleConstructorReturn(this, (MdcIconButton.__proto__ || Object.getPrototypeOf(MdcIconButton)).call(this));
                    _this.root_;
                    _this.ripple_;
                    return _this;
                }
                _createClass(MdcIconButton, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.root_ = this.querySelector(".mdc-icon-button");
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_2__["installClassNameChangeHook"].call(this.root_);
                            this.ripple_ = new _material_ripple_component__WEBPACK_IMPORTED_MODULE_1__["MDCRipple"](this.root_);
                            this.ripple_.unbounded = true;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.ripple_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_2__["uninstallClassNameChangeHook"].call(this.root_);
                        }
                    }
                ]);
                return MdcIconButton;
            }(HTMLElement);
            customElements.define("mdc-icon-button", MdcIconButton);
            var MdcIconToggle = function(_HTMLElement2) {
                _inherits(MdcIconToggle, _HTMLElement2);
                _createClass(MdcIconToggle, [
                    {
                        key: "on",
                        get: function get() {
                            return this.on_;
                        },
                        set: function set(on) {
                            this.on_ = on;
                            if (!!this.iconButtonToggle_) this.iconButtonToggle_.on = on;
                        }
                    }
                ]);
                function MdcIconToggle() {
                    _classCallCheck(this, MdcIconToggle);
                    var _this2 = _possibleConstructorReturn(this, (MdcIconToggle.__proto__ || Object.getPrototypeOf(MdcIconToggle)).call(this));
                    _this2.root_;
                    _this2.on_ = false;
                    _this2.iconButtonToggle_;
                    return _this2;
                }
                _createClass(MdcIconToggle, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.root_ = this.querySelector(".mdc-icon-button");
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_2__["installClassNameChangeHook"].call(this.root_);
                            this.iconButtonToggle_ = new _mdc_icon_button_component__WEBPACK_IMPORTED_MODULE_0__["MDCIconButtonToggle"](this.root_);
                            this.iconButtonToggle_.on = this.on_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.iconButtonToggle_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_2__["uninstallClassNameChangeHook"].call(this.root_);
                        }
                    }
                ]);
                return MdcIconToggle;
            }(HTMLElement);
            customElements.define("mdc-icon-toggle", MdcIconToggle);
        /***/ },
        /***/ "./packages/mdc-icon-button/foundation.ts": /*!************************************************!*\
  !*** ./packages/mdc-icon-button/foundation.ts ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCIconButtonToggleFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-icon-button/constants.ts");
            var MDCIconButtonToggleFoundation = /** @class */ function(_super) {
                __extends(MDCIconButtonToggleFoundation, _super);
                function MDCIconButtonToggleFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCIconButtonToggleFoundation.defaultAdapter), adapter)) || this;
                    /**
         * Whether the icon button has an aria label that changes depending on
         * toggled state.
         */ _this.hasToggledAriaLabel = false;
                    return _this;
                }
                Object.defineProperty(MDCIconButtonToggleFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCIconButtonToggleFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCIconButtonToggleFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            notifyChange: function notifyChange() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            getAttr: function getAttr() {
                                return null;
                            },
                            setAttr: function setAttr() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCIconButtonToggleFoundation.prototype.init = function() {
                    var ariaLabelOn = this.adapter.getAttr(constants_1.strings.DATA_ARIA_LABEL_ON);
                    var ariaLabelOff = this.adapter.getAttr(constants_1.strings.DATA_ARIA_LABEL_OFF);
                    if (ariaLabelOn && ariaLabelOff) {
                        if (this.adapter.getAttr(constants_1.strings.ARIA_PRESSED) !== null) throw new Error("MDCIconButtonToggleFoundation: Button should not set `aria-pressed` if it has a toggled aria label.");
                        this.hasToggledAriaLabel = true;
                    } else this.adapter.setAttr(constants_1.strings.ARIA_PRESSED, String(this.isOn()));
                };
                MDCIconButtonToggleFoundation.prototype.handleClick = function() {
                    this.toggle();
                    this.adapter.notifyChange({
                        isOn: this.isOn()
                    });
                };
                MDCIconButtonToggleFoundation.prototype.isOn = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.ICON_BUTTON_ON);
                };
                MDCIconButtonToggleFoundation.prototype.toggle = function(isOn) {
                    if (isOn === void 0) isOn = !this.isOn();
                    // Toggle UI based on state.
                    if (isOn) this.adapter.addClass(constants_1.cssClasses.ICON_BUTTON_ON);
                    else this.adapter.removeClass(constants_1.cssClasses.ICON_BUTTON_ON);
                    // Toggle aria attributes based on state.
                    if (this.hasToggledAriaLabel) {
                        var ariaLabel = isOn ? this.adapter.getAttr(constants_1.strings.DATA_ARIA_LABEL_ON) : this.adapter.getAttr(constants_1.strings.DATA_ARIA_LABEL_OFF);
                        this.adapter.setAttr(constants_1.strings.ARIA_LABEL, ariaLabel || "");
                    } else this.adapter.setAttr(constants_1.strings.ARIA_PRESSED, "" + isOn);
                };
                return MDCIconButtonToggleFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCIconButtonToggleFoundation = MDCIconButtonToggleFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCIconButtonToggleFoundation;
        /***/ },
        /***/ "./packages/mdc-image-list/custom-element.js": /*!***************************************************!*\
  !*** ./packages/mdc-image-list/custom-element.js ***!
  \***************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_material_ripple_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcImageList = function(_HTMLElement) {
                _inherits(MdcImageList, _HTMLElement);
                function MdcImageList() {
                    _classCallCheck(this, MdcImageList);
                    return _possibleConstructorReturn(this, (MdcImageList.__proto__ || Object.getPrototypeOf(MdcImageList)).call(this));
                }
                _createClass(MdcImageList, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {}
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {}
                    }
                ]);
                return MdcImageList;
            }(HTMLElement);
            customElements.define("mdc-image-list", MdcImageList);
            var MdcImageListItem = function(_HTMLElement2) {
                _inherits(MdcImageListItem, _HTMLElement2);
                function MdcImageListItem() {
                    _classCallCheck(this, MdcImageListItem);
                    var _this2 = _possibleConstructorReturn(this, (MdcImageListItem.__proto__ || Object.getPrototypeOf(MdcImageListItem)).call(this));
                    _this2.ripple_;
                    return _this2;
                }
                _createClass(MdcImageListItem, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.style.display = "block";
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            var rippleSurfaceElement = this.querySelector(".mdc-ripple-surface");
                            if (!!rippleSurfaceElement) this.ripple_ = new _material_ripple_component__WEBPACK_IMPORTED_MODULE_0__["MDCRipple"](rippleSurfaceElement);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            if (!!this.ripple_) this.ripple_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcImageListItem;
            }(HTMLElement);
            customElements.define("mdc-image-list-item", MdcImageListItem);
        /***/ },
        /***/ "./packages/mdc-layout-grid/custom-element.js": /*!****************************************************!*\
  !*** ./packages/mdc-layout-grid/custom-element.js ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcLayoutGrid = function(_HTMLElement) {
                _inherits(MdcLayoutGrid, _HTMLElement);
                function MdcLayoutGrid() {
                    _classCallCheck(this, MdcLayoutGrid);
                    return _possibleConstructorReturn(this, (MdcLayoutGrid.__proto__ || Object.getPrototypeOf(MdcLayoutGrid)).call(this));
                }
                _createClass(MdcLayoutGrid, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {}
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {}
                    }
                ]);
                return MdcLayoutGrid;
            }(HTMLElement);
            customElements.define("mdc-layout-grid", MdcLayoutGrid);
        /***/ },
        /***/ "./packages/mdc-line-ripple/component.ts": /*!***********************************************!*\
  !*** ./packages/mdc-line-ripple/component.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCLineRipple = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-line-ripple/foundation.ts");
            var MDCLineRipple = /** @class */ function(_super) {
                __extends(MDCLineRipple, _super);
                function MDCLineRipple() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCLineRipple.attachTo = function(root) {
                    return new MDCLineRipple(root);
                };
                /**
     * Activates the line ripple
     */ MDCLineRipple.prototype.activate = function() {
                    this.foundation.activate();
                };
                /**
     * Deactivates the line ripple
     */ MDCLineRipple.prototype.deactivate = function() {
                    this.foundation.deactivate();
                };
                /**
     * Sets the transform origin given a user's click location.
     * The `rippleCenter` is the x-coordinate of the middle of the ripple.
     */ MDCLineRipple.prototype.setRippleCenter = function(xCoordinate) {
                    this.foundation.setRippleCenter(xCoordinate);
                };
                MDCLineRipple.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        setStyle: function setStyle(propertyName, value) {
                            return _this.root.style.setProperty(propertyName, value);
                        },
                        registerEventHandler: function registerEventHandler(evtType, handler) {
                            return _this.listen(evtType, handler);
                        },
                        deregisterEventHandler: function deregisterEventHandler(evtType, handler) {
                            return _this.unlisten(evtType, handler);
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_1.MDCLineRippleFoundation(adapter);
                };
                return MDCLineRipple;
            }(component_1.MDCComponent);
            exports.MDCLineRipple = MDCLineRipple;
        /***/ },
        /***/ "./packages/mdc-line-ripple/constants.ts": /*!***********************************************!*\
  !*** ./packages/mdc-line-ripple/constants.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.cssClasses = void 0;
            var cssClasses = {
                LINE_RIPPLE_ACTIVE: "mdc-line-ripple--active",
                LINE_RIPPLE_DEACTIVATING: "mdc-line-ripple--deactivating"
            };
            exports.cssClasses = cssClasses;
        /***/ },
        /***/ "./packages/mdc-line-ripple/foundation.ts": /*!************************************************!*\
  !*** ./packages/mdc-line-ripple/foundation.ts ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCLineRippleFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-line-ripple/constants.ts");
            var MDCLineRippleFoundation = /** @class */ function(_super) {
                __extends(MDCLineRippleFoundation, _super);
                function MDCLineRippleFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCLineRippleFoundation.defaultAdapter), adapter)) || this;
                    _this.transitionEndHandler_ = function(evt) {
                        return _this.handleTransitionEnd(evt);
                    };
                    return _this;
                }
                Object.defineProperty(MDCLineRippleFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCLineRippleFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCLineRippleAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            setStyle: function setStyle() {
                                return undefined;
                            },
                            registerEventHandler: function registerEventHandler() {
                                return undefined;
                            },
                            deregisterEventHandler: function deregisterEventHandler() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCLineRippleFoundation.prototype.init = function() {
                    this.adapter.registerEventHandler("transitionend", this.transitionEndHandler_);
                };
                MDCLineRippleFoundation.prototype.destroy = function() {
                    this.adapter.deregisterEventHandler("transitionend", this.transitionEndHandler_);
                };
                MDCLineRippleFoundation.prototype.activate = function() {
                    this.adapter.removeClass(constants_1.cssClasses.LINE_RIPPLE_DEACTIVATING);
                    this.adapter.addClass(constants_1.cssClasses.LINE_RIPPLE_ACTIVE);
                };
                MDCLineRippleFoundation.prototype.setRippleCenter = function(xCoordinate) {
                    this.adapter.setStyle("transform-origin", xCoordinate + "px center");
                };
                MDCLineRippleFoundation.prototype.deactivate = function() {
                    this.adapter.addClass(constants_1.cssClasses.LINE_RIPPLE_DEACTIVATING);
                };
                MDCLineRippleFoundation.prototype.handleTransitionEnd = function(evt) {
                    // Wait for the line ripple to be either transparent or opaque
                    // before emitting the animation end event
                    var isDeactivating = this.adapter.hasClass(constants_1.cssClasses.LINE_RIPPLE_DEACTIVATING);
                    if (evt.propertyName === "opacity") {
                        if (isDeactivating) {
                            this.adapter.removeClass(constants_1.cssClasses.LINE_RIPPLE_ACTIVE);
                            this.adapter.removeClass(constants_1.cssClasses.LINE_RIPPLE_DEACTIVATING);
                        }
                    }
                };
                return MDCLineRippleFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCLineRippleFoundation = MDCLineRippleFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCLineRippleFoundation;
        /***/ },
        /***/ "./packages/mdc-linear-progress/component.ts": /*!***************************************************!*\
  !*** ./packages/mdc-linear-progress/component.ts ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCLinearProgress = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-linear-progress/foundation.ts");
            var MDCLinearProgress = /** @class */ function(_super) {
                __extends(MDCLinearProgress, _super);
                function MDCLinearProgress() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCLinearProgress.attachTo = function(root) {
                    return new MDCLinearProgress(root);
                };
                Object.defineProperty(MDCLinearProgress.prototype, "determinate", {
                    set: function set(value) {
                        this.foundation.setDeterminate(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCLinearProgress.prototype, "progress", {
                    set: function set(value) {
                        this.foundation.setProgress(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCLinearProgress.prototype, "buffer", {
                    set: function set(value) {
                        this.foundation.setBuffer(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCLinearProgress.prototype.open = function() {
                    this.foundation.open();
                };
                MDCLinearProgress.prototype.close = function() {
                    this.foundation.close();
                };
                MDCLinearProgress.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.root.addEventListener("transitionend", function() {
                        _this.foundation.handleTransitionEnd();
                    });
                };
                MDCLinearProgress.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take
                    // a Partial<MDCFooAdapter>. To ensure we don't accidentally omit any
                    // methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClass: function addClass(className) {
                            _this.root.classList.add(className);
                        },
                        forceLayout: function forceLayout() {
                            _this.root.getBoundingClientRect();
                        },
                        setBufferBarStyle: function setBufferBarStyle(styleProperty, value) {
                            var bufferBar = _this.root.querySelector(foundation_1.MDCLinearProgressFoundation.strings.BUFFER_BAR_SELECTOR);
                            if (bufferBar) bufferBar.style.setProperty(styleProperty, value);
                        },
                        setPrimaryBarStyle: function setPrimaryBarStyle(styleProperty, value) {
                            var primaryBar = _this.root.querySelector(foundation_1.MDCLinearProgressFoundation.strings.PRIMARY_BAR_SELECTOR);
                            if (primaryBar) primaryBar.style.setProperty(styleProperty, value);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        removeAttribute: function removeAttribute(attributeName) {
                            _this.root.removeAttribute(attributeName);
                        },
                        removeClass: function removeClass(className) {
                            _this.root.classList.remove(className);
                        },
                        setAttribute: function setAttribute(attributeName, value) {
                            _this.root.setAttribute(attributeName, value);
                        },
                        setStyle: function setStyle(name, value) {
                            _this.root.style.setProperty(name, value);
                        },
                        attachResizeObserver: function attachResizeObserver(callback) {
                            var RO = window.ResizeObserver;
                            if (RO) {
                                var ro = new RO(callback);
                                ro.observe(_this.root);
                                return ro;
                            }
                            return null;
                        },
                        getWidth: function getWidth() {
                            return _this.root.offsetWidth;
                        }
                    };
                    return new foundation_1.MDCLinearProgressFoundation(adapter);
                };
                return MDCLinearProgress;
            }(component_1.MDCComponent);
            exports.MDCLinearProgress = MDCLinearProgress;
        /***/ },
        /***/ "./packages/mdc-linear-progress/constants.ts": /*!***************************************************!*\
  !*** ./packages/mdc-linear-progress/constants.ts ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.animationDimensionPercentages = exports.strings = exports.cssClasses = void 0;
            exports.cssClasses = {
                CLOSED_CLASS: "mdc-linear-progress--closed",
                CLOSED_ANIMATION_OFF_CLASS: "mdc-linear-progress--closed-animation-off",
                INDETERMINATE_CLASS: "mdc-linear-progress--indeterminate",
                REVERSED_CLASS: "mdc-linear-progress--reversed",
                ANIMATION_READY_CLASS: "mdc-linear-progress--animation-ready"
            };
            exports.strings = {
                ARIA_HIDDEN: "aria-hidden",
                ARIA_VALUEMAX: "aria-valuemax",
                ARIA_VALUEMIN: "aria-valuemin",
                ARIA_VALUENOW: "aria-valuenow",
                BUFFER_BAR_SELECTOR: ".mdc-linear-progress__buffer-bar",
                FLEX_BASIS: "flex-basis",
                PRIMARY_BAR_SELECTOR: ".mdc-linear-progress__primary-bar"
            };
            // these are percentages pulled from keyframes.scss
            exports.animationDimensionPercentages = {
                PRIMARY_HALF: .8367142,
                PRIMARY_FULL: 2.00611057,
                SECONDARY_QUARTER: .37651913,
                SECONDARY_HALF: .84386165,
                SECONDARY_FULL: 1.60277782
            };
        /***/ },
        /***/ "./packages/mdc-linear-progress/custom-element.js": /*!********************************************************!*\
  !*** ./packages/mdc-linear-progress/custom-element.js ***!
  \********************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-linear-progress/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcLinearProgress = function(_HTMLElement) {
                _inherits(MdcLinearProgress, _HTMLElement);
                _createClass(MdcLinearProgress, [
                    {
                        key: "determinate",
                        get: function get() {
                            return this.determinate_;
                        },
                        set: function set(determinate) {
                            this.determinate_ = determinate;
                            if (!!this.linearProgress_) this.linearProgress_.determinate = determinate;
                        }
                    },
                    {
                        key: "progress",
                        get: function get() {
                            return this.progress_;
                        },
                        set: function set(progress) {
                            this.progress_ = progress;
                            if (!!this.linearProgress_) this.linearProgress_.progress = progress;
                        }
                    },
                    {
                        key: "buffer",
                        get: function get() {
                            return this.buffer_;
                        },
                        set: function set(buffer) {
                            this.buffer_ = buffer;
                            if (!!this.linearProgress_) this.linearProgress_.buffer = buffer;
                        }
                    },
                    {
                        key: "closed",
                        get: function get() {
                            return this.closed_;
                        },
                        set: function set(closed) {
                            this.closed_ = closed;
                            if (!!this.linearProgress_) {
                                if (closed) this.linearProgress_.close();
                                else this.linearProgress_.open();
                            }
                        }
                    }
                ]);
                function MdcLinearProgress() {
                    _classCallCheck(this, MdcLinearProgress);
                    var _this = _possibleConstructorReturn(this, (MdcLinearProgress.__proto__ || Object.getPrototypeOf(MdcLinearProgress)).call(this));
                    _this.determinate_ = false;
                    _this.progress_ = 0;
                    _this.buffer_ = 1;
                    _this.closed_ = false;
                    _this.linearProgress_;
                    return _this;
                }
                _createClass(MdcLinearProgress, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.linearProgress_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCLinearProgress"](this);
                            this.linearProgress_.determinate = this.determinate_;
                            this.linearProgress_.progress = this.progress_;
                            this.linearProgress_.buffer = this.buffer_;
                            if (this.closed_) this.linearProgress_.close();
                            else this.linearProgress_.open();
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.linearProgress_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcLinearProgress;
            }(HTMLElement);
            customElements.define("mdc-linear-progress", MdcLinearProgress);
        /***/ },
        /***/ "./packages/mdc-linear-progress/foundation.ts": /*!****************************************************!*\
  !*** ./packages/mdc-linear-progress/foundation.ts ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __values = this && this.__values || function(o) {
                var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
                if (m) return m.call(o);
                if (o && typeof o.length === "number") return {
                    next: function next() {
                        if (o && i >= o.length) o = void 0;
                        return {
                            value: o && o[i++],
                            done: !o
                        };
                    }
                };
                throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCLinearProgressFoundation = void 0;
            var util_1 = __webpack_require__(/*! @material/animation/util */ "./packages/mdc-animation/util.ts");
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-linear-progress/constants.ts");
            var MDCLinearProgressFoundation = /** @class */ function(_super) {
                __extends(MDCLinearProgressFoundation, _super);
                function MDCLinearProgressFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCLinearProgressFoundation.defaultAdapter), adapter)) || this;
                    _this.observer = null;
                    return _this;
                }
                Object.defineProperty(MDCLinearProgressFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCLinearProgressFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCLinearProgressFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            attachResizeObserver: function attachResizeObserver() {
                                return null;
                            },
                            forceLayout: function forceLayout() {
                                return undefined;
                            },
                            getWidth: function getWidth() {
                                return 0;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            setBufferBarStyle: function setBufferBarStyle() {
                                return null;
                            },
                            setPrimaryBarStyle: function setPrimaryBarStyle() {
                                return null;
                            },
                            setStyle: function setStyle() {
                                return undefined;
                            },
                            removeAttribute: function removeAttribute() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            setAttribute: function setAttribute() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCLinearProgressFoundation.prototype.init = function() {
                    var _this = this;
                    this.determinate = !this.adapter.hasClass(constants_1.cssClasses.INDETERMINATE_CLASS);
                    this.adapter.addClass(constants_1.cssClasses.ANIMATION_READY_CLASS);
                    this.progress = 0;
                    this.buffer = 1;
                    this.observer = this.adapter.attachResizeObserver(function(entries) {
                        var e_1, _a;
                        if (_this.determinate) return;
                        try {
                            for(var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()){
                                var entry = entries_1_1.value;
                                if (entry.contentRect) _this.calculateAndSetDimensions(entry.contentRect.width);
                            }
                        } catch (e_1_1) {
                            e_1 = {
                                error: e_1_1
                            };
                        } finally{
                            try {
                                if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                        }
                    });
                    if (!this.determinate && this.observer) this.calculateAndSetDimensions(this.adapter.getWidth());
                };
                MDCLinearProgressFoundation.prototype.setDeterminate = function(isDeterminate) {
                    this.determinate = isDeterminate;
                    if (this.determinate) {
                        this.adapter.removeClass(constants_1.cssClasses.INDETERMINATE_CLASS);
                        this.adapter.setAttribute(constants_1.strings.ARIA_VALUENOW, this.progress.toString());
                        this.adapter.setAttribute(constants_1.strings.ARIA_VALUEMAX, "1");
                        this.adapter.setAttribute(constants_1.strings.ARIA_VALUEMIN, "0");
                        this.setPrimaryBarProgress(this.progress);
                        this.setBufferBarProgress(this.buffer);
                        return;
                    }
                    if (this.observer) this.calculateAndSetDimensions(this.adapter.getWidth());
                    this.adapter.addClass(constants_1.cssClasses.INDETERMINATE_CLASS);
                    this.adapter.removeAttribute(constants_1.strings.ARIA_VALUENOW);
                    this.adapter.removeAttribute(constants_1.strings.ARIA_VALUEMAX);
                    this.adapter.removeAttribute(constants_1.strings.ARIA_VALUEMIN);
                    this.setPrimaryBarProgress(1);
                    this.setBufferBarProgress(1);
                };
                MDCLinearProgressFoundation.prototype.isDeterminate = function() {
                    return this.determinate;
                };
                MDCLinearProgressFoundation.prototype.setProgress = function(value) {
                    this.progress = value;
                    if (this.determinate) {
                        this.setPrimaryBarProgress(value);
                        this.adapter.setAttribute(constants_1.strings.ARIA_VALUENOW, value.toString());
                    }
                };
                MDCLinearProgressFoundation.prototype.getProgress = function() {
                    return this.progress;
                };
                MDCLinearProgressFoundation.prototype.setBuffer = function(value) {
                    this.buffer = value;
                    if (this.determinate) this.setBufferBarProgress(value);
                };
                MDCLinearProgressFoundation.prototype.getBuffer = function() {
                    return this.buffer;
                };
                MDCLinearProgressFoundation.prototype.open = function() {
                    this.adapter.removeClass(constants_1.cssClasses.CLOSED_CLASS);
                    this.adapter.removeClass(constants_1.cssClasses.CLOSED_ANIMATION_OFF_CLASS);
                    this.adapter.removeAttribute(constants_1.strings.ARIA_HIDDEN);
                };
                MDCLinearProgressFoundation.prototype.close = function() {
                    this.adapter.addClass(constants_1.cssClasses.CLOSED_CLASS);
                    this.adapter.setAttribute(constants_1.strings.ARIA_HIDDEN, "true");
                };
                MDCLinearProgressFoundation.prototype.isClosed = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.CLOSED_CLASS);
                };
                /**
     * Handles the transitionend event emitted after `close()` is called and the
     * opacity fades out. This is so that animations are removed only after the
     * progress indicator is completely hidden.
     */ MDCLinearProgressFoundation.prototype.handleTransitionEnd = function() {
                    if (this.adapter.hasClass(constants_1.cssClasses.CLOSED_CLASS)) this.adapter.addClass(constants_1.cssClasses.CLOSED_ANIMATION_OFF_CLASS);
                };
                MDCLinearProgressFoundation.prototype.destroy = function() {
                    _super.prototype.destroy.call(this);
                    if (this.observer) this.observer.disconnect();
                };
                MDCLinearProgressFoundation.prototype.restartAnimation = function() {
                    this.adapter.removeClass(constants_1.cssClasses.ANIMATION_READY_CLASS);
                    this.adapter.forceLayout();
                    this.adapter.addClass(constants_1.cssClasses.ANIMATION_READY_CLASS);
                };
                MDCLinearProgressFoundation.prototype.setPrimaryBarProgress = function(progressValue) {
                    var value = "scaleX(" + progressValue + ")";
                    // Accessing `window` without a `typeof` check will throw on Node
                    // environments.
                    var transformProp = typeof window !== "undefined" ? util_1.getCorrectPropertyName(window, "transform") : "transform";
                    this.adapter.setPrimaryBarStyle(transformProp, value);
                };
                MDCLinearProgressFoundation.prototype.setBufferBarProgress = function(progressValue) {
                    var value = progressValue * 100 + "%";
                    this.adapter.setBufferBarStyle(constants_1.strings.FLEX_BASIS, value);
                };
                MDCLinearProgressFoundation.prototype.calculateAndSetDimensions = function(width) {
                    var primaryHalf = width * constants_1.animationDimensionPercentages.PRIMARY_HALF;
                    var primaryFull = width * constants_1.animationDimensionPercentages.PRIMARY_FULL;
                    var secondaryQuarter = width * constants_1.animationDimensionPercentages.SECONDARY_QUARTER;
                    var secondaryHalf = width * constants_1.animationDimensionPercentages.SECONDARY_HALF;
                    var secondaryFull = width * constants_1.animationDimensionPercentages.SECONDARY_FULL;
                    this.adapter.setStyle("--mdc-linear-progress-primary-half", primaryHalf + "px");
                    this.adapter.setStyle("--mdc-linear-progress-primary-half-neg", -primaryHalf + "px");
                    this.adapter.setStyle("--mdc-linear-progress-primary-full", primaryFull + "px");
                    this.adapter.setStyle("--mdc-linear-progress-primary-full-neg", -primaryFull + "px");
                    this.adapter.setStyle("--mdc-linear-progress-secondary-quarter", secondaryQuarter + "px");
                    this.adapter.setStyle("--mdc-linear-progress-secondary-quarter-neg", -secondaryQuarter + "px");
                    this.adapter.setStyle("--mdc-linear-progress-secondary-half", secondaryHalf + "px");
                    this.adapter.setStyle("--mdc-linear-progress-secondary-half-neg", -secondaryHalf + "px");
                    this.adapter.setStyle("--mdc-linear-progress-secondary-full", secondaryFull + "px");
                    this.adapter.setStyle("--mdc-linear-progress-secondary-full-neg", -secondaryFull + "px");
                    // need to restart animation for custom props to apply to keyframes
                    this.restartAnimation();
                };
                return MDCLinearProgressFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCLinearProgressFoundation = MDCLinearProgressFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCLinearProgressFoundation;
        /***/ },
        /***/ "./packages/mdc-list/component.ts": /*!****************************************!*\
  !*** ./packages/mdc-list/component.ts ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCList = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-list/constants.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-list/foundation.ts");
            var MDCList = /** @class */ function(_super) {
                __extends(MDCList, _super);
                function MDCList() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(MDCList.prototype, "vertical", {
                    set: function set(value) {
                        this.foundation.setVerticalOrientation(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCList.prototype, "listElements", {
                    get: function get() {
                        return Array.from(this.root.querySelectorAll("." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_CLASS]));
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCList.prototype, "wrapFocus", {
                    set: function set(value) {
                        this.foundation.setWrapFocus(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCList.prototype, "typeaheadInProgress", {
                    /**
         * @return Whether typeahead is currently matching a user-specified prefix.
         */ get: function get() {
                        return this.foundation.isTypeaheadInProgress();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCList.prototype, "hasTypeahead", {
                    /**
         * Sets whether typeahead functionality is enabled on the list.
         * @param hasTypeahead Whether typeahead is enabled.
         */ set: function set(hasTypeahead) {
                        this.foundation.setHasTypeahead(hasTypeahead);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCList.prototype, "singleSelection", {
                    set: function set(isSingleSelectionList) {
                        this.foundation.setSingleSelection(isSingleSelectionList);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCList.prototype, "selectedIndex", {
                    get: function get() {
                        return this.foundation.getSelectedIndex();
                    },
                    set: function set(index) {
                        this.foundation.setSelectedIndex(index);
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCList.attachTo = function(root) {
                    return new MDCList(root);
                };
                MDCList.prototype.initialSyncWithDOM = function() {
                    this.isEvolutionEnabled = constants_1.evolutionAttribute in this.root.dataset;
                    if (this.isEvolutionEnabled) this.classNameMap = constants_1.evolutionClassNameMap;
                    else if (ponyfill_1.matches(this.root, constants_1.strings.DEPRECATED_SELECTOR)) this.classNameMap = constants_1.deprecatedClassNameMap;
                    else this.classNameMap = Object.values(constants_1.cssClasses).reduce(function(obj, className) {
                        obj[className] = className;
                        return obj;
                    }, {});
                    this.handleClick = this.handleClickEvent.bind(this);
                    this.handleKeydown = this.handleKeydownEvent.bind(this);
                    this.focusInEventListener = this.handleFocusInEvent.bind(this);
                    this.focusOutEventListener = this.handleFocusOutEvent.bind(this);
                    this.listen("keydown", this.handleKeydown);
                    this.listen("click", this.handleClick);
                    this.listen("focusin", this.focusInEventListener);
                    this.listen("focusout", this.focusOutEventListener);
                    this.layout();
                    this.initializeListType();
                    this.ensureFocusable();
                };
                MDCList.prototype.destroy = function() {
                    this.unlisten("keydown", this.handleKeydown);
                    this.unlisten("click", this.handleClick);
                    this.unlisten("focusin", this.focusInEventListener);
                    this.unlisten("focusout", this.focusOutEventListener);
                };
                MDCList.prototype.layout = function() {
                    var direction = this.root.getAttribute(constants_1.strings.ARIA_ORIENTATION);
                    this.vertical = direction !== constants_1.strings.ARIA_ORIENTATION_HORIZONTAL;
                    var itemSelector = "." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_CLASS] + ":not([tabindex])";
                    var childSelector = constants_1.strings.FOCUSABLE_CHILD_ELEMENTS;
                    // List items need to have at least tabindex=-1 to be focusable.
                    var itemEls = this.root.querySelectorAll(itemSelector);
                    if (itemEls.length) Array.prototype.forEach.call(itemEls, function(el) {
                        el.setAttribute("tabindex", "-1");
                    });
                    // Child button/a elements are not tabbable until the list item is focused.
                    var focusableChildEls = this.root.querySelectorAll(childSelector);
                    if (focusableChildEls.length) Array.prototype.forEach.call(focusableChildEls, function(el) {
                        el.setAttribute("tabindex", "-1");
                    });
                    if (this.isEvolutionEnabled) this.foundation.setUseSelectedAttribute(true);
                    this.foundation.layout();
                };
                /**
     * Extracts the primary text from a list item.
     * @param item The list item element.
     * @return The primary text in the element.
     */ MDCList.prototype.getPrimaryText = function(item) {
                    var _a;
                    var primaryText = item.querySelector("." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_PRIMARY_TEXT_CLASS]);
                    if (this.isEvolutionEnabled || primaryText) return (_a = primaryText === null || primaryText === void 0 ? void 0 : primaryText.textContent) !== null && _a !== void 0 ? _a : "";
                    var singleLineText = item.querySelector("." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_TEXT_CLASS]);
                    return singleLineText && singleLineText.textContent || "";
                };
                /**
     * Initialize selectedIndex value based on pre-selected list items.
     */ MDCList.prototype.initializeListType = function() {
                    var _this = this;
                    this.isInteractive = ponyfill_1.matches(this.root, constants_1.strings.ARIA_INTERACTIVE_ROLES_SELECTOR);
                    if (this.isEvolutionEnabled && this.isInteractive) {
                        var selection = Array.from(this.root.querySelectorAll(constants_1.strings.SELECTED_ITEM_SELECTOR), function(listItem) {
                            return _this.listElements.indexOf(listItem);
                        });
                        if (ponyfill_1.matches(this.root, constants_1.strings.ARIA_MULTI_SELECTABLE_SELECTOR)) this.selectedIndex = selection;
                        else if (selection.length > 0) this.selectedIndex = selection[0];
                        return;
                    }
                    var checkboxListItems = this.root.querySelectorAll(constants_1.strings.ARIA_ROLE_CHECKBOX_SELECTOR);
                    var radioSelectedListItem = this.root.querySelector(constants_1.strings.ARIA_CHECKED_RADIO_SELECTOR);
                    if (checkboxListItems.length) {
                        var preselectedItems = this.root.querySelectorAll(constants_1.strings.ARIA_CHECKED_CHECKBOX_SELECTOR);
                        this.selectedIndex = Array.from(preselectedItems, function(listItem) {
                            return _this.listElements.indexOf(listItem);
                        });
                    } else if (radioSelectedListItem) this.selectedIndex = this.listElements.indexOf(radioSelectedListItem);
                };
                /**
     * Updates the list item at itemIndex to the desired isEnabled state.
     * @param itemIndex Index of the list item
     * @param isEnabled Sets the list item to enabled or disabled.
     */ MDCList.prototype.setEnabled = function(itemIndex, isEnabled) {
                    this.foundation.setEnabled(itemIndex, isEnabled);
                };
                /**
     * Given the next desired character from the user, adds it to the typeahead
     * buffer. Then, attempts to find the next option matching the buffer. Wraps
     * around if at the end of options.
     *
     * @param nextChar The next character to add to the prefix buffer.
     * @param startingIndex The index from which to start matching. Defaults to
     *     the currently focused index.
     * @return The index of the matched item.
     */ MDCList.prototype.typeaheadMatchItem = function(nextChar, startingIndex) {
                    return this.foundation.typeaheadMatchItem(nextChar, startingIndex, /** skipFocus */ true);
                };
                MDCList.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take
                    // a Partial<MDCFooAdapter>. To ensure we don't accidentally omit any
                    // methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClassForElementIndex: function addClassForElementIndex(index, className) {
                            var element = _this.listElements[index];
                            if (element) element.classList.add(_this.classNameMap[className]);
                        },
                        focusItemAtIndex: function focusItemAtIndex(index) {
                            var element = _this.listElements[index];
                            if (element) element.focus();
                        },
                        getAttributeForElementIndex: function getAttributeForElementIndex(index, attr) {
                            return _this.listElements[index].getAttribute(attr);
                        },
                        getFocusedElementIndex: function getFocusedElementIndex() {
                            return _this.listElements.indexOf(document.activeElement);
                        },
                        getListItemCount: function getListItemCount() {
                            return _this.listElements.length;
                        },
                        getPrimaryTextAtIndex: function getPrimaryTextAtIndex(index) {
                            return _this.getPrimaryText(_this.listElements[index]);
                        },
                        hasCheckboxAtIndex: function hasCheckboxAtIndex(index) {
                            var listItem = _this.listElements[index];
                            return !!listItem.querySelector(constants_1.strings.CHECKBOX_SELECTOR);
                        },
                        hasRadioAtIndex: function hasRadioAtIndex(index) {
                            var listItem = _this.listElements[index];
                            return !!listItem.querySelector(constants_1.strings.RADIO_SELECTOR);
                        },
                        isCheckboxCheckedAtIndex: function isCheckboxCheckedAtIndex(index) {
                            var listItem = _this.listElements[index];
                            var toggleEl = listItem.querySelector(constants_1.strings.CHECKBOX_SELECTOR + ", " + constants_1.strings.RADIO_SELECTOR);
                            return toggleEl.checked;
                        },
                        isFocusInsideList: function isFocusInsideList() {
                            return _this.root !== document.activeElement && _this.root.contains(document.activeElement);
                        },
                        isRootFocused: function isRootFocused() {
                            return document.activeElement === _this.root;
                        },
                        listItemAtIndexHasClass: function listItemAtIndexHasClass(index, className) {
                            return _this.listElements[index].classList.contains(_this.classNameMap[className]);
                        },
                        notifyAction: function notifyAction(index) {
                            _this.emit(constants_1.strings.ACTION_EVENT, {
                                index: index
                            }, /** shouldBubble */ true);
                        },
                        removeClassForElementIndex: function removeClassForElementIndex(index, className) {
                            var element = _this.listElements[index];
                            if (element) element.classList.remove(_this.classNameMap[className]);
                        },
                        setAttributeForElementIndex: function setAttributeForElementIndex(index, attr, value) {
                            var element = _this.listElements[index];
                            if (element) element.setAttribute(attr, value);
                        },
                        setCheckedCheckboxOrRadioAtIndex: function setCheckedCheckboxOrRadioAtIndex(index) {
                            var listItem = _this.listElements[index];
                            var toggleEl = listItem.querySelector(constants_1.strings.CHECKBOX_RADIO_SELECTOR);
                            var event = document.createEvent("Event");
                            event.initEvent("change", true, true);
                            toggleEl.dispatchEvent(event);
                        },
                        setTabIndexForListItemChildren: function setTabIndexForListItemChildren(listItemIndex, tabIndexValue) {
                            var element = _this.listElements[listItemIndex];
                            var selector = constants_1.strings.CHILD_ELEMENTS_TO_TOGGLE_TABINDEX;
                            Array.prototype.forEach.call(element.querySelectorAll(selector), function(el) {
                                el.setAttribute("tabindex", tabIndexValue);
                            });
                        }
                    };
                    return new foundation_1.MDCListFoundation(adapter);
                };
                /**
     * Ensures that at least one item is focusable if the list is interactive and
     * doesn't specify a suitable tabindex.
     */ MDCList.prototype.ensureFocusable = function() {
                    if (this.isEvolutionEnabled && this.isInteractive) {
                        if (!this.root.querySelector("." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_CLASS] + '[tabindex="0"]')) {
                            var index = this.initialFocusIndex();
                            if (index !== -1) this.listElements[index].tabIndex = 0;
                        }
                    }
                };
                MDCList.prototype.initialFocusIndex = function() {
                    if (this.selectedIndex instanceof Array && this.selectedIndex.length > 0) return this.selectedIndex[0];
                    if (typeof this.selectedIndex === "number" && this.selectedIndex !== constants_1.numbers.UNSET_INDEX) return this.selectedIndex;
                    var el = this.root.querySelector("." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_CLASS] + ":not(." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS] + ")");
                    if (el === null) return -1;
                    return this.getListItemIndex(el);
                };
                /**
     * Used to figure out which list item this event is targetting. Or returns -1
     * if there is no list item
     */ MDCList.prototype.getListItemIndex = function(el) {
                    var nearestParent = ponyfill_1.closest(el, "." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_CLASS] + ", ." + this.classNameMap[constants_1.cssClasses.ROOT]);
                    // Get the index of the element if it is a list item.
                    if (nearestParent && ponyfill_1.matches(nearestParent, "." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_CLASS])) return this.listElements.indexOf(nearestParent);
                    return -1;
                };
                /**
     * Used to figure out which element was clicked before sending the event to
     * the foundation.
     */ MDCList.prototype.handleFocusInEvent = function(evt) {
                    var index = this.getListItemIndex(evt.target);
                    this.foundation.handleFocusIn(evt, index);
                };
                /**
     * Used to figure out which element was clicked before sending the event to
     * the foundation.
     */ MDCList.prototype.handleFocusOutEvent = function(evt) {
                    var index = this.getListItemIndex(evt.target);
                    this.foundation.handleFocusOut(evt, index);
                };
                /**
     * Used to figure out which element was focused when keydown event occurred
     * before sending the event to the foundation.
     */ MDCList.prototype.handleKeydownEvent = function(evt) {
                    var index = this.getListItemIndex(evt.target);
                    var target = evt.target;
                    this.foundation.handleKeydown(evt, target.classList.contains(this.classNameMap[constants_1.cssClasses.LIST_ITEM_CLASS]), index);
                };
                /**
     * Used to figure out which element was clicked before sending the event to
     * the foundation.
     */ MDCList.prototype.handleClickEvent = function(evt) {
                    var index = this.getListItemIndex(evt.target);
                    var target = evt.target;
                    // Toggle the checkbox only if it's not the target of the event, or the
                    // checkbox will have 2 change events.
                    var toggleCheckbox = !ponyfill_1.matches(target, constants_1.strings.CHECKBOX_RADIO_SELECTOR);
                    this.foundation.handleClick(index, toggleCheckbox);
                };
                return MDCList;
            }(component_1.MDCComponent);
            exports.MDCList = MDCList;
        /***/ },
        /***/ "./packages/mdc-list/constants.ts": /*!****************************************!*\
  !*** ./packages/mdc-list/constants.ts ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var _a, _b;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.evolutionClassNameMap = exports.evolutionAttribute = exports.deprecatedClassNameMap = exports.numbers = exports.cssClasses = exports.strings = void 0;
            var cssClasses = {
                LIST_ITEM_ACTIVATED_CLASS: "mdc-list-item--activated",
                LIST_ITEM_CLASS: "mdc-list-item",
                LIST_ITEM_DISABLED_CLASS: "mdc-list-item--disabled",
                LIST_ITEM_SELECTED_CLASS: "mdc-list-item--selected",
                LIST_ITEM_TEXT_CLASS: "mdc-list-item__text",
                LIST_ITEM_PRIMARY_TEXT_CLASS: "mdc-list-item__primary-text",
                ROOT: "mdc-list"
            };
            exports.cssClasses = cssClasses;
            var evolutionClassNameMap = (_a = {}, _a["" + cssClasses.LIST_ITEM_ACTIVATED_CLASS] = "mdc-list-item--activated", _a["" + cssClasses.LIST_ITEM_CLASS] = "mdc-list-item", _a["" + cssClasses.LIST_ITEM_DISABLED_CLASS] = "mdc-list-item--disabled", _a["" + cssClasses.LIST_ITEM_SELECTED_CLASS] = "mdc-list-item--selected", _a["" + cssClasses.LIST_ITEM_PRIMARY_TEXT_CLASS] = "mdc-list-item__primary-text", _a["" + cssClasses.ROOT] = "mdc-list", _a);
            exports.evolutionClassNameMap = evolutionClassNameMap;
            var deprecatedClassNameMap = (_b = {}, _b["" + cssClasses.LIST_ITEM_ACTIVATED_CLASS] = "mdc-deprecated-list-item--activated", _b["" + cssClasses.LIST_ITEM_CLASS] = "mdc-deprecated-list-item", _b["" + cssClasses.LIST_ITEM_DISABLED_CLASS] = "mdc-deprecated-list-item--disabled", _b["" + cssClasses.LIST_ITEM_SELECTED_CLASS] = "mdc-deprecated-list-item--selected", _b["" + cssClasses.LIST_ITEM_TEXT_CLASS] = "mdc-deprecated-list-item__text", _b["" + cssClasses.LIST_ITEM_PRIMARY_TEXT_CLASS] = "mdc-deprecated-list-item__primary-text", _b["" + cssClasses.ROOT] = "mdc-deprecated-list", _b);
            exports.deprecatedClassNameMap = deprecatedClassNameMap;
            var strings = {
                ACTION_EVENT: "MDCList:action",
                ARIA_CHECKED: "aria-checked",
                ARIA_CHECKED_CHECKBOX_SELECTOR: '[role="checkbox"][aria-checked="true"]',
                ARIA_CHECKED_RADIO_SELECTOR: '[role="radio"][aria-checked="true"]',
                ARIA_CURRENT: "aria-current",
                ARIA_DISABLED: "aria-disabled",
                ARIA_ORIENTATION: "aria-orientation",
                ARIA_ORIENTATION_HORIZONTAL: "horizontal",
                ARIA_ROLE_CHECKBOX_SELECTOR: '[role="checkbox"]',
                ARIA_SELECTED: "aria-selected",
                ARIA_INTERACTIVE_ROLES_SELECTOR: '[role="listbox"], [role="menu"]',
                ARIA_MULTI_SELECTABLE_SELECTOR: '[aria-multiselectable="true"]',
                CHECKBOX_RADIO_SELECTOR: 'input[type="checkbox"], input[type="radio"]',
                CHECKBOX_SELECTOR: 'input[type="checkbox"]',
                CHILD_ELEMENTS_TO_TOGGLE_TABINDEX: "\n    ." + cssClasses.LIST_ITEM_CLASS + " button:not(:disabled),\n    ." + cssClasses.LIST_ITEM_CLASS + " a,\n    ." + deprecatedClassNameMap[cssClasses.LIST_ITEM_CLASS] + " button:not(:disabled),\n    ." + deprecatedClassNameMap[cssClasses.LIST_ITEM_CLASS] + " a\n  ",
                DEPRECATED_SELECTOR: ".mdc-deprecated-list",
                FOCUSABLE_CHILD_ELEMENTS: "\n    ." + cssClasses.LIST_ITEM_CLASS + " button:not(:disabled),\n    ." + cssClasses.LIST_ITEM_CLASS + " a,\n    ." + cssClasses.LIST_ITEM_CLASS + ' input[type="radio"]:not(:disabled),\n    .' + cssClasses.LIST_ITEM_CLASS + ' input[type="checkbox"]:not(:disabled),\n    .' + deprecatedClassNameMap[cssClasses.LIST_ITEM_CLASS] + " button:not(:disabled),\n    ." + deprecatedClassNameMap[cssClasses.LIST_ITEM_CLASS] + " a,\n    ." + deprecatedClassNameMap[cssClasses.LIST_ITEM_CLASS] + ' input[type="radio"]:not(:disabled),\n    .' + deprecatedClassNameMap[cssClasses.LIST_ITEM_CLASS] + ' input[type="checkbox"]:not(:disabled)\n  ',
                RADIO_SELECTOR: 'input[type="radio"]',
                SELECTED_ITEM_SELECTOR: '[aria-selected="true"], [aria-current="true"]'
            };
            exports.strings = strings;
            var numbers = {
                UNSET_INDEX: -1,
                TYPEAHEAD_BUFFER_CLEAR_TIMEOUT_MS: 300
            };
            exports.numbers = numbers;
            var evolutionAttribute = "evolution";
            exports.evolutionAttribute = evolutionAttribute;
        /***/ },
        /***/ "./packages/mdc-list/custom-element.js": /*!*********************************************!*\
  !*** ./packages/mdc-list/custom-element.js ***!
  \*********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-list/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_material_ripple_component__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcList = function(_HTMLElement) {
                _inherits(MdcList, _HTMLElement);
                _createClass(MdcList, [
                    {
                        key: "focus",
                        value: function focus() {
                            var selectedIndex = this.list_.foundation.getSelectedIndex();
                            if (typeof selectedIndex !== "number") selectedIndex = selectedIndex.length > 0 ? selectedIndex[0] : -1;
                            if (0 <= selectedIndex && selectedIndex < this.list_.listElements.length) this.list_.listElements[selectedIndex].focus();
                            else if (this.list_.listElements.length > 0) this.list_.listElements[0].focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            if (this.contains(document.activeElement)) document.activeElement.blur();
                        }
                    },
                    {
                        key: "selectedIndex",
                        get: function get() {
                            return this.selectedIndex_;
                        },
                        set: function set(selectedIndex) {
                            var previousSelectedIndex = this.selectedIndex_;
                            this.selectedIndex_ = selectedIndex;
                            if (this.list_) {
                                this.list_.selectedIndex = selectedIndex;
                                var previousIndex = previousSelectedIndex.length > 0 ? previousSelectedIndex[0] : -1;
                                if (previousIndex !== -1 && this.list_.listElements[previousIndex]) this.list_.listElements[previousIndex].setAttribute("tabindex", "-1");
                                if (selectedIndex.length > 0 && this.list_.listElements.length > selectedIndex[0]) this.list_.listElements[selectedIndex[0]].setAttribute("tabindex", "0");
                                else if (this.list_.listElements.length > 0) this.list_.listElements[0].setAttribute("tabindex", "0");
                            }
                        }
                    },
                    {
                        key: "vertical",
                        get: function get() {
                            return this.vertical_;
                        },
                        set: function set(vertical) {
                            this.vertical_ = vertical;
                            if (this.list_) this.list_.vertical = vertical;
                        }
                    },
                    {
                        key: "wrapFocus",
                        get: function get() {
                            return this.wrapFocus_;
                        },
                        set: function set(wrapFocus) {
                            this.wrapFocus_ = wrapFocus;
                            if (this.list_) this.list_.wrapFocus = wrapFocus;
                        }
                    },
                    {
                        key: "interactive",
                        get: function get() {
                            return this.interactive_;
                        },
                        set: function set(interactive) {
                            var oldInteractive = this.interactive_;
                            this.interactive_ = interactive;
                            if (oldInteractive !== interactive && this.init_) {
                                if (this.interactive_) this.initInteractive();
                                else this.deinitInteractive();
                            }
                        }
                    }
                ]);
                function MdcList() {
                    _classCallCheck(this, MdcList);
                    var _this = _possibleConstructorReturn(this, (MdcList.__proto__ || Object.getPrototypeOf(MdcList)).call(this));
                    _this.init_ = false;
                    _this.selectedIndex_ = -1;
                    _this.wrapFocus_ = false;
                    _this.vertical_ = true;
                    _this.interactive_ = false;
                    _this.list_;
                    return _this;
                }
                _createClass(MdcList, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.init();
                        }
                    },
                    {
                        key: "init",
                        value: function init() {
                            if (this.init_) return;
                            this.init_ = true;
                            this.style.display = "block";
                            this.style.pointerEvents = "none";
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_2__["installClassNameChangeHook"].call(this);
                            if (this.interactive_) this.initInteractive();
                        }
                    },
                    {
                        key: "initInteractive",
                        value: function initInteractive() {
                            if (this.list_) return;
                            this.style.pointerEvents = "auto";
                            this.list_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCList"](this);
                            this.list_.selectedIndex = this.selectedIndex_;
                            this.list_.vertical = this.vertical_;
                            this.list_.wrapFocus = this.wrapFocus_;
                            var firstSelectedListItem = this.querySelector(".mdc-deprecated-list-item--selected, .mdc-deprecated-list-item--activated");
                            if (firstSelectedListItem) firstSelectedListItem.setAttribute("tabindex", 0);
                            else {
                                var firstListItem = this.querySelector(".mdc-deprecated-list-item");
                                if (firstListItem) firstListItem.setAttribute("tabindex", 0);
                            }
                        }
                    },
                    {
                        key: "deinitInteractive",
                        value: function deinitInteractive() {
                            if (!this.list_) return;
                            this.style.pointerEvents = "none";
                            this.list_.destroy();
                            delete this.list_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.deinitInteractive();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_2__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcList;
            }(HTMLElement);
            customElements.define("mdc-list", MdcList);
            var MdcListItem = function(_HTMLElement2) {
                _inherits(MdcListItem, _HTMLElement2);
                function MdcListItem() {
                    _classCallCheck(this, MdcListItem);
                    var _this2 = _possibleConstructorReturn(this, (MdcListItem.__proto__ || Object.getPrototypeOf(MdcListItem)).call(this));
                    _this2.ripples_ = false;
                    _this2.init_ = false;
                    _this2.ripple_;
                    return _this2;
                }
                _createClass(MdcListItem, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.init();
                        }
                    },
                    {
                        key: "init",
                        value: function init() {
                            if (this.init_) return;
                            this.init_ = true;
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_2__["installClassNameChangeHook"].call(this.listItemElement);
                            if (this.ripples_) this.initRipple();
                        }
                    },
                    {
                        key: "initRipple",
                        value: function initRipple() {
                            if (this.ripple_) return;
                            this.ripple_ = new _material_ripple_component__WEBPACK_IMPORTED_MODULE_1__["MDCRipple"](this.listItemElement);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.deinitRipple();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_2__["uninstallClassNameChangeHook"].call(this.listItemElement);
                        }
                    },
                    {
                        key: "deinitRipple",
                        value: function deinitRipple() {
                            if (!this.ripple_) return;
                            this.ripple_.destroy();
                            delete this.ripple_;
                        }
                    },
                    {
                        key: "ripples",
                        set: function set(ripples) {
                            var oldRipples = this.ripples_;
                            this.ripples_ = ripples;
                            if (oldRipples !== this.ripples_ && this.init_) {
                                if (this.ripples_) this.initRipple();
                                else this.dinitRipple();
                            }
                        },
                        get: function get() {
                            return this.ripples_;
                        }
                    },
                    {
                        key: "listItemElement",
                        get: function get() {
                            return this.classList.contains("mdc-deprecated-list-item") ? this : this.querySelector(".mdc-deprecated-list-item");
                        }
                    }
                ]);
                return MdcListItem;
            }(HTMLElement);
            customElements.define("mdc-list-item", MdcListItem);
        /***/ },
        /***/ "./packages/mdc-list/events.ts": /*!*************************************!*\
  !*** ./packages/mdc-list/events.ts ***!
  \*************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.preventDefaultEvent = void 0;
            var ELEMENTS_KEY_ALLOWED_IN = [
                "input",
                "button",
                "textarea",
                "select"
            ];
            /**
 * Ensures that preventDefault is only called if the containing element
 * doesn't consume the event, and it will cause an unintended scroll.
 *
 * @param evt keyboard event to be prevented.
 */ var preventDefaultEvent = function preventDefaultEvent(evt) {
                var target = evt.target;
                if (!target) return;
                var tagName = ("" + target.tagName).toLowerCase();
                if (ELEMENTS_KEY_ALLOWED_IN.indexOf(tagName) === -1) evt.preventDefault();
            };
            exports.preventDefaultEvent = preventDefaultEvent;
        /***/ },
        /***/ "./packages/mdc-list/foundation.ts": /*!*****************************************!*\
  !*** ./packages/mdc-list/foundation.ts ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                Object.defineProperty(o, k2, {
                    enumerable: true,
                    get: function get() {
                        return m[k];
                    }
                });
            } : function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
            });
            var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                Object.defineProperty(o, "default", {
                    enumerable: true,
                    value: v
                });
            } : function(o, v) {
                o["default"] = v;
            });
            var __importStar = this && this.__importStar || function(mod) {
                if (mod && mod.__esModule) return mod;
                var result = {};
                if (mod != null) {
                    for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                }
                __setModuleDefault(result, mod);
                return result;
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCListFoundation = void 0;
            // TODO(b/152410470): Remove trailing underscores from private properties
            // tslint:disable:strip-private-property-underscore
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var keyboard_1 = __webpack_require__(/*! @material/dom/keyboard */ "./packages/mdc-dom/keyboard.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-list/constants.ts");
            var events_1 = __webpack_require__(/*! ./events */ "./packages/mdc-list/events.ts");
            var typeahead = __importStar(__webpack_require__(/*! ./typeahead */ "./packages/mdc-list/typeahead.ts"));
            function isNumberArray(selectedIndex) {
                return selectedIndex instanceof Array;
            }
            var MDCListFoundation = /** @class */ function(_super) {
                __extends(MDCListFoundation, _super);
                function MDCListFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCListFoundation.defaultAdapter), adapter)) || this;
                    _this.wrapFocus_ = false;
                    _this.isVertical_ = true;
                    _this.isSingleSelectionList_ = false;
                    _this.selectedIndex_ = constants_1.numbers.UNSET_INDEX;
                    _this.focusedItemIndex = constants_1.numbers.UNSET_INDEX;
                    _this.useSelectedAttr_ = false;
                    _this.ariaCurrentAttrValue_ = null;
                    _this.isCheckboxList_ = false;
                    _this.isRadioList_ = false;
                    _this.hasTypeahead = false;
                    // Transiently holds current typeahead prefix from user.
                    _this.typeaheadState = typeahead.initState();
                    _this.sortedIndexByFirstChar = new Map();
                    return _this;
                }
                Object.defineProperty(MDCListFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCListFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCListFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCListFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClassForElementIndex: function addClassForElementIndex() {
                                return undefined;
                            },
                            focusItemAtIndex: function focusItemAtIndex() {
                                return undefined;
                            },
                            getAttributeForElementIndex: function getAttributeForElementIndex() {
                                return null;
                            },
                            getFocusedElementIndex: function getFocusedElementIndex() {
                                return 0;
                            },
                            getListItemCount: function getListItemCount() {
                                return 0;
                            },
                            hasCheckboxAtIndex: function hasCheckboxAtIndex() {
                                return false;
                            },
                            hasRadioAtIndex: function hasRadioAtIndex() {
                                return false;
                            },
                            isCheckboxCheckedAtIndex: function isCheckboxCheckedAtIndex() {
                                return false;
                            },
                            isFocusInsideList: function isFocusInsideList() {
                                return false;
                            },
                            isRootFocused: function isRootFocused() {
                                return false;
                            },
                            listItemAtIndexHasClass: function listItemAtIndexHasClass() {
                                return false;
                            },
                            notifyAction: function notifyAction() {
                                return undefined;
                            },
                            removeClassForElementIndex: function removeClassForElementIndex() {
                                return undefined;
                            },
                            setAttributeForElementIndex: function setAttributeForElementIndex() {
                                return undefined;
                            },
                            setCheckedCheckboxOrRadioAtIndex: function setCheckedCheckboxOrRadioAtIndex() {
                                return undefined;
                            },
                            setTabIndexForListItemChildren: function setTabIndexForListItemChildren() {
                                return undefined;
                            },
                            getPrimaryTextAtIndex: function getPrimaryTextAtIndex() {
                                return "";
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCListFoundation.prototype.layout = function() {
                    if (this.adapter.getListItemCount() === 0) return;
                    // TODO(b/172274142): consider all items when determining the list's type.
                    if (this.adapter.hasCheckboxAtIndex(0)) this.isCheckboxList_ = true;
                    else if (this.adapter.hasRadioAtIndex(0)) this.isRadioList_ = true;
                    else this.maybeInitializeSingleSelection();
                    if (this.hasTypeahead) this.sortedIndexByFirstChar = this.typeaheadInitSortedIndex();
                };
                /**
     * Sets the private wrapFocus_ variable.
     */ MDCListFoundation.prototype.setWrapFocus = function(value) {
                    this.wrapFocus_ = value;
                };
                /**
     * Sets the isVertical_ private variable.
     */ MDCListFoundation.prototype.setVerticalOrientation = function(value) {
                    this.isVertical_ = value;
                };
                /**
     * Sets the isSingleSelectionList_ private variable.
     */ MDCListFoundation.prototype.setSingleSelection = function(value) {
                    this.isSingleSelectionList_ = value;
                    if (value) this.maybeInitializeSingleSelection();
                };
                /**
     * Automatically determines whether the list is single selection list. If so,
     * initializes the internal state to match the selected item.
     */ MDCListFoundation.prototype.maybeInitializeSingleSelection = function() {
                    var listItemsCount = this.adapter.getListItemCount();
                    for(var i = 0; i < listItemsCount; i++){
                        var hasSelectedClass = this.adapter.listItemAtIndexHasClass(i, constants_1.cssClasses.LIST_ITEM_SELECTED_CLASS);
                        var hasActivatedClass = this.adapter.listItemAtIndexHasClass(i, constants_1.cssClasses.LIST_ITEM_ACTIVATED_CLASS);
                        if (!(hasSelectedClass || hasActivatedClass)) continue;
                        this.isSingleSelectionList_ = true;
                        this.selectedIndex_ = i;
                        return;
                    }
                };
                /**
     * Sets whether typeahead is enabled on the list.
     * @param hasTypeahead Whether typeahead is enabled.
     */ MDCListFoundation.prototype.setHasTypeahead = function(hasTypeahead) {
                    this.hasTypeahead = hasTypeahead;
                    if (hasTypeahead) this.sortedIndexByFirstChar = this.typeaheadInitSortedIndex();
                };
                /**
     * @return Whether typeahead is currently matching a user-specified prefix.
     */ MDCListFoundation.prototype.isTypeaheadInProgress = function() {
                    return this.hasTypeahead && typeahead.isTypingInProgress(this.typeaheadState);
                };
                /**
     * Sets the useSelectedAttr_ private variable.
     */ MDCListFoundation.prototype.setUseSelectedAttribute = function(useSelected) {
                    this.useSelectedAttr_ = useSelected;
                };
                MDCListFoundation.prototype.getSelectedIndex = function() {
                    return this.selectedIndex_;
                };
                MDCListFoundation.prototype.setSelectedIndex = function(index) {
                    if (!this.isIndexValid_(index)) return;
                    if (this.isCheckboxList_) this.setCheckboxAtIndex_(index);
                    else if (this.isRadioList_) this.setCheckboxAtIndex_(index);
                    else this.setSingleSelectionAtIndex_(index);
                };
                /**
     * Focus in handler for the list items.
     */ MDCListFoundation.prototype.handleFocusIn = function(_, listItemIndex) {
                    if (listItemIndex >= 0) {
                        this.focusedItemIndex = listItemIndex;
                        this.adapter.setAttributeForElementIndex(listItemIndex, "tabindex", "0");
                        this.adapter.setTabIndexForListItemChildren(listItemIndex, "0");
                    }
                };
                /**
     * Focus out handler for the list items.
     */ MDCListFoundation.prototype.handleFocusOut = function(_, listItemIndex) {
                    var _this = this;
                    if (listItemIndex >= 0) {
                        this.adapter.setAttributeForElementIndex(listItemIndex, "tabindex", "-1");
                        this.adapter.setTabIndexForListItemChildren(listItemIndex, "-1");
                    }
                    /**
         * Between Focusout & Focusin some browsers do not have focus on any
         * element. Setting a delay to wait till the focus is moved to next element.
         */ setTimeout(function() {
                        if (!_this.adapter.isFocusInsideList()) _this.setTabindexToFirstSelectedOrFocusedItem();
                    }, 0);
                };
                /**
     * Key handler for the list.
     */ MDCListFoundation.prototype.handleKeydown = function(event, isRootListItem, listItemIndex) {
                    var _this = this;
                    var isArrowLeft = keyboard_1.normalizeKey(event) === "ArrowLeft";
                    var isArrowUp = keyboard_1.normalizeKey(event) === "ArrowUp";
                    var isArrowRight = keyboard_1.normalizeKey(event) === "ArrowRight";
                    var isArrowDown = keyboard_1.normalizeKey(event) === "ArrowDown";
                    var isHome = keyboard_1.normalizeKey(event) === "Home";
                    var isEnd = keyboard_1.normalizeKey(event) === "End";
                    var isEnter = keyboard_1.normalizeKey(event) === "Enter";
                    var isSpace = keyboard_1.normalizeKey(event) === "Spacebar";
                    // Have to check both upper and lower case, because having caps lock on affects the value.
                    var isLetterA = event.key === "A" || event.key === "a";
                    if (this.adapter.isRootFocused()) {
                        if (isArrowUp || isEnd) {
                            event.preventDefault();
                            this.focusLastElement();
                        } else if (isArrowDown || isHome) {
                            event.preventDefault();
                            this.focusFirstElement();
                        }
                        if (this.hasTypeahead) {
                            var handleKeydownOpts = {
                                event: event,
                                focusItemAtIndex: function focusItemAtIndex(index) {
                                    _this.focusItemAtIndex(index);
                                },
                                focusedItemIndex: -1,
                                isTargetListItem: isRootListItem,
                                sortedIndexByFirstChar: this.sortedIndexByFirstChar,
                                isItemAtIndexDisabled: function isItemAtIndexDisabled(index) {
                                    return _this.adapter.listItemAtIndexHasClass(index, constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS);
                                }
                            };
                            typeahead.handleKeydown(handleKeydownOpts, this.typeaheadState);
                        }
                        return;
                    }
                    var currentIndex = this.adapter.getFocusedElementIndex();
                    if (currentIndex === -1) {
                        currentIndex = listItemIndex;
                        if (currentIndex < 0) // If this event doesn't have a mdc-list-item ancestor from the
                        // current list (not from a sublist), return early.
                        return;
                    }
                    if (this.isVertical_ && isArrowDown || !this.isVertical_ && isArrowRight) {
                        events_1.preventDefaultEvent(event);
                        this.focusNextElement(currentIndex);
                    } else if (this.isVertical_ && isArrowUp || !this.isVertical_ && isArrowLeft) {
                        events_1.preventDefaultEvent(event);
                        this.focusPrevElement(currentIndex);
                    } else if (isHome) {
                        events_1.preventDefaultEvent(event);
                        this.focusFirstElement();
                    } else if (isEnd) {
                        events_1.preventDefaultEvent(event);
                        this.focusLastElement();
                    } else if (isLetterA && event.ctrlKey && this.isCheckboxList_) {
                        event.preventDefault();
                        this.toggleAll(this.selectedIndex_ === constants_1.numbers.UNSET_INDEX ? [] : this.selectedIndex_);
                    } else if (isEnter || isSpace) {
                        if (isRootListItem) {
                            // Return early if enter key is pressed on anchor element which triggers
                            // synthetic MouseEvent event.
                            var target = event.target;
                            if (target && target.tagName === "A" && isEnter) return;
                            events_1.preventDefaultEvent(event);
                            if (this.adapter.listItemAtIndexHasClass(currentIndex, constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS)) return;
                            if (!this.isTypeaheadInProgress()) {
                                if (this.isSelectableList_()) this.setSelectedIndexOnAction_(currentIndex);
                                this.adapter.notifyAction(currentIndex);
                            }
                        }
                    }
                    if (this.hasTypeahead) {
                        var handleKeydownOpts = {
                            event: event,
                            focusItemAtIndex: function focusItemAtIndex(index) {
                                _this.focusItemAtIndex(index);
                            },
                            focusedItemIndex: this.focusedItemIndex,
                            isTargetListItem: isRootListItem,
                            sortedIndexByFirstChar: this.sortedIndexByFirstChar,
                            isItemAtIndexDisabled: function isItemAtIndexDisabled(index) {
                                return _this.adapter.listItemAtIndexHasClass(index, constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS);
                            }
                        };
                        typeahead.handleKeydown(handleKeydownOpts, this.typeaheadState);
                    }
                };
                /**
     * Click handler for the list.
     */ MDCListFoundation.prototype.handleClick = function(index, toggleCheckbox) {
                    if (index === constants_1.numbers.UNSET_INDEX) return;
                    if (this.adapter.listItemAtIndexHasClass(index, constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS)) return;
                    if (this.isSelectableList_()) this.setSelectedIndexOnAction_(index, toggleCheckbox);
                    this.adapter.notifyAction(index);
                };
                /**
     * Focuses the next element on the list.
     */ MDCListFoundation.prototype.focusNextElement = function(index) {
                    var count = this.adapter.getListItemCount();
                    var nextIndex = index + 1;
                    if (nextIndex >= count) {
                        if (this.wrapFocus_) nextIndex = 0;
                        else // Return early because last item is already focused.
                        return index;
                    }
                    this.focusItemAtIndex(nextIndex);
                    return nextIndex;
                };
                /**
     * Focuses the previous element on the list.
     */ MDCListFoundation.prototype.focusPrevElement = function(index) {
                    var prevIndex = index - 1;
                    if (prevIndex < 0) {
                        if (this.wrapFocus_) prevIndex = this.adapter.getListItemCount() - 1;
                        else // Return early because first item is already focused.
                        return index;
                    }
                    this.focusItemAtIndex(prevIndex);
                    return prevIndex;
                };
                MDCListFoundation.prototype.focusFirstElement = function() {
                    this.focusItemAtIndex(0);
                    return 0;
                };
                MDCListFoundation.prototype.focusLastElement = function() {
                    var lastIndex = this.adapter.getListItemCount() - 1;
                    this.focusItemAtIndex(lastIndex);
                    return lastIndex;
                };
                MDCListFoundation.prototype.focusInitialElement = function() {
                    var initialIndex = this.getFirstSelectedOrFocusedItemIndex();
                    this.focusItemAtIndex(initialIndex);
                    return initialIndex;
                };
                /**
     * @param itemIndex Index of the list item
     * @param isEnabled Sets the list item to enabled or disabled.
     */ MDCListFoundation.prototype.setEnabled = function(itemIndex, isEnabled) {
                    if (!this.isIndexValid_(itemIndex)) return;
                    if (isEnabled) this.adapter.setAttributeForElementIndex(itemIndex, constants_1.strings.ARIA_DISABLED, "false");
                    else this.adapter.setAttributeForElementIndex(itemIndex, constants_1.strings.ARIA_DISABLED, "true");
                };
                MDCListFoundation.prototype.setSingleSelectionAtIndex_ = function(index) {
                    if (Array.isArray(index)) index = index.length > 0 ? index[0] : -1;
                    if (this.selectedIndex_ === index) return;
                    this.setAriaForSingleSelectionAtIndex_(index);
                    this.setTabindexAtIndex(index);
                    this.selectedIndex_ = index;
                };
                /**
     * Sets aria attribute for single selection at given index.
     */ MDCListFoundation.prototype.setAriaForSingleSelectionAtIndex_ = function(index) {
                    // Detect the presence of aria-current and get the value only during list
                    // initialization when it is in unset state.
                    if (this.selectedIndex_ === constants_1.numbers.UNSET_INDEX) this.ariaCurrentAttrValue_ = this.adapter.getAttributeForElementIndex(index, constants_1.strings.ARIA_CURRENT);
                    var isAriaCurrent = this.ariaCurrentAttrValue_ !== null;
                    var ariaAttribute = isAriaCurrent ? constants_1.strings.ARIA_CURRENT : constants_1.strings.ARIA_SELECTED;
                    if (index !== constants_1.numbers.UNSET_INDEX) {
                        var ariaAttributeValue = isAriaCurrent ? this.ariaCurrentAttrValue_ : "true";
                        this.adapter.setAttributeForElementIndex(index, ariaAttribute, ariaAttributeValue);
                    }
                };
                /**
     * Returns the attribute to use for indicating selection status.
     */ MDCListFoundation.prototype.getSelectionAttribute = function() {
                    return this.useSelectedAttr_ ? constants_1.strings.ARIA_SELECTED : constants_1.strings.ARIA_CHECKED;
                };
                MDCListFoundation.prototype.setCheckboxAtIndex_ = function(index) {
                    var selectionAttribute = this.getSelectionAttribute();
                    for(var i = 0; i < this.adapter.getListItemCount(); i++){
                        var isChecked = false;
                        if (index.indexOf(i) >= 0) isChecked = true;
                        this.adapter.setAttributeForElementIndex(i, selectionAttribute, isChecked ? "true" : "false");
                    }
                    this.selectedIndex_ = index;
                };
                MDCListFoundation.prototype.setTabindexAtIndex = function(index) {
                    if (this.focusedItemIndex === constants_1.numbers.UNSET_INDEX && index !== 0) // If some list item was selected set first list item's tabindex to -1.
                    // Generally, tabindex is set to 0 on first list item of list that has no
                    // preselected items.
                    this.adapter.setAttributeForElementIndex(0, "tabindex", "-1");
                    else if (this.focusedItemIndex >= 0 && this.focusedItemIndex !== index) this.adapter.setAttributeForElementIndex(this.focusedItemIndex, "tabindex", "-1");
                    // Set the previous selection's tabindex to -1. We need this because
                    // in selection menus that are not visible, programmatically setting an
                    // option will not change focus but will change where tabindex should be 0.
                    if (!(this.selectedIndex_ instanceof Array) && this.selectedIndex_ !== index) this.adapter.setAttributeForElementIndex(this.selectedIndex_, "tabindex", "-1");
                    if (index !== constants_1.numbers.UNSET_INDEX) this.adapter.setAttributeForElementIndex(index, "tabindex", "0");
                };
                /**
     * @return Return true if it is single selectin list, checkbox list or radio
     *     list.
     */ MDCListFoundation.prototype.isSelectableList_ = function() {
                    return this.isSingleSelectionList_ || this.isCheckboxList_ || this.isRadioList_;
                };
                MDCListFoundation.prototype.setTabindexToFirstSelectedOrFocusedItem = function() {
                    var targetIndex = this.getFirstSelectedOrFocusedItemIndex();
                    this.setTabindexAtIndex(targetIndex);
                };
                MDCListFoundation.prototype.getFirstSelectedOrFocusedItemIndex = function() {
                    var targetIndex = this.focusedItemIndex >= 0 ? this.focusedItemIndex : 0;
                    if (this.isSelectableList_()) {
                        if (typeof this.selectedIndex_ === "number" && this.selectedIndex_ !== constants_1.numbers.UNSET_INDEX) targetIndex = this.selectedIndex_;
                        else if (isNumberArray(this.selectedIndex_) && this.selectedIndex_.length > 0) targetIndex = this.selectedIndex_.reduce(function(currentIndex, minIndex) {
                            return Math.min(currentIndex, minIndex);
                        });
                    }
                    return targetIndex;
                };
                MDCListFoundation.prototype.isIndexValid_ = function(index) {
                    var _this = this;
                    if (index instanceof Array) {
                        if (index.length === 0) return true;
                        else return index.some(function(i) {
                            return _this.isIndexInRange_(i);
                        });
                    } else return false;
                };
                MDCListFoundation.prototype.isIndexInRange_ = function(index) {
                    var listSize = this.adapter.getListItemCount();
                    return index >= 0 && index < listSize;
                };
                /**
     * Sets selected index on user action, toggles checkbox / radio based on
     * toggleCheckbox value. User interaction should not toggle list item(s) when
     * disabled.
     */ MDCListFoundation.prototype.setSelectedIndexOnAction_ = function(index, toggleCheckbox) {
                    if (toggleCheckbox === void 0) toggleCheckbox = true;
                    if (this.isCheckboxList_ || this.isRadioList_) this.toggleCheckboxAtIndex_(index, toggleCheckbox);
                    else this.setSelectedIndex([
                        index
                    ]);
                };
                MDCListFoundation.prototype.toggleCheckboxAtIndex_ = function(index, toggleCheckbox) {
                    var isChecked = this.adapter.isCheckboxCheckedAtIndex(index);
                    if (toggleCheckbox) {
                        isChecked = !isChecked;
                        this.adapter.setCheckedCheckboxOrRadioAtIndex(index, isChecked);
                    }
                };
                MDCListFoundation.prototype.focusItemAtIndex = function(index) {
                    this.adapter.focusItemAtIndex(index);
                    this.focusedItemIndex = index;
                };
                MDCListFoundation.prototype.toggleAll = function(currentlySelectedIndexes) {
                    var count = this.adapter.getListItemCount();
                    // If all items are selected, deselect everything.
                    if (currentlySelectedIndexes.length === count) this.setCheckboxAtIndex_([]);
                    else {
                        // Otherwise select all enabled options.
                        var allIndexes = [];
                        for(var i = 0; i < count; i++)if (!this.adapter.listItemAtIndexHasClass(i, constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS) || currentlySelectedIndexes.indexOf(i) > -1) allIndexes.push(i);
                        this.setCheckboxAtIndex_(allIndexes);
                    }
                };
                /**
     * Given the next desired character from the user, adds it to the typeahead
     * buffer. Then, attempts to find the next option matching the buffer. Wraps
     * around if at the end of options.
     *
     * @param nextChar The next character to add to the prefix buffer.
     * @param startingIndex The index from which to start matching. Only relevant
     *     when starting a new match sequence. To start a new match sequence,
     *     clear the buffer using `clearTypeaheadBuffer`, or wait for the buffer
     *     to clear after a set interval defined in list foundation. Defaults to
     *     the currently focused index.
     * @return The index of the matched item, or -1 if no match.
     */ MDCListFoundation.prototype.typeaheadMatchItem = function(nextChar, startingIndex, skipFocus) {
                    var _this = this;
                    if (skipFocus === void 0) skipFocus = false;
                    var opts = {
                        focusItemAtIndex: function focusItemAtIndex(index) {
                            _this.focusItemAtIndex(index);
                        },
                        focusedItemIndex: startingIndex ? startingIndex : this.focusedItemIndex,
                        nextChar: nextChar,
                        sortedIndexByFirstChar: this.sortedIndexByFirstChar,
                        skipFocus: skipFocus,
                        isItemAtIndexDisabled: function isItemAtIndexDisabled(index) {
                            return _this.adapter.listItemAtIndexHasClass(index, constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS);
                        }
                    };
                    return typeahead.matchItem(opts, this.typeaheadState);
                };
                /**
     * Initializes the MDCListTextAndIndex data structure by indexing the current
     * list items by primary text.
     *
     * @return The primary texts of all the list items sorted by first character.
     */ MDCListFoundation.prototype.typeaheadInitSortedIndex = function() {
                    return typeahead.initSortedIndex(this.adapter.getListItemCount(), this.adapter.getPrimaryTextAtIndex);
                };
                /**
     * Clears the typeahead buffer.
     */ MDCListFoundation.prototype.clearTypeaheadBuffer = function() {
                    typeahead.clearBuffer(this.typeaheadState);
                };
                return MDCListFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCListFoundation = MDCListFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCListFoundation;
        /***/ },
        /***/ "./packages/mdc-list/typeahead.ts": /*!****************************************!*\
  !*** ./packages/mdc-list/typeahead.ts ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.handleKeydown = exports.clearBuffer = exports.isTypingInProgress = exports.matchItem = exports.initSortedIndex = exports.initState = void 0;
            var keyboard_1 = __webpack_require__(/*! @material/dom/keyboard */ "./packages/mdc-dom/keyboard.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-list/constants.ts");
            var events_1 = __webpack_require__(/*! ./events */ "./packages/mdc-list/events.ts");
            /**
 * Initializes a state object for typeahead. Use the same reference for calls to
 * typeahead functions.
 *
 * @return The current state of the typeahead process. Each state reference
 *     represents a typeahead instance as the reference is typically mutated
 *     in-place.
 */ function initState() {
                var state = {
                    bufferClearTimeout: 0,
                    currentFirstChar: "",
                    sortedIndexCursor: 0,
                    typeaheadBuffer: ""
                };
                return state;
            }
            exports.initState = initState;
            /**
 * Initializes typeahead state by indexing the current list items by primary
 * text into the sortedIndexByFirstChar data structure.
 *
 * @param listItemCount numer of items in the list
 * @param getPrimaryTextByItemIndex function that returns the primary text at a
 *     given index
 *
 * @return Map that maps the first character of the primary text to the full
 *     list text and it's index
 */ function initSortedIndex(listItemCount, getPrimaryTextByItemIndex) {
                var sortedIndexByFirstChar = new Map();
                // Aggregate item text to index mapping
                for(var i = 0; i < listItemCount; i++){
                    var primaryText = getPrimaryTextByItemIndex(i).trim();
                    if (!primaryText) continue;
                    var firstChar = primaryText[0].toLowerCase();
                    if (!sortedIndexByFirstChar.has(firstChar)) sortedIndexByFirstChar.set(firstChar, []);
                    sortedIndexByFirstChar.get(firstChar).push({
                        text: primaryText.toLowerCase(),
                        index: i
                    });
                }
                // Sort the mapping
                // TODO(b/157162694): Investigate replacing forEach with Map.values()
                sortedIndexByFirstChar.forEach(function(values) {
                    values.sort(function(first, second) {
                        return first.index - second.index;
                    });
                });
                return sortedIndexByFirstChar;
            }
            exports.initSortedIndex = initSortedIndex;
            /**
 * Given the next desired character from the user, it attempts to find the next
 * list option matching the buffer. Wraps around if at the end of options.
 *
 * @param opts Options and accessors
 *   - nextChar - the next character to match against items
 *   - sortedIndexByFirstChar - output of `initSortedIndex(...)`
 *   - focusedItemIndex - the index of the currently focused item
 *   - focusItemAtIndex - function that focuses a list item at given index
 *   - skipFocus - whether or not to focus the matched item
 *   - isItemAtIndexDisabled - function that determines whether an item at a
 *        given index is disabled
 * @param state The typeahead state instance. See `initState`.
 *
 * @return The index of the matched item, or -1 if no match.
 */ function matchItem(opts, state) {
                var nextChar = opts.nextChar, focusItemAtIndex = opts.focusItemAtIndex, sortedIndexByFirstChar = opts.sortedIndexByFirstChar, focusedItemIndex = opts.focusedItemIndex, skipFocus = opts.skipFocus, isItemAtIndexDisabled = opts.isItemAtIndexDisabled;
                clearTimeout(state.bufferClearTimeout);
                state.bufferClearTimeout = setTimeout(function() {
                    clearBuffer(state);
                }, constants_1.numbers.TYPEAHEAD_BUFFER_CLEAR_TIMEOUT_MS);
                state.typeaheadBuffer = state.typeaheadBuffer + nextChar;
                var index;
                if (state.typeaheadBuffer.length === 1) index = matchFirstChar(sortedIndexByFirstChar, focusedItemIndex, isItemAtIndexDisabled, state);
                else index = matchAllChars(sortedIndexByFirstChar, isItemAtIndexDisabled, state);
                if (index !== -1 && !skipFocus) focusItemAtIndex(index);
                return index;
            }
            exports.matchItem = matchItem;
            /**
 * Matches the user's single input character in the buffer to the
 * next option that begins with such character. Wraps around if at
 * end of options. Returns -1 if no match is found.
 */ function matchFirstChar(sortedIndexByFirstChar, focusedItemIndex, isItemAtIndexDisabled, state) {
                var firstChar = state.typeaheadBuffer[0];
                var itemsMatchingFirstChar = sortedIndexByFirstChar.get(firstChar);
                if (!itemsMatchingFirstChar) return -1;
                // Has the same firstChar been recently matched?
                // Also, did starting index remain the same between key presses?
                // If both hold true, simply increment index.
                if (firstChar === state.currentFirstChar && itemsMatchingFirstChar[state.sortedIndexCursor].index === focusedItemIndex) {
                    state.sortedIndexCursor = (state.sortedIndexCursor + 1) % itemsMatchingFirstChar.length;
                    var newIndex = itemsMatchingFirstChar[state.sortedIndexCursor].index;
                    if (!isItemAtIndexDisabled(newIndex)) return newIndex;
                }
                // If we're here, it means one of the following happened:
                // - either firstChar or startingIndex has changed, invalidating the
                // cursor.
                // - The next item of typeahead is disabled, so we have to look further.
                state.currentFirstChar = firstChar;
                var newCursorPosition = -1;
                var cursorPosition;
                // Find the first non-disabled item as a fallback.
                for(cursorPosition = 0; cursorPosition < itemsMatchingFirstChar.length; cursorPosition++)if (!isItemAtIndexDisabled(itemsMatchingFirstChar[cursorPosition].index)) {
                    newCursorPosition = cursorPosition;
                    break;
                }
                // Advance cursor to first item matching the firstChar that is positioned
                // after starting item. Cursor is unchanged from fallback if there's no
                // such item.
                for(; cursorPosition < itemsMatchingFirstChar.length; cursorPosition++)if (itemsMatchingFirstChar[cursorPosition].index > focusedItemIndex && !isItemAtIndexDisabled(itemsMatchingFirstChar[cursorPosition].index)) {
                    newCursorPosition = cursorPosition;
                    break;
                }
                if (newCursorPosition !== -1) {
                    state.sortedIndexCursor = newCursorPosition;
                    return itemsMatchingFirstChar[state.sortedIndexCursor].index;
                }
                return -1;
            }
            /**
 * Attempts to find the next item that matches all of the typeahead buffer.
 * Wraps around if at end of options. Returns -1 if no match is found.
 */ function matchAllChars(sortedIndexByFirstChar, isItemAtIndexDisabled, state) {
                var firstChar = state.typeaheadBuffer[0];
                var itemsMatchingFirstChar = sortedIndexByFirstChar.get(firstChar);
                if (!itemsMatchingFirstChar) return -1;
                // Do nothing if text already matches
                var startingItem = itemsMatchingFirstChar[state.sortedIndexCursor];
                if (startingItem.text.lastIndexOf(state.typeaheadBuffer, 0) === 0 && !isItemAtIndexDisabled(startingItem.index)) return startingItem.index;
                // Find next item that matches completely; if no match, we'll eventually
                // loop around to same position
                var cursorPosition = (state.sortedIndexCursor + 1) % itemsMatchingFirstChar.length;
                var nextCursorPosition = -1;
                while(cursorPosition !== state.sortedIndexCursor){
                    var currentItem = itemsMatchingFirstChar[cursorPosition];
                    var matches = currentItem.text.lastIndexOf(state.typeaheadBuffer, 0) === 0;
                    var isEnabled = !isItemAtIndexDisabled(currentItem.index);
                    if (matches && isEnabled) {
                        nextCursorPosition = cursorPosition;
                        break;
                    }
                    cursorPosition = (cursorPosition + 1) % itemsMatchingFirstChar.length;
                }
                if (nextCursorPosition !== -1) {
                    state.sortedIndexCursor = nextCursorPosition;
                    return itemsMatchingFirstChar[state.sortedIndexCursor].index;
                }
                return -1;
            }
            /**
 * Whether or not the given typeahead instaance state is currently typing.
 *
 * @param state The typeahead state instance. See `initState`.
 */ function isTypingInProgress(state) {
                return state.typeaheadBuffer.length > 0;
            }
            exports.isTypingInProgress = isTypingInProgress;
            /**
 * Clears the typeahaed buffer so that it resets item matching to the first
 * character.
 *
 * @param state The typeahead state instance. See `initState`.
 */ function clearBuffer(state) {
                state.typeaheadBuffer = "";
            }
            exports.clearBuffer = clearBuffer;
            /**
 * Given a keydown event, it calculates whether or not to automatically focus a
 * list item depending on what was typed mimicing the typeahead functionality of
 * a standard <select> element that is open.
 *
 * @param opts Options and accessors
 *   - event - the KeyboardEvent to handle and parse
 *   - sortedIndexByFirstChar - output of `initSortedIndex(...)`
 *   - focusedItemIndex - the index of the currently focused item
 *   - focusItemAtIndex - function that focuses a list item at given index
 *   - isItemAtFocusedIndexDisabled - whether or not the currently focused item
 *      is disabled
 *   - isTargetListItem - whether or not the event target is a list item
 * @param state The typeahead state instance. See `initState`.
 *
 * @returns index of the item matched by the keydown. -1 if not matched.
 */ function handleKeydown(opts, state) {
                var event = opts.event, isTargetListItem = opts.isTargetListItem, focusedItemIndex = opts.focusedItemIndex, focusItemAtIndex = opts.focusItemAtIndex, sortedIndexByFirstChar = opts.sortedIndexByFirstChar, isItemAtIndexDisabled = opts.isItemAtIndexDisabled;
                var isArrowLeft = keyboard_1.normalizeKey(event) === "ArrowLeft";
                var isArrowUp = keyboard_1.normalizeKey(event) === "ArrowUp";
                var isArrowRight = keyboard_1.normalizeKey(event) === "ArrowRight";
                var isArrowDown = keyboard_1.normalizeKey(event) === "ArrowDown";
                var isHome = keyboard_1.normalizeKey(event) === "Home";
                var isEnd = keyboard_1.normalizeKey(event) === "End";
                var isEnter = keyboard_1.normalizeKey(event) === "Enter";
                var isSpace = keyboard_1.normalizeKey(event) === "Spacebar";
                if (event.ctrlKey || event.metaKey || isArrowLeft || isArrowUp || isArrowRight || isArrowDown || isHome || isEnd || isEnter) return -1;
                var isCharacterKey = !isSpace && event.key.length === 1;
                if (isCharacterKey) {
                    events_1.preventDefaultEvent(event);
                    var matchItemOpts = {
                        focusItemAtIndex: focusItemAtIndex,
                        focusedItemIndex: focusedItemIndex,
                        nextChar: event.key.toLowerCase(),
                        sortedIndexByFirstChar: sortedIndexByFirstChar,
                        skipFocus: false,
                        isItemAtIndexDisabled: isItemAtIndexDisabled
                    };
                    return matchItem(matchItemOpts, state);
                }
                if (!isSpace) return -1;
                if (isTargetListItem) events_1.preventDefaultEvent(event);
                var typeaheadOnListItem = isTargetListItem && isTypingInProgress(state);
                if (typeaheadOnListItem) {
                    var matchItemOpts = {
                        focusItemAtIndex: focusItemAtIndex,
                        focusedItemIndex: focusedItemIndex,
                        nextChar: " ",
                        sortedIndexByFirstChar: sortedIndexByFirstChar,
                        skipFocus: false,
                        isItemAtIndexDisabled: isItemAtIndexDisabled
                    };
                    // space participates in typeahead matching if in rapid typing mode
                    return matchItem(matchItemOpts, state);
                }
                return -1;
            }
            exports.handleKeydown = handleKeydown;
        /***/ },
        /***/ "./packages/mdc-menu-surface/component.ts": /*!************************************************!*\
  !*** ./packages/mdc-menu-surface/component.ts ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCMenuSurface = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-menu-surface/constants.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-menu-surface/foundation.ts");
            var util_1 = __webpack_require__(/*! @material/animation/util */ "./packages/mdc-animation/util.ts");
            var MDCMenuSurface = /** @class */ function(_super) {
                __extends(MDCMenuSurface, _super);
                function MDCMenuSurface() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCMenuSurface.attachTo = function(root) {
                    return new MDCMenuSurface(root);
                };
                MDCMenuSurface.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    var parentEl = this.root.parentElement;
                    this.anchorElement = parentEl && parentEl.classList.contains(constants_1.cssClasses.ANCHOR) ? parentEl : null;
                    if (this.root.classList.contains(constants_1.cssClasses.FIXED)) this.setFixedPosition(true);
                    this.handleKeydown = function(evt) {
                        return _this.handleKeydown_(evt);
                    };
                    this.handleBodyClick = function(evt) {
                        return _this.handleBodyClick_(evt);
                    };
                    // capture so that no race between handleBodyClick and quickOpen when
                    // menusurface opened on button click which registers this listener
                    this.registerBodyClickListener = function() {
                        document.body.addEventListener("click", _this.handleBodyClick, {
                            capture: true
                        });
                    };
                    this.deregisterBodyClickListener = function() {
                        document.body.removeEventListener("click", _this.handleBodyClick, {
                            capture: true
                        });
                    };
                    this.listen("keydown", this.handleKeydown);
                    this.listen(constants_1.strings.OPENED_EVENT, this.registerBodyClickListener);
                    this.listen(constants_1.strings.CLOSED_EVENT, this.deregisterBodyClickListener);
                };
                /** Handle clicks and close if not within menu-surface element. */ MDCMenuSurface.prototype.handleBodyClick_ = function(evt) {
                    var el = evt.target;
                    if (this.isElementInContainer(el)) return;
                    this.emit("MDCMenuSurface:close", {}, true);
                };
                /** Handle keys that close the surface. */ MDCMenuSurface.prototype.handleKeydown_ = function(evt) {
                    var keyCode = evt.keyCode, key = evt.key;
                    var isEscape = key === "Escape" || keyCode === 27;
                    if (isEscape) this.emit("MDCMenuSurface:close", {}, true);
                };
                MDCMenuSurface.prototype.isElementInContainer = function(el) {
                    return this.root.contains(el);
                };
                MDCMenuSurface.prototype.destroy = function() {
                    this.unlisten("keydown", this.handleKeydown);
                    this.unlisten(constants_1.strings.OPENED_EVENT, this.registerBodyClickListener);
                    this.unlisten(constants_1.strings.CLOSED_EVENT, this.deregisterBodyClickListener);
                    this.deregisterBodyClickListener();
                    _super.prototype.destroy.call(this);
                };
                MDCMenuSurface.prototype.isOpen = function() {
                    return this.foundation.isOpen();
                };
                MDCMenuSurface.prototype.open = function() {
                    this.foundation.open();
                };
                MDCMenuSurface.prototype.close = function(skipRestoreFocus) {
                    if (skipRestoreFocus === void 0) skipRestoreFocus = false;
                    this.foundation.close(skipRestoreFocus);
                };
                Object.defineProperty(MDCMenuSurface.prototype, "quickOpen", {
                    set: function set(quickOpen) {
                        this.foundation.setQuickOpen(quickOpen);
                    },
                    enumerable: false,
                    configurable: true
                });
                /** Sets the foundation to use page offsets for an positioning when the menu is hoisted to the body. */ MDCMenuSurface.prototype.setIsHoisted = function(isHoisted) {
                    this.foundation.setIsHoisted(isHoisted);
                };
                /** Sets the element that the menu-surface is anchored to. */ MDCMenuSurface.prototype.setMenuSurfaceAnchorElement = function(element) {
                    this.anchorElement = element;
                };
                /** Sets the menu-surface to position: fixed. */ MDCMenuSurface.prototype.setFixedPosition = function(isFixed) {
                    if (isFixed) this.root.classList.add(constants_1.cssClasses.FIXED);
                    else this.root.classList.remove(constants_1.cssClasses.FIXED);
                    this.foundation.setFixedPosition(isFixed);
                };
                /** Sets the absolute x/y position to position based on. Requires the menu to be hoisted. */ MDCMenuSurface.prototype.setAbsolutePosition = function(x, y) {
                    this.foundation.setAbsolutePosition(x, y);
                    this.setIsHoisted(true);
                };
                /**
     * @param corner Default anchor corner alignment of top-left surface corner.
     */ MDCMenuSurface.prototype.setAnchorCorner = function(corner) {
                    this.foundation.setAnchorCorner(corner);
                };
                MDCMenuSurface.prototype.setAnchorMargin = function(margin) {
                    this.foundation.setAnchorMargin(margin);
                };
                MDCMenuSurface.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        hasAnchor: function hasAnchor() {
                            return !!_this.anchorElement;
                        },
                        notifyClose: function notifyClose() {
                            return _this.emit(foundation_1.MDCMenuSurfaceFoundation.strings.CLOSED_EVENT, {});
                        },
                        notifyClosing: function notifyClosing() {
                            _this.emit(foundation_1.MDCMenuSurfaceFoundation.strings.CLOSING_EVENT, {});
                        },
                        notifyOpen: function notifyOpen() {
                            return _this.emit(foundation_1.MDCMenuSurfaceFoundation.strings.OPENED_EVENT, {});
                        },
                        isElementInContainer: function isElementInContainer(el) {
                            return _this.root.contains(el);
                        },
                        isRtl: function isRtl() {
                            return getComputedStyle(_this.root).getPropertyValue("direction") === "rtl";
                        },
                        setTransformOrigin: function setTransformOrigin(origin) {
                            var propertyName = util_1.getCorrectPropertyName(window, "transform") + "-origin";
                            _this.root.style.setProperty(propertyName, origin);
                        },
                        isFocused: function isFocused() {
                            return document.activeElement === _this.root;
                        },
                        saveFocus: function saveFocus() {
                            _this.previousFocus = document.activeElement;
                        },
                        restoreFocus: function restoreFocus() {
                            if (_this.root.contains(document.activeElement)) {
                                if (_this.previousFocus && _this.previousFocus.focus) _this.previousFocus.focus();
                            }
                        },
                        getInnerDimensions: function getInnerDimensions() {
                            return {
                                width: _this.root.offsetWidth,
                                height: _this.root.offsetHeight
                            };
                        },
                        getAnchorDimensions: function getAnchorDimensions() {
                            return _this.anchorElement ? _this.anchorElement.getBoundingClientRect() : null;
                        },
                        getWindowDimensions: function getWindowDimensions() {
                            return {
                                width: window.innerWidth,
                                height: window.innerHeight
                            };
                        },
                        getBodyDimensions: function getBodyDimensions() {
                            return {
                                width: document.body.clientWidth,
                                height: document.body.clientHeight
                            };
                        },
                        getWindowScroll: function getWindowScroll() {
                            return {
                                x: window.pageXOffset,
                                y: window.pageYOffset
                            };
                        },
                        setPosition: function setPosition(position) {
                            var rootHTML = _this.root;
                            rootHTML.style.left = "left" in position ? position.left + "px" : "";
                            rootHTML.style.right = "right" in position ? position.right + "px" : "";
                            rootHTML.style.top = "top" in position ? position.top + "px" : "";
                            rootHTML.style.bottom = "bottom" in position ? position.bottom + "px" : "";
                        },
                        setMaxHeight: function setMaxHeight(height) {
                            _this.root.style.maxHeight = height;
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_1.MDCMenuSurfaceFoundation(adapter);
                };
                return MDCMenuSurface;
            }(component_1.MDCComponent);
            exports.MDCMenuSurface = MDCMenuSurface;
        /***/ },
        /***/ "./packages/mdc-menu-surface/constants.ts": /*!************************************************!*\
  !*** ./packages/mdc-menu-surface/constants.ts ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.Corner = exports.CornerBit = exports.numbers = exports.strings = exports.cssClasses = void 0;
            var cssClasses = {
                ANCHOR: "mdc-menu-surface--anchor",
                ANIMATING_CLOSED: "mdc-menu-surface--animating-closed",
                ANIMATING_OPEN: "mdc-menu-surface--animating-open",
                FIXED: "mdc-menu-surface--fixed",
                IS_OPEN_BELOW: "mdc-menu-surface--is-open-below",
                OPEN: "mdc-menu-surface--open",
                ROOT: "mdc-menu-surface"
            };
            exports.cssClasses = cssClasses;
            // tslint:disable:object-literal-sort-keys
            var strings = {
                CLOSED_EVENT: "MDCMenuSurface:closed",
                CLOSING_EVENT: "MDCMenuSurface:closing",
                OPENED_EVENT: "MDCMenuSurface:opened",
                FOCUSABLE_ELEMENTS: [
                    "button:not(:disabled)",
                    '[href]:not([aria-disabled="true"])',
                    "input:not(:disabled)",
                    "select:not(:disabled)",
                    "textarea:not(:disabled)",
                    '[tabindex]:not([tabindex="-1"]):not([aria-disabled="true"])'
                ].join(", ")
            };
            exports.strings = strings;
            // tslint:enable:object-literal-sort-keys
            var numbers = {
                /** Total duration of menu-surface open animation. */ TRANSITION_OPEN_DURATION: 120,
                /** Total duration of menu-surface close animation. */ TRANSITION_CLOSE_DURATION: 75,
                /** Margin left to the edge of the viewport when menu-surface is at maximum possible height. Also used as a viewport margin. */ MARGIN_TO_EDGE: 32,
                /** Ratio of anchor width to menu-surface width for switching from corner positioning to center positioning. */ ANCHOR_TO_MENU_SURFACE_WIDTH_RATIO: 0.67
            };
            exports.numbers = numbers;
            /**
 * Enum for bits in the {@see Corner) bitmap.
 */ var CornerBit;
            (function(CornerBit) {
                CornerBit[CornerBit["BOTTOM"] = 1] = "BOTTOM";
                CornerBit[CornerBit["CENTER"] = 2] = "CENTER";
                CornerBit[CornerBit["RIGHT"] = 4] = "RIGHT";
                CornerBit[CornerBit["FLIP_RTL"] = 8] = "FLIP_RTL";
            })(CornerBit || (CornerBit = {}));
            exports.CornerBit = CornerBit;
            /**
 * Enum for representing an element corner for positioning the menu-surface.
 *
 * The START constants map to LEFT if element directionality is left
 * to right and RIGHT if the directionality is right to left.
 * Likewise END maps to RIGHT or LEFT depending on the directionality.
 */ var Corner;
            (function(Corner) {
                Corner[Corner["TOP_LEFT"] = 0] = "TOP_LEFT";
                Corner[Corner["TOP_RIGHT"] = 4] = "TOP_RIGHT";
                Corner[Corner["BOTTOM_LEFT"] = 1] = "BOTTOM_LEFT";
                Corner[Corner["BOTTOM_RIGHT"] = 5] = "BOTTOM_RIGHT";
                Corner[Corner["TOP_START"] = 8] = "TOP_START";
                Corner[Corner["TOP_END"] = 12] = "TOP_END";
                Corner[Corner["BOTTOM_START"] = 9] = "BOTTOM_START";
                Corner[Corner["BOTTOM_END"] = 13] = "BOTTOM_END";
            })(Corner || (Corner = {}));
            exports.Corner = Corner;
        /***/ },
        /***/ "./packages/mdc-menu-surface/foundation.ts": /*!*************************************************!*\
  !*** ./packages/mdc-menu-surface/foundation.ts ***!
  \*************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __values = this && this.__values || function(o) {
                var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
                if (m) return m.call(o);
                if (o && typeof o.length === "number") return {
                    next: function next() {
                        if (o && i >= o.length) o = void 0;
                        return {
                            value: o && o[i++],
                            done: !o
                        };
                    }
                };
                throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCMenuSurfaceFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-menu-surface/constants.ts");
            var MDCMenuSurfaceFoundation = /** @class */ function(_super) {
                __extends(MDCMenuSurfaceFoundation, _super);
                function MDCMenuSurfaceFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCMenuSurfaceFoundation.defaultAdapter), adapter)) || this;
                    _this.isSurfaceOpen = false;
                    _this.isQuickOpen = false;
                    _this.isHoistedElement = false;
                    _this.isFixedPosition = false;
                    _this.isHorizontallyCenteredOnViewport = false;
                    _this.maxHeight = 0;
                    _this.openAnimationEndTimerId = 0;
                    _this.closeAnimationEndTimerId = 0;
                    _this.animationRequestId = 0;
                    _this.anchorCorner = constants_1.Corner.TOP_START;
                    /**
         * Corner of the menu surface to which menu surface is attached to anchor.
         *
         *  Anchor corner --->+----------+
         *                    |  ANCHOR  |
         *                    +----------+
         *  Origin corner --->+--------------+
         *                    |              |
         *                    |              |
         *                    | MENU SURFACE |
         *                    |              |
         *                    |              |
         *                    +--------------+
         */ _this.originCorner = constants_1.Corner.TOP_START;
                    _this.anchorMargin = {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    };
                    _this.position = {
                        x: 0,
                        y: 0
                    };
                    return _this;
                }
                Object.defineProperty(MDCMenuSurfaceFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenuSurfaceFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenuSurfaceFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenuSurfaceFoundation, "Corner", {
                    get: function get() {
                        return constants_1.Corner;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenuSurfaceFoundation, "defaultAdapter", {
                    /**
         * @see {@link MDCMenuSurfaceAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            hasAnchor: function hasAnchor() {
                                return false;
                            },
                            isElementInContainer: function isElementInContainer() {
                                return false;
                            },
                            isFocused: function isFocused() {
                                return false;
                            },
                            isRtl: function isRtl() {
                                return false;
                            },
                            getInnerDimensions: function getInnerDimensions() {
                                return {
                                    height: 0,
                                    width: 0
                                };
                            },
                            getAnchorDimensions: function getAnchorDimensions() {
                                return null;
                            },
                            getWindowDimensions: function getWindowDimensions() {
                                return {
                                    height: 0,
                                    width: 0
                                };
                            },
                            getBodyDimensions: function getBodyDimensions() {
                                return {
                                    height: 0,
                                    width: 0
                                };
                            },
                            getWindowScroll: function getWindowScroll() {
                                return {
                                    x: 0,
                                    y: 0
                                };
                            },
                            setPosition: function setPosition() {
                                return undefined;
                            },
                            setMaxHeight: function setMaxHeight() {
                                return undefined;
                            },
                            setTransformOrigin: function setTransformOrigin() {
                                return undefined;
                            },
                            saveFocus: function saveFocus() {
                                return undefined;
                            },
                            restoreFocus: function restoreFocus() {
                                return undefined;
                            },
                            notifyClose: function notifyClose() {
                                return undefined;
                            },
                            notifyOpen: function notifyOpen() {
                                return undefined;
                            },
                            notifyClosing: function notifyClosing() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCMenuSurfaceFoundation.prototype.init = function() {
                    var _a = MDCMenuSurfaceFoundation.cssClasses, ROOT = _a.ROOT, OPEN = _a.OPEN;
                    if (!this.adapter.hasClass(ROOT)) throw new Error(ROOT + " class required in root element.");
                    if (this.adapter.hasClass(OPEN)) this.isSurfaceOpen = true;
                };
                MDCMenuSurfaceFoundation.prototype.destroy = function() {
                    clearTimeout(this.openAnimationEndTimerId);
                    clearTimeout(this.closeAnimationEndTimerId);
                    // Cancel any currently running animations.
                    cancelAnimationFrame(this.animationRequestId);
                };
                /**
     * @param corner Default anchor corner alignment of top-left menu surface corner.
     */ MDCMenuSurfaceFoundation.prototype.setAnchorCorner = function(corner) {
                    this.anchorCorner = corner;
                };
                /**
     * Flip menu corner horizontally.
     */ MDCMenuSurfaceFoundation.prototype.flipCornerHorizontally = function() {
                    this.originCorner = this.originCorner ^ constants_1.CornerBit.RIGHT;
                };
                /**
     * @param margin Set of margin values from anchor.
     */ MDCMenuSurfaceFoundation.prototype.setAnchorMargin = function(margin) {
                    this.anchorMargin.top = margin.top || 0;
                    this.anchorMargin.right = margin.right || 0;
                    this.anchorMargin.bottom = margin.bottom || 0;
                    this.anchorMargin.left = margin.left || 0;
                };
                /** Used to indicate if the menu-surface is hoisted to the body. */ MDCMenuSurfaceFoundation.prototype.setIsHoisted = function(isHoisted) {
                    this.isHoistedElement = isHoisted;
                };
                /** Used to set the menu-surface calculations based on a fixed position menu. */ MDCMenuSurfaceFoundation.prototype.setFixedPosition = function(isFixedPosition) {
                    this.isFixedPosition = isFixedPosition;
                };
                /** Sets the menu-surface position on the page. */ MDCMenuSurfaceFoundation.prototype.setAbsolutePosition = function(x, y) {
                    this.position.x = this.isFinite(x) ? x : 0;
                    this.position.y = this.isFinite(y) ? y : 0;
                };
                /** Sets whether menu-surface should be horizontally centered to viewport. */ MDCMenuSurfaceFoundation.prototype.setIsHorizontallyCenteredOnViewport = function(isCentered) {
                    this.isHorizontallyCenteredOnViewport = isCentered;
                };
                MDCMenuSurfaceFoundation.prototype.setQuickOpen = function(quickOpen) {
                    this.isQuickOpen = quickOpen;
                };
                /**
     * Sets maximum menu-surface height on open.
     * @param maxHeight The desired max-height. Set to 0 (default) to
     *     automatically calculate max height based on available viewport space.
     */ MDCMenuSurfaceFoundation.prototype.setMaxHeight = function(maxHeight) {
                    this.maxHeight = maxHeight;
                };
                MDCMenuSurfaceFoundation.prototype.isOpen = function() {
                    return this.isSurfaceOpen;
                };
                /**
     * Open the menu surface.
     */ MDCMenuSurfaceFoundation.prototype.open = function() {
                    var _this = this;
                    if (this.isSurfaceOpen) return;
                    this.adapter.saveFocus();
                    if (this.isQuickOpen) {
                        this.isSurfaceOpen = true;
                        this.adapter.addClass(MDCMenuSurfaceFoundation.cssClasses.OPEN);
                        this.dimensions = this.adapter.getInnerDimensions();
                        this.autoposition();
                        this.adapter.notifyOpen();
                    } else {
                        this.adapter.addClass(MDCMenuSurfaceFoundation.cssClasses.ANIMATING_OPEN);
                        this.animationRequestId = requestAnimationFrame(function() {
                            _this.adapter.addClass(MDCMenuSurfaceFoundation.cssClasses.OPEN);
                            _this.dimensions = _this.adapter.getInnerDimensions();
                            _this.autoposition();
                            _this.openAnimationEndTimerId = setTimeout(function() {
                                _this.openAnimationEndTimerId = 0;
                                _this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.ANIMATING_OPEN);
                                _this.adapter.notifyOpen();
                            }, constants_1.numbers.TRANSITION_OPEN_DURATION);
                        });
                        this.isSurfaceOpen = true;
                    }
                };
                /**
     * Closes the menu surface.
     */ MDCMenuSurfaceFoundation.prototype.close = function(skipRestoreFocus) {
                    var _this = this;
                    if (skipRestoreFocus === void 0) skipRestoreFocus = false;
                    if (!this.isSurfaceOpen) return;
                    this.adapter.notifyClosing();
                    if (this.isQuickOpen) {
                        this.isSurfaceOpen = false;
                        if (!skipRestoreFocus) this.maybeRestoreFocus();
                        this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.OPEN);
                        this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.IS_OPEN_BELOW);
                        this.adapter.notifyClose();
                        return;
                    }
                    this.adapter.addClass(MDCMenuSurfaceFoundation.cssClasses.ANIMATING_CLOSED);
                    requestAnimationFrame(function() {
                        _this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.OPEN);
                        _this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.IS_OPEN_BELOW);
                        _this.closeAnimationEndTimerId = setTimeout(function() {
                            _this.closeAnimationEndTimerId = 0;
                            _this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.ANIMATING_CLOSED);
                            _this.adapter.notifyClose();
                        }, constants_1.numbers.TRANSITION_CLOSE_DURATION);
                    });
                    this.isSurfaceOpen = false;
                    if (!skipRestoreFocus) this.maybeRestoreFocus();
                };
                MDCMenuSurfaceFoundation.prototype.autoposition = function() {
                    var _a;
                    // Compute measurements for autoposition methods reuse.
                    this.measurements = this.getAutoLayoutmeasurements();
                    var corner = this.getoriginCorner();
                    var maxMenuSurfaceHeight = this.getMenuSurfaceMaxHeight(corner);
                    var verticalAlignment = this.hasBit(corner, constants_1.CornerBit.BOTTOM) ? "bottom" : "top";
                    var horizontalAlignment = this.hasBit(corner, constants_1.CornerBit.RIGHT) ? "right" : "left";
                    var horizontalOffset = this.getHorizontalOriginOffset(corner);
                    var verticalOffset = this.getVerticalOriginOffset(corner);
                    var _b = this.measurements, anchorSize = _b.anchorSize, surfaceSize = _b.surfaceSize;
                    var position = (_a = {}, _a[horizontalAlignment] = horizontalOffset, _a[verticalAlignment] = verticalOffset, _a);
                    // Center align when anchor width is comparable or greater than menu surface, otherwise keep corner.
                    if (anchorSize.width / surfaceSize.width > constants_1.numbers.ANCHOR_TO_MENU_SURFACE_WIDTH_RATIO) horizontalAlignment = "center";
                    // If the menu-surface has been hoisted to the body, it's no longer relative to the anchor element
                    if (this.isHoistedElement || this.isFixedPosition) this.adjustPositionForHoistedElement(position);
                    this.adapter.setTransformOrigin(horizontalAlignment + " " + verticalAlignment);
                    this.adapter.setPosition(position);
                    this.adapter.setMaxHeight(maxMenuSurfaceHeight ? maxMenuSurfaceHeight + "px" : "");
                    // If it is opened from the top then add is-open-below class
                    if (!this.hasBit(corner, constants_1.CornerBit.BOTTOM)) this.adapter.addClass(MDCMenuSurfaceFoundation.cssClasses.IS_OPEN_BELOW);
                };
                /**
     * @return Measurements used to position menu surface popup.
     */ MDCMenuSurfaceFoundation.prototype.getAutoLayoutmeasurements = function() {
                    var anchorRect = this.adapter.getAnchorDimensions();
                    var bodySize = this.adapter.getBodyDimensions();
                    var viewportSize = this.adapter.getWindowDimensions();
                    var windowScroll = this.adapter.getWindowScroll();
                    if (!anchorRect) // tslint:disable:object-literal-sort-keys Positional properties are more readable when they're grouped together
                    anchorRect = {
                        top: this.position.y,
                        right: this.position.x,
                        bottom: this.position.y,
                        left: this.position.x,
                        width: 0,
                        height: 0
                    };
                    return {
                        anchorSize: anchorRect,
                        bodySize: bodySize,
                        surfaceSize: this.dimensions,
                        viewportDistance: {
                            // tslint:disable:object-literal-sort-keys Positional properties are more readable when they're grouped together
                            top: anchorRect.top,
                            right: viewportSize.width - anchorRect.right,
                            bottom: viewportSize.height - anchorRect.bottom,
                            left: anchorRect.left
                        },
                        viewportSize: viewportSize,
                        windowScroll: windowScroll
                    };
                };
                /**
     * Computes the corner of the anchor from which to animate and position the
     * menu surface.
     *
     * Only LEFT or RIGHT bit is used to position the menu surface ignoring RTL
     * context. E.g., menu surface will be positioned from right side on TOP_END.
     */ MDCMenuSurfaceFoundation.prototype.getoriginCorner = function() {
                    var corner = this.originCorner;
                    var _a = this.measurements, viewportDistance = _a.viewportDistance, anchorSize = _a.anchorSize, surfaceSize = _a.surfaceSize;
                    var MARGIN_TO_EDGE = MDCMenuSurfaceFoundation.numbers.MARGIN_TO_EDGE;
                    var isAnchoredToBottom = this.hasBit(this.anchorCorner, constants_1.CornerBit.BOTTOM);
                    var availableTop;
                    var availableBottom;
                    if (isAnchoredToBottom) {
                        availableTop = viewportDistance.top - MARGIN_TO_EDGE + this.anchorMargin.bottom;
                        availableBottom = viewportDistance.bottom - MARGIN_TO_EDGE - this.anchorMargin.bottom;
                    } else {
                        availableTop = viewportDistance.top - MARGIN_TO_EDGE + this.anchorMargin.top;
                        availableBottom = viewportDistance.bottom - MARGIN_TO_EDGE + anchorSize.height - this.anchorMargin.top;
                    }
                    var isAvailableBottom = availableBottom - surfaceSize.height > 0;
                    if (!isAvailableBottom && availableTop > availableBottom) // Attach bottom side of surface to the anchor.
                    corner = this.setBit(corner, constants_1.CornerBit.BOTTOM);
                    var isRtl = this.adapter.isRtl();
                    var isFlipRtl = this.hasBit(this.anchorCorner, constants_1.CornerBit.FLIP_RTL);
                    var hasRightBit = this.hasBit(this.anchorCorner, constants_1.CornerBit.RIGHT) || this.hasBit(corner, constants_1.CornerBit.RIGHT);
                    // Whether surface attached to right side of anchor element.
                    var isAnchoredToRight = false;
                    // Anchored to start
                    if (isRtl && isFlipRtl) isAnchoredToRight = !hasRightBit;
                    else // Anchored to right
                    isAnchoredToRight = hasRightBit;
                    var availableLeft;
                    var availableRight;
                    if (isAnchoredToRight) {
                        availableLeft = viewportDistance.left + anchorSize.width + this.anchorMargin.right;
                        availableRight = viewportDistance.right - this.anchorMargin.right;
                    } else {
                        availableLeft = viewportDistance.left + this.anchorMargin.left;
                        availableRight = viewportDistance.right + anchorSize.width - this.anchorMargin.left;
                    }
                    var isAvailableLeft = availableLeft - surfaceSize.width > 0;
                    var isAvailableRight = availableRight - surfaceSize.width > 0;
                    var isOriginCornerAlignedToEnd = this.hasBit(corner, constants_1.CornerBit.FLIP_RTL) && this.hasBit(corner, constants_1.CornerBit.RIGHT);
                    if (isAvailableRight && isOriginCornerAlignedToEnd && isRtl || !isAvailableLeft && isOriginCornerAlignedToEnd) // Attach left side of surface to the anchor.
                    corner = this.unsetBit(corner, constants_1.CornerBit.RIGHT);
                    else if (isAvailableLeft && isAnchoredToRight && isRtl || isAvailableLeft && !isAnchoredToRight && hasRightBit || !isAvailableRight && availableLeft >= availableRight) // Attach right side of surface to the anchor.
                    corner = this.setBit(corner, constants_1.CornerBit.RIGHT);
                    return corner;
                };
                /**
     * @param corner Origin corner of the menu surface.
     * @return Maximum height of the menu surface, based on available space. 0 indicates should not be set.
     */ MDCMenuSurfaceFoundation.prototype.getMenuSurfaceMaxHeight = function(corner) {
                    if (this.maxHeight > 0) return this.maxHeight;
                    var viewportDistance = this.measurements.viewportDistance;
                    var maxHeight = 0;
                    var isBottomAligned = this.hasBit(corner, constants_1.CornerBit.BOTTOM);
                    var isBottomAnchored = this.hasBit(this.anchorCorner, constants_1.CornerBit.BOTTOM);
                    var MARGIN_TO_EDGE = MDCMenuSurfaceFoundation.numbers.MARGIN_TO_EDGE;
                    // When maximum height is not specified, it is handled from CSS.
                    if (isBottomAligned) {
                        maxHeight = viewportDistance.top + this.anchorMargin.top - MARGIN_TO_EDGE;
                        if (!isBottomAnchored) maxHeight += this.measurements.anchorSize.height;
                    } else {
                        maxHeight = viewportDistance.bottom - this.anchorMargin.bottom + this.measurements.anchorSize.height - MARGIN_TO_EDGE;
                        if (isBottomAnchored) maxHeight -= this.measurements.anchorSize.height;
                    }
                    return maxHeight;
                };
                /**
     * @param corner Origin corner of the menu surface.
     * @return Horizontal offset of menu surface origin corner from corresponding anchor corner.
     */ MDCMenuSurfaceFoundation.prototype.getHorizontalOriginOffset = function(corner) {
                    var anchorSize = this.measurements.anchorSize;
                    // isRightAligned corresponds to using the 'right' property on the surface.
                    var isRightAligned = this.hasBit(corner, constants_1.CornerBit.RIGHT);
                    var avoidHorizontalOverlap = this.hasBit(this.anchorCorner, constants_1.CornerBit.RIGHT);
                    if (isRightAligned) {
                        var rightOffset = avoidHorizontalOverlap ? anchorSize.width - this.anchorMargin.left : this.anchorMargin.right;
                        // For hoisted or fixed elements, adjust the offset by the difference
                        // between viewport width and body width so when we calculate the right
                        // value (`adjustPositionForHoistedElement`) based on the element
                        // position, the right property is correct.
                        if (this.isHoistedElement || this.isFixedPosition) return rightOffset - (this.measurements.viewportSize.width - this.measurements.bodySize.width);
                        return rightOffset;
                    }
                    return avoidHorizontalOverlap ? anchorSize.width - this.anchorMargin.right : this.anchorMargin.left;
                };
                /**
     * @param corner Origin corner of the menu surface.
     * @return Vertical offset of menu surface origin corner from corresponding anchor corner.
     */ MDCMenuSurfaceFoundation.prototype.getVerticalOriginOffset = function(corner) {
                    var anchorSize = this.measurements.anchorSize;
                    var isBottomAligned = this.hasBit(corner, constants_1.CornerBit.BOTTOM);
                    var avoidVerticalOverlap = this.hasBit(this.anchorCorner, constants_1.CornerBit.BOTTOM);
                    var y = 0;
                    if (isBottomAligned) y = avoidVerticalOverlap ? anchorSize.height - this.anchorMargin.top : -this.anchorMargin.bottom;
                    else y = avoidVerticalOverlap ? anchorSize.height + this.anchorMargin.bottom : this.anchorMargin.top;
                    return y;
                };
                /** Calculates the offsets for positioning the menu-surface when the menu-surface has been hoisted to the body. */ MDCMenuSurfaceFoundation.prototype.adjustPositionForHoistedElement = function(position) {
                    var e_1, _a;
                    var _b = this.measurements, windowScroll = _b.windowScroll, viewportDistance = _b.viewportDistance, surfaceSize = _b.surfaceSize, viewportSize = _b.viewportSize;
                    var props = Object.keys(position);
                    try {
                        for(var props_1 = __values(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                            var prop = props_1_1.value;
                            var value = position[prop] || 0;
                            if (this.isHorizontallyCenteredOnViewport && (prop === "left" || prop === "right")) {
                                position[prop] = (viewportSize.width - surfaceSize.width) / 2;
                                continue;
                            }
                            // Hoisted surfaces need to have the anchor elements location on the page added to the
                            // position properties for proper alignment on the body.
                            value += viewportDistance[prop];
                            // Surfaces that are absolutely positioned need to have additional calculations for scroll
                            // and bottom positioning.
                            if (!this.isFixedPosition) {
                                if (prop === "top") value += windowScroll.y;
                                else if (prop === "bottom") value -= windowScroll.y;
                                else if (prop === "left") value += windowScroll.x;
                                else // prop === 'right'
                                value -= windowScroll.x;
                            }
                            position[prop] = value;
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                };
                /**
     * The last focused element when the menu surface was opened should regain focus, if the user is
     * focused on or within the menu surface when it is closed.
     */ MDCMenuSurfaceFoundation.prototype.maybeRestoreFocus = function() {
                    var isRootFocused = this.adapter.isFocused();
                    var childHasFocus = document.activeElement && this.adapter.isElementInContainer(document.activeElement);
                    if (isRootFocused || childHasFocus) this.adapter.restoreFocus();
                };
                MDCMenuSurfaceFoundation.prototype.hasBit = function(corner, bit) {
                    return Boolean(corner & bit); // tslint:disable-line:no-bitwise
                };
                MDCMenuSurfaceFoundation.prototype.setBit = function(corner, bit) {
                    return corner | bit; // tslint:disable-line:no-bitwise
                };
                MDCMenuSurfaceFoundation.prototype.unsetBit = function(corner, bit) {
                    return corner ^ bit;
                };
                /**
     * isFinite that doesn't force conversion to number type.
     * Equivalent to Number.isFinite in ES2015, which is not supported in IE.
     */ MDCMenuSurfaceFoundation.prototype.isFinite = function(num) {
                    return typeof num === "number" && isFinite(num);
                };
                return MDCMenuSurfaceFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCMenuSurfaceFoundation = MDCMenuSurfaceFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCMenuSurfaceFoundation;
        /***/ },
        /***/ "./packages/mdc-menu/component.ts": /*!****************************************!*\
  !*** ./packages/mdc-menu/component.ts ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCMenu = void 0;
            // TODO(b/152410470): Remove trailing underscores from private properties
            // tslint:disable:strip-private-property-underscore
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var constants_1 = __webpack_require__(/*! @material/list/constants */ "./packages/mdc-list/constants.ts");
            var foundation_1 = __webpack_require__(/*! @material/list/foundation */ "./packages/mdc-list/foundation.ts");
            var component_2 = __webpack_require__(/*! @material/menu-surface/component */ "./packages/mdc-menu-surface/component.ts");
            var foundation_2 = __webpack_require__(/*! @material/menu-surface/foundation */ "./packages/mdc-menu-surface/foundation.ts");
            var constants_2 = __webpack_require__(/*! ./constants */ "./packages/mdc-menu/constants.ts");
            var foundation_3 = __webpack_require__(/*! ./foundation */ "./packages/mdc-menu/foundation.ts");
            var MDCMenu = /** @class */ function(_super) {
                __extends(MDCMenu, _super);
                function MDCMenu() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCMenu.attachTo = function(root) {
                    return new MDCMenu(root);
                };
                MDCMenu.prototype.initialize = function(menuSurfaceFactory) {
                    if (menuSurfaceFactory === void 0) menuSurfaceFactory = function menuSurfaceFactory(el) {
                        return new component_2.MDCMenuSurface(el);
                    };
                    this.menuSurfaceFactory_ = menuSurfaceFactory;
                };
                MDCMenu.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.menuSurface_ = this.menuSurfaceFactory_(this.root);
                    var list = this.root.querySelector(constants_2.strings.LIST_SELECTOR);
                    if (list) {
                        list.init();
                        this.list_ = list.list_;
                        /* TODO(list): wrapFocus */ this.list_.wrapFocus = true;
                    } else this.list_ = null;
                    this.handleKeydown_ = function(evt) {
                        return _this.foundation.handleKeydown(evt);
                    };
                    this.handleItemAction_ = function(evt) {
                        return _this.foundation.handleItemAction(_this.items[evt.detail.index]);
                    };
                    this.handleMenuSurfaceOpened_ = function() {
                        return _this.foundation.handleMenuSurfaceOpened();
                    };
                    this.menuSurface_.listen(foundation_2.MDCMenuSurfaceFoundation.strings.OPENED_EVENT, this.handleMenuSurfaceOpened_);
                    this.listen("keydown", this.handleKeydown_);
                    this.listen(foundation_1.MDCListFoundation.strings.ACTION_EVENT, this.handleItemAction_);
                };
                MDCMenu.prototype.destroy = function() {
                    this.menuSurface_.destroy();
                    this.menuSurface_.unlisten(foundation_2.MDCMenuSurfaceFoundation.strings.OPENED_EVENT, this.handleMenuSurfaceOpened_);
                    this.unlisten("keydown", this.handleKeydown_);
                    this.unlisten(foundation_1.MDCListFoundation.strings.ACTION_EVENT, this.handleItemAction_);
                    _super.prototype.destroy.call(this);
                };
                Object.defineProperty(MDCMenu.prototype, "open", {
                    get: function get() {
                        return this.menuSurface_.isOpen();
                    },
                    set: function set(value) {
                        if (value) this.menuSurface_.open();
                        else this.menuSurface_.close();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenu.prototype, "wrapFocus", {
                    get: function get() {
                        return this.list_ ? this.list_.wrapFocus : false;
                    },
                    set: function set(value) {
                        if (this.list_) this.list_.wrapFocus = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenu.prototype, "hasTypeahead", {
                    /**
         * Sets whether the menu has typeahead functionality.
         * @param value Whether typeahead is enabled.
         */ set: function set(value) {
                        if (this.list_) this.list_.hasTypeahead = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenu.prototype, "typeaheadInProgress", {
                    /**
         * @return Whether typeahead logic is currently matching some user prefix.
         */ get: function get() {
                        return this.list_ ? this.list_.typeaheadInProgress : false;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Given the next desired character from the user, adds it to the typeahead
     * buffer. Then, attempts to find the next option matching the buffer. Wraps
     * around if at the end of options.
     *
     * @param nextChar The next character to add to the prefix buffer.
     * @param startingIndex The index from which to start matching. Only relevant
     *     when starting a new match sequence. To start a new match sequence,
     *     clear the buffer using `clearTypeaheadBuffer`, or wait for the buffer
     *     to clear after a set interval defined in list foundation. Defaults to
     *     the currently focused index.
     * @return The index of the matched item, or -1 if no match.
     */ MDCMenu.prototype.typeaheadMatchItem = function(nextChar, startingIndex) {
                    if (this.list_) return this.list_.typeaheadMatchItem(nextChar, startingIndex);
                    return -1;
                };
                /**
     * Layout the underlying list element in the case of any dynamic updates
     * to its structure.
     */ MDCMenu.prototype.layout = function() {
                    if (this.list_) this.list_.layout();
                };
                Object.defineProperty(MDCMenu.prototype, "items", {
                    /**
         * Return the items within the menu. Note that this only contains the set of elements within
         * the items container that are proper list items, and not supplemental / presentational DOM
         * elements.
         */ get: function get() {
                        return this.list_ ? this.list_.listElements : [];
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenu.prototype, "singleSelection", {
                    /**
         * Turns on/off the underlying list's single selection mode. Used mainly
         * by select menu.
         *
         * @param singleSelection Whether to enable single selection mode.
         */ set: function set(singleSelection) {
                        if (this.list_) this.list_.singleSelection = singleSelection;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenu.prototype, "selectedIndex", {
                    /**
         * Retrieves the selected index. Only applicable to select menus.
         * @return The selected index, which is a number for single selection and
         *     radio lists, and an array of numbers for checkbox lists.
         */ get: function get() {
                        return this.list_ ? this.list_.selectedIndex : constants_1.numbers.UNSET_INDEX;
                    },
                    /**
         * Sets the selected index of the list. Only applicable to select menus.
         * @param index The selected index, which is a number for single selection and
         *     radio lists, and an array of numbers for checkbox lists.
         */ set: function set(index) {
                        if (this.list_) this.list_.selectedIndex = index;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenu.prototype, "quickOpen", {
                    set: function set(quickOpen) {
                        this.menuSurface_.quickOpen = quickOpen;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Sets default focus state where the menu should focus every time when menu
     * is opened. Focuses the list root (`DefaultFocusState.LIST_ROOT`) element by
     * default.
     * @param focusState Default focus state.
     */ MDCMenu.prototype.setDefaultFocusState = function(focusState) {
                    this.foundation.setDefaultFocusState(focusState);
                };
                /**
     * @param corner Default anchor corner alignment of top-left menu corner.
     */ MDCMenu.prototype.setAnchorCorner = function(corner) {
                    this.menuSurface_.setAnchorCorner(corner);
                };
                MDCMenu.prototype.setAnchorMargin = function(margin) {
                    this.menuSurface_.setAnchorMargin(margin);
                };
                /**
     * Sets the list item as the selected row at the specified index.
     * @param index Index of list item within menu.
     */ MDCMenu.prototype.setSelectedIndex = function(index) {
                    this.foundation.setSelectedIndex(index);
                };
                /**
     * Sets the enabled state to isEnabled for the menu item at the given index.
     * @param index Index of the menu item
     * @param isEnabled The desired enabled state of the menu item.
     */ MDCMenu.prototype.setEnabled = function(index, isEnabled) {
                    this.foundation.setEnabled(index, isEnabled);
                };
                /**
     * @return The item within the menu at the index specified.
     */ MDCMenu.prototype.getOptionByIndex = function(index) {
                    var items = this.items;
                    if (index < items.length) return this.items[index];
                    else return null;
                };
                /**
     * @param index A menu item's index.
     * @return The primary text within the menu at the index specified.
     */ MDCMenu.prototype.getPrimaryTextAtIndex = function(index) {
                    var item = this.getOptionByIndex(index);
                    if (item && this.list_) return this.list_.getPrimaryText(item) || "";
                    return "";
                };
                MDCMenu.prototype.setFixedPosition = function(isFixed) {
                    this.menuSurface_.setFixedPosition(isFixed);
                };
                MDCMenu.prototype.setIsHoisted = function(isHoisted) {
                    this.menuSurface_.setIsHoisted(isHoisted);
                };
                MDCMenu.prototype.setAbsolutePosition = function(x, y) {
                    this.menuSurface_.setAbsolutePosition(x, y);
                };
                /**
     * Sets the element that the menu-surface is anchored to.
     */ MDCMenu.prototype.setAnchorElement = function(element) {
                    this.menuSurface_.anchorElement = element;
                };
                MDCMenu.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClassToElementAtIndex: function addClassToElementAtIndex(index, className) {
                            var list = _this.items;
                            list[index].classList.add(className);
                        },
                        removeClassFromElementAtIndex: function removeClassFromElementAtIndex(index, className) {
                            var list = _this.items;
                            list[index].classList.remove(className);
                        },
                        addAttributeToElementAtIndex: function addAttributeToElementAtIndex(index, attr, value) {
                            var list = _this.items;
                            list[index].setAttribute(attr, value);
                        },
                        removeAttributeFromElementAtIndex: function removeAttributeFromElementAtIndex(index, attr) {
                            var list = _this.items;
                            list[index].removeAttribute(attr);
                        },
                        elementContainsClass: function elementContainsClass(element, className) {
                            return element.classList.contains(className);
                        },
                        closeSurface: function closeSurface() {
                            return _this.emit("MDCMenu:close", {}, true);
                        },
                        getElementIndex: function getElementIndex(element) {
                            return _this.items.indexOf(element);
                        },
                        notifySelected: function notifySelected(evtData) {
                            return _this.emit(constants_2.strings.SELECTED_EVENT, {
                                index: evtData.index,
                                item: _this.items[evtData.index]
                            });
                        },
                        getMenuItemCount: function getMenuItemCount() {
                            return _this.items.length;
                        },
                        focusItemAtIndex: function focusItemAtIndex(index) {
                            return _this.items[index].focus();
                        },
                        focusListRoot: function focusListRoot() {
                            return _this.root.querySelector(constants_2.strings.LIST_SELECTOR).focus();
                        },
                        isSelectableItemAtIndex: function isSelectableItemAtIndex(index) {
                            return !!ponyfill_1.closest(_this.items[index], "." + constants_2.cssClasses.MENU_SELECTION_GROUP);
                        },
                        getSelectedSiblingOfItemAtIndex: function getSelectedSiblingOfItemAtIndex(index) {
                            var selectionGroupEl = ponyfill_1.closest(_this.items[index], "." + constants_2.cssClasses.MENU_SELECTION_GROUP);
                            var selectedItemEl = selectionGroupEl.querySelector("." + constants_2.cssClasses.MENU_SELECTED_LIST_ITEM);
                            return selectedItemEl ? _this.items.indexOf(selectedItemEl) : -1;
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_3.MDCMenuFoundation(adapter);
                };
                return MDCMenu;
            }(component_1.MDCComponent);
            exports.MDCMenu = MDCMenu;
        /***/ },
        /***/ "./packages/mdc-menu/constants.ts": /*!****************************************!*\
  !*** ./packages/mdc-menu/constants.ts ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.DefaultFocusState = exports.numbers = exports.strings = exports.cssClasses = void 0;
            var cssClasses = {
                MENU_SELECTED_LIST_ITEM: "mdc-menu-item--selected",
                MENU_SELECTION_GROUP: "mdc-menu__selection-group",
                ROOT: "mdc-menu"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                ARIA_CHECKED_ATTR: "aria-checked",
                ARIA_DISABLED_ATTR: "aria-disabled",
                CHECKBOX_SELECTOR: 'input[type="checkbox"]',
                LIST_SELECTOR: ".mdc-list,.mdc-deprecated-list",
                SELECTED_EVENT: "MDCMenu:selected"
            };
            exports.strings = strings;
            var numbers = {
                FOCUS_ROOT_INDEX: -1
            };
            exports.numbers = numbers;
            var DefaultFocusState;
            (function(DefaultFocusState) {
                DefaultFocusState[DefaultFocusState["NONE"] = 0] = "NONE";
                DefaultFocusState[DefaultFocusState["LIST_ROOT"] = 1] = "LIST_ROOT";
                DefaultFocusState[DefaultFocusState["FIRST_ITEM"] = 2] = "FIRST_ITEM";
                DefaultFocusState[DefaultFocusState["LAST_ITEM"] = 3] = "LAST_ITEM";
            })(DefaultFocusState || (DefaultFocusState = {}));
            exports.DefaultFocusState = DefaultFocusState;
        /***/ },
        /***/ "./packages/mdc-menu/custom-element.js": /*!*********************************************!*\
  !*** ./packages/mdc-menu/custom-element.js ***!
  \*********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-menu/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcMenu = function(_HTMLElement) {
                _inherits(MdcMenu, _HTMLElement);
                _createClass(MdcMenu, [
                    {
                        key: "open",
                        get: function get() {
                            return this.open_;
                        },
                        set: function set(open) {
                            this.open_ = open;
                            if (!!this.menu_) this.menu_.open = open;
                        }
                    },
                    {
                        key: "quickOpen",
                        get: function get() {
                            return this.quickOpen_;
                        },
                        set: function set(quickOpen) {
                            this.quickOpen_ = quickOpen;
                            if (!!this.menu_) this.menu_.quickOpen = quickOpen;
                        }
                    }
                ]);
                function MdcMenu() {
                    _classCallCheck(this, MdcMenu);
                    var _this = _possibleConstructorReturn(this, (MdcMenu.__proto__ || Object.getPrototypeOf(MdcMenu)).call(this));
                    _this.init_ = false;
                    _this.open_ = false;
                    _this.quickOpen_ = false;
                    _this.menu_;
                    return _this;
                }
                _createClass(MdcMenu, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.init();
                        }
                    },
                    {
                        key: "init",
                        value: function init() {
                            if (this.init_) return;
                            this.init_ = true;
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.menu_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCMenu"](this);
                            this.menu_.open = this.open_;
                            this.menu_.quickOpen = this.quickOpen_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.menu_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcMenu;
            }(HTMLElement);
            customElements.define("mdc-menu", MdcMenu);
        /***/ },
        /***/ "./packages/mdc-menu/foundation.ts": /*!*****************************************!*\
  !*** ./packages/mdc-menu/foundation.ts ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCMenuFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! @material/list/constants */ "./packages/mdc-list/constants.ts");
            var foundation_2 = __webpack_require__(/*! @material/menu-surface/foundation */ "./packages/mdc-menu-surface/foundation.ts");
            var constants_2 = __webpack_require__(/*! ./constants */ "./packages/mdc-menu/constants.ts");
            var MDCMenuFoundation = /** @class */ function(_super) {
                __extends(MDCMenuFoundation, _super);
                function MDCMenuFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCMenuFoundation.defaultAdapter), adapter)) || this;
                    _this.closeAnimationEndTimerId_ = 0;
                    _this.defaultFocusState_ = constants_2.DefaultFocusState.LIST_ROOT;
                    return _this;
                }
                Object.defineProperty(MDCMenuFoundation, "cssClasses", {
                    get: function get() {
                        return constants_2.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenuFoundation, "strings", {
                    get: function get() {
                        return constants_2.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenuFoundation, "numbers", {
                    get: function get() {
                        return constants_2.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenuFoundation, "defaultAdapter", {
                    /**
         * @see {@link MDCMenuAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClassToElementAtIndex: function addClassToElementAtIndex() {
                                return undefined;
                            },
                            removeClassFromElementAtIndex: function removeClassFromElementAtIndex() {
                                return undefined;
                            },
                            addAttributeToElementAtIndex: function addAttributeToElementAtIndex() {
                                return undefined;
                            },
                            removeAttributeFromElementAtIndex: function removeAttributeFromElementAtIndex() {
                                return undefined;
                            },
                            elementContainsClass: function elementContainsClass() {
                                return false;
                            },
                            closeSurface: function closeSurface() {
                                return undefined;
                            },
                            getElementIndex: function getElementIndex() {
                                return -1;
                            },
                            notifySelected: function notifySelected() {
                                return undefined;
                            },
                            getMenuItemCount: function getMenuItemCount() {
                                return 0;
                            },
                            focusItemAtIndex: function focusItemAtIndex() {
                                return undefined;
                            },
                            focusListRoot: function focusListRoot() {
                                return undefined;
                            },
                            getSelectedSiblingOfItemAtIndex: function getSelectedSiblingOfItemAtIndex() {
                                return -1;
                            },
                            isSelectableItemAtIndex: function isSelectableItemAtIndex() {
                                return false;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCMenuFoundation.prototype.destroy = function() {
                    if (this.closeAnimationEndTimerId_) clearTimeout(this.closeAnimationEndTimerId_);
                    this.adapter.closeSurface();
                };
                MDCMenuFoundation.prototype.handleKeydown = function(evt) {
                    var key = evt.key, keyCode = evt.keyCode;
                    var isTab = key === "Tab" || keyCode === 9;
                    if (isTab) this.adapter.closeSurface(/** skipRestoreFocus */ true);
                };
                MDCMenuFoundation.prototype.handleItemAction = function(listItem) {
                    var _this = this;
                    var index = this.adapter.getElementIndex(listItem);
                    if (index < 0) return;
                    this.adapter.notifySelected({
                        index: index
                    });
                    this.adapter.closeSurface();
                    // Wait for the menu to close before adding/removing classes that affect styles.
                    this.closeAnimationEndTimerId_ = setTimeout(function() {
                        // Recompute the index in case the menu contents have changed.
                        var recomputedIndex = _this.adapter.getElementIndex(listItem);
                        if (recomputedIndex >= 0 && _this.adapter.isSelectableItemAtIndex(recomputedIndex)) _this.setSelectedIndex(recomputedIndex);
                    }, foundation_2.MDCMenuSurfaceFoundation.numbers.TRANSITION_CLOSE_DURATION);
                };
                MDCMenuFoundation.prototype.handleMenuSurfaceOpened = function() {
                    switch(this.defaultFocusState_){
                        case constants_2.DefaultFocusState.FIRST_ITEM:
                            this.adapter.focusItemAtIndex(0);
                            break;
                        case constants_2.DefaultFocusState.LAST_ITEM:
                            this.adapter.focusItemAtIndex(this.adapter.getMenuItemCount() - 1);
                            break;
                        case constants_2.DefaultFocusState.NONE:
                            break;
                        default:
                            this.adapter.focusListRoot();
                            break;
                    }
                };
                /**
     * Sets default focus state where the menu should focus every time when menu
     * is opened. Focuses the list root (`DefaultFocusState.LIST_ROOT`) element by
     * default.
     */ MDCMenuFoundation.prototype.setDefaultFocusState = function(focusState) {
                    this.defaultFocusState_ = focusState;
                };
                /**
     * Selects the list item at `index` within the menu.
     * @param index Index of list item within the menu.
     */ MDCMenuFoundation.prototype.setSelectedIndex = function(index) {
                    this.validatedIndex_(index);
                    if (!this.adapter.isSelectableItemAtIndex(index)) throw new Error("MDCMenuFoundation: No selection group at specified index.");
                    var prevSelectedIndex = this.adapter.getSelectedSiblingOfItemAtIndex(index);
                    if (prevSelectedIndex >= 0) {
                        this.adapter.removeAttributeFromElementAtIndex(prevSelectedIndex, constants_2.strings.ARIA_CHECKED_ATTR);
                        this.adapter.removeClassFromElementAtIndex(prevSelectedIndex, constants_2.cssClasses.MENU_SELECTED_LIST_ITEM);
                    }
                    this.adapter.addClassToElementAtIndex(index, constants_2.cssClasses.MENU_SELECTED_LIST_ITEM);
                    this.adapter.addAttributeToElementAtIndex(index, constants_2.strings.ARIA_CHECKED_ATTR, "true");
                };
                /**
     * Sets the enabled state to isEnabled for the menu item at the given index.
     * @param index Index of the menu item
     * @param isEnabled The desired enabled state of the menu item.
     */ MDCMenuFoundation.prototype.setEnabled = function(index, isEnabled) {
                    this.validatedIndex_(index);
                    if (isEnabled) {
                        this.adapter.removeClassFromElementAtIndex(index, constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS);
                        this.adapter.addAttributeToElementAtIndex(index, constants_2.strings.ARIA_DISABLED_ATTR, "false");
                    } else {
                        this.adapter.addClassToElementAtIndex(index, constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS);
                        this.adapter.addAttributeToElementAtIndex(index, constants_2.strings.ARIA_DISABLED_ATTR, "true");
                    }
                };
                MDCMenuFoundation.prototype.validatedIndex_ = function(index) {
                    var menuSize = this.adapter.getMenuItemCount();
                    var isIndexInRange = index >= 0 && index < menuSize;
                    if (!isIndexInRange) throw new Error("MDCMenuFoundation: No list item at specified index.");
                };
                return MDCMenuFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCMenuFoundation = MDCMenuFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCMenuFoundation;
        /***/ },
        /***/ "./packages/mdc-notched-outline/component.ts": /*!***************************************************!*\
  !*** ./packages/mdc-notched-outline/component.ts ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCNotchedOutline = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/floating-label/foundation */ "./packages/mdc-floating-label/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-notched-outline/constants.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-notched-outline/foundation.ts");
            var MDCNotchedOutline = /** @class */ function(_super) {
                __extends(MDCNotchedOutline, _super);
                function MDCNotchedOutline() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCNotchedOutline.attachTo = function(root) {
                    return new MDCNotchedOutline(root);
                };
                MDCNotchedOutline.prototype.initialSyncWithDOM = function() {
                    this.notchElement_ = this.root.querySelector(constants_1.strings.NOTCH_ELEMENT_SELECTOR);
                    var label = this.root.querySelector("." + foundation_1.MDCFloatingLabelFoundation.cssClasses.ROOT);
                    if (label) {
                        label.style.transitionDuration = "0s";
                        this.root.classList.add(constants_1.cssClasses.OUTLINE_UPGRADED);
                        requestAnimationFrame(function() {
                            label.style.transitionDuration = "";
                        });
                    } else this.root.classList.add(constants_1.cssClasses.NO_LABEL);
                };
                /**
     * Updates classes and styles to open the notch to the specified width.
     * @param notchWidth The notch width in the outline.
     */ MDCNotchedOutline.prototype.notch = function(notchWidth) {
                    this.foundation.notch(notchWidth);
                };
                /**
     * Updates classes and styles to close the notch.
     */ MDCNotchedOutline.prototype.closeNotch = function() {
                    this.foundation.closeNotch();
                };
                MDCNotchedOutline.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        setNotchWidthProperty: function setNotchWidthProperty(width) {
                            return _this.notchElement_.style.setProperty("width", width + "px");
                        },
                        removeNotchWidthProperty: function removeNotchWidthProperty() {
                            return _this.notchElement_.style.removeProperty("width");
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_2.MDCNotchedOutlineFoundation(adapter);
                };
                return MDCNotchedOutline;
            }(component_1.MDCComponent);
            exports.MDCNotchedOutline = MDCNotchedOutline;
        /***/ },
        /***/ "./packages/mdc-notched-outline/constants.ts": /*!***************************************************!*\
  !*** ./packages/mdc-notched-outline/constants.ts ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.numbers = exports.cssClasses = void 0;
            var strings = {
                NOTCH_ELEMENT_SELECTOR: ".mdc-notched-outline__notch"
            };
            exports.strings = strings;
            var numbers = {
                // This should stay in sync with $mdc-notched-outline-padding * 2.
                NOTCH_ELEMENT_PADDING: 8
            };
            exports.numbers = numbers;
            var cssClasses = {
                NO_LABEL: "mdc-notched-outline--no-label",
                OUTLINE_NOTCHED: "mdc-notched-outline--notched",
                OUTLINE_UPGRADED: "mdc-notched-outline--upgraded"
            };
            exports.cssClasses = cssClasses;
        /***/ },
        /***/ "./packages/mdc-notched-outline/foundation.ts": /*!****************************************************!*\
  !*** ./packages/mdc-notched-outline/foundation.ts ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCNotchedOutlineFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-notched-outline/constants.ts");
            var MDCNotchedOutlineFoundation = /** @class */ function(_super) {
                __extends(MDCNotchedOutlineFoundation, _super);
                function MDCNotchedOutlineFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCNotchedOutlineFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCNotchedOutlineFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCNotchedOutlineFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCNotchedOutlineFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCNotchedOutlineFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCNotchedOutlineAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            setNotchWidthProperty: function setNotchWidthProperty() {
                                return undefined;
                            },
                            removeNotchWidthProperty: function removeNotchWidthProperty() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Adds the outline notched selector and updates the notch width calculated based off of notchWidth.
     */ MDCNotchedOutlineFoundation.prototype.notch = function(notchWidth) {
                    var OUTLINE_NOTCHED = MDCNotchedOutlineFoundation.cssClasses.OUTLINE_NOTCHED;
                    if (notchWidth > 0) notchWidth += constants_1.numbers.NOTCH_ELEMENT_PADDING; // Add padding from left/right.
                    this.adapter.setNotchWidthProperty(notchWidth);
                    this.adapter.addClass(OUTLINE_NOTCHED);
                };
                /**
     * Removes notched outline selector to close the notch in the outline.
     */ MDCNotchedOutlineFoundation.prototype.closeNotch = function() {
                    var OUTLINE_NOTCHED = MDCNotchedOutlineFoundation.cssClasses.OUTLINE_NOTCHED;
                    this.adapter.removeClass(OUTLINE_NOTCHED);
                    this.adapter.removeNotchWidthProperty();
                };
                return MDCNotchedOutlineFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCNotchedOutlineFoundation = MDCNotchedOutlineFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCNotchedOutlineFoundation;
        /***/ },
        /***/ "./packages/mdc-radio/component.ts": /*!*****************************************!*\
  !*** ./packages/mdc-radio/component.ts ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCRadio = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var events_1 = __webpack_require__(/*! @material/dom/events */ "./packages/mdc-dom/events.ts");
            var component_2 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-radio/foundation.ts");
            var MDCRadio = /** @class */ function(_super) {
                __extends(MDCRadio, _super);
                function MDCRadio() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.ripple_ = _this.createRipple_();
                    return _this;
                }
                MDCRadio.attachTo = function(root) {
                    return new MDCRadio(root);
                };
                Object.defineProperty(MDCRadio.prototype, "checked", {
                    get: function get() {
                        return this.nativeControl_.checked;
                    },
                    set: function set(checked) {
                        this.nativeControl_.checked = checked;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCRadio.prototype, "disabled", {
                    get: function get() {
                        return this.nativeControl_.disabled;
                    },
                    set: function set(disabled) {
                        this.foundation.setDisabled(disabled);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCRadio.prototype, "value", {
                    get: function get() {
                        return this.nativeControl_.value;
                    },
                    set: function set(value) {
                        this.nativeControl_.value = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCRadio.prototype, "ripple", {
                    get: function get() {
                        return this.ripple_;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCRadio.prototype.destroy = function() {
                    this.ripple_.destroy();
                    _super.prototype.destroy.call(this);
                };
                MDCRadio.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        setNativeControlDisabled: function setNativeControlDisabled(disabled) {
                            return _this.nativeControl_.disabled = disabled;
                        }
                    };
                    return new foundation_2.MDCRadioFoundation(adapter);
                };
                MDCRadio.prototype.createRipple_ = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = __assign(__assign({}, component_2.MDCRipple.createAdapter(this)), {
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            return _this.nativeControl_.addEventListener(evtType, handler, events_1.applyPassive());
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            return _this.nativeControl_.removeEventListener(evtType, handler, events_1.applyPassive());
                        },
                        // Radio buttons technically go "active" whenever there is *any* keyboard interaction.
                        // This is not the UI we desire.
                        isSurfaceActive: function isSurfaceActive() {
                            return false;
                        },
                        isUnbounded: function isUnbounded() {
                            return true;
                        }
                    });
                    // tslint:enable:object-literal-sort-keys
                    return new component_2.MDCRipple(this.root, new foundation_1.MDCRippleFoundation(adapter));
                };
                Object.defineProperty(MDCRadio.prototype, "nativeControl_", {
                    get: function get() {
                        var NATIVE_CONTROL_SELECTOR = foundation_2.MDCRadioFoundation.strings.NATIVE_CONTROL_SELECTOR;
                        var el = this.root.querySelector(NATIVE_CONTROL_SELECTOR);
                        if (!el) throw new Error("Radio component requires a " + NATIVE_CONTROL_SELECTOR + " element");
                        return el;
                    },
                    enumerable: false,
                    configurable: true
                });
                return MDCRadio;
            }(component_1.MDCComponent);
            exports.MDCRadio = MDCRadio;
        /***/ },
        /***/ "./packages/mdc-radio/constants.ts": /*!*****************************************!*\
  !*** ./packages/mdc-radio/constants.ts ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.cssClasses = exports.strings = void 0;
            var strings = {
                NATIVE_CONTROL_SELECTOR: ".mdc-radio__native-control"
            };
            exports.strings = strings;
            var cssClasses = {
                DISABLED: "mdc-radio--disabled",
                ROOT: "mdc-radio"
            };
            exports.cssClasses = cssClasses;
        /***/ },
        /***/ "./packages/mdc-radio/custom-element.js": /*!**********************************************!*\
  !*** ./packages/mdc-radio/custom-element.js ***!
  \**********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-radio/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcRadio = function(_HTMLElement) {
                _inherits(MdcRadio, _HTMLElement);
                _createClass(MdcRadio, [
                    {
                        key: "focus",
                        value: function focus() {
                            this.radio_.nativeControl_.focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            this.radio_.nativeControl_.blur();
                        }
                    },
                    {
                        key: "checked",
                        get: function get() {
                            return this.checked_;
                        },
                        set: function set(checked) {
                            this.checked_ = checked;
                            if (!!this.radio_) this.radio_.checked = checked;
                        }
                    },
                    {
                        key: "disabled",
                        get: function get() {
                            return this.disabled_;
                        },
                        set: function set(disabled) {
                            this.disabled_ = disabled;
                            if (!!this.radio_) this.radio_.disabled = disabled;
                        }
                    }
                ]);
                function MdcRadio() {
                    _classCallCheck(this, MdcRadio);
                    var _this = _possibleConstructorReturn(this, (MdcRadio.__proto__ || Object.getPrototypeOf(MdcRadio)).call(this));
                    _this.checked_ = false;
                    _this.disabled_ = false;
                    _this.radio_;
                    return _this;
                }
                _createClass(MdcRadio, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.radio_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCRadio"](this);
                            this.radio_.checked = this.checked_;
                            this.radio_.disabled = this.disabled_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.radio_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcRadio;
            }(HTMLElement);
            customElements.define("mdc-radio", MdcRadio);
        /***/ },
        /***/ "./packages/mdc-radio/foundation.ts": /*!******************************************!*\
  !*** ./packages/mdc-radio/foundation.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCRadioFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-radio/constants.ts");
            var MDCRadioFoundation = /** @class */ function(_super) {
                __extends(MDCRadioFoundation, _super);
                function MDCRadioFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCRadioFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCRadioFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCRadioFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCRadioFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            setNativeControlDisabled: function setNativeControlDisabled() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCRadioFoundation.prototype.setDisabled = function(disabled) {
                    var DISABLED = MDCRadioFoundation.cssClasses.DISABLED;
                    this.adapter.setNativeControlDisabled(disabled);
                    if (disabled) this.adapter.addClass(DISABLED);
                    else this.adapter.removeClass(DISABLED);
                };
                return MDCRadioFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCRadioFoundation = MDCRadioFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCRadioFoundation;
        /***/ },
        /***/ "./packages/mdc-ripple/component.ts": /*!******************************************!*\
  !*** ./packages/mdc-ripple/component.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                Object.defineProperty(o, k2, {
                    enumerable: true,
                    get: function get() {
                        return m[k];
                    }
                });
            } : function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
            });
            var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                Object.defineProperty(o, "default", {
                    enumerable: true,
                    value: v
                });
            } : function(o, v) {
                o["default"] = v;
            });
            var __importStar = this && this.__importStar || function(mod) {
                if (mod && mod.__esModule) return mod;
                var result = {};
                if (mod != null) {
                    for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                }
                __setModuleDefault(result, mod);
                return result;
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCRipple = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var events_1 = __webpack_require__(/*! @material/dom/events */ "./packages/mdc-dom/events.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-ripple/foundation.ts");
            var util = __importStar(__webpack_require__(/*! ./util */ "./packages/mdc-ripple/util.ts"));
            var MDCRipple = /** @class */ function(_super) {
                __extends(MDCRipple, _super);
                function MDCRipple() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.disabled = false;
                    return _this;
                }
                MDCRipple.attachTo = function(root, opts) {
                    if (opts === void 0) opts = {
                        isUnbounded: undefined
                    };
                    var ripple = new MDCRipple(root);
                    // Only override unbounded behavior if option is explicitly specified
                    if (opts.isUnbounded !== undefined) ripple.unbounded = opts.isUnbounded;
                    return ripple;
                };
                MDCRipple.createAdapter = function(instance) {
                    return {
                        addClass: function addClass(className) {
                            return instance.root.classList.add(className);
                        },
                        browserSupportsCssVars: function browserSupportsCssVars() {
                            return util.supportsCssVariables(window);
                        },
                        computeBoundingRect: function computeBoundingRect() {
                            return instance.root.getBoundingClientRect();
                        },
                        containsEventTarget: function containsEventTarget(target) {
                            return instance.root.contains(target);
                        },
                        deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler(evtType, handler) {
                            return document.documentElement.removeEventListener(evtType, handler, events_1.applyPassive());
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            return instance.root.removeEventListener(evtType, handler, events_1.applyPassive());
                        },
                        deregisterResizeHandler: function deregisterResizeHandler(handler) {
                            return window.removeEventListener("resize", handler);
                        },
                        getWindowPageOffset: function getWindowPageOffset() {
                            return {
                                x: window.pageXOffset,
                                y: window.pageYOffset
                            };
                        },
                        isSurfaceActive: function isSurfaceActive() {
                            return ponyfill_1.matches(instance.root, ":active");
                        },
                        isSurfaceDisabled: function isSurfaceDisabled() {
                            return Boolean(instance.disabled);
                        },
                        isUnbounded: function isUnbounded() {
                            return Boolean(instance.unbounded);
                        },
                        registerDocumentInteractionHandler: function registerDocumentInteractionHandler(evtType, handler) {
                            return document.documentElement.addEventListener(evtType, handler, events_1.applyPassive());
                        },
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            return instance.root.addEventListener(evtType, handler, events_1.applyPassive());
                        },
                        registerResizeHandler: function registerResizeHandler(handler) {
                            return window.addEventListener("resize", handler);
                        },
                        removeClass: function removeClass(className) {
                            return instance.root.classList.remove(className);
                        },
                        updateCssVariable: function updateCssVariable(varName, value) {
                            return instance.root.style.setProperty(varName, value);
                        }
                    };
                };
                Object.defineProperty(MDCRipple.prototype, "unbounded", {
                    get: function get() {
                        return Boolean(this.unbounded_);
                    },
                    set: function set(unbounded) {
                        this.unbounded_ = Boolean(unbounded);
                        this.setUnbounded_();
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCRipple.prototype.activate = function() {
                    this.foundation.activate();
                };
                MDCRipple.prototype.deactivate = function() {
                    this.foundation.deactivate();
                };
                MDCRipple.prototype.layout = function() {
                    this.foundation.layout();
                };
                MDCRipple.prototype.getDefaultFoundation = function() {
                    return new foundation_1.MDCRippleFoundation(MDCRipple.createAdapter(this));
                };
                MDCRipple.prototype.initialSyncWithDOM = function() {
                    var root = this.root;
                    this.unbounded = "mdcRippleIsUnbounded" in root.dataset;
                };
                /**
     * Closure Compiler throws an access control error when directly accessing a
     * protected or private property inside a getter/setter, like unbounded above.
     * By accessing the protected property inside a method, we solve that problem.
     * That's why this function exists.
     */ MDCRipple.prototype.setUnbounded_ = function() {
                    this.foundation.setUnbounded(Boolean(this.unbounded_));
                };
                return MDCRipple;
            }(component_1.MDCComponent);
            exports.MDCRipple = MDCRipple;
        /***/ },
        /***/ "./packages/mdc-ripple/constants.ts": /*!******************************************!*\
  !*** ./packages/mdc-ripple/constants.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.numbers = exports.strings = exports.cssClasses = void 0;
            exports.cssClasses = {
                // Ripple is a special case where the "root" component is really a "mixin" of sorts,
                // given that it's an 'upgrade' to an existing component. That being said it is the root
                // CSS class that all other CSS classes derive from.
                BG_FOCUSED: "mdc-ripple-upgraded--background-focused",
                FG_ACTIVATION: "mdc-ripple-upgraded--foreground-activation",
                FG_DEACTIVATION: "mdc-ripple-upgraded--foreground-deactivation",
                ROOT: "mdc-ripple-upgraded",
                UNBOUNDED: "mdc-ripple-upgraded--unbounded"
            };
            exports.strings = {
                VAR_FG_SCALE: "--mdc-ripple-fg-scale",
                VAR_FG_SIZE: "--mdc-ripple-fg-size",
                VAR_FG_TRANSLATE_END: "--mdc-ripple-fg-translate-end",
                VAR_FG_TRANSLATE_START: "--mdc-ripple-fg-translate-start",
                VAR_LEFT: "--mdc-ripple-left",
                VAR_TOP: "--mdc-ripple-top"
            };
            exports.numbers = {
                DEACTIVATION_TIMEOUT_MS: 225,
                FG_DEACTIVATION_MS: 150,
                INITIAL_ORIGIN_SCALE: 0.6,
                PADDING: 10,
                TAP_DELAY_MS: 300
            };
        /***/ },
        /***/ "./packages/mdc-ripple/custom-element.js": /*!***********************************************!*\
  !*** ./packages/mdc-ripple/custom-element.js ***!
  \***********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-ripple/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcRipple = function(_HTMLElement) {
                _inherits(MdcRipple, _HTMLElement);
                _createClass(MdcRipple, [
                    {
                        key: "unbounded",
                        get: function get() {
                            return this.unbounded_;
                        },
                        set: function set(unbounded) {
                            this.unbounded_ = unbounded;
                            if (!!this.ripple_) this.ripple_.unbounded = unbounded;
                        }
                    }
                ]);
                function MdcRipple() {
                    _classCallCheck(this, MdcRipple);
                    var _this = _possibleConstructorReturn(this, (MdcRipple.__proto__ || Object.getPrototypeOf(MdcRipple)).call(this));
                    _this.unbounded_ = false;
                    _this.ripple_;
                    return _this;
                }
                _createClass(MdcRipple, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.ripple_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCRipple"](this);
                            this.ripple_.unbounded = this.unbounded_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.ripple_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcRipple;
            }(HTMLElement);
            customElements.define("mdc-ripple", MdcRipple);
        /***/ },
        /***/ "./packages/mdc-ripple/foundation.ts": /*!*******************************************!*\
  !*** ./packages/mdc-ripple/foundation.ts ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCRippleFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-ripple/constants.ts");
            var util_1 = __webpack_require__(/*! ./util */ "./packages/mdc-ripple/util.ts");
            // Activation events registered on the root element of each instance for activation
            var ACTIVATION_EVENT_TYPES = [
                "touchstart",
                "pointerdown",
                "mousedown",
                "keydown"
            ];
            // Deactivation events registered on documentElement when a pointer-related down event occurs
            var POINTER_DEACTIVATION_EVENT_TYPES = [
                "touchend",
                "pointerup",
                "mouseup",
                "contextmenu"
            ];
            // simultaneous nested activations
            var activatedTargets = [];
            var MDCRippleFoundation = /** @class */ function(_super) {
                __extends(MDCRippleFoundation, _super);
                function MDCRippleFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCRippleFoundation.defaultAdapter), adapter)) || this;
                    _this.activationAnimationHasEnded_ = false;
                    _this.activationTimer_ = 0;
                    _this.fgDeactivationRemovalTimer_ = 0;
                    _this.fgScale_ = "0";
                    _this.frame_ = {
                        width: 0,
                        height: 0
                    };
                    _this.initialSize_ = 0;
                    _this.layoutFrame_ = 0;
                    _this.maxRadius_ = 0;
                    _this.unboundedCoords_ = {
                        left: 0,
                        top: 0
                    };
                    _this.activationState_ = _this.defaultActivationState_();
                    _this.activationTimerCallback_ = function() {
                        _this.activationAnimationHasEnded_ = true;
                        _this.runDeactivationUXLogicIfReady_();
                    };
                    _this.activateHandler_ = function(e) {
                        return _this.activate_(e);
                    };
                    _this.deactivateHandler_ = function() {
                        return _this.deactivate_();
                    };
                    _this.focusHandler_ = function() {
                        return _this.handleFocus();
                    };
                    _this.blurHandler_ = function() {
                        return _this.handleBlur();
                    };
                    _this.resizeHandler_ = function() {
                        return _this.layout();
                    };
                    return _this;
                }
                Object.defineProperty(MDCRippleFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCRippleFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCRippleFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCRippleFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            browserSupportsCssVars: function browserSupportsCssVars() {
                                return true;
                            },
                            computeBoundingRect: function computeBoundingRect() {
                                return {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                    width: 0,
                                    height: 0
                                };
                            },
                            containsEventTarget: function containsEventTarget() {
                                return true;
                            },
                            deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler() {
                                return undefined;
                            },
                            deregisterInteractionHandler: function deregisterInteractionHandler() {
                                return undefined;
                            },
                            deregisterResizeHandler: function deregisterResizeHandler() {
                                return undefined;
                            },
                            getWindowPageOffset: function getWindowPageOffset() {
                                return {
                                    x: 0,
                                    y: 0
                                };
                            },
                            isSurfaceActive: function isSurfaceActive() {
                                return true;
                            },
                            isSurfaceDisabled: function isSurfaceDisabled() {
                                return true;
                            },
                            isUnbounded: function isUnbounded() {
                                return true;
                            },
                            registerDocumentInteractionHandler: function registerDocumentInteractionHandler() {
                                return undefined;
                            },
                            registerInteractionHandler: function registerInteractionHandler() {
                                return undefined;
                            },
                            registerResizeHandler: function registerResizeHandler() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            updateCssVariable: function updateCssVariable() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCRippleFoundation.prototype.init = function() {
                    var _this = this;
                    var supportsPressRipple = this.supportsPressRipple_();
                    this.registerRootHandlers_(supportsPressRipple);
                    if (supportsPressRipple) {
                        var _a = MDCRippleFoundation.cssClasses, ROOT_1 = _a.ROOT, UNBOUNDED_1 = _a.UNBOUNDED;
                        requestAnimationFrame(function() {
                            _this.adapter.addClass(ROOT_1);
                            if (_this.adapter.isUnbounded()) {
                                _this.adapter.addClass(UNBOUNDED_1);
                                // Unbounded ripples need layout logic applied immediately to set coordinates for both shade and ripple
                                _this.layoutInternal_();
                            }
                        });
                    }
                };
                MDCRippleFoundation.prototype.destroy = function() {
                    var _this = this;
                    if (this.supportsPressRipple_()) {
                        if (this.activationTimer_) {
                            clearTimeout(this.activationTimer_);
                            this.activationTimer_ = 0;
                            this.adapter.removeClass(MDCRippleFoundation.cssClasses.FG_ACTIVATION);
                        }
                        if (this.fgDeactivationRemovalTimer_) {
                            clearTimeout(this.fgDeactivationRemovalTimer_);
                            this.fgDeactivationRemovalTimer_ = 0;
                            this.adapter.removeClass(MDCRippleFoundation.cssClasses.FG_DEACTIVATION);
                        }
                        var _a = MDCRippleFoundation.cssClasses, ROOT_2 = _a.ROOT, UNBOUNDED_2 = _a.UNBOUNDED;
                        requestAnimationFrame(function() {
                            _this.adapter.removeClass(ROOT_2);
                            _this.adapter.removeClass(UNBOUNDED_2);
                            _this.removeCssVars_();
                        });
                    }
                    this.deregisterRootHandlers_();
                    this.deregisterDeactivationHandlers_();
                };
                /**
     * @param evt Optional event containing position information.
     */ MDCRippleFoundation.prototype.activate = function(evt) {
                    this.activate_(evt);
                };
                MDCRippleFoundation.prototype.deactivate = function() {
                    this.deactivate_();
                };
                MDCRippleFoundation.prototype.layout = function() {
                    var _this = this;
                    if (this.layoutFrame_) cancelAnimationFrame(this.layoutFrame_);
                    this.layoutFrame_ = requestAnimationFrame(function() {
                        _this.layoutInternal_();
                        _this.layoutFrame_ = 0;
                    });
                };
                MDCRippleFoundation.prototype.setUnbounded = function(unbounded) {
                    var UNBOUNDED = MDCRippleFoundation.cssClasses.UNBOUNDED;
                    if (unbounded) this.adapter.addClass(UNBOUNDED);
                    else this.adapter.removeClass(UNBOUNDED);
                };
                MDCRippleFoundation.prototype.handleFocus = function() {
                    var _this = this;
                    requestAnimationFrame(function() {
                        return _this.adapter.addClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
                    });
                };
                MDCRippleFoundation.prototype.handleBlur = function() {
                    var _this = this;
                    requestAnimationFrame(function() {
                        return _this.adapter.removeClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
                    });
                };
                /**
     * We compute this property so that we are not querying information about the client
     * until the point in time where the foundation requests it. This prevents scenarios where
     * client-side feature-detection may happen too early, such as when components are rendered on the server
     * and then initialized at mount time on the client.
     */ MDCRippleFoundation.prototype.supportsPressRipple_ = function() {
                    return this.adapter.browserSupportsCssVars();
                };
                MDCRippleFoundation.prototype.defaultActivationState_ = function() {
                    return {
                        activationEvent: undefined,
                        hasDeactivationUXRun: false,
                        isActivated: false,
                        isProgrammatic: false,
                        wasActivatedByPointer: false,
                        wasElementMadeActive: false
                    };
                };
                /**
     * supportsPressRipple Passed from init to save a redundant function call
     */ MDCRippleFoundation.prototype.registerRootHandlers_ = function(supportsPressRipple) {
                    var _this = this;
                    if (supportsPressRipple) {
                        ACTIVATION_EVENT_TYPES.forEach(function(evtType) {
                            _this.adapter.registerInteractionHandler(evtType, _this.activateHandler_);
                        });
                        if (this.adapter.isUnbounded()) this.adapter.registerResizeHandler(this.resizeHandler_);
                    }
                    this.adapter.registerInteractionHandler("focus", this.focusHandler_);
                    this.adapter.registerInteractionHandler("blur", this.blurHandler_);
                };
                MDCRippleFoundation.prototype.registerDeactivationHandlers_ = function(evt) {
                    var _this = this;
                    if (evt.type === "keydown") this.adapter.registerInteractionHandler("keyup", this.deactivateHandler_);
                    else POINTER_DEACTIVATION_EVENT_TYPES.forEach(function(evtType) {
                        _this.adapter.registerDocumentInteractionHandler(evtType, _this.deactivateHandler_);
                    });
                };
                MDCRippleFoundation.prototype.deregisterRootHandlers_ = function() {
                    var _this = this;
                    ACTIVATION_EVENT_TYPES.forEach(function(evtType) {
                        _this.adapter.deregisterInteractionHandler(evtType, _this.activateHandler_);
                    });
                    this.adapter.deregisterInteractionHandler("focus", this.focusHandler_);
                    this.adapter.deregisterInteractionHandler("blur", this.blurHandler_);
                    if (this.adapter.isUnbounded()) this.adapter.deregisterResizeHandler(this.resizeHandler_);
                };
                MDCRippleFoundation.prototype.deregisterDeactivationHandlers_ = function() {
                    var _this = this;
                    this.adapter.deregisterInteractionHandler("keyup", this.deactivateHandler_);
                    POINTER_DEACTIVATION_EVENT_TYPES.forEach(function(evtType) {
                        _this.adapter.deregisterDocumentInteractionHandler(evtType, _this.deactivateHandler_);
                    });
                };
                MDCRippleFoundation.prototype.removeCssVars_ = function() {
                    var _this = this;
                    var rippleStrings = MDCRippleFoundation.strings;
                    var keys = Object.keys(rippleStrings);
                    keys.forEach(function(key) {
                        if (key.indexOf("VAR_") === 0) _this.adapter.updateCssVariable(rippleStrings[key], null);
                    });
                };
                MDCRippleFoundation.prototype.activate_ = function(evt) {
                    var _this = this;
                    if (this.adapter.isSurfaceDisabled()) return;
                    var activationState = this.activationState_;
                    if (activationState.isActivated) return;
                    // Avoid reacting to follow-on events fired by touch device after an already-processed user interaction
                    var previousActivationEvent = this.previousActivationEvent_;
                    var isSameInteraction = previousActivationEvent && evt !== undefined && previousActivationEvent.type !== evt.type;
                    if (isSameInteraction) return;
                    activationState.isActivated = true;
                    activationState.isProgrammatic = evt === undefined;
                    activationState.activationEvent = evt;
                    activationState.wasActivatedByPointer = activationState.isProgrammatic ? false : evt !== undefined && (evt.type === "mousedown" || evt.type === "touchstart" || evt.type === "pointerdown");
                    var hasActivatedChild = evt !== undefined && activatedTargets.length > 0 && activatedTargets.some(function(target) {
                        return _this.adapter.containsEventTarget(target);
                    });
                    if (hasActivatedChild) {
                        // Immediately reset activation state, while preserving logic that prevents touch follow-on events
                        this.resetActivationState_();
                        return;
                    }
                    if (evt !== undefined) {
                        activatedTargets.push(evt.target);
                        this.registerDeactivationHandlers_(evt);
                    }
                    activationState.wasElementMadeActive = this.checkElementMadeActive_(evt);
                    if (activationState.wasElementMadeActive) this.animateActivation_();
                    requestAnimationFrame(function() {
                        // Reset array on next frame after the current event has had a chance to bubble to prevent ancestor ripples
                        activatedTargets = [];
                        if (!activationState.wasElementMadeActive && evt !== undefined && (evt.key === " " || evt.keyCode === 32)) {
                            // If space was pressed, try again within an rAF call to detect :active, because different UAs report
                            // active states inconsistently when they're called within event handling code:
                            // - https://bugs.chromium.org/p/chromium/issues/detail?id=635971
                            // - https://bugzilla.mozilla.org/show_bug.cgi?id=1293741
                            // We try first outside rAF to support Edge, which does not exhibit this problem, but will crash if a CSS
                            // variable is set within a rAF callback for a submit button interaction (#2241).
                            activationState.wasElementMadeActive = _this.checkElementMadeActive_(evt);
                            if (activationState.wasElementMadeActive) _this.animateActivation_();
                        }
                        if (!activationState.wasElementMadeActive) // Reset activation state immediately if element was not made active.
                        _this.activationState_ = _this.defaultActivationState_();
                    });
                };
                MDCRippleFoundation.prototype.checkElementMadeActive_ = function(evt) {
                    return evt !== undefined && evt.type === "keydown" ? this.adapter.isSurfaceActive() : true;
                };
                MDCRippleFoundation.prototype.animateActivation_ = function() {
                    var _this = this;
                    var _a = MDCRippleFoundation.strings, VAR_FG_TRANSLATE_START = _a.VAR_FG_TRANSLATE_START, VAR_FG_TRANSLATE_END = _a.VAR_FG_TRANSLATE_END;
                    var _b = MDCRippleFoundation.cssClasses, FG_DEACTIVATION = _b.FG_DEACTIVATION, FG_ACTIVATION = _b.FG_ACTIVATION;
                    var DEACTIVATION_TIMEOUT_MS = MDCRippleFoundation.numbers.DEACTIVATION_TIMEOUT_MS;
                    this.layoutInternal_();
                    var translateStart = "";
                    var translateEnd = "";
                    if (!this.adapter.isUnbounded()) {
                        var _c = this.getFgTranslationCoordinates_(), startPoint = _c.startPoint, endPoint = _c.endPoint;
                        translateStart = startPoint.x + "px, " + startPoint.y + "px";
                        translateEnd = endPoint.x + "px, " + endPoint.y + "px";
                    }
                    this.adapter.updateCssVariable(VAR_FG_TRANSLATE_START, translateStart);
                    this.adapter.updateCssVariable(VAR_FG_TRANSLATE_END, translateEnd);
                    // Cancel any ongoing activation/deactivation animations
                    clearTimeout(this.activationTimer_);
                    clearTimeout(this.fgDeactivationRemovalTimer_);
                    this.rmBoundedActivationClasses_();
                    this.adapter.removeClass(FG_DEACTIVATION);
                    // Force layout in order to re-trigger the animation.
                    this.adapter.computeBoundingRect();
                    this.adapter.addClass(FG_ACTIVATION);
                    this.activationTimer_ = setTimeout(function() {
                        return _this.activationTimerCallback_();
                    }, DEACTIVATION_TIMEOUT_MS);
                };
                MDCRippleFoundation.prototype.getFgTranslationCoordinates_ = function() {
                    var _a = this.activationState_, activationEvent = _a.activationEvent, wasActivatedByPointer = _a.wasActivatedByPointer;
                    var startPoint;
                    if (wasActivatedByPointer) startPoint = util_1.getNormalizedEventCoords(activationEvent, this.adapter.getWindowPageOffset(), this.adapter.computeBoundingRect());
                    else startPoint = {
                        x: this.frame_.width / 2,
                        y: this.frame_.height / 2
                    };
                    // Center the element around the start point.
                    startPoint = {
                        x: startPoint.x - this.initialSize_ / 2,
                        y: startPoint.y - this.initialSize_ / 2
                    };
                    var endPoint = {
                        x: this.frame_.width / 2 - this.initialSize_ / 2,
                        y: this.frame_.height / 2 - this.initialSize_ / 2
                    };
                    return {
                        startPoint: startPoint,
                        endPoint: endPoint
                    };
                };
                MDCRippleFoundation.prototype.runDeactivationUXLogicIfReady_ = function() {
                    var _this = this;
                    // This method is called both when a pointing device is released, and when the activation animation ends.
                    // The deactivation animation should only run after both of those occur.
                    var FG_DEACTIVATION = MDCRippleFoundation.cssClasses.FG_DEACTIVATION;
                    var _a = this.activationState_, hasDeactivationUXRun = _a.hasDeactivationUXRun, isActivated = _a.isActivated;
                    var activationHasEnded = hasDeactivationUXRun || !isActivated;
                    if (activationHasEnded && this.activationAnimationHasEnded_) {
                        this.rmBoundedActivationClasses_();
                        this.adapter.addClass(FG_DEACTIVATION);
                        this.fgDeactivationRemovalTimer_ = setTimeout(function() {
                            _this.adapter.removeClass(FG_DEACTIVATION);
                        }, constants_1.numbers.FG_DEACTIVATION_MS);
                    }
                };
                MDCRippleFoundation.prototype.rmBoundedActivationClasses_ = function() {
                    var FG_ACTIVATION = MDCRippleFoundation.cssClasses.FG_ACTIVATION;
                    this.adapter.removeClass(FG_ACTIVATION);
                    this.activationAnimationHasEnded_ = false;
                    this.adapter.computeBoundingRect();
                };
                MDCRippleFoundation.prototype.resetActivationState_ = function() {
                    var _this = this;
                    this.previousActivationEvent_ = this.activationState_.activationEvent;
                    this.activationState_ = this.defaultActivationState_();
                    // Touch devices may fire additional events for the same interaction within a short time.
                    // Store the previous event until it's safe to assume that subsequent events are for new interactions.
                    setTimeout(function() {
                        return _this.previousActivationEvent_ = undefined;
                    }, MDCRippleFoundation.numbers.TAP_DELAY_MS);
                };
                MDCRippleFoundation.prototype.deactivate_ = function() {
                    var _this = this;
                    var activationState = this.activationState_;
                    // This can happen in scenarios such as when you have a keyup event that blurs the element.
                    if (!activationState.isActivated) return;
                    var state = __assign({}, activationState);
                    if (activationState.isProgrammatic) {
                        requestAnimationFrame(function() {
                            return _this.animateDeactivation_(state);
                        });
                        this.resetActivationState_();
                    } else {
                        this.deregisterDeactivationHandlers_();
                        requestAnimationFrame(function() {
                            _this.activationState_.hasDeactivationUXRun = true;
                            _this.animateDeactivation_(state);
                            _this.resetActivationState_();
                        });
                    }
                };
                MDCRippleFoundation.prototype.animateDeactivation_ = function(_a) {
                    var wasActivatedByPointer = _a.wasActivatedByPointer, wasElementMadeActive = _a.wasElementMadeActive;
                    if (wasActivatedByPointer || wasElementMadeActive) this.runDeactivationUXLogicIfReady_();
                };
                MDCRippleFoundation.prototype.layoutInternal_ = function() {
                    var _this = this;
                    this.frame_ = this.adapter.computeBoundingRect();
                    var maxDim = Math.max(this.frame_.height, this.frame_.width);
                    // Surface diameter is treated differently for unbounded vs. bounded ripples.
                    // Unbounded ripple diameter is calculated smaller since the surface is expected to already be padded appropriately
                    // to extend the hitbox, and the ripple is expected to meet the edges of the padded hitbox (which is typically
                    // square). Bounded ripples, on the other hand, are fully expected to expand beyond the surface's longest diameter
                    // (calculated based on the diagonal plus a constant padding), and are clipped at the surface's border via
                    // `overflow: hidden`.
                    var getBoundedRadius = function getBoundedRadius() {
                        var hypotenuse = Math.sqrt(Math.pow(_this.frame_.width, 2) + Math.pow(_this.frame_.height, 2));
                        return hypotenuse + MDCRippleFoundation.numbers.PADDING;
                    };
                    this.maxRadius_ = this.adapter.isUnbounded() ? maxDim : getBoundedRadius();
                    // Ripple is sized as a fraction of the largest dimension of the surface, then scales up using a CSS scale transform
                    var initialSize = Math.floor(maxDim * MDCRippleFoundation.numbers.INITIAL_ORIGIN_SCALE);
                    // Unbounded ripple size should always be even number to equally center align.
                    if (this.adapter.isUnbounded() && initialSize % 2 !== 0) this.initialSize_ = initialSize - 1;
                    else this.initialSize_ = initialSize;
                    this.fgScale_ = "" + this.maxRadius_ / this.initialSize_;
                    this.updateLayoutCssVars_();
                };
                MDCRippleFoundation.prototype.updateLayoutCssVars_ = function() {
                    var _a = MDCRippleFoundation.strings, VAR_FG_SIZE = _a.VAR_FG_SIZE, VAR_LEFT = _a.VAR_LEFT, VAR_TOP = _a.VAR_TOP, VAR_FG_SCALE = _a.VAR_FG_SCALE;
                    this.adapter.updateCssVariable(VAR_FG_SIZE, this.initialSize_ + "px");
                    this.adapter.updateCssVariable(VAR_FG_SCALE, this.fgScale_);
                    if (this.adapter.isUnbounded()) {
                        this.unboundedCoords_ = {
                            left: Math.round(this.frame_.width / 2 - this.initialSize_ / 2),
                            top: Math.round(this.frame_.height / 2 - this.initialSize_ / 2)
                        };
                        this.adapter.updateCssVariable(VAR_LEFT, this.unboundedCoords_.left + "px");
                        this.adapter.updateCssVariable(VAR_TOP, this.unboundedCoords_.top + "px");
                    }
                };
                return MDCRippleFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCRippleFoundation = MDCRippleFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCRippleFoundation;
        /***/ },
        /***/ "./packages/mdc-ripple/util.ts": /*!*************************************!*\
  !*** ./packages/mdc-ripple/util.ts ***!
  \*************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.getNormalizedEventCoords = exports.supportsCssVariables = void 0;
            /**
 * Stores result from supportsCssVariables to avoid redundant processing to
 * detect CSS custom variable support.
 */ var supportsCssVariables_;
            function supportsCssVariables(windowObj, forceRefresh) {
                if (forceRefresh === void 0) forceRefresh = false;
                var CSS = windowObj.CSS;
                var supportsCssVars = supportsCssVariables_;
                if (typeof supportsCssVariables_ === "boolean" && !forceRefresh) return supportsCssVariables_;
                var supportsFunctionPresent = CSS && typeof CSS.supports === "function";
                if (!supportsFunctionPresent) return false;
                var explicitlySupportsCssVars = CSS.supports("--css-vars", "yes");
                // See: https://bugs.webkit.org/show_bug.cgi?id=154669
                // See: README section on Safari
                var weAreFeatureDetectingSafari10plus = CSS.supports("(--css-vars: yes)") && CSS.supports("color", "#00000000");
                supportsCssVars = explicitlySupportsCssVars || weAreFeatureDetectingSafari10plus;
                if (!forceRefresh) supportsCssVariables_ = supportsCssVars;
                return supportsCssVars;
            }
            exports.supportsCssVariables = supportsCssVariables;
            function getNormalizedEventCoords(evt, pageOffset, clientRect) {
                if (!evt) return {
                    x: 0,
                    y: 0
                };
                var x = pageOffset.x, y = pageOffset.y;
                var documentX = x + clientRect.left;
                var documentY = y + clientRect.top;
                var normalizedX;
                var normalizedY;
                // Determine touch point relative to the ripple container.
                if (evt.type === "touchstart") {
                    var touchEvent = evt;
                    normalizedX = touchEvent.changedTouches[0].pageX - documentX;
                    normalizedY = touchEvent.changedTouches[0].pageY - documentY;
                } else {
                    var mouseEvent = evt;
                    normalizedX = mouseEvent.pageX - documentX;
                    normalizedY = mouseEvent.pageY - documentY;
                }
                return {
                    x: normalizedX,
                    y: normalizedY
                };
            }
            exports.getNormalizedEventCoords = getNormalizedEventCoords;
        /***/ },
        /***/ "./packages/mdc-select/component.ts": /*!******************************************!*\
  !*** ./packages/mdc-select/component.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                Object.defineProperty(o, k2, {
                    enumerable: true,
                    get: function get() {
                        return m[k];
                    }
                });
            } : function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
            });
            var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                Object.defineProperty(o, "default", {
                    enumerable: true,
                    value: v
                });
            } : function(o, v) {
                o["default"] = v;
            });
            var __importStar = this && this.__importStar || function(mod) {
                if (mod && mod.__esModule) return mod;
                var result = {};
                if (mod != null) {
                    for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                }
                __setModuleDefault(result, mod);
                return result;
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSelect = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var component_2 = __webpack_require__(/*! @material/floating-label/component */ "./packages/mdc-floating-label/component.ts");
            var component_3 = __webpack_require__(/*! @material/line-ripple/component */ "./packages/mdc-line-ripple/component.ts");
            var menuSurfaceConstants = __importStar(__webpack_require__(/*! @material/menu-surface/constants */ "./packages/mdc-menu-surface/constants.ts"));
            var menuConstants = __importStar(__webpack_require__(/*! @material/menu/constants */ "./packages/mdc-menu/constants.ts"));
            var component_4 = __webpack_require__(/*! @material/notched-outline/component */ "./packages/mdc-notched-outline/component.ts");
            var component_5 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-select/constants.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-select/foundation.ts");
            var component_6 = __webpack_require__(/*! ./helper-text/component */ "./packages/mdc-select/helper-text/component.ts");
            var component_7 = __webpack_require__(/*! ./icon/component */ "./packages/mdc-select/icon/component.ts");
            var MDCSelect = /** @class */ function(_super) {
                __extends(MDCSelect, _super);
                function MDCSelect() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCSelect.attachTo = function(root) {
                    return new MDCSelect(root);
                };
                MDCSelect.prototype.initialize = function(labelFactory, lineRippleFactory, outlineFactory, iconFactory, helperTextFactory) {
                    if (labelFactory === void 0) labelFactory = function labelFactory(el) {
                        return new component_2.MDCFloatingLabel(el);
                    };
                    if (lineRippleFactory === void 0) lineRippleFactory = function lineRippleFactory(el) {
                        return new component_3.MDCLineRipple(el);
                    };
                    if (outlineFactory === void 0) outlineFactory = function outlineFactory(el) {
                        return new component_4.MDCNotchedOutline(el);
                    };
                    if (iconFactory === void 0) iconFactory = function iconFactory(el) {
                        return new component_7.MDCSelectIcon(el);
                    };
                    if (helperTextFactory === void 0) helperTextFactory = function helperTextFactory(el) {
                        return new component_6.MDCSelectHelperText(el);
                    };
                    this.selectAnchor = this.root.querySelector(constants_1.strings.SELECT_ANCHOR_SELECTOR);
                    this.selectedText = this.root.querySelector(constants_1.strings.SELECTED_TEXT_SELECTOR);
                    this.hiddenInput = this.root.querySelector(constants_1.strings.HIDDEN_INPUT_SELECTOR);
                    if (!this.selectedText) throw new Error("MDCSelect: Missing required element: The following selector must be present: " + ("'" + constants_1.strings.SELECTED_TEXT_SELECTOR + "'"));
                    if (this.selectAnchor.hasAttribute(constants_1.strings.ARIA_CONTROLS)) {
                        var helperTextElement = document.getElementById(this.selectAnchor.getAttribute(constants_1.strings.ARIA_CONTROLS));
                        if (helperTextElement) this.helperText = helperTextFactory(helperTextElement);
                    }
                    this.menuSetup();
                    var labelElement = this.root.querySelector(constants_1.strings.LABEL_SELECTOR);
                    this.label = labelElement ? labelFactory(labelElement) : null;
                    var lineRippleElement = this.root.querySelector(constants_1.strings.LINE_RIPPLE_SELECTOR);
                    this.lineRipple = lineRippleElement ? lineRippleFactory(lineRippleElement) : null;
                    var outlineElement = this.root.querySelector(constants_1.strings.OUTLINE_SELECTOR);
                    this.outline = outlineElement ? outlineFactory(outlineElement) : null;
                    var leadingIcon = this.root.querySelector(constants_1.strings.LEADING_ICON_SELECTOR);
                    if (leadingIcon) this.leadingIcon = iconFactory(leadingIcon);
                    if (!this.root.classList.contains(constants_1.cssClasses.OUTLINED)) this.ripple = this.createRipple();
                };
                /**
     * Initializes the select's event listeners and internal state based
     * on the environment's state.
     */ MDCSelect.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.handleFocus = function() {
                        _this.foundation.handleFocus();
                    };
                    this.handleBlur = function() {
                        _this.foundation.handleBlur();
                    };
                    this.handleClick = function(evt) {
                        _this.selectAnchor.focus();
                        _this.foundation.handleClick(_this.getNormalizedXCoordinate(evt));
                    };
                    this.handleKeydown = function(evt) {
                        _this.foundation.handleKeydown(evt);
                    };
                    this.handleMenuItemAction = function(evt) {
                        _this.foundation.handleMenuItemAction(evt.detail.index);
                    };
                    this.handleMenuOpened = function() {
                        _this.foundation.handleMenuOpened();
                    };
                    this.handleMenuClose = function() {
                        _this.menu.open = false;
                    };
                    this.handleMenuClosed = function() {
                        _this.foundation.handleMenuClosed();
                    };
                    this.handleMenuClosing = function() {
                        _this.foundation.handleMenuClosing();
                    };
                    this.selectAnchor.addEventListener("focus", this.handleFocus);
                    this.selectAnchor.addEventListener("blur", this.handleBlur);
                    this.selectAnchor.addEventListener("click", this.handleClick);
                    this.selectAnchor.addEventListener("keydown", this.handleKeydown);
                    this.menu.listen("MDCMenuSurface:close", this.handleMenuClose);
                    this.menu.listen(menuSurfaceConstants.strings.CLOSED_EVENT, this.handleMenuClosed);
                    this.menu.listen(menuSurfaceConstants.strings.CLOSING_EVENT, this.handleMenuClosing);
                    this.menu.listen(menuSurfaceConstants.strings.OPENED_EVENT, this.handleMenuOpened);
                    this.menu.listen(menuConstants.strings.SELECTED_EVENT, this.handleMenuItemAction);
                    if (this.hiddenInput) {
                        if (this.hiddenInput.value) {
                            // If the hidden input already has a value, use it to restore the
                            // select's value. This can happen e.g. if the user goes back or (in
                            // some browsers) refreshes the page.
                            this.foundation.layout();
                            return;
                        }
                    }
                };
                MDCSelect.prototype.destroy = function() {
                    this.selectAnchor.removeEventListener("focus", this.handleFocus);
                    this.selectAnchor.removeEventListener("blur", this.handleBlur);
                    this.selectAnchor.removeEventListener("keydown", this.handleKeydown);
                    this.selectAnchor.removeEventListener("click", this.handleClick);
                    this.menu.unlisten("MDCMenuSurface:close", this.handleMenuClose);
                    this.menu.unlisten(menuSurfaceConstants.strings.CLOSED_EVENT, this.handleMenuClosed);
                    this.menu.unlisten(menuSurfaceConstants.strings.CLOSING_EVENT, this.handleMenuClosed);
                    this.menu.unlisten(menuSurfaceConstants.strings.OPENED_EVENT, this.handleMenuOpened);
                    this.menu.unlisten(menuConstants.strings.SELECTED_EVENT, this.handleMenuItemAction);
                    this.menu.destroy();
                    if (this.ripple) this.ripple.destroy();
                    if (this.outline) this.outline.destroy();
                    if (this.leadingIcon) this.leadingIcon.destroy();
                    if (this.helperText) this.helperText.destroy();
                    _super.prototype.destroy.call(this);
                };
                Object.defineProperty(MDCSelect.prototype, "menuItemValues", {
                    get: function get() {
                        return this.menu.items.map(function(el) {
                            return el.getAttribute(constants_1.strings.VALUE_ATTR) || "";
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSelect.prototype.clickMenuItem = function(index) {
                    if (index < 0 || index >= this.menu.items.length) return;
                    this.menu.items[index].click();
                };
                Object.defineProperty(MDCSelect.prototype, "selectedIndex", {
                    get: function get() {
                        return this.foundation.getSelectedIndex();
                    },
                    set: function set(selectedIndex) {
                        this.foundation.setSelectedIndex(selectedIndex, /* closeMenu */ true);
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSelect.prototype.setSelectedIndex = function(selectedIndex, skipNotify) {
                    if (skipNotify === void 0) skipNotify = false;
                    this.foundation.setSelectedIndex(selectedIndex, /* closeMenu */ true, skipNotify);
                };
                Object.defineProperty(MDCSelect.prototype, "disabled", {
                    get: function get() {
                        return this.foundation.getDisabled();
                    },
                    set: function set(disabled) {
                        this.foundation.setDisabled(disabled);
                        if (this.hiddenInput) this.hiddenInput.disabled = disabled;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelect.prototype, "leadingIconAriaLabel", {
                    set: function set(label) {
                        this.foundation.setLeadingIconAriaLabel(label);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelect.prototype, "leadingIconContent", {
                    /**
         * Sets the text content of the leading icon.
         */ set: function set(content) {
                        this.foundation.setLeadingIconContent(content);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelect.prototype, "helperTextContent", {
                    /**
         * Sets the text content of the helper text.
         */ set: function set(content) {
                        this.foundation.setHelperTextContent(content);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelect.prototype, "useDefaultValidation", {
                    /**
         * Enables or disables the default validation scheme where a required select
         * must be non-empty. Set to false for custom validation.
         * @param useDefaultValidation Set this to false to ignore default
         *     validation scheme.
         */ set: function set(useDefaultValidation) {
                        this.foundation.setUseDefaultValidation(useDefaultValidation);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelect.prototype, "valid", {
                    /**
         * Checks if the select is in a valid state.
         */ get: function get() {
                        return this.foundation.isValid();
                    },
                    /**
         * Sets the current invalid state of the select.
         */ set: function set(isValid) {
                        this.foundation.setValid(isValid);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelect.prototype, "required", {
                    /**
         * Returns whether the select is required.
         */ get: function get() {
                        return this.foundation.getRequired();
                    },
                    /**
         * Sets the control to the required state.
         */ set: function set(isRequired) {
                        this.foundation.setRequired(isRequired);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Re-calculates if the notched outline should be notched and if the label
     * should float.
     */ MDCSelect.prototype.layout = function() {
                    this.foundation.layout();
                };
                /**
     * Synchronizes the list of options with the state of the foundation. Call
     * this whenever menu options are dynamically updated.
     */ MDCSelect.prototype.layoutOptions = function() {
                    this.foundation.layoutOptions();
                    this.menu.layout();
                };
                MDCSelect.prototype.getDefaultFoundation = function() {
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = __assign(__assign(__assign(__assign({}, this.getSelectAdapterMethods()), this.getCommonAdapterMethods()), this.getOutlineAdapterMethods()), this.getLabelAdapterMethods());
                    return new foundation_2.MDCSelectFoundation(adapter, this.getFoundationMap());
                };
                /**
     * Handles setup for the menu.
     */ MDCSelect.prototype.menuSetup = function() {
                    this.menuElement = this.root.querySelector(constants_1.strings.MENU_SELECTOR);
                    this.menuElement.init();
                    this.menu = this.menuElement.menu_;
                    /* TODO(revise): hasTypeahead */ this.menu.hasTypeahead = true;
                    /* TODO(revise): singleSelection */ this.menu.singleSelection = true;
                };
                MDCSelect.prototype.createRipple = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = __assign(__assign({}, component_5.MDCRipple.createAdapter({
                        root: this.selectAnchor
                    })), {
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            _this.selectAnchor.addEventListener(evtType, handler);
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            _this.selectAnchor.removeEventListener(evtType, handler);
                        }
                    });
                    // tslint:enable:object-literal-sort-keys
                    return new component_5.MDCRipple(this.selectAnchor, new foundation_1.MDCRippleFoundation(adapter));
                };
                MDCSelect.prototype.getSelectAdapterMethods = function() {
                    var _this = this;
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    return {
                        getMenuItemAttr: function getMenuItemAttr(menuItem, attr) {
                            return menuItem.getAttribute(attr);
                        },
                        setSelectedText: function setSelectedText(text) {
                            _this.selectedText.textContent = text;
                        },
                        isSelectAnchorFocused: function isSelectAnchorFocused() {
                            return document.activeElement === _this.selectAnchor;
                        },
                        getSelectAnchorAttr: function getSelectAnchorAttr(attr) {
                            return _this.selectAnchor.getAttribute(attr);
                        },
                        setSelectAnchorAttr: function setSelectAnchorAttr(attr, value) {
                            _this.selectAnchor.setAttribute(attr, value);
                        },
                        removeSelectAnchorAttr: function removeSelectAnchorAttr(attr) {
                            _this.selectAnchor.removeAttribute(attr);
                        },
                        addMenuClass: function addMenuClass(className) {
                            _this.menuElement.classList.add(className);
                        },
                        removeMenuClass: function removeMenuClass(className) {
                            _this.menuElement.classList.remove(className);
                        },
                        openMenu: function openMenu() {
                            _this.menu.open = true;
                        },
                        closeMenu: function closeMenu() {
                            _this.menu.open = false;
                        },
                        getAnchorElement: function getAnchorElement() {
                            return _this.root.querySelector(constants_1.strings.SELECT_ANCHOR_SELECTOR);
                        },
                        setMenuAnchorElement: function setMenuAnchorElement(anchorEl) {
                            _this.menu.setAnchorElement(anchorEl);
                        },
                        setMenuAnchorCorner: function setMenuAnchorCorner(anchorCorner) {
                            _this.menu.setAnchorCorner(anchorCorner);
                        },
                        setMenuWrapFocus: function setMenuWrapFocus(wrapFocus) {
                            _this.menu.wrapFocus = wrapFocus;
                        },
                        getSelectedIndex: function getSelectedIndex() {
                            var index = _this.menu.selectedIndex;
                            return index instanceof Array ? index[0] : index;
                        },
                        setSelectedIndex: function setSelectedIndex(index) {
                            _this.menu.selectedIndex = index;
                        },
                        focusMenuItemAtIndex: function focusMenuItemAtIndex(index) {
                            _this.menu.items[index].focus();
                        },
                        getMenuItemCount: function getMenuItemCount() {
                            return _this.menu.items.length;
                        },
                        // Cache menu item values. layoutOptions() updates this cache.
                        getMenuItemValues: function getMenuItemValues() {
                            return _this.menuItemValues;
                        },
                        clickMenuItem: function clickMenuItem(index) {
                            return _this.clickMenuItem(index);
                        },
                        getMenuItemTextAtIndex: function getMenuItemTextAtIndex(index) {
                            return _this.menu.getPrimaryTextAtIndex(index);
                        },
                        isTypeaheadInProgress: function isTypeaheadInProgress() {
                            return _this.menu.typeaheadInProgress;
                        },
                        typeaheadMatchItem: function typeaheadMatchItem(nextChar, startingIndex) {
                            return _this.menu.typeaheadMatchItem(nextChar, startingIndex);
                        }
                    };
                // tslint:enable:object-literal-sort-keys
                };
                MDCSelect.prototype.getCommonAdapterMethods = function() {
                    var _this = this;
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    return {
                        addClass: function addClass(className) {
                            _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            _this.root.classList.remove(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        setRippleCenter: function setRippleCenter(normalizedX) {
                            _this.lineRipple && _this.lineRipple.setRippleCenter(normalizedX);
                        },
                        activateBottomLine: function activateBottomLine() {
                            _this.lineRipple && _this.lineRipple.activate();
                        },
                        deactivateBottomLine: function deactivateBottomLine() {
                            _this.lineRipple && _this.lineRipple.deactivate();
                        },
                        notifyChange: function notifyChange(value) {
                            if (_this.hiddenInput) _this.hiddenInput.value = value;
                            var index = _this.selectedIndex;
                            _this.emit(constants_1.strings.CHANGE_EVENT, {
                                value: value,
                                index: index
                            }, true);
                        }
                    };
                // tslint:enable:object-literal-sort-keys
                };
                MDCSelect.prototype.getOutlineAdapterMethods = function() {
                    var _this = this;
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    return {
                        hasOutline: function hasOutline() {
                            return Boolean(_this.outline);
                        },
                        notchOutline: function notchOutline(labelWidth) {
                            _this.outline && _this.outline.notch(labelWidth);
                        },
                        closeOutline: function closeOutline() {
                            _this.outline && _this.outline.closeNotch();
                        }
                    };
                // tslint:enable:object-literal-sort-keys
                };
                MDCSelect.prototype.getLabelAdapterMethods = function() {
                    var _this = this;
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    return {
                        hasLabel: function hasLabel() {
                            return !!_this.label;
                        },
                        floatLabel: function floatLabel(shouldFloat) {
                            _this.label && _this.label.float(shouldFloat);
                        },
                        getLabelWidth: function getLabelWidth() {
                            return _this.label ? _this.label.getWidth() : 0;
                        },
                        setLabelRequired: function setLabelRequired(isRequired) {
                            _this.label && _this.label.setRequired(isRequired);
                        }
                    };
                // tslint:enable:object-literal-sort-keys
                };
                /**
     * Calculates where the line ripple should start based on the x coordinate within the component.
     */ MDCSelect.prototype.getNormalizedXCoordinate = function(evt) {
                    var targetClientRect = evt.target.getBoundingClientRect();
                    var xCoordinate = this.isTouchEvent(evt) ? evt.touches[0].clientX : evt.clientX;
                    return xCoordinate - targetClientRect.left;
                };
                MDCSelect.prototype.isTouchEvent = function(evt) {
                    return Boolean(evt.touches);
                };
                /**
     * Returns a map of all subcomponents to subfoundations.
     */ MDCSelect.prototype.getFoundationMap = function() {
                    return {
                        helperText: this.helperText ? this.helperText.foundationForSelect : undefined,
                        leadingIcon: this.leadingIcon ? this.leadingIcon.foundationForSelect : undefined
                    };
                };
                return MDCSelect;
            }(component_1.MDCComponent);
            exports.MDCSelect = MDCSelect;
        /***/ },
        /***/ "./packages/mdc-select/constants.ts": /*!******************************************!*\
  !*** ./packages/mdc-select/constants.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.numbers = exports.strings = exports.cssClasses = void 0;
            var cssClasses = {
                ACTIVATED: "mdc-select--activated",
                DISABLED: "mdc-select--disabled",
                FOCUSED: "mdc-select--focused",
                INVALID: "mdc-select--invalid",
                MENU_INVALID: "mdc-select__menu--invalid",
                OUTLINED: "mdc-select--outlined",
                REQUIRED: "mdc-select--required",
                ROOT: "mdc-select",
                WITH_LEADING_ICON: "mdc-select--with-leading-icon"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                ARIA_CONTROLS: "aria-controls",
                ARIA_DESCRIBEDBY: "aria-describedby",
                ARIA_SELECTED_ATTR: "aria-selected",
                CHANGE_EVENT: "MDCSelect:change",
                HIDDEN_INPUT_SELECTOR: 'input[type="hidden"]',
                LABEL_SELECTOR: ".mdc-floating-label",
                LEADING_ICON_SELECTOR: ".mdc-select__icon",
                LINE_RIPPLE_SELECTOR: ".mdc-line-ripple",
                MENU_SELECTOR: ".mdc-select__menu",
                OUTLINE_SELECTOR: ".mdc-notched-outline",
                SELECTED_TEXT_SELECTOR: ".mdc-select__selected-text",
                SELECT_ANCHOR_SELECTOR: ".mdc-select__anchor",
                VALUE_ATTR: "data-value"
            };
            exports.strings = strings;
            var numbers = {
                LABEL_SCALE: 0.75,
                UNSET_INDEX: -1,
                CLICK_DEBOUNCE_TIMEOUT_MS: 330
            };
            exports.numbers = numbers;
        /***/ },
        /***/ "./packages/mdc-select/custom-element.js": /*!***********************************************!*\
  !*** ./packages/mdc-select/custom-element.js ***!
  \***********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-select/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcSelect = function(_HTMLElement) {
                _inherits(MdcSelect, _HTMLElement);
                _createClass(MdcSelect, [
                    {
                        key: "focus",
                        value: function focus() {
                            this.select_.selectAnchor.focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            this.select_.selectAnchor.blur();
                        }
                    },
                    {
                        key: "selectedIndex",
                        get: function get() {
                            return !!this.select_ ? this.select_.selectedIndex : this.selectedIndex_;
                        },
                        set: function set(selectedIndex) {
                            this.selectedIndex_ = selectedIndex;
                            if (!!this.select_) this.select_.selectedIndex = selectedIndex;
                        }
                    },
                    {
                        key: "disabled",
                        get: function get() {
                            return !!this.select_ ? this.select_.disabled : this.disabled_;
                        },
                        set: function set(disabled) {
                            this.disabled_ = disabled;
                            if (!!this.select_) this.select_.disabled = disabled;
                        }
                    },
                    {
                        key: "valid",
                        get: function get() {
                            return !!this.select_ ? this.select_.valid : this.valid_;
                        },
                        set: function set(valid) {
                            this.valid_ = valid;
                            if (!!this.select_) this.select_.valid = valid;
                        }
                    },
                    {
                        key: "required",
                        get: function get() {
                            return !!this.select_ ? this.select_.required : this.required_;
                        },
                        set: function set(required) {
                            this.required_ = required;
                            if (!!this.select_) this.select_.required = required;
                        }
                    }
                ]);
                function MdcSelect() {
                    _classCallCheck(this, MdcSelect);
                    var _this = _possibleConstructorReturn(this, (MdcSelect.__proto__ || Object.getPrototypeOf(MdcSelect)).call(this));
                    _this.selectedIndex_ = -1;
                    _this.disabled_ = false;
                    _this.valid_ = true;
                    _this.required_ = false;
                    _this.select_;
                    return _this;
                }
                _createClass(MdcSelect, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.select_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCSelect"](this);
                            this.select_.disabled = this.disabled_;
                            this.select_.valid = this.valid_;
                            this.select_.required = this.required_;
                            this.select_.selectedIndex = this.selectedIndex_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.select_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcSelect;
            }(HTMLElement);
            customElements.define("mdc-select", MdcSelect);
        /***/ },
        /***/ "./packages/mdc-select/foundation.ts": /*!*******************************************!*\
  !*** ./packages/mdc-select/foundation.ts ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSelectFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var keyboard_1 = __webpack_require__(/*! @material/dom/keyboard */ "./packages/mdc-dom/keyboard.ts");
            var constants_1 = __webpack_require__(/*! @material/menu-surface/constants */ "./packages/mdc-menu-surface/constants.ts");
            var constants_2 = __webpack_require__(/*! ./constants */ "./packages/mdc-select/constants.ts");
            var MDCSelectFoundation = /** @class */ function(_super) {
                __extends(MDCSelectFoundation, _super);
                /* istanbul ignore next: optional argument is not a branch statement */ /**
     * @param adapter
     * @param foundationMap Map from subcomponent names to their subfoundations.
     */ function MDCSelectFoundation(adapter, foundationMap) {
                    if (foundationMap === void 0) foundationMap = {};
                    var _this = _super.call(this, __assign(__assign({}, MDCSelectFoundation.defaultAdapter), adapter)) || this;
                    // Disabled state
                    _this.disabled = false;
                    // isMenuOpen is used to track the state of the menu by listening to the
                    // MDCMenuSurface:closed event For reference, menu.open will return false if
                    // the menu is still closing, but isMenuOpen returns false only after the menu
                    // has closed
                    _this.isMenuOpen = false;
                    // By default, select is invalid if it is required but no value is selected.
                    _this.useDefaultValidation = true;
                    _this.customValidity = true;
                    _this.lastSelectedIndex = constants_2.numbers.UNSET_INDEX;
                    _this.clickDebounceTimeout = 0;
                    _this.recentlyClicked = false;
                    _this.leadingIcon = foundationMap.leadingIcon;
                    _this.helperText = foundationMap.helperText;
                    return _this;
                }
                Object.defineProperty(MDCSelectFoundation, "cssClasses", {
                    get: function get() {
                        return constants_2.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelectFoundation, "numbers", {
                    get: function get() {
                        return constants_2.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelectFoundation, "strings", {
                    get: function get() {
                        return constants_2.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelectFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCSelectAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            activateBottomLine: function activateBottomLine() {
                                return undefined;
                            },
                            deactivateBottomLine: function deactivateBottomLine() {
                                return undefined;
                            },
                            getSelectedIndex: function getSelectedIndex() {
                                return -1;
                            },
                            setSelectedIndex: function setSelectedIndex() {
                                return undefined;
                            },
                            hasLabel: function hasLabel() {
                                return false;
                            },
                            floatLabel: function floatLabel() {
                                return undefined;
                            },
                            getLabelWidth: function getLabelWidth() {
                                return 0;
                            },
                            setLabelRequired: function setLabelRequired() {
                                return undefined;
                            },
                            hasOutline: function hasOutline() {
                                return false;
                            },
                            notchOutline: function notchOutline() {
                                return undefined;
                            },
                            closeOutline: function closeOutline() {
                                return undefined;
                            },
                            setRippleCenter: function setRippleCenter() {
                                return undefined;
                            },
                            notifyChange: function notifyChange() {
                                return undefined;
                            },
                            setSelectedText: function setSelectedText() {
                                return undefined;
                            },
                            isSelectAnchorFocused: function isSelectAnchorFocused() {
                                return false;
                            },
                            getSelectAnchorAttr: function getSelectAnchorAttr() {
                                return "";
                            },
                            setSelectAnchorAttr: function setSelectAnchorAttr() {
                                return undefined;
                            },
                            removeSelectAnchorAttr: function removeSelectAnchorAttr() {
                                return undefined;
                            },
                            addMenuClass: function addMenuClass() {
                                return undefined;
                            },
                            removeMenuClass: function removeMenuClass() {
                                return undefined;
                            },
                            openMenu: function openMenu() {
                                return undefined;
                            },
                            closeMenu: function closeMenu() {
                                return undefined;
                            },
                            getAnchorElement: function getAnchorElement() {
                                return null;
                            },
                            setMenuAnchorElement: function setMenuAnchorElement() {
                                return undefined;
                            },
                            setMenuAnchorCorner: function setMenuAnchorCorner() {
                                return undefined;
                            },
                            setMenuWrapFocus: function setMenuWrapFocus() {
                                return undefined;
                            },
                            focusMenuItemAtIndex: function focusMenuItemAtIndex() {
                                return undefined;
                            },
                            getMenuItemCount: function getMenuItemCount() {
                                return 0;
                            },
                            clickMenuItem: function clickMenuItem() {
                                return undefined;
                            },
                            getMenuItemValues: function getMenuItemValues() {
                                return [];
                            },
                            getMenuItemTextAtIndex: function getMenuItemTextAtIndex() {
                                return "";
                            },
                            isTypeaheadInProgress: function isTypeaheadInProgress() {
                                return false;
                            },
                            typeaheadMatchItem: function typeaheadMatchItem() {
                                return -1;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                /** Returns the index of the currently selected menu item, or -1 if none. */ MDCSelectFoundation.prototype.getSelectedIndex = function() {
                    return this.adapter.getSelectedIndex();
                };
                MDCSelectFoundation.prototype.setSelectedIndex = function(index, closeMenu, skipNotify) {
                    if (closeMenu === void 0) closeMenu = false;
                    if (skipNotify === void 0) skipNotify = false;
                    if (index >= this.adapter.getMenuItemCount()) return;
                    if (index === constants_2.numbers.UNSET_INDEX) this.adapter.setSelectedText("");
                    else this.adapter.setSelectedText(this.adapter.getMenuItemTextAtIndex(index).trim());
                    this.adapter.setSelectedIndex(index);
                    if (closeMenu) this.adapter.closeMenu();
                    if (!skipNotify && this.lastSelectedIndex !== index) this.handleChange();
                    this.lastSelectedIndex = index;
                };
                MDCSelectFoundation.prototype.getValue = function() {
                    var index = this.adapter.getSelectedIndex();
                    var menuItemValues = this.adapter.getMenuItemValues();
                    return index !== constants_2.numbers.UNSET_INDEX ? menuItemValues[index] : "";
                };
                MDCSelectFoundation.prototype.getDisabled = function() {
                    return this.disabled;
                };
                MDCSelectFoundation.prototype.setDisabled = function(isDisabled) {
                    this.disabled = isDisabled;
                    if (this.disabled) {
                        this.adapter.addClass(constants_2.cssClasses.DISABLED);
                        this.adapter.closeMenu();
                    } else this.adapter.removeClass(constants_2.cssClasses.DISABLED);
                    if (this.leadingIcon) this.leadingIcon.setDisabled(this.disabled);
                    if (this.disabled) // Prevent click events from focusing select. Simply pointer-events: none
                    // is not enough since screenreader clicks may bypass this.
                    this.adapter.removeSelectAnchorAttr("tabindex");
                    else this.adapter.setSelectAnchorAttr("tabindex", "0");
                    this.adapter.setSelectAnchorAttr("aria-disabled", this.disabled.toString());
                };
                /** Opens the menu. */ MDCSelectFoundation.prototype.openMenu = function() {
                    this.adapter.addClass(constants_2.cssClasses.ACTIVATED);
                    this.adapter.openMenu();
                    this.isMenuOpen = true;
                    this.adapter.setSelectAnchorAttr("aria-expanded", "true");
                };
                /**
     * @param content Sets the content of the helper text.
     */ MDCSelectFoundation.prototype.setHelperTextContent = function(content) {
                    if (this.helperText) this.helperText.setContent(content);
                };
                /**
     * Re-calculates if the notched outline should be notched and if the label
     * should float.
     */ MDCSelectFoundation.prototype.layout = function() {
                    if (this.adapter.hasLabel()) {
                        var optionHasValue = this.getSelectedIndex() !== constants_2.numbers.UNSET_INDEX && this.adapter.getMenuItemTextAtIndex(this.getSelectedIndex()).length > 0;
                        var isFocused = this.adapter.hasClass(constants_2.cssClasses.FOCUSED);
                        var shouldFloatAndNotch = optionHasValue || isFocused;
                        var isRequired = this.adapter.hasClass(constants_2.cssClasses.REQUIRED);
                        this.notchOutline(shouldFloatAndNotch);
                        this.adapter.floatLabel(shouldFloatAndNotch);
                        this.adapter.setLabelRequired(isRequired);
                    }
                };
                /**
     * Synchronizes the list of options with the state of the foundation. Call
     * this whenever menu options are dynamically updated.
     */ MDCSelectFoundation.prototype.layoutOptions = function() {
                    var menuItemValues = this.adapter.getMenuItemValues();
                    var selectedIndex = menuItemValues.indexOf(this.getValue());
                    this.setSelectedIndex(selectedIndex, /** closeMenu */ false, /** skipNotify */ true);
                };
                MDCSelectFoundation.prototype.handleMenuOpened = function() {
                    if (this.adapter.getMenuItemValues().length === 0) return;
                    // Menu should open to the last selected element, should open to first menu item otherwise.
                    var selectedIndex = this.getSelectedIndex();
                    var focusItemIndex = selectedIndex >= 0 ? selectedIndex : 0;
                    this.adapter.focusMenuItemAtIndex(focusItemIndex);
                };
                MDCSelectFoundation.prototype.handleMenuClosing = function() {
                    this.adapter.setSelectAnchorAttr("aria-expanded", "false");
                };
                MDCSelectFoundation.prototype.handleMenuClosed = function() {
                    this.adapter.removeClass(constants_2.cssClasses.ACTIVATED);
                    this.isMenuOpen = false;
                    // Unfocus the select if menu is closed without a selection
                    if (!this.adapter.isSelectAnchorFocused()) this.blur();
                };
                /**
     * Handles value changes, via change event or programmatic updates.
     */ MDCSelectFoundation.prototype.handleChange = function() {
                    this.layout();
                    var isRequired = this.adapter.hasClass(constants_2.cssClasses.REQUIRED);
                    if (isRequired && this.useDefaultValidation) this.setValid(this.isValid());
                };
                MDCSelectFoundation.prototype.handleMenuItemAction = function(index) {
                    this.setSelectedIndex(index, /** closeMenu */ true);
                };
                /**
     * Handles focus events from select element.
     */ MDCSelectFoundation.prototype.handleFocus = function() {
                    this.adapter.addClass(constants_2.cssClasses.FOCUSED);
                    this.layout();
                    this.adapter.activateBottomLine();
                };
                /**
     * Handles blur events from select element.
     */ MDCSelectFoundation.prototype.handleBlur = function() {
                    if (this.isMenuOpen) return;
                    this.blur();
                };
                MDCSelectFoundation.prototype.handleClick = function(normalizedX) {
                    if (this.disabled || this.recentlyClicked) return;
                    this.setClickDebounceTimeout();
                    if (this.isMenuOpen) {
                        this.adapter.closeMenu();
                        return;
                    }
                    this.adapter.setRippleCenter(normalizedX);
                    this.openMenu();
                };
                /**
     * Handles keydown events on select element. Depending on the type of
     * character typed, does typeahead matching or opens menu.
     */ MDCSelectFoundation.prototype.handleKeydown = function(event) {
                    if (this.isMenuOpen || !this.adapter.hasClass(constants_2.cssClasses.FOCUSED)) return;
                    var isEnter = keyboard_1.normalizeKey(event) === keyboard_1.KEY.ENTER;
                    var isSpace = keyboard_1.normalizeKey(event) === keyboard_1.KEY.SPACEBAR;
                    var arrowUp = keyboard_1.normalizeKey(event) === keyboard_1.KEY.ARROW_UP;
                    var arrowDown = keyboard_1.normalizeKey(event) === keyboard_1.KEY.ARROW_DOWN;
                    var isModifier = event.ctrlKey || event.metaKey;
                    // Typeahead
                    if (!isModifier && (!isSpace && event.key && event.key.length === 1 || isSpace && this.adapter.isTypeaheadInProgress())) {
                        var key = isSpace ? " " : event.key;
                        var typeaheadNextIndex = this.adapter.typeaheadMatchItem(key, this.getSelectedIndex());
                        if (typeaheadNextIndex >= 0) {
                            this.adapter.clickMenuItem(typeaheadNextIndex);
                            this.setSelectedIndex(typeaheadNextIndex);
                        }
                        event.preventDefault();
                        return;
                    }
                    if (!isEnter && !isSpace && !arrowUp && !arrowDown) return;
                    this.openMenu();
                    event.preventDefault();
                };
                /**
     * Opens/closes the notched outline.
     */ MDCSelectFoundation.prototype.notchOutline = function(openNotch) {
                    if (!this.adapter.hasOutline()) return;
                    var isFocused = this.adapter.hasClass(constants_2.cssClasses.FOCUSED);
                    if (openNotch) {
                        var labelScale = constants_2.numbers.LABEL_SCALE;
                        var labelWidth = this.adapter.getLabelWidth() * labelScale;
                        this.adapter.notchOutline(labelWidth);
                    } else if (!isFocused) this.adapter.closeOutline();
                };
                /**
     * Sets the aria label of the leading icon.
     */ MDCSelectFoundation.prototype.setLeadingIconAriaLabel = function(label) {
                    if (this.leadingIcon) this.leadingIcon.setAriaLabel(label);
                };
                /**
     * Sets the text content of the leading icon.
     */ MDCSelectFoundation.prototype.setLeadingIconContent = function(content) {
                    if (this.leadingIcon) this.leadingIcon.setContent(content);
                };
                MDCSelectFoundation.prototype.setUseDefaultValidation = function(useDefaultValidation) {
                    this.useDefaultValidation = useDefaultValidation;
                };
                MDCSelectFoundation.prototype.setValid = function(isValid) {
                    if (!this.useDefaultValidation) this.customValidity = isValid;
                    this.adapter.setSelectAnchorAttr("aria-invalid", (!isValid).toString());
                    if (isValid) {
                        this.adapter.removeClass(constants_2.cssClasses.INVALID);
                        this.adapter.removeMenuClass(constants_2.cssClasses.MENU_INVALID);
                    } else {
                        this.adapter.addClass(constants_2.cssClasses.INVALID);
                        this.adapter.addMenuClass(constants_2.cssClasses.MENU_INVALID);
                    }
                    this.syncHelperTextValidity(isValid);
                };
                MDCSelectFoundation.prototype.isValid = function() {
                    if (this.useDefaultValidation && this.adapter.hasClass(constants_2.cssClasses.REQUIRED) && !this.adapter.hasClass(constants_2.cssClasses.DISABLED)) // See notes for required attribute under https://www.w3.org/TR/html52/sec-forms.html#the-select-element
                    // TL;DR: Invalid if no index is selected, or if the first index is selected and has an empty value.
                    return this.getSelectedIndex() !== constants_2.numbers.UNSET_INDEX && (this.getSelectedIndex() !== 0 || this.adapter.getMenuItemTextAtIndex(this.getSelectedIndex()).length > 0);
                    return this.customValidity;
                };
                MDCSelectFoundation.prototype.setRequired = function(isRequired) {
                    if (isRequired) this.adapter.addClass(constants_2.cssClasses.REQUIRED);
                    else this.adapter.removeClass(constants_2.cssClasses.REQUIRED);
                    this.adapter.setSelectAnchorAttr("aria-required", isRequired.toString());
                    this.adapter.setLabelRequired(isRequired);
                };
                MDCSelectFoundation.prototype.getRequired = function() {
                    return this.adapter.getSelectAnchorAttr("aria-required") === "true";
                };
                MDCSelectFoundation.prototype.init = function() {
                    var anchorEl = this.adapter.getAnchorElement();
                    if (anchorEl) {
                        this.adapter.setMenuAnchorElement(anchorEl);
                        this.adapter.setMenuAnchorCorner(constants_1.Corner.BOTTOM_START);
                    }
                    this.adapter.setMenuWrapFocus(false);
                    this.setDisabled(this.adapter.hasClass(constants_2.cssClasses.DISABLED));
                    this.syncHelperTextValidity(!this.adapter.hasClass(constants_2.cssClasses.INVALID));
                    this.layout();
                    this.layoutOptions();
                };
                /**
     * Unfocuses the select component.
     */ MDCSelectFoundation.prototype.blur = function() {
                    this.adapter.removeClass(constants_2.cssClasses.FOCUSED);
                    this.layout();
                    this.adapter.deactivateBottomLine();
                    var isRequired = this.adapter.hasClass(constants_2.cssClasses.REQUIRED);
                    if (isRequired && this.useDefaultValidation) this.setValid(this.isValid());
                };
                MDCSelectFoundation.prototype.syncHelperTextValidity = function(isValid) {
                    if (!this.helperText) return;
                    this.helperText.setValidity(isValid);
                    var helperTextVisible = this.helperText.isVisible();
                    var helperTextId = this.helperText.getId();
                    if (helperTextVisible && helperTextId) this.adapter.setSelectAnchorAttr(constants_2.strings.ARIA_DESCRIBEDBY, helperTextId);
                    else // Needed because screenreaders will read labels pointed to by
                    // `aria-describedby` even if they are `aria-hidden`.
                    this.adapter.removeSelectAnchorAttr(constants_2.strings.ARIA_DESCRIBEDBY);
                };
                MDCSelectFoundation.prototype.setClickDebounceTimeout = function() {
                    var _this = this;
                    clearTimeout(this.clickDebounceTimeout);
                    this.clickDebounceTimeout = setTimeout(function() {
                        _this.recentlyClicked = false;
                    }, constants_2.numbers.CLICK_DEBOUNCE_TIMEOUT_MS);
                    this.recentlyClicked = true;
                };
                return MDCSelectFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCSelectFoundation = MDCSelectFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCSelectFoundation;
        /***/ },
        /***/ "./packages/mdc-select/helper-text/component.ts": /*!******************************************************!*\
  !*** ./packages/mdc-select/helper-text/component.ts ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSelectHelperText = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-select/helper-text/foundation.ts");
            var MDCSelectHelperText = /** @class */ function(_super) {
                __extends(MDCSelectHelperText, _super);
                function MDCSelectHelperText() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCSelectHelperText.attachTo = function(root) {
                    return new MDCSelectHelperText(root);
                };
                Object.defineProperty(MDCSelectHelperText.prototype, "foundationForSelect", {
                    // Provided for access by MDCSelect component
                    get: function get() {
                        return this.foundation;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSelectHelperText.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        getAttr: function getAttr(attr) {
                            return _this.root.getAttribute(attr);
                        },
                        setAttr: function setAttr(attr, value) {
                            return _this.root.setAttribute(attr, value);
                        },
                        removeAttr: function removeAttr(attr) {
                            return _this.root.removeAttribute(attr);
                        },
                        setContent: function setContent(content) {
                            _this.root.textContent = content;
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_1.MDCSelectHelperTextFoundation(adapter);
                };
                return MDCSelectHelperText;
            }(component_1.MDCComponent);
            exports.MDCSelectHelperText = MDCSelectHelperText;
        /***/ },
        /***/ "./packages/mdc-select/helper-text/constants.ts": /*!******************************************************!*\
  !*** ./packages/mdc-select/helper-text/constants.ts ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.cssClasses = exports.strings = void 0;
            var strings = {
                ARIA_HIDDEN: "aria-hidden",
                ROLE: "role"
            };
            exports.strings = strings;
            var cssClasses = {
                HELPER_TEXT_VALIDATION_MSG: "mdc-select-helper-text--validation-msg",
                HELPER_TEXT_VALIDATION_MSG_PERSISTENT: "mdc-select-helper-text--validation-msg-persistent"
            };
            exports.cssClasses = cssClasses;
        /***/ },
        /***/ "./packages/mdc-select/helper-text/foundation.ts": /*!*******************************************************!*\
  !*** ./packages/mdc-select/helper-text/foundation.ts ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSelectHelperTextFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-select/helper-text/constants.ts");
            var MDCSelectHelperTextFoundation = /** @class */ function(_super) {
                __extends(MDCSelectHelperTextFoundation, _super);
                function MDCSelectHelperTextFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCSelectHelperTextFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCSelectHelperTextFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelectHelperTextFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelectHelperTextFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCSelectHelperTextAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            setAttr: function setAttr() {
                                return undefined;
                            },
                            getAttr: function getAttr() {
                                return null;
                            },
                            removeAttr: function removeAttr() {
                                return undefined;
                            },
                            setContent: function setContent() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * @return The ID of the helper text, or null if none is set.
     */ MDCSelectHelperTextFoundation.prototype.getId = function() {
                    return this.adapter.getAttr("id");
                };
                /**
     * @return Whether the helper text is currently visible.
     */ MDCSelectHelperTextFoundation.prototype.isVisible = function() {
                    return this.adapter.getAttr(constants_1.strings.ARIA_HIDDEN) !== "true";
                };
                /**
     * Sets the content of the helper text field.
     */ MDCSelectHelperTextFoundation.prototype.setContent = function(content) {
                    this.adapter.setContent(content);
                };
                /**
     * Sets the helper text to act as a validation message.
     * By default, validation messages are hidden when the select is valid and
     * visible when the select is invalid.
     *
     * @param isValidation True to make the helper text act as an error validation
     *     message.
     */ MDCSelectHelperTextFoundation.prototype.setValidation = function(isValidation) {
                    if (isValidation) this.adapter.addClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG);
                    else this.adapter.removeClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG);
                };
                /**
     * Sets the persistency of the validation helper text.
     * This keeps the validation message visible even if the select is valid,
     * though it will be displayed in the normal (grey) color.
     */ MDCSelectHelperTextFoundation.prototype.setValidationMsgPersistent = function(isPersistent) {
                    if (isPersistent) this.adapter.addClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG_PERSISTENT);
                    else this.adapter.removeClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG_PERSISTENT);
                };
                /**
     * When acting as a validation message, shows/hides the helper text and
     * triggers alerts as necessary based on the select's validity.
     */ MDCSelectHelperTextFoundation.prototype.setValidity = function(selectIsValid) {
                    var isValidationMsg = this.adapter.hasClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG);
                    if (!isValidationMsg) // Non-validating helper-text is always displayed and does not participate
                    // in validation logic.
                    return;
                    var isPersistentValidationMsg = this.adapter.hasClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG_PERSISTENT);
                    // Validating helper text is displayed if select is invalid, unless it is
                    // set as persistent, in which case it always displays.
                    var msgShouldDisplay = !selectIsValid || isPersistentValidationMsg;
                    if (msgShouldDisplay) {
                        this.showToScreenReader();
                        // In addition to displaying, also trigger an alert if the select
                        // has become invalid.
                        if (!selectIsValid) this.adapter.setAttr(constants_1.strings.ROLE, "alert");
                        else this.adapter.removeAttr(constants_1.strings.ROLE);
                        return;
                    }
                    // Hide everything.
                    this.adapter.removeAttr(constants_1.strings.ROLE);
                    this.hide();
                };
                /**
     * Makes the helper text visible to screen readers.
     */ MDCSelectHelperTextFoundation.prototype.showToScreenReader = function() {
                    this.adapter.removeAttr(constants_1.strings.ARIA_HIDDEN);
                };
                /**
     * Hides the help text from screen readers.
     */ MDCSelectHelperTextFoundation.prototype.hide = function() {
                    this.adapter.setAttr(constants_1.strings.ARIA_HIDDEN, "true");
                };
                return MDCSelectHelperTextFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCSelectHelperTextFoundation = MDCSelectHelperTextFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCSelectHelperTextFoundation;
        /***/ },
        /***/ "./packages/mdc-select/icon/component.ts": /*!***********************************************!*\
  !*** ./packages/mdc-select/icon/component.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSelectIcon = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-select/icon/foundation.ts");
            var MDCSelectIcon = /** @class */ function(_super) {
                __extends(MDCSelectIcon, _super);
                function MDCSelectIcon() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCSelectIcon.attachTo = function(root) {
                    return new MDCSelectIcon(root);
                };
                Object.defineProperty(MDCSelectIcon.prototype, "foundationForSelect", {
                    // Provided for access by MDCSelect component
                    get: function get() {
                        return this.foundation;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSelectIcon.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        getAttr: function getAttr(attr) {
                            return _this.root.getAttribute(attr);
                        },
                        setAttr: function setAttr(attr, value) {
                            return _this.root.setAttribute(attr, value);
                        },
                        removeAttr: function removeAttr(attr) {
                            return _this.root.removeAttribute(attr);
                        },
                        setContent: function setContent(content) {
                            _this.root.textContent = content;
                        },
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            return _this.listen(evtType, handler);
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            return _this.unlisten(evtType, handler);
                        },
                        notifyIconAction: function notifyIconAction() {
                            return _this.emit(foundation_1.MDCSelectIconFoundation.strings.ICON_EVENT, {} /* evtData */ , true);
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_1.MDCSelectIconFoundation(adapter);
                };
                return MDCSelectIcon;
            }(component_1.MDCComponent);
            exports.MDCSelectIcon = MDCSelectIcon;
        /***/ },
        /***/ "./packages/mdc-select/icon/constants.ts": /*!***********************************************!*\
  !*** ./packages/mdc-select/icon/constants.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = void 0;
            var strings = {
                ICON_EVENT: "MDCSelect:icon",
                ICON_ROLE: "button"
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-select/icon/foundation.ts": /*!************************************************!*\
  !*** ./packages/mdc-select/icon/foundation.ts ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSelectIconFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-select/icon/constants.ts");
            var INTERACTION_EVENTS = [
                "click",
                "keydown"
            ];
            var MDCSelectIconFoundation = /** @class */ function(_super) {
                __extends(MDCSelectIconFoundation, _super);
                function MDCSelectIconFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCSelectIconFoundation.defaultAdapter), adapter)) || this;
                    _this.savedTabIndex_ = null;
                    _this.interactionHandler_ = function(evt) {
                        return _this.handleInteraction(evt);
                    };
                    return _this;
                }
                Object.defineProperty(MDCSelectIconFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelectIconFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCSelectIconAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            getAttr: function getAttr() {
                                return null;
                            },
                            setAttr: function setAttr() {
                                return undefined;
                            },
                            removeAttr: function removeAttr() {
                                return undefined;
                            },
                            setContent: function setContent() {
                                return undefined;
                            },
                            registerInteractionHandler: function registerInteractionHandler() {
                                return undefined;
                            },
                            deregisterInteractionHandler: function deregisterInteractionHandler() {
                                return undefined;
                            },
                            notifyIconAction: function notifyIconAction() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSelectIconFoundation.prototype.init = function() {
                    var _this = this;
                    this.savedTabIndex_ = this.adapter.getAttr("tabindex");
                    INTERACTION_EVENTS.forEach(function(evtType) {
                        _this.adapter.registerInteractionHandler(evtType, _this.interactionHandler_);
                    });
                };
                MDCSelectIconFoundation.prototype.destroy = function() {
                    var _this = this;
                    INTERACTION_EVENTS.forEach(function(evtType) {
                        _this.adapter.deregisterInteractionHandler(evtType, _this.interactionHandler_);
                    });
                };
                MDCSelectIconFoundation.prototype.setDisabled = function(disabled) {
                    if (!this.savedTabIndex_) return;
                    if (disabled) {
                        this.adapter.setAttr("tabindex", "-1");
                        this.adapter.removeAttr("role");
                    } else {
                        this.adapter.setAttr("tabindex", this.savedTabIndex_);
                        this.adapter.setAttr("role", constants_1.strings.ICON_ROLE);
                    }
                };
                MDCSelectIconFoundation.prototype.setAriaLabel = function(label) {
                    this.adapter.setAttr("aria-label", label);
                };
                MDCSelectIconFoundation.prototype.setContent = function(content) {
                    this.adapter.setContent(content);
                };
                MDCSelectIconFoundation.prototype.handleInteraction = function(evt) {
                    var isEnterKey = evt.key === "Enter" || evt.keyCode === 13;
                    if (evt.type === "click" || isEnterKey) this.adapter.notifyIconAction();
                };
                return MDCSelectIconFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCSelectIconFoundation = MDCSelectIconFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCSelectIconFoundation;
        /***/ },
        /***/ "./packages/mdc-slider/component.ts": /*!******************************************!*\
  !*** ./packages/mdc-slider/component.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSlider = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var events_1 = __webpack_require__(/*! @material/dom/events */ "./packages/mdc-dom/events.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var component_2 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-slider/constants.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-slider/foundation.ts");
            var types_1 = __webpack_require__(/*! ./types */ "./packages/mdc-slider/types.ts");
            /** Vanilla JS implementation of slider component. */ var MDCSlider = /** @class */ function(_super) {
                __extends(MDCSlider, _super);
                function MDCSlider() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.skipInitialUIUpdate = false;
                    // Function that maps a slider value to the value of the `aria-valuetext`
                    // attribute on the thumb element.
                    _this.valueToAriaValueTextFn = null;
                    return _this;
                }
                MDCSlider.attachTo = function(root, options) {
                    if (options === void 0) options = {};
                    return new MDCSlider(root, undefined, options);
                };
                MDCSlider.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // tslint:disable:object-literal-sort-keys Methods should be in the same
                    // order as the adapter interface.
                    var adapter = {
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        addClass: function addClass(className) {
                            _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            _this.root.classList.remove(className);
                        },
                        addThumbClass: function addThumbClass(className, thumb) {
                            _this.getThumbEl(thumb).classList.add(className);
                        },
                        removeThumbClass: function removeThumbClass(className, thumb) {
                            _this.getThumbEl(thumb).classList.remove(className);
                        },
                        getAttribute: function getAttribute(attribute) {
                            return _this.root.getAttribute(attribute);
                        },
                        getInputValue: function getInputValue(thumb) {
                            return _this.getInput(thumb).value;
                        },
                        setInputValue: function setInputValue(value, thumb) {
                            _this.getInput(thumb).value = value;
                        },
                        getInputAttribute: function getInputAttribute(attribute, thumb) {
                            return _this.getInput(thumb).getAttribute(attribute);
                        },
                        setInputAttribute: function setInputAttribute(attribute, value, thumb) {
                            _this.getInput(thumb).setAttribute(attribute, value);
                        },
                        removeInputAttribute: function removeInputAttribute(attribute, thumb) {
                            _this.getInput(thumb).removeAttribute(attribute);
                        },
                        focusInput: function focusInput(thumb) {
                            _this.getInput(thumb).focus();
                        },
                        isInputFocused: function isInputFocused(thumb) {
                            return _this.getInput(thumb) === document.activeElement;
                        },
                        getThumbKnobWidth: function getThumbKnobWidth(thumb) {
                            return _this.getThumbEl(thumb).querySelector("." + constants_1.cssClasses.THUMB_KNOB).getBoundingClientRect().width;
                        },
                        getThumbBoundingClientRect: function getThumbBoundingClientRect(thumb) {
                            return _this.getThumbEl(thumb).getBoundingClientRect();
                        },
                        getBoundingClientRect: function getBoundingClientRect() {
                            return _this.root.getBoundingClientRect();
                        },
                        isRTL: function isRTL() {
                            return getComputedStyle(_this.root).direction === "rtl";
                        },
                        setThumbStyleProperty: function setThumbStyleProperty(propertyName, value, thumb) {
                            _this.getThumbEl(thumb).style.setProperty(propertyName, value);
                        },
                        removeThumbStyleProperty: function removeThumbStyleProperty(propertyName, thumb) {
                            _this.getThumbEl(thumb).style.removeProperty(propertyName);
                        },
                        setTrackActiveStyleProperty: function setTrackActiveStyleProperty(propertyName, value) {
                            _this.trackActive.style.setProperty(propertyName, value);
                        },
                        removeTrackActiveStyleProperty: function removeTrackActiveStyleProperty(propertyName) {
                            _this.trackActive.style.removeProperty(propertyName);
                        },
                        setValueIndicatorText: function setValueIndicatorText(value, thumb) {
                            var valueIndicatorEl = _this.getThumbEl(thumb).querySelector("." + constants_1.cssClasses.VALUE_INDICATOR_TEXT);
                            valueIndicatorEl.textContent = String(value);
                        },
                        getValueToAriaValueTextFn: function getValueToAriaValueTextFn() {
                            return _this.valueToAriaValueTextFn;
                        },
                        updateTickMarks: function updateTickMarks(tickMarks) {
                            var tickMarksContainer = _this.root.querySelector("." + constants_1.cssClasses.TICK_MARKS_CONTAINER);
                            if (!tickMarksContainer) {
                                tickMarksContainer = document.createElement("div");
                                tickMarksContainer.classList.add(constants_1.cssClasses.TICK_MARKS_CONTAINER);
                                var track = _this.root.querySelector("." + constants_1.cssClasses.TRACK);
                                track.appendChild(tickMarksContainer);
                            }
                            if (tickMarks.length !== tickMarksContainer.children.length) {
                                tickMarksContainer.innerHTML = "";
                                _this.addTickMarks(tickMarksContainer, tickMarks);
                            } else _this.updateTickMarks(tickMarksContainer, tickMarks);
                        },
                        setPointerCapture: function setPointerCapture(pointerId) {
                            _this.root.setPointerCapture(pointerId);
                        },
                        emitChangeEvent: function emitChangeEvent(value, thumb) {
                            _this.emit(constants_1.events.CHANGE, {
                                value: value,
                                thumb: thumb
                            });
                        },
                        emitInputEvent: function emitInputEvent(value, thumb) {
                            _this.emit(constants_1.events.INPUT, {
                                value: value,
                                thumb: thumb
                            });
                        },
                        emitDragStartEvent: function emitDragStartEvent(_, thumb) {
                            // Emitting event is not yet implemented. See issue:
                            // https://github.com/material-components/material-components-web/issues/6448
                            _this.getRipple(thumb).activate();
                        },
                        emitDragEndEvent: function emitDragEndEvent(_, thumb) {
                            // Emitting event is not yet implemented. See issue:
                            // https://github.com/material-components/material-components-web/issues/6448
                            _this.getRipple(thumb).deactivate();
                        },
                        registerEventHandler: function registerEventHandler(evtType, handler) {
                            _this.listen(evtType, handler);
                        },
                        deregisterEventHandler: function deregisterEventHandler(evtType, handler) {
                            _this.unlisten(evtType, handler);
                        },
                        registerThumbEventHandler: function registerThumbEventHandler(thumb, evtType, handler) {
                            _this.getThumbEl(thumb).addEventListener(evtType, handler);
                        },
                        deregisterThumbEventHandler: function deregisterThumbEventHandler(thumb, evtType, handler) {
                            _this.getThumbEl(thumb).removeEventListener(evtType, handler);
                        },
                        registerInputEventHandler: function registerInputEventHandler(thumb, evtType, handler) {
                            _this.getInput(thumb).addEventListener(evtType, handler);
                        },
                        deregisterInputEventHandler: function deregisterInputEventHandler(thumb, evtType, handler) {
                            _this.getInput(thumb).removeEventListener(evtType, handler);
                        },
                        registerBodyEventHandler: function registerBodyEventHandler(evtType, handler) {
                            document.body.addEventListener(evtType, handler);
                        },
                        deregisterBodyEventHandler: function deregisterBodyEventHandler(evtType, handler) {
                            document.body.removeEventListener(evtType, handler);
                        },
                        registerWindowEventHandler: function registerWindowEventHandler(evtType, handler) {
                            window.addEventListener(evtType, handler);
                        },
                        deregisterWindowEventHandler: function deregisterWindowEventHandler(evtType, handler) {
                            window.removeEventListener(evtType, handler);
                        }
                    };
                    return new foundation_2.MDCSliderFoundation(adapter);
                };
                /**
     * Initializes component, with the following options:
     * - `skipInitialUIUpdate`: Whether to skip updating the UI when initially
     *   syncing with the DOM. This should be enabled when the slider position
     *   is set before component initialization.
     */ MDCSlider.prototype.initialize = function(_a) {
                    var _b = _a === void 0 ? {} : _a, skipInitialUIUpdate = _b.skipInitialUIUpdate;
                    this.inputs = [].slice.call(this.root.querySelectorAll("." + constants_1.cssClasses.INPUT));
                    this.thumbs = [].slice.call(this.root.querySelectorAll("." + constants_1.cssClasses.THUMB));
                    this.trackActive = this.root.querySelector("." + constants_1.cssClasses.TRACK_ACTIVE);
                    this.ripples = this.createRipples();
                    if (skipInitialUIUpdate) this.skipInitialUIUpdate = true;
                };
                MDCSlider.prototype.initialSyncWithDOM = function() {
                    this.foundation.layout({
                        skipUpdateUI: this.skipInitialUIUpdate
                    });
                };
                /** Redraws UI based on DOM (e.g. element dimensions, RTL). */ MDCSlider.prototype.layout = function() {
                    this.foundation.layout();
                };
                MDCSlider.prototype.getValueStart = function() {
                    return this.foundation.getValueStart();
                };
                MDCSlider.prototype.setValueStart = function(valueStart) {
                    this.foundation.setValueStart(valueStart);
                };
                MDCSlider.prototype.getValue = function() {
                    return this.foundation.getValue();
                };
                MDCSlider.prototype.setValue = function(value) {
                    this.foundation.setValue(value);
                };
                /** @return Slider disabled state. */ MDCSlider.prototype.getDisabled = function() {
                    return this.foundation.getDisabled();
                };
                /** Sets slider disabled state. */ MDCSlider.prototype.setDisabled = function(disabled) {
                    this.foundation.setDisabled(disabled);
                };
                /**
     * Sets a function that maps the slider value to the value of the
     * `aria-valuetext` attribute on the thumb element.
     */ MDCSlider.prototype.setValueToAriaValueTextFn = function(mapFn) {
                    this.valueToAriaValueTextFn = mapFn;
                };
                MDCSlider.prototype.getThumbEl = function(thumb) {
                    return thumb === types_1.Thumb.END ? this.thumbs[this.thumbs.length - 1] : this.thumbs[0];
                };
                MDCSlider.prototype.getInput = function(thumb) {
                    return thumb === types_1.Thumb.END ? this.inputs[this.inputs.length - 1] : this.inputs[0];
                };
                MDCSlider.prototype.getRipple = function(thumb) {
                    return thumb === types_1.Thumb.END ? this.ripples[this.ripples.length - 1] : this.ripples[0];
                };
                /** Adds tick mark elements to the given container. */ MDCSlider.prototype.addTickMarks = function(tickMarkContainer, tickMarks) {
                    var fragment = document.createDocumentFragment();
                    for(var i = 0; i < tickMarks.length; i++){
                        var div = document.createElement("div");
                        var tickMarkClass = tickMarks[i] === types_1.TickMark.ACTIVE ? constants_1.cssClasses.TICK_MARK_ACTIVE : constants_1.cssClasses.TICK_MARK_INACTIVE;
                        div.classList.add(tickMarkClass);
                        fragment.appendChild(div);
                    }
                    tickMarkContainer.appendChild(fragment);
                };
                /** Updates tick mark elements' classes in the given container. */ MDCSlider.prototype.updateTickMarks = function(tickMarkContainer, tickMarks) {
                    var tickMarkEls = Array.from(tickMarkContainer.children);
                    for(var i = 0; i < tickMarkEls.length; i++)if (tickMarks[i] === types_1.TickMark.ACTIVE) {
                        tickMarkEls[i].classList.add(constants_1.cssClasses.TICK_MARK_ACTIVE);
                        tickMarkEls[i].classList.remove(constants_1.cssClasses.TICK_MARK_INACTIVE);
                    } else {
                        tickMarkEls[i].classList.add(constants_1.cssClasses.TICK_MARK_INACTIVE);
                        tickMarkEls[i].classList.remove(constants_1.cssClasses.TICK_MARK_ACTIVE);
                    }
                };
                /** Initializes thumb ripples. */ MDCSlider.prototype.createRipples = function() {
                    var ripples = [];
                    var rippleSurfaces = [].slice.call(this.root.querySelectorAll("." + constants_1.cssClasses.THUMB));
                    var _loop_1 = function _loop_1(i) {
                        var rippleSurface = rippleSurfaces[i];
                        // Use the corresponding input as the focus source for the ripple (i.e.
                        // when the input is focused, the ripple is in the focused state).
                        var input = this_1.inputs[i];
                        var adapter = __assign(__assign({}, component_2.MDCRipple.createAdapter(this_1)), {
                            addClass: function addClass(className) {
                                rippleSurface.classList.add(className);
                            },
                            computeBoundingRect: function computeBoundingRect() {
                                return rippleSurface.getBoundingClientRect();
                            },
                            deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                                input.removeEventListener(evtType, handler);
                            },
                            isSurfaceActive: function isSurfaceActive() {
                                return ponyfill_1.matches(input, ":active");
                            },
                            isUnbounded: function isUnbounded() {
                                return true;
                            },
                            registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                                input.addEventListener(evtType, handler, events_1.applyPassive());
                            },
                            removeClass: function removeClass(className) {
                                rippleSurface.classList.remove(className);
                            },
                            updateCssVariable: function updateCssVariable(varName, value) {
                                rippleSurface.style.setProperty(varName, value);
                            }
                        });
                        var ripple = new component_2.MDCRipple(rippleSurface, new foundation_1.MDCRippleFoundation(adapter));
                        ripple.unbounded = true;
                        ripples.push(ripple);
                    };
                    var this_1 = this;
                    for(var i = 0; i < rippleSurfaces.length; i++)_loop_1(i);
                    return ripples;
                };
                return MDCSlider;
            }(component_1.MDCComponent);
            exports.MDCSlider = MDCSlider;
        /***/ },
        /***/ "./packages/mdc-slider/constants.ts": /*!******************************************!*\
  !*** ./packages/mdc-slider/constants.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.events = exports.attributes = exports.numbers = exports.cssClasses = void 0;
            /** Slider element classes. */ exports.cssClasses = {
                DISABLED: "mdc-slider--disabled",
                DISCRETE: "mdc-slider--discrete",
                INPUT: "mdc-slider__input",
                RANGE: "mdc-slider--range",
                THUMB: "mdc-slider__thumb",
                // Applied when thumb is in the focused state.
                THUMB_FOCUSED: "mdc-slider__thumb--focused",
                THUMB_KNOB: "mdc-slider__thumb-knob",
                // Class added to the top thumb (for overlapping thumbs in range slider).
                THUMB_TOP: "mdc-slider__thumb--top",
                THUMB_WITH_INDICATOR: "mdc-slider__thumb--with-indicator",
                TICK_MARKS: "mdc-slider--tick-marks",
                TICK_MARKS_CONTAINER: "mdc-slider__tick-marks",
                TICK_MARK_ACTIVE: "mdc-slider__tick-mark--active",
                TICK_MARK_INACTIVE: "mdc-slider__tick-mark--inactive",
                TRACK: "mdc-slider__track",
                // The active track fill element that will be scaled as the value changes.
                TRACK_ACTIVE: "mdc-slider__track--active_fill",
                VALUE_INDICATOR_TEXT: "mdc-slider__value-indicator-text"
            };
            /** Slider numbers. */ exports.numbers = {
                // Default step size.
                STEP_SIZE: 1,
                // Minimum absolute difference between clientX of move event / down event
                // for which to update thumb, in the case of overlapping thumbs.
                // This is needed to reduce chances of choosing the thumb based on
                // pointer jitter.
                THUMB_UPDATE_MIN_PX: 5
            };
            /** Slider attributes. */ exports.attributes = {
                ARIA_VALUETEXT: "aria-valuetext",
                INPUT_DISABLED: "disabled",
                INPUT_MIN: "min",
                INPUT_MAX: "max",
                INPUT_VALUE: "value",
                INPUT_STEP: "step"
            };
            /** Slider events. */ exports.events = {
                CHANGE: "MDCSlider:change",
                INPUT: "MDCSlider:input"
            };
        /***/ },
        /***/ "./packages/mdc-slider/custom-element.js": /*!***********************************************!*\
  !*** ./packages/mdc-slider/custom-element.js ***!
  \***********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-slider/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcSlider = function(_HTMLElement) {
                _inherits(MdcSlider, _HTMLElement);
                _createClass(MdcSlider, [
                    {
                        key: "focus",
                        value: function focus() {
                            var input = this.querySelector(".mdc-slider__input");
                            if (!input) return;
                            input.focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            if (this.contains(document.activeElement)) document.activeElement.blur();
                        }
                    },
                    {
                        key: "value",
                        get: function get() {
                            if (!!this.slider_) return this.slider_.value;
                            else return this.value_;
                        },
                        set: function set(value) {
                            this.value_ = value;
                            if (!!this.slider_) this.slider_.value = value;
                        }
                    },
                    {
                        key: "min",
                        get: function get() {
                            return this.min_;
                        },
                        set: function set(min) {
                            this.min_ = min;
                            if (!!this.slider_) this.slider_.min = min;
                        }
                    },
                    {
                        key: "max",
                        get: function get() {
                            return this.max_;
                        },
                        set: function set(max) {
                            this.max_ = max;
                            if (!!this.slider_) this.slider_.max = max;
                        }
                    },
                    {
                        key: "step",
                        get: function get() {
                            return this.step_;
                        },
                        set: function set(step) {
                            this.step_ = step;
                            if (!!this.slider_) this.slider_.step = step;
                        }
                    },
                    {
                        key: "disabled",
                        get: function get() {
                            return this.disabled_;
                        },
                        set: function set(disabled) {
                            this.disabled_ = disabled;
                            if (!!this.slider_) this.slider_.disabled = disabled;
                        }
                    }
                ]);
                function MdcSlider() {
                    _classCallCheck(this, MdcSlider);
                    var _this = _possibleConstructorReturn(this, (MdcSlider.__proto__ || Object.getPrototypeOf(MdcSlider)).call(this));
                    _this.value_ = 0;
                    _this.min_ = 0;
                    _this.max_ = 100;
                    _this.step_ = 0;
                    _this.disabled_ = false;
                    _this.slider_;
                    return _this;
                }
                _createClass(MdcSlider, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.style.display = "block";
                            /* TODO(width) */ this.style.width = "100%";
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.slider_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCSlider"](this);
                            this.slider_.value = this.value_;
                            this.slider_.min = this.min_;
                            this.slider_.max = this.max_;
                            this.slider_.step = this.step_;
                            this.slider_.disabled = this.disabled_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.slider_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcSlider;
            }(HTMLElement);
            customElements.define("mdc-slider", MdcSlider);
        /***/ },
        /***/ "./packages/mdc-slider/foundation.ts": /*!*******************************************!*\
  !*** ./packages/mdc-slider/foundation.ts ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSliderFoundation = void 0;
            var animationframe_1 = __webpack_require__(/*! @material/animation/animationframe */ "./packages/mdc-animation/animationframe.ts");
            var util_1 = __webpack_require__(/*! @material/animation/util */ "./packages/mdc-animation/util.ts");
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-slider/constants.ts");
            var types_1 = __webpack_require__(/*! ./types */ "./packages/mdc-slider/types.ts");
            var AnimationKeys;
            (function(AnimationKeys) {
                AnimationKeys["SLIDER_UPDATE"] = "slider_update";
            })(AnimationKeys || (AnimationKeys = {}));
            // Accessing `window` without a `typeof` check will throw on Node environments.
            var HAS_WINDOW = typeof window !== "undefined";
            /**
 * Foundation class for slider. Responsibilities include:
 * - Updating slider values (internal state and DOM updates) based on client
 *   'x' position.
 * - Updating DOM after slider property updates (e.g. min, max).
 */ var MDCSliderFoundation = /** @class */ function(_super) {
                __extends(MDCSliderFoundation, _super);
                function MDCSliderFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCSliderFoundation.defaultAdapter), adapter)) || this;
                    // Whether the initial styles (to position the thumb, before component
                    // initialization) have been removed.
                    _this.initialStylesRemoved = false;
                    _this.isDisabled = false;
                    _this.isDiscrete = false;
                    _this.step = constants_1.numbers.STEP_SIZE;
                    _this.hasTickMarks = false;
                    // The following properties are only set for range sliders.
                    _this.isRange = false;
                    // Tracks the thumb being moved across a slider pointer interaction (down,
                    // move event).
                    _this.thumb = null;
                    // `clientX` from the most recent down event. Used in subsequent move
                    // events to determine which thumb to move (in the case of
                    // overlapping thumbs).
                    _this.downEventClientX = null;
                    // Width of the start thumb knob.
                    _this.startThumbKnobWidth = 0;
                    // Width of the end thumb knob.
                    _this.endThumbKnobWidth = 0;
                    _this.animFrame = new animationframe_1.AnimationFrame();
                    return _this;
                }
                Object.defineProperty(MDCSliderFoundation, "defaultAdapter", {
                    get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same
                        // order as the adapter interface.
                        return {
                            hasClass: function hasClass() {
                                return false;
                            },
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            addThumbClass: function addThumbClass() {
                                return undefined;
                            },
                            removeThumbClass: function removeThumbClass() {
                                return undefined;
                            },
                            getAttribute: function getAttribute() {
                                return null;
                            },
                            getInputValue: function getInputValue() {
                                return "";
                            },
                            setInputValue: function setInputValue() {
                                return undefined;
                            },
                            getInputAttribute: function getInputAttribute() {
                                return null;
                            },
                            setInputAttribute: function setInputAttribute() {
                                return null;
                            },
                            removeInputAttribute: function removeInputAttribute() {
                                return null;
                            },
                            focusInput: function focusInput() {
                                return undefined;
                            },
                            isInputFocused: function isInputFocused() {
                                return false;
                            },
                            getThumbKnobWidth: function getThumbKnobWidth() {
                                return 0;
                            },
                            getThumbBoundingClientRect: function getThumbBoundingClientRect() {
                                return {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                    width: 0,
                                    height: 0
                                };
                            },
                            getBoundingClientRect: function getBoundingClientRect() {
                                return {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                    width: 0,
                                    height: 0
                                };
                            },
                            isRTL: function isRTL() {
                                return false;
                            },
                            setThumbStyleProperty: function setThumbStyleProperty() {
                                return undefined;
                            },
                            removeThumbStyleProperty: function removeThumbStyleProperty() {
                                return undefined;
                            },
                            setTrackActiveStyleProperty: function setTrackActiveStyleProperty() {
                                return undefined;
                            },
                            removeTrackActiveStyleProperty: function removeTrackActiveStyleProperty() {
                                return undefined;
                            },
                            setValueIndicatorText: function setValueIndicatorText() {
                                return undefined;
                            },
                            getValueToAriaValueTextFn: function getValueToAriaValueTextFn() {
                                return null;
                            },
                            updateTickMarks: function updateTickMarks() {
                                return undefined;
                            },
                            setPointerCapture: function setPointerCapture() {
                                return undefined;
                            },
                            emitChangeEvent: function emitChangeEvent() {
                                return undefined;
                            },
                            emitInputEvent: function emitInputEvent() {
                                return undefined;
                            },
                            emitDragStartEvent: function emitDragStartEvent() {
                                return undefined;
                            },
                            emitDragEndEvent: function emitDragEndEvent() {
                                return undefined;
                            },
                            registerEventHandler: function registerEventHandler() {
                                return undefined;
                            },
                            deregisterEventHandler: function deregisterEventHandler() {
                                return undefined;
                            },
                            registerThumbEventHandler: function registerThumbEventHandler() {
                                return undefined;
                            },
                            deregisterThumbEventHandler: function deregisterThumbEventHandler() {
                                return undefined;
                            },
                            registerInputEventHandler: function registerInputEventHandler() {
                                return undefined;
                            },
                            deregisterInputEventHandler: function deregisterInputEventHandler() {
                                return undefined;
                            },
                            registerBodyEventHandler: function registerBodyEventHandler() {
                                return undefined;
                            },
                            deregisterBodyEventHandler: function deregisterBodyEventHandler() {
                                return undefined;
                            },
                            registerWindowEventHandler: function registerWindowEventHandler() {
                                return undefined;
                            },
                            deregisterWindowEventHandler: function deregisterWindowEventHandler() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSliderFoundation.prototype.init = function() {
                    var _this = this;
                    this.isDisabled = this.adapter.hasClass(constants_1.cssClasses.DISABLED);
                    this.isDiscrete = this.adapter.hasClass(constants_1.cssClasses.DISCRETE);
                    this.hasTickMarks = this.adapter.hasClass(constants_1.cssClasses.TICK_MARKS);
                    this.isRange = this.adapter.hasClass(constants_1.cssClasses.RANGE);
                    var min = this.convertAttributeValueToNumber(this.adapter.getInputAttribute(constants_1.attributes.INPUT_MIN, this.isRange ? types_1.Thumb.START : types_1.Thumb.END), constants_1.attributes.INPUT_MIN);
                    var max = this.convertAttributeValueToNumber(this.adapter.getInputAttribute(constants_1.attributes.INPUT_MAX, types_1.Thumb.END), constants_1.attributes.INPUT_MAX);
                    var value = this.convertAttributeValueToNumber(this.adapter.getInputAttribute(constants_1.attributes.INPUT_VALUE, types_1.Thumb.END), constants_1.attributes.INPUT_VALUE);
                    var valueStart = this.isRange ? this.convertAttributeValueToNumber(this.adapter.getInputAttribute(constants_1.attributes.INPUT_VALUE, types_1.Thumb.START), constants_1.attributes.INPUT_VALUE) : min;
                    var stepAttr = this.adapter.getInputAttribute(constants_1.attributes.INPUT_STEP, types_1.Thumb.END);
                    var step = stepAttr ? this.convertAttributeValueToNumber(stepAttr, constants_1.attributes.INPUT_STEP) : this.step;
                    this.validateProperties({
                        min: min,
                        max: max,
                        value: value,
                        valueStart: valueStart,
                        step: step
                    });
                    this.min = min;
                    this.max = max;
                    this.value = value;
                    this.valueStart = valueStart;
                    this.step = step;
                    this.numDecimalPlaces = getNumDecimalPlaces(this.step);
                    this.valueBeforeDownEvent = value;
                    this.valueStartBeforeDownEvent = valueStart;
                    this.mousedownOrTouchstartListener = this.handleMousedownOrTouchstart.bind(this);
                    this.moveListener = this.handleMove.bind(this);
                    this.pointerdownListener = this.handlePointerdown.bind(this);
                    this.pointerupListener = this.handlePointerup.bind(this);
                    this.thumbMouseenterListener = this.handleThumbMouseenter.bind(this);
                    this.thumbMouseleaveListener = this.handleThumbMouseleave.bind(this);
                    this.inputStartChangeListener = function() {
                        _this.handleInputChange(types_1.Thumb.START);
                    };
                    this.inputEndChangeListener = function() {
                        _this.handleInputChange(types_1.Thumb.END);
                    };
                    this.inputStartFocusListener = function() {
                        _this.handleInputFocus(types_1.Thumb.START);
                    };
                    this.inputEndFocusListener = function() {
                        _this.handleInputFocus(types_1.Thumb.END);
                    };
                    this.inputStartBlurListener = function() {
                        _this.handleInputBlur(types_1.Thumb.START);
                    };
                    this.inputEndBlurListener = function() {
                        _this.handleInputBlur(types_1.Thumb.END);
                    };
                    this.resizeListener = this.handleResize.bind(this);
                    this.registerEventHandlers();
                };
                MDCSliderFoundation.prototype.destroy = function() {
                    this.deregisterEventHandlers();
                };
                MDCSliderFoundation.prototype.getMin = function() {
                    return this.min;
                };
                MDCSliderFoundation.prototype.getMax = function() {
                    return this.max;
                };
                /**
     * - For single point sliders, returns the thumb value.
     * - For range (two-thumb) sliders, returns the end thumb's value.
     */ MDCSliderFoundation.prototype.getValue = function() {
                    return this.value;
                };
                /**
     * - For single point sliders, sets the thumb value.
     * - For range (two-thumb) sliders, sets the end thumb's value.
     */ MDCSliderFoundation.prototype.setValue = function(value) {
                    if (this.isRange && value < this.valueStart) throw new Error("end thumb value (" + value + ") must be >= start thumb " + ("value (" + this.valueStart + ")"));
                    this.updateValue(value, types_1.Thumb.END);
                };
                /**
     * Only applicable for range sliders.
     * @return The start thumb's value.
     */ MDCSliderFoundation.prototype.getValueStart = function() {
                    if (!this.isRange) throw new Error("`valueStart` is only applicable for range sliders.");
                    return this.valueStart;
                };
                /**
     * Only applicable for range sliders. Sets the start thumb's value.
     */ MDCSliderFoundation.prototype.setValueStart = function(valueStart) {
                    if (!this.isRange) throw new Error("`valueStart` is only applicable for range sliders.");
                    if (this.isRange && valueStart > this.value) throw new Error("start thumb value (" + valueStart + ") must be <= end thumb " + ("value (" + this.value + ")"));
                    this.updateValue(valueStart, types_1.Thumb.START);
                };
                MDCSliderFoundation.prototype.getStep = function() {
                    return this.step;
                };
                MDCSliderFoundation.prototype.getDisabled = function() {
                    return this.isDisabled;
                };
                /**
     * Sets disabled state, including updating styles and thumb tabindex.
     */ MDCSliderFoundation.prototype.setDisabled = function(disabled) {
                    this.isDisabled = disabled;
                    if (disabled) {
                        this.adapter.addClass(constants_1.cssClasses.DISABLED);
                        if (this.isRange) this.adapter.setInputAttribute(constants_1.attributes.INPUT_DISABLED, "", types_1.Thumb.START);
                        this.adapter.setInputAttribute(constants_1.attributes.INPUT_DISABLED, "", types_1.Thumb.END);
                    } else {
                        this.adapter.removeClass(constants_1.cssClasses.DISABLED);
                        if (this.isRange) this.adapter.removeInputAttribute(constants_1.attributes.INPUT_DISABLED, types_1.Thumb.START);
                        this.adapter.removeInputAttribute(constants_1.attributes.INPUT_DISABLED, types_1.Thumb.END);
                    }
                };
                /** @return Whether the slider is a range slider. */ MDCSliderFoundation.prototype.getIsRange = function() {
                    return this.isRange;
                };
                /**
     * - Syncs slider boundingClientRect with the current DOM.
     * - Updates UI based on internal state.
     */ MDCSliderFoundation.prototype.layout = function(_a) {
                    var _b = _a === void 0 ? {} : _a, skipUpdateUI = _b.skipUpdateUI;
                    this.rect = this.adapter.getBoundingClientRect();
                    if (this.isRange) {
                        this.startThumbKnobWidth = this.adapter.getThumbKnobWidth(types_1.Thumb.START);
                        this.endThumbKnobWidth = this.adapter.getThumbKnobWidth(types_1.Thumb.END);
                    }
                    if (!skipUpdateUI) this.updateUI();
                };
                /** Handles resize events on the window. */ MDCSliderFoundation.prototype.handleResize = function() {
                    this.layout();
                };
                /**
     * Handles pointer down events on the slider root element.
     */ MDCSliderFoundation.prototype.handleDown = function(event) {
                    if (this.isDisabled) return;
                    this.valueStartBeforeDownEvent = this.valueStart;
                    this.valueBeforeDownEvent = this.value;
                    var clientX = event.clientX != null ? event.clientX : event.targetTouches[0].clientX;
                    this.downEventClientX = clientX;
                    var value = this.mapClientXOnSliderScale(clientX);
                    this.thumb = this.getThumbFromDownEvent(clientX, value);
                    if (this.thumb === null) return;
                    this.handleDragStart(event, value, this.thumb);
                    this.updateValue(value, this.thumb, {
                        emitInputEvent: true
                    });
                };
                /**
     * Handles pointer move events on the slider root element.
     */ MDCSliderFoundation.prototype.handleMove = function(event) {
                    if (this.isDisabled) return;
                    // Prevent scrolling.
                    event.preventDefault();
                    var clientX = event.clientX != null ? event.clientX : event.targetTouches[0].clientX;
                    var dragAlreadyStarted = this.thumb != null;
                    this.thumb = this.getThumbFromMoveEvent(clientX);
                    if (this.thumb === null) return;
                    var value = this.mapClientXOnSliderScale(clientX);
                    if (!dragAlreadyStarted) {
                        this.handleDragStart(event, value, this.thumb);
                        this.adapter.emitDragStartEvent(value, this.thumb);
                    }
                    this.updateValue(value, this.thumb, {
                        emitInputEvent: true
                    });
                };
                /**
     * Handles pointer up events on the slider root element.
     */ MDCSliderFoundation.prototype.handleUp = function() {
                    if (this.isDisabled || this.thumb === null) return;
                    var oldValue = this.thumb === types_1.Thumb.START ? this.valueStartBeforeDownEvent : this.valueBeforeDownEvent;
                    var newValue = this.thumb === types_1.Thumb.START ? this.valueStart : this.value;
                    if (oldValue !== newValue) this.adapter.emitChangeEvent(newValue, this.thumb);
                    this.adapter.emitDragEndEvent(newValue, this.thumb);
                    this.thumb = null;
                };
                /**
     * For range, discrete slider, shows the value indicator on both thumbs.
     */ MDCSliderFoundation.prototype.handleThumbMouseenter = function() {
                    if (!this.isDiscrete || !this.isRange) return;
                    this.adapter.addThumbClass(constants_1.cssClasses.THUMB_WITH_INDICATOR, types_1.Thumb.START);
                    this.adapter.addThumbClass(constants_1.cssClasses.THUMB_WITH_INDICATOR, types_1.Thumb.END);
                };
                /**
     * For range, discrete slider, hides the value indicator on both thumbs.
     */ MDCSliderFoundation.prototype.handleThumbMouseleave = function() {
                    if (!this.isDiscrete || !this.isRange) return;
                    if (this.adapter.isInputFocused(types_1.Thumb.START) || this.adapter.isInputFocused(types_1.Thumb.END)) // Leave value indicator shown if either input is focused.
                    return;
                    this.adapter.removeThumbClass(constants_1.cssClasses.THUMB_WITH_INDICATOR, types_1.Thumb.START);
                    this.adapter.removeThumbClass(constants_1.cssClasses.THUMB_WITH_INDICATOR, types_1.Thumb.END);
                };
                MDCSliderFoundation.prototype.handleMousedownOrTouchstart = function(event) {
                    var _this = this;
                    var moveEventType = event.type === "mousedown" ? "mousemove" : "touchmove";
                    // After a down event on the slider root, listen for move events on
                    // body (so the slider value is updated for events outside of the
                    // slider root).
                    this.adapter.registerBodyEventHandler(moveEventType, this.moveListener);
                    var upHandler = function upHandler() {
                        _this.handleUp();
                        // Once the drag is finished (up event on body), remove the move
                        // handler.
                        _this.adapter.deregisterBodyEventHandler(moveEventType, _this.moveListener);
                        // Also stop listening for subsequent up events.
                        _this.adapter.deregisterEventHandler("mouseup", upHandler);
                        _this.adapter.deregisterEventHandler("touchend", upHandler);
                    };
                    this.adapter.registerBodyEventHandler("mouseup", upHandler);
                    this.adapter.registerBodyEventHandler("touchend", upHandler);
                    this.handleDown(event);
                };
                MDCSliderFoundation.prototype.handlePointerdown = function(event) {
                    this.adapter.setPointerCapture(event.pointerId);
                    this.adapter.registerEventHandler("pointermove", this.moveListener);
                    this.handleDown(event);
                };
                /**
     * Handles input `change` event by setting internal slider value to match
     * input's new value.
     */ MDCSliderFoundation.prototype.handleInputChange = function(thumb) {
                    var value = Number(this.adapter.getInputValue(thumb));
                    if (thumb === types_1.Thumb.START) this.setValueStart(value);
                    else this.setValue(value);
                    this.adapter.emitChangeEvent(thumb === types_1.Thumb.START ? this.valueStart : this.value, thumb);
                    this.adapter.emitInputEvent(thumb === types_1.Thumb.START ? this.valueStart : this.value, thumb);
                };
                /** Shows activated state and value indicator on thumb(s). */ MDCSliderFoundation.prototype.handleInputFocus = function(thumb) {
                    this.adapter.addThumbClass(constants_1.cssClasses.THUMB_FOCUSED, thumb);
                    if (!this.isDiscrete) return;
                    this.adapter.addThumbClass(constants_1.cssClasses.THUMB_WITH_INDICATOR, thumb);
                    if (this.isRange) {
                        var otherThumb = thumb === types_1.Thumb.START ? types_1.Thumb.END : types_1.Thumb.START;
                        this.adapter.addThumbClass(constants_1.cssClasses.THUMB_WITH_INDICATOR, otherThumb);
                    }
                };
                /** Removes activated state and value indicator from thumb(s). */ MDCSliderFoundation.prototype.handleInputBlur = function(thumb) {
                    this.adapter.removeThumbClass(constants_1.cssClasses.THUMB_FOCUSED, thumb);
                    if (!this.isDiscrete) return;
                    this.adapter.removeThumbClass(constants_1.cssClasses.THUMB_WITH_INDICATOR, thumb);
                    if (this.isRange) {
                        var otherThumb = thumb === types_1.Thumb.START ? types_1.Thumb.END : types_1.Thumb.START;
                        this.adapter.removeThumbClass(constants_1.cssClasses.THUMB_WITH_INDICATOR, otherThumb);
                    }
                };
                /**
     * Emits custom dragStart event, along with focusing the underlying input.
     */ MDCSliderFoundation.prototype.handleDragStart = function(event, value, thumb) {
                    this.adapter.focusInput(thumb);
                    // Prevent the input (that we just focused) from losing focus.
                    event.preventDefault();
                    this.adapter.emitDragStartEvent(value, thumb);
                };
                /**
     * @return The thumb to be moved based on initial down event.
     */ MDCSliderFoundation.prototype.getThumbFromDownEvent = function(clientX, value) {
                    // For single point slider, thumb to be moved is always the END (only)
                    // thumb.
                    if (!this.isRange) return types_1.Thumb.END;
                    // Check if event press point is in the bounds of any thumb.
                    var thumbStartRect = this.adapter.getThumbBoundingClientRect(types_1.Thumb.START);
                    var thumbEndRect = this.adapter.getThumbBoundingClientRect(types_1.Thumb.END);
                    var inThumbStartBounds = clientX >= thumbStartRect.left && clientX <= thumbStartRect.right;
                    var inThumbEndBounds = clientX >= thumbEndRect.left && clientX <= thumbEndRect.right;
                    if (inThumbStartBounds && inThumbEndBounds) // Thumbs overlapping. Thumb to be moved cannot be determined yet.
                    return null;
                    // If press is in bounds for either thumb on down event, that's the thumb
                    // to be moved.
                    if (inThumbStartBounds) return types_1.Thumb.START;
                    if (inThumbEndBounds) return types_1.Thumb.END;
                    // For presses outside the range, return whichever thumb is closer.
                    if (value < this.valueStart) return types_1.Thumb.START;
                    if (value > this.value) return types_1.Thumb.END;
                    // For presses inside the range, return whichever thumb is closer.
                    return value - this.valueStart <= this.value - value ? types_1.Thumb.START : types_1.Thumb.END;
                };
                /**
     * @return The thumb to be moved based on move event (based on drag
     *     direction from original down event). Only applicable if thumbs
     *     were overlapping in the down event.
     */ MDCSliderFoundation.prototype.getThumbFromMoveEvent = function(clientX) {
                    // Thumb has already been chosen.
                    if (this.thumb !== null) return this.thumb;
                    if (this.downEventClientX === null) throw new Error("`downEventClientX` is null after move event.");
                    var moveDistanceUnderThreshold = Math.abs(this.downEventClientX - clientX) < constants_1.numbers.THUMB_UPDATE_MIN_PX;
                    if (moveDistanceUnderThreshold) return this.thumb;
                    var draggedThumbToLeft = clientX < this.downEventClientX;
                    if (draggedThumbToLeft) return this.adapter.isRTL() ? types_1.Thumb.END : types_1.Thumb.START;
                    else return this.adapter.isRTL() ? types_1.Thumb.START : types_1.Thumb.END;
                };
                /**
     * Updates UI based on internal state.
     * @param thumb Thumb whose value is being updated. If undefined, UI is
     *     updated for both thumbs based on current internal state.
     */ MDCSliderFoundation.prototype.updateUI = function(thumb) {
                    this.updateThumbAndInputAttributes(thumb);
                    this.updateThumbAndTrackUI(thumb);
                    this.updateValueIndicatorUI(thumb);
                    this.updateTickMarksUI();
                };
                /**
     * Updates thumb and input attributes based on current value.
     * @param thumb Thumb whose aria attributes to update.
     */ MDCSliderFoundation.prototype.updateThumbAndInputAttributes = function(thumb) {
                    if (!thumb) return;
                    var value = this.isRange && thumb === types_1.Thumb.START ? this.valueStart : this.value;
                    var valueStr = String(value);
                    this.adapter.setInputAttribute(constants_1.attributes.INPUT_VALUE, valueStr, thumb);
                    if (this.isRange && thumb === types_1.Thumb.START) this.adapter.setInputAttribute(constants_1.attributes.INPUT_MIN, valueStr, types_1.Thumb.END);
                    else if (this.isRange && thumb === types_1.Thumb.END) this.adapter.setInputAttribute(constants_1.attributes.INPUT_MAX, valueStr, types_1.Thumb.START);
                    // Sync attribute with property.
                    if (this.adapter.getInputValue(thumb) !== valueStr) this.adapter.setInputValue(valueStr, thumb);
                    var valueToAriaValueTextFn = this.adapter.getValueToAriaValueTextFn();
                    if (valueToAriaValueTextFn) this.adapter.setInputAttribute(constants_1.attributes.ARIA_VALUETEXT, valueToAriaValueTextFn(value), thumb);
                };
                /**
     * Updates value indicator UI based on current value.
     * @param thumb Thumb whose value indicator to update. If undefined, all
     *     thumbs' value indicators are updated.
     */ MDCSliderFoundation.prototype.updateValueIndicatorUI = function(thumb) {
                    if (!this.isDiscrete) return;
                    var value = this.isRange && thumb === types_1.Thumb.START ? this.valueStart : this.value;
                    this.adapter.setValueIndicatorText(value, thumb === types_1.Thumb.START ? types_1.Thumb.START : types_1.Thumb.END);
                    if (!thumb && this.isRange) this.adapter.setValueIndicatorText(this.valueStart, types_1.Thumb.START);
                };
                /**
     * Updates tick marks UI within slider, based on current min, max, and step.
     */ MDCSliderFoundation.prototype.updateTickMarksUI = function() {
                    if (!this.isDiscrete || !this.hasTickMarks) return;
                    var numTickMarksInactiveStart = (this.valueStart - this.min) / this.step;
                    var numTickMarksActive = (this.value - this.valueStart) / this.step + 1;
                    var numTickMarksInactiveEnd = (this.max - this.value) / this.step;
                    var tickMarksInactiveStart = Array.from({
                        length: numTickMarksInactiveStart
                    }).fill(types_1.TickMark.INACTIVE);
                    var tickMarksActive = Array.from({
                        length: numTickMarksActive
                    }).fill(types_1.TickMark.ACTIVE);
                    var tickMarksInactiveEnd = Array.from({
                        length: numTickMarksInactiveEnd
                    }).fill(types_1.TickMark.INACTIVE);
                    this.adapter.updateTickMarks(tickMarksInactiveStart.concat(tickMarksActive).concat(tickMarksInactiveEnd));
                };
                /** Maps clientX to a value on the slider scale. */ MDCSliderFoundation.prototype.mapClientXOnSliderScale = function(clientX) {
                    var xPos = clientX - this.rect.left;
                    var pctComplete = xPos / this.rect.width;
                    if (this.adapter.isRTL()) pctComplete = 1 - pctComplete;
                    // Fit the percentage complete between the range [min,max]
                    // by remapping from [0, 1] to [min, min+(max-min)].
                    var value = this.min + pctComplete * (this.max - this.min);
                    if (value === this.max || value === this.min) return value;
                    return Number(this.quantize(value).toFixed(this.numDecimalPlaces));
                };
                /** Calculates the quantized value based on step value. */ MDCSliderFoundation.prototype.quantize = function(value) {
                    var numSteps = Math.round((value - this.min) / this.step);
                    return this.min + numSteps * this.step;
                };
                /**
     * Updates slider value (internal state and UI) based on the given value.
     */ MDCSliderFoundation.prototype.updateValue = function(value, thumb, _a) {
                    var _b = _a === void 0 ? {} : _a, emitInputEvent = _b.emitInputEvent;
                    value = this.clampValue(value, thumb);
                    if (this.isRange && thumb === types_1.Thumb.START) {
                        // Exit early if current value is the same as the new value.
                        if (this.valueStart === value) return;
                        this.valueStart = value;
                    } else {
                        // Exit early if current value is the same as the new value.
                        if (this.value === value) return;
                        this.value = value;
                    }
                    this.updateUI(thumb);
                    if (emitInputEvent) this.adapter.emitInputEvent(thumb === types_1.Thumb.START ? this.valueStart : this.value, thumb);
                };
                /**
     * Clamps the given value for the given thumb based on slider properties:
     * - Restricts value within [min, max].
     * - If range slider, clamp start value <= end value, and
     *   end value >= start value.
     */ MDCSliderFoundation.prototype.clampValue = function(value, thumb) {
                    // Clamp value to [min, max] range.
                    value = Math.min(Math.max(value, this.min), this.max);
                    var thumbStartMovedPastThumbEnd = this.isRange && thumb === types_1.Thumb.START && value > this.value;
                    if (thumbStartMovedPastThumbEnd) return this.value;
                    var thumbEndMovedPastThumbStart = this.isRange && thumb === types_1.Thumb.END && value < this.valueStart;
                    if (thumbEndMovedPastThumbStart) return this.valueStart;
                    return value;
                };
                /**
     * Updates the active track and thumb style properties to reflect current
     * value.
     */ MDCSliderFoundation.prototype.updateThumbAndTrackUI = function(thumb) {
                    var _this = this;
                    var _a = this, max = _a.max, min = _a.min;
                    var pctComplete = (this.value - this.valueStart) / (max - min);
                    var rangePx = pctComplete * this.rect.width;
                    var isRtl = this.adapter.isRTL();
                    var transformProp = HAS_WINDOW ? util_1.getCorrectPropertyName(window, "transform") : "transform";
                    if (this.isRange) {
                        var thumbLeftPos_1 = this.adapter.isRTL() ? (max - this.value) / (max - min) * this.rect.width : (this.valueStart - min) / (max - min) * this.rect.width;
                        var thumbRightPos_1 = thumbLeftPos_1 + rangePx;
                        this.animFrame.request(AnimationKeys.SLIDER_UPDATE, function() {
                            // Set active track styles, accounting for animation direction by
                            // setting `transform-origin`.
                            var trackAnimatesFromRight = !isRtl && thumb === types_1.Thumb.START || isRtl && thumb !== types_1.Thumb.START;
                            if (trackAnimatesFromRight) {
                                _this.adapter.setTrackActiveStyleProperty("transform-origin", "right");
                                _this.adapter.setTrackActiveStyleProperty("left", "unset");
                                _this.adapter.setTrackActiveStyleProperty("right", _this.rect.width - thumbRightPos_1 + "px");
                            } else {
                                _this.adapter.setTrackActiveStyleProperty("transform-origin", "left");
                                _this.adapter.setTrackActiveStyleProperty("right", "unset");
                                _this.adapter.setTrackActiveStyleProperty("left", thumbLeftPos_1 + "px");
                            }
                            _this.adapter.setTrackActiveStyleProperty(transformProp, "scaleX(" + pctComplete + ")");
                            // Set thumb styles.
                            var thumbStartPos = isRtl ? thumbRightPos_1 : thumbLeftPos_1;
                            var thumbEndPos = _this.adapter.isRTL() ? thumbLeftPos_1 : thumbRightPos_1;
                            if (thumb === types_1.Thumb.START || !thumb || !_this.initialStylesRemoved) _this.adapter.setThumbStyleProperty(transformProp, "translateX(" + thumbStartPos + "px)", types_1.Thumb.START);
                            if (thumb === types_1.Thumb.END || !thumb || !_this.initialStylesRemoved) _this.adapter.setThumbStyleProperty(transformProp, "translateX(" + thumbEndPos + "px)", types_1.Thumb.END);
                            _this.removeInitialStyles(isRtl);
                            _this.updateOverlappingThumbsUI(thumbStartPos, thumbEndPos, thumb);
                        });
                    } else this.animFrame.request(AnimationKeys.SLIDER_UPDATE, function() {
                        var thumbStartPos = isRtl ? _this.rect.width - rangePx : rangePx;
                        _this.adapter.setThumbStyleProperty(transformProp, "translateX(" + thumbStartPos + "px)", types_1.Thumb.END);
                        _this.adapter.setTrackActiveStyleProperty(transformProp, "scaleX(" + pctComplete + ")");
                        _this.removeInitialStyles(isRtl);
                    });
                };
                /**
     * Removes initial inline styles if not already removed. `left:<...>%`
     * inline styles can be added to position the thumb correctly before JS
     * initialization. However, they need to be removed before the JS starts
     * positioning the thumb. This is because the JS uses
     * `transform:translateX(<...>)px` (for performance reasons) to position
     * the thumb (which is not possible for initial styles since we need the
     * bounding rect measurements).
     */ MDCSliderFoundation.prototype.removeInitialStyles = function(isRtl) {
                    if (this.initialStylesRemoved) return;
                    // Remove thumb position properties that were added for initial render.
                    var position = isRtl ? "right" : "left";
                    this.adapter.removeThumbStyleProperty(position, types_1.Thumb.END);
                    if (this.isRange) this.adapter.removeThumbStyleProperty(position, types_1.Thumb.START);
                    this.initialStylesRemoved = true;
                    this.resetTrackAndThumbAnimation();
                };
                /**
     * Resets track/thumb animation to prevent animation when adding
     * `transform` styles to thumb initially.
     */ MDCSliderFoundation.prototype.resetTrackAndThumbAnimation = function() {
                    var _this = this;
                    if (!this.isDiscrete) return;
                    // Set transition properties to default (no animation), so that the
                    // newly added `transform` styles do not animate thumb/track from
                    // their default positions.
                    var transitionProp = HAS_WINDOW ? util_1.getCorrectPropertyName(window, "transition") : "transition";
                    var transitionDefault = "all 0s ease 0s";
                    this.adapter.setThumbStyleProperty(transitionProp, transitionDefault, types_1.Thumb.END);
                    if (this.isRange) this.adapter.setThumbStyleProperty(transitionProp, transitionDefault, types_1.Thumb.START);
                    this.adapter.setTrackActiveStyleProperty(transitionProp, transitionDefault);
                    // In the next frame, remove the transition inline styles we just
                    // added, such that any animations added in the CSS can now take effect.
                    requestAnimationFrame(function() {
                        _this.adapter.removeThumbStyleProperty(transitionProp, types_1.Thumb.END);
                        _this.adapter.removeTrackActiveStyleProperty(transitionProp);
                        if (_this.isRange) _this.adapter.removeThumbStyleProperty(transitionProp, types_1.Thumb.START);
                    });
                };
                /**
     * Adds THUMB_TOP class to active thumb if thumb knobs overlap; otherwise
     * removes THUMB_TOP class from both thumbs.
     * @param thumb Thumb that is active (being moved).
     */ MDCSliderFoundation.prototype.updateOverlappingThumbsUI = function(thumbStartPos, thumbEndPos, thumb) {
                    var thumbsOverlap = false;
                    if (this.adapter.isRTL()) {
                        var startThumbLeftEdge = thumbStartPos - this.startThumbKnobWidth / 2;
                        var endThumbRightEdge = thumbEndPos + this.endThumbKnobWidth / 2;
                        thumbsOverlap = endThumbRightEdge >= startThumbLeftEdge;
                    } else {
                        var startThumbRightEdge = thumbStartPos + this.startThumbKnobWidth / 2;
                        var endThumbLeftEdge = thumbEndPos - this.endThumbKnobWidth / 2;
                        thumbsOverlap = startThumbRightEdge >= endThumbLeftEdge;
                    }
                    if (thumbsOverlap) {
                        this.adapter.addThumbClass(constants_1.cssClasses.THUMB_TOP, // If no thumb was dragged (in the case of initial layout), end
                        // thumb is on top by default.
                        thumb || types_1.Thumb.END);
                        this.adapter.removeThumbClass(constants_1.cssClasses.THUMB_TOP, thumb === types_1.Thumb.START ? types_1.Thumb.END : types_1.Thumb.START);
                    } else {
                        this.adapter.removeThumbClass(constants_1.cssClasses.THUMB_TOP, types_1.Thumb.START);
                        this.adapter.removeThumbClass(constants_1.cssClasses.THUMB_TOP, types_1.Thumb.END);
                    }
                };
                /**
     * Converts attribute value to a number, e.g. '100' => 100. Throws errors
     * for invalid values.
     * @param attributeValue Attribute value, e.g. 100.
     * @param attributeName Attribute name, e.g. `aria-valuemax`.
     */ MDCSliderFoundation.prototype.convertAttributeValueToNumber = function(attributeValue, attributeName) {
                    if (attributeValue === null) throw new Error("MDCSliderFoundation: `" + attributeName + "` must be non-null.");
                    var value = Number(attributeValue);
                    if (isNaN(value)) throw new Error("MDCSliderFoundation: `" + attributeName + "` value is " + ("`" + attributeValue + "`, but must be a number."));
                    return value;
                };
                /** Checks that the given properties are valid slider values. */ MDCSliderFoundation.prototype.validateProperties = function(_a) {
                    var min = _a.min, max = _a.max, value = _a.value, valueStart = _a.valueStart, step = _a.step;
                    if (min >= max) throw new Error("MDCSliderFoundation: min must be strictly less than max. " + ("Current: [min: " + min + ", max: " + max + "]"));
                    if (step <= 0) throw new Error("MDCSliderFoundation: step must be a positive number. " + ("Current step: " + this.step));
                    if (this.isRange) {
                        if (value < min || value > max || valueStart < min || valueStart > max) throw new Error("MDCSliderFoundation: values must be in [min, max] range. " + ("Current values: [start value: " + valueStart + ", end value: " + value + "]"));
                        if (valueStart > value) throw new Error("MDCSliderFoundation: start value must be <= end value. " + ("Current values: [start value: " + valueStart + ", end value: " + value + "]"));
                        var numStepsValueStartFromMin = (valueStart - min) / step;
                        var numStepsValueFromMin = (value - min) / step;
                        if (numStepsValueStartFromMin % 1 !== 0 || numStepsValueFromMin % 1 !== 0) throw new Error("MDCSliderFoundation: Slider values must be valid based on the " + ("step value. Current values: [start value: " + valueStart + ", ") + ("end value: " + value + "]"));
                    } else {
                        // Single point slider.
                        if (value < min || value > max) throw new Error("MDCSliderFoundation: value must be in [min, max] range. " + ("Current value: " + value));
                        var numStepsValueFromMin = (value - min) / step;
                        if (numStepsValueFromMin % 1 !== 0) throw new Error("MDCSliderFoundation: Slider value must be valid based on the " + ("step value. Current value: " + value));
                    }
                };
                MDCSliderFoundation.prototype.registerEventHandlers = function() {
                    this.adapter.registerWindowEventHandler("resize", this.resizeListener);
                    if (MDCSliderFoundation.SUPPORTS_POINTER_EVENTS) {
                        // If supported, use pointer events API with #setPointerCapture.
                        this.adapter.registerEventHandler("pointerdown", this.pointerdownListener);
                        this.adapter.registerEventHandler("pointerup", this.pointerupListener);
                    } else {
                        // Otherwise, fall back to mousedown/touchstart events.
                        this.adapter.registerEventHandler("mousedown", this.mousedownOrTouchstartListener);
                        this.adapter.registerEventHandler("touchstart", this.mousedownOrTouchstartListener);
                    }
                    if (this.isRange) {
                        this.adapter.registerThumbEventHandler(types_1.Thumb.START, "mouseenter", this.thumbMouseenterListener);
                        this.adapter.registerThumbEventHandler(types_1.Thumb.START, "mouseleave", this.thumbMouseleaveListener);
                        this.adapter.registerInputEventHandler(types_1.Thumb.START, "change", this.inputStartChangeListener);
                        this.adapter.registerInputEventHandler(types_1.Thumb.START, "focus", this.inputStartFocusListener);
                        this.adapter.registerInputEventHandler(types_1.Thumb.START, "blur", this.inputStartBlurListener);
                    }
                    this.adapter.registerThumbEventHandler(types_1.Thumb.END, "mouseenter", this.thumbMouseenterListener);
                    this.adapter.registerThumbEventHandler(types_1.Thumb.END, "mouseleave", this.thumbMouseleaveListener);
                    this.adapter.registerInputEventHandler(types_1.Thumb.END, "change", this.inputEndChangeListener);
                    this.adapter.registerInputEventHandler(types_1.Thumb.END, "focus", this.inputEndFocusListener);
                    this.adapter.registerInputEventHandler(types_1.Thumb.END, "blur", this.inputEndBlurListener);
                };
                MDCSliderFoundation.prototype.deregisterEventHandlers = function() {
                    this.adapter.deregisterWindowEventHandler("resize", this.resizeListener);
                    if (MDCSliderFoundation.SUPPORTS_POINTER_EVENTS) {
                        this.adapter.deregisterEventHandler("pointerdown", this.pointerdownListener);
                        this.adapter.deregisterEventHandler("pointerup", this.pointerupListener);
                    } else {
                        this.adapter.deregisterEventHandler("mousedown", this.mousedownOrTouchstartListener);
                        this.adapter.deregisterEventHandler("touchstart", this.mousedownOrTouchstartListener);
                    }
                    if (this.isRange) {
                        this.adapter.deregisterThumbEventHandler(types_1.Thumb.START, "mouseenter", this.thumbMouseenterListener);
                        this.adapter.deregisterThumbEventHandler(types_1.Thumb.START, "mouseleave", this.thumbMouseleaveListener);
                        this.adapter.deregisterInputEventHandler(types_1.Thumb.START, "change", this.inputStartChangeListener);
                        this.adapter.deregisterInputEventHandler(types_1.Thumb.START, "focus", this.inputStartFocusListener);
                        this.adapter.deregisterInputEventHandler(types_1.Thumb.START, "blur", this.inputStartBlurListener);
                    }
                    this.adapter.deregisterThumbEventHandler(types_1.Thumb.END, "mouseenter", this.thumbMouseenterListener);
                    this.adapter.deregisterThumbEventHandler(types_1.Thumb.END, "mouseleave", this.thumbMouseleaveListener);
                    this.adapter.deregisterInputEventHandler(types_1.Thumb.END, "change", this.inputEndChangeListener);
                    this.adapter.deregisterInputEventHandler(types_1.Thumb.END, "focus", this.inputEndFocusListener);
                    this.adapter.deregisterInputEventHandler(types_1.Thumb.END, "blur", this.inputEndBlurListener);
                };
                MDCSliderFoundation.prototype.handlePointerup = function() {
                    this.handleUp();
                    this.adapter.deregisterEventHandler("pointermove", this.moveListener);
                };
                MDCSliderFoundation.SUPPORTS_POINTER_EVENTS = HAS_WINDOW && Boolean(window.PointerEvent) && // #setPointerCapture is buggy on iOS, so we can't use pointer events
                // until the following bug is fixed:
                // https://bugs.webkit.org/show_bug.cgi?id=220196
                !isIOS();
                return MDCSliderFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCSliderFoundation = MDCSliderFoundation;
            function isIOS() {
                // Source:
                // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
                return [
                    "iPad Simulator",
                    "iPhone Simulator",
                    "iPod Simulator",
                    "iPad",
                    "iPhone",
                    "iPod"
                ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
            }
            /**
 * Given a number, returns the number of digits that appear after the
 * decimal point.
 * See
 * https://stackoverflow.com/questions/9539513/is-there-a-reliable-way-in-javascript-to-obtain-the-number-of-decimal-places-of
 */ function getNumDecimalPlaces(n) {
                // Pull out the fraction and the exponent.
                var match = /(?:\.(\d+))?(?:[eE]([+\-]?\d+))?$/.exec(String(n));
                // NaN or Infinity or integer.
                // We arbitrarily decide that Infinity is integral.
                if (!match) return 0;
                var fraction = match[1] || ""; // E.g. 1.234e-2 => 234
                var exponent = match[2] || 0; // E.g. 1.234e-2 => -2
                // Count the number of digits in the fraction and subtract the
                // exponent to simulate moving the decimal point left by exponent places.
                // 1.234e+2 has 1 fraction digit and '234'.length -  2 == 1
                // 1.234e-2 has 5 fraction digit and '234'.length - -2 == 5
                return Math.max(0, (fraction === "0" ? 0 : fraction.length) - Number(exponent));
            }
        /***/ },
        /***/ "./packages/mdc-slider/types.ts": /*!**************************************!*\
  !*** ./packages/mdc-slider/types.ts ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.Thumb = exports.TickMark = void 0;
            /** Tick mark enum, for discrete sliders. */ var TickMark;
            (function(TickMark) {
                TickMark[TickMark["ACTIVE"] = 0] = "ACTIVE";
                TickMark[TickMark["INACTIVE"] = 1] = "INACTIVE";
            })(TickMark = exports.TickMark || (exports.TickMark = {}));
            /**
 * Thumb types: range slider has two thumbs (START, END) whereas single point
 * slider only has one thumb (END).
 */ var Thumb;
            (function(Thumb) {
                // Thumb at start of slider (e.g. in LTR mode, left thumb on range slider).
                Thumb[Thumb["START"] = 1] = "START";
                // Thumb at end of slider (e.g. in LTR mode, right thumb on range slider,
                // or only thumb on single point slider).
                Thumb[Thumb["END"] = 2] = "END";
            })(Thumb = exports.Thumb || (exports.Thumb = {}));
        /***/ },
        /***/ "./packages/mdc-snackbar/component.ts": /*!********************************************!*\
  !*** ./packages/mdc-snackbar/component.ts ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSnackbar = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-snackbar/constants.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-snackbar/foundation.ts");
            var SURFACE_SELECTOR = constants_1.strings.SURFACE_SELECTOR, LABEL_SELECTOR = constants_1.strings.LABEL_SELECTOR, ACTION_SELECTOR = constants_1.strings.ACTION_SELECTOR, DISMISS_SELECTOR = constants_1.strings.DISMISS_SELECTOR, OPENING_EVENT = constants_1.strings.OPENING_EVENT, OPENED_EVENT = constants_1.strings.OPENED_EVENT, CLOSING_EVENT = constants_1.strings.CLOSING_EVENT, CLOSED_EVENT = constants_1.strings.CLOSED_EVENT;
            var MDCSnackbar = /** @class */ function(_super) {
                __extends(MDCSnackbar, _super);
                function MDCSnackbar() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCSnackbar.attachTo = function(root) {
                    return new MDCSnackbar(root);
                };
                MDCSnackbar.prototype.initialize = function() {};
                MDCSnackbar.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.surfaceEl_ = this.root.querySelector(SURFACE_SELECTOR);
                    this.labelEl_ = this.root.querySelector(LABEL_SELECTOR);
                    this.actionEl_ = this.root.querySelector(ACTION_SELECTOR);
                    this.handleKeyDown_ = function(evt) {
                        return _this.foundation.handleKeyDown(evt);
                    };
                    this.handleSurfaceClick_ = function(evt) {
                        var target = evt.target;
                        if (_this.isActionButton_(target)) _this.foundation.handleActionButtonClick(evt);
                        else if (_this.isActionIcon_(target)) _this.foundation.handleActionIconClick(evt);
                    };
                    this.registerKeyDownHandler_(this.handleKeyDown_);
                    this.registerSurfaceClickHandler_(this.handleSurfaceClick_);
                };
                MDCSnackbar.prototype.destroy = function() {
                    _super.prototype.destroy.call(this);
                    this.deregisterKeyDownHandler_(this.handleKeyDown_);
                    this.deregisterSurfaceClickHandler_(this.handleSurfaceClick_);
                };
                MDCSnackbar.prototype.open = function() {
                    this.foundation.open();
                };
                /**
     * @param reason Why the snackbar was closed. Value will be passed to CLOSING_EVENT and CLOSED_EVENT via the
     *     `event.detail.reason` property. Standard values are REASON_ACTION and REASON_DISMISS, but custom
     *     client-specific values may also be used if desired.
     */ MDCSnackbar.prototype.close = function(reason) {
                    if (reason === void 0) reason = "";
                    this.foundation.close(reason);
                };
                MDCSnackbar.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        announce: function announce() {},
                        notifyClosed: function notifyClosed(reason) {
                            return _this.emit(CLOSED_EVENT, reason ? {
                                reason: reason
                            } : {});
                        },
                        notifyClosing: function notifyClosing(reason) {
                            return _this.emit(CLOSING_EVENT, reason ? {
                                reason: reason
                            } : {});
                        },
                        notifyOpened: function notifyOpened() {
                            return _this.emit(OPENED_EVENT, {});
                        },
                        notifyOpening: function notifyOpening() {
                            return _this.emit(OPENING_EVENT, {});
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        }
                    };
                    return new foundation_1.MDCSnackbarFoundation(adapter);
                };
                Object.defineProperty(MDCSnackbar.prototype, "timeoutMs", {
                    get: function get() {
                        return this.foundation.getTimeoutMs();
                    },
                    set: function set(timeoutMs) {
                        this.foundation.setTimeoutMs(timeoutMs);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSnackbar.prototype, "closeOnEscape", {
                    get: function get() {
                        return this.foundation.getCloseOnEscape();
                    },
                    set: function set(closeOnEscape) {
                        this.foundation.setCloseOnEscape(closeOnEscape);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSnackbar.prototype, "isOpen", {
                    get: function get() {
                        return this.foundation.isOpen();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSnackbar.prototype, "labelText", {
                    get: function get() {
                        // This property only returns null if the node is a document, DOCTYPE, or notation.
                        // On Element nodes, it always returns a string.
                        return this.labelEl_.textContent;
                    },
                    set: function set(labelText) {
                        this.labelEl_.textContent = labelText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSnackbar.prototype, "actionButtonText", {
                    get: function get() {
                        return this.actionEl_.textContent;
                    },
                    set: function set(actionButtonText) {
                        this.actionEl_.textContent = actionButtonText;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSnackbar.prototype.registerKeyDownHandler_ = function(handler) {
                    this.listen("keydown", handler);
                };
                MDCSnackbar.prototype.deregisterKeyDownHandler_ = function(handler) {
                    this.unlisten("keydown", handler);
                };
                MDCSnackbar.prototype.registerSurfaceClickHandler_ = function(handler) {
                    this.surfaceEl_.addEventListener("click", handler);
                };
                MDCSnackbar.prototype.deregisterSurfaceClickHandler_ = function(handler) {
                    this.surfaceEl_.removeEventListener("click", handler);
                };
                MDCSnackbar.prototype.isActionButton_ = function(target) {
                    return Boolean(ponyfill_1.closest(target, ACTION_SELECTOR));
                };
                MDCSnackbar.prototype.isActionIcon_ = function(target) {
                    return Boolean(ponyfill_1.closest(target, DISMISS_SELECTOR));
                };
                return MDCSnackbar;
            }(component_1.MDCComponent);
            exports.MDCSnackbar = MDCSnackbar;
        /***/ },
        /***/ "./packages/mdc-snackbar/constants.ts": /*!********************************************!*\
  !*** ./packages/mdc-snackbar/constants.ts ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.numbers = exports.strings = exports.cssClasses = void 0;
            var cssClasses = {
                CLOSING: "mdc-snackbar--closing",
                OPEN: "mdc-snackbar--open",
                OPENING: "mdc-snackbar--opening"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                ACTION_SELECTOR: ".mdc-snackbar__action",
                ARIA_LIVE_LABEL_TEXT_ATTR: "data-mdc-snackbar-label-text",
                CLOSED_EVENT: "MDCSnackbar:closed",
                CLOSING_EVENT: "MDCSnackbar:closing",
                DISMISS_SELECTOR: ".mdc-snackbar__dismiss",
                LABEL_SELECTOR: ".mdc-snackbar__label",
                OPENED_EVENT: "MDCSnackbar:opened",
                OPENING_EVENT: "MDCSnackbar:opening",
                REASON_ACTION: "action",
                REASON_DISMISS: "dismiss",
                SURFACE_SELECTOR: ".mdc-snackbar__surface"
            };
            exports.strings = strings;
            var numbers = {
                DEFAULT_AUTO_DISMISS_TIMEOUT_MS: 5000,
                INDETERMINATE: -1,
                MAX_AUTO_DISMISS_TIMEOUT_MS: 10000,
                MIN_AUTO_DISMISS_TIMEOUT_MS: 4000,
                // These variables need to be kept in sync with the values in _variables.scss.
                SNACKBAR_ANIMATION_CLOSE_TIME_MS: 75,
                SNACKBAR_ANIMATION_OPEN_TIME_MS: 150,
                /**
     * Number of milliseconds to wait between temporarily clearing the label text
     * in the DOM and subsequently restoring it. This is necessary to force IE 11
     * to pick up the `aria-live` content change and announce it to the user.
     */ ARIA_LIVE_DELAY_MS: 1000
            };
            exports.numbers = numbers;
        /***/ },
        /***/ "./packages/mdc-snackbar/custom-element.js": /*!*************************************************!*\
  !*** ./packages/mdc-snackbar/custom-element.js ***!
  \*************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-snackbar/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcSnackbar = function(_HTMLElement) {
                _inherits(MdcSnackbar, _HTMLElement);
                _createClass(MdcSnackbar, [
                    {
                        key: "closeOnEscape",
                        get: function get() {
                            return this.closeOnEscape_;
                        },
                        set: function set(closeOnEscape) {
                            this.closeOnEscape_ = closeOnEscape;
                            if (!!this.snackbar_) this.snackbar_.closeOnEscape = closeOnEscape;
                        }
                    },
                    {
                        key: "timeoutMs",
                        get: function get() {
                            return this.timeoutMs_;
                        },
                        set: function set(timeoutMs) {
                            this.timeoutMs_ = timeoutMs;
                            if (!!this.snackbar_) this.snackbar_.timeoutMs = timeoutMs;
                        }
                    },
                    {
                        key: "messageId",
                        get: function get() {
                            return this.messageId_;
                        },
                        set: function set(messageId) {
                            this.messageId_ = messageId;
                            if (!!this.snackbar_ && messageId !== -1) this.snackbar_.open();
                        }
                    }
                ]);
                function MdcSnackbar() {
                    _classCallCheck(this, MdcSnackbar);
                    var _this = _possibleConstructorReturn(this, (MdcSnackbar.__proto__ || Object.getPrototypeOf(MdcSnackbar)).call(this));
                    _this.closeOnEscape_ = false;
                    _this.timeoutMs_ = 5000;
                    _this.messageId_ = -1;
                    _this.snackbar_;
                    return _this;
                }
                _createClass(MdcSnackbar, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.snackbar_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCSnackbar"](this);
                            this.snackbar_.closeOnEscape = this.closeOnEscape_;
                            this.snackbar_.timeoutMs = this.timeoutMs_;
                            if (this.messageId_ !== -1) this.snackbar_.open();
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.snackbar_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcSnackbar;
            }(HTMLElement);
            customElements.define("mdc-snackbar", MdcSnackbar);
        /***/ },
        /***/ "./packages/mdc-snackbar/foundation.ts": /*!*********************************************!*\
  !*** ./packages/mdc-snackbar/foundation.ts ***!
  \*********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSnackbarFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-snackbar/constants.ts");
            var OPENING = constants_1.cssClasses.OPENING, OPEN = constants_1.cssClasses.OPEN, CLOSING = constants_1.cssClasses.CLOSING;
            var REASON_ACTION = constants_1.strings.REASON_ACTION, REASON_DISMISS = constants_1.strings.REASON_DISMISS;
            var MDCSnackbarFoundation = /** @class */ function(_super) {
                __extends(MDCSnackbarFoundation, _super);
                function MDCSnackbarFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCSnackbarFoundation.defaultAdapter), adapter)) || this;
                    _this.isOpen_ = false;
                    _this.animationFrame_ = 0;
                    _this.animationTimer_ = 0;
                    _this.autoDismissTimer_ = 0;
                    _this.autoDismissTimeoutMs_ = constants_1.numbers.DEFAULT_AUTO_DISMISS_TIMEOUT_MS;
                    _this.closeOnEscape_ = true;
                    return _this;
                }
                Object.defineProperty(MDCSnackbarFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSnackbarFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSnackbarFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSnackbarFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            announce: function announce() {
                                return undefined;
                            },
                            notifyClosed: function notifyClosed() {
                                return undefined;
                            },
                            notifyClosing: function notifyClosing() {
                                return undefined;
                            },
                            notifyOpened: function notifyOpened() {
                                return undefined;
                            },
                            notifyOpening: function notifyOpening() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSnackbarFoundation.prototype.destroy = function() {
                    this.clearAutoDismissTimer_();
                    cancelAnimationFrame(this.animationFrame_);
                    this.animationFrame_ = 0;
                    clearTimeout(this.animationTimer_);
                    this.animationTimer_ = 0;
                    this.adapter.removeClass(OPENING);
                    this.adapter.removeClass(OPEN);
                    this.adapter.removeClass(CLOSING);
                };
                MDCSnackbarFoundation.prototype.open = function() {
                    var _this = this;
                    this.clearAutoDismissTimer_();
                    this.isOpen_ = true;
                    this.adapter.notifyOpening();
                    this.adapter.removeClass(CLOSING);
                    this.adapter.addClass(OPENING);
                    this.adapter.announce();
                    // Wait a frame once display is no longer "none", to establish basis for animation
                    this.runNextAnimationFrame_(function() {
                        _this.adapter.addClass(OPEN);
                        _this.animationTimer_ = setTimeout(function() {
                            var timeoutMs = _this.getTimeoutMs();
                            _this.handleAnimationTimerEnd_();
                            _this.adapter.notifyOpened();
                            if (timeoutMs !== constants_1.numbers.INDETERMINATE) _this.autoDismissTimer_ = setTimeout(function() {
                                _this.close(REASON_DISMISS);
                            }, timeoutMs);
                        }, constants_1.numbers.SNACKBAR_ANIMATION_OPEN_TIME_MS);
                    });
                };
                /**
     * @param reason Why the snackbar was closed. Value will be passed to CLOSING_EVENT and CLOSED_EVENT via the
     *     `event.detail.reason` property. Standard values are REASON_ACTION and REASON_DISMISS, but custom
     *     client-specific values may also be used if desired.
     */ MDCSnackbarFoundation.prototype.close = function(reason) {
                    var _this = this;
                    if (reason === void 0) reason = "";
                    if (!this.isOpen_) // Avoid redundant close calls (and events), e.g. repeated interactions as the snackbar is animating closed
                    return;
                    cancelAnimationFrame(this.animationFrame_);
                    this.animationFrame_ = 0;
                    this.clearAutoDismissTimer_();
                    this.isOpen_ = false;
                    this.adapter.notifyClosing(reason);
                    this.adapter.addClass(constants_1.cssClasses.CLOSING);
                    this.adapter.removeClass(constants_1.cssClasses.OPEN);
                    this.adapter.removeClass(constants_1.cssClasses.OPENING);
                    clearTimeout(this.animationTimer_);
                    this.animationTimer_ = setTimeout(function() {
                        _this.handleAnimationTimerEnd_();
                        _this.adapter.notifyClosed(reason);
                    }, constants_1.numbers.SNACKBAR_ANIMATION_CLOSE_TIME_MS);
                };
                MDCSnackbarFoundation.prototype.isOpen = function() {
                    return this.isOpen_;
                };
                MDCSnackbarFoundation.prototype.getTimeoutMs = function() {
                    return this.autoDismissTimeoutMs_;
                };
                MDCSnackbarFoundation.prototype.setTimeoutMs = function(timeoutMs) {
                    // Use shorter variable names to make the code more readable
                    var minValue = constants_1.numbers.MIN_AUTO_DISMISS_TIMEOUT_MS;
                    var maxValue = constants_1.numbers.MAX_AUTO_DISMISS_TIMEOUT_MS;
                    var indeterminateValue = constants_1.numbers.INDETERMINATE;
                    if (timeoutMs === constants_1.numbers.INDETERMINATE || timeoutMs <= maxValue && timeoutMs >= minValue) this.autoDismissTimeoutMs_ = timeoutMs;
                    else throw new Error("\n        timeoutMs must be an integer in the range " + minValue + "\u2013" + maxValue + "\n        (or " + indeterminateValue + " to disable), but got '" + timeoutMs + "'");
                };
                MDCSnackbarFoundation.prototype.getCloseOnEscape = function() {
                    return this.closeOnEscape_;
                };
                MDCSnackbarFoundation.prototype.setCloseOnEscape = function(closeOnEscape) {
                    this.closeOnEscape_ = closeOnEscape;
                };
                MDCSnackbarFoundation.prototype.handleKeyDown = function(evt) {
                    var isEscapeKey = evt.key === "Escape" || evt.keyCode === 27;
                    if (isEscapeKey && this.getCloseOnEscape()) this.close(REASON_DISMISS);
                };
                MDCSnackbarFoundation.prototype.handleActionButtonClick = function(_evt) {
                    this.close(REASON_ACTION);
                };
                MDCSnackbarFoundation.prototype.handleActionIconClick = function(_evt) {
                    this.close(REASON_DISMISS);
                };
                MDCSnackbarFoundation.prototype.clearAutoDismissTimer_ = function() {
                    clearTimeout(this.autoDismissTimer_);
                    this.autoDismissTimer_ = 0;
                };
                MDCSnackbarFoundation.prototype.handleAnimationTimerEnd_ = function() {
                    this.animationTimer_ = 0;
                    this.adapter.removeClass(constants_1.cssClasses.OPENING);
                    this.adapter.removeClass(constants_1.cssClasses.CLOSING);
                };
                /**
     * Runs the given logic on the next animation frame, using setTimeout to factor in Firefox reflow behavior.
     */ MDCSnackbarFoundation.prototype.runNextAnimationFrame_ = function(callback) {
                    var _this = this;
                    cancelAnimationFrame(this.animationFrame_);
                    this.animationFrame_ = requestAnimationFrame(function() {
                        _this.animationFrame_ = 0;
                        clearTimeout(_this.animationTimer_);
                        _this.animationTimer_ = setTimeout(callback, 0);
                    });
                };
                return MDCSnackbarFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCSnackbarFoundation = MDCSnackbarFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCSnackbarFoundation;
        /***/ },
        /***/ "./packages/mdc-switch/component.ts": /*!******************************************!*\
  !*** ./packages/mdc-switch/component.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSwitch = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var events_1 = __webpack_require__(/*! @material/dom/events */ "./packages/mdc-dom/events.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var component_2 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-switch/foundation.ts");
            var MDCSwitch = /** @class */ function(_super) {
                __extends(MDCSwitch, _super);
                function MDCSwitch() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.ripple_ = _this.createRipple_();
                    return _this;
                }
                MDCSwitch.attachTo = function(root) {
                    return new MDCSwitch(root);
                };
                MDCSwitch.prototype.destroy = function() {
                    _super.prototype.destroy.call(this);
                    this.ripple_.destroy();
                };
                MDCSwitch.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        setNativeControlChecked: function setNativeControlChecked(checked) {
                            return _this.nativeControl_.checked = checked;
                        },
                        setNativeControlDisabled: function setNativeControlDisabled(disabled) {
                            return _this.nativeControl_.disabled = disabled;
                        },
                        setNativeControlAttr: function setNativeControlAttr(attr, value) {
                            return _this.nativeControl_.setAttribute(attr, value);
                        }
                    };
                    return new foundation_2.MDCSwitchFoundation(adapter);
                };
                Object.defineProperty(MDCSwitch.prototype, "ripple", {
                    get: function get() {
                        return this.ripple_;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSwitch.prototype, "checked", {
                    get: function get() {
                        return this.nativeControl_.checked;
                    },
                    set: function set(checked) {
                        this.foundation.setChecked(checked);
                        this.foundation.handleChange({
                            target: this.nativeControl_
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSwitch.prototype, "disabled", {
                    get: function get() {
                        return this.nativeControl_.disabled;
                    },
                    set: function set(disabled) {
                        this.foundation.setDisabled(disabled);
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSwitch.prototype.createRipple_ = function() {
                    var _this = this;
                    var RIPPLE_SURFACE_SELECTOR = foundation_2.MDCSwitchFoundation.strings.RIPPLE_SURFACE_SELECTOR;
                    var rippleSurface = this.root.querySelector(RIPPLE_SURFACE_SELECTOR);
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = __assign(__assign({}, component_2.MDCRipple.createAdapter(this)), {
                        addClass: function addClass(className) {
                            return rippleSurface.classList.add(className);
                        },
                        computeBoundingRect: function computeBoundingRect() {
                            return rippleSurface.getBoundingClientRect();
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            _this.nativeControl_.removeEventListener(evtType, handler, events_1.applyPassive());
                        },
                        isSurfaceActive: function isSurfaceActive() {
                            return ponyfill_1.matches(_this.nativeControl_, ":active");
                        },
                        isUnbounded: function isUnbounded() {
                            return true;
                        },
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            _this.nativeControl_.addEventListener(evtType, handler, events_1.applyPassive());
                        },
                        removeClass: function removeClass(className) {
                            rippleSurface.classList.remove(className);
                        },
                        updateCssVariable: function updateCssVariable(varName, value) {
                            rippleSurface.style.setProperty(varName, value);
                        }
                    });
                    return new component_2.MDCRipple(this.root, new foundation_1.MDCRippleFoundation(adapter));
                };
                Object.defineProperty(MDCSwitch.prototype, "nativeControl_", {
                    get: function get() {
                        var NATIVE_CONTROL_SELECTOR = foundation_2.MDCSwitchFoundation.strings.NATIVE_CONTROL_SELECTOR;
                        return this.root.querySelector(NATIVE_CONTROL_SELECTOR);
                    },
                    enumerable: false,
                    configurable: true
                });
                return MDCSwitch;
            }(component_1.MDCComponent);
            exports.MDCSwitch = MDCSwitch;
        /***/ },
        /***/ "./packages/mdc-switch/constants.ts": /*!******************************************!*\
  !*** ./packages/mdc-switch/constants.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.cssClasses = void 0;
            /** CSS classes used by the switch. */ var cssClasses = {
                /** Class used for a switch that is in the "checked" (on) position. */ CHECKED: "mdc-switch--checked",
                /** Class used for a switch that is disabled. */ DISABLED: "mdc-switch--disabled"
            };
            exports.cssClasses = cssClasses;
            /** String constants used by the switch. */ var strings = {
                /** Aria attribute for checked or unchecked state of switch */ ARIA_CHECKED_ATTR: "aria-checked",
                /** A CSS selector used to locate the native HTML control for the switch.  */ NATIVE_CONTROL_SELECTOR: ".mdc-switch__native-control",
                /** A CSS selector used to locate the ripple surface element for the switch. */ RIPPLE_SURFACE_SELECTOR: ".mdc-switch__thumb-underlay"
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-switch/custom-element.js": /*!***********************************************!*\
  !*** ./packages/mdc-switch/custom-element.js ***!
  \***********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-switch/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcSwitch = function(_HTMLElement) {
                _inherits(MdcSwitch, _HTMLElement);
                _createClass(MdcSwitch, [
                    {
                        key: "focus",
                        value: function focus() {
                            this.switch_.nativeControl_.focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            this.switch_.nativeControl_.blur();
                        }
                    },
                    {
                        key: "checked",
                        get: function get() {
                            return this.checked_;
                        },
                        set: function set(checked) {
                            this.checked_ = checked;
                            if (!!this.switch_) this.switch_.checked = checked;
                        }
                    },
                    {
                        key: "disabled",
                        get: function get() {
                            return this.disabled_;
                        },
                        set: function set(disabled) {
                            this.disabled_ = disabled;
                            if (!!this.switch_) this.switch_.disabled = disabled;
                        }
                    }
                ]);
                function MdcSwitch() {
                    _classCallCheck(this, MdcSwitch);
                    var _this = _possibleConstructorReturn(this, (MdcSwitch.__proto__ || Object.getPrototypeOf(MdcSwitch)).call(this));
                    _this.checked_ = false;
                    _this.disabled_ = false;
                    _this.switch_;
                    return _this;
                }
                _createClass(MdcSwitch, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.switch_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCSwitch"](this);
                            this.switch_.checked = this.checked_;
                            this.switch_.disabled = this.disabled_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.switch_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcSwitch;
            }(HTMLElement);
            customElements.define("mdc-switch", MdcSwitch);
        /***/ },
        /***/ "./packages/mdc-switch/foundation.ts": /*!*******************************************!*\
  !*** ./packages/mdc-switch/foundation.ts ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSwitchFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-switch/constants.ts");
            var MDCSwitchFoundation = /** @class */ function(_super) {
                __extends(MDCSwitchFoundation, _super);
                function MDCSwitchFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCSwitchFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCSwitchFoundation, "strings", {
                    /** The string constants used by the switch. */ get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSwitchFoundation, "cssClasses", {
                    /** The CSS classes used by the switch. */ get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSwitchFoundation, "defaultAdapter", {
                    /** The default Adapter for the switch. */ get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            setNativeControlChecked: function setNativeControlChecked() {
                                return undefined;
                            },
                            setNativeControlDisabled: function setNativeControlDisabled() {
                                return undefined;
                            },
                            setNativeControlAttr: function setNativeControlAttr() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                /** Sets the checked state of the switch. */ MDCSwitchFoundation.prototype.setChecked = function(checked) {
                    this.adapter.setNativeControlChecked(checked);
                    this.updateAriaChecked_(checked);
                    this.updateCheckedStyling_(checked);
                };
                /** Sets the disabled state of the switch. */ MDCSwitchFoundation.prototype.setDisabled = function(disabled) {
                    this.adapter.setNativeControlDisabled(disabled);
                    if (disabled) this.adapter.addClass(constants_1.cssClasses.DISABLED);
                    else this.adapter.removeClass(constants_1.cssClasses.DISABLED);
                };
                /** Handles the change event for the switch native control. */ MDCSwitchFoundation.prototype.handleChange = function(evt) {
                    var nativeControl = evt.target;
                    this.updateAriaChecked_(nativeControl.checked);
                    this.updateCheckedStyling_(nativeControl.checked);
                };
                /** Updates the styling of the switch based on its checked state. */ MDCSwitchFoundation.prototype.updateCheckedStyling_ = function(checked) {
                    if (checked) this.adapter.addClass(constants_1.cssClasses.CHECKED);
                    else this.adapter.removeClass(constants_1.cssClasses.CHECKED);
                };
                MDCSwitchFoundation.prototype.updateAriaChecked_ = function(checked) {
                    this.adapter.setNativeControlAttr(constants_1.strings.ARIA_CHECKED_ATTR, "" + !!checked);
                };
                return MDCSwitchFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCSwitchFoundation = MDCSwitchFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCSwitchFoundation;
        /***/ },
        /***/ "./packages/mdc-tab-bar/component.ts": /*!*******************************************!*\
  !*** ./packages/mdc-tab-bar/component.ts ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabBar = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var component_2 = __webpack_require__(/*! @material/tab-scroller/component */ "./packages/mdc-tab-scroller/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/tab/foundation */ "./packages/mdc-tab/foundation.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-tab-bar/foundation.ts");
            var strings = foundation_2.MDCTabBarFoundation.strings;
            var MDCTabBar = /** @class */ function(_super) {
                __extends(MDCTabBar, _super);
                function MDCTabBar() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTabBar.attachTo = function(root) {
                    return new MDCTabBar(root);
                };
                Object.defineProperty(MDCTabBar.prototype, "focusOnActivate", {
                    set: function set(focusOnActivate) {
                        this.tabList_.forEach(function(tab) {
                            return tab.focusOnActivate = focusOnActivate;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabBar.prototype, "useAutomaticActivation", {
                    set: function set(useAutomaticActivation) {
                        this.foundation.setUseAutomaticActivation(useAutomaticActivation);
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTabBar.prototype.initialize = function(tabScrollerFactory) {
                    if (tabScrollerFactory === void 0) tabScrollerFactory = function tabScrollerFactory(el) {
                        return new component_2.MDCTabScroller(el);
                    };
                    this.tabScroller_ = this.instantiateTabScroller_(tabScrollerFactory);
                };
                MDCTabBar.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.handleTabInteraction_ = function(evt) {
                        return _this.foundation.handleTabInteraction(evt);
                    };
                    this.handleKeyDown_ = function(evt) {
                        return _this.foundation.handleKeyDown(evt);
                    };
                    this.listen(foundation_1.MDCTabFoundation.strings.INTERACTED_EVENT, this.handleTabInteraction_);
                    this.listen("keydown", this.handleKeyDown_);
                    for(var i = 0; i < this.tabList_.length; i++)if (this.tabList_[i].active) {
                        this.scrollIntoView(i);
                        break;
                    }
                };
                MDCTabBar.prototype.destroy = function() {
                    _super.prototype.destroy.call(this);
                    this.unlisten(foundation_1.MDCTabFoundation.strings.INTERACTED_EVENT, this.handleTabInteraction_);
                    this.unlisten("keydown", this.handleKeyDown_);
                    if (this.tabScroller_) this.tabScroller_.destroy();
                };
                MDCTabBar.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        scrollTo: function scrollTo(scrollX) {
                            return _this.tabScroller_.scrollTo(scrollX);
                        },
                        incrementScroll: function incrementScroll(scrollXIncrement) {
                            return _this.tabScroller_.incrementScroll(scrollXIncrement);
                        },
                        getScrollPosition: function getScrollPosition() {
                            return _this.tabScroller_.getScrollPosition();
                        },
                        getScrollContentWidth: function getScrollContentWidth() {
                            return _this.tabScroller_.getScrollContentWidth();
                        },
                        getOffsetWidth: function getOffsetWidth() {
                            return _this.root.offsetWidth;
                        },
                        isRTL: function isRTL() {
                            return window.getComputedStyle(_this.root).getPropertyValue("direction") === "rtl";
                        },
                        setActiveTab: function setActiveTab() {},
                        activateTabAtIndex: function activateTabAtIndex(index, clientRect) {
                            return _this.tabList_[index].activate(clientRect);
                        },
                        deactivateTabAtIndex: function deactivateTabAtIndex(index) {
                            return _this.tabList_[index].deactivate();
                        },
                        focusTabAtIndex: function focusTabAtIndex(index) {
                            return _this.tabList_[index].focus();
                        },
                        getTabIndicatorClientRectAtIndex: function getTabIndicatorClientRectAtIndex(index) {
                            return _this.tabList_[index].computeIndicatorClientRect();
                        },
                        getTabDimensionsAtIndex: function getTabDimensionsAtIndex(index) {
                            return _this.tabList_[index].computeDimensions();
                        },
                        getPreviousActiveTabIndex: function getPreviousActiveTabIndex() {
                            for(var i = 0; i < _this.tabList_.length; i++){
                                if (_this.tabList_[i].active) return i;
                            }
                            return -1;
                        },
                        getFocusedTabIndex: function getFocusedTabIndex() {
                            var tabElements = _this.getTabElements_();
                            var activeElement = document.activeElement;
                            return tabElements.indexOf(activeElement);
                        },
                        getIndexOfTabById: function getIndexOfTabById(id) {
                            for(var i = 0; i < _this.tabList_.length; i++){
                                if (_this.tabList_[i].id === id) return i;
                            }
                            return -1;
                        },
                        getTabListLength: function getTabListLength() {
                            return _this.tabList_.length;
                        },
                        notifyTabActivated: function notifyTabActivated(index) {
                            return _this.emit(strings.TAB_ACTIVATED_EVENT, {
                                index: index
                            }, true);
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_2.MDCTabBarFoundation(adapter);
                };
                /**
     * Activates the tab at the given index
     * @param index The index of the tab
     */ MDCTabBar.prototype.activateTab = function(index) {
                    this.foundation.activateTab(index);
                };
                /**
     * Scrolls the tab at the given index into view
     * @param index THe index of the tab
     */ MDCTabBar.prototype.scrollIntoView = function(index) {
                    this.foundation.scrollIntoView(index);
                };
                /**
     * Returns all the tab elements in a nice clean array
     */ MDCTabBar.prototype.getTabElements_ = function() {
                    return [].slice.call(this.root.querySelectorAll(strings.TAB_SELECTOR));
                };
                Object.defineProperty(MDCTabBar.prototype, "tabList_", {
                    get: function get() {
                        return this.getTabElements_().map(function(el) {
                            el.init();
                            return el.tab_;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Instantiates tab scroller component on the child tab scroller element
     */ MDCTabBar.prototype.instantiateTabScroller_ = function(tabScrollerFactory) {
                    var tabScrollerElement = this.root.querySelector(strings.TAB_SCROLLER_SELECTOR);
                    if (tabScrollerElement) return tabScrollerFactory(tabScrollerElement);
                    return null;
                };
                return MDCTabBar;
            }(component_1.MDCComponent);
            exports.MDCTabBar = MDCTabBar;
        /***/ },
        /***/ "./packages/mdc-tab-bar/constants.ts": /*!*******************************************!*\
  !*** ./packages/mdc-tab-bar/constants.ts ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.numbers = void 0;
            var strings = {
                ARROW_LEFT_KEY: "ArrowLeft",
                ARROW_RIGHT_KEY: "ArrowRight",
                END_KEY: "End",
                ENTER_KEY: "Enter",
                HOME_KEY: "Home",
                SPACE_KEY: "Space",
                TAB_ACTIVATED_EVENT: "MDCTabBar:activated",
                TAB_SCROLLER_SELECTOR: ".mdc-tab-scroller",
                TAB_SELECTOR: ".mdc-tab"
            };
            exports.strings = strings;
            var numbers = {
                ARROW_LEFT_KEYCODE: 37,
                ARROW_RIGHT_KEYCODE: 39,
                END_KEYCODE: 35,
                ENTER_KEYCODE: 13,
                EXTRA_SCROLL_AMOUNT: 20,
                HOME_KEYCODE: 36,
                SPACE_KEYCODE: 32
            };
            exports.numbers = numbers;
        /***/ },
        /***/ "./packages/mdc-tab-bar/custom-element.js": /*!************************************************!*\
  !*** ./packages/mdc-tab-bar/custom-element.js ***!
  \************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-tab-bar/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcTabBar = function(_HTMLElement) {
                _inherits(MdcTabBar, _HTMLElement);
                _createClass(MdcTabBar, [
                    {
                        key: "focus",
                        value: function focus() {
                            for(var i = 0; i < this.tabBar_.tabList_.length; i++)if (this.tabBar_.tabList_[i].active) {
                                this.tabBar_.tabList_[i].focus();
                                return;
                            }
                            if (this.tabBar_.tabList[0].length > 0) this.tabBar_.tabList_[0].focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            if (this.contains(document.activeElement)) document.activeElement.blur();
                        }
                    },
                    {
                        key: "focusOnActivate",
                        get: function get() {
                            return this.focusOnActivate_;
                        },
                        set: function set(focusOnActivate) {
                            this.focusOnActivate_ = focusOnActivate;
                            if (!!this.tabBar_) this.tabBar_.focusOnActivate = focusOnActivate;
                        }
                    },
                    {
                        key: "useAutomaticActivation",
                        get: function get() {
                            return this.useAutomaticActivation_;
                        },
                        set: function set(useAutomaticActivation) {
                            this.useAutomaticActivation_ = useAutomaticActivation;
                            if (!!this.tabBar_) this.tabBar_.useAutomaticActivation = useAutomaticActivation;
                        }
                    },
                    {
                        key: "activeTabIndex",
                        get: function get() {
                            return this.activeTabIndex_;
                        },
                        set: function set(activeTabIndex) {
                            this.activeTabIndex_ = activeTabIndex;
                            if (!!this.tabBar_) this.tabBar_.activateTab(activeTabIndex);
                        }
                    }
                ]);
                function MdcTabBar() {
                    _classCallCheck(this, MdcTabBar);
                    var _this = _possibleConstructorReturn(this, (MdcTabBar.__proto__ || Object.getPrototypeOf(MdcTabBar)).call(this));
                    _this.activeTabIndex_ = -1;
                    _this.focusOnActivate_ = false;
                    _this.useAutomaticActivation_ = false;
                    _this.tabBar_;
                    return _this;
                }
                _createClass(MdcTabBar, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.tabBar_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCTabBar"](this);
                            this.tabBar_.focusOnActivate = this.focusOnActivate_;
                            this.tabBar_.useAutomaticActivation = this.useAutomaticActivation_;
                            if (this.activeTabIndex !== -1) this.tabBar_.tabList_[this.activeTabIndex_].activate();
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.tabBar_.destroy();
                        }
                    }
                ]);
                return MdcTabBar;
            }(HTMLElement);
            customElements.define("mdc-tab-bar", MdcTabBar);
        /***/ },
        /***/ "./packages/mdc-tab-bar/foundation.ts": /*!********************************************!*\
  !*** ./packages/mdc-tab-bar/foundation.ts ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabBarFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-tab-bar/constants.ts");
            var ACCEPTABLE_KEYS = new Set();
            // IE11 has no support for new Set with iterable so we need to initialize this by hand
            ACCEPTABLE_KEYS.add(constants_1.strings.ARROW_LEFT_KEY);
            ACCEPTABLE_KEYS.add(constants_1.strings.ARROW_RIGHT_KEY);
            ACCEPTABLE_KEYS.add(constants_1.strings.END_KEY);
            ACCEPTABLE_KEYS.add(constants_1.strings.HOME_KEY);
            ACCEPTABLE_KEYS.add(constants_1.strings.ENTER_KEY);
            ACCEPTABLE_KEYS.add(constants_1.strings.SPACE_KEY);
            var KEYCODE_MAP = new Map();
            // IE11 has no support for new Map with iterable so we need to initialize this by hand
            KEYCODE_MAP.set(constants_1.numbers.ARROW_LEFT_KEYCODE, constants_1.strings.ARROW_LEFT_KEY);
            KEYCODE_MAP.set(constants_1.numbers.ARROW_RIGHT_KEYCODE, constants_1.strings.ARROW_RIGHT_KEY);
            KEYCODE_MAP.set(constants_1.numbers.END_KEYCODE, constants_1.strings.END_KEY);
            KEYCODE_MAP.set(constants_1.numbers.HOME_KEYCODE, constants_1.strings.HOME_KEY);
            KEYCODE_MAP.set(constants_1.numbers.ENTER_KEYCODE, constants_1.strings.ENTER_KEY);
            KEYCODE_MAP.set(constants_1.numbers.SPACE_KEYCODE, constants_1.strings.SPACE_KEY);
            var MDCTabBarFoundation = /** @class */ function(_super) {
                __extends(MDCTabBarFoundation, _super);
                function MDCTabBarFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCTabBarFoundation.defaultAdapter), adapter)) || this;
                    _this.useAutomaticActivation_ = false;
                    return _this;
                }
                Object.defineProperty(MDCTabBarFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabBarFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabBarFoundation, "defaultAdapter", {
                    get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            scrollTo: function scrollTo() {
                                return undefined;
                            },
                            incrementScroll: function incrementScroll() {
                                return undefined;
                            },
                            getScrollPosition: function getScrollPosition() {
                                return 0;
                            },
                            getScrollContentWidth: function getScrollContentWidth() {
                                return 0;
                            },
                            getOffsetWidth: function getOffsetWidth() {
                                return 0;
                            },
                            isRTL: function isRTL() {
                                return false;
                            },
                            setActiveTab: function setActiveTab() {
                                return undefined;
                            },
                            activateTabAtIndex: function activateTabAtIndex() {
                                return undefined;
                            },
                            deactivateTabAtIndex: function deactivateTabAtIndex() {
                                return undefined;
                            },
                            focusTabAtIndex: function focusTabAtIndex() {
                                return undefined;
                            },
                            getTabIndicatorClientRectAtIndex: function getTabIndicatorClientRectAtIndex() {
                                return {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                    width: 0,
                                    height: 0
                                };
                            },
                            getTabDimensionsAtIndex: function getTabDimensionsAtIndex() {
                                return {
                                    rootLeft: 0,
                                    rootRight: 0,
                                    contentLeft: 0,
                                    contentRight: 0
                                };
                            },
                            getPreviousActiveTabIndex: function getPreviousActiveTabIndex() {
                                return -1;
                            },
                            getFocusedTabIndex: function getFocusedTabIndex() {
                                return -1;
                            },
                            getIndexOfTabById: function getIndexOfTabById() {
                                return -1;
                            },
                            getTabListLength: function getTabListLength() {
                                return 0;
                            },
                            notifyTabActivated: function notifyTabActivated() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Switches between automatic and manual activation modes.
     * See https://www.w3.org/TR/wai-aria-practices/#tabpanel for examples.
     */ MDCTabBarFoundation.prototype.setUseAutomaticActivation = function(useAutomaticActivation) {
                    this.useAutomaticActivation_ = useAutomaticActivation;
                };
                MDCTabBarFoundation.prototype.activateTab = function(index) {
                    var previousActiveIndex = this.adapter.getPreviousActiveTabIndex();
                    if (!this.indexIsInRange_(index) || index === previousActiveIndex) return;
                    var previousClientRect;
                    if (previousActiveIndex !== -1) {
                        this.adapter.deactivateTabAtIndex(previousActiveIndex);
                        previousClientRect = this.adapter.getTabIndicatorClientRectAtIndex(previousActiveIndex);
                    }
                    this.adapter.activateTabAtIndex(index, previousClientRect);
                    this.scrollIntoView(index);
                };
                MDCTabBarFoundation.prototype.handleKeyDown = function(evt) {
                    // Get the key from the event
                    var key = this.getKeyFromEvent_(evt);
                    // Early exit if the event key isn't one of the keyboard navigation keys
                    if (key === undefined) return;
                    // Prevent default behavior for movement keys, but not for activation keys, since :active is used to apply ripple
                    if (!this.isActivationKey_(key)) evt.preventDefault();
                    if (this.useAutomaticActivation_) {
                        if (this.isActivationKey_(key)) return;
                        var index = this.determineTargetFromKey_(this.adapter.getPreviousActiveTabIndex(), key);
                        this.adapter.notifyTabActivated(index);
                        this.scrollIntoView(index);
                    } else {
                        var focusedTabIndex = this.adapter.getFocusedTabIndex();
                        if (this.isActivationKey_(key)) this.adapter.notifyTabActivated(focusedTabIndex);
                        else {
                            var index = this.determineTargetFromKey_(focusedTabIndex, key);
                            this.adapter.focusTabAtIndex(index);
                            this.scrollIntoView(index);
                        }
                    }
                };
                /**
     * Handles the MDCTab:interacted event
     */ MDCTabBarFoundation.prototype.handleTabInteraction = function(evt) {
                    this.adapter.notifyTabActivated(this.adapter.getIndexOfTabById(evt.detail.tabId));
                };
                /**
     * Scrolls the tab at the given index into view
     * @param index The tab index to make visible
     */ MDCTabBarFoundation.prototype.scrollIntoView = function(index) {
                    // Early exit if the index is out of range
                    if (!this.indexIsInRange_(index)) return;
                    // Always scroll to 0 if scrolling to the 0th index
                    if (index === 0) return this.adapter.scrollTo(0);
                    // Always scroll to the max value if scrolling to the Nth index
                    // MDCTabScroller.scrollTo() will never scroll past the max possible value
                    if (index === this.adapter.getTabListLength() - 1) return this.adapter.scrollTo(this.adapter.getScrollContentWidth());
                    if (this.isRTL_()) return this.scrollIntoViewRTL_(index);
                    this.scrollIntoView_(index);
                };
                /**
     * Private method for determining the index of the destination tab based on what key was pressed
     * @param origin The original index from which to determine the destination
     * @param key The name of the key
     */ MDCTabBarFoundation.prototype.determineTargetFromKey_ = function(origin, key) {
                    var isRTL = this.isRTL_();
                    var maxIndex = this.adapter.getTabListLength() - 1;
                    var shouldGoToEnd = key === constants_1.strings.END_KEY;
                    var shouldDecrement = key === constants_1.strings.ARROW_LEFT_KEY && !isRTL || key === constants_1.strings.ARROW_RIGHT_KEY && isRTL;
                    var shouldIncrement = key === constants_1.strings.ARROW_RIGHT_KEY && !isRTL || key === constants_1.strings.ARROW_LEFT_KEY && isRTL;
                    var index = origin;
                    if (shouldGoToEnd) index = maxIndex;
                    else if (shouldDecrement) index -= 1;
                    else if (shouldIncrement) index += 1;
                    else index = 0;
                    if (index < 0) index = maxIndex;
                    else if (index > maxIndex) index = 0;
                    return index;
                };
                /**
     * Calculates the scroll increment that will make the tab at the given index visible
     * @param index The index of the tab
     * @param nextIndex The index of the next tab
     * @param scrollPosition The current scroll position
     * @param barWidth The width of the Tab Bar
     */ MDCTabBarFoundation.prototype.calculateScrollIncrement_ = function(index, nextIndex, scrollPosition, barWidth) {
                    var nextTabDimensions = this.adapter.getTabDimensionsAtIndex(nextIndex);
                    var relativeContentLeft = nextTabDimensions.contentLeft - scrollPosition - barWidth;
                    var relativeContentRight = nextTabDimensions.contentRight - scrollPosition;
                    var leftIncrement = relativeContentRight - constants_1.numbers.EXTRA_SCROLL_AMOUNT;
                    var rightIncrement = relativeContentLeft + constants_1.numbers.EXTRA_SCROLL_AMOUNT;
                    if (nextIndex < index) return Math.min(leftIncrement, 0);
                    return Math.max(rightIncrement, 0);
                };
                /**
     * Calculates the scroll increment that will make the tab at the given index visible in RTL
     * @param index The index of the tab
     * @param nextIndex The index of the next tab
     * @param scrollPosition The current scroll position
     * @param barWidth The width of the Tab Bar
     * @param scrollContentWidth The width of the scroll content
     */ MDCTabBarFoundation.prototype.calculateScrollIncrementRTL_ = function(index, nextIndex, scrollPosition, barWidth, scrollContentWidth) {
                    var nextTabDimensions = this.adapter.getTabDimensionsAtIndex(nextIndex);
                    var relativeContentLeft = scrollContentWidth - nextTabDimensions.contentLeft - scrollPosition;
                    var relativeContentRight = scrollContentWidth - nextTabDimensions.contentRight - scrollPosition - barWidth;
                    var leftIncrement = relativeContentRight + constants_1.numbers.EXTRA_SCROLL_AMOUNT;
                    var rightIncrement = relativeContentLeft - constants_1.numbers.EXTRA_SCROLL_AMOUNT;
                    if (nextIndex > index) return Math.max(leftIncrement, 0);
                    return Math.min(rightIncrement, 0);
                };
                /**
     * Determines the index of the adjacent tab closest to either edge of the Tab Bar
     * @param index The index of the tab
     * @param tabDimensions The dimensions of the tab
     * @param scrollPosition The current scroll position
     * @param barWidth The width of the tab bar
     */ MDCTabBarFoundation.prototype.findAdjacentTabIndexClosestToEdge_ = function(index, tabDimensions, scrollPosition, barWidth) {
                    /**
         * Tabs are laid out in the Tab Scroller like this:
         *
         *    Scroll Position
         *    +---+
         *    |   |   Bar Width
         *    |   +-----------------------------------+
         *    |   |                                   |
         *    |   V                                   V
         *    |   +-----------------------------------+
         *    V   |             Tab Scroller          |
         *    +------------+--------------+-------------------+
         *    |    Tab     |      Tab     |        Tab        |
         *    +------------+--------------+-------------------+
         *        |                                   |
         *        +-----------------------------------+
         *
         * To determine the next adjacent index, we look at the Tab root left and
         * Tab root right, both relative to the scroll position. If the Tab root
         * left is less than 0, then we know it's out of view to the left. If the
         * Tab root right minus the bar width is greater than 0, we know the Tab is
         * out of view to the right. From there, we either increment or decrement
         * the index.
         */ var relativeRootLeft = tabDimensions.rootLeft - scrollPosition;
                    var relativeRootRight = tabDimensions.rootRight - scrollPosition - barWidth;
                    var relativeRootDelta = relativeRootLeft + relativeRootRight;
                    var leftEdgeIsCloser = relativeRootLeft < 0 || relativeRootDelta < 0;
                    var rightEdgeIsCloser = relativeRootRight > 0 || relativeRootDelta > 0;
                    if (leftEdgeIsCloser) return index - 1;
                    if (rightEdgeIsCloser) return index + 1;
                    return -1;
                };
                /**
     * Determines the index of the adjacent tab closest to either edge of the Tab Bar in RTL
     * @param index The index of the tab
     * @param tabDimensions The dimensions of the tab
     * @param scrollPosition The current scroll position
     * @param barWidth The width of the tab bar
     * @param scrollContentWidth The width of the scroller content
     */ MDCTabBarFoundation.prototype.findAdjacentTabIndexClosestToEdgeRTL_ = function(index, tabDimensions, scrollPosition, barWidth, scrollContentWidth) {
                    var rootLeft = scrollContentWidth - tabDimensions.rootLeft - barWidth - scrollPosition;
                    var rootRight = scrollContentWidth - tabDimensions.rootRight - scrollPosition;
                    var rootDelta = rootLeft + rootRight;
                    var leftEdgeIsCloser = rootLeft > 0 || rootDelta > 0;
                    var rightEdgeIsCloser = rootRight < 0 || rootDelta < 0;
                    if (leftEdgeIsCloser) return index + 1;
                    if (rightEdgeIsCloser) return index - 1;
                    return -1;
                };
                /**
     * Returns the key associated with a keydown event
     * @param evt The keydown event
     */ MDCTabBarFoundation.prototype.getKeyFromEvent_ = function(evt) {
                    if (ACCEPTABLE_KEYS.has(evt.key)) return evt.key;
                    return KEYCODE_MAP.get(evt.keyCode);
                };
                MDCTabBarFoundation.prototype.isActivationKey_ = function(key) {
                    return key === constants_1.strings.SPACE_KEY || key === constants_1.strings.ENTER_KEY;
                };
                /**
     * Returns whether a given index is inclusively between the ends
     * @param index The index to test
     */ MDCTabBarFoundation.prototype.indexIsInRange_ = function(index) {
                    return index >= 0 && index < this.adapter.getTabListLength();
                };
                /**
     * Returns the view's RTL property
     */ MDCTabBarFoundation.prototype.isRTL_ = function() {
                    return this.adapter.isRTL();
                };
                /**
     * Scrolls the tab at the given index into view for left-to-right user agents.
     * @param index The index of the tab to scroll into view
     */ MDCTabBarFoundation.prototype.scrollIntoView_ = function(index) {
                    var scrollPosition = this.adapter.getScrollPosition();
                    var barWidth = this.adapter.getOffsetWidth();
                    var tabDimensions = this.adapter.getTabDimensionsAtIndex(index);
                    var nextIndex = this.findAdjacentTabIndexClosestToEdge_(index, tabDimensions, scrollPosition, barWidth);
                    if (!this.indexIsInRange_(nextIndex)) return;
                    var scrollIncrement = this.calculateScrollIncrement_(index, nextIndex, scrollPosition, barWidth);
                    this.adapter.incrementScroll(scrollIncrement);
                };
                /**
     * Scrolls the tab at the given index into view in RTL
     * @param index The tab index to make visible
     */ MDCTabBarFoundation.prototype.scrollIntoViewRTL_ = function(index) {
                    var scrollPosition = this.adapter.getScrollPosition();
                    var barWidth = this.adapter.getOffsetWidth();
                    var tabDimensions = this.adapter.getTabDimensionsAtIndex(index);
                    var scrollWidth = this.adapter.getScrollContentWidth();
                    var nextIndex = this.findAdjacentTabIndexClosestToEdgeRTL_(index, tabDimensions, scrollPosition, barWidth, scrollWidth);
                    if (!this.indexIsInRange_(nextIndex)) return;
                    var scrollIncrement = this.calculateScrollIncrementRTL_(index, nextIndex, scrollPosition, barWidth, scrollWidth);
                    this.adapter.incrementScroll(scrollIncrement);
                };
                return MDCTabBarFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTabBarFoundation = MDCTabBarFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTabBarFoundation;
        /***/ },
        /***/ "./packages/mdc-tab-indicator/component.ts": /*!*************************************************!*\
  !*** ./packages/mdc-tab-indicator/component.ts ***!
  \*************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabIndicator = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var fading_foundation_1 = __webpack_require__(/*! ./fading-foundation */ "./packages/mdc-tab-indicator/fading-foundation.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-tab-indicator/foundation.ts");
            var sliding_foundation_1 = __webpack_require__(/*! ./sliding-foundation */ "./packages/mdc-tab-indicator/sliding-foundation.ts");
            var MDCTabIndicator = /** @class */ function(_super) {
                __extends(MDCTabIndicator, _super);
                function MDCTabIndicator() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTabIndicator.attachTo = function(root) {
                    return new MDCTabIndicator(root);
                };
                MDCTabIndicator.prototype.initialize = function() {
                    this.content_ = this.root.querySelector(foundation_1.MDCTabIndicatorFoundation.strings.CONTENT_SELECTOR);
                };
                MDCTabIndicator.prototype.computeContentClientRect = function() {
                    return this.foundation.computeContentClientRect();
                };
                MDCTabIndicator.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        computeContentClientRect: function computeContentClientRect() {
                            return _this.content_.getBoundingClientRect();
                        },
                        setContentStyleProperty: function setContentStyleProperty(prop, value) {
                            return _this.content_.style.setProperty(prop, value);
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    if (this.root.classList.contains(foundation_1.MDCTabIndicatorFoundation.cssClasses.FADE)) return new fading_foundation_1.MDCFadingTabIndicatorFoundation(adapter);
                    // Default to the sliding indicator
                    return new sliding_foundation_1.MDCSlidingTabIndicatorFoundation(adapter);
                };
                MDCTabIndicator.prototype.activate = function(previousIndicatorClientRect) {
                    this.foundation.activate(previousIndicatorClientRect);
                };
                MDCTabIndicator.prototype.deactivate = function() {
                    this.foundation.deactivate();
                };
                return MDCTabIndicator;
            }(component_1.MDCComponent);
            exports.MDCTabIndicator = MDCTabIndicator;
        /***/ },
        /***/ "./packages/mdc-tab-indicator/constants.ts": /*!*************************************************!*\
  !*** ./packages/mdc-tab-indicator/constants.ts ***!
  \*************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.cssClasses = void 0;
            var cssClasses = {
                ACTIVE: "mdc-tab-indicator--active",
                FADE: "mdc-tab-indicator--fade",
                NO_TRANSITION: "mdc-tab-indicator--no-transition"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                CONTENT_SELECTOR: ".mdc-tab-indicator__content"
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-tab-indicator/fading-foundation.ts": /*!*********************************************************!*\
  !*** ./packages/mdc-tab-indicator/fading-foundation.ts ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCFadingTabIndicatorFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-tab-indicator/foundation.ts");
            /* istanbul ignore next: subclass is not a branch statement */ var MDCFadingTabIndicatorFoundation = /** @class */ function(_super) {
                __extends(MDCFadingTabIndicatorFoundation, _super);
                function MDCFadingTabIndicatorFoundation() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCFadingTabIndicatorFoundation.prototype.activate = function() {
                    this.adapter.addClass(foundation_1.MDCTabIndicatorFoundation.cssClasses.ACTIVE);
                };
                MDCFadingTabIndicatorFoundation.prototype.deactivate = function() {
                    this.adapter.removeClass(foundation_1.MDCTabIndicatorFoundation.cssClasses.ACTIVE);
                };
                return MDCFadingTabIndicatorFoundation;
            }(foundation_1.MDCTabIndicatorFoundation);
            exports.MDCFadingTabIndicatorFoundation = MDCFadingTabIndicatorFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCFadingTabIndicatorFoundation;
        /***/ },
        /***/ "./packages/mdc-tab-indicator/foundation.ts": /*!**************************************************!*\
  !*** ./packages/mdc-tab-indicator/foundation.ts ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabIndicatorFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-tab-indicator/constants.ts");
            var MDCTabIndicatorFoundation = /** @class */ function(_super) {
                __extends(MDCTabIndicatorFoundation, _super);
                function MDCTabIndicatorFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCTabIndicatorFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCTabIndicatorFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabIndicatorFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabIndicatorFoundation, "defaultAdapter", {
                    get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            computeContentClientRect: function computeContentClientRect() {
                                return {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                    width: 0,
                                    height: 0
                                };
                            },
                            setContentStyleProperty: function setContentStyleProperty() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTabIndicatorFoundation.prototype.computeContentClientRect = function() {
                    return this.adapter.computeContentClientRect();
                };
                return MDCTabIndicatorFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTabIndicatorFoundation = MDCTabIndicatorFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTabIndicatorFoundation;
        /***/ },
        /***/ "./packages/mdc-tab-indicator/sliding-foundation.ts": /*!**********************************************************!*\
  !*** ./packages/mdc-tab-indicator/sliding-foundation.ts ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSlidingTabIndicatorFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-tab-indicator/foundation.ts");
            /* istanbul ignore next: subclass is not a branch statement */ var MDCSlidingTabIndicatorFoundation = /** @class */ function(_super) {
                __extends(MDCSlidingTabIndicatorFoundation, _super);
                function MDCSlidingTabIndicatorFoundation() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCSlidingTabIndicatorFoundation.prototype.activate = function(previousIndicatorClientRect) {
                    // Early exit if no indicator is present to handle cases where an indicator
                    // may be activated without a prior indicator state
                    if (!previousIndicatorClientRect) {
                        this.adapter.addClass(foundation_1.MDCTabIndicatorFoundation.cssClasses.ACTIVE);
                        return;
                    }
                    // This animation uses the FLIP approach. You can read more about it at the link below:
                    // https://aerotwist.com/blog/flip-your-animations/
                    // Calculate the dimensions based on the dimensions of the previous indicator
                    var currentClientRect = this.computeContentClientRect();
                    var widthDelta = previousIndicatorClientRect.width / currentClientRect.width;
                    var xPosition = previousIndicatorClientRect.left - currentClientRect.left;
                    this.adapter.addClass(foundation_1.MDCTabIndicatorFoundation.cssClasses.NO_TRANSITION);
                    this.adapter.setContentStyleProperty("transform", "translateX(" + xPosition + "px) scaleX(" + widthDelta + ")");
                    // Force repaint before updating classes and transform to ensure the transform properly takes effect
                    this.computeContentClientRect();
                    this.adapter.removeClass(foundation_1.MDCTabIndicatorFoundation.cssClasses.NO_TRANSITION);
                    this.adapter.addClass(foundation_1.MDCTabIndicatorFoundation.cssClasses.ACTIVE);
                    this.adapter.setContentStyleProperty("transform", "");
                };
                MDCSlidingTabIndicatorFoundation.prototype.deactivate = function() {
                    this.adapter.removeClass(foundation_1.MDCTabIndicatorFoundation.cssClasses.ACTIVE);
                };
                return MDCSlidingTabIndicatorFoundation;
            }(foundation_1.MDCTabIndicatorFoundation);
            exports.MDCSlidingTabIndicatorFoundation = MDCSlidingTabIndicatorFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCSlidingTabIndicatorFoundation;
        /***/ },
        /***/ "./packages/mdc-tab-scroller/component.ts": /*!************************************************!*\
  !*** ./packages/mdc-tab-scroller/component.ts ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                Object.defineProperty(o, k2, {
                    enumerable: true,
                    get: function get() {
                        return m[k];
                    }
                });
            } : function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
            });
            var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                Object.defineProperty(o, "default", {
                    enumerable: true,
                    value: v
                });
            } : function(o, v) {
                o["default"] = v;
            });
            var __importStar = this && this.__importStar || function(mod) {
                if (mod && mod.__esModule) return mod;
                var result = {};
                if (mod != null) {
                    for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                }
                __setModuleDefault(result, mod);
                return result;
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabScroller = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var events_1 = __webpack_require__(/*! @material/dom/events */ "./packages/mdc-dom/events.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-tab-scroller/foundation.ts");
            var util = __importStar(__webpack_require__(/*! ./util */ "./packages/mdc-tab-scroller/util.ts"));
            var MDCTabScroller = /** @class */ function(_super) {
                __extends(MDCTabScroller, _super);
                function MDCTabScroller() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTabScroller.attachTo = function(root) {
                    return new MDCTabScroller(root);
                };
                MDCTabScroller.prototype.initialize = function() {
                    this.area_ = this.root.querySelector(foundation_1.MDCTabScrollerFoundation.strings.AREA_SELECTOR);
                    this.content_ = this.root.querySelector(foundation_1.MDCTabScrollerFoundation.strings.CONTENT_SELECTOR);
                };
                MDCTabScroller.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.handleInteraction_ = function() {
                        return _this.foundation.handleInteraction();
                    };
                    this.handleTransitionEnd_ = function(evt) {
                        return _this.foundation.handleTransitionEnd(evt);
                    };
                    this.area_.addEventListener("wheel", this.handleInteraction_, events_1.applyPassive());
                    this.area_.addEventListener("touchstart", this.handleInteraction_, events_1.applyPassive());
                    this.area_.addEventListener("pointerdown", this.handleInteraction_, events_1.applyPassive());
                    this.area_.addEventListener("mousedown", this.handleInteraction_, events_1.applyPassive());
                    this.area_.addEventListener("keydown", this.handleInteraction_, events_1.applyPassive());
                    this.content_.addEventListener("transitionend", this.handleTransitionEnd_);
                };
                MDCTabScroller.prototype.destroy = function() {
                    _super.prototype.destroy.call(this);
                    this.area_.removeEventListener("wheel", this.handleInteraction_, events_1.applyPassive());
                    this.area_.removeEventListener("touchstart", this.handleInteraction_, events_1.applyPassive());
                    this.area_.removeEventListener("pointerdown", this.handleInteraction_, events_1.applyPassive());
                    this.area_.removeEventListener("mousedown", this.handleInteraction_, events_1.applyPassive());
                    this.area_.removeEventListener("keydown", this.handleInteraction_, events_1.applyPassive());
                    this.content_.removeEventListener("transitionend", this.handleTransitionEnd_);
                };
                MDCTabScroller.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        eventTargetMatchesSelector: function eventTargetMatchesSelector(evtTarget, selector) {
                            return ponyfill_1.matches(evtTarget, selector);
                        },
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        addScrollAreaClass: function addScrollAreaClass(className) {
                            return _this.area_.classList.add(className);
                        },
                        setScrollAreaStyleProperty: function setScrollAreaStyleProperty(prop, value) {
                            return _this.area_.style.setProperty(prop, value);
                        },
                        setScrollContentStyleProperty: function setScrollContentStyleProperty(prop, value) {
                            return _this.content_.style.setProperty(prop, value);
                        },
                        getScrollContentStyleValue: function getScrollContentStyleValue(propName) {
                            return window.getComputedStyle(_this.content_).getPropertyValue(propName);
                        },
                        setScrollAreaScrollLeft: function setScrollAreaScrollLeft(scrollX) {
                            return _this.area_.scrollLeft = scrollX;
                        },
                        getScrollAreaScrollLeft: function getScrollAreaScrollLeft() {
                            return _this.area_.scrollLeft;
                        },
                        getScrollContentOffsetWidth: function getScrollContentOffsetWidth() {
                            return _this.content_.offsetWidth;
                        },
                        getScrollAreaOffsetWidth: function getScrollAreaOffsetWidth() {
                            return _this.area_.offsetWidth;
                        },
                        computeScrollAreaClientRect: function computeScrollAreaClientRect() {
                            return _this.area_.getBoundingClientRect();
                        },
                        computeScrollContentClientRect: function computeScrollContentClientRect() {
                            return _this.content_.getBoundingClientRect();
                        },
                        computeHorizontalScrollbarHeight: function computeHorizontalScrollbarHeight() {
                            return util.computeHorizontalScrollbarHeight(document);
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_1.MDCTabScrollerFoundation(adapter);
                };
                /**
     * Returns the current visual scroll position
     */ MDCTabScroller.prototype.getScrollPosition = function() {
                    return this.foundation.getScrollPosition();
                };
                /**
     * Returns the width of the scroll content
     */ MDCTabScroller.prototype.getScrollContentWidth = function() {
                    return this.content_.offsetWidth;
                };
                /**
     * Increments the scroll value by the given amount
     * @param scrollXIncrement The pixel value by which to increment the scroll value
     */ MDCTabScroller.prototype.incrementScroll = function(scrollXIncrement) {
                    this.foundation.incrementScroll(scrollXIncrement);
                };
                /**
     * Scrolls to the given pixel position
     * @param scrollX The pixel value to scroll to
     */ MDCTabScroller.prototype.scrollTo = function(scrollX) {
                    this.foundation.scrollTo(scrollX);
                };
                return MDCTabScroller;
            }(component_1.MDCComponent);
            exports.MDCTabScroller = MDCTabScroller;
        /***/ },
        /***/ "./packages/mdc-tab-scroller/constants.ts": /*!************************************************!*\
  !*** ./packages/mdc-tab-scroller/constants.ts ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.cssClasses = void 0;
            var cssClasses = {
                ANIMATING: "mdc-tab-scroller--animating",
                SCROLL_AREA_SCROLL: "mdc-tab-scroller__scroll-area--scroll",
                SCROLL_TEST: "mdc-tab-scroller__test"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                AREA_SELECTOR: ".mdc-tab-scroller__scroll-area",
                CONTENT_SELECTOR: ".mdc-tab-scroller__scroll-content"
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-tab-scroller/foundation.ts": /*!*************************************************!*\
  !*** ./packages/mdc-tab-scroller/foundation.ts ***!
  \*************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __read = this && this.__read || function(o, n) {
                var m = typeof Symbol === "function" && o[Symbol.iterator];
                if (!m) return o;
                var i = m.call(o), r, ar = [], e;
                try {
                    while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
                } catch (error) {
                    e = {
                        error: error
                    };
                } finally{
                    try {
                        if (r && !r.done && (m = i["return"])) m.call(i);
                    } finally{
                        if (e) throw e.error;
                    }
                }
                return ar;
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabScrollerFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-tab-scroller/constants.ts");
            var rtl_default_scroller_1 = __webpack_require__(/*! ./rtl-default-scroller */ "./packages/mdc-tab-scroller/rtl-default-scroller.ts");
            var rtl_negative_scroller_1 = __webpack_require__(/*! ./rtl-negative-scroller */ "./packages/mdc-tab-scroller/rtl-negative-scroller.ts");
            var rtl_reverse_scroller_1 = __webpack_require__(/*! ./rtl-reverse-scroller */ "./packages/mdc-tab-scroller/rtl-reverse-scroller.ts");
            var MDCTabScrollerFoundation = /** @class */ function(_super) {
                __extends(MDCTabScrollerFoundation, _super);
                function MDCTabScrollerFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCTabScrollerFoundation.defaultAdapter), adapter)) || this;
                    /**
         * Controls whether we should handle the transitionend and interaction events during the animation.
         */ _this.isAnimating_ = false;
                    return _this;
                }
                Object.defineProperty(MDCTabScrollerFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabScrollerFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabScrollerFoundation, "defaultAdapter", {
                    get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            eventTargetMatchesSelector: function eventTargetMatchesSelector() {
                                return false;
                            },
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            addScrollAreaClass: function addScrollAreaClass() {
                                return undefined;
                            },
                            setScrollAreaStyleProperty: function setScrollAreaStyleProperty() {
                                return undefined;
                            },
                            setScrollContentStyleProperty: function setScrollContentStyleProperty() {
                                return undefined;
                            },
                            getScrollContentStyleValue: function getScrollContentStyleValue() {
                                return "";
                            },
                            setScrollAreaScrollLeft: function setScrollAreaScrollLeft() {
                                return undefined;
                            },
                            getScrollAreaScrollLeft: function getScrollAreaScrollLeft() {
                                return 0;
                            },
                            getScrollContentOffsetWidth: function getScrollContentOffsetWidth() {
                                return 0;
                            },
                            getScrollAreaOffsetWidth: function getScrollAreaOffsetWidth() {
                                return 0;
                            },
                            computeScrollAreaClientRect: function computeScrollAreaClientRect() {
                                return {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                    width: 0,
                                    height: 0
                                };
                            },
                            computeScrollContentClientRect: function computeScrollContentClientRect() {
                                return {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                    width: 0,
                                    height: 0
                                };
                            },
                            computeHorizontalScrollbarHeight: function computeHorizontalScrollbarHeight() {
                                return 0;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTabScrollerFoundation.prototype.init = function() {
                    // Compute horizontal scrollbar height on scroller with overflow initially hidden, then update overflow to scroll
                    // and immediately adjust bottom margin to avoid the scrollbar initially appearing before JS runs.
                    var horizontalScrollbarHeight = this.adapter.computeHorizontalScrollbarHeight();
                    this.adapter.setScrollAreaStyleProperty("margin-bottom", -horizontalScrollbarHeight + "px");
                    this.adapter.addScrollAreaClass(MDCTabScrollerFoundation.cssClasses.SCROLL_AREA_SCROLL);
                };
                /**
     * Computes the current visual scroll position
     */ MDCTabScrollerFoundation.prototype.getScrollPosition = function() {
                    if (this.isRTL_()) return this.computeCurrentScrollPositionRTL_();
                    var currentTranslateX = this.calculateCurrentTranslateX_();
                    var scrollLeft = this.adapter.getScrollAreaScrollLeft();
                    return scrollLeft - currentTranslateX;
                };
                /**
     * Handles interaction events that occur during transition
     */ MDCTabScrollerFoundation.prototype.handleInteraction = function() {
                    // Early exit if we aren't animating
                    if (!this.isAnimating_) return;
                    // Prevent other event listeners from handling this event
                    this.stopScrollAnimation_();
                };
                /**
     * Handles the transitionend event
     */ MDCTabScrollerFoundation.prototype.handleTransitionEnd = function(evt) {
                    // Early exit if we aren't animating or the event was triggered by a different element.
                    var evtTarget = evt.target;
                    if (!this.isAnimating_ || !this.adapter.eventTargetMatchesSelector(evtTarget, MDCTabScrollerFoundation.strings.CONTENT_SELECTOR)) return;
                    this.isAnimating_ = false;
                    this.adapter.removeClass(MDCTabScrollerFoundation.cssClasses.ANIMATING);
                };
                /**
     * Increment the scroll value by the scrollXIncrement using animation.
     * @param scrollXIncrement The value by which to increment the scroll position
     */ MDCTabScrollerFoundation.prototype.incrementScroll = function(scrollXIncrement) {
                    // Early exit for non-operational increment values
                    if (scrollXIncrement === 0) return;
                    this.animate_(this.getIncrementScrollOperation_(scrollXIncrement));
                };
                /**
     * Increment the scroll value by the scrollXIncrement without animation.
     * @param scrollXIncrement The value by which to increment the scroll position
     */ MDCTabScrollerFoundation.prototype.incrementScrollImmediate = function(scrollXIncrement) {
                    // Early exit for non-operational increment values
                    if (scrollXIncrement === 0) return;
                    var operation = this.getIncrementScrollOperation_(scrollXIncrement);
                    if (operation.scrollDelta === 0) return;
                    this.stopScrollAnimation_();
                    this.adapter.setScrollAreaScrollLeft(operation.finalScrollPosition);
                };
                /**
     * Scrolls to the given scrollX value
     */ MDCTabScrollerFoundation.prototype.scrollTo = function(scrollX) {
                    if (this.isRTL_()) return this.scrollToRTL_(scrollX);
                    this.scrollTo_(scrollX);
                };
                /**
     * @return Browser-specific {@link MDCTabScrollerRTL} instance.
     */ MDCTabScrollerFoundation.prototype.getRTLScroller = function() {
                    if (!this.rtlScrollerInstance_) this.rtlScrollerInstance_ = this.rtlScrollerFactory_();
                    return this.rtlScrollerInstance_;
                };
                /**
     * @return translateX value from a CSS matrix transform function string.
     */ MDCTabScrollerFoundation.prototype.calculateCurrentTranslateX_ = function() {
                    var transformValue = this.adapter.getScrollContentStyleValue("transform");
                    // Early exit if no transform is present
                    if (transformValue === "none") return 0;
                    // The transform value comes back as a matrix transformation in the form
                    // of `matrix(a, b, c, d, tx, ty)`. We only care about tx (translateX) so
                    // we're going to grab all the parenthesized values, strip out tx, and
                    // parse it.
                    var match = /\((.+?)\)/.exec(transformValue);
                    if (!match) return 0;
                    var matrixParams = match[1];
                    // tslint:disable-next-line:ban-ts-ignore "Unused vars" should be a linter warning, not a compiler error.
                    // @ts-ignore These unused variables should retain their semantic names for clarity.
                    var _a = __read(matrixParams.split(","), 6), a = _a[0], b = _a[1], c = _a[2], d = _a[3], tx = _a[4], ty = _a[5];
                    return parseFloat(tx); // tslint:disable-line:ban
                };
                /**
     * Calculates a safe scroll value that is > 0 and < the max scroll value
     * @param scrollX The distance to scroll
     */ MDCTabScrollerFoundation.prototype.clampScrollValue_ = function(scrollX) {
                    var edges = this.calculateScrollEdges_();
                    return Math.min(Math.max(edges.left, scrollX), edges.right);
                };
                MDCTabScrollerFoundation.prototype.computeCurrentScrollPositionRTL_ = function() {
                    var translateX = this.calculateCurrentTranslateX_();
                    return this.getRTLScroller().getScrollPositionRTL(translateX);
                };
                MDCTabScrollerFoundation.prototype.calculateScrollEdges_ = function() {
                    var contentWidth = this.adapter.getScrollContentOffsetWidth();
                    var rootWidth = this.adapter.getScrollAreaOffsetWidth();
                    return {
                        left: 0,
                        right: contentWidth - rootWidth
                    };
                };
                /**
     * Internal scroll method
     * @param scrollX The new scroll position
     */ MDCTabScrollerFoundation.prototype.scrollTo_ = function(scrollX) {
                    var currentScrollX = this.getScrollPosition();
                    var safeScrollX = this.clampScrollValue_(scrollX);
                    var scrollDelta = safeScrollX - currentScrollX;
                    this.animate_({
                        finalScrollPosition: safeScrollX,
                        scrollDelta: scrollDelta
                    });
                };
                /**
     * Internal RTL scroll method
     * @param scrollX The new scroll position
     */ MDCTabScrollerFoundation.prototype.scrollToRTL_ = function(scrollX) {
                    var animation = this.getRTLScroller().scrollToRTL(scrollX);
                    this.animate_(animation);
                };
                /**
     * Internal method to compute the increment scroll operation values.
     * @param scrollX The desired scroll position increment
     * @return MDCTabScrollerAnimation with the sanitized values for performing the scroll operation.
     */ MDCTabScrollerFoundation.prototype.getIncrementScrollOperation_ = function(scrollX) {
                    if (this.isRTL_()) return this.getRTLScroller().incrementScrollRTL(scrollX);
                    var currentScrollX = this.getScrollPosition();
                    var targetScrollX = scrollX + currentScrollX;
                    var safeScrollX = this.clampScrollValue_(targetScrollX);
                    var scrollDelta = safeScrollX - currentScrollX;
                    return {
                        finalScrollPosition: safeScrollX,
                        scrollDelta: scrollDelta
                    };
                };
                /**
     * Animates the tab scrolling
     * @param animation The animation to apply
     */ MDCTabScrollerFoundation.prototype.animate_ = function(animation) {
                    var _this = this;
                    // Early exit if translateX is 0, which means there's no animation to perform
                    if (animation.scrollDelta === 0) return;
                    this.stopScrollAnimation_();
                    // This animation uses the FLIP approach.
                    // Read more here: https://aerotwist.com/blog/flip-your-animations/
                    this.adapter.setScrollAreaScrollLeft(animation.finalScrollPosition);
                    this.adapter.setScrollContentStyleProperty("transform", "translateX(" + animation.scrollDelta + "px)");
                    // Force repaint
                    this.adapter.computeScrollAreaClientRect();
                    requestAnimationFrame(function() {
                        _this.adapter.addClass(MDCTabScrollerFoundation.cssClasses.ANIMATING);
                        _this.adapter.setScrollContentStyleProperty("transform", "none");
                    });
                    this.isAnimating_ = true;
                };
                /**
     * Stops scroll animation
     */ MDCTabScrollerFoundation.prototype.stopScrollAnimation_ = function() {
                    this.isAnimating_ = false;
                    var currentScrollPosition = this.getAnimatingScrollPosition_();
                    this.adapter.removeClass(MDCTabScrollerFoundation.cssClasses.ANIMATING);
                    this.adapter.setScrollContentStyleProperty("transform", "translateX(0px)");
                    this.adapter.setScrollAreaScrollLeft(currentScrollPosition);
                };
                /**
     * Gets the current scroll position during animation
     */ MDCTabScrollerFoundation.prototype.getAnimatingScrollPosition_ = function() {
                    var currentTranslateX = this.calculateCurrentTranslateX_();
                    var scrollLeft = this.adapter.getScrollAreaScrollLeft();
                    if (this.isRTL_()) return this.getRTLScroller().getAnimatingScrollPosition(scrollLeft, currentTranslateX);
                    return scrollLeft - currentTranslateX;
                };
                /**
     * Determines the RTL Scroller to use
     */ MDCTabScrollerFoundation.prototype.rtlScrollerFactory_ = function() {
                    // Browsers have three different implementations of scrollLeft in RTL mode,
                    // dependent on the browser. The behavior is based off the max LTR
                    // scrollLeft value and 0.
                    //
                    // * Default scrolling in RTL *
                    //    - Left-most value: 0
                    //    - Right-most value: Max LTR scrollLeft value
                    //
                    // * Negative scrolling in RTL *
                    //    - Left-most value: Negated max LTR scrollLeft value
                    //    - Right-most value: 0
                    //
                    // * Reverse scrolling in RTL *
                    //    - Left-most value: Max LTR scrollLeft value
                    //    - Right-most value: 0
                    //
                    // We use those principles below to determine which RTL scrollLeft
                    // behavior is implemented in the current browser.
                    var initialScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    this.adapter.setScrollAreaScrollLeft(initialScrollLeft - 1);
                    var newScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    // If the newScrollLeft value is negative,then we know that the browser has
                    // implemented negative RTL scrolling, since all other implementations have
                    // only positive values.
                    if (newScrollLeft < 0) {
                        // Undo the scrollLeft test check
                        this.adapter.setScrollAreaScrollLeft(initialScrollLeft);
                        return new rtl_negative_scroller_1.MDCTabScrollerRTLNegative(this.adapter);
                    }
                    var rootClientRect = this.adapter.computeScrollAreaClientRect();
                    var contentClientRect = this.adapter.computeScrollContentClientRect();
                    var rightEdgeDelta = Math.round(contentClientRect.right - rootClientRect.right);
                    // Undo the scrollLeft test check
                    this.adapter.setScrollAreaScrollLeft(initialScrollLeft);
                    // By calculating the clientRect of the root element and the clientRect of
                    // the content element, we can determine how much the scroll value changed
                    // when we performed the scrollLeft subtraction above.
                    if (rightEdgeDelta === newScrollLeft) return new rtl_reverse_scroller_1.MDCTabScrollerRTLReverse(this.adapter);
                    return new rtl_default_scroller_1.MDCTabScrollerRTLDefault(this.adapter);
                };
                MDCTabScrollerFoundation.prototype.isRTL_ = function() {
                    return this.adapter.getScrollContentStyleValue("direction") === "rtl";
                };
                return MDCTabScrollerFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTabScrollerFoundation = MDCTabScrollerFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTabScrollerFoundation;
        /***/ },
        /***/ "./packages/mdc-tab-scroller/rtl-default-scroller.ts": /*!***********************************************************!*\
  !*** ./packages/mdc-tab-scroller/rtl-default-scroller.ts ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabScrollerRTLDefault = void 0;
            var rtl_scroller_1 = __webpack_require__(/*! ./rtl-scroller */ "./packages/mdc-tab-scroller/rtl-scroller.ts");
            var MDCTabScrollerRTLDefault = /** @class */ function(_super) {
                __extends(MDCTabScrollerRTLDefault, _super);
                function MDCTabScrollerRTLDefault() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTabScrollerRTLDefault.prototype.getScrollPositionRTL = function() {
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    var right = this.calculateScrollEdges_().right;
                    // Scroll values on most browsers are ints instead of floats so we round
                    return Math.round(right - currentScrollLeft);
                };
                MDCTabScrollerRTLDefault.prototype.scrollToRTL = function(scrollX) {
                    var edges = this.calculateScrollEdges_();
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    var clampedScrollLeft = this.clampScrollValue_(edges.right - scrollX);
                    return {
                        finalScrollPosition: clampedScrollLeft,
                        scrollDelta: clampedScrollLeft - currentScrollLeft
                    };
                };
                MDCTabScrollerRTLDefault.prototype.incrementScrollRTL = function(scrollX) {
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    var clampedScrollLeft = this.clampScrollValue_(currentScrollLeft - scrollX);
                    return {
                        finalScrollPosition: clampedScrollLeft,
                        scrollDelta: clampedScrollLeft - currentScrollLeft
                    };
                };
                MDCTabScrollerRTLDefault.prototype.getAnimatingScrollPosition = function(scrollX) {
                    return scrollX;
                };
                MDCTabScrollerRTLDefault.prototype.calculateScrollEdges_ = function() {
                    var contentWidth = this.adapter.getScrollContentOffsetWidth();
                    var rootWidth = this.adapter.getScrollAreaOffsetWidth();
                    return {
                        left: 0,
                        right: contentWidth - rootWidth
                    };
                };
                MDCTabScrollerRTLDefault.prototype.clampScrollValue_ = function(scrollX) {
                    var edges = this.calculateScrollEdges_();
                    return Math.min(Math.max(edges.left, scrollX), edges.right);
                };
                return MDCTabScrollerRTLDefault;
            }(rtl_scroller_1.MDCTabScrollerRTL);
            exports.MDCTabScrollerRTLDefault = MDCTabScrollerRTLDefault;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTabScrollerRTLDefault;
        /***/ },
        /***/ "./packages/mdc-tab-scroller/rtl-negative-scroller.ts": /*!************************************************************!*\
  !*** ./packages/mdc-tab-scroller/rtl-negative-scroller.ts ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabScrollerRTLNegative = void 0;
            var rtl_scroller_1 = __webpack_require__(/*! ./rtl-scroller */ "./packages/mdc-tab-scroller/rtl-scroller.ts");
            var MDCTabScrollerRTLNegative = /** @class */ function(_super) {
                __extends(MDCTabScrollerRTLNegative, _super);
                function MDCTabScrollerRTLNegative() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTabScrollerRTLNegative.prototype.getScrollPositionRTL = function(translateX) {
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    return Math.round(translateX - currentScrollLeft);
                };
                MDCTabScrollerRTLNegative.prototype.scrollToRTL = function(scrollX) {
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    var clampedScrollLeft = this.clampScrollValue_(-scrollX);
                    return {
                        finalScrollPosition: clampedScrollLeft,
                        scrollDelta: clampedScrollLeft - currentScrollLeft
                    };
                };
                MDCTabScrollerRTLNegative.prototype.incrementScrollRTL = function(scrollX) {
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    var clampedScrollLeft = this.clampScrollValue_(currentScrollLeft - scrollX);
                    return {
                        finalScrollPosition: clampedScrollLeft,
                        scrollDelta: clampedScrollLeft - currentScrollLeft
                    };
                };
                MDCTabScrollerRTLNegative.prototype.getAnimatingScrollPosition = function(scrollX, translateX) {
                    return scrollX - translateX;
                };
                MDCTabScrollerRTLNegative.prototype.calculateScrollEdges_ = function() {
                    var contentWidth = this.adapter.getScrollContentOffsetWidth();
                    var rootWidth = this.adapter.getScrollAreaOffsetWidth();
                    return {
                        left: rootWidth - contentWidth,
                        right: 0
                    };
                };
                MDCTabScrollerRTLNegative.prototype.clampScrollValue_ = function(scrollX) {
                    var edges = this.calculateScrollEdges_();
                    return Math.max(Math.min(edges.right, scrollX), edges.left);
                };
                return MDCTabScrollerRTLNegative;
            }(rtl_scroller_1.MDCTabScrollerRTL);
            exports.MDCTabScrollerRTLNegative = MDCTabScrollerRTLNegative;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTabScrollerRTLNegative;
        /***/ },
        /***/ "./packages/mdc-tab-scroller/rtl-reverse-scroller.ts": /*!***********************************************************!*\
  !*** ./packages/mdc-tab-scroller/rtl-reverse-scroller.ts ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabScrollerRTLReverse = void 0;
            var rtl_scroller_1 = __webpack_require__(/*! ./rtl-scroller */ "./packages/mdc-tab-scroller/rtl-scroller.ts");
            var MDCTabScrollerRTLReverse = /** @class */ function(_super) {
                __extends(MDCTabScrollerRTLReverse, _super);
                function MDCTabScrollerRTLReverse() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTabScrollerRTLReverse.prototype.getScrollPositionRTL = function(translateX) {
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    // Scroll values on most browsers are ints instead of floats so we round
                    return Math.round(currentScrollLeft - translateX);
                };
                MDCTabScrollerRTLReverse.prototype.scrollToRTL = function(scrollX) {
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    var clampedScrollLeft = this.clampScrollValue_(scrollX);
                    return {
                        finalScrollPosition: clampedScrollLeft,
                        scrollDelta: currentScrollLeft - clampedScrollLeft
                    };
                };
                MDCTabScrollerRTLReverse.prototype.incrementScrollRTL = function(scrollX) {
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    var clampedScrollLeft = this.clampScrollValue_(currentScrollLeft + scrollX);
                    return {
                        finalScrollPosition: clampedScrollLeft,
                        scrollDelta: currentScrollLeft - clampedScrollLeft
                    };
                };
                MDCTabScrollerRTLReverse.prototype.getAnimatingScrollPosition = function(scrollX, translateX) {
                    return scrollX + translateX;
                };
                MDCTabScrollerRTLReverse.prototype.calculateScrollEdges_ = function() {
                    var contentWidth = this.adapter.getScrollContentOffsetWidth();
                    var rootWidth = this.adapter.getScrollAreaOffsetWidth();
                    return {
                        left: contentWidth - rootWidth,
                        right: 0
                    };
                };
                MDCTabScrollerRTLReverse.prototype.clampScrollValue_ = function(scrollX) {
                    var edges = this.calculateScrollEdges_();
                    return Math.min(Math.max(edges.right, scrollX), edges.left);
                };
                return MDCTabScrollerRTLReverse;
            }(rtl_scroller_1.MDCTabScrollerRTL);
            exports.MDCTabScrollerRTLReverse = MDCTabScrollerRTLReverse;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTabScrollerRTLReverse;
        /***/ },
        /***/ "./packages/mdc-tab-scroller/rtl-scroller.ts": /*!***************************************************!*\
  !*** ./packages/mdc-tab-scroller/rtl-scroller.ts ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabScrollerRTL = void 0;
            var MDCTabScrollerRTL = /** @class */ function() {
                function MDCTabScrollerRTL(adapter) {
                    this.adapter = adapter;
                }
                return MDCTabScrollerRTL;
            }();
            exports.MDCTabScrollerRTL = MDCTabScrollerRTL;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTabScrollerRTL;
        /***/ },
        /***/ "./packages/mdc-tab-scroller/util.ts": /*!*******************************************!*\
  !*** ./packages/mdc-tab-scroller/util.ts ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.computeHorizontalScrollbarHeight = void 0;
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-tab-scroller/constants.ts");
            /**
 * Stores result from computeHorizontalScrollbarHeight to avoid redundant processing.
 */ var horizontalScrollbarHeight_;
            /**
 * Computes the height of browser-rendered horizontal scrollbars using a self-created test element.
 * May return 0 (e.g. on OS X browsers under default configuration).
 */ function computeHorizontalScrollbarHeight(documentObj, shouldCacheResult) {
                if (shouldCacheResult === void 0) shouldCacheResult = true;
                if (shouldCacheResult && typeof horizontalScrollbarHeight_ !== "undefined") return horizontalScrollbarHeight_;
                var el = documentObj.createElement("div");
                el.classList.add(constants_1.cssClasses.SCROLL_TEST);
                documentObj.body.appendChild(el);
                var horizontalScrollbarHeight = el.offsetHeight - el.clientHeight;
                documentObj.body.removeChild(el);
                if (shouldCacheResult) horizontalScrollbarHeight_ = horizontalScrollbarHeight;
                return horizontalScrollbarHeight;
            }
            exports.computeHorizontalScrollbarHeight = computeHorizontalScrollbarHeight;
        /***/ },
        /***/ "./packages/mdc-tab/component.ts": /*!***************************************!*\
  !*** ./packages/mdc-tab/component.ts ***!
  \***************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTab = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var component_2 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var component_3 = __webpack_require__(/*! @material/tab-indicator/component */ "./packages/mdc-tab-indicator/component.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-tab/foundation.ts");
            var MDCTab = /** @class */ function(_super) {
                __extends(MDCTab, _super);
                function MDCTab() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTab.attachTo = function(root) {
                    return new MDCTab(root);
                };
                MDCTab.prototype.initialize = function(rippleFactory, tabIndicatorFactory) {
                    if (rippleFactory === void 0) rippleFactory = function rippleFactory(el, foundation) {
                        return new component_2.MDCRipple(el, foundation);
                    };
                    if (tabIndicatorFactory === void 0) tabIndicatorFactory = function tabIndicatorFactory(el) {
                        return new component_3.MDCTabIndicator(el);
                    };
                    this.id = this.root.id;
                    var rippleFoundation = new foundation_1.MDCRippleFoundation(component_2.MDCRipple.createAdapter(this));
                    this.ripple_ = rippleFactory(this.root, rippleFoundation);
                    var tabIndicatorElement = this.root.querySelector(foundation_2.MDCTabFoundation.strings.TAB_INDICATOR_SELECTOR);
                    this.tabIndicator_ = tabIndicatorFactory(tabIndicatorElement);
                    this.content_ = this.root.querySelector(foundation_2.MDCTabFoundation.strings.CONTENT_SELECTOR);
                };
                MDCTab.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.handleClick_ = function() {
                        return _this.foundation.handleClick();
                    };
                    this.listen("click", this.handleClick_);
                };
                MDCTab.prototype.destroy = function() {
                    this.unlisten("click", this.handleClick_);
                    this.ripple_.destroy();
                    _super.prototype.destroy.call(this);
                };
                MDCTab.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        setAttr: function setAttr(attr, value) {
                            return _this.root.setAttribute(attr, value);
                        },
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        activateIndicator: function activateIndicator(previousIndicatorClientRect) {
                            return _this.tabIndicator_.activate(previousIndicatorClientRect);
                        },
                        deactivateIndicator: function deactivateIndicator() {
                            return _this.tabIndicator_.deactivate();
                        },
                        notifyInteracted: function notifyInteracted() {
                            return _this.emit(foundation_2.MDCTabFoundation.strings.INTERACTED_EVENT, {
                                tabId: _this.id
                            }, true);
                        },
                        getOffsetLeft: function getOffsetLeft() {
                            return _this.root.offsetLeft;
                        },
                        getOffsetWidth: function getOffsetWidth() {
                            return _this.root.offsetWidth;
                        },
                        getContentOffsetLeft: function getContentOffsetLeft() {
                            return _this.content_.offsetLeft;
                        },
                        getContentOffsetWidth: function getContentOffsetWidth() {
                            return _this.content_.offsetWidth;
                        },
                        focus: function focus() {
                            return _this.root.focus();
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_2.MDCTabFoundation(adapter);
                };
                Object.defineProperty(MDCTab.prototype, "active", {
                    /**
         * Getter for the active state of the tab
         */ get: function get() {
                        return this.foundation.isActive();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTab.prototype, "focusOnActivate", {
                    set: function set(focusOnActivate) {
                        this.foundation.setFocusOnActivate(focusOnActivate);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Activates the tab
     */ MDCTab.prototype.activate = function(computeIndicatorClientRect) {
                    this.foundation.activate(computeIndicatorClientRect);
                };
                /**
     * Deactivates the tab
     */ MDCTab.prototype.deactivate = function() {
                    this.foundation.deactivate();
                };
                /**
     * Returns the indicator's client rect
     */ MDCTab.prototype.computeIndicatorClientRect = function() {
                    return this.tabIndicator_.computeContentClientRect();
                };
                MDCTab.prototype.computeDimensions = function() {
                    return this.foundation.computeDimensions();
                };
                /**
     * Focuses the tab
     */ MDCTab.prototype.focus = function() {
                    this.root.focus();
                };
                return MDCTab;
            }(component_1.MDCComponent);
            exports.MDCTab = MDCTab;
        /***/ },
        /***/ "./packages/mdc-tab/constants.ts": /*!***************************************!*\
  !*** ./packages/mdc-tab/constants.ts ***!
  \***************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.cssClasses = void 0;
            var cssClasses = {
                ACTIVE: "mdc-tab--active"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                ARIA_SELECTED: "aria-selected",
                CONTENT_SELECTOR: ".mdc-tab__content",
                INTERACTED_EVENT: "MDCTab:interacted",
                RIPPLE_SELECTOR: ".mdc-tab__ripple",
                TABINDEX: "tabIndex",
                TAB_INDICATOR_SELECTOR: ".mdc-tab-indicator"
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-tab/custom-element.js": /*!********************************************!*\
  !*** ./packages/mdc-tab/custom-element.js ***!
  \********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-tab/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var tabIdCounter = 0;
            var MdcTab = function(_HTMLElement) {
                _inherits(MdcTab, _HTMLElement);
                function MdcTab() {
                    _classCallCheck(this, MdcTab);
                    var _this = _possibleConstructorReturn(this, (MdcTab.__proto__ || Object.getPrototypeOf(MdcTab)).call(this));
                    _this.init_ = false;
                    _this.tab_;
                    _this.handleKeydown_ = _this.handleKeydown.bind(_this);
                    return _this;
                }
                _createClass(MdcTab, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.init();
                            this.tabIndex = 0;
                        }
                    },
                    {
                        key: "init",
                        value: function init() {
                            if (this.init_) return;
                            this.init_ = true;
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.id = this.id || "mdc-tab-" + ++tabIdCounter;
                            this.tab_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCTab"](this);
                            this.addEventListener("keydown", this.handleKeydown_);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.removeEventListener("keydown", this.handleKeydown_);
                            this.tab_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    },
                    {
                        key: "handleKeydown",
                        value: function handleKeydown(event) {
                            if (event.key === "Space" || event.keyCode == 32) event.preventDefault();
                        }
                    }
                ]);
                return MdcTab;
            }(HTMLElement);
            customElements.define("mdc-tab", MdcTab);
        /***/ },
        /***/ "./packages/mdc-tab/foundation.ts": /*!****************************************!*\
  !*** ./packages/mdc-tab/foundation.ts ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-tab/constants.ts");
            var MDCTabFoundation = /** @class */ function(_super) {
                __extends(MDCTabFoundation, _super);
                function MDCTabFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCTabFoundation.defaultAdapter), adapter)) || this;
                    _this.focusOnActivate_ = true;
                    return _this;
                }
                Object.defineProperty(MDCTabFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabFoundation, "defaultAdapter", {
                    get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            setAttr: function setAttr() {
                                return undefined;
                            },
                            activateIndicator: function activateIndicator() {
                                return undefined;
                            },
                            deactivateIndicator: function deactivateIndicator() {
                                return undefined;
                            },
                            notifyInteracted: function notifyInteracted() {
                                return undefined;
                            },
                            getOffsetLeft: function getOffsetLeft() {
                                return 0;
                            },
                            getOffsetWidth: function getOffsetWidth() {
                                return 0;
                            },
                            getContentOffsetLeft: function getContentOffsetLeft() {
                                return 0;
                            },
                            getContentOffsetWidth: function getContentOffsetWidth() {
                                return 0;
                            },
                            focus: function focus() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTabFoundation.prototype.handleClick = function() {
                    // It's up to the parent component to keep track of the active Tab and
                    // ensure we don't activate a Tab that's already active.
                    this.adapter.notifyInteracted();
                };
                MDCTabFoundation.prototype.isActive = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.ACTIVE);
                };
                /**
     * Sets whether the tab should focus itself when activated
     */ MDCTabFoundation.prototype.setFocusOnActivate = function(focusOnActivate) {
                    this.focusOnActivate_ = focusOnActivate;
                };
                /**
     * Activates the Tab
     */ MDCTabFoundation.prototype.activate = function(previousIndicatorClientRect) {
                    this.adapter.addClass(constants_1.cssClasses.ACTIVE);
                    this.adapter.setAttr(constants_1.strings.ARIA_SELECTED, "true");
                    this.adapter.setAttr(constants_1.strings.TABINDEX, "0");
                    this.adapter.activateIndicator(previousIndicatorClientRect);
                    if (this.focusOnActivate_) this.adapter.focus();
                };
                /**
     * Deactivates the Tab
     */ MDCTabFoundation.prototype.deactivate = function() {
                    // Early exit
                    if (!this.isActive()) return;
                    this.adapter.removeClass(constants_1.cssClasses.ACTIVE);
                    this.adapter.setAttr(constants_1.strings.ARIA_SELECTED, "false");
                    this.adapter.setAttr(constants_1.strings.TABINDEX, "-1");
                    this.adapter.deactivateIndicator();
                };
                /**
     * Returns the dimensions of the Tab
     */ MDCTabFoundation.prototype.computeDimensions = function() {
                    var rootWidth = this.adapter.getOffsetWidth();
                    var rootLeft = this.adapter.getOffsetLeft();
                    var contentWidth = this.adapter.getContentOffsetWidth();
                    var contentLeft = this.adapter.getContentOffsetLeft();
                    return {
                        contentLeft: rootLeft + contentLeft,
                        contentRight: rootLeft + contentLeft + contentWidth,
                        rootLeft: rootLeft,
                        rootRight: rootLeft + rootWidth
                    };
                };
                return MDCTabFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTabFoundation = MDCTabFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTabFoundation;
        /***/ },
        /***/ "./packages/mdc-textfield/character-counter/component.ts": /*!***************************************************************!*\
  !*** ./packages/mdc-textfield/character-counter/component.ts ***!
  \***************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTextFieldCharacterCounter = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-textfield/character-counter/foundation.ts");
            var MDCTextFieldCharacterCounter = /** @class */ function(_super) {
                __extends(MDCTextFieldCharacterCounter, _super);
                function MDCTextFieldCharacterCounter() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTextFieldCharacterCounter.attachTo = function(root) {
                    return new MDCTextFieldCharacterCounter(root);
                };
                Object.defineProperty(MDCTextFieldCharacterCounter.prototype, "foundationForTextField", {
                    // Provided for access by MDCTextField component
                    get: function get() {
                        return this.foundation;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTextFieldCharacterCounter.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        setContent: function setContent(content) {
                            _this.root.textContent = content;
                        }
                    };
                    return new foundation_1.MDCTextFieldCharacterCounterFoundation(adapter);
                };
                return MDCTextFieldCharacterCounter;
            }(component_1.MDCComponent);
            exports.MDCTextFieldCharacterCounter = MDCTextFieldCharacterCounter;
        /***/ },
        /***/ "./packages/mdc-textfield/character-counter/constants.ts": /*!***************************************************************!*\
  !*** ./packages/mdc-textfield/character-counter/constants.ts ***!
  \***************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.cssClasses = exports.strings = void 0;
            var cssClasses = {
                ROOT: "mdc-text-field-character-counter"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                ROOT_SELECTOR: "." + cssClasses.ROOT
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-textfield/character-counter/foundation.ts": /*!****************************************************************!*\
  !*** ./packages/mdc-textfield/character-counter/foundation.ts ***!
  \****************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTextFieldCharacterCounterFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-textfield/character-counter/constants.ts");
            var MDCTextFieldCharacterCounterFoundation = /** @class */ function(_super) {
                __extends(MDCTextFieldCharacterCounterFoundation, _super);
                function MDCTextFieldCharacterCounterFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCTextFieldCharacterCounterFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCTextFieldCharacterCounterFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldCharacterCounterFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldCharacterCounterFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCTextFieldCharacterCounterAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        return {
                            setContent: function setContent() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTextFieldCharacterCounterFoundation.prototype.setCounterValue = function(currentLength, maxLength) {
                    currentLength = Math.min(currentLength, maxLength);
                    this.adapter.setContent(currentLength + " / " + maxLength);
                };
                return MDCTextFieldCharacterCounterFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTextFieldCharacterCounterFoundation = MDCTextFieldCharacterCounterFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTextFieldCharacterCounterFoundation;
        /***/ },
        /***/ "./packages/mdc-textfield/component.ts": /*!*********************************************!*\
  !*** ./packages/mdc-textfield/component.ts ***!
  \*********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                Object.defineProperty(o, k2, {
                    enumerable: true,
                    get: function get() {
                        return m[k];
                    }
                });
            } : function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
            });
            var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                Object.defineProperty(o, "default", {
                    enumerable: true,
                    value: v
                });
            } : function(o, v) {
                o["default"] = v;
            });
            var __importStar = this && this.__importStar || function(mod) {
                if (mod && mod.__esModule) return mod;
                var result = {};
                if (mod != null) {
                    for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                }
                __setModuleDefault(result, mod);
                return result;
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTextField = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var events_1 = __webpack_require__(/*! @material/dom/events */ "./packages/mdc-dom/events.ts");
            var ponyfill = __importStar(__webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts"));
            var component_2 = __webpack_require__(/*! @material/floating-label/component */ "./packages/mdc-floating-label/component.ts");
            var component_3 = __webpack_require__(/*! @material/line-ripple/component */ "./packages/mdc-line-ripple/component.ts");
            var component_4 = __webpack_require__(/*! @material/notched-outline/component */ "./packages/mdc-notched-outline/component.ts");
            var component_5 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var component_6 = __webpack_require__(/*! ./character-counter/component */ "./packages/mdc-textfield/character-counter/component.ts");
            var foundation_2 = __webpack_require__(/*! ./character-counter/foundation */ "./packages/mdc-textfield/character-counter/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-textfield/constants.ts");
            var foundation_3 = __webpack_require__(/*! ./foundation */ "./packages/mdc-textfield/foundation.ts");
            var component_7 = __webpack_require__(/*! ./helper-text/component */ "./packages/mdc-textfield/helper-text/component.ts");
            var foundation_4 = __webpack_require__(/*! ./helper-text/foundation */ "./packages/mdc-textfield/helper-text/foundation.ts");
            var component_8 = __webpack_require__(/*! ./icon/component */ "./packages/mdc-textfield/icon/component.ts");
            var MDCTextField = /** @class */ function(_super) {
                __extends(MDCTextField, _super);
                function MDCTextField() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTextField.attachTo = function(root) {
                    return new MDCTextField(root);
                };
                MDCTextField.prototype.initialize = function(rippleFactory, lineRippleFactory, helperTextFactory, characterCounterFactory, iconFactory, labelFactory, outlineFactory) {
                    if (rippleFactory === void 0) rippleFactory = function rippleFactory(el, foundation) {
                        return new component_5.MDCRipple(el, foundation);
                    };
                    if (lineRippleFactory === void 0) lineRippleFactory = function lineRippleFactory(el) {
                        return new component_3.MDCLineRipple(el);
                    };
                    if (helperTextFactory === void 0) helperTextFactory = function helperTextFactory(el) {
                        return new component_7.MDCTextFieldHelperText(el);
                    };
                    if (characterCounterFactory === void 0) characterCounterFactory = function characterCounterFactory(el) {
                        return new component_6.MDCTextFieldCharacterCounter(el);
                    };
                    if (iconFactory === void 0) iconFactory = function iconFactory(el) {
                        return new component_8.MDCTextFieldIcon(el);
                    };
                    if (labelFactory === void 0) labelFactory = function labelFactory(el) {
                        return new component_2.MDCFloatingLabel(el);
                    };
                    if (outlineFactory === void 0) outlineFactory = function outlineFactory(el) {
                        return new component_4.MDCNotchedOutline(el);
                    };
                    this.input_ = this.root.querySelector(constants_1.strings.INPUT_SELECTOR);
                    var labelElement = this.root.querySelector(constants_1.strings.LABEL_SELECTOR);
                    this.label_ = labelElement ? labelFactory(labelElement) : null;
                    var lineRippleElement = this.root.querySelector(constants_1.strings.LINE_RIPPLE_SELECTOR);
                    this.lineRipple_ = lineRippleElement ? lineRippleFactory(lineRippleElement) : null;
                    var outlineElement = this.root.querySelector(constants_1.strings.OUTLINE_SELECTOR);
                    this.outline_ = outlineElement ? outlineFactory(outlineElement) : null;
                    // Helper text
                    var helperTextStrings = foundation_4.MDCTextFieldHelperTextFoundation.strings;
                    var nextElementSibling = this.root.nextElementSibling;
                    var hasHelperLine = nextElementSibling && nextElementSibling.classList.contains(constants_1.cssClasses.HELPER_LINE);
                    var helperTextEl = hasHelperLine && nextElementSibling && nextElementSibling.querySelector(helperTextStrings.ROOT_SELECTOR);
                    this.helperText_ = helperTextEl ? helperTextFactory(helperTextEl) : null;
                    // Character counter
                    var characterCounterStrings = foundation_2.MDCTextFieldCharacterCounterFoundation.strings;
                    var characterCounterEl = this.root.querySelector(characterCounterStrings.ROOT_SELECTOR);
                    // If character counter is not found in root element search in sibling element.
                    if (!characterCounterEl && hasHelperLine && nextElementSibling) characterCounterEl = nextElementSibling.querySelector(characterCounterStrings.ROOT_SELECTOR);
                    this.characterCounter_ = characterCounterEl ? characterCounterFactory(characterCounterEl) : null;
                    // Leading icon
                    var leadingIconEl = this.root.querySelector(constants_1.strings.LEADING_ICON_SELECTOR);
                    this.leadingIcon_ = leadingIconEl ? iconFactory(leadingIconEl) : null;
                    // Trailing icon
                    var trailingIconEl = this.root.querySelector(constants_1.strings.TRAILING_ICON_SELECTOR);
                    this.trailingIcon_ = trailingIconEl ? iconFactory(trailingIconEl) : null;
                    // Prefix and Suffix
                    this.prefix_ = this.root.querySelector(constants_1.strings.PREFIX_SELECTOR);
                    this.suffix_ = this.root.querySelector(constants_1.strings.SUFFIX_SELECTOR);
                    this.ripple = this.createRipple_(rippleFactory);
                };
                MDCTextField.prototype.destroy = function() {
                    if (this.ripple) this.ripple.destroy();
                    if (this.lineRipple_) this.lineRipple_.destroy();
                    if (this.helperText_) this.helperText_.destroy();
                    if (this.characterCounter_) this.characterCounter_.destroy();
                    if (this.leadingIcon_) this.leadingIcon_.destroy();
                    if (this.trailingIcon_) this.trailingIcon_.destroy();
                    if (this.label_) this.label_.destroy();
                    if (this.outline_) this.outline_.destroy();
                    _super.prototype.destroy.call(this);
                };
                /**
     * Initializes the Text Field's internal state based on the environment's
     * state.
     */ MDCTextField.prototype.initialSyncWithDOM = function() {
                    this.disabled = this.input_.disabled;
                };
                Object.defineProperty(MDCTextField.prototype, "value", {
                    get: function get() {
                        return this.foundation.getValue();
                    },
                    /**
         * @param value The value to set on the input.
         */ set: function set(value) {
                        this.foundation.setValue(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "disabled", {
                    get: function get() {
                        return this.foundation.isDisabled();
                    },
                    /**
         * @param disabled Sets the Text Field disabled or enabled.
         */ set: function set(disabled) {
                        this.foundation.setDisabled(disabled);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "valid", {
                    get: function get() {
                        return this.foundation.isValid();
                    },
                    /**
         * @param valid Sets the Text Field valid or invalid.
         */ set: function set(valid) {
                        this.foundation.setValid(valid);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "required", {
                    get: function get() {
                        return this.input_.required;
                    },
                    /**
         * @param required Sets the Text Field to required.
         */ set: function set(required) {
                        this.input_.required = required;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "pattern", {
                    get: function get() {
                        return this.input_.pattern;
                    },
                    /**
         * @param pattern Sets the input element's validation pattern.
         */ set: function set(pattern) {
                        if (pattern === null) delete this.input_.pattern;
                        else this.input_.pattern = pattern;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "minLength", {
                    get: function get() {
                        return this.input_.minLength;
                    },
                    /**
         * @param minLength Sets the input element's minLength.
         */ set: function set(minLength) {
                        if (minLength < 0) this.input_.removeAttribute("minLength");
                        else this.input_.minLength = minLength;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "maxLength", {
                    get: function get() {
                        return this.input_.maxLength;
                    },
                    /**
         * @param maxLength Sets the input element's maxLength.
         */ set: function set(maxLength) {
                        if (maxLength < 0) this.input_.removeAttribute("maxLength");
                        else this.input_.maxLength = maxLength;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "min", {
                    get: function get() {
                        return this.input_.min;
                    },
                    /**
         * @param min Sets the input element's min.
         */ set: function set(min) {
                        this.input_.min = min;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "max", {
                    get: function get() {
                        return this.input_.max;
                    },
                    /**
         * @param max Sets the input element's max.
         */ set: function set(max) {
                        this.input_.max = max;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "step", {
                    get: function get() {
                        return this.input_.step;
                    },
                    /**
         * @param step Sets the input element's step.
         */ set: function set(step) {
                        this.input_.step = step;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "helperTextContent", {
                    /**
         * Sets the helper text element content.
         */ set: function set(content) {
                        this.foundation.setHelperTextContent(content);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "leadingIconAriaLabel", {
                    /**
         * Sets the aria label of the leading icon.
         */ set: function set(label) {
                        this.foundation.setLeadingIconAriaLabel(label);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "leadingIconContent", {
                    /**
         * Sets the text content of the leading icon.
         */ set: function set(content) {
                        this.foundation.setLeadingIconContent(content);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "trailingIconAriaLabel", {
                    /**
         * Sets the aria label of the trailing icon.
         */ set: function set(label) {
                        this.foundation.setTrailingIconAriaLabel(label);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "trailingIconContent", {
                    /**
         * Sets the text content of the trailing icon.
         */ set: function set(content) {
                        this.foundation.setTrailingIconContent(content);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "useNativeValidation", {
                    /**
         * Enables or disables the use of native validation. Use this for custom validation.
         * @param useNativeValidation Set this to false to ignore native input validation.
         */ set: function set(useNativeValidation) {
                        this.foundation.setUseNativeValidation(useNativeValidation);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "prefixText", {
                    /**
         * Gets the text content of the prefix, or null if it does not exist.
         */ get: function get() {
                        return this.prefix_ ? this.prefix_.textContent : null;
                    },
                    /**
         * Sets the text content of the prefix, if it exists.
         */ set: function set(prefixText) {
                        if (this.prefix_) this.prefix_.textContent = prefixText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "suffixText", {
                    /**
         * Gets the text content of the suffix, or null if it does not exist.
         */ get: function get() {
                        return this.suffix_ ? this.suffix_.textContent : null;
                    },
                    /**
         * Sets the text content of the suffix, if it exists.
         */ set: function set(suffixText) {
                        if (this.suffix_) this.suffix_.textContent = suffixText;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Focuses the input element.
     */ MDCTextField.prototype.focus = function() {
                    this.input_.focus();
                };
                /**
     * Recomputes the outline SVG path for the outline element.
     */ MDCTextField.prototype.layout = function() {
                    var openNotch = this.foundation.shouldFloat;
                    this.foundation.notchOutline(openNotch);
                };
                MDCTextField.prototype.getDefaultFoundation = function() {
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = __assign(__assign(__assign(__assign(__assign({}, this.getRootAdapterMethods_()), this.getInputAdapterMethods_()), this.getLabelAdapterMethods_()), this.getLineRippleAdapterMethods_()), this.getOutlineAdapterMethods_());
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_3.MDCTextFieldFoundation(adapter, this.getFoundationMap_());
                };
                MDCTextField.prototype.getRootAdapterMethods_ = function() {
                    var _this = this;
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    return {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        registerTextFieldInteractionHandler: function registerTextFieldInteractionHandler(evtType, handler) {
                            _this.listen(evtType, handler);
                        },
                        deregisterTextFieldInteractionHandler: function deregisterTextFieldInteractionHandler(evtType, handler) {
                            _this.unlisten(evtType, handler);
                        },
                        registerValidationAttributeChangeHandler: function registerValidationAttributeChangeHandler(handler) {
                            var getAttributesList = function getAttributesList(mutationsList) {
                                return mutationsList.map(function(mutation) {
                                    return mutation.attributeName;
                                }).filter(function(attributeName) {
                                    return attributeName;
                                });
                            };
                            var observer = new MutationObserver(function(mutationsList) {
                                return handler(getAttributesList(mutationsList));
                            });
                            var config = {
                                attributes: true
                            };
                            observer.observe(_this.input_, config);
                            return observer;
                        },
                        deregisterValidationAttributeChangeHandler: function deregisterValidationAttributeChangeHandler(observer) {
                            observer.disconnect();
                        }
                    };
                // tslint:enable:object-literal-sort-keys
                };
                MDCTextField.prototype.getInputAdapterMethods_ = function() {
                    var _this = this;
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    return {
                        getNativeInput: function getNativeInput() {
                            return _this.input_;
                        },
                        setInputAttr: function setInputAttr(attr, value) {
                            _this.input_.setAttribute(attr, value);
                        },
                        removeInputAttr: function removeInputAttr(attr) {
                            _this.input_.removeAttribute(attr);
                        },
                        isFocused: function isFocused() {
                            return document.activeElement === _this.input_;
                        },
                        registerInputInteractionHandler: function registerInputInteractionHandler(evtType, handler) {
                            _this.input_.addEventListener(evtType, handler, events_1.applyPassive());
                        },
                        deregisterInputInteractionHandler: function deregisterInputInteractionHandler(evtType, handler) {
                            _this.input_.removeEventListener(evtType, handler, events_1.applyPassive());
                        }
                    };
                // tslint:enable:object-literal-sort-keys
                };
                MDCTextField.prototype.getLabelAdapterMethods_ = function() {
                    var _this = this;
                    return {
                        floatLabel: function floatLabel(shouldFloat) {
                            return _this.label_ && _this.label_.float(shouldFloat);
                        },
                        getLabelWidth: function getLabelWidth() {
                            return _this.label_ ? _this.label_.getWidth() : 0;
                        },
                        hasLabel: function hasLabel() {
                            return Boolean(_this.label_);
                        },
                        shakeLabel: function shakeLabel(shouldShake) {
                            return _this.label_ && _this.label_.shake(shouldShake);
                        },
                        setLabelRequired: function setLabelRequired(isRequired) {
                            return _this.label_ && _this.label_.setRequired(isRequired);
                        }
                    };
                };
                MDCTextField.prototype.getLineRippleAdapterMethods_ = function() {
                    var _this = this;
                    return {
                        activateLineRipple: function activateLineRipple() {
                            if (_this.lineRipple_) _this.lineRipple_.activate();
                        },
                        deactivateLineRipple: function deactivateLineRipple() {
                            if (_this.lineRipple_) _this.lineRipple_.deactivate();
                        },
                        setLineRippleTransformOrigin: function setLineRippleTransformOrigin(normalizedX) {
                            if (_this.lineRipple_) _this.lineRipple_.setRippleCenter(normalizedX);
                        }
                    };
                };
                MDCTextField.prototype.getOutlineAdapterMethods_ = function() {
                    var _this = this;
                    return {
                        closeOutline: function closeOutline() {
                            return _this.outline_ && _this.outline_.closeNotch();
                        },
                        hasOutline: function hasOutline() {
                            return Boolean(_this.outline_);
                        },
                        notchOutline: function notchOutline(labelWidth) {
                            return _this.outline_ && _this.outline_.notch(labelWidth);
                        }
                    };
                };
                /**
     * @return A map of all subcomponents to subfoundations.
     */ MDCTextField.prototype.getFoundationMap_ = function() {
                    return {
                        characterCounter: this.characterCounter_ ? this.characterCounter_.foundationForTextField : undefined,
                        helperText: this.helperText_ ? this.helperText_.foundationForTextField : undefined,
                        leadingIcon: this.leadingIcon_ ? this.leadingIcon_.foundationForTextField : undefined,
                        trailingIcon: this.trailingIcon_ ? this.trailingIcon_.foundationForTextField : undefined
                    };
                };
                MDCTextField.prototype.createRipple_ = function(rippleFactory) {
                    var _this = this;
                    var isTextArea = this.root.classList.contains(constants_1.cssClasses.TEXTAREA);
                    var isOutlined = this.root.classList.contains(constants_1.cssClasses.OUTLINED);
                    if (isTextArea || isOutlined) return null;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = __assign(__assign({}, component_5.MDCRipple.createAdapter(this)), {
                        isSurfaceActive: function isSurfaceActive() {
                            return ponyfill.matches(_this.input_, ":active");
                        },
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            return _this.input_.addEventListener(evtType, handler, events_1.applyPassive());
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            return _this.input_.removeEventListener(evtType, handler, events_1.applyPassive());
                        }
                    });
                    // tslint:enable:object-literal-sort-keys
                    return rippleFactory(this.root, new foundation_1.MDCRippleFoundation(adapter));
                };
                return MDCTextField;
            }(component_1.MDCComponent);
            exports.MDCTextField = MDCTextField;
        /***/ },
        /***/ "./packages/mdc-textfield/constants.ts": /*!*********************************************!*\
  !*** ./packages/mdc-textfield/constants.ts ***!
  \*********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.ALWAYS_FLOAT_TYPES = exports.VALIDATION_ATTR_WHITELIST = exports.numbers = exports.strings = exports.cssClasses = void 0;
            var strings = {
                ARIA_CONTROLS: "aria-controls",
                ARIA_DESCRIBEDBY: "aria-describedby",
                INPUT_SELECTOR: ".mdc-text-field__input",
                LABEL_SELECTOR: ".mdc-floating-label",
                LEADING_ICON_SELECTOR: ".mdc-text-field__icon--leading",
                LINE_RIPPLE_SELECTOR: ".mdc-line-ripple",
                OUTLINE_SELECTOR: ".mdc-notched-outline",
                PREFIX_SELECTOR: ".mdc-text-field__affix--prefix",
                SUFFIX_SELECTOR: ".mdc-text-field__affix--suffix",
                TRAILING_ICON_SELECTOR: ".mdc-text-field__icon--trailing"
            };
            exports.strings = strings;
            var cssClasses = {
                DISABLED: "mdc-text-field--disabled",
                FOCUSED: "mdc-text-field--focused",
                HELPER_LINE: "mdc-text-field-helper-line",
                INVALID: "mdc-text-field--invalid",
                LABEL_FLOATING: "mdc-text-field--label-floating",
                NO_LABEL: "mdc-text-field--no-label",
                OUTLINED: "mdc-text-field--outlined",
                ROOT: "mdc-text-field",
                TEXTAREA: "mdc-text-field--textarea",
                WITH_LEADING_ICON: "mdc-text-field--with-leading-icon",
                WITH_TRAILING_ICON: "mdc-text-field--with-trailing-icon"
            };
            exports.cssClasses = cssClasses;
            var numbers = {
                LABEL_SCALE: 0.75
            };
            exports.numbers = numbers;
            /**
 * Whitelist based off of https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5/Constraint_validation
 * under the "Validation-related attributes" section.
 */ var VALIDATION_ATTR_WHITELIST = [
                "pattern",
                "min",
                "max",
                "required",
                "step",
                "minlength",
                "maxlength"
            ];
            exports.VALIDATION_ATTR_WHITELIST = VALIDATION_ATTR_WHITELIST;
            /**
 * Label should always float for these types as they show some UI even if value is empty.
 */ var ALWAYS_FLOAT_TYPES = [
                "color",
                "date",
                "datetime-local",
                "month",
                "range",
                "time",
                "week"
            ];
            exports.ALWAYS_FLOAT_TYPES = ALWAYS_FLOAT_TYPES;
        /***/ },
        /***/ "./packages/mdc-textfield/custom-element.js": /*!**************************************************!*\
  !*** ./packages/mdc-textfield/custom-element.js ***!
  \**************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-textfield/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcTextField = function(_HTMLElement) {
                _inherits(MdcTextField, _HTMLElement);
                _createClass(MdcTextField, [
                    {
                        key: "focus",
                        value: function focus() {
                            if (this.textField_ && this.textField_.input_) this.textField_.input_.focus();
                        }
                    },
                    {
                        key: "value",
                        get: function get() {
                            if (!!this.textField_) return this.textField_.value;
                            else return this.value_;
                        },
                        set: function set(value) {
                            this.value_ = value;
                            if (!!this.textField_) this.textField_.value = value;
                        }
                    },
                    {
                        key: "disabled",
                        get: function get() {
                            return this.disabled_;
                        },
                        set: function set(disabled) {
                            this.disabled_ = disabled;
                            if (!!this.textField_) this.textField_.disabled = disabled;
                        }
                    },
                    {
                        key: "valid",
                        get: function get() {
                            return this.valid_;
                        },
                        set: function set(valid) {
                            this.valid_ = valid;
                            if (!!this.textField_) this.textField_.valid = valid;
                        }
                    },
                    {
                        key: "required",
                        get: function get() {
                            return this.required_;
                        },
                        set: function set(required) {
                            this.required_ = required;
                            if (!!this.textField_) this.required_ = required;
                        }
                    },
                    {
                        key: "pattern",
                        get: function get() {
                            return this.pattern_;
                        },
                        set: function set(pattern) {
                            this.pattern_ = pattern;
                            if (!!this.textField_) this.textField_.pattern = pattern;
                        }
                    },
                    {
                        key: "minLength",
                        get: function get() {
                            return this.minLength_;
                        },
                        set: function set(minLength) {
                            this.minLength_ = minLength;
                            if (!!this.textField) this.textField_.minLength = minLength;
                        }
                    },
                    {
                        key: "maxLength",
                        get: function get() {
                            return this.maxLength_;
                        },
                        set: function set(maxLength) {
                            this.maxLength_ = maxLength;
                            if (!!this.textField_) this.textField_.maxLength = maxLength;
                        }
                    },
                    {
                        key: "min",
                        get: function get() {
                            return this.min_;
                        },
                        set: function set(min) {
                            this.min_ = min;
                            if (!!this.textField_) this.textField_.min = min;
                        }
                    },
                    {
                        key: "max",
                        get: function get() {
                            return this.max_;
                        },
                        set: function set(max) {
                            this.max_ = max;
                            if (!!this.textField_) this.textField_.max = max;
                        }
                    },
                    {
                        key: "step",
                        get: function get() {
                            return this.step_;
                        },
                        set: function set(step) {
                            this.step_ = step;
                            if (!!this.textField_) this.textField_.step = step;
                        }
                    }
                ]);
                function MdcTextField() {
                    _classCallCheck(this, MdcTextField);
                    var _this = _possibleConstructorReturn(this, (MdcTextField.__proto__ || Object.getPrototypeOf(MdcTextField)).call(this));
                    _this.value_ = "";
                    _this.disabled_ = false;
                    _this.valid_ = true;
                    _this.required_ = false;
                    _this.pattern_ = null;
                    _this.minLength_ = -1;
                    _this.maxLength_ = -1;
                    _this.min_ = "";
                    _this.max_ = "";
                    _this.step_ = "";
                    _this.textField_;
                    return _this;
                }
                _createClass(MdcTextField, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.textField_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCTextField"](this);
                            this.textField_.useNativeValidation = false;
                            this.textField_.value = this.value_;
                            this.textField_.disabled = this.disabled_;
                            this.textField_.valid = this.valid_;
                            this.textField_.required = this.required_;
                            this.textField_.pattern = this.pattern_;
                            this.textField_.minLength = this.minLength_;
                            this.textField_.maxLength = this.maxLength_;
                            this.textField_.min = this.min_;
                            this.textField_.max = this.max_;
                            this.textField_.step = this.step_;
                            var floatingLabel = this.querySelector(".mdc-floating-label");
                            if (!!floatingLabel) _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(floatingLabel);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            var floatingLabel = this.querySelector(".mdc-floating-label");
                            if (!!floatingLabel) _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(floatingLabel);
                            this.textField_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcTextField;
            }(HTMLElement);
            customElements.define("mdc-text-field", MdcTextField);
        /***/ },
        /***/ "./packages/mdc-textfield/foundation.ts": /*!**********************************************!*\
  !*** ./packages/mdc-textfield/foundation.ts ***!
  \**********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTextFieldFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-textfield/constants.ts");
            var POINTERDOWN_EVENTS = [
                "mousedown",
                "touchstart"
            ];
            var INTERACTION_EVENTS = [
                "click",
                "keydown"
            ];
            var MDCTextFieldFoundation = /** @class */ function(_super) {
                __extends(MDCTextFieldFoundation, _super);
                /**
     * @param adapter
     * @param foundationMap Map from subcomponent names to their subfoundations.
     */ function MDCTextFieldFoundation(adapter, foundationMap) {
                    if (foundationMap === void 0) foundationMap = {};
                    var _this = _super.call(this, __assign(__assign({}, MDCTextFieldFoundation.defaultAdapter), adapter)) || this;
                    _this.isFocused_ = false;
                    _this.receivedUserInput_ = false;
                    _this.isValid_ = true;
                    _this.useNativeValidation_ = true;
                    _this.validateOnValueChange_ = false;
                    _this.helperText_ = foundationMap.helperText;
                    _this.characterCounter_ = foundationMap.characterCounter;
                    _this.leadingIcon_ = foundationMap.leadingIcon;
                    _this.trailingIcon_ = foundationMap.trailingIcon;
                    _this.inputFocusHandler_ = function() {
                        return _this.activateFocus();
                    };
                    _this.inputBlurHandler_ = function() {
                        return _this.deactivateFocus();
                    };
                    _this.inputInputHandler_ = function() {
                        return _this.handleInput();
                    };
                    _this.setPointerXOffset_ = function(evt) {
                        return _this.setTransformOrigin(evt);
                    };
                    _this.textFieldInteractionHandler_ = function() {
                        return _this.handleTextFieldInteraction();
                    };
                    _this.validationAttributeChangeHandler_ = function() {};
                    return _this;
                }
                Object.defineProperty(MDCTextFieldFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldFoundation.prototype, "shouldAlwaysFloat_", {
                    get: function get() {
                        var type = this.getNativeInput_().type;
                        return constants_1.ALWAYS_FLOAT_TYPES.indexOf(type) >= 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldFoundation.prototype, "shouldFloat", {
                    get: function get() {
                        return this.shouldAlwaysFloat_ || this.isFocused_ || !!this.getValue() || this.isBadInput_();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldFoundation.prototype, "shouldShake", {
                    get: function get() {
                        return !this.isFocused_ && !this.isValid() && !!this.getValue();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCTextFieldAdapter} for typing information on parameters and
         * return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return true;
                            },
                            setInputAttr: function setInputAttr() {
                                return undefined;
                            },
                            removeInputAttr: function removeInputAttr() {
                                return undefined;
                            },
                            registerTextFieldInteractionHandler: function registerTextFieldInteractionHandler() {
                                return undefined;
                            },
                            deregisterTextFieldInteractionHandler: function deregisterTextFieldInteractionHandler() {
                                return undefined;
                            },
                            registerInputInteractionHandler: function registerInputInteractionHandler() {
                                return undefined;
                            },
                            deregisterInputInteractionHandler: function deregisterInputInteractionHandler() {
                                return undefined;
                            },
                            registerValidationAttributeChangeHandler: function registerValidationAttributeChangeHandler() {
                                return new MutationObserver(function() {
                                    return undefined;
                                });
                            },
                            deregisterValidationAttributeChangeHandler: function deregisterValidationAttributeChangeHandler() {
                                return undefined;
                            },
                            getNativeInput: function getNativeInput() {
                                return null;
                            },
                            isFocused: function isFocused() {
                                return false;
                            },
                            activateLineRipple: function activateLineRipple() {
                                return undefined;
                            },
                            deactivateLineRipple: function deactivateLineRipple() {
                                return undefined;
                            },
                            setLineRippleTransformOrigin: function setLineRippleTransformOrigin() {
                                return undefined;
                            },
                            shakeLabel: function shakeLabel() {
                                return undefined;
                            },
                            floatLabel: function floatLabel() {
                                return undefined;
                            },
                            setLabelRequired: function setLabelRequired() {
                                return undefined;
                            },
                            hasLabel: function hasLabel() {
                                return false;
                            },
                            getLabelWidth: function getLabelWidth() {
                                return 0;
                            },
                            hasOutline: function hasOutline() {
                                return false;
                            },
                            notchOutline: function notchOutline() {
                                return undefined;
                            },
                            closeOutline: function closeOutline() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTextFieldFoundation.prototype.init = function() {
                    var _this = this;
                    if (this.adapter.hasLabel() && this.getNativeInput_().required) this.adapter.setLabelRequired(true);
                    if (this.adapter.isFocused()) this.inputFocusHandler_();
                    else if (this.adapter.hasLabel() && this.shouldFloat) {
                        this.notchOutline(true);
                        this.adapter.floatLabel(true);
                        this.styleFloating_(true);
                    }
                    this.adapter.registerInputInteractionHandler("focus", this.inputFocusHandler_);
                    this.adapter.registerInputInteractionHandler("blur", this.inputBlurHandler_);
                    this.adapter.registerInputInteractionHandler("input", this.inputInputHandler_);
                    POINTERDOWN_EVENTS.forEach(function(evtType) {
                        _this.adapter.registerInputInteractionHandler(evtType, _this.setPointerXOffset_);
                    });
                    INTERACTION_EVENTS.forEach(function(evtType) {
                        _this.adapter.registerTextFieldInteractionHandler(evtType, _this.textFieldInteractionHandler_);
                    });
                    this.validationObserver_ = this.adapter.registerValidationAttributeChangeHandler(this.validationAttributeChangeHandler_);
                    this.setCharacterCounter_(this.getValue().length);
                };
                MDCTextFieldFoundation.prototype.destroy = function() {
                    var _this = this;
                    this.adapter.deregisterInputInteractionHandler("focus", this.inputFocusHandler_);
                    this.adapter.deregisterInputInteractionHandler("blur", this.inputBlurHandler_);
                    this.adapter.deregisterInputInteractionHandler("input", this.inputInputHandler_);
                    POINTERDOWN_EVENTS.forEach(function(evtType) {
                        _this.adapter.deregisterInputInteractionHandler(evtType, _this.setPointerXOffset_);
                    });
                    INTERACTION_EVENTS.forEach(function(evtType) {
                        _this.adapter.deregisterTextFieldInteractionHandler(evtType, _this.textFieldInteractionHandler_);
                    });
                    this.adapter.deregisterValidationAttributeChangeHandler(this.validationObserver_);
                };
                /**
     * Handles user interactions with the Text Field.
     */ MDCTextFieldFoundation.prototype.handleTextFieldInteraction = function() {
                    var nativeInput = this.adapter.getNativeInput();
                    if (nativeInput && nativeInput.disabled) return;
                    this.receivedUserInput_ = true;
                };
                /**
     * Handles validation attribute changes
     */ MDCTextFieldFoundation.prototype.handleValidationAttributeChange = function(attributesList) {
                    var _this = this;
                    attributesList.some(function(attributeName) {
                        if (constants_1.VALIDATION_ATTR_WHITELIST.indexOf(attributeName) > -1) {
                            _this.styleValidity_(true);
                            _this.adapter.setLabelRequired(_this.getNativeInput_().required);
                            return true;
                        }
                        return false;
                    });
                    if (attributesList.indexOf("maxlength") > -1) this.setCharacterCounter_(this.getValue().length);
                };
                /**
     * Opens/closes the notched outline.
     */ MDCTextFieldFoundation.prototype.notchOutline = function(openNotch) {
                    if (!this.adapter.hasOutline() || !this.adapter.hasLabel()) return;
                    if (openNotch) {
                        var labelWidth = this.adapter.getLabelWidth() * constants_1.numbers.LABEL_SCALE;
                        this.adapter.notchOutline(labelWidth);
                    } else this.adapter.closeOutline();
                };
                /**
     * Activates the text field focus state.
     */ MDCTextFieldFoundation.prototype.activateFocus = function() {
                    this.isFocused_ = true;
                    this.styleFocused_(this.isFocused_);
                    this.adapter.activateLineRipple();
                    if (this.adapter.hasLabel()) {
                        this.notchOutline(this.shouldFloat);
                        this.adapter.floatLabel(this.shouldFloat);
                        this.styleFloating_(this.shouldFloat);
                        this.adapter.shakeLabel(this.shouldShake);
                    }
                    if (this.helperText_ && (this.helperText_.isPersistent() || !this.helperText_.isValidation() || !this.isValid_)) this.helperText_.showToScreenReader();
                };
                /**
     * Sets the line ripple's transform origin, so that the line ripple activate
     * animation will animate out from the user's click location.
     */ MDCTextFieldFoundation.prototype.setTransformOrigin = function(evt) {
                    if (this.isDisabled() || this.adapter.hasOutline()) return;
                    var touches = evt.touches;
                    var targetEvent = touches ? touches[0] : evt;
                    var targetClientRect = targetEvent.target.getBoundingClientRect();
                    var normalizedX = targetEvent.clientX - targetClientRect.left;
                    this.adapter.setLineRippleTransformOrigin(normalizedX);
                };
                /**
     * Handles input change of text input and text area.
     */ MDCTextFieldFoundation.prototype.handleInput = function() {
                    this.autoCompleteFocus();
                    this.setCharacterCounter_(this.getValue().length);
                };
                /**
     * Activates the Text Field's focus state in cases when the input value
     * changes without user input (e.g. programmatically).
     */ MDCTextFieldFoundation.prototype.autoCompleteFocus = function() {
                    if (!this.receivedUserInput_) this.activateFocus();
                };
                /**
     * Deactivates the Text Field's focus state.
     */ MDCTextFieldFoundation.prototype.deactivateFocus = function() {
                    this.isFocused_ = false;
                    this.adapter.deactivateLineRipple();
                    var isValid = this.isValid();
                    this.styleValidity_(isValid);
                    this.styleFocused_(this.isFocused_);
                    if (this.adapter.hasLabel()) {
                        this.notchOutline(this.shouldFloat);
                        this.adapter.floatLabel(this.shouldFloat);
                        this.styleFloating_(this.shouldFloat);
                        this.adapter.shakeLabel(this.shouldShake);
                    }
                    if (!this.shouldFloat) this.receivedUserInput_ = false;
                };
                MDCTextFieldFoundation.prototype.getValue = function() {
                    return this.getNativeInput_().value;
                };
                /**
     * @param value The value to set on the input Element.
     */ MDCTextFieldFoundation.prototype.setValue = function(value) {
                    // Prevent Safari from moving the caret to the end of the input when the
                    // value has not changed.
                    if (this.getValue() !== value) this.getNativeInput_().value = value;
                    this.setCharacterCounter_(value.length);
                    if (this.validateOnValueChange_) {
                        var isValid = this.isValid();
                        this.styleValidity_(isValid);
                    }
                    if (this.adapter.hasLabel()) {
                        this.notchOutline(this.shouldFloat);
                        this.adapter.floatLabel(this.shouldFloat);
                        this.styleFloating_(this.shouldFloat);
                        if (this.validateOnValueChange_) this.adapter.shakeLabel(this.shouldShake);
                    }
                };
                /**
     * @return The custom validity state, if set; otherwise, the result of a
     *     native validity check.
     */ MDCTextFieldFoundation.prototype.isValid = function() {
                    return this.useNativeValidation_ ? this.isNativeInputValid_() : this.isValid_;
                };
                /**
     * @param isValid Sets the custom validity state of the Text Field.
     */ MDCTextFieldFoundation.prototype.setValid = function(isValid) {
                    this.isValid_ = isValid;
                    this.styleValidity_(isValid);
                    var shouldShake = !isValid && !this.isFocused_ && !!this.getValue();
                    if (this.adapter.hasLabel()) this.adapter.shakeLabel(shouldShake);
                };
                /**
     * @param shouldValidate Whether or not validity should be updated on
     *     value change.
     */ MDCTextFieldFoundation.prototype.setValidateOnValueChange = function(shouldValidate) {
                    this.validateOnValueChange_ = shouldValidate;
                };
                /**
     * @return Whether or not validity should be updated on value change. `true`
     *     by default.
     */ MDCTextFieldFoundation.prototype.getValidateOnValueChange = function() {
                    return this.validateOnValueChange_;
                };
                /**
     * Enables or disables the use of native validation. Use this for custom
     * validation.
     * @param useNativeValidation Set this to false to ignore native input
     *     validation.
     */ MDCTextFieldFoundation.prototype.setUseNativeValidation = function(useNativeValidation) {
                    this.useNativeValidation_ = useNativeValidation;
                };
                MDCTextFieldFoundation.prototype.isDisabled = function() {
                    return this.getNativeInput_().disabled;
                };
                /**
     * @param disabled Sets the text-field disabled or enabled.
     */ MDCTextFieldFoundation.prototype.setDisabled = function(disabled) {
                    this.getNativeInput_().disabled = disabled;
                    this.styleDisabled_(disabled);
                };
                /**
     * @param content Sets the content of the helper text.
     */ MDCTextFieldFoundation.prototype.setHelperTextContent = function(content) {
                    if (this.helperText_) this.helperText_.setContent(content);
                };
                /**
     * Sets the aria label of the leading icon.
     */ MDCTextFieldFoundation.prototype.setLeadingIconAriaLabel = function(label) {
                    if (this.leadingIcon_) this.leadingIcon_.setAriaLabel(label);
                };
                /**
     * Sets the text content of the leading icon.
     */ MDCTextFieldFoundation.prototype.setLeadingIconContent = function(content) {
                    if (this.leadingIcon_) this.leadingIcon_.setContent(content);
                };
                /**
     * Sets the aria label of the trailing icon.
     */ MDCTextFieldFoundation.prototype.setTrailingIconAriaLabel = function(label) {
                    if (this.trailingIcon_) this.trailingIcon_.setAriaLabel(label);
                };
                /**
     * Sets the text content of the trailing icon.
     */ MDCTextFieldFoundation.prototype.setTrailingIconContent = function(content) {
                    if (this.trailingIcon_) this.trailingIcon_.setContent(content);
                };
                /**
     * Sets character counter values that shows characters used and the total
     * character limit.
     */ MDCTextFieldFoundation.prototype.setCharacterCounter_ = function(currentLength) {
                    if (!this.characterCounter_) return;
                    var maxLength = this.getNativeInput_().maxLength;
                    if (maxLength === -1) throw new Error("MDCTextFieldFoundation: Expected maxlength html property on text input or textarea.");
                    this.characterCounter_.setCounterValue(currentLength, maxLength);
                };
                /**
     * @return True if the Text Field input fails in converting the user-supplied
     *     value.
     */ MDCTextFieldFoundation.prototype.isBadInput_ = function() {
                    // The badInput property is not supported in IE 11 💩.
                    return this.getNativeInput_().validity.badInput || false;
                };
                /**
     * @return The result of native validity checking (ValidityState.valid).
     */ MDCTextFieldFoundation.prototype.isNativeInputValid_ = function() {
                    return this.getNativeInput_().validity.valid;
                };
                /**
     * Styles the component based on the validity state.
     */ MDCTextFieldFoundation.prototype.styleValidity_ = function(isValid) {
                    var INVALID = MDCTextFieldFoundation.cssClasses.INVALID;
                    if (isValid) this.adapter.removeClass(INVALID);
                    else this.adapter.addClass(INVALID);
                    if (this.helperText_) {
                        this.helperText_.setValidity(isValid);
                        // We dynamically set or unset aria-describedby for validation helper text
                        // only, based on whether the field is valid
                        var helperTextValidation = this.helperText_.isValidation();
                        if (!helperTextValidation) return;
                        var helperTextVisible = this.helperText_.isVisible();
                        var helperTextId = this.helperText_.getId();
                        if (helperTextVisible && helperTextId) this.adapter.setInputAttr(constants_1.strings.ARIA_DESCRIBEDBY, helperTextId);
                        else this.adapter.removeInputAttr(constants_1.strings.ARIA_DESCRIBEDBY);
                    }
                };
                /**
     * Styles the component based on the focused state.
     */ MDCTextFieldFoundation.prototype.styleFocused_ = function(isFocused) {
                    var FOCUSED = MDCTextFieldFoundation.cssClasses.FOCUSED;
                    if (isFocused) this.adapter.addClass(FOCUSED);
                    else this.adapter.removeClass(FOCUSED);
                };
                /**
     * Styles the component based on the disabled state.
     */ MDCTextFieldFoundation.prototype.styleDisabled_ = function(isDisabled) {
                    var _a = MDCTextFieldFoundation.cssClasses, DISABLED = _a.DISABLED, INVALID = _a.INVALID;
                    if (isDisabled) {
                        this.adapter.addClass(DISABLED);
                        this.adapter.removeClass(INVALID);
                    } else this.adapter.removeClass(DISABLED);
                    if (this.leadingIcon_) this.leadingIcon_.setDisabled(isDisabled);
                    if (this.trailingIcon_) this.trailingIcon_.setDisabled(isDisabled);
                };
                /**
     * Styles the component based on the label floating state.
     */ MDCTextFieldFoundation.prototype.styleFloating_ = function(isFloating) {
                    var LABEL_FLOATING = MDCTextFieldFoundation.cssClasses.LABEL_FLOATING;
                    if (isFloating) this.adapter.addClass(LABEL_FLOATING);
                    else this.adapter.removeClass(LABEL_FLOATING);
                };
                /**
     * @return The native text input element from the host environment, or an
     *     object with the same shape for unit tests.
     */ MDCTextFieldFoundation.prototype.getNativeInput_ = function() {
                    // this.adapter may be undefined in foundation unit tests. This happens when
                    // testdouble is creating a mock object and invokes the
                    // shouldShake/shouldFloat getters (which in turn call getValue(), which
                    // calls this method) before init() has been called from the MDCTextField
                    // constructor. To work around that issue, we return a dummy object.
                    var nativeInput = this.adapter ? this.adapter.getNativeInput() : null;
                    return nativeInput || {
                        disabled: false,
                        maxLength: -1,
                        required: false,
                        type: "input",
                        validity: {
                            badInput: false,
                            valid: true
                        },
                        value: ""
                    };
                };
                return MDCTextFieldFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTextFieldFoundation = MDCTextFieldFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTextFieldFoundation;
        /***/ },
        /***/ "./packages/mdc-textfield/helper-text/component.ts": /*!*********************************************************!*\
  !*** ./packages/mdc-textfield/helper-text/component.ts ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTextFieldHelperText = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-textfield/helper-text/foundation.ts");
            var MDCTextFieldHelperText = /** @class */ function(_super) {
                __extends(MDCTextFieldHelperText, _super);
                function MDCTextFieldHelperText() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTextFieldHelperText.attachTo = function(root) {
                    return new MDCTextFieldHelperText(root);
                };
                Object.defineProperty(MDCTextFieldHelperText.prototype, "foundationForTextField", {
                    // Provided for access by MDCTextField component
                    get: function get() {
                        return this.foundation;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTextFieldHelperText.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        getAttr: function getAttr(attr) {
                            return _this.root.getAttribute(attr);
                        },
                        setAttr: function setAttr(attr, value) {
                            return _this.root.setAttribute(attr, value);
                        },
                        removeAttr: function removeAttr(attr) {
                            return _this.root.removeAttribute(attr);
                        },
                        setContent: function setContent(content) {
                            _this.root.textContent = content;
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_1.MDCTextFieldHelperTextFoundation(adapter);
                };
                return MDCTextFieldHelperText;
            }(component_1.MDCComponent);
            exports.MDCTextFieldHelperText = MDCTextFieldHelperText;
        /***/ },
        /***/ "./packages/mdc-textfield/helper-text/constants.ts": /*!*********************************************************!*\
  !*** ./packages/mdc-textfield/helper-text/constants.ts ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.cssClasses = exports.strings = void 0;
            var cssClasses = {
                HELPER_TEXT_PERSISTENT: "mdc-text-field-helper-text--persistent",
                HELPER_TEXT_VALIDATION_MSG: "mdc-text-field-helper-text--validation-msg",
                ROOT: "mdc-text-field-helper-text"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                ARIA_HIDDEN: "aria-hidden",
                ROLE: "role",
                ROOT_SELECTOR: "." + cssClasses.ROOT
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-textfield/helper-text/foundation.ts": /*!**********************************************************!*\
  !*** ./packages/mdc-textfield/helper-text/foundation.ts ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTextFieldHelperTextFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-textfield/helper-text/constants.ts");
            var MDCTextFieldHelperTextFoundation = /** @class */ function(_super) {
                __extends(MDCTextFieldHelperTextFoundation, _super);
                function MDCTextFieldHelperTextFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCTextFieldHelperTextFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCTextFieldHelperTextFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldHelperTextFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldHelperTextFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCTextFieldHelperTextAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            getAttr: function getAttr() {
                                return null;
                            },
                            setAttr: function setAttr() {
                                return undefined;
                            },
                            removeAttr: function removeAttr() {
                                return undefined;
                            },
                            setContent: function setContent() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTextFieldHelperTextFoundation.prototype.getId = function() {
                    return this.adapter.getAttr("id");
                };
                MDCTextFieldHelperTextFoundation.prototype.isVisible = function() {
                    return this.adapter.getAttr(constants_1.strings.ARIA_HIDDEN) !== "true";
                };
                /**
     * Sets the content of the helper text field.
     */ MDCTextFieldHelperTextFoundation.prototype.setContent = function(content) {
                    this.adapter.setContent(content);
                };
                MDCTextFieldHelperTextFoundation.prototype.isPersistent = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.HELPER_TEXT_PERSISTENT);
                };
                /**
     * @param isPersistent Sets the persistency of the helper text.
     */ MDCTextFieldHelperTextFoundation.prototype.setPersistent = function(isPersistent) {
                    if (isPersistent) this.adapter.addClass(constants_1.cssClasses.HELPER_TEXT_PERSISTENT);
                    else this.adapter.removeClass(constants_1.cssClasses.HELPER_TEXT_PERSISTENT);
                };
                /**
     * @return whether the helper text acts as an error validation message.
     */ MDCTextFieldHelperTextFoundation.prototype.isValidation = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG);
                };
                /**
     * @param isValidation True to make the helper text act as an error validation message.
     */ MDCTextFieldHelperTextFoundation.prototype.setValidation = function(isValidation) {
                    if (isValidation) this.adapter.addClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG);
                    else this.adapter.removeClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG);
                };
                /**
     * Makes the helper text visible to the screen reader.
     */ MDCTextFieldHelperTextFoundation.prototype.showToScreenReader = function() {
                    this.adapter.removeAttr(constants_1.strings.ARIA_HIDDEN);
                };
                /**
     * Sets the validity of the helper text based on the input validity.
     */ MDCTextFieldHelperTextFoundation.prototype.setValidity = function(inputIsValid) {
                    var helperTextIsPersistent = this.adapter.hasClass(constants_1.cssClasses.HELPER_TEXT_PERSISTENT);
                    var helperTextIsValidationMsg = this.adapter.hasClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG);
                    var validationMsgNeedsDisplay = helperTextIsValidationMsg && !inputIsValid;
                    if (validationMsgNeedsDisplay) {
                        this.showToScreenReader();
                        this.adapter.setAttr(constants_1.strings.ROLE, "alert");
                    } else this.adapter.removeAttr(constants_1.strings.ROLE);
                    if (!helperTextIsPersistent && !validationMsgNeedsDisplay) this.hide_();
                };
                /**
     * Hides the help text from screen readers.
     */ MDCTextFieldHelperTextFoundation.prototype.hide_ = function() {
                    this.adapter.setAttr(constants_1.strings.ARIA_HIDDEN, "true");
                };
                return MDCTextFieldHelperTextFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTextFieldHelperTextFoundation = MDCTextFieldHelperTextFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTextFieldHelperTextFoundation;
        /***/ },
        /***/ "./packages/mdc-textfield/icon/component.ts": /*!**************************************************!*\
  !*** ./packages/mdc-textfield/icon/component.ts ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTextFieldIcon = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-textfield/icon/foundation.ts");
            var MDCTextFieldIcon = /** @class */ function(_super) {
                __extends(MDCTextFieldIcon, _super);
                function MDCTextFieldIcon() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTextFieldIcon.attachTo = function(root) {
                    return new MDCTextFieldIcon(root);
                };
                Object.defineProperty(MDCTextFieldIcon.prototype, "foundationForTextField", {
                    // Provided for access by MDCTextField component
                    get: function get() {
                        return this.foundation;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTextFieldIcon.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        getAttr: function getAttr(attr) {
                            return _this.root.getAttribute(attr);
                        },
                        setAttr: function setAttr(attr, value) {
                            return _this.root.setAttribute(attr, value);
                        },
                        removeAttr: function removeAttr(attr) {
                            return _this.root.removeAttribute(attr);
                        },
                        setContent: function setContent(content) {
                            _this.root.textContent = content;
                        },
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            return _this.listen(evtType, handler);
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            return _this.unlisten(evtType, handler);
                        },
                        notifyIconAction: function notifyIconAction() {
                            return _this.emit(foundation_1.MDCTextFieldIconFoundation.strings.ICON_EVENT, {} /* evtData */ , true);
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_1.MDCTextFieldIconFoundation(adapter);
                };
                return MDCTextFieldIcon;
            }(component_1.MDCComponent);
            exports.MDCTextFieldIcon = MDCTextFieldIcon;
        /***/ },
        /***/ "./packages/mdc-textfield/icon/constants.ts": /*!**************************************************!*\
  !*** ./packages/mdc-textfield/icon/constants.ts ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.cssClasses = exports.strings = void 0;
            var strings = {
                ICON_EVENT: "MDCTextField:icon",
                ICON_ROLE: "button"
            };
            exports.strings = strings;
            var cssClasses = {
                ROOT: "mdc-text-field__icon"
            };
            exports.cssClasses = cssClasses;
        /***/ },
        /***/ "./packages/mdc-textfield/icon/foundation.ts": /*!***************************************************!*\
  !*** ./packages/mdc-textfield/icon/foundation.ts ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTextFieldIconFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-textfield/icon/constants.ts");
            var INTERACTION_EVENTS = [
                "click",
                "keydown"
            ];
            var MDCTextFieldIconFoundation = /** @class */ function(_super) {
                __extends(MDCTextFieldIconFoundation, _super);
                function MDCTextFieldIconFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCTextFieldIconFoundation.defaultAdapter), adapter)) || this;
                    _this.savedTabIndex_ = null;
                    _this.interactionHandler_ = function(evt) {
                        return _this.handleInteraction(evt);
                    };
                    return _this;
                }
                Object.defineProperty(MDCTextFieldIconFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldIconFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldIconFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCTextFieldIconAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            getAttr: function getAttr() {
                                return null;
                            },
                            setAttr: function setAttr() {
                                return undefined;
                            },
                            removeAttr: function removeAttr() {
                                return undefined;
                            },
                            setContent: function setContent() {
                                return undefined;
                            },
                            registerInteractionHandler: function registerInteractionHandler() {
                                return undefined;
                            },
                            deregisterInteractionHandler: function deregisterInteractionHandler() {
                                return undefined;
                            },
                            notifyIconAction: function notifyIconAction() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTextFieldIconFoundation.prototype.init = function() {
                    var _this = this;
                    this.savedTabIndex_ = this.adapter.getAttr("tabindex");
                    INTERACTION_EVENTS.forEach(function(evtType) {
                        _this.adapter.registerInteractionHandler(evtType, _this.interactionHandler_);
                    });
                };
                MDCTextFieldIconFoundation.prototype.destroy = function() {
                    var _this = this;
                    INTERACTION_EVENTS.forEach(function(evtType) {
                        _this.adapter.deregisterInteractionHandler(evtType, _this.interactionHandler_);
                    });
                };
                MDCTextFieldIconFoundation.prototype.setDisabled = function(disabled) {
                    if (!this.savedTabIndex_) return;
                    if (disabled) {
                        this.adapter.setAttr("tabindex", "-1");
                        this.adapter.removeAttr("role");
                    } else {
                        this.adapter.setAttr("tabindex", this.savedTabIndex_);
                        this.adapter.setAttr("role", constants_1.strings.ICON_ROLE);
                    }
                };
                MDCTextFieldIconFoundation.prototype.setAriaLabel = function(label) {
                    this.adapter.setAttr("aria-label", label);
                };
                MDCTextFieldIconFoundation.prototype.setContent = function(content) {
                    this.adapter.setContent(content);
                };
                MDCTextFieldIconFoundation.prototype.handleInteraction = function(evt) {
                    var isEnterKey = evt.key === "Enter" || evt.keyCode === 13;
                    if (evt.type === "click" || isEnterKey) {
                        evt.preventDefault(); // stop click from causing host label to focus
                        // input
                        this.adapter.notifyIconAction();
                    }
                };
                return MDCTextFieldIconFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTextFieldIconFoundation = MDCTextFieldIconFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTextFieldIconFoundation;
        /***/ },
        /***/ "./packages/mdc-top-app-bar/component.ts": /*!***********************************************!*\
  !*** ./packages/mdc-top-app-bar/component.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTopAppBar = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-top-app-bar/constants.ts");
            var foundation_1 = __webpack_require__(/*! ./fixed/foundation */ "./packages/mdc-top-app-bar/fixed/foundation.ts");
            var foundation_2 = __webpack_require__(/*! ./short/foundation */ "./packages/mdc-top-app-bar/short/foundation.ts");
            var foundation_3 = __webpack_require__(/*! ./standard/foundation */ "./packages/mdc-top-app-bar/standard/foundation.ts");
            var MDCTopAppBar = /** @class */ function(_super) {
                __extends(MDCTopAppBar, _super);
                function MDCTopAppBar() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTopAppBar.attachTo = function(root) {
                    return new MDCTopAppBar(root);
                };
                MDCTopAppBar.prototype.initialize = function() {
                    this.navIcon_ = this.root.querySelector(constants_1.strings.NAVIGATION_ICON_SELECTOR);
                    this.scrollTarget_ = window;
                };
                MDCTopAppBar.prototype.initialSyncWithDOM = function() {
                    this.handleNavigationClick_ = this.foundation.handleNavigationClick.bind(this.foundation);
                    this.handleWindowResize_ = this.foundation.handleWindowResize.bind(this.foundation);
                    this.handleTargetScroll_ = this.foundation.handleTargetScroll.bind(this.foundation);
                    this.scrollTarget_.addEventListener("scroll", this.handleTargetScroll_);
                    if (this.navIcon_) this.navIcon_.addEventListener("click", this.handleNavigationClick_);
                    var isFixed = this.root.classList.contains(constants_1.cssClasses.FIXED_CLASS);
                    var isShort = this.root.classList.contains(constants_1.cssClasses.SHORT_CLASS);
                    if (!isShort && !isFixed) window.addEventListener("resize", this.handleWindowResize_);
                };
                MDCTopAppBar.prototype.destroy = function() {
                    this.scrollTarget_.removeEventListener("scroll", this.handleTargetScroll_);
                    if (this.navIcon_) this.navIcon_.removeEventListener("click", this.handleNavigationClick_);
                    var isFixed = this.root.classList.contains(constants_1.cssClasses.FIXED_CLASS);
                    var isShort = this.root.classList.contains(constants_1.cssClasses.SHORT_CLASS);
                    if (!isShort && !isFixed) window.removeEventListener("resize", this.handleWindowResize_);
                    _super.prototype.destroy.call(this);
                };
                MDCTopAppBar.prototype.setScrollTarget = function(target) {
                    // Remove scroll handler from the previous scroll target
                    this.scrollTarget_.removeEventListener("scroll", this.handleTargetScroll_);
                    this.scrollTarget_ = target;
                    // Initialize scroll handler on the new scroll target
                    this.handleTargetScroll_ = this.foundation.handleTargetScroll.bind(this.foundation);
                    this.scrollTarget_.addEventListener("scroll", this.handleTargetScroll_);
                };
                MDCTopAppBar.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        setStyle: function setStyle(property, value) {
                            return _this.root.style.setProperty(property, value);
                        },
                        getTopAppBarHeight: function getTopAppBarHeight() {
                            return _this.root.clientHeight;
                        },
                        notifyNavigationIconClicked: function notifyNavigationIconClicked() {
                            return _this.emit(constants_1.strings.NAVIGATION_EVENT, {});
                        },
                        getViewportScrollY: function getViewportScrollY() {
                            var win = _this.scrollTarget_;
                            var el = _this.scrollTarget_;
                            return win.pageYOffset !== undefined ? win.pageYOffset : el.scrollTop;
                        },
                        getTotalActionItems: function getTotalActionItems() {
                            return _this.root.querySelectorAll(constants_1.strings.ACTION_ITEM_SELECTOR).length;
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    var foundation;
                    if (this.root.classList.contains(constants_1.cssClasses.SHORT_CLASS)) foundation = new foundation_2.MDCShortTopAppBarFoundation(adapter);
                    else if (this.root.classList.contains(constants_1.cssClasses.FIXED_CLASS)) foundation = new foundation_1.MDCFixedTopAppBarFoundation(adapter);
                    else foundation = new foundation_3.MDCTopAppBarFoundation(adapter);
                    return foundation;
                };
                return MDCTopAppBar;
            }(component_1.MDCComponent);
            exports.MDCTopAppBar = MDCTopAppBar;
        /***/ },
        /***/ "./packages/mdc-top-app-bar/constants.ts": /*!***********************************************!*\
  !*** ./packages/mdc-top-app-bar/constants.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.numbers = exports.cssClasses = void 0;
            var cssClasses = {
                FIXED_CLASS: "mdc-top-app-bar--fixed",
                FIXED_SCROLLED_CLASS: "mdc-top-app-bar--fixed-scrolled",
                SHORT_CLASS: "mdc-top-app-bar--short",
                SHORT_COLLAPSED_CLASS: "mdc-top-app-bar--short-collapsed",
                SHORT_HAS_ACTION_ITEM_CLASS: "mdc-top-app-bar--short-has-action-item"
            };
            exports.cssClasses = cssClasses;
            var numbers = {
                DEBOUNCE_THROTTLE_RESIZE_TIME_MS: 100,
                MAX_TOP_APP_BAR_HEIGHT: 128
            };
            exports.numbers = numbers;
            var strings = {
                ACTION_ITEM_SELECTOR: ".mdc-top-app-bar__action-item",
                NAVIGATION_EVENT: "MDCTopAppBar:nav",
                NAVIGATION_ICON_SELECTOR: ".mdc-top-app-bar__navigation-icon",
                ROOT_SELECTOR: ".mdc-top-app-bar",
                TITLE_SELECTOR: ".mdc-top-app-bar__title"
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-top-app-bar/custom-element.js": /*!****************************************************!*\
  !*** ./packages/mdc-top-app-bar/custom-element.js ***!
  \****************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-top-app-bar/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcTopAppBar = function(_HTMLElement) {
                _inherits(MdcTopAppBar, _HTMLElement);
                function MdcTopAppBar() {
                    _classCallCheck(this, MdcTopAppBar);
                    return _possibleConstructorReturn(this, (MdcTopAppBar.__proto__ || Object.getPrototypeOf(MdcTopAppBar)).call(this));
                }
                _createClass(MdcTopAppBar, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.topAppBar_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCTopAppBar"](this);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.topAppBar_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcTopAppBar;
            }(HTMLElement);
            customElements.define("mdc-top-app-bar", MdcTopAppBar);
        /***/ },
        /***/ "./packages/mdc-top-app-bar/fixed/foundation.ts": /*!******************************************************!*\
  !*** ./packages/mdc-top-app-bar/fixed/foundation.ts ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCFixedTopAppBarFoundation = void 0;
            var constants_1 = __webpack_require__(/*! ../constants */ "./packages/mdc-top-app-bar/constants.ts");
            var foundation_1 = __webpack_require__(/*! ../standard/foundation */ "./packages/mdc-top-app-bar/standard/foundation.ts");
            var MDCFixedTopAppBarFoundation = /** @class */ function(_super) {
                __extends(MDCFixedTopAppBarFoundation, _super);
                function MDCFixedTopAppBarFoundation() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    /**
         * State variable for the previous scroll iteration top app bar state
         */ _this.wasScrolled_ = false;
                    return _this;
                }
                /**
     * Scroll handler for applying/removing the modifier class on the fixed top app bar.
     * @override
     */ MDCFixedTopAppBarFoundation.prototype.handleTargetScroll = function() {
                    var currentScroll = this.adapter.getViewportScrollY();
                    if (currentScroll <= 0) {
                        if (this.wasScrolled_) {
                            this.adapter.removeClass(constants_1.cssClasses.FIXED_SCROLLED_CLASS);
                            this.wasScrolled_ = false;
                        }
                    } else if (!this.wasScrolled_) {
                        this.adapter.addClass(constants_1.cssClasses.FIXED_SCROLLED_CLASS);
                        this.wasScrolled_ = true;
                    }
                };
                return MDCFixedTopAppBarFoundation;
            }(foundation_1.MDCTopAppBarFoundation);
            exports.MDCFixedTopAppBarFoundation = MDCFixedTopAppBarFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCFixedTopAppBarFoundation;
        /***/ },
        /***/ "./packages/mdc-top-app-bar/foundation.ts": /*!************************************************!*\
  !*** ./packages/mdc-top-app-bar/foundation.ts ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTopAppBarBaseFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-top-app-bar/constants.ts");
            var MDCTopAppBarBaseFoundation = /** @class */ function(_super) {
                __extends(MDCTopAppBarBaseFoundation, _super);
                /* istanbul ignore next: optional argument is not a branch statement */ function MDCTopAppBarBaseFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCTopAppBarBaseFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCTopAppBarBaseFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTopAppBarBaseFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTopAppBarBaseFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTopAppBarBaseFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCTopAppBarAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            setStyle: function setStyle() {
                                return undefined;
                            },
                            getTopAppBarHeight: function getTopAppBarHeight() {
                                return 0;
                            },
                            notifyNavigationIconClicked: function notifyNavigationIconClicked() {
                                return undefined;
                            },
                            getViewportScrollY: function getViewportScrollY() {
                                return 0;
                            },
                            getTotalActionItems: function getTotalActionItems() {
                                return 0;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                /** Other variants of TopAppBar foundation overrides this method */ MDCTopAppBarBaseFoundation.prototype.handleTargetScroll = function() {}; // tslint:disable-line:no-empty
                /** Other variants of TopAppBar foundation overrides this method */ MDCTopAppBarBaseFoundation.prototype.handleWindowResize = function() {}; // tslint:disable-line:no-empty
                MDCTopAppBarBaseFoundation.prototype.handleNavigationClick = function() {
                    this.adapter.notifyNavigationIconClicked();
                };
                return MDCTopAppBarBaseFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTopAppBarBaseFoundation = MDCTopAppBarBaseFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTopAppBarBaseFoundation;
        /***/ },
        /***/ "./packages/mdc-top-app-bar/short/foundation.ts": /*!******************************************************!*\
  !*** ./packages/mdc-top-app-bar/short/foundation.ts ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCShortTopAppBarFoundation = void 0;
            var constants_1 = __webpack_require__(/*! ../constants */ "./packages/mdc-top-app-bar/constants.ts");
            var foundation_1 = __webpack_require__(/*! ../foundation */ "./packages/mdc-top-app-bar/foundation.ts");
            var MDCShortTopAppBarFoundation = /** @class */ function(_super) {
                __extends(MDCShortTopAppBarFoundation, _super);
                /* istanbul ignore next: optional argument is not a branch statement */ function MDCShortTopAppBarFoundation(adapter) {
                    var _this = _super.call(this, adapter) || this;
                    _this.isCollapsed_ = false;
                    _this.isAlwaysCollapsed_ = false;
                    return _this;
                }
                Object.defineProperty(MDCShortTopAppBarFoundation.prototype, "isCollapsed", {
                    // Public visibility for backward compatibility.
                    get: function get() {
                        return this.isCollapsed_;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCShortTopAppBarFoundation.prototype.init = function() {
                    _super.prototype.init.call(this);
                    if (this.adapter.getTotalActionItems() > 0) this.adapter.addClass(constants_1.cssClasses.SHORT_HAS_ACTION_ITEM_CLASS);
                    // If initialized with SHORT_COLLAPSED_CLASS, the bar should always be collapsed
                    this.setAlwaysCollapsed(this.adapter.hasClass(constants_1.cssClasses.SHORT_COLLAPSED_CLASS));
                };
                /**
     * Set if the short top app bar should always be collapsed.
     *
     * @param value When `true`, bar will always be collapsed. When `false`, bar may collapse or expand based on scroll.
     */ MDCShortTopAppBarFoundation.prototype.setAlwaysCollapsed = function(value) {
                    this.isAlwaysCollapsed_ = !!value;
                    if (this.isAlwaysCollapsed_) this.collapse_();
                    else // let maybeCollapseBar_ determine if the bar should be collapsed
                    this.maybeCollapseBar_();
                };
                MDCShortTopAppBarFoundation.prototype.getAlwaysCollapsed = function() {
                    return this.isAlwaysCollapsed_;
                };
                /**
     * Scroll handler for applying/removing the collapsed modifier class on the short top app bar.
     * @override
     */ MDCShortTopAppBarFoundation.prototype.handleTargetScroll = function() {
                    this.maybeCollapseBar_();
                };
                MDCShortTopAppBarFoundation.prototype.maybeCollapseBar_ = function() {
                    if (this.isAlwaysCollapsed_) return;
                    var currentScroll = this.adapter.getViewportScrollY();
                    if (currentScroll <= 0) {
                        if (this.isCollapsed_) this.uncollapse_();
                    } else if (!this.isCollapsed_) this.collapse_();
                };
                MDCShortTopAppBarFoundation.prototype.uncollapse_ = function() {
                    this.adapter.removeClass(constants_1.cssClasses.SHORT_COLLAPSED_CLASS);
                    this.isCollapsed_ = false;
                };
                MDCShortTopAppBarFoundation.prototype.collapse_ = function() {
                    this.adapter.addClass(constants_1.cssClasses.SHORT_COLLAPSED_CLASS);
                    this.isCollapsed_ = true;
                };
                return MDCShortTopAppBarFoundation;
            }(foundation_1.MDCTopAppBarBaseFoundation);
            exports.MDCShortTopAppBarFoundation = MDCShortTopAppBarFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCShortTopAppBarFoundation;
        /***/ },
        /***/ "./packages/mdc-top-app-bar/standard/foundation.ts": /*!*********************************************************!*\
  !*** ./packages/mdc-top-app-bar/standard/foundation.ts ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTopAppBarFoundation = void 0;
            var constants_1 = __webpack_require__(/*! ../constants */ "./packages/mdc-top-app-bar/constants.ts");
            var foundation_1 = __webpack_require__(/*! ../foundation */ "./packages/mdc-top-app-bar/foundation.ts");
            var INITIAL_VALUE = 0;
            var MDCTopAppBarFoundation = /** @class */ function(_super) {
                __extends(MDCTopAppBarFoundation, _super);
                /* istanbul ignore next: optional argument is not a branch statement */ function MDCTopAppBarFoundation(adapter) {
                    var _this = _super.call(this, adapter) || this;
                    /**
         * Indicates if the top app bar was docked in the previous scroll handler iteration.
         */ _this.wasDocked_ = true;
                    /**
         * Indicates if the top app bar is docked in the fully shown position.
         */ _this.isDockedShowing_ = true;
                    /**
         * Variable for current scroll position of the top app bar
         */ _this.currentAppBarOffsetTop_ = 0;
                    /**
         * Used to prevent the top app bar from being scrolled out of view during resize events
         */ _this.isCurrentlyBeingResized_ = false;
                    /**
         * The timeout that's used to throttle the resize events
         */ _this.resizeThrottleId_ = INITIAL_VALUE;
                    /**
         * The timeout that's used to debounce toggling the isCurrentlyBeingResized_ variable after a resize
         */ _this.resizeDebounceId_ = INITIAL_VALUE;
                    _this.lastScrollPosition_ = _this.adapter.getViewportScrollY();
                    _this.topAppBarHeight_ = _this.adapter.getTopAppBarHeight();
                    return _this;
                }
                MDCTopAppBarFoundation.prototype.destroy = function() {
                    _super.prototype.destroy.call(this);
                    this.adapter.setStyle("top", "");
                };
                /**
     * Scroll handler for the default scroll behavior of the top app bar.
     * @override
     */ MDCTopAppBarFoundation.prototype.handleTargetScroll = function() {
                    var currentScrollPosition = Math.max(this.adapter.getViewportScrollY(), 0);
                    var diff = currentScrollPosition - this.lastScrollPosition_;
                    this.lastScrollPosition_ = currentScrollPosition;
                    // If the window is being resized the lastScrollPosition_ needs to be updated but the
                    // current scroll of the top app bar should stay in the same position.
                    if (!this.isCurrentlyBeingResized_) {
                        this.currentAppBarOffsetTop_ -= diff;
                        if (this.currentAppBarOffsetTop_ > 0) this.currentAppBarOffsetTop_ = 0;
                        else if (Math.abs(this.currentAppBarOffsetTop_) > this.topAppBarHeight_) this.currentAppBarOffsetTop_ = -this.topAppBarHeight_;
                        this.moveTopAppBar_();
                    }
                };
                /**
     * Top app bar resize handler that throttle/debounce functions that execute updates.
     * @override
     */ MDCTopAppBarFoundation.prototype.handleWindowResize = function() {
                    var _this = this;
                    // Throttle resize events 10 p/s
                    if (!this.resizeThrottleId_) this.resizeThrottleId_ = setTimeout(function() {
                        _this.resizeThrottleId_ = INITIAL_VALUE;
                        _this.throttledResizeHandler_();
                    }, constants_1.numbers.DEBOUNCE_THROTTLE_RESIZE_TIME_MS);
                    this.isCurrentlyBeingResized_ = true;
                    if (this.resizeDebounceId_) clearTimeout(this.resizeDebounceId_);
                    this.resizeDebounceId_ = setTimeout(function() {
                        _this.handleTargetScroll();
                        _this.isCurrentlyBeingResized_ = false;
                        _this.resizeDebounceId_ = INITIAL_VALUE;
                    }, constants_1.numbers.DEBOUNCE_THROTTLE_RESIZE_TIME_MS);
                };
                /**
     * Function to determine if the DOM needs to update.
     */ MDCTopAppBarFoundation.prototype.checkForUpdate_ = function() {
                    var offscreenBoundaryTop = -this.topAppBarHeight_;
                    var hasAnyPixelsOffscreen = this.currentAppBarOffsetTop_ < 0;
                    var hasAnyPixelsOnscreen = this.currentAppBarOffsetTop_ > offscreenBoundaryTop;
                    var partiallyShowing = hasAnyPixelsOffscreen && hasAnyPixelsOnscreen;
                    // If it's partially showing, it can't be docked.
                    if (partiallyShowing) this.wasDocked_ = false;
                    else {
                        // Not previously docked and not partially showing, it's now docked.
                        if (!this.wasDocked_) {
                            this.wasDocked_ = true;
                            return true;
                        } else if (this.isDockedShowing_ !== hasAnyPixelsOnscreen) {
                            this.isDockedShowing_ = hasAnyPixelsOnscreen;
                            return true;
                        }
                    }
                    return partiallyShowing;
                };
                /**
     * Function to move the top app bar if needed.
     */ MDCTopAppBarFoundation.prototype.moveTopAppBar_ = function() {
                    if (this.checkForUpdate_()) {
                        // Once the top app bar is fully hidden we use the max potential top app bar height as our offset
                        // so the top app bar doesn't show if the window resizes and the new height > the old height.
                        var offset = this.currentAppBarOffsetTop_;
                        if (Math.abs(offset) >= this.topAppBarHeight_) offset = -constants_1.numbers.MAX_TOP_APP_BAR_HEIGHT;
                        this.adapter.setStyle("top", offset + "px");
                    }
                };
                /**
     * Throttled function that updates the top app bar scrolled values if the
     * top app bar height changes.
     */ MDCTopAppBarFoundation.prototype.throttledResizeHandler_ = function() {
                    var currentHeight = this.adapter.getTopAppBarHeight();
                    if (this.topAppBarHeight_ !== currentHeight) {
                        this.wasDocked_ = false;
                        // Since the top app bar has a different height depending on the screen width, this
                        // will ensure that the top app bar remains in the correct location if
                        // completely hidden and a resize makes the top app bar a different height.
                        this.currentAppBarOffsetTop_ -= this.topAppBarHeight_ - currentHeight;
                        this.topAppBarHeight_ = currentHeight;
                    }
                    this.handleTargetScroll();
                };
                return MDCTopAppBarFoundation;
            }(foundation_1.MDCTopAppBarBaseFoundation);
            exports.MDCTopAppBarFoundation = MDCTopAppBarFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTopAppBarFoundation;
        /***/ },
        /***/ "./packages/mdc-utils/className.js": /*!*****************************************!*\
  !*** ./packages/mdc-utils/className.js ***!
  \*****************************************/ /*! exports provided: installClassNameChangeHook, uninstallClassNameChangeHook */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installClassNameChangeHook", function() {
                return installClassNameChangeHook;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uninstallClassNameChangeHook", function() {
                return uninstallClassNameChangeHook;
            });
            function _toConsumableArray(arr) {
                if (Array.isArray(arr)) {
                    for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                    return arr2;
                } else return Array.from(arr);
            }
            /* Material Components frequently enhance their DOM elements with additional
 * class names that depend on component state (ie. has focus) rather than
 * configuration state (ie. text field value).
 *
 * Since the component state is unknown to Elm, we cannot control those class
 * names in Elm. On the other hand, Elm does controls some class names (ie.
 * mdc-text-field).
 *
 * This means that currently, Elm's virtual dom library assumes sole control
 * over class names, since it sets a DOM node's `className` property. Thus, if
 * a Elm-controlled class name changes, it might delete additional uncontrolled
 * class names.
 *
 * We work around this issue by patching a DOM node's `className` property in
 * the following way:
 * (1) We may assume that Elm only ever touches `className`
 * (2) We may assume that Material Components only ever touch `classList`
 *
 * Thus, whenever a write to `className` happens, we record the list of classes
 * that Elm has control over (classes that have been added via `className`).
 * Then we identify classes removed via `className`, and we only allow removal
 * of classes that Elm has control over. Classes added via the `classList`
 * property cannot be removed via the `className` property.
 *
 * We will not require this fix anymore once Elm's virtual dom implementation
 * uses `classList.add`, `classList.remove` to manage class names.
 *
 * In addition to this, there are some class names that Elm should assume
 * control over for the first frame, but may not remove them in subsequent
 * frames. Those class names are class names that fall into the component
 * state, but may have to be set by Elm in the first frame to prevent a flash
 * of unstyled content (FOUC).
 *
 * The logic for those is implemented similarly, with the exception that the
 * classNames have to be listed in the node's property `foucClassNames`.
 */ function setClassName(className) {
                var css = className.split(" ").filter(function(cs) {
                    return cs !== "";
                });
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;
                try {
                    for(var _iterator = css[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var cs = _step.value;
                        this.classList.add(cs);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                    } finally{
                        if (_didIteratorError) throw _iteratorError;
                    }
                }
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = this.className_[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var _cs = _step2.value;
                        if (!!this.foucClassNames && this.foucClassNames.includes(_cs)) return;
                        if (!css.includes(_cs)) this.classList.remove(_cs);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                    } finally{
                        if (_didIteratorError2) throw _iteratorError2;
                    }
                }
                this.className_ = css;
            }
            function getClassName() {
                return "" + this.classList;
            }
            function installClassNameChangeHook() {
                Object.defineProperty(this, "className", {
                    get: getClassName.bind(this),
                    set: setClassName.bind(this),
                    configurable: true
                });
                this.className_ = [].concat(_toConsumableArray(this.classList));
            }
            function uninstallClassNameChangeHook() {
                var object = Object.getPrototypeOf(this);
                var descriptor = void 0;
                while(!(descriptor = Object.getOwnPropertyDescriptor(object, "className")))object = Object.getPrototypeOf(object);
                Object.defineProperty(this, "className", descriptor);
                delete this.className_;
                this.className = getClassName.call(this);
            }
        /***/ }
    });
});


customElements.define("x-checkout", class Checkout extends HTMLElement {
    get locale() {
        return this._locale;
    }
    set locale(newLocale) {
        if (this._locale !== null) console.warn("property `locale' can only be set initially, ignoring");
        this._locale = newLocale;
    }
    get endpoint() {
        return this._endpoint;
    }
    set endpoint(newEndpoint) {
        if (this._endpoint !== null) console.warn("property `endpoint' can only be set initially, ignoring");
        this._endpoint = newEndpoint;
    }
    get checkoutId() {
        return this._checkoutId;
    }
    set checkoutId(newCheckoutId) {
        if (this._checkoutId !== null) console.warn("property `checkoutId' can only be set initially, ignoring");
        this._checkoutId = newCheckoutId;
    }
    get brands() {
        return this._brands;
    }
    set brands(newBrands) {
        if (this._brands !== null) console.warn("property `brands' can only be set initially, ignoring");
        this._brands = newBrands;
    }
    get shopperResultUrl() {
        return this._shopperResultUrl;
    }
    set shopperResultUrl(newShopperResultUrl) {
        if (this._shopperResultUrl !== null) console.warn("property `shopperResultUrl' can only be set initially, ignoring");
        this._shopperResultUrl = newShopperResultUrl;
    }
    constructor(){
        super();
        this._brands = null;
        this._checkoutId = null;
        this._endpoint = null;
        this._shopperResultUrl = null;
        this._locale = null;
    }
    connectedCallback() {
        this._shadowRoot = this.attachShadow({
            mode: "closed"
        });
        const slot = document.createElement("slot");
        slot.setAttribute("name", "form");
        this._shadowRoot.appendChild(slot);
        const form = document.createElement("form");
        form.action = this._shopperResultUrl;
        form.classList.add("paymentWidgets");
        form.dataset.brands = this._brands;
        const formWrapper = document.createElement("div");
        formWrapper.setAttribute("slot", "form");
        formWrapper.appendChild(form);
        this.appendChild(formWrapper);
        const script = document.createElement("script");
        script.textContent = `
      var wpwlOptions = {
          locale: "${this.locale}",
      }
    `;
        document.head.appendChild(script);
        const paymentWidgets = document.createElement("script");
        paymentWidgets.src = `${this._endpoint}v1/paymentWidgets.js?checkoutId=${this._checkoutId}`;
        document.head.appendChild(paymentWidgets);
    }
    disconnectedCallback() {}
});


customElements.define("x-user-upload", class FileUpload extends HTMLElement {
    constructor(){
        super();
        this._accept = null;
    }
    get accept() {
        return this._accept;
    }
    set accept(accept) {
        this._accept = accept;
        if (!this._input) return;
        if (accept) this._input.setAttribute("accept", accept);
        else this._input.removeAttribute("accept");
    }
    connectedCallback() {
        this._shadowRoot = this.attachShadow({
            mode: "closed"
        });
        this._div = document.createElement("div");
        this._div.style.position = "relative";
        this._input = document.createElement("input");
        this._input.setAttribute("type", "file");
        if (this._accept) this._input.setAttribute("accept", this._accept);
        this._input.addEventListener("change", this.handleChange.bind(this));
        this._input.style.position = "absolute";
        this._input.style.inset = "0 0 0 0";
        this._input.style.display = "none";
        this._slot = document.createElement("slot");
        this._slot.name = "root";
        this._slot.style.display = "block";
        this._slot.addEventListener("click", this.handleClick.bind(this));
        this._slot.addEventListener("keypress", this.handleKeypress.bind(this));
        this._div.appendChild(this._input);
        this._div.appendChild(this._slot);
        this._shadowRoot.appendChild(this._div);
    }
    async handleChange(event) {
        const file = this._input.files[0];
        const reader = new FileReader();
        const dataURL = await new Promise((resolve, reject)=>{
            reader.addEventListener("load", ()=>resolve(reader.result), false);
            reader.readAsDataURL(file);
        });
        const detail = {
            lastModified: file.lastModified,
            name: file.name,
            size: file.size,
            type: file.type,
            dataURL: dataURL
        };
        this.dispatchEvent(new CustomEvent("filereplaced", {
            detail: detail,
            bubbles: true,
            composed: true
        }));
    }
    async handleFocus(event) {
        this._input.click();
    }
    async handleClick(event) {
        this._input.click();
    }
    async handleKeypress(event) {
        if (event.key !== "Enter" && event.key !== " ") {
            event.stopPropagation();
            event.preventDefault();
            return false;
        }
        await this._input.click();
        event.preventDefault();
    }
});


//import debugValues from "../../backend/data/ADDITC/values.json";
const $207b5609c0277175$var$trace = (x)=>console.trace(x) || x;
customElements.define("x-ticketshop", class Ticketshop extends HTMLElement {
    config(key, dflt = null) {
        if (this.hasAttribute(key)) return this.getAttribute(key);
        return new URL(document.location).searchParams.get(key) || dflt;
    }
    static get observedAttributes() {
        return [
            "data-locale",
            "data-code"
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        this[name.slice("data-".length)] = newValue;
    }
    get id() {
        return this._id;
    }
    set id(newId) {
        if (this._id !== null) console.warn("property `id' can only be set initially, ignoring");
        this._id = newId;
    }
    get checkout() {
        return this._checkout;
    }
    set checkout(newCheckout) {
        if (this._checkout !== null) console.warn("property `checkout' can only be set initially, ignoring");
        this._checkout = newCheckout;
    }
    get crashed() {
        return this._crashed;
    }
    set crashed(newCrashed) {
        if (this._crashed !== null) console.warn("property `crashed' can only be set initially, ignoring");
        this._crashed = newCrashed;
    }
    get loading() {
        return this._loading;
    }
    set loading(newLoading) {
        if (this._loading !== null) console.warn("property `loading' can only be set initially, ignoring");
        this._loading = newLoading;
    }
    get code() {
        return this._code;
    }
    set code(newCode) {
        if (this._code !== null) console.warn("property `code' can only be set initially, ignoring");
        this._code = newCode;
    }
    get exhibitor() {
        return this._exhibitor;
    }
    set exhibitor(newExhibitor) {
        if (this._exhibitor !== null) console.warn("property `exhibitor' can only be set initially, ignoring");
        this._exhibitor = newExhibitor;
    }
    get api() {
        return this._api;
    }
    set api(newApi) {
        if (this._api !== null) console.warn("property `api' can only be set initially, ignoring");
        this._api = newApi;
    }
    get values() {
        return this._values;
    }
    set values(newValues) {
        if (this._values !== null) console.warn("property `values' can only be set initially, ignoring");
        this._values = newValues;
    }
    get pages() {
        return this._pages;
    }
    set pages(newPages) {
        this._pages = newPages;
        if (this.app) this.app.ports.setPages.send(newPages);
    }
    get locale() {
        return this._locale;
    }
    set locale(newLocale) {
        this._locale = newLocale;
        if (this.app) this.app.ports.setLocale.send(this._locale);
    }
    get tickets() {
        return this._tickets;
    }
    set tickets(newTickets) {
        this._tickets = newTickets;
        if (this.app) this.app.ports.setTickets.send(this._tickets);
    }
    get discounts() {
        return this._discounts;
    }
    set discounts(newTickets) {
        this._discounts = newTickets;
        if (this.app) this.app.ports.setDiscounts.send(this._discounts);
    }
    constructor(){
        super();
        this.app = null;
        this._id = new URL(document.location).searchParams.get("order-id");
        this._pages = null;
        this._tickets = null;
        this._discounts = null;
        this._values = null // trace(debugValues);
        ;
        this._locale = this.config("locale");
        this._code = this.config("code");
        this._exhibitor = this.config("exhibitor");
        this._loginCode = this.config("loginCode");
        this._auth = null;
        this._checkout = null;
        this._crashed = new URL(document.location).searchParams.get("crashed");
        this._loading = null;
    }
    async connectedCallback() {
        this._shadowRoot = this.attachShadow({
            mode: "closed"
        });
        const style = document.createElement("style");
        style.setAttribute("type", "text/css");
        style.textContent = (0, (/*@__PURE__*/$parcel$interopDefault($4a3647cc29c100ad$exports)));
        this._shadowRoot.appendChild(style);
        const link = document.createElement("link");
        link.setAttribute("href", "https://fonts.googleapis.com/icon?family=Material+Icons");
        link.setAttribute("rel", "stylesheet");
        this._shadowRoot.appendChild(link);
        const node = document.createElement("div");
        this._shadowRoot.appendChild(node);
        const slot = document.createElement("slot");
        slot.setAttribute("name", "checkout");
        this._shadowRoot.appendChild(slot);
        if (this._loginCode) {
            try {
                const auth = await (await fetch(`http://localhost:8080/public/user-account/login/callback?i=${this._loginCode}`, {
                    credentials: "include"
                })).json();
                const whoami = await fetch(`http://localhost:8080/public/user-account/whoami`, {
                    credentials: "include"
                });
                if (!whoami.ok) this._auth = auth;
            } catch (e) {
                console.info(`loginCode: ${e}`);
            }
            const url = new URL(window.location.href);
            url.search = url.search.replace(/[?&]loginCode=[^&]*/, "").replace(/^&/, "?");
            history.replaceState(null, "", `${url}`);
        }
        (()=>{
            const link = document.createElement("link");
            link.setAttribute("href", "https://fonts.googleapis.com/icon?family=Material+Icons");
            link.setAttribute("rel", "stylesheet");
            document.head.append(link);
        })();
        console.log("flags", {
            values: this._values,
            pages: this._pages,
            idempotencyToken: crypto.randomUUID(),
            locale: this._locale,
            tickets: this._tickets,
            discounts: this._discounts,
            api: this._api,
            code: this._code,
            exhibitor: this._exhibitor,
            id: this._id,
            checkout: this._checkout,
            crashed: this._crashed,
            loading: this._loading,
            origin: window.location.href,
            width: this.parentElement.clientWidth,
            auth: this._auth
        });
        this.app = (0, $ca3222cb63d04ad8$exports.Elm).Frontend.init({
            flags: {
                values: this._values,
                pages: this._pages,
                idempotencyToken: crypto.randomUUID(),
                locale: this._locale,
                tickets: this._tickets,
                discounts: this._discounts,
                api: this._api,
                code: this._code,
                exhibitor: this._exhibitor,
                id: this._id,
                checkout: this._checkout,
                crashed: this._crashed,
                loading: this._loading,
                origin: window.location.href,
                width: this.parentElement.clientWidth,
                auth: this._auth
            },
            node: node
        });
        this.app.ports.inspect.subscribe((detail)=>this.dispatchEvent(new CustomEvent("inspect", {
                detail: detail
            })));
        this.app.ports.submit.subscribe((detail)=>this.dispatchEvent(new CustomEvent("submit", {
                detail: detail
            })));
        this.app.ports.navigated.subscribe(()=>window.requestAnimationFrame(()=>this.scrollIntoView()));
        this.app.ports.mountCheckout.subscribe((checkout)=>{
            const node = document.createElement("x-checkout");
            node.setAttribute("slot", "checkout");
            node.brands = checkout.brands.join(" ");
            node.checkoutId = checkout.checkoutId;
            node.endpoint = checkout.endpoint;
            node.shopperResultUrl = checkout.shopperResultUrl;
            node.locale = checkout.locale;
            this.appendChild(node);
        });
        window.addEventListener("resize", ()=>this.app.ports.setWidth.send(this.parentElement.clientWidth));
    /*} catch(e) {
    console.info(e);
    throw e;
  }*/ }
});

})();
//# sourceMappingURL=frontend.js.map
